// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const fi = {
    login: {
        title: '[[TOK_0]] ComplianceOne',
        subtitle: 'Kirjaudu tilillesi',
        email: 'Sähköposti',
        password: 'Salasana',
        sign_in: 'Kirjaudu sisään',
        signing_in: 'Kirjaudutaan...',
        mfa_code: 'MFA-koodi',
        mfa_placeholder: 'Syötä 6-numeroinen koodi',
        mfa_instruction: 'Syötä 6-numeroinen koodi todennussovelluksestasi.',
        verify: 'Vahvista',
        verifying: 'Vahvistetaan...',
        forgot_password: 'Unohditko salasanan?',
        account_locked: 'Tili on lukittu. Yritä myöhemmin uudelleen.',
        account_deactivated: 'Tili on poistettu käytöstä. Ota yhteyttä järjestelmänvalvojaan.',
        invalid_mfa: 'Virheellinen MFA-koodi. Yritä uudelleen.',
        invalid_credentials: 'Virheellinen sähköposti tai salasana.',
        login_failed: 'Kirjautuminen epäonnistui',
        session_expired: 'Istuntosi on vanhentunut. Lataa sivu uudelleen ja yritä uudelleen.',
    },
    auth: {
        forgot_password: {
            title: 'Unohtunut salasana',
            subtitle: 'Syötä sähköpostiosoitteesi, niin lähetämme sinulle linkin salasanan nollaamiseksi.',
            send: 'Lähetä nollauslinkki',
            sending: 'Lähetetään...',
            success: 'Jos kyseinen sähköpostiosoite on olemassa, salasanan nollauslinkki on lähetetty.',
            back_to_login: 'Takaisin kirjautumiseen',
        },
        reset_password: {
            title: 'Nollaa salasana',
            subtitle: 'Syötä uusi salasanasi alle.',
            new_password: 'Uusi salasana',
            confirm_password: 'Vahvista salasana',
            reset: 'Nollaa salasana',
            resetting: 'Nollataan...',
            success: 'Salasanasi on nollattu onnistuneesti.',
            go_to_login: 'Siirry kirjautumiseen',
            password_mismatch: 'Salasanat eivät täsmää.',
            invalid_token: 'Virheellinen tai puuttuva nollausavain. Pyydä uusi salasanan nollauslinkki.',
            requirements_title: 'Salasanavaatimukset:',
            password_requirements: 'Salasanan on täytettävä seuraavat vaatimukset:',
            rules: {
                min_length: 'Vähintään 12 merkkiä',
                uppercase: 'Vähintään yksi iso kirjain',
                lowercase: 'Vähintään yksi pieni kirjain',
                digit: 'Vähintään yksi numero',
                special: 'Vähintään yksi erikoismerkki',
            },
        },
        verify_email: {
            title: 'Sähköpostin vahvistus',
            verifying: 'Vahvistetaan sähköpostiosoitettasi...',
            success: 'Sähköpostiosoitteesi on vahvistettu onnistuneesti.',
            invalid_token: 'Virheellinen tai puuttuva vahvistusavain.',
            failed: 'Sähköpostin vahvistus epäonnistui. Avain voi olla virheellinen tai vanhentunut.',
            go_to_login: 'Siirry kirjautumiseen',
        },
        offline: {
            title: 'Olet offline-tilassa',
            message: 'Näyttää siltä, että internetyhteytesi on katkennut. Tarkista verkkoyhteytesi ja yritä uudelleen.',
        },
    },
    intake: {
        title: 'Tietopyyntö',
        subtitle: 'Lähetä tietopyyntö organisaatiollemme',
        fields: {
            full_name: 'Koko nimi',
            email: 'Sähköpostiosoite',
            phone: 'Puhelinnumero (valinnainen)',
            request_type: 'Pyynnön tyyppi',
            description: 'Kuvaile pyyntöäsi',
            preferred_language: 'Ensisijainen kieli',
            consent: 'Suostun tämän pyynnön käsittelyyn',
        },
        submit: 'Lähetä pyyntö',
        validation: {
            name_required: 'Koko nimi on pakollinen',
            email_required: 'Kelvollinen sähköpostiosoite on pakollinen',
            type_required: 'Valitse pyynnön tyyppi',
            description_required: 'Kuvaile pyyntöäsi',
            consent_required: 'Sinun on suostuttava käsittelyyn jatkaaksesi',
        },
        error_title: 'Virhe',
        config_load_error: 'Konfiguraation lataaminen epäonnistui. Tarkista URL-osoite.',
        organization_label: 'Organisaatio',
        customer_reference: 'Asiakasviitenumero',
        country: 'Maa / Lainkäyttöalue',
        preferred_channel: 'Ensisijainen vastauskanava',
        channels: {
            email: 'Sähköposti',
            postal: 'Posti',
            phone: 'Puhelin',
            portal: 'Portaali',
        },
        confirmation: {
            title: 'Pyyntö vastaanotettu',
            message: 'Pyyntösi on tallennettu onnistuneesti. Viitenumerosi on:',
            next_steps: 'Käsittelemme pyyntösi mahdollisimman pian sovellettavan lainsäädännön mukaisesti. Arvioitu käsittelyaika on 30 työpäivää.',
        },
    },
    request_types: {
        access: 'Pääsy (DSAR)',
        deletion: 'Poistaminen',
        correction: 'Oikaisu / päivitys',
        objection: 'Vastustaminen',
        portability: 'Tietojen siirrettävyys',
        restriction: 'Käsittelyn rajoittaminen',
        consent_withdrawal: 'Suostumuksen peruuttaminen',
    },
    statuses: {
        new: 'Uusi',
        in_review: 'Arvioitavana',
        waiting_on_requester: 'Odotetaan pyytäjää',
        waiting_on_internal_data: 'Odotetaan sisäistä tietoa',
        approved: 'Hyväksytty',
        closed: 'Suljettu',
        rejected: 'Hylätty',
    },
    admin: {
        nav: {
            rights_requests: 'Tietopyynnöt',
            templates: 'Mallipohjat',
            response_templates: 'Vastausmallit',
            data_mapping: 'Tietokartoitus',
            governance: 'Hallinto',
            consent: 'Suostumus',
            assessments: 'Arvioinnit',
            classification: 'Luokitus',
            monitoring: 'Valvonta',
            incidents: 'Tapaukset',
            onboarding: 'Käyttöönotto',
            connectors: 'Liittimet',
            vendor_risk: 'Toimittajariski',
            deletion_orchestration: 'Poiston orkestrointi',
            discovery: 'Tietojen löytäminen',
            incident_ops: 'Tapausten hallinta',
            program_governance: 'Ohjelmahallinto',
            access_accountability: 'Pääsyn vastuullisuus',
            consent_properties: 'Suostumuksen ominaisuudet',
            localization: 'Lokalisointi',
            partner_workspace: 'Kumppanityötila',
            audit_trail: 'Tarkastuspolku',
            forseti: 'Forseti',
            settings: 'Asetukset',
            help_center: 'Ohjekeskus',
            dashboard: 'Yhteenveto',
            platform: 'Alusta',
            integrations: 'Integraatiot',
            cmp_dsar_sync: 'CMP-DSAR-synkronointi',
            cmp_integration: 'CMP-integraatio',
            purpose_mapping: 'Tarkoitusten kytkentä',
            webhook_config: 'Webhook-asetukset',
            bulk_sync: 'Joukkosynkronointi',
            privacy_scanner: 'Tietosuojaskanneri',
            privacy_monitoring: 'Tietosuojavalvonta',
            real_time_scanner: 'Reaaliaikaskanneri',
            compliance_forms: 'Vaatimustenmukaisuuslomakkeet',
            forms_dashboard: 'Lomakkeiden yhteenveto',
            form_templates: 'Mallipohjat',
            form_catalog: 'Lomakekatalogi',
            pack_catalog: 'Pakettikatalogi',
            org_groups: 'Organisaatioryhmät',
            consolidation: 'Konsolidointi',
            organizations: 'Organisaatiot',
            org_list: 'Kaikki organisaatiot',
            intake_configs: 'Vastaanottomääritykset',
            task_management: 'Tehtävähallinta',
            unified_audit: 'Yhdistetty Tarkastus',
            evidence_packs: 'Todistuspaketit',
            audit_periods: 'Tarkastusjaksot',
            regulatory_updates: 'Sääntelypäivitykset',
            departments: 'Osastot',
        },
        sidebar_category_data_privacy_rights: 'Tietosuoja & Oikeudet',
        sidebar_category_vendor_third_party: 'Toimittaja & Kolmannen Osapuolen Hallinta',
        sidebar_category_risk_assessment: 'Riski & Arviointi',
        sidebar_category_operations_automation: 'Toiminnot & Automaatio',
        sidebar_category_task_workflow: 'Tehtävä & Työnkulku',
        sidebar_groups: {
            consent_cmp_webhooks: '[[TOK_0]] ja Webhooks',
            data_mapping_ropa: 'RoPA-rekisteröinti',
            data_mapping_classification: 'Luokittelu',
            data_mapping_governance: 'Hallinto',
            access_live_monitoring: 'Live-seuranta',
            access_reviews_investigations: 'Arvostelut ja tutkimukset',
            access_evidence_policies: 'Todisteet ja käytännöt',
            classification_taxonomies: 'Taksonomiat ja etiketit',
            classification_workflow: 'Työnkulku',
            classification_insights: 'Näkemyksiä',
            connectors_runtime: 'Suoritusaika',
            connectors_due_diligence: 'Due Diligence',
            connectors_coverage: 'Kattavuus',
            cp_definitions: 'Määritelmät',
            cp_lifecycle: 'Elinkaari',
            cp_quality: 'Laatu ja todisteet',
            deletion_execution: 'Toteutus',
            deletion_vendors: 'Myyjät',
            deletion_evidence: 'Todisteet ja integraatio',
            discovery_rules: 'Säännöt ja mallit',
            discovery_scanning: 'Skannaus',
            discovery_review: 'Tarkista työnkulku',
            discovery_insights: 'Näkemyksiä',
            governance_oversight: 'Valvonta',
            governance_reporting: 'Raportointi',
            governance_vendors: 'Myyjät ja rajat ylittävät',
            governance_lifecycle: 'Elinkaari',
            incident_ops_dashboards: 'Kojelaudat',
            incident_ops_sla: '[[TOK_0]] Konfig',
            incident_ops_playbooks: 'Toimintakirjat',
            incident_ops_vendor_regulator: 'Myyjä ja sääntelijä',
            incident_ops_evidence: 'Todisteet ja arvostelu',
            incidents_workload: 'Työmäärä',
            incidents_regulatory: 'Sääntely',
            incidents_reporting: 'Raportointi',
            localization_content: 'Sisältö',
            localization_regulatory: 'Sääntely',
            localization_observability: 'Havaittavuus',
            monitoring_metrics: 'Mittarit',
            monitoring_programs: 'Ohjelmat',
            monitoring_tasks: 'Tehtävät',
            monitoring_controls: 'Säätimet',
            org_entities: 'Entiteetit',
            org_config: 'Kokoonpano',
            org_frameworks: 'Viitekehykset ja koonti',
            partner_overview: 'Yleiskatsaus',
            partner_partners: 'Yhteistyökumppanit',
            partner_delivery: 'Toimitus',
            partner_support: 'Tuki',
            platform_identity: 'Identiteetti ja roolit',
            platform_access_control: 'Kulunvalvonta',
            platform_auth_session: 'Todennus ja istunto',
            platform_access_reviews: 'Pääsy arvosteluihin',
            platform_files: 'Tiedostot',
            platform_notifications: 'Ilmoitukset',
            platform_module_config: 'Moduulin kokoonpano',
            platform_ops: 'Ops & lokit',
            pg_health: 'Ohjelma Terveys',
            pg_maturity: 'Kypsyys',
            pg_audit: 'Tarkastus ja todisteet',
            pg_obligations: 'Velvollisuudet',
            pg_documents: 'Asiakirjat',
            vr_overview: 'Yleiskatsaus',
            vr_onboarding: 'Käyttöönotto',
            vr_assessment: 'Arviointi',
            vr_oversight: 'Valvonta',
        },
        tickets: {
            title: 'Tietopyynnöt',
            create: 'Luo pyyntö',
            filters: 'Suodattimet',
            search_placeholder: 'Hae pyynt?j?...',
            export_csv: 'Vie [[TOK_0]]',
            exporting: 'Viedään...',
            bulk_export_failed: 'Joukkovienti epäonnistui',
            bulk_export: {
                label: 'Vie',
                format: {
                    pdf: '[[TOK_0]] Yhteenveto',
                    zip: 'ZIP (tapauskohtaiset todisteet)',
                    csv: '[[TOK_0]]',
                },
                warning_over_50: 'Tämä luo noin [[TOK_1]] kotelopakettia - voi kestää useita minuutteja. Jatkaa?',
                blocked_over_500: 'Rajaa suodatin 500 tapaukseen tai vähemmän ennen ZIP-tiedoston vientiä (nykyinen: [[TOK_1]]).',
                success: 'Joukkovienti tallennettu tiedostoselaimeen ([[TOK_1]] tapausta)',
                failed: 'Joukkovienti epäonnistui',
                continue: 'Jatka',
                cancel: 'Peruuta',
            },
            no_results: 'Pyyntöjä ei löytynyt',
            ticket_id: 'Pyynnön tunnus',
            request_type: 'Pyynnön tyyppi',
            requester: 'Pyytäjä',
            source: 'lähde',
            all_sources: 'Kaikki lähteet',
            assigned_to: 'Vastuuhenkilö',
            created: 'Luotu',
            load_error: 'Tapausten lataaminen epäonnistui. Yritä uudelleen.',
            case_creation_failed: 'Tapauksen luonti epäonnistui',
            business_unit: 'Liiketoimintayksikkö',
            reference: 'Viite',
            sla: {
                title: 'SLA-tila',
                on_track: '{days} päivää jäljellä',
                approaching: 'Lähestyvä määräaika',
                overdue: '{days} päivää myöhässä',
                ack_overdue: '{hours}t kuittausmääräajan yli',
                ack_warning: 'Kuittaus pian erääntyvä',
                closed: 'Suljettu',
                completed_in: 'Valmistunut {days} päivässä',
            },
        },
        templates: {
            title: 'Vastausmallipohjat',
            new: 'Uusi mallipohja',
            edit: 'Muokkaa mallipohjaa',
            all_types: 'Kaikki tyypit',
            all_locales: 'Kaikki kielet',
            type_access: 'Pääsy/DSAR',
            type_deletion: 'Poistaminen',
            type_correction: 'Oikaisu',
            type_objection: 'Vastustaminen',
            type_portability: 'Siirrettävyys',
            type_other: 'Muu',
            type_restriction: 'Rajoitus',
            type_all: 'Kaikki',
            locale_en: 'Englanti',
            locale_vi: 'Vietnam',
            locale_all: 'Molemmat',
            name: 'Nimi',
            request_type: 'Pyynnön tyyppi',
            locale: 'Kieli',
            subject: 'Aihe',
            body: 'Sisältö',
            name_placeholder: 'Mallipohjan nimi...',
            subject_placeholder: 'Sähköpostin/kirjeen aihe...',
            body_placeholder: 'Mallipohjan sisältö. Käytä paikkamerkkeinä: {{requester_name}}, {{ticket_id}}, {{request_type}}, {{org_name}}, {{response_date}}.',
            available_placeholders: 'Käytettävissä olevat paikkamerkit:',
            create_template: 'Luo mallipohja',
            preview: 'Esikatselu',
            close_preview: 'Sulje esikatselu',
            default_badge: 'Oletus',
            no_templates: 'Mallipohjia ei löytynyt',
            confirm_delete: 'Poistetaanko tämä mallipohja?',
            load_error: 'Mallipohjien lataaminen epäonnistui. Yritä uudelleen.',
            create_error: 'Mallipohjan luominen epäonnistui',
            update_error: 'Mallipohjan päivittäminen epäonnistui',
            delete_error: 'Mallipohjan poistaminen epäonnistui',
            preview_error: 'Mallipohjan esikatselu epäonnistui',
            response_templates_badge: 'Vastausmallit',
            browse_form_templates: 'Selaa Vaatimustenmukaisuuslomakepohjia',
            templates_loaded: 'Mallit ladattu',
            sample_organization: 'Esimerkkiorganisaatio',
        },
        detail: {
            requester_info: 'Pyytäjän tiedot',
            status: 'Tila',
            assignment: 'Vastuutus',
            notes: 'Muistiinpanot',
            audit_trail: 'Tarkastuspolku',
            add_note: 'Lisää muistiinpano',
            case_not_found: 'Tapausta ei löytynyt',
            load_error: 'Tapauksen lataaminen epäonnistui. Yritä uudelleen.',
            note_error: 'Muistiinpanon lisääminen epäonnistui. Yritä uudelleen.',
            submitted_from: 'Lähetetty kohteesta',
            via_cmp: 'AesirX CMP:n kautta',
            cmp_ticket: 'CMP-lippu:',
            select_template: 'Valitse malli',
            direction_inbound: '[[TOK_0]] → GRC',
            direction_outbound: 'GRC → [[TOK_0]]',
            tabs: {
                details: 'Tiedot',
                evidence: 'Todistusaineisto',
                communications: 'Viestintä',
                escalations: 'Eskalaatiot',
                audit_trail: 'Tarkastuspolku',
                fulfillment: 'Täyttäminen',
                response: 'Vastaus',
                extension: 'Jatkoaika',
            },
            requester: {
                name: 'Nimi',
                email: 'Sähköposti',
                phone: 'Puhelin',
                language: 'Kieli',
                source: 'Lähde',
                customer_ref: 'Asiakasviite',
                country: 'Maa',
                preferred_channel: 'Ensisijainen kanava',
            },
            sla: {
                title: 'SLA',
                on_track: 'Aikataulussa',
                due_soon: 'Erääntyy pian',
                overdue: 'Myöhässä',
                days_remaining: 'pv jäljellä',
                due_date: 'Eräpäivä',
                breached: 'Ylitetty',
                paused: 'Keskeytetty',
                total_paused_days: 'Keskeytyspäivät yhteensä',
                days_elapsed: 'Kuluneita päiviä',
                progress: 'Edistyminen',
            },
            identity: {
                title: 'Henkilöllisyyden vahvistus',
                verified: 'Vahvistettu',
                not_verified: 'Ei vahvistettu',
                method: 'Menetelmä',
                notes: 'Muistiinpanot',
                verified_by: 'Vahvistaja',
                verified_at: 'Vahvistettu',
                warning: 'Henkilöllisyyttä ei ole vielä vahvistettu.',
                verify_button: 'Vahvista henkilöllisyys',
                select_method: '-- Valitse --',
                methods: {
                    email_confirmation: 'Sähköpostivahvistus',
                    id_document: 'Henkilöllisyystodistus',
                    phone_call: 'Puhelinsoitto',
                    in_person: 'Henkilökohtaisesti',
                    other: 'Muu',
                },
            },
            closure: {
                reason: 'Sulkemisen syy',
                summary: 'Sulkemisen yhteenveto',
                summary_placeholder: 'Yhteenveto pyynnön ratkaisusta...',
                reason_required: 'Sulkemisen yhteenveto ja syy ovat pakollisia',
                response_not_sent: 'Virallinen vastaus on lähetettävä rekisteröidylle ennen tapauksen sulkemista',
                reasons: {
                    fulfilled: 'Toteutettu',
                    partially_fulfilled: 'Osittain toteutettu',
                    unfounded: 'Perusteeton',
                    excessive: 'Kohtuuton',
                    withdrawn: 'Peruutettu',
                    duplicate: 'Kaksoiskappale',
                    identity_unverified: 'Henkilöllisyys vahvistamatta',
                },
            },
            export_title: 'Vie',
            export_pdf: 'Vie PDF',
            export_zip: 'Vie ZIP',
            case_file_pdf: 'Vie [[TOK_0]] (tapaustiedosto)',
            evidence_pack_zip: 'Vie ZIP (todistepaketti)',
            cross_border_warning: 'Rajat ylittävä siirto havaittu – rajat ylittävä asiakirja vaaditaan',
            breach: {
                flag_btn: 'Merkitse rikkomuksia aiheuttavaksi',
                modal: {
                    title: 'Merkitse kotelo rikkoutumisen aiheuttajana',
                    type_label: 'Rikkomuksen tyyppi',
                    type: {
                        misdirected_response: 'Väärin suunnattu vastaus',
                        unauthorised_disclosure: 'Luvaton paljastaminen',
                        identity_mismatch: 'Identiteetti ei täsmää',
                        other: 'muu',
                    },
                    description: 'Kuvaus (valinnainen)',
                    description_placeholder: 'Mitä tapahtui? (enintään 1000 merkkiä)',
                    confirm: 'Lippu ja käynnistä 72h arkistointikello',
                    cancel: 'Peruuta',
                    flagging: 'Merkitään...',
                },
                banner: {
                    title: 'Rikkomus ilmoitettu: [[TOK_1]]',
                    detected_at: 'Havaittu [[TOK_1]]',
                    filing_deadline: '72 tunnin [[TOK_2]] jättöpäivä: [[TOK_1]] tunnin kuluttua',
                    overdue: '72 tunnin [[TOK_0]] jättöpäivä: MÄÄRITYS',
                },
                toasts: {
                    flagged: 'Tapaus merkitty rikkomuksen aiheuttavaksi - 72 tunnin kello alkoi',
                    flag_failed: 'Tapauksen merkitseminen rikkomuksen aiheuttavaksi epäonnistui',
                },
            },
            export: {
                generating: 'Luodaan... odota',
                success: 'Vie tallennettu tiedostoselaimeen',
                failed: 'Vienti epäonnistui - tarkista tarkastusloki',
            },
            no_notes: 'Ei muistiinpanoja',
            assign_placeholder: 'Käyttäjätunnus vastuutettavaksi...',
            reassign: 'Vastuuta uudelleen',
            evidence: {
                checklist_title: 'Todistusaineiston tarkistuslista',
                complete_pct: '% valmis',
                no_checklist: 'Ei tarkistuslistan kohteita',
                attachments: 'Liitteet',
                upload_attachment: 'Lataa liite',
                upload_button: 'Lataa',
                uploading: 'Ladataan...',
                attachment_uploaded: 'Liite ladattu onnistuneesti',
                upload_error: 'Liitteen lataus epäonnistui',
                category: 'Kategoria',
                categories: {
                    identity_proof: 'Henkilöllisyystodistus',
                    correspondence: 'Kirjeenvaihto',
                    internal_data: 'Sisäiset tiedot',
                    legal: 'Oikeudellinen',
                    other: 'Muu',
                },
                no_attachments: 'Ei liitteitä',
                references_title: 'Todistusaineiston viitteet',
                no_references: 'Ei viitteitä',
                add_reference: 'Lisää viite',
                ref_type: 'Tyyppi',
                ref_value: 'Arvo',
                ref_desc: 'Kuvaus',
                ref_value_placeholder: 'URL, sähköposti-ID tai viite...',
                ref_desc_placeholder: 'Kuvaus...',
                ref_types: {
                    url: 'URL',
                    email_id: 'Sähköposti-ID',
                    crm_record: 'CRM-tietue',
                    ticket_ref: 'Tikettviite',
                    other: 'Muu',
                },
            },
            communications: {
                title: 'Viestintä',
                add: 'Lisää viesti',
                no_records: 'Ei tallennettuja viestejä',
                direction: 'Suunta',
                channel: 'Kanava',
                visibility: 'Näkyvyys',
                subject: 'Aihe',
                body: 'Sisältö',
                send: 'Lähetä',
                inbound: 'Saapuva',
                outbound: 'Lähtevä',
                internal: 'Sisäinen',
                external: 'Ulkoinen',
                tab_all: 'All',
                tab_internal: 'Sisäinen',
                tab_external: 'Ulkoinen',
                subject_placeholder: 'Aihe (valinnainen)',
                body_placeholder: 'Viestin sisältö...',
                channels: {
                    email: 'Sähköposti',
                    portal: 'Portaali',
                    phone: 'Puhelin',
                    postal: 'Posti',
                    in_person: 'Henkilökohtaisesti',
                },
                apply_template: 'Käytä Mallia',
                select_template: 'Valitse malli...',
                no_templates: 'Ei malleja saatavilla',
                template_applied: 'Malli sovellettu vastaukseen.',
                template_apply_error: 'Mallia ei voitu soveltaa.',
            },
            escalations: {
                title: 'Eskalaatiohistoria',
                no_events: 'Ei eskalaatiotapahtumia',
                tier: 'Taso',
                threshold: 'Kynnysarvo',
                action: 'Toiminto',
                target: 'Kohde',
                triggered_at: 'Lauennut',
            },
            cmp_sync: {
                title: 'AesirX CMP -synkronointi',
                sync_status: 'Synkronoinnin tila',
                last_synced: 'Viimeksi synkronoitu',
                not_synced: 'Ei synkronoitu',
                resync: 'Synkronoi uudelleen',
                syncing: 'Synkronoidaan...',
                sync_history: 'Synkronointihistoria (10 viimeisintä)',
                direction: 'Suunta',
                time: 'Aika',
                retries: 'Uudelleenyritykset',
                error_col: 'Virhe',
            },
            audit: {
                filter_event_placeholder: 'Suodata tapahtumatyypin mukaan...',
                filter_actor_placeholder: 'Suodata tekijän mukaan...',
            },
            fulfillment: {
                title: 'Osastotäyttäminen',
                assign_departments: 'Määritä osastot',
                department: 'Osasto',
                assignee: 'Vastuuhenkilö',
                deadline: 'Määräaika',
                evidence_count: 'Todistusaineisto',
                signoff: 'Hyväksyntä',
                signed_off: 'Hyväksytty',
                pending_signoff: 'Odottaa',
                start_button: 'Aloita',
                complete_button: 'Merkitse valmiiksi',
                signoff_button: 'Kirjaudu pois',
                no_tasks: 'Ei täyttämistehtäviä vielä.',
                tasks_table: 'Täyttämistehtävät',
                progress_label: 'Täyttämisen edistyminen',
                overdue: 'myöhässä',
                assigned_success: 'Osastotäyttämistehtävä määritetty onnistuneesti.',
                assign_error: 'Täyttämistehtävän määrittäminen epäonnistui.',
                signoff_success: 'Osastohyväksyntä kirjattu.',
                signoff_error: 'Hyväksynnän kirjaaminen epäonnistui.',
                identity_required: 'Identity verification required before fulfillment actions.',
                remove_task: 'Remove Task',
                remove_success: 'Fulfillment task removed successfully.',
                add_evidence_btn: 'Lisää todiste',
                evidence_uploaded: 'Todiste ladattu ja linkitetty',
                evidence_upload_error: 'Todisteen lataus epäonnistui',
                suggest_data_stores: 'Ehdota tietovarastoja',
                suggest_error: 'Tietovarastoehdotusten lataaminen epäonnistui.',
                suggest_stores_title: 'Ehdotetut tietovarastot',
                suggest_stores_none: 'Yksikään tietovarasto ei vastaa tätä tapausta. Paranna ehdotuksia määrittämällä järjestelmät Data Mappingissa.',
                suggest_stores_add: 'Lisää koteloon',
                suggest_stores_added: 'Tietovarasto lisätty koteloon',
                no_departments_title: 'Mitään osastoja ei ole määritetty',
                no_departments_body: 'Osastojen avulla voit reitittää DSR-täyttötehtävät toimintoon (tietosuoja, lakiasiat, HR, IT-palvelut). Asenna esimerkkiosastot tai pyydä järjestelmänvalvojaa määrittämään osastot Organisaation asetuksissa.',
                no_departments_cta: 'Asenna esimerkkitiedot',
                department_placeholder: 'Osaston nimi...',
                assignee_placeholder: 'Käyttäjätunnus määritettäväksi...',
                assign_button: 'Määritä',
                status_pending: 'Odottaa',
                status_in_progress: 'Käynnissä',
                status_completed: 'Valmis',
                status_verified: 'Vahvistettu',
                confirm_approve: 'Haluatko varmasti hyväksyä tämän jatkoajan?',
                confirm_deny: 'Haluatko varmasti hylätä tämän jatkoajan?',
            },
            response: {
                title: 'Vastauksen luominen',
                select_template: 'Vastausmalli',
                choose_template: 'Valitse malli...',
                generate: 'Luo vastaus',
                preview: 'Vastauksen esikatselu',
                send: 'Lähetä vastaus',
                delivery_method: {
                    label: 'Toimitustapa',
                    email: 'Sähköposti',
                    portal: 'Portaali',
                    postal: 'Postin posti',
                    in_person: 'Henkilökohtaisesti',
                },
                recipient: {
                    email: 'Vastaanottajan sähköposti',
                    portal: 'Portaalin käyttäjätunnus',
                    address: 'Postiosoite',
                },
                auto_generate_btn: 'Luo ja lähetä vastaus',
                auto_generate_success: 'Vastaus luotu ja toimitettu',
                auto_generate_missing_recipient: 'Ilmoita vastaanottaja ennen lähettämistä.',
                auto_fields: 'Automaattisesti täytetyt kentät',
                case_id: 'Tapaus-ID',
                requester_name: 'Pyytäjän nimi',
                rights_type: 'Oikeustyyppi',
                history: 'Lähetetyt vastaukset',
                generated_at: 'Luotu',
                confirmation: 'Vahvistus',
                sent_label: 'Lähetetty',
                draft_label: 'Luonnos',
                generated_success: 'Vastaus luotu onnistuneesti.',
                generate_error: 'Vastauksen luominen epäonnistui.',
                sent_success: 'Vastaus lähetetty onnistuneesti.',
                send_error: 'Vastauksen lähettäminen epäonnistui.',
                load_error: 'Vastausmallien lataaminen epäonnistui.',
                pdf_title: 'Vastauskirje rekisteröidylle',
                download_pdf: 'Lataa PDF',
                download_all: 'Lataa kaikki',
                download_error: 'Vastauksen lataaminen epäonnistui',
            },
            extension: {
                title: 'Määräajan jatkaminen',
                acknowledgment_deadline: 'Kuittausmääräaika',
                fulfillment_deadline: 'Täyttämismääräaika',
                request_extension: 'Pyydä jatkoaikaa',
                reason: 'Syy',
                reason_placeholder: 'Syy lisäajan pyytämiseen...',
                additional_days: 'Lisäpäivät',
                submit_request: 'Lähetä jatkoaikapyyntö',
                history: 'Jatkoaikahistoria',
                requested_at: 'Pyydetty',
                approve: 'Hyväksy',
                deny: 'Hylkää',
                request_success: 'Jatkoaikapyyntö lähetetty.',
                request_error: 'Jatkoaikapyynnön lähettäminen epäonnistui.',
                approved_success: 'Jatkoaika hyväksytty.',
                denied_success: 'Jatkoaika hylätty.',
                decision_error: 'Jatkoaikapäätöksen käsittely epäonnistui.',
                status_pending: 'Odottaa',
                status_approved: 'Hyväksytty',
                status_denied: 'Hylätty',
                confirm_approve: 'Haluatko varmasti hyväksyä tämän jatkoaikapyynnön?',
                confirm_deny: 'Haluatko varmasti hylätä tämän jatkoaikapyynnön?',
                decided_by: 'Päättäjä',
            },
        },
        audit: {
            export_csv: 'Vie CSV',
            exporting: 'Viedään...',
            search_placeholder: 'Etsi tarkastustiedoista...',
            filter_by_actor: 'Suodata tekijän mukaan...',
            all_event_types: 'Kaikki tapahtumatyypit',
            seq: '#',
            timestamp: 'Aikaleima',
            event: 'Tapahtuma',
            case_col: 'Tapaus',
            actor: 'Tekijä',
            summary: 'Yhteenveto',
            no_events: 'Tarkastustapahtumia ei löytynyt',
            export_success: 'Kirjausketjun vienti onnistui.',
            export_error: 'Tarkastus-CSV:n vienti epäonnistui',
            load_error: 'Tarkastuspolun lataaminen epäonnistui. Yritä uudelleen.',
            announce_loaded: 'Tarkastuspolku ladattu',
            start_date: 'Alkamispäivä',
            end_date: 'Päättymispäivä',
            per_page: '{count} / sivu',
            unknown: 'Tuntematon',
            source_filter: {
                label: 'lähde',
                all: 'Kaikki',
                module: 'Moduuli',
                forseti: 'Forseti',
                aria_label: 'Suodata tarkastustapahtumat lähteen mukaan',
            },
            event_types: {
                case_created: 'Tapaus luotu',
                status_changed: 'Tila muutettu',
                case_assigned: 'Tapaus vastuutettu',
                note_added: 'Muistiinpano lisätty',
                attachment_added: 'Liite lisätty',
                attachment_deleted: 'Liite poistettu',
                reference_added: 'Viite lisätty',
                checklist_updated: 'Tarkistuslista päivitetty',
                identity_verified: 'Henkilöllisyys vahvistettu',
                closure_summary_added: 'Sulkemisen yhteenveto',
                approval_granted: 'Hyväksyntä myönnetty',
                template_applied: 'Mallipohja sovellettu',
                export_generated: 'Vienti luotu',
                sla_warning: 'SLA-varoitus',
                sla_overdue: 'SLA myöhässä',
            },
            unified_audit: {
                title: 'Yhdistetty Tarkastuspolku',
                module_filter: 'Moduuli',
                framework_filter: 'Viitekehys',
                select_framework: 'Valitse viitekehys...',
                entity_type_filter: 'Entiteettityyppi',
                action_filter: 'Toiminto',
                actor_filter: 'Toimija',
                select_actor: 'Valitse toimija...',
                search_filter: 'Haku',
                search_placeholder: 'Hae tarkastustapahtumia...',
                filters_heading: 'Suodattimet',
                date_range: 'Aikaväli',
                no_events_found: 'Tarkastustapahtumia ei löytynyt.',
                event_count: 'Tapahtumien määrä',
                action: 'Toiminto',
                actor: 'Toimija',
                date_range_start: 'Ajanjakson alku',
                date_range_end: 'Ajanjakson loppu',
                filtering_events: 'Suodatetaan tarkastustapahtumia',
                framework_codes: 'Viitekehyskoodit',
                entity_type_col: 'Entiteettityyppi',
                aria_table: 'Yhdistetyt tarkastustapahtumat',
                page_of: 'Sivu {page} / {total}',
                entity_types: {
                    user: 'Käyttäjä',
                    case: 'Asia',
                    incident: 'Tapahtuma',
                    assessment: 'Arviointi',
                    vendor: 'Myyjä',
                    consent: 'Suostumus',
                    policy: 'politiikka',
                    data_map: 'Tietokartta',
                },
                actions: {
                    create: 'Luo',
                    update: 'Päivitä',
                    delete: 'Poista',
                    view: 'Näytä',
                    export: 'Vie',
                    status_change: 'Tilan muutos',
                },
            },
            evidence_packs: {
                title: 'Tarkastuksen Todistuspaketit',
                assemble_pack: 'Kokoa Todistuspaketti',
                framework: 'Viitekehys',
                select_framework: 'Valitse viitekehys...',
                framework_code_label: 'Kehyskoodi',
                entity_types: 'Entiteettityypit',
                select_entity_types: 'Valitse entiteettityypit...',
                period: 'Jakso',
                period_start: 'Jakson alku',
                period_end: 'Jakson loppu',
                completeness: 'Kattavuus',
                no_packs_found: 'Todistuspaketteja ei löytynyt.',
                verify: 'Vahvista',
                export_pack: 'Vie',
                exporting: 'Viedään...',
                pack_assembled: 'Todistepaketti koottu',
                pack_exported: 'Todistepaketti viety',
                aria_table: 'Tarkastuksen todistepaketit',
                aria_export_pack: 'Vie paketti',
                export_format: 'Vientimuoto',
                export_in_progress: 'Vienti käynnissä...',
                status_draft: 'Luonnos',
                status_assembled: 'Koottu',
                status_verified: 'Vahvistettu',
                status_submitted: 'Lähetetty',
                entity_type_labels: {
                    user: 'Käyttäjä',
                    case: 'Asia',
                    incident: 'Tapahtuma',
                    assessment: 'Arviointi',
                    vendor: 'Myyjä',
                    consent: 'Suostumus',
                    policy: 'politiikka',
                    data_map: 'Tietokartta',
                },
                template_id: 'Malline-ID',
                csv_headers: {
                    module: 'Moduuli',
                    action: 'Toiminta',
                    actor_id: 'näyttelijä',
                    entity_type: 'Entiteettityyppi',
                    entity_id: 'Entity ID',
                    summary: 'Yhteenveto',
                    timestamp: 'Aikaleima',
                    framework_code: 'puitteet',
                },
                export_header_framework: 'Todistepaketti — Viitekehys: {framework}',
                export_header_period: 'Jakso: {start} - {end}',
                export_header_completeness: 'Kattavuus: {score}%',
                export_header_status: 'Tila: {status}',
            },
            audit_periods: {
                title: 'Tarkastusjaksot',
                create_period: 'Luo Tarkastusjakso',
                framework_code_label: 'Kehyskoodi',
                select_framework: 'Valitse viitekehys...',
                period_label: 'Jakson nimi',
                period_start: 'Jakson alku',
                period_end: 'Jakson loppu',
                start: 'Aloita',
                end: 'Loppu',
                framework: 'Kehys',
                retention_days: 'Säilytyspäivät',
                no_periods_found: 'Tarkastusjaksoja ei löytynyt.',
                period_created: 'Tarkastuskausi luotu',
                aria_table: 'Tarkastuskaudet',
                suggested_boundaries: 'Ehdotetut rajat',
                suggested_boundaries_info: 'Ehdotetut jaksorajat johdetaan kunkin viitekehyksen sääntelyraportoinnin syklistä. Muokkaa tarvittaessa organisaatiollesi sopivaksi.',
                reporting_cycle: 'Raportointisykli',
                suggested_start: 'Ehdotettu alku',
                suggested_end: 'Ehdotettu loppu',
                suggested_next: 'Suositeltu seuraavaksi kaudeksi',
                cycle_monthly: 'Kuukausittain',
                cycle_quarterly: 'Neljännesvuosittain',
                cycle_semi_annual: 'Puolivuosittain',
                cycle_annual: 'Vuosittainen',
                cycle_custom: 'Mukautettu',
                period_deleted: 'Tarkastusjakso poistettu',
            },
        },
        create_case: {
            customer_ref: 'Asiakasviite',
            country: 'Maa / lainkäyttöalue',
            preferred_channel: 'Ensisijainen kanava',
            channels: {
                email: 'Sähköposti',
                postal: 'Posti',
                phone: 'Puhelin',
                portal: 'Portaali',
            },
            source: 'lähde',
            sources: {
                admin_manual: 'Järjestelmänvalvojan käsikirja',
                public_form: 'Julkinen lomake',
                cmp_gateway: '[[TOK_0]] Yhdyskäytävä',
                aesirx_cmp: '[[TOK_1]] [[TOK_0]]',
                phone_received: 'Puhelin vastaanotettu',
                postal_received: 'Posti vastaanotettu',
                email_received: 'Sähköposti vastaanotettu',
                in_person: 'Henkilökohtaisesti',
                legacy_import: 'Vanha tuonti',
            },
            required_fields: 'Pyynnön tyyppi, nimi ja sähköposti ovat pakollisia',
            create_error: 'Tapauksen luominen epäonnistui',
        },
        settings: {
            title: 'Asetukset',
            request_types: 'Pyyntötyypit',
            request_types_desc: 'Määritä mitkä pyyntötyypit ovat käytössä julkisessa lomakkeessa.',
            notifications: 'Ilmoitukset',
            ticket_numbering: 'Tikettien numerointi',
            ticket_format: 'Nykyinen muoto',
            ticket_prefix: 'Etuliite',
            ticket_prefix_note: 'ei muutettavissa Sprint 1.0.0:ssa',
            sla_deadlines: 'SLA-määräajat',
            sla_desc: 'Aseta kunkin pyyntötyypin enimmäisvastausaika (kalenteripäivinä). Tapaukset, jotka lähestyvät raja-arvoa, näyttävät varoituksia.',
            days: 'päivää',
            warning_threshold: 'Varoituskynnys',
            escalation_label: 'Ota automaattinen eskalaatio käyttöön SLA-ylityksissä',
            save_sla: 'Tallenna SLA-asetukset',
            saving: 'Tallennetaan...',
            saved: 'Tallennettu onnistuneesti',
            announce_loaded: 'Asetukset ladattu',
            email_on_creation: 'Sähköposti-ilmoitus tiketin luonnissa',
            send_confirmation: 'Lähetä vahvistussähköposti pyytäjälle',
            users: 'Käyttäjät',
            roles: 'Roolit',
            api_keys: '[[TOK_0]] Näppäimet',
            mfa: 'MFA',
            sessions: 'Istunnot',
            webhooks: 'Webhooks',
            modules: 'Moduulit',
            deadline_labels: {
                access: 'Pääsy (DSAR)',
                deletion: 'Poistaminen',
                correction: 'Oikaisu',
                portability: 'Siirrettävyys',
                objection: 'Vastustaminen',
                restriction: 'Rajoittaminen',
                consent_withdrawal: 'Suostumuksen peruuttaminen',
            },
        },
        section_assignments: {
            title: 'Osion tehtäväjaot',
            assign_section: 'Määritä osio',
            section_ref: 'Osioviite',
            section_label: 'Osion nimi',
            department_id: 'Osasto',
            assignee_id: 'Vastuuhenkilö',
            mandatory: 'Pakollinen',
            assign: 'Määritä',
            no_assignments: 'Ei osion tehtäväjaoistoa',
            status: 'Tila',
            completion: 'Valmistuminen',
            mark_complete: 'Merkitse valmiiksi',
        },
        consolidation: {
            title: 'Konsolidoinnin edistyminen',
            add_child: 'Lisää alitehtävä',
            child_task_id: 'Alitehtävän tunnus',
            department_id: 'Osasto',
            link: 'Linkki',
            overall_completion: 'Kokonaisvalmistuminen',
            departments_complete: 'Valmiit osastot',
            overdue: 'Myöhässä',
            ready: 'Valmis',
            not_ready: 'Ei valmis',
            master_status: 'Pääasiallinen tila',
            department_breakdown: 'Osastoerittely',
            department: 'Osasto',
            status: 'Tila',
            completion: 'Valmistuminen',
            due_date: 'Eräpäivä',
            overdue_flag: 'Myöhässä',
            child_tasks: 'Alitehtävät',
            task: 'Tehtävä',
        },
        conflict_detection: {
            title: 'Ristiriitojen tunnistus',
            unresolved: 'ratkaisematta',
            no_conflicts: 'Ristiriitoja ei havaittu',
            section: 'Osio',
            field: 'Kenttä',
            dept_a: 'Osasto A',
            value_a: 'Arvo A',
            dept_b: 'Osasto B',
            value_b: 'Arvo B',
            severity: 'Vakavuus',
            status: 'Tila',
            resolved: 'Ratkaistu',
            open: 'Avoin',
            resolve: 'Ratkaise',
        },
        org_maturity: {
            title: 'Organisaation Kypsyys',
            departments: 'Osastot',
            department_hierarchy: 'Osastohierarkia',
            create_department: 'Luo Osasto',
            department_name: 'Osaston Nimi',
            department_code: 'Koodi',
            level: 'Taso',
            division: 'Toimiala',
            department: 'Osasto',
            team: 'Tiimi',
            parent_department: 'Yläosasto',
            head_user: 'Osastopäällikkö',
            no_departments: 'Osastoja ei ole määritetty.',
            user_mappings: 'Käyttäjäliitokset',
            map_user: 'Liitä Käyttäjä',
            user_id: 'Käyttäjä-ID',
            role: 'Rooli',
            no_users: 'Tälle osastolle ei ole liitetty käyttäjiä.',
            remove: 'Poista',
            framework_assignments: 'Viitekehystilaukset',
            assign_framework: 'Tilaa Viitekehys',
            entity_id: 'Entiteetti-ID',
            entity_type: 'Entiteettityyppi',
            framework_id: 'Viitekehys-ID',
            framework_code: 'Viitekehyskoodi',
            no_assignments: 'Ei viitekehystilauksia.',
            compliance_rollup: 'Vaatimustenmukaisuusyhteenveto',
            entity_name: 'Entiteetti',
            total_assessments: 'Arvioinnit yhteensä',
            completed: 'Valmis',
            completion_pct: 'Valmistumis-%',
            open_gaps: 'Avoimet Puutteet',
            critical_gaps: 'Kriittiset',
            compliance_score: 'Pisteet',
            no_rollup: 'Vaatimustenmukaisuusyhteenvetotietoja ei saatavilla.',
            entity_summary: 'Entiteetin Vaatimustenmukaisuusyhteenveto',
            frameworks_assigned: 'Viitekehykset',
            overall_score: 'Kokonaispisteet',
            load_departments_error: 'Osastojen lataaminen epäonnistui',
            load_users_error: 'Käyttäjien lataaminen epäonnistui',
            department_created: 'Osasto luotu',
            department_created_announce: 'Osasto luotu',
            create_department_error: 'Osaston luominen epäonnistui',
            user_mapped: 'Käyttäjä yhdistetty',
            user_mapped_announce: 'Käyttäjä yhdistetty osastoon',
            map_user_error: 'Käyttäjän yhdistäminen epäonnistui',
            user_removed: 'Käyttäjä poistettu',
            load_rollup_error: 'Yhteenvedon lataaminen epäonnistui',
            load_assignments_error: 'Määritysten lataaminen epäonnistui',
            framework_assigned: 'Kehys kohdistettu',
            framework_assigned_announce: 'Kehys kohdistettu entiteetille',
            assign_framework_error: 'Kehyksen määrittäminen epäonnistui',
            assignment_removed: 'Kohdistus poistettu',
            enter_entity_id_placeholder: 'Syötä entiteetin tunnus nähdäksesi kohdistukset',
            entity_type_organization: 'Organisaatio',
            entity_type_department: 'Osasto',
        },
        onboarding_maturity: {
            title: 'Aloituskysymys',
            quick_starts: 'Pikakäynnistykset',
            progress: 'Käyttöönoton edistyminen',
            personas: 'Personan polut',
            persona_onboarding: 'Personan käyttöönotto',
            quick_start_scenarios: 'Pika-aloitusskenaariot',
            start: 'Aloita',
            restart: 'Käynnistä uudelleen',
            estimated_minutes: 'Arvioidut minuutit',
            steps: 'Vaiheet',
            scenario: 'Skenaario',
            no_scenarios: 'Pikakäynnistysskenaarioita ei ole saatavilla.',
            persona_id: 'Henkilötunnus',
            persona_label: 'Persoona',
            role_description: 'Roolin kuvaus',
            primary_modules: 'Ensisijaiset moduulit',
            recommended_tours: 'Suositellut retket',
            sample_data_modules: 'Esimerkkitietomoduulit',
            quick_start_scenario: 'Pika-aloitusskenaario',
            no_personas: 'Henkilöpolkuja ei ole saatavilla.',
            framework_setup: 'Sääntelykehykset',
            framework_code: 'Puitekoodi',
            framework_name: 'Kehyksen nimi',
            related_modules: 'Liittyvät moduulit',
            persona_relevance: 'Asiaankuuluvat persoonat',
            no_frameworks: 'Kehysasetusvaihtoehtoja ei ole saatavilla.',
            tier_config: 'Tasomoduulin konfigurointi',
            tier: 'Taso',
            available_modules: 'Saatavilla olevat moduulit',
            module_count: 'Moduulien määrä',
            overall_completion: 'Yleinen valmistuminen',
            wizard_completed: 'Ohjattu toiminto valmis',
            tours_completed: 'Retket suoritettu',
            quick_starts_completed: 'Pikakäynnistykset suoritettu',
            selected_frameworks: 'Valitut puitteet',
            no_progress: 'Käyttöönoton edistymistietoja ei ole saatavilla.',
            detected_persona: 'Havaittu Persona',
            current_tier: 'Nykyinen taso',
            completion_pct: 'Valmistuminen',
            progress_page: {
                loaded: 'Edistyminen ladattu',
                no_progress: 'Ei perehdytyksen edistymistietoja saatavilla.',
                overall: 'Kokonaisedistyminen',
                detected_persona: 'Tunnistettu persona',
                tier: 'Taso',
                modules: 'moduulit',
                wizard: 'Ohjattu toiminto',
                completed: 'Valmis',
                pending: 'Odottaa',
                tours: 'Kierrokset',
                quick_starts: 'Pikaaloitukset',
                frameworks: 'Valitut viitekehykset',
                no_frameworks: 'Ei viitekehyksiä valittuna.',
                go_to_wizard: 'Suorita ohjattu asennus loppuun',
                framework_selection: 'Viitekehyksen valinta',
                framework_toggle: 'Ota viitekehyksiä käyttöön tai poista niitä vaatimustenmukaisuusohjelmastasi.',
                framework_updated: 'Viitekehyksen valinta päivitetty.',
                view_tours: 'Näytä kierrokset',
                view_quick_starts: 'Näytä pikaaloitukset',
            },
            persona_page: {
                description: 'Valitse persona nähdäksesi suositellut moduulit, kierrokset ja pikaaloitusskenaariot.',
                no_personas: 'Ei personapolkuja saatavilla.',
                modules: 'Moduulit',
                tours: 'Kierrokset',
                quick_start: 'Pikaaloitus',
                details: 'Tiedot',
                primary_modules: 'Ensisijaiset moduulit',
                recommended_tours: 'Suositellut kierrokset',
                framework_options: 'Sääntelykehykset',
                no_frameworks: 'Ei viitekehyksen asetusvalintoja saatavilla.',
                framework_code: 'Viitekehyskoodi',
                framework_label: 'Nimike',
                region: 'Alue',
                category: 'Luokka',
                enabled: 'Käytössä',
                disabled: 'Pois käytöstä',
                tier_modules: 'Tasomoduulikonfiguraatio',
                tiers_loaded: 'Tasokonfiguraatiot ladattu',
                no_tier_config: 'Ei tasokonfiguraatiota saatavilla.',
                view_tours: 'Näytä moduulikierrokset',
                view_quick_start: 'Aloita pikaaloitus',
                toggle_framework: 'Vaihda viitekehys',
                framework_updated: 'Viitekehyksen valinta päivitetty.',
                tier_desc_light: 'Yksityisyyden perusasiat — PDPL-vaatimustenmukaisuuden perusteet',
                tier_desc_standard: 'Täydellinen vaatimustenmukaisuuspaketti — kaikki moduulit työnkuluilla',
                tier_desc_enterprise: 'Edistynyt hallinto ja automaatio — moniyksikkö, ryhmäraportointi',
                persona_highlight: 'Sinun moduulisi',
                aria_go_to_module: '[[TOK_1]] — siirry moduuliin',
                aria_start_tour: 'Aloita [[TOK_1]]',
                aria_quick_start: 'Pika-aloitus: [[TOK_1]]',
                aria_help_article: 'Ohjeartikkeli: [[TOK_1]]',
                aria_view_framework: '[[TOK_2]][[TOK_3]] — katso puitteet',
                aria_primary_for_persona: '[[TOK_1]] (ensisijainen tälle henkilölle)',
                primary_for_persona_suffix: ' (ensisijainen tälle henkilölle)',
                aria_view_in_persona_paths: '[[TOK_1]] — näytä Persona Pathsissa',
                progress_of_total: '[[TOK_2]]/[TOK_3] suoritettu',
            },
            quick_starts_page: {
                description: 'Harjoittele yleisiä työnkulkuja opastetuilla pikaaloitusskenaarioilla.',
                no_scenarios: 'Ei pikaaloitusskenaarioita saatavilla.',
                started: 'Pikaaloitus aloitettu',
                status_completed: 'Valmis',
                status_in_progress: 'Käynnissä',
                status_not_started: 'Ei aloitettu',
                minutes: 'min',
                steps: 'vaiheet',
                step: 'Vaihe',
                restart: 'Aloita alusta',
                start: 'Aloita',
                go_to_module: 'Siirry moduuliin',
                next_step: 'Seuraava vaihe',
                complete: 'Valmis',
                reset: 'Nollaa',
                step_of: '/',
                action_navigate: 'Siirry',
                action_form_fill: 'Täytä lomake',
                action_review: 'Tarkista',
                action_confirm: 'Vahvista',
                step_changed: 'Vaihe {current}/{total}: {title}',
                completed_message: 'Pikaaloitus suoritettu onnistuneesti!',
                reset_message: 'Pikaaloitus on nollattu.',
            },
            persona_p_vn_01_label: 'Yritys DPO',
            persona_p_vn_01_description: 'Tietosuojavastaava, joka hallinnoi yrityksen laajuisia vaatimustenmukaisuusohjelmia',
            persona_p_vn_02_label: 'Osaston omistaja',
            persona_p_vn_02_description: 'Osaston johtaja, joka vastaa osien vaatimustenmukaisuuden raportoinnista',
            persona_p_vn_03_label: 'Sähköisen kaupankäynnin vaatimustenmukaisuus',
            persona_p_vn_03_description: 'Compliance Officer keskittyi sähköisen kaupankäynnin tietosuojaan ja suostumukseen',
            persona_p_vn_04_label: 'Telecom [[TOK_0]]',
            persona_p_vn_04_description: 'Televiestintäsektori DPO, joka hallinnoi tilaajatietoja ja tapahtumaraportointia',
            persona_p_vn_05_label: 'Tietohallintojohtaja',
            persona_p_vn_05_description: 'Tietojen kartoittamisesta, luokittelusta ja hallinnasta vastaava johtaja',
            persona_p_vn_06_label: 'Kyberturvallisuus ja lakipalvelut',
            persona_p_vn_06_description: 'Kyberturvallisuuspäällikkö, joka hallitsee tapahtumien reagointia ja toimittajariskiä',
            persona_p_vn_07_label: 'AI Hallintojohtaja',
            persona_p_vn_07_description: 'Johda AI järjestelmän hallinnan, riskinarvioinnin ja luokituksen valvontaa',
            persona_p_vn_08_label: 'Rajat ylittävä ja myyjien kuvernööri',
            persona_p_vn_08_description: 'Virkamies, joka hallinnoi rajat ylittäviä siirtoja ja toimittajan hallintoa',
            persona_p_vn_09_label: 'Rikkomusvastausjohto',
            persona_p_vn_09_description: 'Johda rikkomusilmoitusten ja tapahtumien reagoinnin koordinointia',
            persona_p_vn_10_label: 'Sisäisen tarkastuksen päällikkö',
            persona_p_vn_10_description: 'Johtaja, joka vastaa vaatimustenmukaisuuden tarkastamisesta ja ohjelman hallinnon tarkastuksesta',
            persona_p_vn_11_label: 'HR- ja työntekijätietojen vastuuhenkilö',
            persona_p_vn_11_description: 'HR-päällikkö, joka hallinnoi työntekijöiden suostumusrekistereitä ja sisäisiä DSAR-pyyntöjä',
            persona_p_vn_12_label: 'Monikansallisen tytäryhtiön vaatimustenmukaisuuspäällikkö',
            persona_p_vn_12_description: 'Tietosuojavastaava ulkomaisen yrityksen Vietnamin tytäryhtiössä, joka tarvitsee paikallisen vaatimustenmukaisuuskerroksen',
            persona_p_vn_13_label: 'Koulutuksen vaatimustenmukaisuuspäällikkö',
            persona_p_vn_13_description: 'Vaatimustenmukaisuuspäällikkö ulkomaisessa koulussa, joka hallinnoi oppilaiden ja vanhempien tietosuojaa',
            qs_hr_consent_title: 'Rekisteröi työntekijöiden suostumukset',
            qs_hr_consent_description: 'Käy läpi työntekijöiden suostumuksen rekisteröinti ja kattavuusraportin luominen.',
            qs_subsidiary_dpia_title: 'Luo tytäryhtiön DPIA-arviointi',
            qs_subsidiary_dpia_description: 'Käy läpi DPIA:n luominen tytäryhtiön käsittelytoiminnalle.',
            qs_student_consent_title: 'Määritä oppilaiden suostumuksen kerääminen',
            qs_student_consent_description: 'Käy läpi vanhempien suostumuskäytäntöjen luominen oppilastiedoille.',
            persona_p_vn_14_label: 'Ulkopuolinen lainopillinen neuvonantaja',
            persona_p_vn_14_description: 'Vanhempi asianajotoimistokumppani, joka neuvoo useita asiakasorganisaatioita PDPL:n noudattamisessa',
            persona_p_vn_15_label: 'Asianajotoimiston toimintapäällikkö',
            persona_p_vn_15_description: 'Asiakasvastuukoordinaattori, joka hallitsee suoritteiden seurantaa ja määräaikojen koordinointia',
            persona_p_vn_16_label: 'Yrityksen omistaja / CEO',
            persona_p_vn_16_description: 'CEO tai GM, joka on laillisesti rekisterinpitäjä PDPL:n mukaisesti ja joka on vastuussa vaatimustenmukaisuusinvestoinneista',
            qs_dpia_filing_title: 'Täytä ensimmäinen DPIA hakemuksesi',
            qs_dept_compliance_title: 'Lähetä ensimmäinen osastosi vaatimustenmukaisuusosio',
            qs_ecommerce_consent_title: 'Määritä verkkokaupan suostumuksen kerääminen',
            qs_telecom_data_title: 'Ota käyttöön televiestintätilaajatietojen käsittely',
            qs_data_flow_title: 'Kartoita ensimmäinen tietovirtasi',
            qs_incident_response_title: 'Määritä tapausvastauksen työnkulku',
            qs_ai_risk_title: 'Suorita AI järjestelmäriskin arviointi',
            qs_cross_border_title: 'Arvioi rajat ylittävä tiedonsiirto',
            qs_breach_notification_title: 'Simuloi rikkomusilmoitusten työnkulkua',
            qs_audit_trail_title: 'Tarkista vaatimustenmukaisuuden kirjausketju',
            qs_legal_advisor_portfolio_title: 'Tarkista usean asiakkaan vaatimustenmukaisuusportfolio',
            qs_legal_advisor_portfolio_description: 'Tarkista vaatimustenmukaisuuden tila useissa asiakasorganisaatioissa.',
            qs_law_firm_ops_title: 'Seuraa asiakkaan toimituksen tilaa',
            qs_law_firm_ops_description: 'Seuraa neuvontatoimien edistymistä ja asiakkaiden sitoutumista.',
            qs_ceo_dashboard_title: 'Näytä johtajien vaatimustenmukaisuuden hallintapaneeli',
            qs_ceo_dashboard_description: 'Tarkastele korkean tason vaatimustenmukaisuuden tilaa ja sijoitusmittareita.',
        },
        rights_requests: {
            response_templates: {
                title: 'Vastausmallit',
                subtitle: 'Hallinnoi DSR-vastauskirjemalleja, joita ResponseGenerator käyttää vastausten laatimiseen rekisteröidyille.',
                create_btn: 'Uusi malli',
                edit_btn: 'Muokkaa mallia',
                filter_right_type: 'Suodata oikean tyypin mukaan',
                filter_locale: 'Suodata kieliasetuksen mukaan',
                filter_status: 'Suodata tilan mukaan',
                all_right_types: 'Kaikki oikeat tyypit',
                any_right_type: 'Mikä tahansa (koskee kaikkia tyyppejä)',
                all_locales: 'Kaikki alueet',
                all_statuses: 'Kaikki',
                status_active: 'Aktiivinen',
                status_inactive: 'Ei-aktiivinen',
                empty_state: 'Yksikään malli ei vastaa nykyisiä suodattimia.',
                columns: {
                    template_id: 'Mallin tunnus',
                    outcome: 'Tulos',
                    locale: 'Alue',
                    right_type: 'Oikea tyyppi',
                    is_active: 'Tila',
                    last_updated: 'Viimeksi päivitetty',
                    actions: 'Toiminnot',
                },
                actions: {
                    edit: 'Muokkaa',
                    clone: 'Klooni',
                    deactivate: 'Poista käytöstä',
                    reactivate: 'Aktivoi uudelleen',
                    preview: 'Esikatselu',
                },
                form: {
                    template_id: 'Mallin tunnus',
                    template_id_help: 'Pienet kirjaimet, esim. dsr_access_fulfilled_vi',
                    outcome: 'Tulos',
                    locale: 'Alue',
                    right_type: 'Oikea tyyppi',
                    subject: 'Aihe',
                    body: 'Runkomalli',
                    body_help: 'Käytä paikkamerkkejä, kuten [[TOK_3]], [[TOK_4]], [[TOK_5]]. Vähintään 15 riviä moniosaisille kirjeille.',
                    is_active: 'Aktiivinen',
                    official_form_id: 'Virallinen lomaketunnus (valinnainen)',
                },
                outcomes: {
                    fulfilled: 'Täytetty',
                    partially_fulfilled: 'Osittain täytetty',
                    denied: 'Kielletty',
                },
                clone_modal_title: 'Kloonaa malli',
                clone_target_locale: 'Kohdealue',
                clone_help: 'Kohdealueelle luodaan uusi malli käyttämällä tätä mallia aloituskohtana.',
                preview_modal_title: 'Mallin esikatselu',
                preview_note: 'Esikatselu käyttää esittelytapauksen DSR-DEMO-0020 paikkamerkkejä. Todellinen toimitus korvaa live-tapaustiedot.',
                preview_unavailable: 'Esikatselu vaatii olemassa olevan tapauksen. Liitä tämä malli tapaukseen ja käytä Vastausluonnos -toimintoa tapauksen lisätietosivulla.',
                deactivate_confirm: 'Poistetaanko tämä malli? Sitä sovelletaan edelleen olemassa oleviin tapauksiin, joissa siihen viitataan.',
                toasts: {
                    created: 'Malli luotu',
                    updated: 'Malli päivitetty',
                    deactivated: 'Malli poistettu käytöstä',
                    reactivated: 'Malli aktivoitu uudelleen',
                    cloned: 'Malli kloonattu',
                    load_error: 'Mallien lataaminen epäonnistui',
                    save_error: 'Mallin tallennus epäonnistui',
                    clone_error: 'Mallin kloonaus epäonnistui',
                },
            },
        },
        organizations: {
            departments: {
                title: 'Osastot',
                subtitle: 'Hallinnoi osastoja, jotka reitittävät DSR-tapauksia, [[TOK_0]] tehtäviä ja vaatimustenmukaisuuden työnkulkuja.',
                create_btn: 'Uusi osasto',
                edit_btn: 'Muokkaa osastoa',
                columns: {
                    name: 'Nimi',
                    description: 'Kuvaus',
                    active_cases: 'Aktiiviset tapaukset',
                    members: 'jäsenet',
                    status: 'Tila',
                    actions: 'Toiminnot',
                },
                status_active: 'Aktiivinen',
                status_inactive: 'Ei-aktiivinen',
                form: {
                    name: 'Nimi',
                    description: 'Kuvaus',
                },
                actions: {
                    edit: 'Muokkaa',
                    deactivate: 'Poista käytöstä',
                    reactivate: 'Aktivoi uudelleen',
                    delete: 'Poista',
                    manage_members: 'Hallitse jäseniä',
                },
                delete_modal_title: 'Poista osasto',
                delete_warning: 'Tällä osastolla on edelleen aktiivisia tapauksia. Valitse osasto, johon ne siirretään ennen poistamista.',
                delete_no_cases: 'Tällä osastolla ei ole aktiivisia tapauksia, ja se voidaan poistaa turvallisesti.',
                reassign_prompt: 'Määritä aktiiviset tapaukset uudelleen seuraaville:',
                reassign_none_available: 'Muita aktiivisia osastoja ei ole saatavilla. Luo ensin toinen osasto.',
                member_section_title: 'jäsenet',
                add_member: 'Lisää jäsen',
                remove_member: 'Poista',
                member_role: 'Rooli',
                no_members: 'Tälle osastolle ei ole yhdistetty yhtään jäsentä.',
                toasts: {
                    created: 'Osasto luotu',
                    updated: 'Osasto päivitetty',
                    deactivated: 'Osasto poistettu käytöstä',
                    reactivated: 'Osasto aktivoitu uudelleen',
                    deleted: 'Osasto poistettu',
                    reassigned_count: '[[TOK_1]] tapausta siirretty',
                    member_added: 'Jäsen lisätty',
                    member_removed: 'Jäsen poistettu',
                    load_error: 'Osastojen lataaminen epäonnistui',
                    save_error: 'Osaston tallentaminen epäonnistui',
                    delete_error: 'Osaston poistaminen epäonnistui',
                },
            },
            retention_policies: {
                title: 'Säilytyskäytännöt',
                subtitle: 'Määritä kohdetyyppiset säilytysikkunat. Henkilöllisyyden vahvistusasiakirjat käyttävät tätä leimaamaan retention_expires_at tuleviin latauksiin.',
                create_btn: 'Uusi politiikka',
                edit_btn: 'Muokkaa käytäntöä',
                columns: {
                    target_type: 'Kohdetyyppi',
                    retention_days: 'Säilytys (päiviä)',
                    owner: 'Käytännön omistaja',
                    effective_from: 'Voimassa alkaen',
                    last_reviewed: 'Viimeksi tarkistettu',
                    status: 'Tila',
                    actions: 'Toiminnot',
                },
                status_active: 'Aktiivinen',
                status_inactive: 'Ei-aktiivinen',
                form: {
                    target_type: 'Kohdetyyppi',
                    target_type_help: 'Mitä tietoluokkaa säilytysikkuna koskee. Tällä hetkellä tuetaan vain DSR-henkilöllisyyden todentamisasiakirjoja.',
                    retention_days: 'Säilytysikkuna (päiviä)',
                    retention_days_help: '1–3 650 päivää (enintään 10 vuotta).',
                    owner: 'Käytännön omistaja',
                    owner_help: 'Yleensä [[TOK_0]]. Vastuussa DG-2:n mukaisesta säilyttämispäätöksestä.',
                    effective_from: 'Voimassa alkaen',
                },
                target_types: {
                    dsr_identity_verification_document: 'DSR-henkilöllisyyden todentamisasiakirjat',
                },
                deactivate_notice: 'Deaktivointi ei vaikuta jo leimattuihin liitteisiin – vain tulevat lataukset eivät enää saa säilytysikkunaa.',
                deactivate_confirm: 'Poistetaanko tämä säilytyskäytäntö?',
                toasts: {
                    created: 'Säilytyskäytäntö luotu',
                    updated: 'Säilytyskäytäntö päivitetty',
                    deactivated: 'Säilytyskäytäntö poistettu käytöstä',
                    load_error: 'Säilytyskäytäntöjen lataaminen epäonnistui',
                    save_error: 'Säilytyskäytännön tallentaminen epäonnistui',
                },
            },
        },
    },
    data_mapping: {
        nav: {
            systems: 'Järjestelmät',
            categories: 'Tietoluokat',
            registry: 'Tietorekisteri',
            purposes: 'Käsittelytarkoitukset',
            retention: 'Säilytys',
            flows: 'Tietovirrat',
            activities: 'Käsittelytoimet',
            evidence: 'Todistusaineisto',
            exports: 'Viennit',
            attestation: 'Todistusjaksot',
            governance: 'Hallinto',
            review: 'Tarkistustehtävät',
            inventory: 'Inventaario',
            exceptions: 'Poikkeukset',
            history: 'Historia',
            ropa_completeness: 'ROPA-täydellisyys',
        },
        ropa_completeness_autofix: {
            ask_button: 'Kysy Forsetilta',
            drafting: 'Luonnostetaan…',
            accept: 'Hyväksy',
            reject: 'Hylkää',
            accepted: 'Hyväksytty — hae aktiviteettieditorin kautta.',
            rejected: 'Hylätty.',
            needs_human_input: 'Forseti tarvitsee lisää toimintakontekstia (esim. dokumentoitua tarkoitusta) ennen tämän kentän laatimista.',
        },
        ropa_completeness: {
            title: 'ROPA:n täydellisyysraportti',
            subtitle: 'Kenttäkohtainen hygieniatarkastus käsittelytoimintojesi tiedoista, sääntelykehyksen piirissä.',
            framework_label: 'puitteet',
            kpi_total: 'Aktiviteetit pisteytetty',
            kpi_critical: 'Kriittinen',
            kpi_high: 'Korkea',
            kpi_conditional: 'Ehdollinen',
            field_chart_heading: 'Puuttuvat kentät taajuuden mukaan',
            drilldown_heading: 'Toiminta, jossa on aukkoja',
            col_activity: 'Toiminta',
            col_field: 'Kenttä',
            col_severity: 'Vakavuus',
            col_condition: 'Kunto',
            col_action: 'Fix',
            action_fix: 'Fix',
            severity_critical: 'Kriittinen',
            severity_high: 'Korkea',
            severity_conditional: 'Ehdollinen',
            severity_informational: 'Tiedollinen',
            include_informational: 'Sisällytä tiedotus (ISO 27701)',
            export_csv: 'Lataa [[TOK_0]]',
            exporting: 'Viedään...',
            loading: 'Ladataan…',
            empty_state: 'Kaikilla aktiivisilla toimilla on täydelliset ROPA-tietueet tälle viitekehykselle.',
            error_fetch: 'Täydellisyysraportin lataaminen epäonnistui.',
            error_unsupported_framework: 'Tätä kehystä ei tueta.',
            error_framework_not_installed: 'Tätä kehystä ei ole asennettu organisaatiollesi.',
            no_misses_for_field: 'Tästä kentästä ei puutu mitään toimintoja.',
            framework_PDPL: '[[TOK_0]] (laki 91/2025 + asetus 356)',
            framework_GDPR: '[[TOK_0]] 30 artikla',
            framework_DECREE_165: 'Asetus 165 (Vietnamin tietolaki)',
            framework_ISO_27701: 'ISO 27701 (tiedot)',
        },
        registry: {
            page: {
                title: 'Tietorekisteri',
                subtitle: 'Organisaatiosi hallussa olevat henkilötietoelementit on järjestetty Tietoluokkiin.',
                empty_state: 'Ei vielä rekisteritietoja. Lisää tuote manuaalisesti tai tuo viranomaisrekisteristä.',
                empty_filter_state: 'Yksikään kohde ei vastaa suodattimiasi.',
            },
            filter: {
                category: 'Luokka',
                sensitivity: 'Herkkyys',
                data_subject: 'Rekisteröity',
                status: 'Tila',
                data_tier: 'Datataso',
                cross_border: 'Rajat ylittävä',
                has_owner: 'On omistaja',
                has_form_source: 'Tuotu lomakkeesta',
                search_placeholder: 'Hae nimi, kuvaus tai kentän tunniste…',
                clear: 'Selkeät suodattimet',
                option_all: 'Kaikki',
            },
            col: {
                name: 'Nimi',
                category: 'Luokka',
                sensitivity: 'Herkkyys',
                data_subjects: 'Rekisteröidyt',
                systems: 'Järjestelmät',
                activities: 'Aktiviteetit',
                owner: 'Omistaja',
                retention: 'Säilytys',
                data_tier: 'Datataso',
                status: 'Tila',
                last_reviewed: 'Viimeksi tarkistettu',
                actions: 'Toiminnot',
            },
            action: {
                add_manual: 'Lisää kohde',
                add_from_form: 'Lisää viranomaisrekisteristä',
                import_history: 'Tuo aiemmat lähetykset',
                export: 'Vie',
                archive: 'Arkisto',
                restore: 'Palauta',
                edit: 'Muokkaa',
                assign_owner: 'Määritä omistaja',
                attach_evidence: 'Liitä todisteet',
                open_lineage: 'Avoin sukulinja',
            },
            modal_editor: {
                section_identity: 'Identiteetti',
                section_classification: 'Luokittelu',
                section_subjects: 'Aiheet ja määrä',
                section_location: 'Sijainti ja siirto',
                section_systems: 'Järjestelmät ja toiminnot',
                section_retention: 'Säilytys ja laki',
                section_governance: 'Hallinto',
                section_notes: 'Huomautuksia',
                hint_inherited: '(peritty kategoriasta)',
                hint_overridden: '(ohitattu)',
                placeholder_field_identifiers: 'esim. asiakkaat.primary_email, hris.employee_id',
                validation_name_required: 'Nimi vaaditaan',
                validation_category_required: 'Luokka vaaditaan',
                validation_data_subjects_required: 'Vähintään yksi rekisteröidyn tyyppi vaaditaan',
                label_data_type: 'Tietotyyppi',
                label_field_identifiers: 'Kenttätunnisteet (pilkuilla erotettu)',
                label_data_subject_types: 'Rekisteröityjen tyypit',
                label_volume_band: 'Volyymibändi',
                label_storage_locations: 'Tallennuspaikat (pilkuilla erotettu)',
                placeholder_storage_locations: 'ISO-3166 koodit tai vapaa teksti (esim. VN, Hetzner EU)',
                label_cross_border: 'Rajat ylittävä siirto',
                label_source_systems: 'Lähdejärjestelmät',
                label_processing_activities: 'Käsittelytoiminnot',
                label_collection_method: 'Keräysmenetelmä',
                label_legal_basis: 'Oikeusperusta',
                label_purposes: 'Tarkoitukset',
                hint_multi_select: 'Valitse useita pitämällä Cmd/Ctrl-näppäintä painettuna.',
                option_inherit_category: '- (periä luokasta)',
                option_dash: '—',
            },
            modal_import: {
                dry_run_heading: 'Tuo esikatselu',
                label_to_create: 'luoda',
                label_to_update: 'Päivittämään',
                label_skipped_archived: 'Ohitettu (arkistoitu)',
                label_conflicts: 'Konfliktit',
                commit: 'Tuo',
                cancel: 'Peruuta',
                conflict_row: '[[TOK_3]] — muokkauksen säilyttäminen ([[TOK_4]]); kartoittaja halusi [[TOK_5]].',
            },
            drawer: {
                section_category: 'Luokka',
                section_systems: 'Lähdejärjestelmät',
                section_activities: 'Käsittelytoiminnot',
                section_flows: 'Tietovirrat',
                section_retention: 'Tehokas säilytys',
                section_governance: 'Hallinto',
                section_evidence: 'Todisteet',
                section_audit: 'Viimeaikainen kirjausketju',
                section_source_form: 'Lähdelomakkeen lähetys',
                badge_inherited: 'Peritty',
                badge_overridden: 'Ohitettu',
            },
            toast: {
                created: 'Rekisterikohde luotu.',
                updated: 'Rekisterikohde päivitetty.',
                archived: 'Rekisterikohde arkistoitu.',
                imported: '[[TOK_1]] tuotetta tuotu.',
                conflict_warning: '[[TOK_1]]-kentät säilyttivät muokkauksesi – katso ristiriitaluettelo.',
            },
        },
        systems: {
            title: 'Järjestelmärekisteri',
            new: 'Uusi järjestelmä',
            edit: 'Muokkaa järjestelmää',
            name: 'Nimi',
            owner: 'Omistaja',
            criticality: 'Kriittisyys',
            dpa_status: 'HTS-tila',
            location: 'Sijainti',
            system_type: 'Järjestelmätyyppi',
            metadata: 'Metatiedot (JSON)',
            department: 'Osasto',
            hosting_location: 'Ylläpidon Sijainti',
            hosting_provider: 'Ylläpitotarjoaja',
            data_residency_country: 'Tietojen Sijaintimaa',
            hosting: 'Ylläpito',
            no_systems: 'Järjestelmiä ei löytynyt',
            confirm_archive: 'Arkistoi järjestelmä "{name}"?',
            count: 'järjestelmää',
            count_one: 'järjestelmä',
            type_internal: 'Sisäinen',
            type_external: 'Ulkoinen',
            type_cloud_service: 'Pilvipalvelu',
            type_on_premise: 'Paikallinen',
            type_hybrid: 'Hybridi',
            status_active: 'Aktiivinen',
            status_decommissioning: 'Käytöstäpoistossa',
            status_decommissioned: 'Poistettu Käytöstä',
            status_planned: 'Suunniteltu',
            dpa_not_required: 'Ei Vaadittu',
            dpa_required_missing: 'Vaadittu Puuttuu',
            dpa_in_progress: 'Käynnissä',
            dpa_signed: 'Allekirjoitettu',
            all_criticalities: 'Kaikki Kriittisyystasot',
        },
        categories: {
            title: 'Tietokategoriat',
            new: 'Uusi kategoria',
            edit: 'Muokkaa kategoriaa',
            name: 'Nimi',
            sensitivity: 'Arkaluonteisuus',
            tags: 'Tunnisteet',
            used_in: 'Käytössä',
            examples: 'Esimerkit',
            examples_hint: 'Esimerkit (pilkulla erotettu)',
            default: 'Oletus',
            all_sensitivities: 'Kaikki Arkaluonteisuustasot',
            all_statuses: 'Kaikki tilat',
            no_categories: 'Kategorioita ei löytynyt',
            confirm_delete: 'Poista kategoria "{name}"?',
            count: 'kategoriaa',
            count_one: 'kategoria',
            status_draft: 'Luonnos',
            status_proposed: 'Ehdotettu',
            status_under_review: 'Tarkistettavana',
            status_approved: 'Hyväksytty',
            status_deprecated: 'Vanhentunut',
            status_updated: 'Kategorian tila päivitetty',
            propose: 'Ehdota',
            approve: 'Hyväksy',
            deprecate: 'Vanhenna',
        },
        purposes: {
            title: 'Käsittelyn tarkoitukset',
            new: 'Uusi tarkoitus',
            edit: 'Muokkaa tarkoitusta',
            name: 'Nimi',
            legal_basis: 'Oikeusperuste',
            retention_period: 'Säilytysaika (päiviä)',
            justification: 'Oikeutetun edun perustelu',
            legal_basis_detail: 'Oikeusperusteen Yksityiskohdat',
            all_legal_bases: 'Kaikki Oikeusperusteet',
            no_purposes: 'Tarkoituksia ei löytynyt',
            confirm_delete: 'Poista "{name}"?',
            default: 'Oletus',
            count: '{count} tarkoitusta',
            count_one: '{count} tarkoitus',
            basis_consent: 'Suostumus',
            basis_contract: 'Sopimus',
            basis_legal_obligation: 'Lakisääteinen Velvoite',
            basis_vital_interest: 'Elintärkeä Etu',
            basis_public_interest: 'Yleinen Etu',
            basis_legitimate_interest: 'Oikeutettu Etu',
        },
        retention: {
            title: 'Säilytyskäytännöt',
            new: 'Uusi käytäntö',
            edit: 'Muokkaa käytäntöä',
            name: 'Nimi',
            retention_days: 'Säilytyspäivät',
            disposal_method: 'Hävitystapa',
            data_categories: 'Tietokategoriat',
            activities: 'Toimet',
            review_frequency: 'Tarkistustiheys',
            review_frequency_days: 'Tarkistustiheys (päiviä)',
            no_policies: 'Säilytyskäytäntöjä ei löytynyt',
            confirm_delete: 'Poista "{name}"?',
            count: '{count} käytäntöä',
            count_one: '{count} käytäntö',
            days: 'päivää',
            disposal_deletion: 'Poisto',
            disposal_anonymization: 'Anonymisointi',
            disposal_archival: 'Arkistointi',
            review_overdue: 'Tarkistus myöhässä',
            review_status: 'Tarkistuksen tila',
            review_ok: 'Aikataulussa',
            department: 'Osasto',
            all_departments: 'Kaikki osastot',
        },
        flows: {
            view_tabs_aria: 'Flows-näkymä',
            view_list: 'Luettelo',
            view_map: 'Kartta',
            title: 'Tietovirrat',
            new: 'Uusi tietovirta',
            edit: 'Muokkaa tietovirtaa',
            name: 'Nimi',
            from_system: 'Lähdejärjestelmä',
            to_system: 'Kohdejärjestelmä',
            flow_type: 'Tietovirran tyyppi',
            cross_border: 'Rajat ylittävä',
            risk_level: 'Riskitaso',
            mechanism: 'Mekanismi',
            transfer_mechanism: 'Siirtomekanismi',
            frequency: 'Tiheys',
            source_country: 'Lähtömaa',
            destination_country: 'Kohdemaa',
            transfer_safeguard: 'Siirron Suojatoimi',
            all_risk_levels: 'Kaikki Riskitasot',
            no_flows: 'Tietovirtoja ei löytynyt',
            confirm_archive: 'Arkistoi "{name}"?',
            count: '{count} tietovirtaa',
            count_one: '{count} tietovirta',
            status_active: 'Aktiivinen',
            status_inactive: 'Ei Aktiivinen',
            status_under_review: 'Tarkistettavana',
            mechanism_api: 'API',
            mechanism_file_transfer: 'Tiedostonsiirto',
            mechanism_database_replication: 'Tietokantareplikointi',
            mechanism_manual: 'Manuaalinen',
            mechanism_email: 'Sähköposti',
            mechanism_other: 'Muu',
            frequency_real_time: 'Reaaliaikainen',
            frequency_hourly: 'Tunneittain',
            frequency_daily: 'Päivittäin',
            frequency_weekly: 'Viikoittain',
            frequency_monthly: 'Kuukausittain',
            frequency_on_demand: 'Pyynnöstä',
            frequency_one_time: 'Kertaluonteinen',
            safeguard_adequacy_decision: 'Vastaavuuspäätös',
            safeguard_standard_contractual_clauses: 'Vakiosopimuslausekkeet',
            safeguard_binding_corporate_rules: 'Sitovat Yrityssäännöt',
            safeguard_explicit_consent: 'Nimenomainen Suostumus',
            safeguard_legal_obligation: 'Lakisääteinen Velvoite',
            safeguard_none: 'Ei Mitään',
            safeguard_other: 'Muu',
        },
        activities: {
            title: 'Käsittelytoimet',
            new: 'Uusi käsittelytoimi',
            edit: 'Muokkaa käsittelytoimea',
            activity_title: 'Otsikko',
            category: 'Kategoria',
            legal_basis: 'Oikeusperuste',
            dpa_required: 'HTS vaaditaan',
            ropa_generated: 'Seloste luotu',
            version: 'Versio',
            generate_ropa: 'Luo seloste',
            controller: 'Rekisterinpitäjä',
            controller_name: 'Rekisterinpitäjän Nimi',
            controller_contact: 'Rekisterinpitäjän Yhteystieto',
            legal_basis_detail: 'Oikeusperusteen Yksityiskohdat',
            organization_info: 'Organisaatiotiedot (Liite I)',
            org_address: 'Organisaation osoite',
            tax_code: 'Verokoodi',
            contact_person: 'Yhteyshenkilö',
            contact_email: 'Sähköpostiosoite',
            contact_phone: 'Puhelinnumero',
            select_entity: 'Valitse…',
            no_entities: 'Kohteita ei löytynyt',
            dpo_name: 'DPO:n Nimi',
            dpo_contact: 'DPO:n Yhteystieto',
            processor_name: 'Käsittelijän Nimi',
            processor_contact: 'Käsittelijän Yhteystieto',
            data_subjects: 'Rekisteröidyt',
            data_subjects_hint: 'Rekisteröidyt (pilkulla erotettu)',
            recipients: 'Vastaanottajat',
            recipients_hint: 'Vastaanottajat (pilkulla erotettu)',
            security_measures: 'Turvatoimet',
            dpia_reference: 'DPIA-viite',
            no_activities: 'Käsittelytoimia ei löytynyt',
            confirm_archive: 'Arkistoi "{name}"?',
            count: '{count} käsittelytoimea',
            count_one: '{count} käsittelytoimi',
            ropa_success: 'Seloste luotu. Siirry Vienteihin ladataksesi sen.',
            ropa_error: 'Selosteen luonti epäonnistui',
            required_label: 'Vaaditaan',
            status_draft: 'Luonnos',
            status_active: 'Aktiivinen',
            status_under_review: 'Tarkistettavana',
            status_archived: 'Arkistoitu',
            decree_165_heading: 'Asetuksen 165 tietotaso (Vietnamin tietolaki)',
            decree_165_helper: 'Luokittele tämän toiminnan käsittelemät tiedot Vietnamin asetuksen 165 mukaisesti. Säännölliset tiedot saavat rajat ylittävän perusjärjestelmän; tärkeät ja keskeiset tiedot aiheuttavat lisävelvoitteita.',
            data_tier_label: 'Datataso',
            data_tier_help: 'Asetus 165 luokittelee tiedot tavallisiksi, tärkeiksi tai keskeisiksi – katso ohjeita ohjeartikkelista.',
            data_tier_column_header: 'Datataso',
            data_tier_regular: 'Säännöllinen',
            data_tier_important: 'Tärkeää',
            data_tier_core: 'Core',
            transfer_mechanism_label: 'Rajat ylittävä siirtomekanismi',
            transfer_mechanism_placeholder: 'esim. Vakiosopimuslausekkeet, riittävyyttä koskeva päätös',
            security_assessment_reference_label: 'Turvallisuusarvioinnin viite',
            security_assessment_reference_placeholder: 'esim. [[TOK_0]]-SA-2026-001',
        },
        evidence: {
            title: 'Todistusaineistoholvi',
            new: 'Uusi todistusaineisto',
            edit: 'Muokkaa todistusaineistoa',
            name: 'Nimi',
            evidence_type: 'Todistusaineiston tyyppi',
            linked_entities: 'Linkitetyt kohteet',
            uploaded: 'Ladattu',
            expiry: 'Vanheneminen',
            file_url: 'Tiedoston URL',
            source_mode_label: 'Todistelähde',
            source_mode_file: 'Lähetä tiedosto',
            source_mode_url: 'Linkitä ulkoinen URL',
            attachment_label: 'Liite',
            link_to: 'Linkitä todistusaineistoon',
            entity_type: 'Kohteen tyyppi',
            entity_id: 'Kohteen tunnus',
            no_evidence: 'Todistusaineistoa ei löytynyt',
            manage_links: 'Hallinnoi linkkejä',
            unlink: 'Poista linkitys',
            confirm_delete: 'Poista todistusaineisto "{name}"?',
            count: '{count} kohdetta',
            count_one: '{count} kohde',
            type_document: 'Asiakirja',
            type_screenshot: 'Kuvakaappaus',
            type_policy: 'Käytäntö',
            type_contract: 'Sopimus',
            type_assessment: 'Arviointi',
            type_correspondence: 'Kirjeenvaihto',
            type_other: 'Muu',
            linked_type_system: 'Järjestelmä',
            linked_type_data_flow: 'Tietovirta',
            linked_type_processing_activity: 'Käsittelytoiminto',
            linked_type_data_category: 'Tietoluokka',
            linked_type_purpose: 'Tarkoitus',
            linked_type_retention_policy: 'Säilytyskäytäntö',
            link_entity: 'Linkki entiteettiin',
            link_success: 'Entiteetti linkitetty onnistuneesti',
            confirm_unlink: 'Haluatko varmasti poistaa tämän kokonaisuuden linkityksen?',
            unlink_success: 'Kokonaisuuden linkityksen poistaminen onnistui',
            no_linked_entities: 'Ei linkitettyjä kokonaisuuksia',
            select_entity: 'Valitse…',
            no_entities: 'Ei kohteita',
        },
        exports: {
            title: 'Tietojen viennit',
            recent: 'Viimeisimmät viennit',
            export_type: 'Viennin tyyppi',
            format: 'Muoto',
            requested_by: 'Pyytäjä',
            requested_at: 'Pyydetty',
            download: 'Lataa',
            csv_export: 'CSV-vienti',
            csv_description: 'Lataa tiedot CSV-muodossa taulukkolaskenta-analyysia varten.',
            pdf_reports: 'PDF-raportit',
            pdf_description: 'Luo muotoiltuja raportteja vaatimustenmukaisuusdokumentaatiota varten.',
            csv_systems: 'Järjestelmärekisteri',
            csv_categories: 'Tietokategoriat',
            csv_flows: 'Tietovirrat',
            csv_activities: 'Käsittelytoimet',
            csv_cross_border: 'Rajat Ylittävät Tietovirrat',
            csv_retention_policies: 'Säilytyskäytännöt',
            csv_evidence: 'Todisteet',
            csv_governance_assignments: 'Hallintotehtävät',
            pdf_ropa: 'Seloste',
            pdf_systems: 'Järjestelmäraportti',
            pdf_cross_border: 'Rajat Ylittävien Raportti',
            pdf_flow_map: 'Tietovirtakartan Data',
            export_failed: 'Vienti epäonnistui',
            pdf_generated: 'PDF luotu onnistuneesti.',
            ropa: 'RoPA-rekisteröinti',
            retention_policies: 'Säilytyskäytännöt',
            governance_assignments: 'Hallintotehtävät',
            col_entity: 'Vie kokonaisuus',
            col_description: 'Kuvaus',
            desc_ropa: 'Täydellinen ROPA-rekisteri kaikista käsittelytoimista, joilla on oikeusperusta, [TOK_0]] tila ja valvonta.',
            desc_systems: 'Järjestelmäluettelo, jossa on omistaja, tietoluokkatunnisteet ja vaatimustenmukaisuustila.',
            desc_activities: 'Yksittäiset käsittelytoimet rekisterinpitäjän, oikeusperustan ja [[TOK_0]] luokituksen kanssa.',
            desc_categories: 'Luokittelussa ja tarkastuksissa käytetyt tietoluokat ja herkkyystasot.',
            desc_purposes: 'Käsittelytarkoitukset oikeusperustaisin viittauksin asetuksen 13/2023 ja telelain 2023 mukaisesti.',
            desc_flows: 'Tietovirrat järjestelmien välillä, mukaan lukien sisäiset ja rajat ylittävät reitit.',
            desc_cross_border: 'Vain rajat ylittävät virrat siirtomekanismin ja riskinarvioinnin kanssa.',
            desc_retention_policies: 'Säilytyskäytännöt, hävitysmenetelmät ja tarkistustahti.',
            desc_evidence: 'Käsittelytoimiin liitetyt todisteet: todistukset, tietosuojasopimukset, [[TOK_0]]-raportit.',
            desc_governance_assignments: 'Hallintotoimeksiannot: omistajat, hyväksyjät ja ISO 27001 -viitteet.',
            unified_heading: 'Vie kokonaisuudet',
            unified_description: 'Vie mikä tahansa datakartoituskokonaisuus muodossa [[TOK_0]], [[TOK_3]], [[TOK_2]] tai [[TOK_1]]. Kaikki viennit tallennetaan tiedostoselaimeen.',
            export_button_label: 'Vie',
            csv_download_success: 'CSV ladattu onnistuneesti.',
        },
        attestation: {
            title: 'Todennusjaksot',
            create: 'Uusi jakso',
            name: 'Jakson nimi',
            year: 'Vuosi',
            deadline: 'Määräaika',
            scope: 'Laajuus',
            status: 'Tila',
            tasks: 'Osastotehtävät',
            assign_tasks: 'Määritä tehtävät',
            department: 'Osasto',
            assignee: 'Vastuuhenkilö',
            progress: 'Edistyminen',
            stale_entries: 'Vanhentuneet merkinnät',
            detect_stale: 'Tunnista vanhentuneet',
            export_bundle: 'Vie paketti',
            no_cycles: 'Ei todennusjaksoja vielä.',
            create_success: 'Todennusjakso luotu.',
            assign_success: 'Tehtävät määritetty.',
            complete_success: 'Tehtävä valmis.',
            stale_detected: 'Vanhentuneita merkintöjä havaittu.',
            stale_systems: 'Vanhentuneet järjestelmät',
            stale_flows: 'Vanhentuneet tietovirrat',
            no_stale: 'Vanhentuneita merkintöjä ei havaittu.',
            stale_name: 'Nimi',
            stale_announcement: 'Löydettiin {0} vanhentunutta järjestelmää ja {1} vanhentunutta tietovirtaa',
            last_updated: 'Viimeksi päivitetty',
            status_draft: 'Luonnos',
            status_active: 'Aktiivinen',
            status_completed: 'Valmis',
            task_status_pending: 'Odottaa',
            task_status_in_progress: 'Käynnissä',
            task_status_completed: 'Valmis',
            scope_systems: 'Järjestelmät',
            scope_flows: 'Tietovirrat',
            scope_activities: 'Aktiviteetit',
            scope_categories: 'Kategoriat',
            scope_purposes: 'Tarkoitukset',
            scope_retention: 'Säilytys',
        },
        governance: {
            title: 'Hallintomääritykset',
            assign: 'Määritä omistajuus',
            entity_type: 'Kohdetyyppi',
            entity: 'Kohde',
            role: 'Rooli',
            assigned_by: 'Määrittäjä',
            assigned_at: 'Määritetty',
            remove: 'Poista',
            no_assignments: 'Ei hallintomäärityksiä.',
            assign_success: 'Omistajuus määritetty.',
            remove_success: 'Määritys poistettu.',
            assignee: 'Vastuuhenkilö',
            department: 'Osasto',
            all_departments: 'Kaikki osastot',
            roles: {
                data_owner: 'Tiedon omistaja',
                data_steward: 'Tiedon hallinnoija',
                data_custodian: 'Tiedon säilyttäjä',
                informed: 'Tiedotettu',
            },
            entity_types: {
                system: 'Järjestelmä',
                flow: 'Tietovirta',
                activity: 'Aktiviteetti',
                category: 'Kategoria',
                purpose: 'Tarkoitus',
                retention_policy: 'Säilytyskäytäntö',
            },
        },
        risk_assessment: {
            title: 'Riskinarviointi',
            create: 'Uusi arviointi',
            safeguard_type: 'Suojatyyppi',
            adequacy_status: 'Riittävyys',
            risk_factors: 'Riskitekijät',
            mitigations: 'Toimenpiteet',
            reviewer: 'Arvioija',
            decision: 'Päätös',
            approve: 'Hyväksy',
            reject: 'Hylkää',
            no_assessments: 'Ei riskinarviointeja.',
            create_success: 'Riskinarviointi luotu.',
            approve_success: 'Arviointi hyväksytty.',
            reject_success: 'Arviointi hylätty.',
            one_per_line: 'Yksi per rivi',
            safeguard_adequacy_decision: 'Riittävyyspäätös',
            safeguard_standard_contractual_clauses: 'Vakiosopimuslausekkeet',
            safeguard_binding_corporate_rules: 'Sitovat yrityssäännöt',
            safeguard_explicit_consent: 'Nimenomainen suostumus',
            safeguard_legal_obligation: 'Lakisääteinen velvoite',
            safeguard_none: 'Ei mitään',
            safeguard_other: 'Muu',
            adequacy_adequate: 'Riittävä',
            adequacy_inadequate: 'Riittämätön',
            adequacy_under_review: 'Arvioitavana',
            adequacy_not_assessed: 'Ei arvioitu',
            decision_approved: 'Hyväksytty',
            decision_rejected: 'Hylätty',
        },
        review: {
            title: 'Tarkistustehtävät',
            description: 'Tarkistustehtävät luodaan automaattisesti, kun datakategoria ehdotetaan. Luo uusi tehtävä siirtymällä Datakategorioihin ja napsauttamalla Ehdota luonnoskategoriassa.',
            count: 'tarkistustehtävää',
            summary: 'Tarkistuksen yhteenveto',
            pending: 'Odottaa',
            resolved_today: 'Ratkaistu tänään',
            escalated: 'Eskaloitu',
            overdue: 'Myöhässä (>5 päivää)',
            all_statuses: 'Kaikki tilat',
            status_pending: 'Odottaa',
            status_resolved: 'Ratkaistu',
            status_escalated: 'Eskaloitu',
            category_name: 'Kategoria',
            system_name: 'Järjestelmä',
            owner: 'Omistaja',
            resolve: 'Ratkaise',
            resolve_task: 'Ratkaise tarkistustehtävä',
            resolution: 'Ratkaisu',
            resolution_approve: 'Hyväksy',
            resolution_modify: 'Muokkaa ja hyväksy',
            resolution_reject: 'Hylkää',
            resolution_escalate: 'Eskaloi',
            notes: 'Ratkaisun huomautukset',
            notes_required: 'Huomautukset vaaditaan (vähintään 10 merkkiä) Muokkaa, Hylkää tai Eskaloi -toiminnoille',
            resolved_success: 'Tarkistustehtävä ratkaistu',
            bulk_approve: 'Joukkohyväksyntä',
            bulk_reject: 'Joukkohylkäys',
            bulk_success: '{count} tehtävää käsitelty',
            no_tasks: 'Tarkistustehtäviä ei löytynyt',
        },
        inventory: {
            title: 'Luokittelun inventaario',
            count: 'järjestelmää',
            summary: 'Inventaarion yhteenveto',
            total_systems: 'Järjestelmiä yhteensä',
            total_labels: 'Tunnisteita yhteensä',
            system_name: 'Järjestelmä',
            label_count: 'Tunnisteet',
            approved_count: 'Hyväksytty',
            pending_count: 'Odottaa',
            no_items: 'Inventaarion kohteita ei löytynyt',
        },
        exceptions: {
            title: 'Luokittelun poikkeukset',
            count: 'poikkeusta',
            all_severities: 'Kaikki vakavuustasot',
            all_statuses: 'Kaikki tilat',
            system_name: 'Järjestelmä',
            severity_label: 'Vakavuus',
            status_open: 'Avoin',
            status_resolved: 'Ratkaistu',
            status_accepted_risk: 'Hyväksytty riski',
            resolve: 'Ratkaise',
            resolve_exception: 'Ratkaise poikkeus',
            resolution_type: 'Ratkaisutyyppi',
            notes: 'Huomautukset',
            justification_required: 'Perustelu vaaditaan (vähintään 10 merkkiä) hyväksytylle riskille',
            resolved_success: 'Poikkeus ratkaistu',
            no_exceptions: 'Poikkeuksia ei löytynyt',
        },
        history: {
            title: 'Luokittelun historia',
            count: 'tapahtumaa',
            actor: 'Toimija',
            action: 'Toiminto',
            entity_type: 'Entiteetin tyyppi',
            changes: 'Muutokset',
            view_lineage: 'Näytä alkuperä',
            lineage_title: 'Luokittelun alkuperä',
            no_events: 'Historiatietoja ei löytynyt',
            no_lineage: 'Alkuperätietoja ei saatavilla',
            modified: 'Muokattu',
            created: 'Luotu',
            removed: 'Poistettu',
            action_created: 'Luotu',
            action_updated: 'Päivitetty',
            action_archived: 'Arkistoitu',
            action_approved: 'Hyväksytty',
            action_deprecated: 'Vanhentunut',
            entity_label: 'Tunniste',
            entity_taxonomy: 'Taksonomia',
            entity_review_task: 'Tarkistustehtävä',
            entity_exception: 'Poikkeus',
            before: 'Ennen',
            after: 'Jälkeen',
        },
    },
    governance: {
        audit_trail_title: 'Hallinnan auditointiloki',
        audit_trail_subtitle: 'Poikkileikkaava auditointivirta hallinnan toimenpiteille: hyväksynnät, playbook-suoritukset, todistelinkit ja lisää.',
        audit_trail_item_count: 'auditointitapahtumaa',
        audit_trail_fetch_error: 'Auditointitapahtumien haku epäonnistui.',
        audit_trail_no_events: 'Nykyisillä suodattimilla ei löytynyt auditointitapahtumia.',
        audit_trail_entity_type: 'Entiteettityyppi',
        audit_trail_entity_id: 'Entiteetin tunnus',
        audit_trail_action: 'Toimenpide',
        audit_trail_actor: 'Toimija',
        audit_trail_timestamp: 'Aikaleima',
        audit_trail_date_from: 'Alkaen',
        audit_trail_date_to: 'Päättyen',
        audit_trail_no_rows_to_export: 'Ei vietäviä rivejä.',
        nav: {
            vendors: 'Toimittajat',
            subprocessors: 'Alikäsittelijät',
            cross_border: 'Rajat ylittävä',
            drift: 'Poikkeamavalvonta',
            scores: 'Vaatimustenmukaisuuspisteet',
            playbooks: 'Toimintaohjeet',
            approvals: 'Hyväksynnät',
            audit_trail: 'Auditointiloki',
            board_report: 'Hallitusraportti',
            evidence: 'Todistusaineisto',
            onboarding: 'Käyttöönottoprosessi',
            dpa_reviews: 'DPA-katselmukset',
            periodic_reviews: 'Määräaikaiskatselmukset',
            offboarding: 'Käytöstäpoisto',
        },
        vendors: {
            title: 'Toimittajarekisteri',
            new: 'Uusi toimittaja',
            edit: 'Muokkaa toimittajaa',
            name: 'Nimi',
            jurisdiction: 'Lainkäyttöalue',
            dpa_status: 'HTS-tila',
            risk_level: 'Riskitaso',
            onboarding_status: 'Käyttöönoton tila',
            contact_email: 'Yhteyshenkilön sähköposti',
            contact_name: 'Yhteyshenkilön nimi',
            contact_phone: 'Yhteyshenkilön puhelin',
            website: 'Verkkosivusto',
            services_csv: 'Palvelut (pilkulla erotettu)',
            country: 'Maa',
            country_placeholder: 'esim. FI',
            last_reviewed: 'Viimeksi Tarkistettu',
            offboard: 'Lopeta',
            offboard_vendor: 'Lopeta Toimittaja',
            offboard_reason: 'Lopetuksen syy',
            no_vendors: 'Toimittajia ei löytynyt',
            vendor_count: '{count} toimittaja(a)',
            all_dpa_status: 'Kaikki DPA-tilat',
            all_risk_levels: 'Kaikki Riskitasot',
            all_onboarding: 'Kaikki Käyttöönoton Tilat',
            fetch_error: 'Epäonnistui. Yritä uudelleen.',
            save_error: 'Toimittajan tallennus epäonnistui',
            offboard_error: 'Lopetus epäonnistui',
        },
        vendor_types: {
            processor: 'Tietojenkäsittelijä',
            sub_processor: 'Alikäsittelijä',
            controller: 'Rekisterinpitäjä',
            joint_controller: 'Yhteisrekisterinpitäjä',
        },
        onboarding_statuses: {
            pending_review: 'Odottaa Tarkistusta',
            approved: 'Hyväksytty',
            active: 'Aktiivinen',
            suspended: 'Keskeytetty',
            offboarded: 'Lopetettu',
        },
        dpa_statuses: {
            not_required: 'Ei Vaadittu',
            required_missing: 'Vaadittu Puuttuu',
            draft: 'Luonnos',
            under_review: 'Tarkistettavana',
            signed: 'Allekirjoitettu',
            expired: 'Vanhentunut',
        },
        risk_levels: {
            critical: 'Kriittinen',
            high: 'Korkea',
            medium: 'Keskitaso',
            low: 'Matala',
        },
        approval_statuses: {
            pending: 'Odottaa',
            approved: 'Hyväksytty',
            rejected: 'Hylätty',
            expired: 'Vanhentunut',
        },
        approval_action_types: {
            vendor_onboarding: 'Toimittajan Käyttöönotto',
            vendor_offboarding: 'Toimittajan Lopetus',
            cross_border_acceptance: 'Rajat Ylittävä Hyväksyntä',
            playbook_activation: 'Playbook-aktivointi',
            drift_accept_risk: 'Poikkeama Hyväksytty Riski',
            activity_activation: 'Toiminnan Aktivointi',
        },
        drift_check_types: {
            dpa_expiry: 'DPA-vanheneminen',
            dpa_missing: 'DPA Puuttuu',
            review_overdue: 'Tarkistus Myöhässä',
            cross_border_gap: 'Rajat Ylittävä Puute',
            sub_processor_chain: 'Alikäsittelijäketju',
            risk_assessment_overdue: 'Riskinarviointi Myöhässä',
            retention_policy_missing: 'Säilytyskäytäntö Puuttuu',
            evidence_expiring: 'Todistusaineisto Vanhenemassa',
        },
        drift_statuses: {
            open: 'Avoin',
            acknowledged: 'Vahvistettu',
            in_progress: 'Käynnissä',
            resolved: 'Ratkaistu',
            accepted_risk: 'Hyväksytty Riski',
        },
        drift_entity_types: {
            vendor: 'Toimittaja',
            system: 'Järjestelmä',
            data_flow: 'Tietovirta',
            processing_activity: 'Käsittelytoiminta',
            evidence_item: 'Todistusaineisto',
        },
        playbook_statuses: {
            draft: 'Luonnos',
            active: 'Aktiivinen',
            archived: 'Arkistoitu',
        },
        playbook_action_types: {
            delete_data: 'Poista Tiedot',
            verify_deletion: 'Vahvista Poisto',
            notify_vendor: 'Ilmoita Toimittajalle',
            confirm_receipt: 'Vahvista Vastaanotto',
            document_evidence: 'Dokumentoi',
            other: 'Muu',
        },
        playbook_target_types: {
            system: 'Järjestelmä',
            vendor: 'Toimittaja',
        },
        dpa_chain_statuses: {
            complete: 'Valmis',
            incomplete: 'Puutteellinen',
            unknown: 'Tuntematon',
        },
        sub_processor_statuses: {
            active: 'Aktiivinen',
            terminated: 'Lopetettu',
        },
        evidence_types: {
            dpa_agreement: 'DPA-sopimus',
            risk_assessment: 'Riskinarviointi',
            audit_report: 'Tarkastusraportti',
            certification: 'Sertifiointi',
            deletion_confirmation: 'Poistonvahvistus',
            training_record: 'Koulutuskirjaus',
            incident_report: 'Tapahtumaraportti',
            document: 'Asiakirja',
            screenshot: 'Kuvakaappaus',
            policy: 'Käytäntö',
            contract: 'Sopimus',
            assessment: 'Arviointi',
            correspondence: 'Kirjeenvaihto',
            other: 'Muu',
        },
        linkable_entity_types: {
            vendor: 'Toimittaja',
            transfer_mechanism: 'Siirtomekanismi',
            playbook: 'Toimintasuunnitelma',
            execution: 'Suoritus',
            system: 'Järjestelmä',
            activity: 'Toiminta',
        },
        subprocessors: {
            title: 'Alikäsittelijäsuhteet',
            new: 'Uusi linkki',
            vendor: 'Toimittaja',
            subprocessor: 'Alikäsittelijä',
            relationship_type: 'Suhteen tyyppi',
            countries: 'Maat',
            countries_csv: 'Maat (pilkulla erotettu)',
            dpa_chain: 'DPA-ketju',
            dpa_chain_status: 'DPA-ketjun tila',
            no_processors: 'Käsittelijöitä ei löytynyt.',
            no_subprocessors: 'Alikäsittelijöitä ei löytynyt.',
            processor_vendor: 'Käsittelijätoimittaja',
            select_processor: 'Valitse Käsittelijä',
            select_vendor: 'Valitse Toimittaja',
            services: 'Palvelut',
            sub_processor_vendor_id: 'Alikäsittelijän Toimittajatunnus',
            terminate: 'Lopeta',
            confirm_terminate: 'Haluatko varmasti lopettaa tämän suhteen?',
            create_error: 'Linkin luonti epäonnistui.',
            fetch_error: 'Alikäsittelijöiden haku epäonnistui.',
            processor: 'Käsittelijä',
            services_csv: 'Palvelut (pilkulla erotettu)',
            terminate_error: 'Lopetus epäonnistui.',
            version_history_heading: 'Aliprosessorin muutoksen versio',
            change_tracking_note: 'Kaikki aliprosessorisuhteen muutokset on versioitu. Jokainen muutos tallentaa kirjausketjun ennen/jälkeen-tilan.',
            history_retention_note: 'Muutoshistoria säilytetään koko tietojen säilytysajan. Tarkista muutoslokit toimittajan tietonäkymän kautta.',
            vendor_risk_cross_view_heading: 'Alikäsittelijärekisteri (Vendor Risk)',
            vendor_risk_cross_view_source: 'Lähde: Vendor Risk -rekisteri',
            vendor_risk_cross_view_empty: 'Ei merkintöjä Vendor Risk -rekisterissä.',
        },
        cross_border: {
            title: 'Rajat ylittävän hallinnan raportti',
            flows: 'Rajat ylittävät tietovirrat',
            transfers: 'Rajat ylittävät siirrot',
            detected_gaps: 'Havaitut puutteet',
            safeguards: 'Suojatoimet',
            cross_border_vendors: 'Rajat Ylittävät Toimittajat',
            destination: 'Kohde',
            no_cross_border_vendors: 'Rajat ylittäviä toimittajia ei löytynyt.',
            no_safeguard: 'Ei suojatoimea',
            processing_locations: 'Käsittelypaikat',
            export_error: 'Raportin vienti epäonnistui.',
            export_pdf: 'Vie PDF',
            export_success: 'Raportti vietiin onnistuneesti.',
            exporting: 'Viedään...',
            fetch_error: 'Rajat ylittävien tietojen haku epäonnistui.',
            source: 'Lähde',
            pdpl_p2_heading: '[[TOK_0]]-P2 rajat ylittävien siirtojen noudattaminen',
            dossier_prep_note: 'Asiakirja-aineiston valmistelu: kokoa vaikutustenarviointi, oikeusperusta ja suoja-asiakirjat ennen arkistointia.',
            filing_tracking_note: 'Arkistoinnin seuranta: seuraa lähetyksen tilaa viranomaiselle (PDPC) alkuperäisestä hakemuksesta hyväksymiseen.',
            supplement_loop_note: 'Täydennyssilmukka: vastaa viranomaisen tietopyyntöihin ja lähetä muutetut asiakirjat tarvittaessa uudelleen.',
            official_forms_note: 'Viralliset lomakkeet: käytä Mau so 01a (hakemus), Mau so 01b (lisätiedot) ja Mau so 09 (siirtovaikutusten arviointi) [[TOK_0]]-P2-säännösten mukaisesti.',
            vendor_search_label: 'Toimittajan haku',
            vendor_search_placeholder: 'Hae toimittajan nimellä…',
            jurisdiction_filter_label: 'Lainkäyttöalue',
            filings_section_heading: 'Rajat ylittävät hakemukset',
            filings_empty: 'Ei ilmoituksia vielä. Luo sellainen aloittaaksesi asiakirjan.',
            filings_create_button: 'Uusi arkistointi',
            filings_table_id: 'Arkistointitunnus',
            filings_table_jurisdiction: 'Toimivalta',
            filings_table_type: 'Lomakkeen tyyppi',
            filings_table_status: 'Tila',
            filings_table_updated: 'Päivitetty',
            filings_table_open: 'Avaa',
            filings_detail_title: 'Rajat ylittävä arkistointi',
            filings_back_to_list: 'Takaisin rajan yli',
            filings_status_heading: 'Elinkaari',
            filings_evidence_heading: 'Todisteet',
            filings_history_heading: 'Kirjausketju',
            filings_field_filing_id: 'Arkistointitunnus',
            filings_field_jurisdiction: 'Toimivalta',
            filings_field_type: 'Lomakkeen tyyppi',
            filings_field_status: 'Tila',
            filings_field_reference: 'Viranomaisen viite',
            filings_field_mps_receipt: '[[TOK_0]] kuitti',
            filings_field_submitted_at: 'Lähetetty klo',
            filings_field_acknowledged_at: 'Hyväksytty klo',
            filings_field_archived_at: 'Arkistoitu klo',
            filings_field_version: 'Versio',
            filings_field_notes: 'Huomautuksia',
            filings_action_advance: 'Ennakkotila',
            filings_action_reject: 'Hylkää',
            filings_action_archive: 'Arkisto',
            filings_action_submit: 'Merkki lähetetty',
            filings_action_acknowledge: 'Mark myönsi',
            filings_action_resume_draft: 'Jatka luonnoksena',
            filings_status_draft: 'Luonnos',
            filings_status_assessed: 'Arvioitu',
            filings_status_pending_review: 'Odottaa tarkistusta',
            filings_status_ready_to_file: 'Valmiina tiedostoon',
            filings_status_submitted: 'Lähetetty',
            filings_status_acknowledged: 'Tunnustettu',
            filings_status_rejected: 'Hylätty',
            filings_status_archived: 'Arkistoitu',
            filings_type_mau_01a: 'Mẫu 01a — Siirtohakemus',
            filings_type_mau_03a: 'Mẫu 03a — Täydennysasiakirja',
            filings_type_mau_09: 'Mẫu 09 — Siirron vaikutusten arviointi',
            filings_new_dialog_title: 'Uusi rajat ylittävä hakemus',
            filings_new_form_jurisdiction: 'Lainkäyttöalue (esim. VN-[[TOK_0]])',
            filings_new_form_type: 'Lomakkeen tyyppi',
            filings_new_form_notes: 'Huomautuksia (valinnainen)',
            filings_new_submit: 'Luo',
            filings_new_cancel: 'Peruuta',
            filings_reason_label: 'Syy',
            filings_reference_label: 'Viranomaisen viitenumero',
            filings_mps_receipt_label: '[[TOK_0]] kuitin viite',
            filings_create_error: 'Tiedoston luominen epäonnistui.',
            filings_create_success: 'Tiedosto luotu.',
            filings_update_error: 'Ilmoituksen päivittäminen epäonnistui.',
            filings_update_success: 'Arkistointi päivitetty.',
            filings_fetch_error: 'Ilmoitusten nouto epäonnistui.',
            filings_archive_confirm: 'Arkistoidaanko tämä tiedosto? Tätä ei voi kumota.',
            filings_status_rejected_detour: 'Hakemus hylättiin tarkastelun jälkeen. Jatka luonnoksena aloittaaksesi kulku uudelleen.',
            recent_exports_heading: 'Viimeaikainen vienti',
            recent_exports_empty: 'Ei vientiä vielä. Luo sellainen napsauttamalla "Vie [[TOK_0]]".',
        },
        drift: {
            title: 'Konfiguraation poikkeamavalvonta',
            drift_type: 'Poikkeaman tyyppi',
            severity: 'Vakavuus',
            detected_at: 'Havaittu',
            resolve: 'Ratkaise',
            all_check_types: 'Kaikki Tarkistustyypit',
            all_entity_types: 'Kaikki Kohdetyypit',
            event_count: 'Tapahtumien Lukumäärä',
            accept_risk: 'Hyväksy Riski',
            acknowledge: 'Vahvista',
            assign_error: 'Määritys epäonnistui.',
            assign_event: 'Määritä',
            assigned: 'Määritetty',
            enter_resolution_notes: 'Syötä ratkaisumuistiinpanot...',
            enter_user_id: 'Syötä käyttäjätunnus...',
            entity: 'Kohde',
            fetch_error: 'Poikkeamatapahtumien haku epäonnistui.',
            no_events: 'Poikkeamatapahtumia ei löytynyt.',
            resolution_notes: 'Ratkaisumuistiinpanot',
            update_status_error: 'Tilan päivitys epäonnistui.',
        },
        scores: {
            title: 'Vaatimustenmukaisuuspisteiden yhteenveto',
            overall: 'Kokonaisvaatimustenmukaisuuspisteet',
            breakdown: 'Pisteet moduuleittain',
            trend: 'Historiallinen trendi',
            module: 'Moduuli',
            score: 'Pisteet',
            grade: 'Arvosana',
            calculated_at: 'Laskettu',
            generate_board_report: 'Luo Hallitusraportti',
            lang_english: 'Englanti',
            lang_vietnamese: 'Vietnam',
            fetch_error: 'Vaatimustenmukaisuuspisteiden haku epäonnistui.',
            generate_report: 'Luo Raportti',
            generating: 'Luodaan...',
            recommendations: 'Suositukset',
            report_error: 'Raportin luonti epäonnistui.',
            factor_owner_assigned: 'Omistaja määritetty',
            factor_data_categories_linked: 'Tietoluokat linkitetty',
            factor_purposes_linked: 'Käyttötarkoitukset linkitetty',
            factor_data_flows_documented: 'Tietovirrat dokumentoitu',
            factor_processing_activity_linked: 'Käsittelytoiminta linkitetty',
            factor_dpa_status: 'DPA-tila',
            factor_retention_policy_linked: 'Säilytyskäytäntö linkitetty',
            factor_last_reviewed: 'Viimeksi tarkistettu kynnysarvon sisällä',
            factor_risk_assessment_current: 'Riskinarviointi ajan tasalla',
            factor_sub_processors_documented: 'Alikäsittelijät dokumentoitu',
            factor_cross_border_safeguards: 'Rajat ylittävät suojatoimet',
            factor_contact_info_complete: 'Yhteystiedot täydelliset',
            factor_onboarding_approved: 'Käyttöönotto hyväksytty',
            factor_avg_system_score: 'Keskimääräinen järjestelmäpistemäärä',
            factor_avg_vendor_score: 'Keskimääräinen toimittajapistemäärä',
            factor_processing_activity_coverage: 'Käsittelytoimintojen kattavuus',
            factor_ropa_completeness: 'RoPA-kattavuus',
            factor_open_drift_events: 'Avoimet poikkeamatapahtumat',
        },
        playbooks: {
            title: 'Poiston toimintaohjeet',
            new: 'Uusi toimintaohje',
            edit: 'Muokkaa toimintaohjetta',
            steps: 'Vaiheet',
            add_step: 'Lisää vaihe',
            remove_step: 'Poista vaihe',
            data_categories_csv: 'Tietokategoriat (pilkulla erotettu)',
            estimated_duration: 'Arvioitu Kesto',
            estimated_duration_label: 'Arvioitu Kesto',
            evidence_description: 'Todistusaineiston Kuvaus',
            no_playbooks: 'Toimintaohjeita ei löytynyt.',
            playbook_count: 'Toimintaohjeiden Lukumäärä',
            requires_evidence: 'Vaatii Todistusaineiston',
            step_label: 'Vaiheen Nimi',
            target_name: 'Kohteen nimi',
            target_type: 'Kohteen Tyyppi',
            action_type: 'Toimintotyyppi',
            archive_error: 'Arkistointi epäonnistui.',
            confirm_archive: 'Haluatko varmasti arkistoida tämän toimintaohjeen?',
            data_categories: 'Tietokategoriat',
            days: 'päivää',
            fetch_error: 'Toimintaohjeiden haku epäonnistui.',
            sla_days: 'SLA (päivää)',
            target_id: 'Kohteen Tunnus',
            template_class_heading: 'Mallin luokitus',
            official: 'Virallinen',
            internal: 'Sisäinen',
            classification: 'Luokittelu',
            official_note: 'Virallinen: sääntelyn edellyttämät mallit, jotka on yhdenmukaistettu [[TOK_1]]-, [[TOK_0]]- tai alakohtaisten vaatimusten kanssa.',
            internal_note: 'Sisäinen: organisaatiokohtaiset menettelyt, joita ei ole johdettu sääntelymalleista.',
            active_executions_heading: 'Aktiiviset ajot',
            no_active_executions: 'Ei aktiivisia ajoja.',
            playbook_label: 'Pelikirja',
            ticket_id_label: 'Tiketti',
            progress_label: 'Edistyminen',
            actions_label: 'Toiminnot',
            view_steps_label: 'Näytä vaiheet',
            execution_detail_title: 'Ajon tiedot',
            playbook_missing: 'Playbookia ei löydy.',
            evidence_required_label: 'Todiste vaaditaan',
            upload_evidence_label: 'Lataa todiste',
            mark_complete_label: 'Merkitse valmiiksi',
            evidence_required_toast: 'Todiste vaaditaan ennen vaiheen valmistumista.',
            evidence_blocking_message: 'Liitä todistetiedosto jatkaaksesi.',
            step_completed_toast: 'Vaihe valmis.',
            executions_fetch_error: 'Ajojen lataus epäonnistui.',
            step_evidence_default_name: 'Ajovaiheen todiste',
            attached_evidence_label: 'Liitetyt todisteet',
        },
        approvals: {
            title: 'Hyväksyntätyönkulut',
            new: 'Uusi hyväksyntä',
            edit: 'Muokkaa hyväksyntää',
            request_type: 'Pyynnön tyyppi',
            requester: 'Pyytäjä',
            approve: 'Hyväksy',
            reject: 'Hylkää',
            justification: 'Perustelu',
            all_action_types: 'Kaikki Toimintotyypit',
            decided_by: 'Päättäjä',
            no_approvals: 'Hyväksyntöjä ei löytynyt.',
            approval_count: 'Hyväksyntöjen Lukumäärä',
            approval_notes_optional: 'Muistiinpanot (valinnainen)',
            approve_error: 'Hyväksyntä epäonnistui.',
            approve_request: 'Hyväksy Pyyntö',
            decision: 'Päätös',
            entity: 'Kohde',
            fetch_error: 'Hyväksyntöjen haku epäonnistui.',
            reject_error: 'Hylkäys epäonnistui.',
            reject_request: 'Hylkää Pyyntö',
            rejection_notes_required: 'Hylkäysmuistiinpanot vaaditaan',
            rejection_notes_required_msg: 'Anna syy hylkäykselle.',
            requested_at: 'Pyydetty',
            multi_step_heading: 'Monivaiheisen hyväksynnän työnkulku',
            legal_review_note: 'Vaihe 1 – Lakitarkastus: Lakimies tarkistaa pyynnön säännösten noudattamisesta.',
            dpo_review_note: 'Vaihe 2 – [[TOK_0]] Tarkista: Tietosuojavastaava vahvistaa tietosuojavaikutukset.',
            management_review_note: 'Vaihe 3 – Johdon kirjautuminen: Ylin johto antaa lopullisen valtuutuksen.',
            supporting_evidence_label: 'Tukitodiste (valinnainen)',
            decision_evidence_name: 'Päätöstodiste',
        },
        evidence: {
            title: 'Hallinnan todistusaineisto',
            new: 'Uusi todistusaineisto',
            link_to: 'Linkitä kohteeseen',
            entity_id_placeholder: 'Kohteen Tunnus',
            file_path_placeholder: '/polku/tiedostoon',
            evidence_label: 'Todistusaineiston Nimi',
            file_path: 'Tiedostopolku',
            source_mode_label: 'Todistelähde',
            source_mode_file: 'Lähetä tiedosto',
            source_mode_url: 'Linkitä ulkoinen URL',
            attachment_label: 'Liite',
            item_count: 'Kohteiden Lukumäärä',
            link_button: 'Linkitä Todistusaineisto',
            confirm_delete: 'Haluatko varmasti poistaa tämän todistusaineiston?',
            enter_entity_id: 'Syötä kohteen tunnus...',
            entity_id: 'Kohteen Tunnus',
            entity_type: 'Kohteen Tyyppi',
            expires: 'Vanhenee',
            expires_at: 'Vanhenee',
            fetch_error: 'Todistusaineiston haku epäonnistui.',
            link_error: 'Todistusaineiston linkitys epäonnistui.',
            no_evidence: 'Todistusaineistoa ei löytynyt.',
            tags_csv: 'Tunnisteet (pilkulla erotettu)',
            uploaded: 'Ladattu',
            url: 'URL',
            framework_tag_heading: 'Framework-taged Evidence',
            framework_tag_note: 'Jokainen todistetietue kaappaa kehyskoodin, näyttelijän ja aikaleiman. Suodata kehyksen mukaan eristääksesi tarkastuksen kannalta merkitykselliset tietueet.',
            framework_code: 'Puitekoodi',
            filter_by_framework: 'Suodata kehyskoodin mukaan...',
            actor: 'näyttelijä',
        },
        certification: {
            not_applicable: 'Ei sovellettavissa',
            not_certified: 'Ei sertifioitu',
            pending: 'Odottaa',
            certified: 'Sertifioitu',
            revoked: 'Peruutettu',
        },
        onboarding_pipeline: {
            title: 'Käyttöönottoprosessi',
            new_workflow: 'Uusi käyttöönottotyönkulku',
            vendor_id: 'Toimittajan tunnus',
            stages: 'Vaiheet',
            current_stage: 'Nykyinen vaihe',
            advance: 'Edistä vaihetta',
            advance_success: 'Vaihe edistetty onnistuneesti',
            workflow_status: 'Työnkulun tila',
            initiated: 'Aloitettu',
            in_progress: 'Käynnissä',
            completed: 'Valmis',
            cancelled: 'Peruutettu',
            no_workflows: 'Käyttöönottotyönkulkuja ei löytynyt',
            stages_placeholder: 'Vaihe 1, Vaihe 2, Vaihe 3',
            assigned_to: 'Vastuuhenkilö',
            notes: 'Muistiinpanot',
            pdpl_lifecycle_heading: '[[TOK_0]] Toimittajan elinkaari – käyttöönotto',
            due_diligence_note: 'Due diligence -vaihe on pakollinen ennen prosessorin käyttöönottoa kohdassa [[TOK_0]]. Tarkista tietojen käsittelyn laajuus, oikeusperusta ja turvallisuustoimenpiteet.',
            contract_review_note: 'Sopimuksen tarkastelun on vahvistettava DPA-lausekkeet, tietojen säilytysrajat ja alikäsittelijän rajoitukset.',
            create_dpa_review_cta: 'Luo DPA-arviointi',
            dpa_review_linked: 'DPA-arviointi linkitetty',
        },
        dpa_review: {
            title: 'DPA-katselmukset',
            new_review: 'Uusi DPA-katselmus',
            review_type: 'Katselmuksen tyyppi',
            findings: 'Havainnot',
            outcome: 'Lopputulos',
            complete_review: 'Suorita katselmus',
            complete_success: 'Katselmus suoritettu onnistuneesti',
            link_assessment: 'Linkitä turvallisuusarviointi',
            link_success: 'Arviointi linkitetty onnistuneesti',
            assessment_id: 'Arvioinnin tunnus',
            combined_title: 'Yhdistetty arviointi',
            no_reviews: 'DPA-katselmuksia ei löytynyt',
            telecom_disclosure_heading: 'Telecomin tietojen julkistamisen hallinto',
            disclosure_trigger_note: 'Tietojen paljastamiseen perustuvat arvostelut tallentavat televiestintätilaajien tietojen jakamistapahtumat VN Telecom -lain mukaisesti.',
            telecom_t2_note: 'TELECOM-T2-tason hyväksyntä vaaditaan ennen tilaajatietojen luovuttamista viranomaisille.',
            quarterly_log_note: 'Käytä neljännesvuosittaista lokia dokumentoidaksesi kaikki ilmoitustapahtumat ja ylläpitääksesi jatkuvaa kirjausketjua.',
        },
        periodic_review: {
            title: 'Määräaikaiskatselmukset',
            new_review: 'Uusi määräaikaiskatselmus',
            review_type: 'Katselmuksen tyyppi',
            due_date: 'Eräpäivä',
            next_review: 'Seuraava katselmuspäivä',
            trigger_reassessment: 'Käynnistä uudelleenarviointi',
            reassessment_reason: 'Uudelleenarvioinnin syy',
            reassessment_success: 'Uudelleenarviointi käynnistetty onnistuneesti',
            complete_success: 'Katselmus suoritettu onnistuneesti',
            scheduled: 'Ajoitettu',
            in_progress: 'Käynnissä',
            completed: 'Valmis',
            overdue: 'Myöhässä',
            material_change: 'Olennainen muutos',
            no_reviews: 'Määräaikaiskatselmuksia ei löytynyt',
            mark_complete: 'Merkitse valmiiksi',
            pdpl_periodic_heading: '[[TOK_0]] Toimittajan elinkaari — määräaikaistarkistukset',
            scheduled_review_note: 'Säännölliset tarkastukset on ajoitettava vähintään kerran vuodessa kaikille aktiivisille prosessoreille. Myöhästyneet tarkastukset laukaisevat vaatimustenmukaisuusvaroitukset.',
            material_change_note: 'Olennaiset muutokset tietojenkäsittelyssä vaativat välitöntä uudelleenarviointia aikataulusta riippumatta.',
            overdue_badge: 'Myöhässä',
            overdue_aria: 'Myöhästynyt arviointi',
            only_overdue_filter: 'Vain myöhässä',
        },
        offboarding: {
            title: 'Toimittajan käytöstäpoisto',
            initiate: 'Aloita käytöstäpoisto',
            initiate_success: 'Käytöstäpoisto aloitettu onnistuneesti',
            reason: 'Käytöstäpoiston syy',
            data_return_required: 'Tietojen palautus vaaditaan',
            verify_data: 'Vahvista tietojen palautus',
            verify_success: 'Tietojen palautus vahvistettu onnistuneesti',
            sign_off: 'Hyväksy',
            sign_off_success: 'Käytöstäpoisto hyväksytty onnistuneesti',
            status_initiated: 'Aloitettu',
            status_data_pending: 'Tietojen palautus odottaa',
            status_data_verified: 'Tietojen palautus vahvistettu',
            status_completed: 'Valmis',
            status_cancelled: 'Peruutettu',
            task_id: 'Tehtävätunnus',
            no_tasks: 'Käytöstäpoistotehtäviä ei löytynyt',
            evidence_id: 'Todistusaineiston tunnus',
            pdpl_offboarding_heading: '[[TOK_0]] Toimittajan elinkaari – käytöstä poistaminen ja poistaminen',
            deletion_capture_note: 'Offboardingin on saatava tietojen poistamisen vahvistus toimittajalta. Tarkista tietojen palautus ennen kirjautumista.',
            evidence_attachment_note: 'Liitä poistotodistukset (sertifikaatit, kuvakaappaukset, toimittajan vahvistukset) täydentääksesi offboard-tietueen.',
            verify_mode_label: 'Varmistustapa',
            verify_mode_upload: 'Lähetä uusi tiedosto',
            verify_mode_link: 'Linkitä olemassa oleva todiste',
            verify_mode_none: 'Ei dataa palautettavaksi',
            upload_data_return_evidence: 'Lähetä datan palautustodiste',
            no_data_justification_label: 'Perustelu',
            no_data_justification_placeholder: 'Selitä miksi dataa ei ole palautettavaksi',
            no_data_justification_hint: 'Vähintään 20 merkkiä',
            upload_required_toast: 'Liitä tiedosto jatkaaksesi',
            evidence_link_required_toast: 'Valitse todiste jatkaaksesi',
            no_data_justification_required_toast: 'Anna vähintään 20 merkin perustelu',
            data_return_evidence_name: 'Datan palautustodiste',
        },
        dpa_review_types: {
            initial: 'Alkuperäinen',
            annual: 'Vuosittainen',
            renewal: 'Uusinta',
            incident_triggered: 'Tapahtumalaukaisu',
        },
        periodic_review_types: {
            initial: 'Alkuperäinen',
            annual: 'Vuosittainen',
            renewal: 'Uusinta',
            incident_triggered: 'Tapahtumalaukaisu',
            material_change: 'Olennainen muutos',
            disclosure_triggered: 'Tiedonantolaukaisu',
            quarterly_log: 'Neljännesvuosiraportti',
        },
        dpa_review_statuses: {
            pending: 'Odottaa',
            in_progress: 'Käynnissä',
            completed: 'Valmis',
            cancelled: 'Peruutettu',
        },
        onboarding_stage_names: {
            due_diligence: 'Huolellisuustarkistus',
            contract_review: 'Sopimustarkistus',
            security_assessment: 'Turvallisuusarviointi',
            data_mapping: 'Tietojen kartoitus',
            approval: 'Hyväksyntä',
            integration: 'Integraatio',
        },
        access_denied_title: 'Pääsy estetty',
        access_denied: 'Sinulla ei ole oikeutta tarkastella tätä sivua. Ota yhteyttä järjestelmänvalvojaan.',
    },
    consent: {
        nav: {
            policies: 'Käytännöt',
            purposes: 'Tarkoitusluettelo',
            workflows: 'Työnkulut',
            snapshots: 'CMP-tilannekuvat',
            change_awareness: 'Muutostietoisuus',
            audit: 'Suostumuksen tarkastus',
        },
        gap_analysis: {
            nav_label: 'Aukon analyysi',
            page_title: 'Suostumusvaje-analyysi',
            page_subtitle: 'Forseti tarkistaa aktiivisen suostumuksesi tarkoituksiin asennetun kehyksen vaatimusten ([[TOK_0]] Art.7 + Art.6 + Art.9, [[TOK_1]] Art.13 + Art.20, PIPL Art.13 + Art.29) ja täyttää aukot viittauksella + ehdotetuilla korjaustoimenpiteillä.',
            framework_picker_label: 'Kehykset',
            org_flags_label: 'Organisaation konteksti',
            flag_withdrawal: 'Siinä on dokumentoitu globaali nostomekanismi',
            flag_parental: 'Sisältää vanhempien suostumuksen alle 16-vuotiaille',
            flag_cross_border: 'Rajat ylittävä arkistointi on kirjattu',
            run_label: 'Suorita aukkoanalyysi',
            running_label: 'Juokse…',
            requires_advisor_label: 'Vaatii ai_advisor:chat-luvan.',
            results_heading: 'Aukkoja ilmestyi ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            empty_label: 'Valituissa kehyksissä ei havaittu aukkoja.',
            remediation_label: 'Korjausehdotus:',
            dismiss_label: 'Hylkää soveltumattomana',
            resolve_label: 'Ratkaise',
            dismissed_label: 'Hylätty soveltumattomana',
            resolved_label: 'Ratkaistu',
        },
        import: {
            title: 'Tuo suostumustyönkulkuja',
            nav_title: 'Massatuonti',
            description: 'Lataa CSV-tiedosto suostumustyönkulkujen massatuontia varten.',
            select_file: 'Valitse CSV-tiedosto',
            file_help: 'CSV otsikoineen, jotka vastaavat työnkulkukenttiä.',
            required_columns_help: 'Pakolliset sarakkeet: Työnkulun tyyppi, Rekisteröity, Kanava.',
            file_too_large: 'Tiedosto on liian suuri. Enimmäiskoko on 2 Mt.',
            preview: 'Esikatselu',
            columns_detected: 'Havaitut sarakkeet: {count}',
            column_mapping: 'Sarakemääritys',
            import_button: 'Tuo',
            import_complete: 'Tuonti valmis',
            import_error: 'Tuonti epäonnistui',
            result: 'Tuontitulos',
            total: 'Yhteensä',
            imported: 'Tuotu',
            skipped: 'Ohitettu',
            failed: 'Epäonnistunut',
            errors: 'Virheet',
            error_row: 'Rivi',
            error_field: 'Kenttä',
            error_message: 'Viesti',
            history: 'Tuontihistoria',
            no_history: 'Ei tuontihistoriaa.',
            history_file: 'Tiedostonimi',
            history_date: 'Päivämäärä',
            create_profiles_label: 'Luo Rekisteröidyn profiilit uusille kohteille',
            create_profiles_help: 'Tuonnit ilman vastaavaa profiilia luovat sellaisen automaattisesti. Poista valinta tuodaksesi vain työnkulkuja.',
            profiles_created: 'Luodut profiilit',
            profiles_matched: 'Vastaavat profiilit',
            subject_kind_help: 'Valinnaiset sarakkeet: subject_kind, subject_email, subject_display_name, subject_phone, external_ref_key.',
            error_subject_invalid_email: 'Virheellinen sähköpostiosoite subject_email-sarakkeessa.',
            error_subject_unknown_kind: 'Tuntematon subject_kind-arvo. Odotettu: email, visitor_uuid, employee_id, student_id, external_ref.',
            error_missing_external_ref_key: 'external_ref_key on pakollinen, kun subject_kind=external_ref',
        },
        policies: {
            title: 'Suostumuskäytännöt',
            new: 'Uusi käytäntö',
            edit: 'Muokkaa käytäntöä',
            name: 'Nimi',
            version: 'Versio',
            policy_text: 'Käytännön teksti',
            publish: 'Julkaise',
            versions: 'Versiot',
            hide_versions: 'Piilota versiot',
            submit_for_review: 'Lähetä tarkistettavaksi',
            suspend: 'Keskeytä',
            retire: 'Poista käytöstä',
            jurisdictions: 'Lainkäyttöalueet',
            jurisdictions_csv: 'Lainkäyttöalueet (pilkuin erotetut)',
            approval_mode: 'Hyväksyntätila',
            reviewer_ids: 'Tarkastajien tunnukset (pilkuin erotetut)',
            tags_csv: 'Tunnisteet (pilkuin erotetut)',
            effective_date: 'Voimaantulopäivä',
            review_date: 'Tarkistuspäivä',
            consent_model_statement: 'Suostumusmallin lausunto',
            consent_model_placeholder: 'Valinnainen suostumusmallin lausunto...',
            default_settings: 'Oletusasetukset (JSON)',
            changes: 'Muutokset',
            fetch_error: 'Suostumuskäytäntöjen hakeminen epäonnistui. Yritä uudelleen.',
            save_error: 'Suostumuskäytännön tallentaminen epäonnistui. Yritä uudelleen.',
            submit_review_error: 'Käytännön lähettäminen tarkistettavaksi epäonnistui. Yritä uudelleen.',
            activate_error: 'Käytännön aktivoiminen epäonnistui. Yritä uudelleen.',
            suspend_error: 'Käytännön keskeyttäminen epäonnistui. Yritä uudelleen.',
            retire_error: 'Käytännön käytöstä poistaminen epäonnistui. Yritä uudelleen.',
            submit_review_success: 'Käytäntö lähetetty tarkistettavaksi.',
            activate_success: 'Käytäntö aktivoitu.',
            suspend_success: 'Käytäntö jäädytetty.',
            retire_success: 'Politiikka jäi eläkkeelle.',
            versions_error: 'Käytännön versioiden hakeminen epäonnistui. Yritä uudelleen.',
            invalid_json: 'Virheellinen JSON Oletusasetukset-kentässä. Yritä uudelleen.',
            page_title: 'Suostumuskäytännöt',
            version_updated: 'Päivitetty',
            version_initial: 'Alkuperäinen versio',
            json_format: '[[TOK_0]] muodossa',
            sensitive: 'Herkkä',
            flag_sensitive: 'Lippuherkkä',
            flag_sensitive_title: 'Merkitse käytäntö arkaluonteiseksi',
            require_enhanced_review: 'Edellyttää tehostettua tarkistusta',
            enhanced_review_success: 'Tehostettu tarkistusvaatimus käytössä.',
            select_categories: 'Valitse sovellettavat [[TOK_0]] artiklan 2 mukaiset arkaluontoiset tietoluokat:',
            no_policies: 'Suostumuskäytäntöjä ei löytynyt. Luo ensimmäinen käytäntösi aloittaaksesi.',
            approval_success: 'Käytäntö hyväksytty.',
            reviewers_label: 'Arvioijat',
            enhanced_review_title: 'Laajennettu tarkistus vaaditaan',
            enhanced_review_badge: 'Laajennettu tarkistus vaaditaan',
            enhanced_review_status_pending: 'Tarkistus odottaa',
            enhanced_review_status_approved: 'Tarkistus hyväksytty',
            enhanced_review_status_rejected: 'Tarkistus hylätty',
            enhanced_review_reviewed_by: 'Tarkistanut',
            enhanced_review_notes: 'Tarkistusmuistiinpanot',
            enhanced_review_approve: 'Hyväksy tarkistus',
            enhanced_review_reject: 'Hylkää tarkistus',
            enhanced_review_notes_required: 'Tarkistusmuistiinpanot ovat pakollisia',
            enhanced_review_approved: 'Laajennettu tarkistus hyväksytty',
            enhanced_review_rejected: 'Laajennettu tarkistus hylätty — käytäntö palautettu luonnokseksi',
            enhanced_review_reset_to_draft: 'Laajennettu tarkistus hylätty — käytäntö palautettu luonnokseksi',
            enhanced_review_reject_warning: 'Hylkääminen palauttaa tämän käytännön Luonnos-tilaan. DPO:n on toimitettava se uudelleen tarkistettavaksi ongelmien ratkaisemisen jälkeen.',
            submitted_modal_title: 'Lähetetty laajennettua tarkistusta varten',
            submitted_modal_body: 'Tämä käytäntö on lähetetty. Oikeudellisen/Tietosuoja-arvioijan on hyväksyttävä se ennen kuin se voidaan aktivoida.',
        },
        sensitive_categories: {
            health: 'Terveystiedot',
            biometric: 'Biometriset tiedot',
            political: 'Poliittiset mielipiteet',
            ethnic: 'Etninen alkupera',
            genetic: 'Geneettiset tiedot',
            criminal: 'Rikosrekisterit',
        },
        purposes: {
            title: 'Tarkoitusluettelo',
            new: 'Uusi tarkoitus',
            edit: 'Muokkaa tarkoitusta',
            name: 'Nimi',
            legal_basis: 'Oikeusperuste',
            retention_days: 'Säilytysaika (päiviä)',
            is_active: 'Aktiivinen',
            filter_by_category: 'Suodata kategorian mukaan',
            policy_ids: 'Käytäntötunnukset (pilkuin erotetut)',
            ropa_activity_ids: 'ROPA-toimintatunnukset (pilkuin erotetut)',
            policies: 'Käytännöt',
            deprecate: 'Merkitse vanhentuneeksi',
            fetch_error: 'Suostumustarkoitusten hakeminen epäonnistui. Yritä uudelleen.',
            save_error: 'Suostumustarkoituksen tallentaminen epäonnistui. Yritä uudelleen.',
            deprecate_error: 'Suostumustarkoituksen vanhentaminen epäonnistui. Yritä uudelleen.',
            page_title: 'Tarkoitusluettelo',
            no_purposes: 'Suostumustarkoituksia ei löytynyt. Luo ensimmäinen tarkoituksesi aloittaaksesi.',
            category_personal_data: 'Henkilötiedot',
            category_sensitive_data: 'Arkaluonteiset tiedot',
            category_health_data: 'Terveystiedot',
            category_financial_data: 'Taloustiedot',
            category_biometric_data: 'Biometriset tiedot',
            category_children_data: 'Lasten tiedot',
            category_location_data: 'Sijaintitiedot',
            category_communications_data: 'Viestintätiedot',
            category_other: 'muu',
        },
        workflows: {
            title: 'Suostumuksen työnkulut',
            new: 'Uusi työnkulku',
            edit: 'Muokkaa työnkulkua',
            workflow_type: 'Työnkulun tyyppi',
            user_id: 'Käyttäjätunnus',
            purpose_id: 'Tarkoitustunnus',
            purpose_ids_csv: 'Tarkoitustunnus (pilkuin erotetut)',
            reason: 'Syy',
            process: 'Käsittele',
            data_subject_ref: 'Rekisteröidyn viite',
            data_subject: 'Rekisteröity',
            channel: 'Kanava',
            policy_id: 'Käytäntötunnus',
            scope: 'Laajuus',
            legal_grounds: 'Oikeusperusteet',
            assessment: 'Arviointi',
            select_outcome: 'Valitse tulos',
            partially_approved: 'Osittain hyväksytty',
            denied: 'Evätty',
            outcome_upheld: 'Vahvistettu',
            outcome_pending: 'Odottaa',
            outcome_denied: 'Evätty',
            status_count: 'Tilamäärät',
            channel_filter: 'Suodata kanavalla',
            add_action: '+ Toiminto',
            by_type: 'Tyypin mukaan',
            by_status: 'Tilan mukaan',
            downstream_actions: 'Jatkotoimenpiteet',
            downstream_actions_for: 'Jatkotoimenpiteet kohteelle {subject} ({type})',
            add_downstream_action: 'Lisää jatkotoimenpide',
            assigned_to: 'Vastuuhenkilö',
            fetch_error: 'Suostumuksen työnkulkujen hakeminen epäonnistui. Yritä uudelleen.',
            dashboard_error: 'Työnkulkujen yhteenvedon hakeminen epäonnistui. Yritä uudelleen.',
            save_error: 'Suostumuksen työnkulun tallentaminen epäonnistui. Yritä uudelleen.',
            status_update_error: 'Työnkulun tilan päivittäminen epäonnistui. Yritä uudelleen.',
            assessment_error: 'Työnkulun arvioinnin päivittäminen epäonnistui. Yritä uudelleen.',
            add_action_error: 'Työnkulun toiminnon lisääminen epäonnistui. Yritä uudelleen.',
            update_action_error: 'Työnkulun toiminnon päivittäminen epäonnistui. Yritä uudelleen.',
            type_refusal: 'Kieltäytyminen',
            type_withdrawal: 'Peruutus',
            type_restriction: 'Rajoitus',
            type_objection: 'Vastustaminen',
            status_received: 'Vastaanotettu',
            status_processing: 'Käsittelyssä',
            status_under_assessment: 'Arvioitavana',
            status_implemented: 'Toteutettu',
            evidence_button: 'Todisteet',
            evidence_modal_title: 'Työnkulun todisteet',
            no_evidence: 'Tähän työnkulkuun ei ole liitetty todisteita.',
            upload_evidence_label: 'Lataa työnkulun todisteet',
            completed_at: 'Valmistunut klo',
            effective_date: 'Voimaantulopäivä',
            page_title: 'Suostumustyönkulut',
            no_workflows: 'Suostumustyönkulkuja ei löytynyt. Työnkulut luodaan, kun rekisteröidyt käyttävät oikeuksiaan.',
            type_grant: 'Myöntäminen',
            propagation_none: 'Ei mitään',
            propagation_pending: 'Odottaa',
            propagation_pending_warning: 'Ei voida viimeistellä — peruutuksen eteneminen on vielä kesken',
            propagation_completed: 'Valmis',
            propagation_partial: 'Osittainen',
            propagation_incomplete_error: 'Työnkulkua ei voi viimeistellä, kun peruutuksen eteneminen on vielä kesken',
            propagation_status: 'Etenemisen tila',
        },
        snapshots: {
            title: 'CMP-tilannekuvat',
            new: 'Uusi tilannekuva',
            label: 'Tunniste',
            snapshot_date: 'Tilannekuvan päivämäärä',
            purposes_count: 'Tarkoitusten lukumäärä',
            compare: 'Vertaa',
            snapshot_data: 'Tilannekuvan tiedot (JSON)',
            select_left: 'Valitse vasen tilannekuva',
            select_right: 'Valitse oikea tilannekuva',
            comparison_results: 'Vertailutulokset',
            field: 'Kenttä',
            left: 'Vasen',
            right: 'Oikea',
            close_comparison: 'Sulje vertailu',
            trigger: 'Laukaisin',
            trigger_manual: 'Manuaalinen',
            trigger_policy_approval: 'Käytännön hyväksyntä',
            cmp_version: 'CMP-versio',
            policy_version_id: 'Käytännön versiotunnus',
            banner_config: 'Banneriasetukset (JSON)',
            active_purposes: 'Aktiiviset tarkoitukset (JSON)',
            active_legal_bases: 'Aktiiviset oikeusperusteet (JSON)',
            domain_scope: 'Verkkotunnuksen laajuus',
            domain_scope_csv: 'Verkkotunnuksen laajuus (pilkuin erotettu)',
            raw_config: 'Raaka-asetukset (JSON)',
            checksum: 'Tarkistussumma',
            created: 'Luotu',
            fetch_error: 'CMP-tilannekuvien hakeminen epäonnistui. Yritä uudelleen.',
            save_error: 'CMP-tilannekuvan tallentaminen epäonnistui. Yritä uudelleen.',
            compare_error: 'Tilannekuvien vertailu epäonnistui. Yritä uudelleen.',
            page_title: 'Suostumuksen tilannekuvat',
            json_format: '[[TOK_0]] muodossa',
            json_array_format: '[[TOK_0]]-taulukkomuoto',
            manual_snapshot_note: 'Vain järjestelmänvalvojille/kehittäjille. Normaalitilanteessa tilannekuvat luodaan automaattisesti CMP-webhookin tai käytäntöjen hyväksynnän kautta. Liitä JSON CMP-toimittajasi viennistä (esim. OneTrust, Cookiebot).',
            banner_config_hint: 'Liitä bannerin konfiguraatio-objekti CMP-viennistäsi.',
            active_purposes_hint: 'JSON-taulukko aktiivisista tarkoitusobjekteista CMP-viennistäsi.',
            active_legal_bases_hint: 'JSON-taulukko aktiivisista oikeusperusteista CMP-viennistäsi.',
            raw_config_hint: 'Täydellinen raakamuotoinen konfigurations-JSON CMP:stäsi. Muut JSON-kentät poimitaan tästä. SHA-256-tarkistussumma lasketaan automaattisesti.',
            changed_field: 'Muutettu kenttä: ',
            no_snapshots: 'CMP-tilannekuvia ei löytynyt. Tilannekuvat luodaan, kun käytännöt hyväksytään tai ne käynnistetään manuaalisesti.',
            detail_title: 'Tilannekuvan tiedot',
            view_snapshot_detail: 'Näytä tilannekuvan tiedot',
            policy_version: 'Käytäntöversio',
            removed: 'Ennen',
            added: 'Jälkeen',
        },
        change_awareness: {
            title: 'Suostumuksen muutostietoisuus',
            change_type: 'Muutoksen tyyppi',
            entity_type: 'Kohteen tyyppi',
            entity_id: 'Kohteen tunnus',
            detected_at: 'Havaittu',
            acknowledge: 'Kuittaa',
            new_alert: 'Uusi hälytys',
            new_alert_form: 'Uusi muutostietoisuushälytys',
            total_open: 'Avoimet yhteensä',
            by_severity: 'Vakavuuden mukaan',
            snapshot_id: 'Tilannekuvan tunnus',
            update_status: 'Päivitä tila',
            resolution_notes: 'Ratkaisumuistiinpanot',
            resolution_required: 'Ratkaisumuistiinpanot (pakollinen)',
            resolution_required_msg: 'Ratkaisumuistiinpanot ovat pakollisia kohteen ratkaisemisessa.',
            status_open: 'Avoin',
            status_under_review: 'Tarkistettavana',
            status_resolved: 'Ratkaistu',
            status_accepted: 'Hyväksytty',
            severity_informational: 'Tiedoksi',
            severity_requires_review: 'Vaatii tarkistuksen',
            severity_policy_violation: 'Käytäntörikkomus',
            create_reconciliation: 'Luo sovittelutehtävä',
            reconciliation_created: 'Täsmäytystehtävä luotiin onnistuneesti.',
            reconciliation_error: 'Täsmäytystehtävän luominen epäonnistui. Yritä uudelleen.',
            fetch_error: 'Muutostietoisuuskohteiden hakeminen epäonnistui. Yritä uudelleen.',
            dashboard_error: 'Muutostietoisuuden yhteenvedon hakeminen epäonnistui. Yritä uudelleen.',
            create_error: 'Muutostietoisuuskohteen luominen epäonnistui. Yritä uudelleen.',
            status_update_error: 'Muutostietoisuuden tilan päivittäminen epäonnistui. Yritä uudelleen.',
            page_title: 'Muutostietoisuus',
            no_items: 'Muutostietoisuuselementtejä ei löytynyt. Elementit luodaan, kun suostumuskonfiguraation muutoksia havaitaan.',
        },
        audit: {
            title: 'Suostumuksen tarkastuspolku',
            event_type: 'Tapahtuman tyyppi',
            user_id: 'Käyttäjätunnus',
            timestamp: 'Aikaleima',
            details: 'Tiedot',
            actor: 'Tekijä',
            filter_by_entity_type: 'Suodata kohdetyypin mukaan',
            filter_by_action: 'Suodata toiminnon mukaan',
            fetch_error: 'Suostumuksen tarkastuspolun hakeminen epäonnistui. Yritä uudelleen.',
            page_title: 'Suostumuksen tarkastus',
            export_csv: 'Vie [[TOK_0]]',
            exporting: 'Viedään…',
            export_success: 'Kirjausketjun vienti onnistui.',
            export_error: 'Suostumuksen kirjausketjun vienti epäonnistui. Yritä uudelleen.',
            no_entries: 'Tarkastusmerkintöjä ei löytynyt. Tarkastustapahtumat kirjataan automaattisesti, kun suostumustiedot muuttuvat.',
            entity_policy: 'Käytäntö',
            entity_purpose: 'Tarkoitus',
            entity_workflow: 'Työnkulku',
            entity_consent_record: 'Suostumustietue',
            entity_change_awareness: 'Muutostietoisuus',
            entity_cmp_snapshot: 'CMP-tilannekuva',
            action_created: 'Luotu',
            action_updated: 'Päivitetty',
            action_status_changed: 'Tila muuttunut',
            action_drift_detected: 'Poikkeama havaittu',
            action_snapshot_created: 'Tilannekuva luotu',
            action_approval_submitted: 'Hyväksyntä lähetetty',
            action_archived: 'Arkistoitu',
            action_purpose_auto_mapped: 'Tarkoitus liitetty automaattisesti',
            action_purpose_mapping_updated: 'Tarkoitusliitos päivitetty',
            action_webhook_configured: 'Webhook määritetty',
            entity_propagation: 'Lisääntyminen',
            entity_reconciliation: 'Sovittelu',
            action_propagation_confirmed: 'Levitys vahvistettu',
            action_propagation_failed: 'Levitys epäonnistui',
            action_consent_captured: 'Suostumus tallennettu',
            action_reconciliation_created: 'Sovitus luotu',
            action_reconciliation_resolved: 'Sovittelu ratkaistu',
            action_submitted_for_review: 'Lähetetty tarkistettavaksi',
            action_activated: 'Aktivoitu',
            action_suspended: 'Keskeytetty',
            action_retired: 'Poistettu käytöstä',
            action_enhanced_review_required: 'Tehostettu tarkistus vaaditaan',
            action_enhanced_review_approved: 'Laajennettu tarkistus hyväksytty',
            action_enhanced_review_rejected: 'Laajennettu tarkistus hylätty — käytäntö palautettu luonnokseksi',
            action_consented: 'Suostunut',
            action_consented_customize: 'Suostumus räätälöity',
            action_revoked: 'Peruutettu',
            action_rejected: 'Hylätty',
        },
        web_records: {
            title: 'Verkkosuostumustiedot',
            page_title: 'Verkkosuostumustiedot',
            domain: 'Verkkotunnus',
            visitor_id: 'Vierailijatunnus',
            consent_action: 'Suostumustoimi',
            received_at: 'Vastaanotettu klo',
            admin_status: 'Järjestelmänvalvojan tila',
            revoke: 'Peruuta',
            reject: 'Hylkää',
            reason: 'Syy',
            reason_placeholder: 'Syy tähän toimenpiteeseen (valinnainen)',
            revoke_confirm: 'Perutaanko tämä suostumustietue?',
            reject_confirm: 'Hylätäänkö tämä suostumustietue?',
            override_success: 'Tietueen tilan päivitys onnistui.',
            override_error: 'Tietueen tilan päivittäminen epäonnistui.',
            no_records: 'Verkkosuostumustietueita ei löytynyt.',
            fetch_error: 'Verkkosuostumustietueiden lataaminen epäonnistui.',
            filter_by_domain: 'Suodata verkkotunnuksen mukaan',
            filter_by_action: 'Suodata toiminnon mukaan',
            active: 'Aktiivinen',
        },
        legal_bases: {
            all: 'Kaikki oikeusperusteet',
            consent: 'Suostumus',
            legitimate_interest: 'Oikeutettu etu',
            contract: 'Sopimus',
            legal_obligation: 'Lakisääteinen velvoite',
            vital_interest: 'Elintärkeä etu',
            public_interest: 'Yleinen etu',
        },
        common_statuses: {
            suspended: 'Keskeytetty',
            retired: 'Poistettu käytöstä',
            deprecated: 'Vanhentunut',
        },
        approval_modes: {
            all: 'Kaikki',
            any: 'Mikä tahansa',
        },
        cmp_integration: {
            title: 'AesirX CMP -integraatio',
            back_to_consent: 'Takaisin suostumukseen',
            back_to_integration: 'Takaisin integraatioon',
            webhook_status: 'Webhook-tila',
            events_received: 'Vastaanotetut tapahtumat',
            web_consent_records: 'Verkkosuostumustietueet',
            unmapped_purposes: 'Kytkemättömät tarkoitukset',
            integration_management: 'Integraation hallinta',
            webhook_configuration: 'Webhook-asetukset',
            webhook_config_desc: 'Määritä CMP-webhook-päätepiste ja hallitse HMAC-salaisuutta.',
            purpose_mapping: 'Tarkoitusten kytkentä',
            purpose_mapping_desc: 'Kytke CMP-tarkoitustunnisteet GRC-suostumuskatalogiin.',
            bulk_sync: 'Joukkosynkronointi',
            bulk_sync_desc: 'Sovella tarkoituskytkennät uudelleen kaikkiin kytkemättömiin suostumustietueisiin.',
            consent_analytics: 'Verkkosuostumusanalytiikka (viimeiset 30 päivää)',
            consent_grant_rate: 'Suostumusten myöntämisprosentti',
            top_domain: 'Suosituin verkkotunnus',
            records: 'tietuetta',
            banner_interactions: 'Bannerin vuorovaikutukset',
            consent_actions: 'Suostumustoimenpiteet',
            opt_in_trend: 'Opt-in/Opt-out-trendi',
            records_by_domain: 'Records by Domain',
            date: 'Päivämäärä',
            grants: 'Myönnöt',
            denials: 'Kiellot',
            not_configured: 'Ei määritetty',
            load_error: 'Integraatiotietojen lataaminen epäonnistui',
            webhook_not_configured: 'Webhookia ei ole määritetty.',
            webhook_not_configured_msg: 'Ole hyvä ja {link} ensin.',
            configure_webhook_link: 'määritä webhook',
            setup_wizard: 'Asennusvelho',
            step_configure_webhook: 'Määritä webhook',
            step_map_purposes: 'Kytke tarkoitukset',
            step_run_sync: 'Suorita ensimmäinen joukkosynkronointi',
            step_verify_data: 'Tarkista data yhteenvedossa',
            configure: 'Määritä',
            view_dashboard: 'Näytä yhteenveto',
            syncing: 'Synkronoidaan...',
            sync_now: 'Synkronoi nyt',
            sync_completed: 'Synkronointi valmis: {imported} tuotu, {skipped} ohitettu, {failed} epäonnistunut.',
            sync_failed: 'Synkronointi epäonnistui',
            last_sync_result: 'Viimeisin synkronointitulos',
            imported: 'Tuotu',
            skipped: 'Ohitettu',
            errors: 'Virheet',
            index: 'Indeksi',
            error: 'Virhe',
            sync_history: 'Synkronointihistoria',
            no_sync_jobs: 'Synkronointitehtäviä ei ole vielä tallennettu.',
            load_sync_error: 'Synkronointitietojen lataaminen epäonnistui',
            purpose_mapping_title: 'CMP-tarkoitusten kytkentä',
            auto_mapping: 'Automaattinen kytkentä...',
            auto_map_purposes: 'Kytke tarkoitukset automaattisesti',
            unmapped_warning: '{count} kytkemätöntä tarkoitusta -- nämä CMP-tarkoitukset tulee kytkeä GRC-tarkoituksiin.',
            mapping_saved: 'Kytkentä tallennettu.',
            mapping_deleted: 'Kytkentä poistettu.',
            auto_map_complete: 'Automaattinen kytkentä valmis: {mapped} kytketty, {unmatched} kytkemättä.',
            auto_map_failed: 'Automaattinen kytkentä epäonnistui',
            save_mapping_error: 'Kytkennän tallentaminen epäonnistui',
            delete_mapping_error: 'Kytkennän poistaminen epäonnistui',
            load_data_error: 'Tietojen lataaminen epäonnistui',
            cmp_purpose: 'CMP-tarkoitus',
            grc_purpose: 'GRC-tarkoitus',
            select_grc_purpose: '-- Valitse GRC-tarkoitus --',
            auto_mapped: 'Automaattisesti kytketty',
            mapped: 'Kytketty',
            unmapped: 'Kytkemätön',
            no_mappings: 'Tarkoituskytkentöjä ei löytynyt. Kytkennät luodaan automaattisesti, kun suostumustapahtumia vastaanotetaan.',
            total_mappings: 'Yhteensä: {count} kytkentä(ä)',
            webhook_config_title: 'Webhook-asetukset',
            current_configuration: 'Nykyinen määritys',
            setup_webhook: 'Määritä webhook',
            setup_webhook_desc: 'Määritä AesirX CMP -webhook vastaanottamaan suostumustapahtumia.',
            allowed_domains: 'Sallitut verkkotunnukset (yksi per rivi)',
            webhook_secret_warning: 'Webhook-salaisuus (tallenna tämä nyt -- sitä ei näytetä uudelleen):',
            last_event: 'Viimeisin tapahtuma',
            none_received: 'Ei mitään',
            update_domains: 'Päivitä verkkotunnukset',
            pause_webhook: 'Keskeytä webhook',
            resume_webhook: 'Jatka webhookia',
            regenerate_secret: 'Luo salaisuus uudelleen',
            configuring: 'Määritetään...',
            create_webhook_config: 'Luo webhook-asetukset',
            webhook_endpoint: 'Webhook-päätepiste',
            webhook_endpoint_desc: 'Määritä AesirX CMP lähettämään suostumustapahtumia osoitteeseen:',
            webhook_signature_note: 'Lisää HMAC-SHA256-allekirjoitus {header}-otsikkoon.',
            configured_success: 'Webhook määritetty onnistuneesti.',
            config_updated: 'Asetukset päivitetty.',
            config_error: 'Webhookin määrittäminen epäonnistui',
            update_error: 'Asetusten päivittäminen epäonnistui',
            toggle_error: 'Webhookin vaihtaminen epäonnistui',
            deactivated: 'Webhook poistettu käytöstä.',
            deactivate_error: 'Webhookin poistaminen käytöstä epäonnistui',
            page_title: '[[TOK_0]] Integrointi',
            webhook_config_page_title: '[[TOK_0]] Webhook-määritykset',
            bulk_sync_page_title: 'Karttaa tietueet uudelleen',
            purpose_mapping_page_title: 'Tarkoituksen kartoitus',
            data_loaded: '[[TOK_0]] integrointitiedot ladattu',
            sync_all: 'Synkronoi kaikki',
            sync_selected: 'Synkronoi valitut',
            sync_status: 'Synkronointitila',
            last_sync: 'Viimeisin synkronointi',
            no_records: 'Tietueita ei löytynyt.',
            sync_in_progress: 'Synkronointi käynnissä...',
            sync_complete: 'Synkronointi valmis.',
            sync_error: 'Synkronointi epäonnistui. Yritä uudelleen.',
            map_purpose: 'Liitä tarkoitus',
            unmap: 'Poista liitos',
            mapping_status: 'Liitoksen tila',
            save_mapping: 'Tallenna liitos',
            remap_unmapped_records: 'Karttaa kartoittamattomat tietueet uudelleen',
            remap_records: 'Karttaa tietueet uudelleen',
            add_mappings_first: 'Lisää ensin käyttötarkoituskartoitukset (vaihe 2)',
            remap_result: 'Uudelleenkartoituksen tulos',
            remap_result_desc: 'Käsiteltiin kaikki suostumustietueet kartoittamattomilla tai osittain kartoitetuilla tarkoituksilla.',
            total_processed: 'Käsitelty yhteensä',
            newly_mapped: 'Vasta kartoitettu',
            still_unmapped_label: 'Vielä kartoittamaton',
            still_unmapped_msg: '[[TOK_2]] tietueilla on edelleen kartoittamattomia tarkoituksia. [[TOK_3]] ja napsauta sitten Kartta uudelleen.',
            add_more_mappings: 'Lisää lisää kartoituksia',
            remap_complete: 'Uudelleen kartoitus valmis: [[TOK_2]] on juuri kartoitettu, [[TOK_3]] vielä kartoittamaton.',
            add_mapping: 'Lisää kartoitus',
            cmp_purpose_id_label: '[[TOK_0]] Käyttötunnus *',
            cmp_purpose_id_required: '[[TOK_0]] Käyttötunnus vaaditaan',
            cmp_purpose_name_label: '[[TOK_0]] Käyttötarkoituksen nimi',
            grc_purpose_label: 'GRC:n tarkoitus',
        },
        propagation: {
            title: 'Peruutuksen levitys',
            systems: 'Yhdistetyt järjestelmät',
            status: 'Tila',
            confirmed: 'Vahvistettu',
            pending: 'Odottaa',
            failed: 'Epäonnistunut',
            confirm: 'Vahvista peruutus',
            fail: 'Merkitse epäonnistuneeksi',
            failure_reason: 'Epäonnistumisen syy',
            can_close: 'Kaikki järjestelmät vahvistettu — työnkulku voidaan sulkea',
            cannot_close: 'Odotetaan järjestelmävahvistuksia',
            no_tasks: 'Ei levitystehtäviä.',
            confirm_success: 'Järjestelmän peruutus vahvistettu.',
            fail_success: 'Järjestelmä merkitty epäonnistuneeksi.',
            propagate_success: 'Peruutus levitetty yhdistetyille järjestelmille.',
            propagate: 'Levitä järjestelmiin',
            add_system: 'Lisää järjestelmä',
            remove_system: 'Poista',
            system_id: 'Järjestelmän tunnus',
            system_name: 'Järjestelmän nimi',
            owner_id: 'Omistajan tunnus',
            propagate_error: 'Peruuttamisen levittäminen epäonnistui. Yritä uudelleen.',
            no_systems: 'Lisää vähintään yksi järjestelmä.',
            page_title: 'Noston leviäminen',
            workflow_id: 'Valitse Noston työnkulku',
            system_id_hint: 'esim. crm-001, erp-prod',
            owner_id_hint: 'Järjestelmän omistaja',
            elapsed: 'Kulunut',
        },
        sensitive: {
            title: 'Arkaluonteisten tietojen käytännöt',
            flag: 'Merkitse arkaluonteiseksi',
            categories: 'Arkaluonteiset luokat',
            enhanced_review: 'Vaadi laajennettu tarkistus',
            enhanced_review_success: 'Laajennettu tarkistus vaadittu.',
            flag_success: 'Käytäntö merkitty arkaluonteiseksi.',
            no_sensitive: 'Ei arkaluonteisten tietojen käytäntöjä.',
        },
        reconciliation: {
            title: 'Poikkeamien täsmäytys',
            create: 'Uusi täsmäytystehtävä',
            system: 'Järjestelmä',
            owner: 'Omistaja',
            description: 'Kuvaus',
            resolution: 'Ratkaisu',
            resolve: 'Ratkaise',
            update_grc: 'Päivitä GRC',
            update_cmp: 'Päivitä CMP',
            accept_difference: 'Hyväksy ero',
            escalate: 'Eskaloi',
            resolution_notes: 'Ratkaisuhuomautukset',
            no_tasks: 'Ei täsmäytystehtäviä.',
            resolve_success: 'Täsmäytystehtävä ratkaistu.',
            create_success: 'Täsmäytystehtävä luotu.',
            open: 'Avoin',
            resolved: 'Ratkaistu',
            escalated: 'Eskaloitu',
            dashboard_open: 'Avoimet tehtävät',
            dashboard_resolved: 'Ratkaistut tehtävät',
            dashboard_escalated: 'Eskaloidut tehtävät',
            page_title: 'Epäsovitus täsmäytys',
            my_tasks: 'Omat tehtäväni',
            all_tasks: 'Kaikki tehtävät',
            severity: 'Vakavuus',
        },
        sync: {
            title: 'CMP-synkronointi',
            direction: 'Suunta',
            cmp_to_grc: '[[TOK_0]] → GRC',
            grc_to_cmp: 'GRC → [[TOK_0]]',
            conflict: 'Ristiriita',
            resolve_conflict: 'Ratkaise ristiriita',
            no_events: 'Ei synkronointitapahtumia.',
            resolve_success: 'Synkronointiristiriita ratkaistu.',
            create_success: 'Synkronointitapahtuma tallennettu.',
            page_title: '[[TOK_0]] Synkronoi',
            detect_drift: 'Tunnista ristiriidat',
            detecting: 'Havaitaan...',
            drift_result: '[[TOK_2]] ristiriitaa havaittu / [[TOK_3]] verratusta tarkoituksesta.',
            no_drift: 'Uusia ristiriitoja ei havaittu.',
            drift_error: 'Ristiriitatunnistuksen suorittaminen epäonnistui.',
            resolve_modal_title: 'Ratkaise ristiriita',
            resolve_field: 'Kenttä',
            resolve_grc_value: 'GRC-arvo',
            resolve_cmp_value: '[[TOK_0]] Arvo',
            accept_cmp: 'Hyväksy [[TOK_0]]-arvo',
            accept_cmp_desc: 'Päivitä GRC vastaamaan [[TOK_0]] - [[TOK_1]] arvo muuttuu uudeksi GRC-arvoksi.',
            keep_grc: 'Säilytä GRC-arvo',
            keep_grc_desc: 'Sulje tämä ristiriita muuttamatta GRC:tä – ilmoita [[TOK_0]]:n omistajalle tasaamaan.',
            resolve_applied: 'Konflikti ratkaistu. GRC:n tarkoitus päivitetty vastaamaan [[TOK_0]].',
        },
    },
    assessments: {
        dossier_preflight: {
            advisory_notice: 'Tämä valmiusraportti on neuvoa-antava. Se ei hyväksy, kokoa, muodosta, toimita eikä lähetä asiakirja-aineistoa.',
            run_label: 'Juokse ennen lentoa',
            running: 'Käynnissä ennen lentoa…',
            assemble_label: 'Automaattisesti koottava paketti',
            assembling: 'Kokoonpano…',
            verdict_label: 'Tuomio ennen lentoa',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            remediation_label: 'Korjaus',
            no_gaps: 'Lentoa edeltäviä aukkoja ei havaittu. Arkistointi on valmis koottavaksi.',
            override_label: 'Ohita lohkon päätös – kokoonpano on tarkastusleimattu.',
            accept_label: 'Hyväksy raportti',
            reject_label: 'Hylkää raportti',
            assembled_label: 'Lähetyspaketti koottu',
            package_id_label: 'Paketin tunnus',
            package_filename_label: 'Tiedostonimi',
            package_hash_label: 'Paketin hash',
            evidence_count_label: '[[TOK_1]] todisteita niputettuna',
            error_generic: 'Ei voitu suorittaa ennen lentoa tai koota pakettia. Yritä uudelleen tai tarkista arkistoinnin tila.',
        },
        errors: {
            fetch: 'Arviointien lataaminen epäonnistui.',
            save: 'Arvioinnin tallentaminen epäonnistui.',
            fetch_gap_report_failed: 'Puuteraportin hakeminen epäonnistui.',
            fetch_transfers_failed: 'Siirtojen hakeminen epäonnistui.',
            save_transfer_failed: 'Siirron tallentaminen epäonnistui.',
            submit_review_failed: 'Tarkistettavaksi lähettäminen epäonnistui.',
            process_decision_failed: 'Päätöksen käsittely epäonnistui.',
            deprecate_failed: 'Vanhentaminen epäonnistui.',
            evaluate_risk_failed: 'Riskin arviointi epäonnistui.',
            fetch_safeguards_failed: 'Suojatoimien hakeminen epäonnistui.',
            save_safeguard_failed: 'Suojatoimen tallentaminen epäonnistui.',
            update_safeguard_status_failed: 'Suojatoimen tilan päivittäminen epäonnistui.',
        },
        nav: {
            dpias: 'Tietosuojan vaikutustenarvioinnit',
            transfers: 'Siirtoarvioinnit',
            dashboard: 'Yhteenveto',
            gap_report: 'Puuteraportti',
        },
        risk_level_critical: 'Kriittinen riski',
        risk_level_high: 'Korkea riski',
        risk_level_medium: 'Keskitason riski',
        risk_level_low: 'Matala riski',
        severity_critical: 'Kriittinen vakavuus',
        severity_high: 'Korkea vakavuus',
        severity_medium: 'Keskitason vakavuus',
        severity_low: 'Matala vakavuus',
        overdue: 'Myöhässä',
        framework_filter_label: 'puitteet',
        aria_filter_by_framework: 'Suodata kehyksen mukaan',
        dashboard: {
            title: 'Arviointien yhteenveto',
            page_title: 'Arviointien hallintapaneeli',
            announce_loaded: 'Arviointien hallintapaneeli ladattu',
            announce_chart_view: 'Näytetään kaavionäkymä',
            announce_table_view: 'Näytetään taulukonäkymä',
            aria_metrics_table: 'Arviointien hallintapaneelin mittarit',
            metric_col: 'Mittari',
            value_col: 'Arvo',
            dpia_prefix: 'DPIA',
            transfer_prefix: 'Siirto',
            risk_prefix: 'Riski',
            aria_dpias_by_status: 'DPIAt tilan mukaan',
            aria_transfers_by_status: 'Siirrot tilan mukaan',
            aria_top_risks: 'Suurimmat riskit',
            aria_top_risks_table: 'Suurimmat riskit DPIOissa',
            overdue_dpias_attention: '{count} myöhässä olevaa DPIA-arviointia vaatii huomiota',
            no_overdue_dpias: 'Ei myöhässä olevia DPIA-arviointeja',
            overdue_transfers_attention: '{count} myöhässä olevaa siirtoarviointia vaatii huomiota',
            no_overdue_transfers: 'Ei myöhässä olevia siirtoarviointeja',
            dpias_overview: 'Vaikutustenarviointien yleiskatsaus',
            transfers_overview: 'Siirtoarviointien yleiskatsaus',
            overdue_items: 'Myöhästyneet kohteet',
            overdue_dpias: 'Myöhästyneet vaikutustenarvioinnit',
            overdue_transfers: 'Myöhästyneet siirtoarvioinnit',
            count: 'Lukumäärä',
            no_data: 'Ei tiedot available. löytynyt',
            no_risks: 'Ei riskit found. löytynyt',
            no_dashboard_data: 'Ei kojelauta tiedot available. löytynyt',
            fetch_error: 'Epäonnistui: fetch kojelauta tiedot. Yritä uudelleen.',
        },
        dpias: {
            page_title: 'DPIAt',
            announce_submitted_for_review: 'DPIA lähetetty tarkistettavaksi',
            announce_deprecated: 'DPIA vanhentunut',
            announce_risks_loaded: '{count} riski(ä) ladattu',
            announce_mitigations_loaded: '{count} toimenpide(ttä) ladattu',
            announce_risk_deleted: 'Riski poistettu',
            announce_mitigation_status_updated: 'Toimenpiteen tila päivitetty',
            aria_filter: 'Suodata DPIAt',
            aria_filter_by_status: 'Suodata tilan mukaan',
            aria_filter_by_lead: 'Suodata arvioinnin vetäjän mukaan',
            aria_table: 'Tietosuojan vaikutustenarvioinnit',
            announce_found: '{count} DPIA(ta) löydetty',
            announce_decision: '[[TOK_2]] [[TOK_1]]',
            mitigation_start: 'Aloita',
            mitigation_mark_implemented: 'Merkitse toteutetuksi',
            mitigation_verify: 'Vahvista',
            title: 'Tietosuojan vaikutustenarvioinnit',
            new: 'Uusi vaikutustenarviointi',
            edit: 'Muokkaa vaikutustenarviointia',
            dpia_title: 'Otsikko',
            activity: 'Käsittelytoimi',
            risk_score: 'Riskipisteet',
            risks: 'Riskit',
            mitigations: 'Lieventävät toimet',
            add_risk: 'Lisää riski',
            add_mitigation: 'Lisää lieventävä toimi',
            necessity: 'Tarpeellisuus / oikeasuhtaisuus',
            likelihood: 'Todennäköisyys',
            impact: 'Vaikutus',
            severity_label: 'Vakavuus',
            purpose: 'Tarkoitus',
            consultation_notes: 'Consultation Huomautukset',
            dpo_opinion: 'Tietosuojavastaavan lausunto',
            processing_activity_ids: 'Käsitellään Aktiviteetti Tunniste (comma-separated)',
            system_ids: 'Järjestelmä Tunniste (comma-separated)',
            vendor_ids: 'Toimittajatunnukset (pilkuilla erotettu)',
            data_types: 'Tiedot Tyypit (comma-separated)',
            data_types_short: 'Tiedot Tyypit',
            data_subjects: 'Tiedot Subjects (comma-separated)',
            assessment_lead_id: 'Arviointi Lead Tunniste',
            assessment_lead: 'Arviointi Lead',
            dpo_id: 'DPO Tunniste',
            reviewer_ids: 'Arvioija Tunniste (comma-separated)',
            approval_mode: 'Hyväksyntätila',
            approval_all: 'All',
            approval_any: 'Any',
            require_dpo_signoff: 'Vaadi tietosuojavastaavan hyväksyntä',
            review_date: 'Katselmointia Päivämäärä',
            submit_for_review: 'Lähetä for Katselmointia',
            approve_reject: 'Hyväksy/Hylkää',
            deprecate: 'Vanhenna',
            deprecated: 'Vanhentunut',
            hide_risks: 'Piilota Riskit',
            hide_mitigations: 'Piilota Lieventämiset',
            comments: 'Kommentit',
            submit_decision: 'Lähetä Päätös',
            category_label: 'Kategoria',
            category_data_breach: 'Tiedot Tietoturvaloukkaus',
            category_unauthorized_access: 'Unauthorized Pääsy',
            category_function_creep: 'Toimintojen laajeneminen',
            category_re_identification: 'Uudelleentunnistaminen',
            category_discrimination: 'Syrjintä',
            category_surveillance: 'Valvonta',
            category_other: 'Muu',
            affected_rights: 'Vaikutetut oikeudet (pilkuilla erotettu)',
            no_risks: 'Ei riskit found. löytynyt',
            no_mitigations: 'Ei mitigations found. löytynyt',
            no_dpias: 'Ei dpia found. löytynyt',
            mitigation_type: 'Tyyppi',
            mitigation_technical: 'Tekninen',
            mitigation_organizational: 'Organisatorinen',
            mitigation_contractual: 'Sopimukseen perustuva',
            risk_ids: 'Riski Tunniste (comma-separated)',
            responsible_party: 'Vastuutaho',
            responsible_party_placeholder: 'Tai syötä nimi manuaalisesti',
            affected_rights_placeholder: 'Valitut oikeudet näkyvät tässä',
            affected_rights_freetext_placeholder: 'Syötä vaikutetut oikeudet (pilkulla erotettuna)',
            responsible: 'Vastuullinen',
            target_date: 'Tavoite Päivämäärä',
            created: 'Luotu',
            fetch_error: 'Epäonnistui: fetch DPIA. Yritä uudelleen.',
            save_error: 'Epäonnistui: save DPIA. Yritä uudelleen.',
            submit_review_error: 'Epäonnistui: submit DPIA for katselmointi. Yritä uudelleen.',
            decision_error: 'Epäonnistui: process decision. Yritä uudelleen.',
            deprecate_error: 'Epäonnistui: deprecate DPIA. Yritä uudelleen.',
            fetch_risks_error: 'Epäonnistui: fetch riskit. Yritä uudelleen.',
            save_risk_error: 'Epäonnistui: save riski. Yritä uudelleen.',
            delete_risk_error: 'Epäonnistui: delete riski. Yritä uudelleen.',
            fetch_mitigations_error: 'Epäonnistui: fetch mitigations. Yritä uudelleen.',
            save_mitigation_error: 'Epäonnistui: save mitigation. Yritä uudelleen.',
            update_mitigation_status_error: 'Lieventämistoimenpiteen tilan päivittäminen epäonnistui. Yritä uudelleen.',
            link_form_template: 'Linkin sääntelylomakemalli',
            link_form_template_placeholder: 'Valitse [[TOK_0]]-lomakemalli (valinnainen)',
            link_form_template_none: 'Ei mitään',
            linked_form: 'Linkitetty lomake',
            linked_form_creating: 'Luodaan linkitettyä lomaketta...',
            linked_form_error: 'Linkitetyn lomakkeen esiintymän luominen epäonnistui. [[TOK_0]] luotiin ilman linkitettyä lomaketta.',
            view_linked_form: 'Näytä lomake',
            announce_created_with_form: '[[TOK_0]] luotu linkitetyllä lomake-instanssilla',
            creation_mode: '[[TOK_0]] Luontitila',
            mode_standard: 'Vakio [[TOK_0]]',
            mode_template: 'Käytä sääntelylomakemallia',
            select_form_template: 'Valitse Lomakemalli',
            create_and_fill_form: 'Luo ja täytä lomake',
            template_sections_title: 'Mallin osiot',
            field_singular: 'kenttä',
            field_plural: 'kentät',
            no_sections: 'Tästä mallista ei löytynyt osioita.',
            template_mode_hint: 'Luomisen jälkeen sinut ohjataan täyttämään koko sääntelylomake.',
            linked_dossier_filings: 'Linkitetyt dossier-arkistoinnit',
            no_linked_dossier_filings: 'Ei dossier-arkistointeja linkitetty tähän DPIA:han.',
            view_dossier_filing: 'Näytä arkistointi',
            hide_dossier_filings: 'Piilota dossier-arkistoinnit',
            supporting_evidence: 'Tukevat todisteet',
            hide_supporting_evidence: 'Piilota todisteet',
            no_supporting_evidence: 'Ei liitteenä todisteita.',
            upload_supporting_evidence: 'Lataa tukevat todisteet',
            view_form_responses: 'Näytä lomakevastaukset',
            regulatory_framework: 'Sääntelykehys',
            all_frameworks: 'Kaikki kehykset',
            no_templates_for_market: 'Valitulle markkinalle ei ole malleja saatavilla. Valitse toinen markkina tai luo malli.',
        },
        transfers: {
            page_title: 'Tiedonsiirrot',
            announce_found: '{count} siirtoarviointi(a) löydetty',
            announce_submitted_for_review: 'Siirto lähetetty tarkistettavaksi',
            announce_deprecated: 'Siirto vanhentunut',
            announce_decision: 'Siirto {decision}',
            announce_risk_eval_completed: 'Riskiarviointi valmis',
            announce_safeguard_status_updated: 'Suojatoimenpiteen tila päivitetty',
            announce_safeguards_loaded: '{count} suojatoimenpide(ttä) ladattu',
            aria_filter: 'Suodata siirtoarviointeja',
            aria_filter_by_status: 'Suodata tilan mukaan',
            aria_filter_by_mechanism: 'Suodata siirtomekanismin mukaan',
            aria_table: 'Tiedonsiirtoarvioinnit',
            title: 'Rajat ylittävien siirtojen arvioinnit',
            new: 'Uusi siirto',
            edit: 'Muokkaa siirtoa',
            name: 'Nimi',
            from_country: 'Lähtömaa',
            to_country: 'Kohdemaa',
            safeguards: 'Suojatoimet',
            risk_level: 'Riskitaso',
            assessment_notes: 'Arvioinnin muistiinpanot',
            mechanism: 'Mekanismi',
            transfer_mechanism: 'Siirtomekanismi',
            transfer_mechanism_detail: 'Siirtomekanismin yksityiskohta',
            all_mechanisms: 'Kaikki mekanismit',
            mechanism_adequacy_decision: 'Riittävyyspäätös',
            mechanism_sccs: 'SCC:t',
            mechanism_bcrs: 'BCR:t',
            mechanism_consent: 'Suostumus',
            mechanism_derogation: 'Poikkeus',
            mechanism_other: 'Muu',
            data_types: 'Tiedot Tyypit (comma-separated)',
            data_subjects: 'Tiedot Subjects (comma-separated)',
            purpose: 'Tarkoitus',
            recipient_name: 'Recipient Nimi',
            create_success: 'Siirtoarviointi luotu.',
            update_success: 'Siirtoarviointi päivitetty.',
            recipient_details: 'Vastaanottajan tiedot',
            recipient_details_placeholder: 'Vastaanottajan rooli, sijainti ja järjestelmät sekä edelleensiirron tiedot',
            vendor_id: 'Toimittajatunnus',
            processing_activity_ids: 'Käsitellään Aktiviteetti Tunniste (comma-separated)',
            reviewer_ids: 'Arvioija Tunniste (comma-separated)',
            approval_mode: 'Hyväksyntätila',
            approval_all: 'All',
            approval_any: 'Any',
            require_dpo_signoff: 'Vaadi tietosuojavastaavan hyväksyntä',
            review_date: 'Katselmointia Päivämäärä',
            created: 'Luotu',
            deprecated: 'Vanhentunut',
            submit_for_review: 'Lähetä for Katselmointia',
            approve_reject: 'Hyväksy/Hylkää',
            deprecate: 'Vanhenna',
            risk_eval: 'Riski Eval',
            hide_safeguards: 'Piilota Suojatoimet',
            mechanism_proof: 'Mekanismin todiste',
            hide_mechanism_proof: 'Piilota mekanismin todiste',
            mechanism_proof_hint: 'Lataa allekirjoitettu siirtomekanismi (SCC:t, BCR:t, riittävyyspäätös jne.), joka todistaa tämän siirtoarvion.',
            no_mechanism_proof: 'Ei kiinnitetty mekanismitodistusta.',
            upload_mechanism_proof: 'Lataa mekanismin todiste',
            comments: 'Kommentit',
            submit_decision: 'Lähetä Päätös',
            data_sensitivity: 'Tiedot Sensitivity (1-5)',
            country_risk: 'Maa Riski (1-5)',
            safeguard_adequacy: 'Suojatoimi Adequacy (1-5)',
            volume_factor: 'Tilavuustekijä (1-5)',
            evaluate: 'Arvioi',
            add_safeguard: 'Lisää suojatoimi',
            responsible_party: 'Vastuutaho',
            responsible_party_placeholder: 'Tai syötä nimi manuaalisesti',
            responsible: 'Vastuullinen',
            implementation_date: 'Implementation Päivämäärä',
            implementation: 'Toteutus',
            expiry_date: 'Expiry Päivämäärä',
            expiry: 'Vanheneminen',
            expire: 'Vanhenna',
            no_safeguards: 'Ei safeguards found. löytynyt',
            no_transfers: 'Ei transfer arviointi found. löytynyt',
            fetch_error: 'Epäonnistui: fetch transfer arviointi. Yritä uudelleen.',
            save_error: 'Epäonnistui: save transfer arviointi. Yritä uudelleen.',
            submit_review_error: 'Epäonnistui: submit for katselmointi. Yritä uudelleen.',
            decision_error: 'Epäonnistui: process decision. Yritä uudelleen.',
            deprecate_error: 'Epäonnistui: deprecate transfer. Yritä uudelleen.',
            risk_eval_error: 'Epäonnistui: evaluate riski. Yritä uudelleen.',
            fetch_safeguards_error: 'Epäonnistui: fetch safeguards. Yritä uudelleen.',
            save_safeguard_error: 'Epäonnistui: save safeguard. Yritä uudelleen.',
            update_safeguard_status_error: 'Suojatoimenpiteen tilan päivittäminen epäonnistui. Yritä uudelleen.',
            safeguard_type_encryption_in_transit: 'Salaus in Transit',
            safeguard_type_encryption_at_rest: 'Salaus at Rest',
            safeguard_type_access_controls: 'Pääsynhallintatoimet',
            safeguard_type_contractual_clauses: 'Contractual Lausekkeet',
            safeguard_type_data_minimization: 'Tiedot Minimization',
            safeguard_type_pseudonymization: 'Pseudonymisointi',
            safeguard_type_audit_rights: 'Tarkastus Oikeudet',
            safeguard_type_breach_notification: 'Tietoturvaloukkaus Ilmoitus',
            safeguard_type_data_localization: 'Tiedot Localization',
            safeguard_type_other: 'Muu',
            activate: 'Aktivoi',
            all_statuses: 'Kaikki tilat',
            any: 'Any',
            mechanism_detail: 'Mekanismin yksityiskohta',
            mechanisms: {
                adequacy_decision: 'Riittävyyspäätös',
                sccs: 'SCC:t',
                bcr: 'BCR',
                bcrs: 'BCR:t',
                derogation: 'Poikkeus',
                consent: 'Suostumus',
                other: 'Muu',
            },
            safeguard_types: {
                encryption_in_transit: 'Salaus siirron aikana',
                encryption_at_rest: 'Salaus levossa',
                access_controls: 'Pääsynhallinta',
                contractual_clauses: 'Sopimuslausekkeet',
                data_minimization: 'Tietojen minimointi',
                pseudonymization: 'Pseudonymisointi',
                audit_rights: 'Tarkastusoikeudet',
                breach_notification: 'Tietomurtoilmoitus',
                data_localization: 'Tietojen lokalisointi',
                other: 'Muu',
            },
        },
        gap_report: {
            page_title: 'Arviointien aukkoselvitys',
            announce_loaded: 'Aukkoselvitys ladattu. {count} aukko(a) tunnistettu',
            aria_activities_without_dpia: 'Toiminnot ilman DPIA-arviointia',
            aria_activities_unclassified: 'Toimet, joiden DPIA-vaatimusta ei ole luokiteltu',
            activities_unclassified_section_title: 'Toimet, joiden DPIA-vaatimusta ei ole luokiteltu',
            activities_unclassified_description: 'Näitä toimia ei ole arvioitu sen määrittämiseksi, vaaditaanko DPIA lain mukaan. Luokittele jokainen signaalin poistamiseksi.',
            activities_unclassified_empty: 'Kaikki aktiiviset toimet on luokiteltu.',
            aria_unmitigated_risks: 'Käsittelemättömät korkeat ja kriittiset riskit',
            aria_transfers_without_safeguards: 'Siirrot ilman riittäviä suojatoimenpiteitä',
            aria_expired_assessments: 'Vanhentuneet arvioinnit jotka vaativat uusintaa',
            title: 'Arvioinnin puuteraportti',
            no_dpia: 'Toimet ilman vaikutustenarviointia',
            no_assessment: 'Siirrot ilman arviointia',
            unmitigated: 'Vaikutustenarvioinnit, joissa on lieventämättömiä riskejä',
            activity_id: 'Aktiviteettitunnus',
            dpia_id: 'DPIA Tunniste',
            assessment_id: 'Arviointi Tunniste',
            expired_assessments: 'Vanhentunut Arvioinnit',
            no_gaps_activities: 'Ei puute found. all activities have dpia. löytynyt',
            no_unmitigated_risks: 'Ei unmitigated high/critical riskit found. löytynyt',
            no_gaps_safeguards: 'Ei puute found. all transfers have adequate safeguards. löytynyt',
            no_expired: 'Ei expired arviointi found. löytynyt',
            no_report_data: 'Ei puute raportti tiedot available. löytynyt',
            fetch_error: 'Epäonnistui: fetch puute raportti. Yritä uudelleen.',
            no_expired_assessments: 'No expired arviointi.',
            no_gaps_dpia: 'Ei dpia puute found. löytynyt',
            no_data: 'Ei tiedot available. löytynyt',
        },
        dossier_filings: {
            page_title_detail: 'Dossierin jättämisen yksityiskohdat',
            page_title_list: 'Dossierin jättämistapaukset',
            announce_filings_found: '{count} jättämis(tä) löydetty',
            announce_results: '{count} tulosta',
            aria_filter_by_status: 'Suodata tilan mukaan',
            title: 'Asiakirjojen arkistointiasiat',
            nav_label: 'Asiakirja-aineistot',
            create: 'Luo asiakirja-aineisto',
            form_type: 'Lomakkeen tyyppi',
            phu_luc_i_label: 'Mẫu số 02a (standardi [[TOK_0]], asetus 356)',
            phu_luc_ii_label: 'Mẫu số 02b (Rajat ylittävä / suuri riski [[TOK_0]], asetus 356)',
            dpia_reference: '[[TOK_0]] Viite',
            submitted_date: 'Lähetyspäivämäärä',
            outcome: 'Tulos',
            parent_filing: 'Vanhempi',
            no_filings: 'Asiakirja-aineistoa ei löytynyt.',
            fetch_error: 'Asiakirja-aineiston nouto epäonnistui. Yritä uudelleen.',
            save_error: 'Asiakirja-aineiston luominen epäonnistui. Yritä uudelleen.',
            created: 'Asiakirja-aineisto luotu.',
            loaded: 'Asiakirja-aineisto ladattu.',
            not_found: 'Asiakirja-aineistoa ei löytynyt.',
            back_to_list: 'Takaisin luetteloon',
            section_assignments: 'Osion Tehtävät',
            assign_sections: 'Määritä osiot',
            section_id: 'osio',
            department: 'osasto',
            assignee: 'Valtuutettu',
            deadline: 'Määräaika',
            no_assignments: 'Ei vielä osiotehtäviä.',
            sections_assigned_msg: 'Osuudet määrätty.',
            assign_error: 'Osioiden määrittäminen epäonnistui. Yritä uudelleen.',
            lifecycle: 'Arkistoinnin elinkaari',
            submission: 'Lähetyksen tiedot',
            submission_channel: 'Lähetyskanava',
            mps_portal: '[[TOK_0]] Portaali',
            in_person: 'Henkilökohtaisesti',
            postal: 'Posti',
            confirmation_number: 'Vahvistusnumero',
            submit_for_review: 'Lähetä tarkistettavaksi',
            submitted_for_review: 'Lähetetty sisäiseen tarkasteluun.',
            submit_review_error: 'Lähetys tarkistettavaksi epäonnistui. Yritä uudelleen.',
            legal_signoff: 'Laillinen allekirjoitus',
            legal_signoff_done: 'Oikeudellinen allekirjoitus suoritettu.',
            legal_signoff_error: 'Laillisen allekirjoituksen viimeistely epäonnistui. Yritä uudelleen.',
            approve: 'Hyväksy',
            approved_msg: 'Arkistointi hyväksytty.',
            approve_error: 'Ilmoituksen hyväksyminen epäonnistui. Yritä uudelleen.',
            materialisation_status_column: 'Lähetys artefakti',
            materialisation_na: 'Ei sovellu',
            materialisation_pending: 'Odottaa',
            materialisation_success: 'Materialisoitunut',
            materialisation_failed: 'Epäonnistui',
            materialisation_banner_title: 'Lähetyksen artefaktia ei voitu luoda',
            materialisation_banner_body: 'Arkistointi hyväksyttiin, mutta taustalla olevaa asiakirjatietuetta ei voitu luoda. Saatekirjeiden ja lähetysten vienti ei ole käytettävissä, ennen kuin yrität uudelleen.',
            materialisation_retry_button: 'Yritä uudelleen',
            materialisation_retry_count: 'Aiemmat uudelleenyritykset:',
            materialisation_retry_success: 'Lähetetty artefakti toteutui onnistuneesti.',
            materialisation_retry_announce: 'Uudelleenyritys onnistui',
            filter_materialisation_failed: 'Näytä vain toteutusvirheet',
            column_title: 'Otsikko',
            column_form_type: 'Lomake',
            submit_to_mps: 'Lähetä [[TOK_0]]',
            submitted_to_mps_msg: 'Lähetetty [[TOK_0]].',
            submit_mps_error: 'Lähetys epäonnistui: [[TOK_0]]. Yritä uudelleen.',
            supplement_request: 'Täydennyspyyntö',
            supplement_requests: 'Täydennyspyynnöt',
            supplement_response: 'Täydentävä vastaus',
            record_supplement: 'Tietueen täydennyspyyntö',
            supplement_recorded: 'Täydennyspyyntö kirjattu.',
            supplement_error: 'Täydennyspyynnön tallentaminen epäonnistui. Yritä uudelleen.',
            submit_supplement: 'Lähetä täydennysvastaus',
            supplement_submitted_msg: 'Täydennysvastaus lähetetty.',
            supplement_submit_error: 'Täydennysvastauksen lähettäminen epäonnistui. Yritä uudelleen.',
            response_status: 'Vastauksen tila',
            response_notes: 'Vastaushuomautukset',
            resubmit: 'Lähetä uudelleen',
            resubmitted_msg: 'Asiakirja lähetetty uudelleen.',
            resubmit_error: 'Asiakirjan uudelleenlähetys epäonnistui. Yritä uudelleen.',
            record_outcome: 'Ennätystulos',
            outcome_recorded: 'Tulos kirjattu.',
            outcome_error: 'Tuloksen tallennus epäonnistui. Yritä uudelleen.',
            accepted: 'Hyväksytty',
            rejected: 'Hylätty',
            close: 'Sulje',
            closed_msg: 'Arkistointi suljettu.',
            close_error: 'Arkistoinnin sulkeminen epäonnistui. Yritä uudelleen.',
            change_filing: 'Luo muutostiedosto',
            change_filing_created: 'Muutostiedosto luotu.',
            change_filing_error: 'Muutostiedoston luominen epäonnistui. Yritä uudelleen.',
            change_reason: 'Syy muutokseen',
            filing_lineage: 'Arkistointilinja',
            timers: 'Aktiiviset ajastimet',
            timer_mps_review: '[[TOK_0]] Arvostelu',
            timer_supplement: 'Täydennyksen määräaika',
            timer_resubmission: 'Uudelleenlähetyksen määräaika',
            timer_department: 'Osaston määräaika',
            days_remaining: 'päivää jäljellä',
            days_overdue: 'päivää myöhässä',
            cover_letter: 'Saatekirje',
            checklist: 'Tarkistuslista',
            evidence_index: 'Todisteiden indeksi',
            status_draft: 'Luonnos',
            status_sections_assigned: 'Osiot kohdistettu',
            status_internal_review: 'Sisäinen tarkastus',
            status_legal_signoff: 'Laillinen allekirjoitus',
            status_approved: 'Hyväksytty',
            status_submitted_to_mps: 'Lähetetty [[TOK_0]]',
            status_supplement_requested: 'Täydennys pyydetty',
            status_supplement_submitted: 'Täydennys lähetetty',
            status_resubmitted: 'Uudelleenlähetetty',
            status_accepted: 'Hyväksytty',
            status_rejected: 'Hylätty',
            status_closed: 'Suljettu',
            linked_dpia: 'Linkitetty DPIA',
            linked_dpia_none: 'Ei DPIA:ta linkitetty tähän arkistointiin.',
            view_linked_dpia: 'Näytä DPIA',
            linked_dpia_label: 'Tämä dossier-arkistointi on linkitetty seuraavaan DPIA:han:',
        },
        materialisation_health: {
            nav_label: 'Lähetä artefakti terveys',
            page_title: 'Lähetys Artefact Health',
            page_description: 'Havaitse ja korjaa aineiston toteutumiseen liittyvät ongelmat. Listat koskevat organisaatiotasi.',
            failed_title: 'Epäonnistuneet materialisaatiot',
            failed_empty: 'Ei epäonnistuneita materialisaatioita – hyvä.',
            pending_title: 'Hyväksytty, mutta ei toteutunut',
            pending_empty: 'Kaikilla hyväksytyillä hakemuksilla on tukiasiakirja.',
            orphan_title: 'Orpoasiakirjat',
            orphan_description: 'Toteutumalla luodut asiakirjat, joihin ei enää viitata missään tiedostossa – tyypillisesti samanaikaisen kilpailun häviäjä. Listattu tutkittavaksi; puhdistus on manuaalinen.',
            orphan_empty: 'Ei havaittu orpoasiakirjoja.',
            materialise_button: 'Materialisoi nyt',
            column_failure_reason: 'Epäonnistumisen syy',
            column_failed_at: 'Epäonnistui klo',
            column_retries: 'Uudelleenyritykset',
            column_approved_at: 'Hyväksytty klo',
            column_dossier_id: 'Asiakirjan tunnus',
            column_source_filing_id: 'Lähteen arkistointi',
            column_dossier_type: 'Kirjoita',
            column_created_at: 'Luotu klo',
        },
    },
    classification: {
        access_denied_title: 'Pääsy kielletty',
        access_denied: 'Sinulla ei ole tarvittavia oikeuksia käyttää luokitusmoduulia. Ota yhteyttä järjestelmänvalvojaan.',
        nav: {
            taxonomies: 'Luokittelut',
            labeling: 'Merkinnät',
            lifecycle: 'Elinkaari',
            gaps: 'Puuteraportti',
            exports: 'Viennit',
        },
        exports: {
            title: 'Luokitteluviennit',
            csv_section: 'CSV-viennit',
            pdf_section: 'PDF-raportit',
            inventory: 'Inventaario',
            classification_register: 'Luokittelurekisteri',
            raci: 'RACI-matriisi',
            exceptions: 'Poikkeukset',
            evidence_pack: 'Todistepaketti',
            delta_report: 'Deltaraportti',
            executive_summary: 'Johdon yhteenveto',
            exporting: 'Viedään…',
            export_success: 'Vienti onnistui.',
            export_error: 'Vienti epäonnistui. Yritä uudelleen.',
            csv_download: 'CSV-lataus valmis.',
            pdf_download: 'PDF-luonti aloitettu.',
            no_data: 'Ei vietäviä tietoja.',
        },
        delta: {
            title: 'Muutostiedot',
            added: 'Lisätyt',
            removed: 'Poistetut',
            changed: 'Muutetut',
            added_count: 'Lisätyt ({count})',
            removed_count: 'Poistetut ({count})',
            changed_count: 'Muutetut ({count})',
            object_id: 'Kohdetunnus',
            object_type: 'Kohdetyyppi',
            taxonomy: 'Taksonomia',
            level: 'Taso',
            previous: 'Edellinen',
            current: 'Nykyinen',
            no_records: 'Ei tietueita tässä osiossa.',
            empty_section: 'Tämä osio on tyhjä.',
        },
        schedule: {
            title: 'Ajoita löytösykli',
            enabled: 'Käytössä',
            interval_days: 'Väli (päivää)',
            interval_label: 'Suorita N päivän välein',
            manual_only: 'Vain manuaalinen',
            every_n_days: '{n} päivän välein',
            save: 'Tallenna aikataulu',
            cancel: 'Peruuta',
            schedule_updated: 'Aikataulu päivitetty.',
        },
        taxonomies: {
            title: 'Luokittelutaksonomiat',
            new: 'Uusi taksonomia',
            edit: 'Muokkaa taksonomiaa',
            name: 'Nimi',
            levels: 'Luokitustasot',
            seed_defaults: 'Alusta Oletus',
            scope: 'Laajuus',
            scope_organization: 'Organisaatio',
            scope_module_specific: 'Moduuli Tarkka',
            deprecate: 'Vanhenna',
            hide_levels: 'Piilota Tasot',
            versions: 'Versiot',
            hide_versions: 'Piilota Versiot',
            add_level: 'Lisää taso',
            new_level: 'Uusi Taso',
            edit_level: 'Muokkaa Taso',
            code: 'Koodi',
            label: 'Tunniste',
            color: 'Väri',
            ordinal: 'Järjestysluku',
            handling_requirements: 'Handling Vaatimukset',
            version_history: 'Versiohistoria',
            changes: 'Muutokset',
            failed_fetch: 'Epäonnistui: fetch taxonomies. Yritä uudelleen.',
            failed_save: 'Epäonnistui: save taxonomy. Yritä uudelleen.',
            failed_activate: 'Epäonnistui: activate taxonomy. Yritä uudelleen.',
            failed_deprecate: 'Epäonnistui: deprecate taxonomy. Yritä uudelleen.',
            failed_seed: 'Epäonnistui: seed default taxonomies. Yritä uudelleen.',
            failed_fetch_levels: 'Epäonnistui: fetch taxonomy taso. Yritä uudelleen.',
            failed_save_level: 'Epäonnistui: save taxonomy taso. Yritä uudelleen.',
            failed_delete_level: 'Epäonnistui: delete taxonomy taso. Yritä uudelleen.',
            failed_fetch_versions: 'Epäonnistui: fetch taxonomy versions. Yritä uudelleen.',
            loaded_count: 'Ladattu {count} taksonomiaa',
            defaults_seeded: 'Oletustaksonomiat alustettu.',
            no_levels: 'Ei luokitustasoja määritelty — lisää tasoja luokitushierarkian rakentamiseksi.',
            no_versions: 'Ei versiohistoriaa vielä — versiot luodaan, kun aktiivista taksonomiaa päivitetään.',
        },
        labeling: {
            title: 'Tietojen merkintä',
            new: 'Uusi merkintä',
            edit: 'Muokkaa merkintää',
            entity_type: 'Kohteen tyyppi',
            entity_id: 'Kohteen tunnus',
            taxonomy: 'Taksonomia',
            classification_level: 'Luokitustaso',
            applied_by: 'Merkitsijä',
            applied_at: 'Merkitty',
            bulk_apply: 'Joukkomerkkaus',
            bulk_remove: 'Joukkopoisto',
            all_taxonomies: 'Kaikki taksonomiat',
            system: 'Järjestelmä',
            dataset: 'Tietojoukko',
            level_code_placeholder: 'Taso koodi...',
            select_taxonomy: 'Valitse taxonomy...',
            select_level: 'Valitse taso...',
            rationale: 'Perustelu',
            review_date: 'Katselmointia Päivämäärä',
            review: 'Katselmointia',
            selected: 'valittu',
            select_all_labels: 'Valitse kaikki tunnisteet',
            loaded_count: 'Ladattu {count} tunnistetta',
            hide_stale_labels: 'Piilota Vanhentunut Tunnisteet',
            show_conflicts: 'Näytä Conflicts',
            hide_conflicts: 'Piilota Conflicts',
            label_conflicts: 'Tunnisteristiriidat',
            conflict_reason: 'Ristiriidan syy',
            labels: 'Tunnisteet',
            failed_fetch: 'Epäonnistui: fetch labels. Yritä uudelleen.',
            failed_fetch_taxonomies: 'Epäonnistui: fetch taxonomies. Yritä uudelleen.',
            failed_fetch_levels: 'Epäonnistui: fetch taxonomy taso. Yritä uudelleen.',
            failed_save: 'Epäonnistui: save label. Yritä uudelleen.',
            failed_review: 'Epäonnistui: katselmointi label. Yritä uudelleen.',
            failed_bulk: 'Epäonnistui: bulk label. Yritä uudelleen.',
            failed_stale: 'Epäonnistui: fetch stale labels. Yritä uudelleen.',
            failed_conflicts: 'Epäonnistui: fetch label conflicts. Yritä uudelleen.',
            review_permission_denied: 'Sinulla ei ole oikeutta tarkistaa tätä tunnistetta.',
            review_not_found: 'Tunnistetta ei löytynyt — se on ehkä poistettu.',
            approve_selected: 'Hyväksy valitut',
            reject_selected: 'Hylkää valitut',
            approved: 'Hyväksytty',
            rejected: 'Hylätty',
            labels_count: 'tunnisteita',
            failed_count: 'epäonnistui',
            confirm_approve: 'Vahvista hyväksyntä',
            confirm_reject: 'Vahvista hylkäys',
            approve_n_labels: 'Hyväksy {count} tunnistetta?',
            reject_n_labels: 'Hylkää {count} tunnistetta?',
            submit_for_review: 'Lähetä tarkistettavaksi',
            approve: 'Hyväksy',
            reject: 'Hylkää',
            parent_system: 'Ylajarjestelma',
            parent_system_placeholder: 'Valitse ylajarjestelma...',
            parent_system_help: 'Kaytetaan ristiriitojen havaitsemiseen.',
            dataset_level: 'Tietojoukon taso',
            parent_level: 'Ylataso',
            bulk_created: 'Luotu {created} tunniste(tta)',
            bulk_skipped: '{skipped} ohitettu',
            bulk_all_skipped: 'Kaikki {skipped} ohitettu',
            ids_hint: 'Syota tunnukset pilkuilla erotettuna',
            delete_confirm: 'Poista tunniste kohteelle "{id}"?',
        },
        lifecycle: {
            title: 'Tietojen elinkaaren valvonta',
            new: 'Uusi merkintä',
            current_stage: 'Nykyinen vaihe',
            last_transition: 'Viimeisin siirtymä',
            transition: 'Siirtymä',
            view_history: 'Näytä historia',
            stages: {
                creation: 'Luominen',
                collection: 'Kerääminen',
                processing: 'Käsittely',
                storage: 'Tallennus',
                retention: 'Säilytys',
                disposal: 'Hävittäminen',
                archived: 'Arkistoitu',
                active: 'Aktiivinen',
                pending_deletion: 'Odottaa Deletion',
                deleted: 'Poistettu',
                on_hold: 'On Pidätys',
            },
            all_stages: 'Kaikki vaiheet',
            object_id: 'Object Tunniste',
            object_type: 'Object Tyyppi',
            policy_reference: 'Käytäntö Viite',
            retention_period_days: 'Säilytys Kausi (päivää)',
            retention_basis: 'Säilytys Basis',
            deletion_method: 'Deletion Menetelmä',
            deletion_secure_erase: 'Turvallinen poisto',
            deletion_anonymization: 'Anonymisointi',
            deletion_physical_destruction: 'Fyysinen tuhoaminen',
            deletion_other: 'Muu',
            responsible_party: 'Vastuutaho',
            responsible_user_id: 'Responsible Käyttäjä Tunniste',
            retention_expiry: 'Säilytys Expiry',
            hold_reason: 'Pidätys Reason',
            hold: 'Pidätys',
            release: 'Vapauta',
            hide_events: 'Piilota Tapahtumat',
            events_timeline: 'Tapahtumat Timeline',
            add_event: 'Lisää tapahtuma',
            event_type: 'Tapahtumatyyppi',
            create_event: 'Luo Tapahtuma',
            from_stage: 'From Vaihe',
            to_stage: 'To Vaihe',
            actor: 'Toimija',
            reason_placeholder: 'Syy...',
            go: 'Go',
            show_expired_retentions: 'Näytä Vanhentunut Säilytys',
            hide_expired_retentions: 'Piilota Vanhentunut Säilytys',
            expired_retentions_alert: 'Vanhentunut Säilytys Hälytys',
            failed_fetch: 'Epäonnistui: fetch lifecycle tietueet. Yritä uudelleen.',
            failed_save: 'Epäonnistui: save lifecycle tietue. Yritä uudelleen.',
            failed_transition: 'Epäonnistui: transition lifecycle stage. Yritä uudelleen.',
            failed_hold: 'Epäonnistui: place hold. Yritä uudelleen.',
            failed_release: 'Epäonnistui: release hold. Yritä uudelleen.',
            failed_fetch_events: 'Epäonnistui: fetch lifecycle tapahtuma. Yritä uudelleen.',
            failed_create_event: 'Epäonnistui: create lifecycle tapahtuma. Yritä uudelleen.',
            failed_expired: 'Epäonnistui: fetch expired retentions. Yritä uudelleen.',
            hold_reason_prompt: 'Syötä hold reason:',
            loaded_count: 'Ladattu {count} elinkaaren tietuetta',
            stage_transition_for: 'Vaiheen siirtymä kohteelle {id}',
            event_created: 'Luotu',
            event_updated: 'Päivitetty',
            event_approved: 'Hyväksytty',
            event_deprecated: 'Vanhentunut',
            event_proposed: 'Ehdotettu',
            event_reviewed: 'Tarkistettu',
            event_archived: 'Arkistoitu',
            event_restored: 'Palautettu',
        },
        gap_report: {
            title: 'Luokituksen puuteraportti',
            unlabeled: 'Merkitsemättömät tiedot',
            missing_lifecycle: 'Puuttuva elinkaari',
            stale_labels: 'Vanhentuneet merkinnät',
            run_detection: 'Suorita Puute Detection',
            detecting: 'Havaitaan...',
            detection_complete: 'Puute detection complete. {count} gap(s) detected.',
            detection_failed: 'Puute detection epäonnistunut.',
            by_severity: 'By Vakavuus',
            by_gap_type: 'By Puute Tyyppi',
            all_gap_types: 'Kaikki puutetyypit',
            conflicting_labels: 'Conflicting Tunnisteet',
            expired_retention: 'Vanhentunut Säilytys',
            missing_handling: 'Puuttuvien käsittely',
            info: 'Tiedot',
            gap_type: 'Puutetyyppi',
            object_id: 'Object Tunniste',
            object_type: 'Object Tyyppi',
            detected_at: 'Havaittu',
            open: 'Avaa',
            acknowledged: 'Kuitattu',
            remediated: 'Korjattu',
            accepted: 'Hyväksytty',
            acknowledge: 'Kuittaa',
            remediate: 'Korjaa',
            accept_risk: 'Hyväksy riski',
            accept_risk_prompt: 'Syötä riski acceptance perustelu:',
            failed_fetch: 'Epäonnistui: fetch puute. Yritä uudelleen.',
            failed_acknowledge: 'Epäonnistui: acknowledge puute. Yritä uudelleen.',
            failed_remediate: 'Epäonnistui: remediate puute. Yritä uudelleen.',
            failed_accept_risk: 'Epäonnistui: accept puute riski. Yritä uudelleen.',
            failed_detect: 'Epäonnistui: run puute detection. Yritä uudelleen.',
            loaded_count: 'Ladattu {count} luokitteluaukkoa',
            related_object_id: 'Liittyvän kohteen tunnus',
            related_object_type: 'Liittyvän kohteen tyyppi',
            gap_types: {
                unlabeled_asset: 'Tunnisteeton kohde',
                missing_lifecycle: 'Puuttuva elinkaari',
                expired_retention: 'Vanhentunut sailytys',
                extended_pending_deletion: 'Pidennetty poisto odottaa',
            },
        },
        label_workflow: {
            title: 'Tunnisteen työnkulku',
            proposed: 'Ehdotettu',
            under_review: 'Arvioitavana',
            approved: 'Hyväksytty',
            deprecated: 'Vanhentunut',
            submit_review: 'Lähetä arvioitavaksi',
            approve: 'Hyväksy tunniste',
            deprecate: 'Merkitse vanhentuneeksi',
            bulk_approve: 'Joukkohyväksyntä',
            bulk_approve_success: 'Tunnisteet hyväksytty.',
            submit_success: 'Tunniste lähetetty arvioitavaksi.',
            approve_success: 'Tunniste hyväksytty.',
            deprecate_success: 'Tunniste merkitty vanhentuneeksi.',
        },
        review_tasks: {
            title: 'Arviointitehtävät',
            create: 'Uusi arviointitehtävä',
            system: 'Järjestelmä',
            owner: 'Omistaja',
            description: 'Kuvaus',
            resolution: 'Ratkaisu',
            resolve: 'Ratkaise',
            approve: 'Hyväksy',
            modify: 'Muokkaa',
            reject: 'Hylkää',
            escalate: 'Eskaloi',
            escalated: 'Eskaloidut tehtävät',
            no_tasks: 'Ei arviointitehtäviä.',
            resolve_success: 'Arviointitehtävä ratkaistu.',
            status_pending: 'Odottaa',
            status_resolved: 'Ratkaistu',
            status_escalated: 'Eskaloitu',
            notes: 'Muistiinpanot',
            create_success: 'Tarkistustehtävä luotu.',
            no_tasks_detail: 'Ei tarkistustehtäviä vielä — luo tehtävä tunnisteiden tarkistusten osoittamiseksi järjestelmänomistajille.',
            label_id: 'Tunnisteen tunnus',
            system_id: 'Järjestelmätunnus',
            system_name: 'Järjestelmän nimi',
            owner_id: 'Omistajan tunnus',
            resolution_col: 'Ratkaisu',
            notes_col: 'Muistiinpanot',
        },
        exceptions: {
            title: 'Poikkeusjono',
            create: 'Uusi poikkeus',
            severity: 'Vakavuus',
            system: 'Järjestelmä',
            owner: 'Omistaja',
            resolve: 'Ratkaise',
            no_exceptions: 'Poikkeuksia ei löytynyt.',
            resolve_success: 'Poikkeus ratkaistu.',
            dashboard_open: 'Avoimet poikkeukset',
            dashboard_resolved: 'Ratkaistut poikkeukset',
            dashboard_total: 'Yhteensa',
            dashboard_by_severity: 'Vakavuuden mukaan',
            status_open: 'Avoin',
            status_resolved: 'Ratkaistu',
            status_accepted_risk: 'Hyväksytty riski',
            create_success: 'Poikkeus luotu.',
            no_exceptions_detail: 'Ei poikkeuksia vielä — poikkeukset luodaan vakavista puutteista, jotka vaativat erityiskäsittelyä.',
            gap_id: 'Puutteen tunnus',
            system_id: 'Järjestelmätunnus',
            system_name: 'Järjestelmän nimi',
            owner_id: 'Omistajan tunnus',
            resolution_notes: 'Ratkaisun muistiinpanot',
            resolution_notes_placeholder: 'Kuvaile kuinka tämä poikkeus ratkaistiin...',
        },
        enterprise_map: {
            title: 'Yrityksen datakartta',
            inventory: 'Dataluettelo',
            total_systems: 'Järjestelmät yhteensä',
            total_labels: 'Tunnisteet yhteensä',
            approved_count: 'Hyväksytyt tunnisteet',
            proposed_count: 'Ehdotetut tunnisteet',
            no_data: 'Luokittelutietoja ei saatavilla.',
            no_approved_labels: 'Ei hyväksyttyjä tunnisteita vielä — tunnisteet on tarkistettava ja hyväksyttävä ennen kuin ne näkyvät datakartalla.',
            loaded_count: 'Yritystietokartta ladattu',
        },
        discovery: {
            title: 'Löytösyklit',
            create: 'Uusi sykli',
            cycle_name: 'Syklin nimi',
            run_delta: 'Suorita deltatunnistus',
            delta_success: 'Deltatunnistus valmis.',
            create_success: 'Löytösykli luotu.',
            no_cycles: 'Ei löytösyklejä.',
            status_created: 'Luotu',
            status_scanning: 'Skannaus',
            status_review: 'Tarkista',
            status_approved: 'Hyväksytty',
            status_published: 'Julkaistu',
            status_draft: 'Luonnos',
            running: 'Käynnissä',
            completed: 'Valmis',
            cancelled: 'Peruutettu',
            delta_result_summary: 'Löydettiin {added} lisättyä, {removed} poistettua, {changed} muutettua tunnistetta.',
            delta_results: 'Deltatuloukset',
            view_results: 'Näytä tulokset',
            scope_type: 'Laajuustyyppi',
            scope_type_all: 'Kaikki',
            scope_type_systems: 'Järjestelmät',
            scope_type_datasets: 'Tietojoukot',
            scope_ids: 'Laajuustunnukset',
            scope_ids_placeholder: 'Anna tunnukset pilkuilla erotettuina',
            cycle_explanation: 'Etsintäsykli skannaa tietoinfrastruktuurisi tietoresurssien tunnistamiseksi, luokittelemiseksi ja seuraamiseksi. Määritä laajuus kohdistamaan tiettyjä järjestelmiä tai tietojoukkoja.',
            empty_state_title: 'Ei vielä löytösyklejä',
            empty_state_description: 'Luo ensimmäinen etsintäjakso aloittaaksesi tietoresurssien skannauksen ja luokittelun.',
            empty_state_cta: 'Luo ensimmäinen sykli',
            validation_name_required: 'Jakson nimi vaaditaan',
            validation_scope_type_required: 'Laajuustyyppi vaaditaan',
            validation_scope_ids_required: 'Vähintään yksi laajuustunnus vaaditaan',
        },
        regulatory: {
            sensitivity_importance_info: 'Tietolaki (laki [[TOK_0]], vaatimus 18e4bfd1) edellyttää luokittelua sekä herkkyyden että tärkeyden mukaan erillisinä ulottuvuuksina. Luo yksi taksonomia kullekin ulottuvuudelle täyttääksesi tämän vaatimuksen.',
            handling_rules_info: 'Jokaisella luokitustasolla tulisi määritellä käsittelysäännöt pyyntöä kohti. b89981ac ("Määritä käsittelysäännöt luokitustason mukaan").',
            template_internal_ids_info: 'Kaikki luokitusmallit käyttävät sisäisiä tunnuksia (esim. vn_data_law_data_classification_record). Mitään mallia ei esitetä virallisena ministeriön lomakkeena.',
            ai_risk_tiers_info: '[[TOK_0]] Laki (laki [[TOK_3]], vaatimus 3a87ad63) määrittelee neljä [[TOK_1]]-järjestelmän riskitasoa: minimaalinen, rajoitettu, korkea ja ei-hyväksyttävä. Luo [[TOK_2]] riskitaksonomia näillä tasoilla.',
            ai_risk_tier_minimal: 'Minimaalinen',
            ai_risk_tier_limited: 'Rajoitettu',
            ai_risk_tier_high: 'Korkea',
            ai_risk_tier_unacceptable: 'Ei-hyvaksyttava',
            ai_register_info: '[[TOK_0]] luokitustietueiden tulee linkittää [[TOK_1]] järjestelmärekisterimerkintään (req. 0f4475d3), joka kaappaa: järjestelmän nimi, omistaja, tarkoitus, käyttöönottokonteksti, riskitaso, toimittajan osallistuminen.',
            ai_template_internal_info: '[[TOK_0]]-luokitusmallit käyttävät sisäisiä tunnuksia (esim. [[TOK_1]]-RISK-01). Virallisia [[TOK_2]]-paikkamerkkitunnuksia ([[TOK_3]]-HC-01 - [[TOK_4]]-HC-08) ei käytetä.',
            ai_audit_trail_info: '[[TOK_0]] luokittelumuutokset tuottavat versioidun kirjausketjun UC-VN-06: toimija, aikaleima, edellinen arvo, uusi arvo ja perustelut.',
            lifecycle_data_d1_info: 'Elinkaarisiirtymät kartoitetaan Data Law -menettelyyn DATA-D1 vaiheet: luetteloi, luokittele, määritä käsittelysäännöt, kerää todisteet, ajoita tarkistukset.',
            lifecycle_deletion_link_info: 'Luokiteltu tietoresurssi, joka saavuttaa käyttöikänsä lopun, käynnistää poistoaikataulutietueen deletion Orchestration -moduulin kautta.',
            lifecycle_evidence_info: 'Jokainen elinkaaritilan muutos (luonnos, aktiivinen, aliarvioitu, arkistoitu, poistettu) tallentaa toimijan, aikaleiman ja perustelun kirjausketjun merkinnäksi.',
            escalation_timers_info: 'UC-VN-10 eskaloinnin määräajat: 5 arkipäivää omistajan tarkastukselle, 48 tuntia poikkeuseskalaatiolle, 72 tuntia korkean riskin/arkaluonteisille kohteille.',
            escalation_owner_review: '5 arkipaivaa',
            escalation_exception: '48 tuntia',
            escalation_high_risk: '72 tuntia',
            gap_risk_areas_info: 'Tietolaki req. f6c3060a ("Datariskin arviointi") vaatii puutteiden analysoinnin neljältä riskialueelta: yksityisyys, kyberturvallisuus, kulunvalvonta ja toimintariski.',
            gap_risk_area_privacy: 'Tietosuoja',
            gap_risk_area_cybersecurity: 'Kyberturvallisuus',
            gap_risk_area_access: 'Paasyinhallinta',
            gap_risk_area_operational: 'Operatiivinen',
            gap_framework_filter_info: 'Suodata aukkoja sääntelykehyksen (VN_DATA_LAW tai VN_AI_LAW_2026) mukaan nähdäksesi tarvittavat aukot kullekin sääntelyalueelle.',
            framework_vn_data_law: 'VN Tietolaki',
            framework_vn_ai_law: 'VN Tekoalylaki 2026',
            enterprise_map_approved_info: 'Tämä datakartta näyttää vain hyväksytyt luokitustietueet UC-VN-10-työnkulun vaiheessa 10 ("Hyväksyttyjen tarrojen tulee nykyinen yrityksen totuus"). Luonnokset ja ehdotetut tietueet eivät sisälly.',
            exports_bundle_info: 'Vientipaketit sisältävät: luokitusrekisterin, käsittelysäännöt, omistajuuden/RACI:n ja todistepaketin – jotka vastaavat UC-VN-10 vientivaatimuksia ja DATA-EVD-01 todistelomakkeen muotoa.',
        },
    },
    monitoring: {
        no_permission_title: 'Riittamattomat oikeudet',
        no_permission_message: 'Sinulla ei ole oikeutta kayttaa tata valvontamoduulia.',
        errors: {
            fetch: 'Epäonnistui: load. Yritä uudelleen.',
            save: 'Epäonnistui: save. Yritä uudelleen.',
            fetch_programs_failed: 'Epäonnistui: fetch programs. Yritä uudelleen.',
            fetch_kpi_failed: 'Epäonnistui: fetch KPI tiedot. Yritä uudelleen.',
            create_snapshot_failed: 'Epäonnistui: create snapshot. Yritä uudelleen.',
            fetch_periods_failed: 'Epäonnistui: fetch periods. Yritä uudelleen.',
            create_period_failed: 'Epäonnistui: create period. Yritä uudelleen.',
            auto_generate_failed: 'Epäonnistui: auto-generate periods. Yritä uudelleen.',
            start_period_failed: 'Epäonnistui: start period. Yritä uudelleen.',
            close_period_failed: 'Epäonnistui: close period. Yritä uudelleen.',
            save_program_failed: 'Epäonnistui: save program. Yritä uudelleen.',
            activate_program_failed: 'Epäonnistui: activate program. Yritä uudelleen.',
            pause_program_failed: 'Epäonnistui: pause program. Yritä uudelleen.',
            complete_program_failed: 'Epäonnistui: complete program. Yritä uudelleen.',
            archive_program_failed: 'Epäonnistui: archive program. Yritä uudelleen.',
            fetch_ric_templates_failed: 'Epäonnistui: fetch RIC mallit. Yritä uudelleen.',
            fetch_ric_cases_failed: 'Epäonnistui: fetch RIC cases. Yritä uudelleen.',
            create_ric_case_failed: 'Epäonnistui: create RIC case. Yritä uudelleen.',
            transition_ric_failed: 'Epäonnistui: transition RIC case. Yritä uudelleen.',
            add_follow_up_failed: 'Epäonnistui: add follow-up. Yritä uudelleen.',
            respond_follow_up_failed: 'Epäonnistui: respond to follow-up. Yritä uudelleen.',
            link_evidence_failed: 'Epäonnistui: link todistusaineisto. Yritä uudelleen.',
            fetch_task_templates_failed: 'Epäonnistui: fetch tehtävä mallit. Yritä uudelleen.',
            save_task_template_failed: 'Epäonnistui: save tehtävä malli. Yritä uudelleen.',
            delete_task_template_failed: 'Epäonnistui: delete tehtävä malli. Yritä uudelleen.',
            delete_framework_link_failed: 'Kehyslinkin poistaminen epäonnistui.',
            seed_defaults_failed: 'Epäonnistui: seed defaults. Yritä uudelleen.',
            fetch_tasks_failed: 'Epäonnistui: fetch tehtävä. Yritä uudelleen.',
            create_task_failed: 'Epäonnistui: create tehtävä. Yritä uudelleen.',
            instantiate_tasks_failed: 'Epäonnistui: instantiate tehtävä. Yritä uudelleen.',
            start_task_failed: 'Epäonnistui: start tehtävä. Yritä uudelleen.',
            complete_task_failed: 'Epäonnistui: complete tehtävä. Yritä uudelleen.',
            defer_task_failed: 'Epäonnistui: defer tehtävä. Yritä uudelleen.',
            block_task_failed: 'Epäonnistui: block tehtävä. Yritä uudelleen.',
            override_complete_failed: 'Epäonnistui: override complete. Yritä uudelleen.',
            assign_task_failed: 'Epäonnistui: assign tehtävä. Yritä uudelleen.',
            update_checklist_failed: 'Epäonnistui: update checklist. Yritä uudelleen.',
        },
        nav: {
            programs: 'Ohjelmat',
            periods: 'Kaudet',
            task_templates: 'Tehtävämallit',
            tasks: 'Tehtävät',
            kpi: 'KPI-yhteenveto',
            ric: 'Viranomaistiedustelut',
            framework_link: 'Kehysvalvonta',
            authority_readiness: 'Viranomaisvalmius',
            change_review: 'Muutostarkastus',
            raci: 'RACI Matrix',
        },
        programs: {
            page_title: 'Valvontaohjelmat',
            title: 'Valvontaohjelmat',
            new: 'Uusi ohjelma',
            edit: 'Muokkaa ohjelmaa',
            name: 'Nimi',
            scope: 'Laajuus',
            frequency: 'Tiheys',
            owner: 'Omistaja',
            activate: 'Aktivoi',
            pause: 'Keskeytä',
            resume: 'Jatka',
            complete: 'Valmis',
            archive: 'Arkistoi',
            custom_frequency_days: 'Mukautettu Tiheys (päivää)',
            select_user: 'Valitse käyttäjä…',
            assign_training: 'Määritä koulutus',
            linked_forms: 'Linkitetyt lomakkeet',
            linked_forms_none: 'Ei linkitettyjä lomakkeita vielä',
            loaded_count: 'Ladattu {0} ohjelmaa',
            scope_labels: {
                full: 'Täysi',
                partial: 'Osittainen',
                targeted: 'Kohdennettu',
                consent: 'Suostumus',
                dpia: 'DPIA',
                vendors: 'Toimittajat',
                classification: 'Luokitus',
                rights_requests: 'Oikeuspyynnöt',
                data_mapping: 'Tietokartoitus',
                transfers: 'Siirrot',
                security_monitoring: 'Turvallisuuden valvonta',
                authority_response: 'Viranomaisen vastaus',
                evidence_preservation: 'Todisteiden säilyttäminen',
                localization_review: 'Lokalisoinnin tarkistus',
                ai_system_registration: '[[TOK_0]] Järjestelmän rekisteröinti',
                ai_pre_deployment: '[[TOK_0]] Käyttöönottoa edeltävä arviointi',
                ai_transparency: '[[TOK_0]] Läpinäkyvyystarkastus',
                ai_incident_review: '[[TOK_0]] Tapahtumakatsaus',
            },
            framework_cadence_info: 'Cybersecurity Law programs typically use continuous/monthly/quarterly cadences. AI Law programs typically use annual review cadences.',
        },
        periods: {
            page_title: 'Valvontajaksot',
            title: 'Tarkastuskaudet',
            new: 'Uusi kausi',
            label: 'Kauden nimi',
            start_date: 'Alkamispäivä',
            end_date: 'Päättymispäivä',
            reviewers: 'Tarkastajat',
            auto_generate: 'Luo kaudet automaattisesti',
            start: 'Aloita',
            close: 'Sulje',
            change_digest: 'Muutoskooste',
            no_digest: 'Ei digest available. löytynyt',
            reviewers_count: 'Arvioija Lukumäärä',
            select_program: 'Valitse ohjelma',
            select_program_prompt: 'Valitse a program to view periods.',
            hide_digest: 'Piilota Digest',
            loaded_count: '{0} jaksoa ladattu',
            periods_auto_generated: 'Jaksot autogeneroitu',
            label_placeholder: 'esim. 2026-Q1',
        },
        task_templates: {
            page_title: 'Tehtävämallit',
            title: 'Tehtävämallit',
            new: 'Uusi malli',
            edit: 'Muokkaa mallia',
            category: 'Kategoria',
            priority: 'Prioriteetti',
            checklist_items: 'Tarkistuslistan kohteet',
            effort: 'Arvioitu työmäärä (tuntia)',
            pre_seeded: 'Esitäytetty',
            seed_defaults: 'Lataa oletusarvot',
            add_checklist: 'Lisää tarkistuslistan kohde',
            guidance: 'Ohjeet',
            all_categories: 'Kaikki kategoriat',
            loaded_count: '{0} tehtävämallia ladattu',
            defaults_seeded: 'Oletustehtävämallit luotu',
            checklist_item_label: 'Tarkistuslistan kohta {0}',
            remove_checklist_item: 'Poista tarkistuslistan kohta {0}',
            category_info: 'Categories cover PDPL compliance, Cybersecurity Law tasks, and AI Law tasks.',
        },
        tasks: {
            page_title: 'Tarkistusetehtävät',
            title: 'Tarkastustehtävät',
            new: 'Uusi tehtävä',
            assigned_to: 'Vastuuhenkilö',
            due_date: 'Määräaika',
            checklist: 'Tarkistuslista',
            start: 'Aloita',
            complete: 'Valmis',
            defer: 'Lykkää',
            block: 'Estä',
            override_complete: 'Pakota valmiiksi',
            link_evidence: 'Linkitä todistusaineisto',
            direct_upload_label: 'Lataa todistetiedosto',
            instantiate: 'Luo malleista',
            defer_reason: 'Lykkäyksen syy',
            override_justification: 'Pakottamisen perustelu',
            filter_assignee: 'Suodata by assignee',
            select_period: 'Valitse kausi',
            select_program: 'Valitse ohjelma',
            select_program_period_prompt: 'Valitse a program and period to view tehtävä.',
            assign_placeholder: 'Määritä to...',
            loaded_count: 'Ladattu {0} tehtävää',
            tasks_instantiated: 'Tehtävät luotu malleista',
            overdue: 'Myöhässä',
            checklist_for: 'tarkistuslista kohteelle',
            manage_checklist: 'Hallitse tarkistuslistaa',
            add_checklist_item: 'Lisää kohde',
            checklist_item_label: 'Kohde',
            checklist_item_description: 'Kuvaus',
            remove_checklist_item: 'Poista kohde',
            save_checklist: 'Tallenna tarkistuslista',
            no_checklist_items: 'Ei vielä tarkistuslistan kohteita.',
            confirm_delete_attachment: 'Haluatko varmasti poistaa tämän todistetiedoston? Tätä ei voi kumota.',
        },
        kpi: {
            page_title: 'KPI-näkymä',
            title: 'KPI-yhteenveto',
            kpi_name: 'KPI:n nimi',
            current_value: 'Nykyinen arvo',
            target: 'Tavoite',
            trends: 'Trendit',
            capture_snapshot: 'Capture Tilannekuva',
            select_program: 'Valitse ohjelma',
            select_program_prompt: 'Valitse a program to view kpi.',
            snapshot: 'Tilannekuva',
            kpi_labels: {
                on_track: 'Aikataulussa',
                at_risk: 'At Riski',
                behind: 'Jäljessä',
                rights_request_sla_rate: 'Oikeuspyyntöjen SLA-aste',
                vendor_review_currency: 'Toimittajatarkistuksen ajantasaisuus',
                dpia_completion_rate: 'DPIA-valmistumisaste',
                classification_coverage: 'Luokituskattavuus',
                consent_policy_currency: 'Suostumuspolitiikan ajantasaisuus',
                security_event_detection_rate: 'Turvatapahtuman havaitsemisprosentti',
                evidence_preservation_compliance_rate: 'Todisteiden säilyttämisen vaatimustenmukaisuusaste',
                authority_response_timeliness: 'Viranomaisten vastauksen oikea-aikaisuus',
                localization_readiness_score: 'Lokalisoinnin valmiuspisteet',
                ai_register_completeness: '[[TOK_0]] Järjestelmärekisterin täydellisyys',
                pre_deployment_gate_pass_rate: 'Käyttöönottoa edeltävä portin pääsyprosentti',
                transparency_disclosure_coverage: 'Avoimuustietojen kattavuus',
                ai_incident_readiness_score: '[[TOK_0]] Tapahtumavalmiuden pisteet',
            },
            pdpl_kpi_info: 'The predefined KPI codes are PDPL-specific metrics. For Cybersecurity Law or AI Law monitoring, use framework-specific KPI codes.',
            cybersec_kpi_info: 'Kyberturvallisuuslain KPI:t: turvallisuustapahtumien havaitsemisprosentti, todisteiden säilyttämisen vaatimustenmukaisuusaste, viranomaisten vastauksen oikea-aikaisuus, lokalisointivalmiuspisteet.',
            ai_law_kpi_info: '[[TOK_0]] Lain KPI:t: [[TOK_1]] Järjestelmärekisterin täydellisyys, käyttöönottoa edeltävän portin pääsyprosentti, läpinäkyvyyden paljastamisen kattavuus, [[TOK_2]] tapahtumavalmiuspiste.',
            no_data: 'Ei tiedot available. löytynyt',
            snapshot_date: 'Tilannekuva Päivämäärä',
            loaded_count: 'Ladattu {0} KPI-tilannekatsa­usta',
            snapshot_captured: 'KPI-tilannekatsaus otettu',
            showing_chart: 'Näytetään kaavionäkymä',
            showing_table: 'Näytetään taulukonäkymä',
            aria_current_values: 'KPI nykyiset arvot',
            kpi_label: 'KPI',
            actual: 'Toteutunut',
            trend: 'Suuntaus',
            notes: 'Huomiot',
            trend_up: 'Nouseva',
            trend_down: 'Laskeva',
            trend_stable: 'Vakaa',
        },
        ric: {
            page_title: 'RIC-tapaukset',
            title: 'Viranomaistiedustelut',
            new: 'Uusi tiedustelutapaus',
            reference: 'Viite',
            regulator: 'Viranomainen',
            inquiry_type: 'Tiedustelun tyyppi',
            deadline: 'Vastauksen määräaika',
            lead: 'Vastuuhenkilö',
            follow_ups: 'Jatkotoimet',
            add_follow_up: 'Lisää jatkotoimi',
            respond: 'Vastaa',
            question: 'Kysymys',
            response: 'Vastaus',
            asked_at: 'Kysytty',
            no_follow_ups: 'Ei vielä jatkotoimenpiteitä.',
            received_date: 'Received Päivämäärä',
            responded_at: 'Vastattu',
            hide_follow_ups: 'Piilota Follow-ups',
            inquiry_types: {
                general: 'Yleinen',
                investigation: 'Tutkimus',
                audit: 'Tarkastus',
                complaint: 'Valitus',
                general_audit: 'Yleinen tarkastus',
                rights_requests_review: 'Oikeuspyyntöjen tarkastus',
                cross_border_transfer_review: 'Rajat ylittävien siirtojen tarkastus',
                vendor_governance_review: 'Toimittajien hallinnan tarkastus',
                consent_management_review: 'Suostumustenhallinnan tarkastus',
                data_mapping_ropa_review: 'Tietokartoituksen / ROPA-tarkastus',
                incident_readiness_review: 'Häiriövalmiuden tarkastus',
                security_access_control_review: 'Tietoturvan ja pääsynhallinnan tarkastus',
                targeted_processing_review: 'Kohdennetun käsittelyn tarkastus',
                bank_readiness_pack: 'Pankkivalmiuspaketti',
            },
            link_evidence: 'Linkitä Todistusaineisto',
            loaded_count: '{0} RIC-tapausta ladattu',
            to_follow_up: 'seurantakysymykseen',
            overdue: 'Myöhässä',
            overdue_indicator: 'Vastausaika ylitetty',
            template_info: 'RIC templates are internal platform templates. They are not official government-mandated forms.',
            status_labels: {
                received: 'Vastaanotettu',
                in_triage: 'Lajittelussa',
                evidence_gathering: 'Todisteiden keruu',
                response_drafting: 'Vastausluonnos',
                internal_review: 'Sisäinen tarkistus',
                submitted: 'Lähetetty',
                follow_up: 'Seuranta',
                closed: 'Suljettu',
            },
        },
        framework_link: {
            title: 'Kehyslinkitetty valvonta',
            link_program: 'Linkitä ohjelma kehykseen',
            framework_code: 'Kehyskoodi',
            select_framework: 'Valitse viitekehys...',
            select_program: 'Valitse ohjelma...',
            readiness_score: 'Valmiuspisteet',
            no_links: 'Kehyslinkitettyjä ohjelmia ei löytynyt',
            seed_defaults: 'Luo oletusmallit',
            program_id: 'Ohjelma-ID',
            program: 'Ohjelma',
        },
        authority_readiness: {
            title: 'Viranomaispyyntövalmius',
            create_entry: 'Uusi valmiusmerkintä',
            select_framework: 'Valitse viitekehys...',
            framework_code: 'Kehys',
            readiness_status: 'Valmiustila',
            readiness_package: 'Valmiuspaketti',
            run_drill: 'Suorita valmiusharjoitus',
            drill_success: 'Valmiusharjoitus kirjattu',
            last_drill: 'Viimeisin harjoitus',
            never_drilled: 'Ei koskaan',
            no_readiness: 'Viranomaisvalmiustietoja ei löytynyt',
            entry_created: 'Valmiusmerkintä luotu',
            ready: 'Valmis',
            partial: 'Osittainen',
            not_ready: 'Ei valmis',
            items: 'kohteet',
        },
        change_review: {
            title: 'Sääntelymuutosten tarkastus',
            new_review: 'Uusi muutostarkastus',
            change_id: 'Muutos-ID',
            select_change: 'Valitse muutos...',
            select_framework: 'Valitse viitekehys...',
            impact_assessment: 'Vaikutusarviointi',
            decision: 'Päätös',
            no_action: 'Ei toimenpiteitä',
            internal_update: 'Sisäinen päivitys',
            authority_filing: 'Viranomaishakemus',
            no_reviews: 'Muutostarkastuksia ei löytynyt',
            auto_cycle: 'Automaattinen tarkastuskierto',
            cadence: 'Tarkastustiheys',
            framework: 'Viitekehys',
        },
        export_csv: 'Vie [[TOK_0]]',
        exporting: 'Viedään…',
        export_success: '[[TOK_0]] vietiin onnistuneesti.',
        export_failed: '[[TOK_0]] vienti epäonnistui.',
        export_attestation_pack: 'Vientitodistuspaketti',
        staleness: {
            badge_label: '[[TOK_1]] vanhentunutta kohdetta',
            days_since: '[[TOK_1]] päivää edellisestä päivityksestä',
            detail_title: 'Vanhentuneet esineet',
            accept_justification: 'Hyväksy perustelulla',
            justification_label: 'Perustelut',
            no_stale: 'Vanhoja kohteita ei löytynyt.',
            threshold_label: 'Vanhentumiskynnys (päivää)',
            threshold_min: 'Vähintään 30 päivää',
            threshold_max: 'Enintään 730 päivää',
            threshold_saved: 'Vanhentumiskynnys päivitetty.',
        },
        csv_columns: {
            name: 'Nimi',
            status: 'Tila',
            owner: 'Omistaja',
            created_at: 'Luotu klo',
            updated_at: 'Päivitetty klo',
            scope: 'Laajuus',
            frameworks: 'Kehykset',
            period_label: 'Kauden etiketti',
            start_date: 'Aloituspäivämäärä',
            end_date: 'Päättymispäivämäärä',
            task_count: 'Tehtävien määrä',
            completion_rate: 'Valmistumisaste',
            title: 'Otsikko',
            assigned_to: 'Määrätty vastaanottajalle',
            due_date: 'Eräpäivä',
            priority: 'Prioriteetti',
            completed_at: 'Valmistunut klo',
            kpi_code: '[[TOK_0]] Koodi',
            kpi_label: '[[TOK_0]] Tunniste',
            target: 'Kohde',
            actual: 'Todellinen',
            trend: 'Trendi',
            reference: 'Viite',
            regulator: 'Säädin',
            inquiry_type: 'Kyselyn tyyppi',
            lead: 'Lyijy',
            received_date: 'Vastaanottopäivämäärä',
            deadline: 'Määräaika',
            framework_code: 'Puitekoodi',
            readiness_status: 'Valmiustila',
            package_count: 'Pakettien määrä',
            change_id: 'Vaihda ID',
            impact_assessment: 'Vaikutusten arviointi',
            decision: 'Päätös',
            program: 'Ohjelma',
            readiness_score: 'Valmiuspisteet',
            category: 'Luokka',
            checklist_count: 'Tarkistuslistan määrä',
            effort_hours: 'Ponnistelu (tunteja)',
            version: 'Versio',
            department: 'osasto',
            function_area: 'Toimintoalue',
            role: 'Rooli',
            assignee: 'Valtuutettu',
            frequency: 'Taajuus',
        },
        raci: {
            page_title: 'Hallinto RACI Matrix',
            title: 'Hallinto RACI Matrix',
            department: 'osasto',
            function_area: 'Toimintoalue',
            responsible: 'Vastuullinen',
            accountable: 'Vastuullinen',
            consulted: 'Konsultoitu',
            informed: 'Tietoinen',
            assign_role: 'Määritä RACI-rooli',
            select_program: 'Valitse Ohjelma',
            select_program_prompt: 'Valitse ohjelma tarkastellaksesi RACI-matriisia.',
            no_assignments: 'RACI-tehtäviä ei löytynyt.',
            role_updated: 'RACI-tehtävä päivitetty.',
            role_labels: {
                R: 'Vastuullinen',
                A: 'Vastuullinen',
                C: 'Konsultoitu',
                I: 'Tietoinen',
            },
            loaded_count: 'Ladattu [[TOK_1]] RACI-tehtäviä',
            single_accountability_warning: 'Vain yksi vastuullinen (A) rooli on sallittu toimintoaluetta kohden. Uuden vastuullisen roolin määrittäminen korvaa nykyisen.',
            cybersec_function_areas: 'Kyberturvallisuuslain toimintoalueet: Tapauksiin reagointi, todisteiden säilyttäminen, viranomaisten yhteistyö, lokalisoinnin tarkistus.',
            ai_law_function_areas: '[[TOK_0]] Lain toiminta-alueet: järjestelmän rekisteröinti, käyttöönottoa edeltävä arviointi, läpinäkyvyys, tapausten käsittely.',
            suggested_function_areas: 'Suositellut toiminta-alueet',
        },
        prior_cycle: {
            link_label: 'Linkki aikaisempaan kiertoon',
            select_prior: 'Valitse edellinen sykli…',
            linked: 'Vuodesta toiseen',
            no_prior: 'Aikaisempia jaksoja ei ole saatavilla.',
            linked_success: 'Aikaisempi sykli yhdistetty.',
        },
        digest_table: {
            module: 'Moduuli',
            entity_type: 'Entiteettityyppi',
            change_type: 'Muuta tyyppiä',
            description: 'Kuvaus',
            changed_at: 'Vaihdettu klo',
        },
        view_related_ric: 'Katso liittyviä RIC-tapauksia',
        linked_program: 'Linkitetty ohjelma',
        nav_raci: 'RACI Matrix',
    },
    incidents: {
        authority_response_draft: {
            draft_label: 'Vastausluonnos',
            drafting: 'Luonnostetaan…',
            results_heading: 'Luonnolliset vastaukset ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            counsel_label: 'Asianajajan arviointi vaaditaan:',
            counsel_default: 'Vähintään yksi vastaus vaatii neuvonantajan tarkastuksen ennen lähettämistä.',
            requires_counsel_label: 'Vaatii neuvonantajan tarkastuksen.',
            accept_label: 'Hyväksy luonnos',
            reject_label: 'Hylkää luonnos',
            error_generic: 'Vastausta ei voitu laatia. Yritä uudelleen tai tarkenna kyselytekstiä.',
        },
        breach_timeline: {
            compute_label: 'Laske rikkomusilmoitusten aikajana',
            computing: 'Lasketaan…',
            results_heading: 'Rikkomusilmoitusten määräajat ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            handoff_label: 'Forseti ehdottaa:',
            empty_label: 'Ei sovellettavia puitteita asianomaisille lainkäyttöalueille.',
            mandatory_label: 'Pakolliset kentät:',
            draft_label: 'Ilmoitusluonnos',
            remaining_label: '[[TOK_1]] tuntia jäljellä',
            overdue_label: 'MYÖNNETTY',
            acknowledge_label: 'Acknowledge — ulkoisesti luodut tehtävät',
            acknowledging: 'Tunnustetaan…',
            error_generic: 'Rikkomisen aikajanaa ei voitu laskea. Yritä uudelleen.',
        },
        breach_determination: {
            confirmed_breach: 'Confirmed Tietoturvaloukkaus',
            suspected_breach: 'Suspected Tietoturvaloukkaus',
            not_a_breach: 'Not a Tietoturvaloukkaus',
            pending: 'Odottaa',
        },
        errors: {
            fetch: 'Epäonnistui: load vaaratilanne. Yritä uudelleen.',
            save: 'Epäonnistui: save vaaratilanne. Yritä uudelleen.',
            fetch_failed: 'Epäonnistui: fetch vaaratilanne. Yritä uudelleen.',
            save_failed: 'Epäonnistui: save vaaratilanne. Yritä uudelleen.',
            transition_failed: 'Epäonnistui: transition vaaratilanne. Yritä uudelleen.',
            close_failed: 'Epäonnistui: close vaaratilanne. Yritä uudelleen.',
            fetch_timeline_failed: 'Epäonnistui: fetch timeline. Yritä uudelleen.',
            fetch_decisions_failed: 'Epäonnistui: fetch decisions. Yritä uudelleen.',
            triage_failed: 'Epäonnistui: update lajittelu. Yritä uudelleen.',
            impact_update_failed: 'Epäonnistui: update impact arviointi. Yritä uudelleen.',
            breach_update_failed: 'Epäonnistui: update tietoturvaloukkaus arviointi. Yritä uudelleen.',
            create_timeline_failed: 'Epäonnistui: create timeline merkintä. Yritä uudelleen.',
            create_decision_failed: 'Epäonnistui: create decision. Yritä uudelleen.',
            notification_update_failed: 'Epäonnistui: update notification. Yritä uudelleen.',
            fetch_tasks_failed: 'Epäonnistui: fetch tehtävä. Yritä uudelleen.',
            create_task_failed: 'Epäonnistui: create tehtävä. Yritä uudelleen.',
            update_task_status_failed: 'Tehtävän tilan päivittäminen epäonnistui. Yritä uudelleen.',
            update_checklist_failed: 'Epäonnistui: update checklist. Yritä uudelleen.',
            assign_task_failed: 'Epäonnistui: assign tehtävä. Yritä uudelleen.',
            escalate_task_failed: 'Epäonnistui: escalate tehtävä. Yritä uudelleen.',
            fetch_templates_failed: 'Epäonnistui: fetch mallit. Yritä uudelleen.',
            permission_denied: 'Sinulla ei ole oikeutta tahan osioon. Ota yhteytta yllapitajaan pyytaaksesi kayttooikeutta.',
        },
        harm_likelihood: {
            unlikely: 'Epätodennäköinen',
            possible: 'Mahdollinen',
            likely: 'Todennäköinen',
            very_likely: 'Erittäin todennäköinen',
        },
        reported_via: {
            email: 'Sähköposti',
            phone: 'Puhelin',
            internal_system: 'Sisäinen Järjestelmä',
            third_party: 'Kolmas osapuoli',
            automated_detection: 'Automaattinen Detection',
        },
        task_transition_labels: {
            start: 'Aloita',
            complete: 'Viimeistele',
            block: 'Estä',
            defer: 'Lykkää',
        },
        transition_labels: {
            start: 'Aloita',
            complete: 'Viimeistele',
            block: 'Estä',
            defer: 'Lykkää',
        },
        nav: {
            all: 'Kaikki tapaukset',
            tasks: 'Vastaustoimet',
            reports: 'Raportit',
            breach_notifications: 'Tietoturvaloukkasilmoitukset',
            supplements: 'Täydennykset',
            remediation: 'Korjaustoimet',
            authority_requests: 'Viranomaiskyselyt',
            disclosure_register: 'Julkistamisrekisteri',
        },
        list: {
            page_title: 'Tapahtumat',
            title: 'Tapaukset',
            new: 'Uusi tapaus',
            edit: 'Muokkaa tapausta',
            incident_title: 'Otsikko',
            severity: 'Vakavuus',
            reported_at: 'Ilmoitettu',
            reported_by: 'Ilmoittaja',
            assigned_to: 'Vastuuhenkilö',
            view_detail: 'Näytä tiedot',
            reference: 'Viite',
            lead: 'Vetäjä',
            reported_via: 'Raportoitu kautta',
            discovery_date: 'Discovery Päivämäärä',
            hide_details: 'Piilota Yksityiskohdat',
            close_incident: 'Sulje Vaaratilanteita',
            close_justification_prompt: 'Please provide a perustelu for closing this vaaratilanne.',
            justification: 'Perustelu',
            lead_id: 'Lead Tunniste',
            contact: 'Yhteyshenkilö',
            category: 'Kategoria',
            not_assessed: 'Ei arvioitu',
        },
        detail: {
            page_title: 'Tapahtuman yksityiskohta',
            title: 'Tapauksen tiedot',
            tabs: {
                overview: 'Yleiskatsaus',
                triage: 'Arviointi',
                impact: 'Vaikutusarviointi',
                breach: 'Tietoturvaloukkauksen arviointi',
                timeline: 'Aikajana',
                decisions: 'Päätökset',
                evidence: 'Todisteet',
                audit_trail: 'Audit Trail',
            },
            evidence_upload_label: 'Liitä todistetiedosto',
            evidence_uploaded: 'Todiste ladattu',
            evidence_deleted: 'Todiste poistettu',
            evidence_delete_error: 'Todisteen poisto epäonnistui',
            evidence_uploaded_at: 'Ladattu',
            evidence_empty: 'Tähän tapahtumaan ei ole liitetty todistetiedostoja.',
            evidence_size: 'Koko',
            triage_notes: 'Arvioinnin muistiinpanot',
            initial_classification: 'Alustava luokitus',
            individuals_affected: 'Henkilöiden lukumäärä',
            data_categories: 'Käsitellyt tietokategoriat',
            systems_compromised: 'Vaarantuneet järjestelmät',
            geographic_scope: 'Maantieteellinen laajuus',
            breach_determination: 'Tietoturvaloukkauksen määrittely',
            notification_required: 'Ilmoitus vaaditaan',
            notification_deadline: 'Ilmoituksen määräaika',
            pdpc_reportable: 'Ilmoitettava tietosuojaviranomaiselle',
            add_timeline: 'Lisää aikajanan merkintä',
            add_decision: 'Lisää päätös',
            not_found: 'Vaaratilanteita not found.',
            team_members: 'Tiimin jäsenet',
            checklist: 'Tarkistuslista',
            completed: 'Valmis',
            impact_severity_score: 'Calculated Vaikutus Vakavuus Pistemäärä',
            records_affected: 'Tietueet Affected',
            potential_consequences: 'Mahdolliset seuraukset',
            harm_likelihood: 'Harm Todennäköisyys',
            legal_basis: 'Oikeusperuste',
            jurisdictions: 'Toimivalta',
            jurisdictions_comma: 'Toimivalta (comma-separated)',
            jurisdiction: 'Toimivalta',
            authority_status: 'Valtuudet Tila',
            subject_status: 'Subject Tila',
            authority_deadline: 'Valtuudet Deadline',
            subject_deadline: 'Kohteen määräaika',
            mark_authority_done: 'Mark Valtuudet Done',
            mark_subject_done: 'Merkitse kohde valmiiksi',
            not_assessed: 'Ei arvioitu',
            event_type: 'Tapahtumatyyppi',
            timestamp: 'Aikaleima',
            actor: 'Toimija',
            no_timeline_events: 'No timeline tapahtuma yet.',
            decision_type: 'Päätös Tyyppi',
            decision: 'Päätös',
            rationale: 'Perustelu',
            decision_made: 'Päätös Made',
            no_decisions: 'Ei vielä tallennettuja päätöksiä.',
            jurisdictions_comma_separated: 'VN, SG, EU',
            no_audit_events: 'Tarkastustapahtumia ei ole vielä tallennettu.',
            export_pdf: 'Vie PDF',
            pdf_title: 'Tapahtumaraportti',
            description: 'Kuvaus',
            linked_records: 'Linkitetyt Tietueet',
        },
        tasks: {
            page_title: 'Hätätilanteiden torjuntatehtävät',
            title: 'Tapauksen vastaustoimet',
            new: 'Uusi tehtävä',
            edit: 'Muokkaa tehtävää',
            task_type: 'Tehtävän tyyppi',
            assignee: 'Vastuuhenkilö',
            due_date: 'Määräaika',
            dependencies: 'Riippuvuudet',
            mark_complete: 'Merkitse valmiiksi',
            templates: 'Tehtävämallit',
            select_incident: 'Valitse tapaus',
            all_statuses: 'Kaikki tilat',
            all_categories: 'Kaikki kategoriat',
            new_response_task: 'Uusi vastaustehtävä',
            category: 'Kategoria',
            priority: 'Prioriteetti',
            depends_on: 'Riippuu (pilkuin erotetut tehtävätunnukset)',
            checklist_items: 'Tarkistuslistan kohteet',
            remove: 'Poista',
            add: 'Lisää',
            new_checklist_item: 'Uusi tarkistuslistan kohde',
            no_templates: 'Malleja ei saatavilla.',
            assign_task: 'Vastuuta tehtävä',
            assign_to: 'Vastuuhenkilö',
            assign: 'Vastuuta',
            select_incident_prompt: 'Valitse tapaus nähdäksesi sen vastaustoimet.',
            checklist: 'Tarkistuslista',
            hide_checklist: 'Piilota tarkistuslista',
            escalate: 'Eskaloi',
            escalations: 'Eskalaatiot',
            no_checklist_items: 'Ei tarkistuslistan kohteita.',
        },
        reports: {
            page_title: 'Tapahtumaraportit',
            title: 'Tapausraportit',
            summary: 'Yhteenvetotilastot',
            by_severity: 'Vakavuuden mukaan',
            by_status: 'Tilan mukaan',
            recent: 'Viimeisimmät tapaukset',
            total_incidents: 'Tapauksia yhteensä',
            open: 'Avoimet',
            closed: 'Suljetut',
            export_csv: 'Vie CSV',
            export_pdf: 'Vie PDF',
            export_success: 'Raportti viety onnistuneesti.',
            export_error: 'Raportin vienti epäonnistui.',
            reference: 'Viite',
            view_report: 'Näytä raportti',
        },
        statuses: {
            reported: 'Ilmoitettu',
            triage: 'Arviointi',
            contained: 'Rajattu',
            investigation: 'Tutkinta',
            remediation: 'Korjaus',
            closed: 'Suljettu',
            false_positive: 'Väärä hälytys',
        },
        task_statuses: {
            pending: 'Odottaa',
            in_progress: 'Käynnissä',
            completed: 'Valmis',
            blocked: 'Estetty',
            cancelled: 'Peruutettu',
        },
        severity: {
            low: 'Matala',
            medium: 'Keskitaso',
            high: 'Korkea',
            critical: 'Kriittinen',
        },
        task_types: {
            containment: 'Rajaaminen',
            investigation: 'Tutkinta',
            remediation: 'Korjaus',
            communication: 'Viestintä',
            documentation: 'Dokumentointi',
            notification: 'Ilmoitus',
        },
        categories: {
            data_breach: 'Tiedot Tietoturvaloukkaus',
            unauthorized_access: 'Unauthorized Pääsy',
            data_loss: 'Tiedot Loss',
            system_compromise: 'Järjestelmä Compromise',
            malware: 'Haittaohjelma',
            phishing: 'Tietojenkalastelu',
            insider_threat: 'Sisäinen uhka',
            other: 'Muu',
        },
        reported_via_options: {
            email: 'Sähköposti',
            phone: 'Puhelin',
            internal_system: 'Sisäinen Järjestelmä',
            third_party: 'Kolmas osapuoli',
            automated_detection: 'Automaattinen Detection',
        },
        harm_likelihood_options: {
            unlikely: 'Epätodennäköinen',
            possible: 'Mahdollinen',
            likely: 'Todennäköinen',
            very_likely: 'Erittäin todennäköinen',
        },
        breach_determination_options: {
            confirmed_breach: 'Confirmed Tietoturvaloukkaus',
            suspected_breach: 'Suspected Tietoturvaloukkaus',
            not_a_breach: 'Not a Tietoturvaloukkaus',
            pending: 'Odottaa',
        },
        timeline_event_types: {
            detection: 'Havaitseminen',
            escalation: 'Eskalaatio',
            containment: 'Rajaus',
            investigation_start: 'Tutkimus Aloita',
            evidence_collected: 'Todistusaineisto Collected',
            notification_sent: 'Ilmoitus Sent',
            remediation_action: 'Korjaus Toiminto',
            status_change: 'Tila Change',
            communication: 'Viestintä',
            other: 'Muu',
        },
        decision_types: {
            containment: 'Rajaus',
            notification: 'Ilmoitus',
            remediation: 'Korjaus',
            escalation: 'Eskalaatio',
            closure: 'Sulkeminen',
            other: 'Muu',
        },
        task_transitions: {
            start: 'Aloita',
            complete: 'Viimeistele',
            block: 'Estä',
            cancel: 'Peruuta',
            unblock: 'Poista esto',
        },
        announce: {
            loaded: '[[TOK_1]] tapahtumaa ladattu',
            reports_loaded: '[[TOK_1]] tapahtumaraporttia ladattu',
            tasks_loaded: '[[TOK_1]] tehtävää ladattu',
            created: 'Tapahtuma luotu onnistuneesti',
            updated: 'Tapahtuma päivitetty onnistuneesti',
            closed: 'Tapahtuma päättyi onnistuneesti',
            status_changed: 'Tapahtumatilanne muuttunut',
            triage_completed: 'Triage suoritettu onnistuneesti',
            impact_updated: 'Vaikutustenarviointi päivitetty',
            breach_updated: 'Rikkomusarvio päivitetty',
            timeline_added: 'Aikajanan tapahtuma lisätty',
            decision_recorded: 'Päätös kirjattiin',
            notification_updated: 'Ilmoituksen tila päivitetty',
            task_created: 'Tehtävän luominen onnistui',
            task_status_changed: 'Tehtävän tila muuttunut',
            checklist_completed: 'Tarkistuslistan kohta suoritettu',
            checklist_unchecked: 'Tarkistusluettelon kohdetta ei ole valittu',
            task_assigned: 'Tehtävän määritys onnistui',
            task_escalated: 'Tehtävä eskaloitui',
            export_initiated: 'Vienti aloitettu',
        },
        breach_notifications: {
            page_title: 'Rikkomusilmoitukset',
            title: 'Rikkomusilmoitukset',
            new_notification: 'Uusi ilmoitus',
            no_notifications: 'Rikkomusilmoituksia ei löytynyt',
            status: 'Tila',
            submit_to_mps: 'Lähetä [[TOK_0]]',
            decision: 'Päätös',
            decision_maker: 'Päätöksentekijä',
            notify: 'Ilmoita',
            do_not_notify: 'Älä ilmoita',
            rationale: 'Perustelut',
            filing_deadline: 'Arkistoinnin määräaika',
            overdue: 'Myöhässä',
            due_soon: 'Pian erääntyvä',
            on_track: 'Aikataulussa',
            legal_review: 'Lakitarkastus',
            incident_id: 'Tapahtuman tunnus',
            notification_statuses: {
                assessment: 'Arviointi',
                decision_to_notify: 'Päätös ilmoittaa',
                notification_drafted: 'Ilmoitus laadittu',
                legal_review: 'Lakitarkastus',
                submitted_to_mps: 'Lähetetty [[TOK_0]]',
                supplement_requested: 'Täydennys pyydetty',
                supplement_submitted: 'Täydennys lähetetty',
                acknowledged: 'Tunnustettu',
                closed: 'Suljettu',
            },
        },
        supplements: {
            page_title: 'Täydennyspyynnöt',
            title: 'Täydennyspyynnöt',
            new_supplement: 'Uusi Täydennys',
            no_supplements: 'Täydennyspyyntöjä ei löytynyt',
            request_details: 'Pyydä lisätietoja',
            response_package: 'Vastauspaketti',
            submit_response: 'Lähetä vastaus',
            deadline: 'Määräaika',
            notification_id: 'Ilmoituksen tunnus',
            enter_notification_id: 'Anna ilmoituksen tunnus nähdäksesi lisäykset.',
            supplement_statuses: {
                requested: 'Pyydetty',
                drafting: 'Luonnos',
                submitted: 'Lähetetty',
                accepted: 'Hyväksytty',
                rejected: 'Hylätty',
            },
        },
        remediation: {
            page_title: 'Korjaustoimet',
            title: 'Korjaustoimet',
            new_action: 'Uusi toiminta',
            no_actions: 'Korjaustoimenpiteitä ei löytynyt',
            description: 'Kuvaus',
            owner: 'Omistaja',
            department: 'Osasto',
            deadline: 'Määräaika',
            statuses: {
                planned: 'Suunniteltu',
                in_progress: 'Meneillään',
                completed: 'Valmis',
                verified: 'Vahvistettu',
            },
            verify: 'Vahvista',
            incident_id: 'Tapahtuman tunnus',
            enter_incident_id: 'Anna tapauksen tunnus nähdäksesi korjaustoimenpiteet.',
            start: 'Aloita',
            complete_action: 'Valmis',
        },
        authority_requests: {
            page_title: 'Viranomaisten pyynnöt',
            title: 'Viranomaisten pyynnöt',
            new_request: 'Uusi pyyntö',
            no_requests: 'Viranomaisten pyyntöjä ei löytynyt',
            authority_name: 'Valtuutetun nimi',
            request_details: 'Pyydä lisätietoja',
            response_package: 'Vastauspaketti',
            submission_channel: 'Lähetyskanava',
            submit_response: 'Lähetä vastaus',
            deadline: 'Määräaika',
            confirmation: 'Vahvistus',
            incident_id_optional: 'Tapahtumatunnus (valinnainen)',
            response_context_label: 'Vastauksen konteksti (toimitusasiakirjan luomiseen)',
            response_context_none: '(ohita materialisointi)',
            response_context_supplement: 'Täydennysvastaus',
            response_context_information: 'Tietopyyntöön vastaus',
            response_context_inspection: 'Tarkastukseen vastaus',
            materialisation_status_column: 'Toimitusasiakirja',
            materialisation_pending: 'Odottaa',
            materialisation_success: 'Materialisoitu',
            materialisation_failed: 'Epäonnistunut',
            materialisation_retry_button: 'Yritä uudelleen',
            ar_statuses: {
                received: 'Vastaanotettu',
                verified: 'Vahvistettu',
                assembling: 'Kokoaminen',
                submitted: 'Lähetetty',
                closed: 'Suljettu',
            },
        },
        disclosure_register: {
            page_title: 'Ilmoitusrekisteri',
            title: 'Ilmoitusrekisteri',
            new_entry: 'Uusi merkintä',
            no_entries: 'Ilmoitusrekisterimerkintöjä ei löytynyt',
            disclosure_type: 'Ilmoituksen tyyppi',
            disclosure_date: 'Ilmoituspäivämäärä',
            recipient: 'Vastaanottaja',
            authority_name: 'Valtuutetun nimi',
            channel: 'kanava',
            content_summary: 'Sisällön yhteenveto',
            incident_id_optional: 'Tapahtumatunnus (valinnainen)',
        },
    },
    onboarding: {
        nav: {
            wizard: 'Asennusvelho',
            tours: 'Moduuliesittelyt',
            sample_data: 'Esimerkkidata',
        },
        wizard: {
            title: 'Asennusvelho',
            welcome: 'Tervetuloa AesirX ComplianceOneen',
            welcome_message: 'Määritetään organisaatiosi. Tämä velho opastaa sinut alkukonfiguraation läpi.',
            setup_complete: 'Asennus valmis',
            skipped_message: 'Asennusvelho ohitettiin. Voit suorittaa sen milloin tahansa organisaatiosi määrittämiseksi.',
            start_setup: 'Aloita asennus',
            skip_wizard: 'Ohita velho',
            go_to_admin: 'Siirry kohtaan Admin',
            skip_for_now: 'Ohita toistaiseksi',
            next_step: 'Seuraava vaihe',
            previous_step: 'Edellinen vaihe',
            finish_setup: 'Viimeistele asennus',
            rerun: 'Suorita asennusvelho uudelleen',
            step_label: 'Vaihe {number}',
            validation_org_name_required: 'Organisaation nimi on pakollinen.',
            validation_admin_email_required: 'Ylläpitäjän sähköposti on pakollinen.',
            validation_admin_email_invalid: 'Anna kelvollinen sähköpostiosoite.',
            validation_cmp_endpoint_required: 'CMP:n osoite on pakollinen, kun CMP on käytössä.',
            steps: {
                license_activation: 'Lisenssin aktivointi',
                org_profile: 'Organisaation profiili',
                module_selection: 'Moduulivalinta',
                cmp_integration: 'CMP-integraatio',
                notification_preferences: 'Ilmoitukset',
                review: 'Tarkista ja vahvista',
            },
            step_descriptions: {
                license_activation: 'Aktivoi paketti ja määritä saatavilla olevat moduulit antamalla lisenssiavaimesi.',
                org_profile: 'Määritä organisaation nimi, lainkäyttöalue, toimiala, koko ja ensisijainen kieli.',
                module_selection: 'Valitse, mitkä vaatimustenmukaisuusmoduulit aktivoidaan organisaatiollesi.',
                cmp_integration: 'Määritä Consent Management Platform -integraatio (valinnainen).',
                notification_preferences: 'Määritä miten vastaanotat ilmoituksia vaatimustenmukaisuustapahtumista.',
                review: 'Tarkista asetukset ja viimeistele asennus.',
            },
            license_step: {
                validate_button: 'Vahvista lisenssi',
                skip_warning: 'Moduulien käyttöoikeus rajoitetaan oletuspakettitasoon. Voit aktivoida lisenssin myöhemmin kohdassa Alusta > Lisenssiasetukset.',
            },
            module_descriptions: {
                rights_requests: 'Käsittele rekisteröityjen pääsy- ja poistopyyntöjä.',
                data_mapping: 'Kartoita järjestelmät, tietovirrat ja käsittelytoiminnot.',
                governance: 'Hallinnoi toimittajien vaatimustenmukaisuutta ja poistomenettelyjä.',
                consent: 'Hallinnoi suostumuskäytäntöjä ja käyttötarkoitusluetteloita.',
                consent_properties: 'Hallinnoi suostumusta useiden digitaalisten omaisuuserien välillä.',
                assessments: 'Suorita vaikutustenarviointeja ja rajat ylittäviä tiedonsiirtoja.',
                classification: 'Luokittele ja merkitse tietovaroja elinkaariseurannalla.',
                monitoring: 'Ajoitetut vaatimustenmukaisuuskatselmukset ja KPI-seuranta.',
                incidents: 'Raportoi ja hallinnoi tietoturva- ja tietosuojatapahtumia.',
                connectors: 'Yhdistä ulkoisiin järjestelmiin automaattiseen tiedonvaihtoon.',
                vendor_risk: 'Pisteytä toimittajia, seuraa sopimuksia ja hallinnoi due diligence -prosesseja.',
                deletion_orchestration: 'Koordinoi tietojen poistoa järjestelmien ja toimittajien välillä.',
                discovery: 'Löydä ja luokittele tietoja koko infrastruktuuristasi.',
                incident_ops: 'Edistyneet tapahtumaohjekirjat, SLA-seuranta ja eskaloinnit.',
                program_governance: 'Kypsyysarvioinnit, johdon raportointi ja auditointivalmius.',
                access_accountability: 'Valvo käyttöoikeuksia, istuntoja ja perustelutyönkulkuja.',
                localization: 'Markkinarakokohtaiset vaatimustenmukaisuuspaketit ja sääntelykehykset.',
                partner_workspace: 'Kumppani- ja jälleenmyyjätyötila.',
                privacy_scanner: 'Reaaliaikainen tietosuojavalvonta digitaalisille omaisuuserille.',
                onboarding: 'Asennusvelho, opastetut kierrokset ja esimerkkitietojen hallinta.',
                compliance_forms: 'Interaktiiviset vaatimustenmukaisuusmallit ja asiakirjojen luonti.',
                audit_trail: 'Kattava muuttumaton auditointikirjaus ja säilytys.',
                organizations: 'Moniorganisaatio- ja ryhmähallinta.',
                task_management: 'Yhtenäinen tehtäväsuunnittelu, työnkulkumoottori ja kalenterinäkymät.',
            },
            module_categories: {
                data_privacy_rights: 'Tietosuoja ja oikeudet',
                vendor_third_party: 'Toimittajan ja kolmannen osapuolen hallinta',
                risk_assessment: 'Riskit ja arviointi',
                operations_automation: 'Toiminta ja automaatio',
                platform_admin: 'Alusta ja hallinto',
            },
            package_tier_label: 'Pakettisi',
            package_module_unavailable: 'Ei sisälly pakettiisi',
            select_all: 'Valitse Kaikki',
            deselect_all: 'Poista Kaikki valinnat',
            load_sample_data: 'Lataa esimerkkitiedot asennuksen jälkeen',
            load_sample_data_description: 'Asenna realistiset esittelytiedot (Lotus Financial Services) alustan tutkimiseen. Voidaan poistaa myöhemmin kohdasta Käyttöönotto > Esimerkkitiedot.',
            language_label: 'Ensisijainen Kieli',
            language_description: 'Valitse organisaatiosi oletuskieli.',
            admin_account_title: 'Ylläpitäjätili',
            admin_account_created: 'Ylläpitäjätili luotu',
            admin_full_name: 'Koko nimi',
            admin_email: 'Sähköpostiosoite',
            admin_password: 'Salasana',
            admin_confirm_password: 'Vahvista salasana',
            admin_show_password: 'Näytä salasana',
            admin_hide_password: 'Piilota salasana',
            admin_name_placeholder: 'esim. Jane Smith',
            admin_email_placeholder: 'admin@example.com',
            admin_password_placeholder: 'Vähintään 8 merkkiä',
            admin_password_confirm_placeholder: 'Syötä salasana uudelleen',
            validation_admin_name_required: 'Ylläpitäjän nimi on pakollinen',
            validation_admin_password_required: 'Salasana on pakollinen',
            validation_admin_password_min_length: 'Salasanan on oltava vähintään 8 merkkiä',
            validation_passwords_mismatch: 'Salasanat eivät täsmää',
            notification_email_enabled: 'Ota Sähköposti-ilmoitukset Käyttöön',
            notification_email_description: 'Vastaanota sähköposti-ilmoituksia tehtävien jakamisesta, SLA-rikkomuksista ja vaatimustenmukaisuustapahtumista.',
            notification_digest_frequency: 'Yhteenvedon Tiheys',
            notification_digest_daily: 'Päivittäin',
            notification_digest_weekly: 'Viikoittain',
            notification_digest_none: 'Ei yhteenvetoa',
            notification_in_app_enabled: 'Ota Alustailmoitukset Käyttöön',
            notification_in_app_description: 'Näytä ilmoitusmerkki ja -laatikko reaaliaikaisille hälytyksille.',
            jurisdictions: {
                vietnam: 'Vietnam',
                asean: 'ASEAN',
                eu_eea: 'EU/ETA',
                global: 'Maailmanlaajuinen',
            },
            languages: {
                en: 'englanti',
                vi: 'Tiếng Việt',
                da: 'Dansk',
                sv: 'Svenska',
                nb: 'Norsk Bokmål',
                nn: 'Norsk Nynorsk',
                de: 'Deutsch',
                fi: 'Suomi',
                nl: 'Nederlands',
                fr: 'Français',
                lb: 'Lëtzebuergesch',
                ga: 'Gaeilge',
                es: 'español',
                ca: 'Català',
                eu: 'Euskara',
                pt: 'portugali',
            },
            industries: {
                financial_services: 'Rahoituspalvelut',
                healthcare: 'Terveydenhuolto',
                technology: 'Teknologia',
                telecommunications: 'Televiestintä',
                government: 'Julkishallinto',
                education: 'Koulutus',
                manufacturing: 'Valmistus',
                retail: 'Vähittäiskauppa',
                other: 'Muu',
            },
            placeholders: {
                org_name: 'esim. Lotus Financial Services',
                admin_email: 'admin@company.vn',
                team_emails: 'käyttäjä1@yritys.vn, käyttäjä2@yritys.vn',
                cmp_endpoint: 'https://cmp.example.com/api',
            },
            fields: {
                org_name: 'Organisaation nimi',
                jurisdiction: 'Lainkäyttöalue',
                industry: 'Toimiala',
                org_size: 'Organisaation koko',
                language: 'Ensisijainen Kieli',
                admin_email: 'Ylläpitäjän sähköposti',
                team_emails: 'Tiimin jäsenten sähköpostit (pilkuin erotetut)',
                enable_cmp: 'Ota CMP-integraatio käyttöön',
                cmp_endpoint: 'CMP:n API-osoite',
                email_notifications: 'Sähköposti-ilmoitukset',
                in_app_notifications: 'Alustailmoitukset',
                digest_frequency: 'Yhteenvedon Tiheys',
            },
        },
        tours: {
            title: 'Moduulien esittelykierrokset',
            start: 'Aloita esittely',
            continue_tour: 'Jatka esittelyä',
            replay: 'Toista esittely',
            exit: 'Poistu esittelystä',
            skip: 'Ohita esittely',
            next: 'Seuraava',
            previous: 'Edellinen',
            finish: 'Lopeta esittely',
            step_of: 'Vaihe {current}/{total}',
            info: 'Tutustu kunkin moduulin keskeisiin ominaisuuksiin ja työnkulkuihin opastetuilla kierroksilla. Esittelyt voi toistaa milloin tahansa.',
            autoplay: 'Automaattinen toisto',
            interactive: 'Interaktiivinen',
            play_all: 'Toista kaikki',
            search_tours: 'Hae kiertomatkoja...',
            duration: 'Kesto',
            steps_label: '[[TOK_1]] askelta',
            mode: 'tila',
            pause: 'Tauko',
            resume: 'Jatka',
            speed: 'Nopeus',
            restart: 'Käynnistä uudelleen',
            reset: 'Nollaa',
            reset_success: 'Kiertueen eteneminen on nollattu.',
            category_core_privacy: 'Ydintietosuoja',
            category_governance: 'Hallinto',
            category_operations: 'Toiminnot',
            category_platform: 'Alusta',
            category_advanced: 'Edistynyt',
            category_data_privacy_rights: 'Tietosuoja ja oikeudet',
            category_vendor_third_party: 'Toimittajan ja kolmannen osapuolen hallinta',
            category_risk_assessment: 'Riskit ja arviointi',
            category_operations_automation: 'Toiminta ja automaatio',
            category_platform_admin: 'Alusta ja hallinto',
            steps_count: '[[TOK_1]] askelta',
        },
        sample_data: {
            title: 'Esimerkkidatan hallinta',
            select_modules: 'Valitse moduulit',
            current_status: 'Nykyinen tila',
            operation_history: 'Toimintahistoria',
            load: 'Lataa esimerkkidata',
            clear: 'Tyhjennä esimerkkidata',
            processing: 'Käsitellään...',
            loaded: 'Ladattu',
            not_loaded: 'Ei ladattu',
            records: 'Esimerkkitietueet',
            confirm_clear: 'Haluatko varmasti tyhjentää kaiken esimerkkidatan valituista moduuleista?',
            confirm_clear_title: 'Tyhjennä esimerkkidata',
            confirm_load_title: 'Lataa esimerkkitiedot',
            confirm_load: 'Haluatko varmasti ladata esimerkkitiedot valituille moduuleille?',
            action_load: 'Lataa',
            action_clear: 'Tyhjennä',
            info: 'Lataa realistista esittelydataa koulutusta ja esittelyjä varten kuvitteellisesta yrityksestä "Lotus Financial Services". Esimerkkidata on merkittyä ja voidaan poistaa turvallisesti ilman vaikutusta oikeaan dataan.',
        },
        help: {
            title: 'Ohjekeskus',
            search: 'Haku',
            search_placeholder: 'Etsi ohjeartikkeleita...',
            clear: 'Tyhjennä',
            all_categories: 'Kaikki kategoriat',
            all_modules: 'Kaikki Moduulit',
            back: 'Takaisin ohjekeskukseen',
            callout_important: 'Tärkeää',
            callout_tip: 'Vihje',
            no_results: 'Hakuasi vastaavia artikkeleita ei löytynyt.',
            no_articles: 'Ohjeartikkeleita ei ole vielä saatavilla. Artikkelit ilmestyvät tähän, kun sisältöä lisätään.',
            results_for: '{count} tulos(ta) haulle "{query}"',
            quick_links: {
                getting_started: 'Aloitusopas',
                getting_started_desc: 'Asennus, käyttöönotto ja pikaopas.',
                user_guide: 'Käyttöopas',
                user_guide_desc: 'Moduulikohtainen käyttödokumentaatio.',
                admin_guide: 'Ylläpito-opas',
                admin_guide_desc: 'Konfigurointi, ylläpito ja vianmääritys.',
                faq: 'UKK',
                faq_desc: 'Usein kysytyt kysymykset ja vastaukset.',
            },
            search_articles_aria: 'Etsi ohjeartikkeleita',
            article_metadata_aria: 'Artikkelin metatiedot',
            articles_list_aria: 'Ohjeartikkelit',
            category_nav_aria: 'Luokkanavigaatio',
            quick_links_aria: 'Pikalinkit ohjeluokkiin',
            returned_to_list: 'Palattiin artikkelilistaan',
            opening_article: 'Avataan artikkeli: {title}',
            read_article_aria: 'Lue artikkeli: {title}',
            pagination_nav_aria: 'Artikkelien sivutus',
            error_unavailable: 'Ohjekeskus ei ole tällä hetkellä käytettävissä. Yritä myöhemmin uudelleen.',
            retry: 'Yritä uudelleen',
        },
    },
    common: {
        save: 'Tallenna',
        cancel: 'Peruuta',
        system_actor: 'Järjestelmä',
        delete: 'Poista',
        edit: 'Muokkaa',
        create: 'Luo',
        update: 'Päivitä',
        loading: 'Ladataan...',
        error: 'Tapahtui virhe',
        success: 'Onnistui',
        logout: 'Kirjaudu ulos',
        actions: 'Toiminnot',
        retrying: 'Yritetään uudelleen…',
        permission_denied: 'Sinulla ei ole pääsyä tälle sivulle.',
        status: 'Tila',
        description: 'Kuvaus',
        name: 'Nimi',
        created_at: 'Luotu',
        updated_at: 'Päivitetty',
        yes: 'Kyllä',
        no: 'Ei',
        confirm: 'Vahvista',
        back: 'Takaisin',
        next: 'Seuraava',
        previous: 'Edellinen',
        search: 'Haku',
        filter: 'Suodatin',
        page_x_of_y: 'Sivu [[TOK_2]]/[TOK_3]]',
        pagination_label: 'Sivutus',
        view_mode_label: 'Näyttötila',
        export: 'Vie',
        exporting: 'Viedään…',
        sidebar_navigation: 'Järjestelmänvalvojan sivupalkin navigointi',
        items_count: '[[TOK_1]] kohdetta',
        items_count_one: '[[TOK_1]] kohde',
        export_success: 'Asiakirjan luominen onnistui.',
        generate_pdf: 'Luo PDF',
        import: 'Tuo',
        download: 'Lataa',
        upload: 'Lataa palvelimelle',
        view: 'Näytä',
        close: 'Sulje',
        submit: 'Lähetä',
        saved: 'Tallennettu',
        saving: 'Tallennetaan...',
        submitting: 'Lähetetään...',
        created: 'Luotu onnistuneesti',
        all: 'Kaikki',
        none: 'Ei mitään',
        select: 'Valitse',
        select_user: 'Valitse käyttäjä...',
        custom_input: 'Kirjoita manuaalisesti',
        required: 'Pakollinen',
        optional: 'Valinnainen',
        notes: 'Muistiinpanot',
        tags: 'Tunnisteet',
        archive: 'Arkistoi',
        clone: 'Kloonaa',
        refresh: 'Päivitä',
        retry: 'Yritä uudelleen',
        reset: 'Nollaa',
        add: 'Lisää',
        remove: 'Poista',
        removing: 'Poistetaan…',
        attachment: 'Liite',
        upload_file: 'Lataa tiedosto',
        upload_file_required: 'Lataa tiedosto (pakollinen)',
        select_entity_type_first: 'Valitse ensin entiteettityyppi',
        failed_to_remove_file: 'Tiedostoa ei voitu poistaa.',
        entity_type_label: 'Entiteettiryhmä',
        entity_label: 'Entiteetti',
        entity_reference: 'Entiteettiviittaus',
        failed_to_load_entities: 'Entiteettien lataaminen epäonnistui',
        enable: 'Ota käyttöön',
        disable: 'Poista käytöstä',
        no_data: 'Tietoja ei löytynyt',
        confirm_delete: 'Haluatko varmasti poistaa tämän kohteen?',
        confirm_action: 'Haluatko varmasti jatkaa?',
        save_success: 'Tallennettu onnistuneesti',
        save_error: 'Tallennus epäonnistui',
        delete_success: 'Poistettu onnistuneesti',
        delete_error: 'Poistaminen epäonnistui',
        hour: 'tunti',
        hours: 'tuntia',
        load_error: 'Tietojen lataus epäonnistui',
        operation_error: 'Toiminto epäonnistui',
        something_went_wrong: 'Jokin meni pieleen',
        go_home: 'Siirry yhteenvetoon',
        access_denied: 'Pääsy estetty',
        no_permission: 'Sinulla ei ole oikeutta käyttää tätä sivua.',
        no_permission_title: 'Riittämättömät oikeudet',
        no_permission_message: 'Sinulla ei ole oikeutta käyttää tätä sivua.',
        unknown: 'Tuntematon',
        back_to_dashboard: 'Takaisin yhteenvetoon',
        id: 'Tunnus',
        type: 'Tyyppi',
        date: 'Päivämäärä',
        created_by: 'Luonut',
        updated_by: 'Päivittänyt',
        page_of: 'Sivu {page}/{total}',
        showing_items: 'Näytetään {count} kohdetta',
        items_per_page: 'Kohteita sivulla',
        no_results: 'Suodattimia vastaavia tietueita ei löytynyt',
        no_items: 'Kohteita ei löytynyt',
        sort_by: 'Lajittele',
        ascending: 'Nouseva',
        descending: 'Laskeva',
        all_statuses: 'Kaikki tilat',
        all_types: 'Kaikki tyypit',
        all_categories: 'Kaikki kategoriat',
        all_severities: 'Kaikki vakavuudet',
        date_range: 'Aikaväli',
        from_date: 'Alkaen',
        to_date: 'Päättyen',
        clear_filters: 'Tyhjennä suodattimet',
        apply_filters: 'Käytä suodattimia',
        save_changes: 'Tallenna muutokset',
        discard_changes: 'Hylkää muutokset',
        confirm_discard: 'Sinulla on tallentamattomia muutoksia. Haluatko hylätä ne?',
        copy: 'Kopioi',
        duplicate: 'Monista',
        move: 'Siirrä',
        assign: 'Vastuuta',
        unassign: 'Poista vastuutus',
        approve: 'Hyväksy',
        reject: 'Hylkää',
        deleting: 'Poistetaan...',
        processing: 'Käsitellään...',
        loading_page: 'Ladataan sivua...',
        operation_success: 'Toiminto suoritettu onnistuneesti',
        operation_failed: 'Toiminto epäonnistui. Yritä uudelleen.',
        empty_dash: '—',
        network_error: 'Verkkovirhe. Tarkista yhteytesi.',
        session_expired: 'Istunto vanhentunut. Kirjaudu sisään uudelleen.',
        test: 'Testaa',
        pause: 'Keskeytä',
        resume: 'Jatka',
        activate: 'Aktivoi',
        last_sync: 'Viimeisin synkronointi',
        health: 'Terveydentila',
        email: 'Sähköposti',
        role: 'Rooli',
        title: 'Otsikko',
        owner: 'Omistaja',
        priority: 'Prioriteetti',
        category: 'Kategoria',
        details: 'Tiedot',
        overview: 'Yleiskatsaus',
        configuration: 'Asetukset',
        history: 'Historia',
        new_item: 'Uusi',
        edit_item: 'Muokkaa',
        select_option: 'Valitse...',
        total: 'Yhteensä',
        active: 'Aktiivinen',
        inactive: 'Ei aktiivinen',
        enabled: 'Käytössä',
        disabled: 'Ei käytössä',
        last_login: 'Viimeisin kirjautuminen',
        never: 'Ei koskaan',
        password_changed: 'Salasana vaihdettu. Sinut kirjataan ulos.',
        password_change_failed: 'Salasanan vaihto epäonnistui',
        passwords_mismatch: 'Salasanat eivät täsmää',
        install: 'Asenna',
        uninstall: 'Poista asennus',
        installed: 'Asennettu',
        available: 'Saatavilla',
        catalog: 'Katalogi',
        published: 'Julkaistu',
        version: 'Versio',
        market: 'Markkina-alue',
        language: 'Kieli',
        framework: 'Sääntelykehys',
        template: 'Mallipohja',
        connector_type: 'Liitintyyppi',
        polling_interval: 'Kyselyväli (minuuttia)',
        new_instance: 'Uusi instanssi',
        change_password: 'Vaihda salasana',
        current_password: 'Nykyinen salasana',
        new_password: 'Uusi salasana',
        confirm_password: 'Vahvista salasana',
        comments: 'Kommentit',
        completed: 'Valmis',
        contact: 'Yhteyshenkilö',
        hide: 'Piilota',
        hide_details: 'Piilota Yksityiskohdat',
        label: 'Tunniste',
        max: 'Max',
        min: 'Min',
        na: 'N/A',
        of: 'of',
        showing: 'Näytetään',
        page: 'Sivu',
        preview: 'Esikatselu',
        print: 'Tulosta',
        show: 'Näytä',
        status_active: 'Aktiivinen',
        status_completed: 'Valmis',
        status_draft: 'Luonnos',
        status_in_progress: 'Käynnissä',
        status_pending: 'Odottaa',
        view_details: 'Näytä yksityiskohdat',
        all_priorities: 'Kaikki prioriteetit',
        pipeline: 'Putki',
        all_requests: 'Kaikki pyynnöt',
        schedule: 'Aikataulu',
        deploy: 'Ota käyttöön',
        rollback: 'Palautus',
        advance_stage: 'Edistä vaihetta',
        submit_for_approval: 'Lähetä for Hyväksyntä',
        approval_log: 'Hyväksyntäloki',
        approver: 'Hyväksyjä',
        decision: 'Päätös',
        decided_at: 'Päätetty',
        rollout_stages: 'Rollout Vaiheet',
        approval_comment: 'Hyväksyntäkommentti',
        optional_comment: 'Valinnainen comment...',
        impact_summary: 'Vaikutus Yhteenveto',
        target_property_ids: 'Tavoite Ominaisuus Tunniste (comma-separated)',
        policy_id: 'Käytäntö Tunniste',
        target_version: 'Tavoite Versio',
        target_version_placeholder: 'esim. 2.0.0',
        scheduled_label: 'Aikataulutettu',
        scheduled_start: 'Aikataulutettu Aloita',
        scheduled_end: 'Aikataulutettu End',
        properties_count: '{count} ominaisuutta',
        results: 'Tulokset',
        comparison_results: 'Comparison Tulokset',
        past_comparison_reports: 'Past Comparison Raportit',
        scanning: 'Skannataan...',
        run_inconsistency_scan: 'Suorita Inconsistency Skannaus',
        property_ids_label: 'Ominaisuus Tunniste (comma-separated, min 2)',
        comparison_type: 'Comparison Tyyppi',
        golden_template_id: 'Golden Malli Tunniste (optional)',
        leave_blank_compare: 'Jätä tyhjäksi verrataksesi ominaisuuksia toisiinsa',
        add_notes_placeholder: 'Lisää analyysimuistiinpanosi tähän...',
        covered_of_active: '{covered}/{active} aktiivista ominaisuutta katettu',
        fetch_error: 'Epäonnistui: fetch tiedot. Yritä uudelleen.',
        run_comparison_error: 'Epäonnistui: run comparison. Yritä uudelleen.',
        save_notes_error: 'Epäonnistui: save notes. Yritä uudelleen.',
        scan_complete: 'Inconsistency skannaus valmis successfully.',
        scan_error: 'Epäonnistui: run inconsistency skannaus. Yritä uudelleen.',
        min_two_properties: 'Please provide at least 2 property Tunniste for comparison.',
        comma_separated: 'pilkulla erotettu',
        language_english: 'Englanti',
        language_vietnamese: 'Vietnamilainen',
        language_vietnamese_native: 'Tiếng Việt',
        author: 'Tekijä',
        dependencies: 'Riippuvuudet',
        checksum: 'Tarkistussumma',
        changelog: 'Muutosloki',
        tier: 'Taso',
        phone: 'Puhelin',
        launch: 'Käynnistä',
        complete: 'Viimeistele',
        back_to_list: 'Takaisin to Lista',
        clear_selection: 'Tyhjennä valinta',
        deactivate: 'Poista käytöstä',
        scope: 'Laajuus',
        deadline: 'Määräaika',
        progress: 'Edistyminen',
        frequency: 'Tiheys',
        reviewer: 'Arvioija',
        user: 'Käyttäjä',
        campaign: 'Kampanja',
        items: 'Kohteet',
        next_run: 'Seuraava Suorita',
        last_run: 'Last Suorita',
        overdue: 'OVERDUE',
        creating: 'Luodaan...',
        launching: 'Käynnistetään...',
        loaded: 'loaded',
        page_size: 'Sivun koko',
        per_page: '/ sivu',
        urgent: 'Kiireellinen',
        pagination: 'Sivutus',
        metric: 'Metrinen',
        value: 'Arvo',
        country: 'Maa',
        showing_chart_view: 'Näytetään kaavionäkymä',
        showing_table_view: 'Näytetään datataulukkonäkymä',
        policies: 'Käytännöt',
        select_content_type: 'Valitse vähintään yksi sisältötyyppi.',
        compliant: 'Yhteensopiva',
        non_compliant_status: 'Ei yhteensopiva',
        all_data: 'Kaikki tiedot',
        sr_urgent: 'Kiireellinen',
        n_per_page: '[[TOK_1]] / sivu',
        select_user_placeholder: '-- Valitse käyttäjä --',
        field_required: 'Tämä kenttä on pakollinen',
        results_found: 'tulosta löytyi',
        select_placeholder: '-- Valitse --',
        unknown_user: 'Tuntematon käyttäjä',
        export_csv: 'Vie CSV',
        not_applicable: 'Ei sovellettavissa',
        aria_overdue_since: 'Myöhässä {date} alkaen',
        placeholders: {
            enter_justification: 'Syötä perustelu',
            justification: 'Perustelu',
            campaign_name_example: 'Q1 2026 Pääsy Katselmointia',
            optional_description: 'Valinnainen kuvaus',
            enter_user_id: 'Syötä the käyttäjä tunniste of the reviewer',
            enter_user_id_short: 'Syötä käyttäjä tunniste',
            schedule_name_example: 'Neljännesvuosittain Pääsy Todistus',
            enter_property_id: 'Syötä property tunniste',
            enter_policy_id: 'Syötä käytäntö tunniste',
            property_or_group_id: 'Ominaisuus or group Tunniste',
            describe_template_purpose: 'Describe the malli purpose...',
            step_title: 'Vaihe otsikko...',
            detailed_instructions: 'Yksityiskohtaiset ohjeet...',
            filter_by_taxonomy_id: 'Suodata by Taksonomia Tunniste...',
            describe_classification_rule: 'Kuvaile luokittelusääntö...',
            describe_dedup_rule: 'Kuvaile deduplikointisääntö...',
            describe_import_template: 'Describe the import malli...',
            reason_for_rejection: 'Syy hylkäämiselle...',
            jurisdiction_codes_example: 'VN, SG, EU',
            filter_by_locale: 'Suodata by locale...',
            filter_by_event_type: 'Suodata by tapahtuma tyyppi',
            filter_by_actor_id: 'Suodata by actor Tunniste',
            filter_by_market_code: 'Suodata by market koodi...',
            filter_by_framework_id: 'Suodata by kehys Tunniste...',
            add_comment: 'Lisää kommentti...',
            provide_rejection_reason: 'Anna syy lähetyksen hylkäämiselle...',
            filter_by_jurisdiction: 'Suodata by jurisdiction koodi...',
            enter_report_title: 'Syötä raportti otsikko',
            enter_name: 'Syötä nimi',
            enter_description: 'Syötä kuvaus',
            enter_org_id: 'Syötä org tunniste to add',
            describe_evidence_gap: 'Describe the todistusaineisto puute...',
            expected_evidence: 'Mitä todisteita odotetaan',
            entity_identifier: 'Entiteetin tunniste',
            remediation_steps: 'Vaiheet to remediate this puute',
            user_id_or_name: 'Käyttäjätunnus tai nimi',
            reporting_period_id: 'Raportointi period Tunniste',
            maturity_model_id: 'Kypsyys model Tunniste',
            describe_maturity_model: 'Kuvaile tämä kypsyysmalli...',
            describe_role_purpose: "Describe this role's purpose...",
            provide_deny_reason: 'Anna syy pyynnön hylkäämiselle',
            describe_emergency: 'Describe the emergency situation requiring elevated pääsy (minimum 20 characters)',
            enter_delegate_id: 'Syötä käyttäjä tunniste of the delegate',
            provide_delegation_reason: 'Anna syy tälle delegoinnille',
            client_identifier: 'Asiakas identifier',
            client_secret: 'Asiakas secret',
            time_format: 'HH:MM',
            describe_sod_rule: 'Kuvaile tämän SoD-säännön tarkoitus...',
            enter_role_id: 'Syötä rooli tunniste',
            explain_exception: 'Selitä, miksi tämä poikkeus tarvitaan...',
            describe_compensating_controls: 'Describe compensating hallinta in place...',
            full_name: 'Täysi nimi',
            min_chars: 'Vähintään 12 merkkiä',
            enter_override_justification: 'Syötä perustelu for overriding this gate evaluation',
            enter_evidence_id: 'Anna todisteiden tunnus linkitettäväksi:',
            date_format: 'PP/KK/VVVV',
            describe_pack_contents: 'Kuvaile paketin sisältö ja tarkoitus',
            select_reviewers: 'Valitse tarkastajat...',
        },
        aria_previous_page: 'Edellinen sivu',
        aria_next_page: 'Seuraava sivu',
        aria_results_per_page: 'Tulokset per sivu',
        per_page_25: '25 / sivu',
        per_page_50: '50 / sivu',
        per_page_100: '100 / sivu',
        select_language: 'Valitse kieli',
        today: 'Tänään',
        tomorrow: 'Huomenna',
        dashboard_load_error: 'Kojelautaa ei voitu ladata. Yritä uudelleen.',
        enum_grade: {
            red: 'Punainen',
            amber: 'Amber',
            yellow: 'Keltainen',
            green: 'Vihreä',
        },
        enum_severity: {
            critical: 'Kriittinen',
            high: 'Korkea',
            medium: 'Keskitaso',
            low: 'Matala',
        },
        enum_priority: {
            critical: 'Kriittinen',
            high: 'Korkea',
            medium: 'Keskitaso',
            low: 'Matala',
        },
        enum_status: {
            pending: 'Odottaa',
            in_progress: 'Käynnissä',
            completed: 'Valmis',
            blocked: 'Estetty',
            escalated: 'Eskaloitu',
            cancelled: 'Peruutettu',
            overdue: 'Myöhässä',
            not_started: 'Ei aloitettu',
            new: 'Uusi',
            open: 'Avaa',
            closed: 'Suljettu',
            acknowledged: 'Tunnustettu',
            resolved: 'Ratkaistu',
        },
        enum_department: {
            unassigned: 'Ei määritetty',
        },
        enum_form_category: {
            assessment: 'Arviointi',
            assessment_report: 'Arviointiraportti',
            dpia: '[[TOK_0]]',
            authority_submission: 'Viranomaisen esitys',
            cross_border_transfer: 'Rajat ylittävä siirto',
            vendor: 'Myyjä',
            breach: 'Rikkominen',
            consent: 'Suostumus',
            governance: 'Hallinto',
            register: 'Rekisteröidy',
            monitoring: 'Valvonta',
            dpa: 'DPA',
            dsr: 'DSR',
            privacy: 'Yksityisyys',
            incident: 'Tapahtuma',
            org: 'Organisaatio',
            sector: 'sektori',
            classification: 'Luokittelu',
            discovery: 'Löytö',
        },
        enum_module: {
            rights_requests: 'Oikeuspyynnöt',
            assessments: 'Arvioinnit',
            incidents: 'Tapahtumat',
            incident_ops: 'Tapahtumavalvonta',
            monitoring: 'Valvonta',
            vendor_risk: 'Myyjän riski',
            governance: 'Hallinto',
            deletion_orchestration: 'Poistaminen',
            access_review: 'K?ytt?oikeustarkastus',
            consent: 'Suostumus',
            consent_properties: 'Suostumuksen ominaisuudet',
            forms: 'Lomakkeet',
            localization: 'Lokalisointi',
            program_governance: 'Ohjelman hallinto',
            privacy_scanner: 'Yksityisyysskanneri',
            classification: 'Luokittelu',
            discovery: 'Löytö',
            manual: 'Manuaalinen',
            data_mapping: 'Tietojen kartoitus',
        },
        enum_risk_level: {
            critical: 'Kriittinen',
            high: 'Korkea',
            medium: 'Keskitaso',
            low: 'Matala',
        },
        enum_request_type: {
            all: 'All',
            access: 'Pääsy ([[TOK_0]])',
            deletion: 'Poistaminen',
            correction: 'Korjaus',
            objection: 'Vastalause',
            portability: 'Siirrettävyys',
            restriction: 'Rajoitus',
            consent_withdrawal: 'Suostumuksen peruuttaminen',
        },
        enum_locale: {
            en: 'englanti',
            vi: 'vietnamilainen',
            all: 'Molemmat',
        },
        enum_event_type: {
            case_created: 'Tapaus luotu',
            status_changed: 'Tila muutettu',
            case_assigned: 'Tapaus määrätty',
            note_added: 'Huomautus lisätty',
            attachment_added: 'Liite lisätty',
            attachment_deleted: 'Liite poistettu',
            reference_added: 'Viite lisätty',
            checklist_updated: 'Tarkistuslista päivitetty',
            identity_verified: 'Henkilöllisyys vahvistettu',
            closure_summary_added: 'Sulkemisen yhteenveto',
            approval_granted: 'Hyväksyntä myönnetty',
            template_applied: 'Malli käytetty',
            export_generated: 'Vienti luotu',
            sla_warning: '[[TOK_0]] Varoitus',
            sla_overdue: '[[TOK_0]] Myöhässä',
        },
        more: 'more',
        use: 'Use',
        ok: 'OK',
    },
    common_statuses: {
        removed: 'Poistettu',
        draft: 'Luonnos',
        active: 'Aktiivinen',
        inactive: 'Ei aktiivinen',
        pending: 'Odottaa',
        in_progress: 'Käynnissä',
        completed: 'Valmis',
        archived: 'Arkistoitu',
        published: 'Julkaistu',
        approved: 'Hyväksytty',
        rejected: 'Hylätty',
        cancelled: 'Peruutettu',
        blocked: 'Estetty',
        deferred: 'Lykätty',
        not_started: 'Ei aloitettu',
        dismissed: 'Ohitettu',
        failed: 'Epäonnistunut',
        in_review: 'In Katselmointia',
        deprecated: 'Vanhentunut',
        scheduled: 'Aikataulutettu',
        deploying: 'Otetaan käyttöön',
        deployed: 'Otettu käyttöön',
        paused: 'Keskeytetty',
        rolled_back: 'Rolled Takaisin',
        received: 'Vastaanotettu',
        processing: 'Käsitellään',
        under_assessment: 'Arvioinnin alla',
        implemented: 'Toteutettu',
        pending_approval: 'Odottaa Hyväksyntä',
        pending_deletion: 'Odottaa Deletion',
        on_hold: 'On Pidätys',
        deleted: 'Poistettu',
        expired: 'Vanhentunut',
        outdated: 'Vanhentunut',
        drifted: 'Poikennut',
        decommissioned: 'Käytöstä poistettu',
        match: 'Vastaavuus',
        different: 'Eri',
        missing: 'Puuttuu',
        confirmed: 'Vahvistettu',
        revoked: 'Peruutettu',
        escalated: 'Eskaloitu',
        system: 'Järjestelmä',
        custom: 'Mukautettu',
        warning: 'Varoitus',
        blocking: 'Estävä',
        analyst: 'Analyytikko',
        viewer: 'Katsoja',
        daily: 'Päivittäin',
        weekly: 'Viikoittain',
        policies: 'Käytännöt',
        denied: 'Evätty',
        verified: 'Vahvistettu',
        detected: 'Havaittu',
        ignored: 'Ohitettu',
        open: 'Avaa',
        resolved: 'Ratkaistu',
        suspended: 'Keskeytetty',
        retired: 'Eläkkeellä',
        review: 'Tarkista',
        generated: 'Luotu',
        exported: 'Vietiin',
    },
    severity: {
        low: 'Matala',
        medium: 'Keskitaso',
        high: 'Korkea',
        critical: 'Kriittinen',
    },
    sensitivity: {
        standard: 'Perus',
        sensitive: 'Arkaluonteinen',
        special_category: 'Erityinen henkilötietoryhmä',
        badge_sensitive: 'Arkaluonteinen',
    },
    change_types: {
        policy_update: 'Käytäntö Päivitä',
        new_binding: 'Uusi Binding',
        remove_binding: 'Poista Binding',
        configuration_change: 'Konfiguraatio Change',
        banner_update: 'Banner Päivitä',
    },
    comparison_types: {
        full: 'Täysi',
        banner_only: 'Vain banneri',
        purposes_only: 'Tarkoitukset Only',
        legal_bases_only: 'Legal Perusteet Only',
        consent_settings: 'Suostumus Asetukset',
    },
    lifecycle_stages: {
        active: 'Aktiivinen',
        archived: 'Arkistoitu',
        pending_deletion: 'Odottaa Deletion',
        deleted: 'Poistettu',
        on_hold: 'On Pidätys',
    },
    object_types: {
        personal_data: 'Personal Tiedot',
        consent_record: 'Suostumus Tietue',
        user_account: 'Käyttäjätili',
        audit_log: 'Tarkastus Loki',
        document: 'Asiakirja',
        backup: 'Varmuuskopio',
    },
    transfer_mechanisms: {
        adequacy_decision: 'Riittävyyspäätös',
        standard_contractual_clauses: 'Standardi Contractual Lausekkeet',
        binding_corporate_rules: 'Binding Corporate Säännöt',
        explicit_consent: 'Explicit Suostumus',
        public_interest: 'Yleinen etu',
        legal_claims: 'Oikeudelliset vaatimukset',
        vital_interests: 'Elintärkeät edut',
    },
    risk_categories: {
        data_breach: 'Tiedot Tietoturvaloukkaus',
        unauthorized_access: 'Unauthorized Pääsy',
        data_loss: 'Tiedot Loss',
        regulatory_non_compliance: 'Säännösten noudattamattomuus',
        third_party_risk: 'Third-Party Riski',
        operational: 'Toiminnallinen',
        technical: 'Tekninen',
        legal: 'Lakiin perustuva',
    },
    mitigation_types: {
        technical: 'Tekninen',
        organizational: 'Organisatorinen',
        contractual: 'Sopimukseen perustuva',
        procedural: 'Menettelyllinen',
    },
    safeguard_types: {
        encryption_in_transit: 'Salaus siirrossa',
        encryption_at_rest: 'Salaus lepotilassa',
        access_controls: 'Kulunvalvonta',
        contractual_clauses: 'Sopimuslausekkeet',
        data_minimization: 'Tietojen minimointi',
        pseudonymization: 'Pseudonymisointi',
        audit_rights: 'Tilintarkastusoikeudet',
        breach_notification: 'Rikkomusilmoitus',
        data_localization: 'Tietojen lokalisointi',
        other: 'muu',
    },
    scoring_methods: {
        weighted_average: 'Painotettu keskiarvo',
        simple_average: 'Yksinkertainen Keskiarvo',
        maximum: 'Enimmäismäärä',
        manual: 'Manuaalinen',
    },
    dpa_status: {
        not_required: 'Ei vaadita',
        required: 'Vaaditaan',
        in_progress: 'Käynnissä',
        completed: 'Valmis',
        signed: 'Allekirjoitettu',
    },
    disposal_methods: {
        anonymize: 'Anonymisoi',
        pseudonymize: 'Pseudonymisoi',
        aggregate: 'Aggregoi',
        delete: 'Poista',
    },
    dashboard: {
        title: 'Yhteenveto',
        no_data: 'Yhteenvetotietoja ei saatavilla.',
        no_data_heading: 'Ei reaaliaikaista dataa vielä',
        no_data_detail: 'Alla olevat yhteenvedon widgetit näyttävät asettelun. Tiedot täyttyvät, kun taustapalvelu on yhdistetty tietokantaan.',
        consent_coverage: 'Suostumuskattavuus',
        ctia_filings: 'CTIA-ilmoitukset',
        next_dpia_review: 'Seuraava DPIA-tarkistus',
        next_review_none: 'Ei aikataulutettu',
        incident_mps_filings: 'Tapahtumien MPS-ilmoitukset',
        compliance_score: 'Vaatimustenmukaisuuspisteet',
        grade: 'Arvosana',
        no_score: 'Vaatimustenmukaisuuspisteitä ei ole vielä laskettu.',
        rights_requests: 'Tietopyynnöt',
        open: 'Avoimet',
        sla_breached: 'SLA ylitetty',
        sla_approaching: 'SLA lähestyy',
        closed_month: 'Suljetut (kuukausi)',
        incidents: 'Tapaukset ja tietoturvaloukkaukset',
        active: 'Aktiiviset',
        breaches: 'Tietoturvaloukkaukset',
        overdue_tasks: 'Myöhästyneet tehtävät',
        breach_72h_notice: '72 tunnin viranomaisilmoitusaika koskee aktiivisia rikkomuksia',
        recommendations: 'Suositukset',
        take_action: 'Toimi',
        drift_events: 'Poikkeamat ja hyväksynnät',
        open_events: 'Avoimet tapahtumat',
        pending_approvals: 'Odottavat hyväksynnät',
        monitoring: 'Valvontatehtävät',
        programs: 'Ohjelmat',
        overdue: 'Myöhässä',
        pending: 'Odottaa',
        ric_cases: 'Viranomaistiedustelut',
        coverage: 'Tietojen kattavuus',
        systems: 'Järjestelmät',
        activities: 'Käsittelytoimet',
        vendors: 'Toimittajat',
        dpias: 'Vaikutustenarvioinnit',
        open_gaps: 'avoimet puutteet',
        view_as_table: 'Nayta taulukkona',
        view_as_chart: 'Nayta kaaviona',
        table_metric_header: 'Mittari',
        table_value_header: 'Arvo',
        announce_chart_view: 'Nayttaa kaavionakyman',
        announce_table_view: 'Nayttaa taulukkonakyman',
        section_core_metrics: 'Ydintunnusluvut',
        section_task_management: 'Tehtavien hallinta',
        section_compliance_insights: 'Vaatimustenmukaisuusnakymat',
        configure_dashboard: 'Maarita kojelauta',
        config_col_active: 'Aktiivinen',
        config_col_widget: 'Widget',
        collapse_section: 'Pienenna',
        expand_section: 'Laajenna',
        reset_to_defaults: 'Palauta oletukset',
        preferences_saved: 'Kojelaudan asetukset tallennettu',
        preferences_reset: 'Kojelauta palautettu roolioletuksiin',
        preferences_load_error: 'Kojelaudan asetusten lataus epäonnistui',
        factor_avg_system_score: 'Järjestelmän keskimääräinen pistemäärä',
        factor_avg_vendor_score: 'Myyjän keskimääräinen pistemäärä',
        factor_processing_coverage: 'Käsittelytoiminnan kattavuus',
        factor_ropa_completeness: 'RoPA täydellisyys',
        factor_drift_penalty: 'Drift-tapahtumien rangaistus',
        rec_improve_system_gov: 'Paranna järjestelmän hallintadokumentaatiota',
        rec_improve_vendor_gov: 'Paranna toimittajan hallintadokumentaatiota',
        rec_document_processing: 'Asiakirjojen käsittelytoiminnot peittämättömille järjestelmille',
        rec_generate_ropa: 'Luo RoPA-tietueita aktiivisille käsittelytoiminnoille',
        rec_resolve_drift: 'Ratkaise avoimet kriittiset ja erittäin vakavat poikkeamat',
        score_good: 'Hyvä',
        score_fair: 'Kohtalainen',
        score_poor: 'Heikko',
        score_critical: 'Kriittinen',
        drag_to_reorder: 'Vedä järjestääksesi uudelleen',
        widget_moved: 'Widget siirretty',
        press_space_to_grab: 'Paina välilyöntiä tarttuaksesi, nuolinäppäimet siirtämiseen, välilyönti pudottamiseen',
        reorder_instructions: 'Käytä vetämistä ja pudottamista tai pikanäppäimiä järjestääksesi widgetit uudelleen',
        task_widgets: {
            tasks_overview: 'Tehtävien yleiskatsaus',
            pending: 'Odottaa',
            in_progress: 'Meneillään',
            overdue: 'Myöhässä',
            done_7d: 'Valmis (7p)',
            by_priority: 'Prioriteetin mukaan',
            view_all_tasks: 'Näytä kaikki tehtävät',
            upcoming_tasks: 'Tulevat tehtävät (seuraavat 7 päivää)',
            no_upcoming: 'Ei tehtäviä seuraavan 7 päivän aikana.',
            view_calendar: 'Näytä kalenteri',
            overdue_alerts: 'Myöhässä',
            no_overdue: 'Ei myöhässä olevia tehtäviä. Kaikki on raiteilla.',
            assigned_to: 'Määrätty',
            view_all_overdue: 'Näytä kaikki erääntyneet',
            notifications: 'Viimeaikaiset ilmoitukset',
            unread: 'unread',
            no_notifications: 'Ei ilmoituksia. Olette kaikki kiinni!',
            view_all_notifications: 'Näytä kaikki ilmoitukset',
            load_error: 'Tietojen lataaminen epäonnistui.',
            day_late: 'päivän myöhässä',
            days_late_plural: 'päivää myöhässä',
            due_today: 'Erään tänään',
            just_now: 'juuri nyt',
            minutes_short: 'm',
            hours_short: 'h',
            days_short: 'd',
            cross_org_stats: 'Organisaatioiden väliset tilastot',
            by_organization: 'Organisaation mukaan',
            overdue_across_orgs: 'myöhässä olevia tehtäviä eri organisaatioissa',
            total: 'Yhteensä',
            tasks: 'tasks',
            organization: 'Organisaatio',
            current_org: 'Nykyinen organisaatio',
            all_orgs: 'Kaikki organisaatiot',
            all_organizations: 'Kaikki organisaatiot',
            filter_by_org: 'Suodata organisaation mukaan',
            cross_org: 'Cross-org',
            empty_calendar: 'Ei tehtäviä tälle ajanjaksolle. Luo ensimmäinen tehtäväsi tai tarkista suodattimet.',
            empty_my_tasks: 'Sinulle ei ole määritetty tehtäviä. Hienoa työtä!',
            empty_overdue: 'Ei myöhässä olevia tehtäviä. Kaikki on raiteilla.',
            empty_notifications: 'Ei ilmoituksia. Olette kaikki kiinni!',
            empty_workflows: 'Työnkulkuja ei ole määritetty. Aloita selaamalla malleja.',
        },
        my_tasks_widget: {
            title: 'Omat Tehtävät',
            no_tasks: 'Sinulle ei ole osoitettu tehtäviä.',
            load_error: 'Tehtävien lataaminen epäonnistui.',
            overdue: 'myöhässä',
            remaining: 'jäljellä',
            view_all: 'Näytä Kaikki Tehtävät',
        },
        my_section_status_widget: {
            title: 'Oman Osion Tila',
            overall_completion: 'Kokonais',
            sections_count: 'Osiot',
            no_sections: 'Osastoosi ei ole osoitettu osioita.',
            load_error: 'Osion tilan lataaminen epäonnistui.',
        },
        revision_requests_widget: {
            title: 'Tarkistuspyynnöt',
            no_revisions: 'Ei tarkistuspyyntöjä. Kaikki osiot ovat aikataulussa.',
            load_error: 'Tarkistuspyyntöjen lataaminen epäonnistui.',
        },
        consent_summary: {
            title: 'Suostumus',
            active: 'Aktiivinen',
            withdrawn_30d: 'Peruttu (30pv)',
            expiring_7d: 'Vanhenee (7pv)',
        },
        transfer_assessments: {
            title: 'Siirtoarviot',
            open: 'Avaa',
            approved: 'Hyväksytty',
            gaps_flagged: 'Aukkoja merkitty',
        },
        breach_notifications: {
            title: 'Rikkomusilmoitukset',
            deadline_72h: '72h määräaika',
            submitted: 'Lähetetty',
            pending: 'Odottaa',
        },
        authority_requests: {
            title: 'Viranomaisten pyynnöt',
            pending: 'Odottaa',
            overdue: 'Myöhässä',
            responded_30d: 'Vastattu (30p)',
        },
        data_subjects_widget: {
            title: 'Rekisteröidyt',
            total: 'Yhteensä',
            high_risk: 'Korkea riski',
            active_30d: 'Aktiivinen (30 pv)',
        },
        audit_activity_summary: {
            title: 'Tarkastustoiminta',
            events_today: 'Tämän päivän tapahtumat',
            events_7d: 'Tapahtumat (7p)',
            unique_actors_30d: 'Ainutlaatuiset näyttelijät (30d)',
        },
        onboarding_progress: {
            title: 'Käyttöönoton edistyminen',
            completion_pct: 'Täydellinen',
            status_label: 'Tila',
            current_step: 'Nykyinen vaihe',
            status: {
                in_progress: 'Käynnissä',
                completed: 'Valmis',
                skipped: 'Ohitettu',
                not_started: 'Ei aloitettu',
            },
        },
        sector_overlay_reports_due: {
            title: 'Erääntyvät toimialalisäosan raportit',
        },
        persona_widgets: {
            framework_filter: 'Suodata kehyksen mukaan',
            all_frameworks: 'Kaikki kehykset',
            filing_lifecycle: 'Ilmoitusten elinkaari',
            filing_pipeline: 'Ilmoitusputki',
            draft: 'Luonnos',
            internal_review: 'Sisäinen tarkistus',
            approved: 'Hyväksytty',
            submitted: 'Lähetetty',
            supplement_requested: 'Täydennys pyydetty',
            resubmitted: 'Lähetetty uudelleen',
            accepted: 'Hyväksytty',
            rejected: 'Hylätty',
            closed: 'Suljettu',
            deadline: 'Määräaika',
            days_remaining: 'päivää jäljellä',
            days_overdue: 'päivää myöhässä',
            no_filings: 'Ei aktiivisia ilmoituksia.',
            department_consolidation: 'Osastojen konsolidointi',
            departments_completed: 'Osastot valmiit',
            departments_pending: 'Osastot odottavat',
            departments_overdue: 'Osastot myöhässä',
            no_consolidation_cases: 'Ei usean osaston tapauksia käynnissä.',
            vendor_risk: 'Toimittaja- ja kolmannen osapuolen riski',
            pending_assessment: 'Odottava arviointi',
            overdue_questionnaires: 'Myöhässä olevat kyselyt',
            dpa_review_queue: 'DPA-tarkistusjono',
            risk_distribution: 'Riskien jakautuminen',
            total_vendors: 'Toimittajat yhteensä',
            by_risk_level: 'Riskitason mukaan',
            no_vendor_data: 'Toimittajariskitietoja ei saatavilla.',
            discovery_summary: 'Tietojen l?ydett?vyys',
            discovery_classification: 'Tietojen löytäminen ja luokittelu',
            active_scans: 'Aktiiviset skannaukset',
            labels_pending: 'Tarrat odottavat tarkistusta',
            exceptions_unresolved: 'Poikkeukset Ratkaisematta',
            pending_review: 'Odottava tarkistus',
            exceptions: 'Poikkeukset',
            approved_labels: 'Hyväksytyt merkinnät',
            total_classified: 'Yhteensä luokiteltu',
            no_discovery_data: 'Löytämistietoja ei saatavilla.',
            ai_governance: 'Tekoälyjärjestelmien hallinto',
            systems_inventory: 'Järjestelmät varastossa',
            systems_in_inventory: 'Järjestelmät inventaariossa',
            classification_breakdown: 'Luokituksen erittely',
            dossier_completion: 'Asiakirjakansion valmius',
            by_classification: 'Luokittelun mukaan',
            labeling_status: 'Merkintätila',
            not_started: 'Ei aloitettu',
            no_ai_data: 'Tekoälyhallintotietoja ei saatavilla.',
            breach_response: 'Tietoturvaloukkaus- ja poikkeamavaste',
            active_breaches: 'Aktiiviset loukkaukset',
            notification_status: 'Ilmoituksen tila',
            remediation_progress: 'Korjauksen edistyminen',
            supplement_loops: 'Täydennyssilmukat',
            no_breach_data: 'Ei aktiivisia loukkoustapauksia.',
            audit_readiness: 'Tarkastus- ja arviointivalmius',
            assessments: 'Arvioinnit',
            gap_findings: 'Puutelöydökset',
            evidence_completion: 'Todisteiden valmius',
            export_ready: 'Vientivalmis',
            not_ready: 'Ei valmis',
            no_audit_data: 'Tarkastusvalmiustietoja ei saatavilla.',
            framework_label_vn_pdpl: 'VN PDPL 2025',
            framework_label_vn_cybersecurity: 'VN Kyberturvallisuus 2018',
            framework_label_vn_ecommerce: 'VN Sahkoinen kauppa 2023',
            framework_label_vn_telecom: 'VN Televiestinta 2023',
            framework_label_vn_ai: 'VN Tekoalylaki 2025',
            framework_label_gdpr: 'GDPR',
            framework_label_unspecified: 'Määrittelemätön',
            my_department: 'Oma osasto',
            my_tasks: 'Omat tehtävät',
            section_status: 'Osion tila',
            revision_requests: 'Muutospyynnöt',
            completion: 'Valmius',
            reason: 'Syy',
            requested_at: 'Pyydetty',
            no_tasks_assigned: 'Ei tehtäviä sinulle.',
            no_sections: 'Ei osioita osastollesi.',
            no_revisions: 'Ei muutospyyntöjä.',
            load_error: 'Tietojen lataaminen epäonnistui.',
        },
    },
    connectors: {
        nav: {
            instances: 'Instanssit',
            credentials: 'Tunnisteholvi',
            event_bus: 'Tapahtumaväylä',
            definitions: 'Määritelmät',
            brds: 'BRD-keruu',
            security_reviews: 'Tietoturva-arvioinnit',
            poc_scorecards: 'POC-tuloskortit',
            automation_planning: 'Automaatiosuunnittelu',
            system_inventory: 'Järjestelmäinventaario',
            traceability_matrix: 'Jäljitettävyysmatriisi',
            gap_register: 'Puuterekisteri',
        },
        instances: {
            title: 'Liitininstanssit',
            page_title: 'Liittimet',
            add: 'Lisää instanssi',
            test: 'Testaa yhteys',
            sync_now: 'Synkronoi nyt',
            new_instance: 'Uusi Liitin Instance',
            no_instances: 'Ei connector instances löytynyt',
            instance_count: '{count} esiintymää',
            confirm_delete: 'Poista connector instance "{name}"?',
            all_connector_types: 'Kaikki liitintyypit',
            select_connector: 'Valitse a connector...',
            fetch_error: 'Epäonnistui: fetch connector instances. Yritä uudelleen.',
            fetch_definitions_error: 'Epäonnistui: fetch connector definitions. Yritä uudelleen.',
            create_error: 'Epäonnistui: create connector instance. Yritä uudelleen.',
            test_error: 'Epäonnistui: test connector. Yritä uudelleen.',
            status_error: 'Yhdistimen tilan päivittäminen epäonnistui. Yritä uudelleen.',
            delete_error: 'Epäonnistui: delete connector instance. Yritä uudelleen.',
        },
        credentials: {
            title: 'Tunnisteholvi',
            page_title: 'Liittimen tunnistetiedot',
            add: 'Lisää tunniste',
            rotate: 'Kierrätä',
            expired: 'Vanhentunut',
            expiring: 'Vanhenemassa pian',
            orphaned: 'Orpo',
            new_credential: 'Uusi Tunniste',
            no_credentials: 'Ei credentials löytynyt',
            no_expiry: 'Ei vanhenemista',
            linked_connectors: 'Linked Liittimet',
            expires_at: 'Vanhenee',
            value_label: 'Arvo * (vain kirjoitus)',
            confirm_delete_title: 'Vahvista poisto',
            confirm_delete_message: 'Poista tämä tunniste? Yhdistetyt liittimet menettävät pääsyn.',
            rotate_title: 'Kierrätä tunniste',
            new_credential_value: 'Uusi tunnistearvo',
            fetch_error: 'Epäonnistui: load credentials. Yritä uudelleen.',
            health_error: 'Epäonnistui: load health. Yritä uudelleen.',
            create_error: 'Epäonnistui: create credential. Yritä uudelleen.',
            rotate_error: 'Epäonnistui: rotate credential. Yritä uudelleen.',
            delete_error: 'Epäonnistui: delete credential. Yritä uudelleen.',
        },
        event_bus: {
            title: 'Tapahtumaväylä',
            page_title: 'Tapahtumaväylä',
            events: 'Tapahtumat',
            subscriptions: 'Tilaukset',
            dlq: 'Virheviestijono',
            publish: 'Julkaise tapahtuma',
            retry: 'Yritä uudelleen',
            dismiss: 'Ohita',
            search_events: 'Hae tapahtuma...',
            filter_event_type: 'Suodata by tapahtuma tyyppi...',
            event_type: 'Tapahtumatyyppi',
            source_module: 'Lähde Moduuli',
            timestamp: 'Aikaleima',
            delivery_status: 'Delivery Tila',
            correlation_id: 'Korrelaatio Tunniste',
            tracking_id: 'Seurantatunnus',
            delivery_status_hint: 'Toimituksen tila päivittyy automaattisesti tapahtumien käsittelyn yhteydessä.',
            no_events: 'Ei tapahtuma löytynyt',
            total_with_count: '{count} yhteensä',
            prev: 'Edellinen',
            new_subscription: '+ Uusi tilaus',
            subscriber_type: 'Subscriber Tyyppi',
            subscriber_id: 'Subscriber Tunniste',
            event_type_pattern: 'Tapahtuma Tyyppi Malli',
            event_type_pattern_placeholder: 'esim. incident.*',
            filter_expression: 'Suodata Expression',
            filter_expression_placeholder: 'Valinnainen filter',
            subscriber_type_hint: 'Valitse tapahtumien toimitustapa: webhook lähettää HTTP-pyyntöjä, sähköposti lähettää ilmoituksia, jono ohjaa viestijonoon.',
            subscriber_id_hint: 'Syötä tapahtumien kohde. Webhookeille käytä URL-osoitetta. Sähköpostille käytä osoitetta. Jonoille käytä jonon nimeä.',
            event_type_pattern_hint: 'Täsmää tapahtumia tyypin mukaan jokerimerkeillä. Käytä * minkä tahansa segmentin täsmäämiseen (esim. incident.* täsmää incident.created, incident.resolved).',
            filter_expression_hint: 'Valinnainen. Suodata tapahtumia sisällön mukaan (esim. severity=high).',
            subscriber_id_placeholder_webhook: 'esim. https://sovelluksesi.com/webhook',
            subscriber_id_placeholder_email: 'esim. halytykset@yrityksesi.com',
            subscriber_id_placeholder_queue: 'esim. tapahtumajoono',
            event_pattern: 'Tapahtuma Malli',
            filter: 'Suodata',
            enabled: 'Käytössä',
            delivery_stats: 'Toimitustilastot',
            no_subscriptions: 'Ei subscriptions löytynyt',
            on: 'ON',
            off: 'OFF',
            delivered_failed: '{delivered} toimitettu / {failed} epäonnistunut',
            confirm_delete_subscription: 'Poista this subscription?',
            unresolved: 'Ratkaisematon',
            resolved: 'Ratkaistu',
            event_id: 'Tapahtuma Tunniste',
            subscription_id: 'Tilaus Tunniste',
            error_code: 'Virhe Koodi',
            error_message: 'Virhe Message',
            attempts: 'Yritykset',
            last_failed: 'Last Epäonnistunut',
            no_dlq_entries: 'Ei dead letter entries löytynyt',
            dlq_count: '{count} merkintää yhteensä',
            fetch_events_error: 'Epäonnistui: fetch tapahtuma. Yritä uudelleen.',
            fetch_subscriptions_error: 'Epäonnistui: fetch subscriptions. Yritä uudelleen.',
            fetch_dlq_error: 'Epäonnistui: fetch DLQ entries. Yritä uudelleen.',
            create_subscription_error: 'Epäonnistui: create subscription. Yritä uudelleen.',
            toggle_subscription_error: 'Epäonnistui: toggle subscription. Yritä uudelleen.',
            delete_subscription_error: 'Epäonnistui: delete subscription. Yritä uudelleen.',
            retry_error: 'Yritä uudelleen epäonnistunut',
            dismiss_error: 'Dismiss epäonnistunut',
            event_published: 'Tapahtuma julkaistu',
            publish_event_error: 'Tapahtuman julkaisu epäonnistui. Yritä uudelleen.',
            priority_label: 'Prioriteetti',
            priority_low: 'Matala',
            priority_normal: 'Normaali',
            priority_high: 'Korkea',
            payload_helper_text: 'Syötä tapahtumatiedot JSON-muodossa. Esimerkki: {"incident_id": "INC-001", "severity": "high"}',
            subscription_created: 'Tilaus luotu',
            subscription_toggled: 'Tilaus vaihdettu',
            subscription_deleted: 'Tilaus poistettu',
            dlq_retried: 'DLQ-viestiä yritettiin uudelleen',
            dlq_dismissed: 'DLQ-viesti hylätty',
        },
        definitions: {
            title: 'Liittimen määritelmät',
            page_title: 'Liitinmäärittelyt',
            add: 'Lisää määritelmä',
            new_definition: 'Uusi liittimen määritelmä',
            edit_definition: 'Muokkaa liittimen määritelmää',
            no_definitions: 'Liitinmääritelmiä ei löytynyt',
            definition_count: '[[TOK_1]] määritelmä(t)',
            all_categories: 'Kaikki luokat',
            select_category: 'Valitse luokka...',
            capabilities: 'Ominaisuudet',
            capabilities_hint: 'Ominaisuudet (pilkuilla erotettu)',
            capabilities_placeholder: 'esim. lukea, kirjoittaa, synkronoida',
            created: 'Liittimen määritelmä luotu',
            updated: 'Liittimen määritelmä päivitetty',
            fetch_error: 'Liitinmääritelmien noutaminen epäonnistui. Yritä uudelleen.',
            create_error: 'Liittimen määrityksen luominen epäonnistui',
            update_error: 'Yhdistimen määrityksen päivittäminen epäonnistui',
        },
        brds: {
            title: 'BRD-keruu',
            page_title: 'BRD-tallennus',
            create_brd: 'Luo BRD',
            brd_title: 'BRD-otsikko',
            description: 'Kuvaus',
            requirements: 'Vaatimukset',
            status: 'Tila',
            stakeholders: 'Sidosryhmät',
            connector_label: 'Liitin',
            select_connector: 'Valitse liitin...',
            approval: 'Hyväksyntä',
            no_brds_found: 'BRD:itä ei löytynyt',
            decision_records: 'Päätöstietueet',
            create_decision: 'Luo päätös',
            alternatives_considered: 'Harkitut vaihtoehdot',
            alternative_name: 'Vaihtoehdon nimi',
            reason_rejected: 'Hylkäyksen syy',
            add_alternative: 'Lisää vaihtoehto',
            remove_alternative: 'Poista vaihtoehto {name}',
            alternatives: 'Vaihtoehdot',
            rationale: 'Perustelu',
            selected_connector: 'Valittu liitin',
            comma_separated_names: 'Pilkuilla erotetut nimet',
            brd_created: 'BRD luotu',
            decision_record_created: 'Päätöstietue luotu',
            no_decision_records_found: 'Ei päätöstietueita löytynyt',
            aria_brds_table: 'BRD:t',
            aria_decision_records_table: 'Päätöstietueet',
            aria_approve: 'Hyväksy {name}',
            aria_archive: 'Arkistoi {name}',
            brd_title_help: 'Lyhyt, ihmisen luettavissa oleva nimi tälle BRD:lle – esim. "Jira-lippujen integrointi", "Okta SSO:n käyttöönotto".',
            brd_title_placeholder: 'esim. Jiran lippujen integrointi',
            description_help: 'Liiketoimintaongelman tämä liitin ratkaisee. Millaista tulosta odotat sen jälkeen, kun se on live-tilassa?',
            description_placeholder: 'esim. Automatisoi tapahtumalipun luominen valvontahälytyksistä, jotta päivystys haetaan 60 sekunnissa.',
            connector_help: 'Valinnainen. Valitse liitin, johon tämä BRD on tarkoitettu – jätä tyhjäksi, jos liitintä ei ole vielä valittu.',
            requirements_help: 'Pilkuilla eroteltu luettelo pakollisista ominaisuuksista – esim. "OAuth2-kirjautuminen, webhook-toimitus, tarkastuksen vienti".',
            requirements_placeholder: 'OAuth2-kirjautuminen, webhook-toimitus, tarkastuksen vienti',
            stakeholders_help: 'Pilkuilla erotetut nimet tai sähköpostiosoitteet henkilöistä, joiden on kirjauduttava ulos.',
            selected_connector_help: 'Valitse liitin, jota tämä päätös koskee.',
            rationale_help: 'Miksi tämä liitin valittiin? Käsittele ratkaisevat tekijät, jotta tuleva lukija ymmärtää kutsun.',
            rationale_placeholder: 'esim. Valitsi Jiran, koska sillä on jo lippuhistoriamme ja joukkue on koulutettu siihen.',
            alternatives_considered_help: 'Muut liittimet arvioitiin ja miksi niitä ei valittu. Lisää puolustettavuutta tarkastukseen.',
            alternative_name_placeholder: 'esim. ServiceNow',
            reason_rejected_placeholder: 'esim. Hinta 3 kertaa korkeampi, ei etua käyttötapauksellemme',
        },
        security_reviews: {
            title: 'Tietoturva-arvioinnit',
            page_title: 'Turvallisuuskatsaukset',
            create_review: 'Luo arviointi',
            connector_name: 'Liittimen nimi',
            connector_label: 'Liitin',
            select_connector: 'Valitse liitin...',
            reviewer: 'Arvioija',
            select_reviewer: 'Valitse arvioija...',
            findings: 'Havainnot (yksi per rivi)',
            risk_level: 'Riskitaso',
            risk_level_placeholder: 'esim. korkea, keskitaso, matala',
            notes: 'Muistiinpanot',
            review_status: 'Arvioinnin tila',
            checklist: 'Tarkistuslista',
            privacy_impact: 'Tietosuojavaikutus',
            approval_gate: 'Hyväksyntäportti',
            no_reviews_found: 'Arviointeja ei löytynyt',
            review_created: 'Turvallisuuskatsaus luotu',
            create_control_mapping: 'Luo kontrollikartoitus',
            control_mapping_created: 'Kontrollikartoitus luotu',
            connector_id_label: 'Liittimen tunnus',
            control_id_label: 'Kontrollin tunnus',
            control_name_label: 'Kontrollin nimi',
            aria_approve: 'Hyväksy {name}',
            aria_reject: 'Hylkää {name}',
            scan_imported: 'Skannaus tuotu onnistuneesti',
            import_scan: 'Tuo skannaus',
            scan_format: 'Skannausmuoto',
            scan_data: 'Skannausdata',
            import_results: 'Tuontitulokset',
            recommendations: 'Suositukset',
            auto_populated_from: 'Täytetty automaattisesti kohteesta [[TOK_1]]',
            manual_entry: 'Manuaalinen syöttö',
            automation_type: 'Automaatiotyyppi',
            select_automation_type: 'Valitse automaatiotyyppi...',
            automation_full: 'Full — liitin täysin automatisoi tämän ohjauksen',
            automation_partial: 'Osittainen — liitin antaa todisteita; ihmiset toimivat edelleen',
            automation_monitoring: 'Vain valvonta – liitin tarkkailee, ei pakota',
            control_id_help: 'Käytä vaatimustenmukaisuusjärjestelmäsi koodia (esim. ISO-27001-A.12.1, SOC2-CC6.1 tai sisäisen valvontatunnuksesi).',
            control_name_help: 'Lyhyt ihmisen luettavissa oleva nimi (esim. "Verkon käyttörajoitus").',
            description_label: 'Kuvaus',
            load_sarif_example: 'Lataa SARIF-esimerkki',
            load_json_example: 'Lataa mukautettu esimerkki [[TOK_0]]',
            scan_format_help: 'SARIF on useimpien skannerien (Snyk, CodeQL, Semgrep) lähettämä OASIS-standardi. Käytä mukautettua [[TOK_0]] työkaluille, jotka eivät lähetä SARIF:ia.',
            scan_data_help: 'Liitä koko skannaustuloste, lähetä .sarif/.json-tiedosto tai napsauta Lataa esimerkki -painiketta nähdäksesi muodon.',
            upload_file_label: 'Lataa .sarif- tai .json-tiedosto',
            invalid_scan_json: 'Skannaustietoja ei voitu jäsentää muodossa [[TOK_0]]. Tarkista, onko korostetun merkin lähellä syntaksivirheitä.',
            save_as_review: 'Tallenna suojausarvioksi',
            discard_preview: 'Hylkää esikatselu',
            preview_hint: 'Tämä on esikatselu – mitään ei ole vielä tallennettu. Napsauta "Tallenna suojausarvioksi" luodaksesi odottavan tarkistuksen, joka on esitäytetty näillä arvoilla.',
            reviewer_required_for_save: 'Valitse tarkistaja tallentaaksesi tämän skannauksen tietoturvatarkistuksena.',
        },
        poc_scorecards: {
            title: 'POC-tuloskortit',
            page_title: 'POC-tuloskortit',
            create_scorecard: 'Luo tuloskortti',
            connector_label: 'Liitin',
            select_connector: 'Valitse liitin...',
            vendor_name: 'Toimittajan nimi',
            recommendation: 'Suositus',
            recommendation_placeholder: 'esim. Jatka, Älä jatka, Vaatii lisäarviointia',
            criteria: 'Arviointikriteerit',
            criterion_name: 'Kriteerin nimi',
            score: 'Pisteet',
            max_score: 'Enimmäispisteet',
            notes: 'Muistiinpanot',
            add_criterion: 'Lisää kriteeri',
            remove_criterion: 'Poista kriteeri {name}',
            total_score: 'Kokonaispisteet',
            api_quality: 'API-laatu',
            reliability: 'Luotettavuus',
            support_quality: 'Tuen laatu',
            cost_score: 'Kustannusarvio',
            overall_score: 'Kokonaisarvio',
            evidence: 'Todisteet',
            no_scorecards_found: 'Tuloskortteja ei löytynyt',
            scorecard_created: 'POC-tuloskortti luotu',
            connector_help: 'Valitse liitin, jolle tämä POC-arviointi on tarkoitettu.',
            vendor_name_help: 'Myyjä tai arvioitava tuote – esim. "Okta", "Datadog", "Lumihiutale".',
            vendor_name_placeholder: 'esim. Okta, Datadog, Snowflake',
            recommendation_help: 'Viimeinen puhelusi arvioinnin jälkeen. Pidä se lyhyenä ja päättäväisenä.',
            criteria_help: 'Anna toimittajalle pisteet jokaisesta arviointikriteeristä. Lisää yksi rivi ehtoa kohden ([[TOK_0]] laatu, luotettavuus, tuki, hinta jne.).',
            criterion_name_help: 'Mitä pisteet - esim. "[[TOK_0]] Laatu", "Luotettavuus", "Tuki", "Hinta".',
            criterion_name_placeholder: 'esim. [[TOK_0]] Laatu',
            score_help: 'Tästä kriteeristä myönnetty piste. Ei saa ylittää enimmäispistemäärää.',
            max_score_help: 'Parhaat pisteet tällä kriteerillä. Käytä samaa asteikkoa eri riveillä, jotta kokonaissummat ovat vertailukelpoisia.',
            notes_help: 'Valinnainen. Lisää todisteita, varoituksia tai linkkejä – mitä tahansa, mikä selittää tuloksen.',
        },
        common_labels: {
            aria_filter_instances: 'Suodata liitininstanssit',
            aria_filter_definitions: 'Suodata liitinmäärittelyt',
            aria_filter_credentials: 'Suodata tunnistetiedot',
            aria_filter_events: 'Suodata tapahtumat',
            aria_filter_dlq: 'Suodata kuolleiden kirjeiden jono',
            aria_instance_summary: 'Liitininstanssin yhteenveto',
            aria_active_connectors: 'Aktiiviset liittimet',
            aria_error_connectors: 'Virheelliset liittimet',
            aria_credential_health: 'Tunnistetietojen tilayhteenveto',
            aria_items_per_page: 'Kohteet sivua kohti',
            show_password: 'Näytä salasana',
            hide_password: 'Piilota salasana',
            payload_json_label: 'Hyötykuorma (JSON)',
            payload_invalid_json: 'Hyötykuorman on oltava kelvollinen JSON',
            placeholder_event_type: 'esim. incident.created',
            placeholder_source_module: 'esim. monitoring',
            placeholder_version: 'esim. 1.0',
        },
        statuses: {
            configuring: 'Määritetään',
            testing: 'Testaus',
            active: 'Aktiivinen',
            paused: 'Keskeytetty',
            error: 'Virhe',
            disabled: 'Ei käytössä',
            draft: 'Luonnos',
            approved: 'Hyväksytty',
            archived: 'Arkistoitu',
            pending: 'Odottaa',
            rejected: 'Hylätty',
        },
        system_types: {
            application: 'Sovellus',
            database: 'Tietokanta',
            middleware: 'Väliohjelmisto',
            infrastructure: 'Infrastruktuuri',
            saas: 'SaaS',
            other: 'Muu',
        },
        hosting_types: {
            on_premise: 'Paikallinen',
            cloud: 'Pilvi',
            hybrid: 'Hybridi',
            managed: 'Hallittu',
        },
        system_statuses: {
            active: 'Aktiivinen',
            decommissioned: 'Poistettu käytöstä',
            planned: 'Suunniteltu',
            under_review: 'Tarkistuksessa',
        },
        automation_statuses: {
            planning: 'Suunnittelu',
            in_progress: 'Käynnissä',
            completed: 'Valmis',
            on_hold: 'Odottaa',
        },
        gap_types: {
            functional: 'Toimiva',
            technical: 'Tekninen',
            security: 'Turvallisuus',
            compliance: 'Vaatimustenmukaisuus',
            process: 'Prosessi',
        },
        severity_labels: {
            critical: 'Kriittinen',
            high: 'Korkea',
            medium: 'Keskitaso',
            low: 'Matala',
        },
        gap_statuses: {
            open: 'Avoin',
            in_progress: 'Käynnissä',
            mitigated: 'Lievennetty',
            closed: 'Suljettu',
            accepted: 'Hyväksytty',
        },
        verification_statuses: {
            not_started: 'Ei aloitettu',
            in_progress: 'Käynnissä',
            verified: 'Vahvistettu',
            failed: 'Epäonnistunut',
        },
        subscriber_types: {
            webhook: 'Webhook',
            internal: 'Sisäinen',
            email: 'Sähköposti',
            queue: 'Jono',
        },
        credential_types: {
            password: 'Salasana',
            api_key: 'API-avain',
            oauth2_client: 'OAuth2-asiakas',
            certificate: 'Sertifikaatti',
            token: 'Token',
            ssh_key: 'SSH-avain',
            imap_credentials: 'IMAP-tunnisteet',
        },
        categories: {
            hr: 'HR',
            crm: 'CRM',
            erp: 'ERP',
            cloud: 'Pilvi',
            security: 'Turvallisuus',
            itsm: 'ITSM',
            custom: 'Mukautettu',
        },
        delivery_statuses: {
            pending: 'Odottaa',
            delivered: 'Toimitettu',
            partial: 'Osittainen',
            failed: 'Epäonnistunut',
        },
        automation_planning: {
            title: 'Automaatiosuunnittelu',
            page_title: 'Automaatiosuunnittelu',
            program_name: 'Ohjelman nimi',
            program_status: 'Tila',
            description: 'Kuvaus',
            linked_artifacts: 'Linkitetyt artefaktit',
            create_program: 'Luo ohjelma',
            edit_program: 'Muokkaa ohjelmaa',
            no_programs_found: 'Ei ohjelmia',
            program_created: 'Ohjelma luotu',
            program_updated: 'Ohjelma päivitetty',
            target_date: 'Tavoitepäivä',
            owner: 'Omistaja',
            select_status: 'Valitse tila...',
            aria_programs_table: 'Automaatio-ohjelmat',
            aria_edit: 'Muokkaa {name}',
            export_programs: 'Vie ohjelmat',
            title_label: 'Ohjelman nimi',
            title_help: 'Lyhyt, ihmisen luettava nimi automaatioohjelmalle – esim. "Q3 incident-to-Jira-käyttöönotto", "[[TOK_0]] pääsy-pyyntöautomaatio".',
            title_placeholder: 'esim. Q3-tapahtuma-Jiran käyttöönotto',
            description_help: 'Mitä tämä ohjelma kattaa ja mitä tuloksia odotat sen ollessa livenä. Valinnainen mutta suositeltavaa.',
            description_placeholder: 'esim. Johdinvalvonta hälyttää Jiraan, joten päivystys haetaan 60 sekunnissa.',
            owner_label: 'Ohjelman omistaja',
            owner_help: 'Tästä ohjelmasta vastuussa oleva henkilö. He saavat ilmoituksia edistymisestä ja porteista.',
            select_owner: 'Valitse omistaja...',
            frameworks_in_scope: 'Kehykset laajuudessa',
            frameworks_in_scope_help: 'Yhdenmukaisuuskehykset, joita tämä ohjelma tukee. Auttaa kirjausketjua näyttämään, mitkä säädökset automaatiota säätelevät.',
            select_frameworks: 'Valitse puitteet...',
            status_draft: 'Luonnos',
            status_active: 'Aktiivinen',
            status_completed: 'Valmis',
            status_archived: 'Arkistoitu',
            change_status: 'Muuta tilaa',
            status_updated: 'Tila päivitetty',
            aria_change_status: 'Muuta tilaa [[TOK_1]]',
        },
        system_inventory: {
            title: 'Järjestelmäinventaario',
            page_title: 'Järjestelmäinventaario',
            system_name: 'Järjestelmän nimi',
            system_type: 'Järjestelmätyyppi',
            hosting: 'Isännöinti',
            status: 'Tila',
            description: 'Kuvaus',
            create_system: 'Luo järjestelmä',
            edit_system: 'Muokkaa järjestelmää',
            no_systems_found: 'Ei järjestelmiä',
            system_created: 'Järjestelmä luotu',
            system_updated: 'Järjestelmä päivitetty',
            select_type: 'Valitse tyyppi...',
            select_hosting: 'Valitse hosting...',
            select_status: 'Valitse tila...',
            owner: 'Omistaja',
            department: 'Osasto',
            data_categories: 'Tietoluokat',
            data_categories_placeholder: 'Pilkuilla erotettu, esim. PII, Talous, Terveys',
            jurisdiction: 'Toimivalta',
            jurisdiction_placeholder: 'esim. EU, US, Globaali',
            interfaces: 'Liitännät',
            interfaces_placeholder: 'Pilkuilla erotettu, esim. REST API, SFTP, JDBC',
            owner_placeholder: 'Valitse vastuullinen omistaja...',
            department_placeholder: 'Valitse vastuullinen organisaatioyksikkö...',
            system_name_hint: 'Käytä liiketoiminnan tunnustamaa järjestelmän tai sovelluksen nimeä.',
            system_type_hint: 'Luokittele järjestelmä, jotta raportointi voi ryhmitellä vastaavia resursseja.',
            hosting_hint: 'Tunnista, missä järjestelmä sijaitsee asuinpaikan, turvallisuuden ja toimittaja-arvioinnin vuoksi.',
            status_hint: 'Aseta elinkaaren tila, jota arvostelut, viennit ja tarkastustodisteet käyttävät.',
            owner_hint: 'Valitse aktiivinen käyttäjä, joka vastaa järjestelmän hallinnasta ja seurantatehtävistä.',
            department_hint: 'Käytä tämän järjestelmän toiminnasta tai hallinnasta vastaavaa organisaatioyksikköä.',
            data_categories_hint: 'Luettele tämän järjestelmän käsittelemät tietoluokat pilkuilla erotettuina.',
            jurisdiction_hint: 'Tallenna tärkein laillinen tai hosting-toimivalta vaatimustenmukaisuuden kartoitusta varten.',
            interfaces_hint: 'Luettele tiedonvaihtoon käytetyt liitin- tai integraatiopolut.',
            description_hint: 'Yhteenveto siitä, mitä järjestelmä tekee ja miksi sillä on merkitystä tietokartalle.',
            owner_department_required: 'Omistaja ja osasto vaaditaan.',
            aria_systems_table: 'Järjestelmäinventaario',
            aria_edit: 'Muokkaa {name}',
            export_systems: 'Vie järjestelmät',
        },
        traceability_matrix: {
            title: 'Jäljitettävyysmatriisi',
            page_title: 'Jäljitettävyysmatriisi',
            brd_selector: 'Valitse BRD',
            requirement: 'Vaatimus',
            linked_artifact: 'Linkitetty artefakti',
            verification_status: 'Todennustila',
            verified_by: 'Todennut',
            create_entry: 'Luo merkintä',
            edit_entry: 'Muokkaa merkintää',
            no_entries_found: 'Ei merkintöjä',
            entry_created: 'Merkintä luotu',
            entry_updated: 'Merkintä päivitetty',
            select_brd: 'Valitse BRD...',
            select_status: 'Valitse tila...',
            aria_matrix_table: 'Jäljitettävyysmatriisi',
            aria_edit: 'Muokkaa: {name}',
            export_matrix: 'Vie matriisi',
        },
        gap_register: {
            title: 'Puuterekisteri',
            page_title: 'Puuterekisteri',
            gap_title: 'Puutteen otsikko',
            gap_type: 'Puutetyyppi',
            severity: 'Vakavuusaste',
            status: 'Tila',
            description: 'Kuvaus',
            remediation_plan: 'Korjaussuunnitelma',
            assigned_to: 'Vastuuhenkilö',
            due_date: 'Eräpäivä',
            create_gap: 'Luo puute',
            edit_gap: 'Muokkaa puutetta',
            no_gaps_found: 'Ei puutteita',
            gap_created: 'Puute luotu',
            gap_updated: 'Puute päivitetty',
            select_type: 'Valitse tyyppi...',
            select_severity: 'Valitse vakavuusaste...',
            select_status: 'Valitse tila...',
            aria_gaps_table: 'Puuterekisteri',
            aria_edit: 'Muokkaa {name}',
            export_gaps: 'Vie puutteet',
            gap_title_hint: 'Provide a concise name for the identified gap.',
            gap_type_hint: 'Select the nature of the gap (e.g., missing coverage or integration issue).',
            severity_hint: 'The impact of this gap on compliance and operations.',
            status_hint: 'Current stage of the gap resolution lifecycle.',
            owner_hint: 'The person responsible for tracking and remediating this gap.',
            description_hint: 'Detailed context regarding the gap, its root cause, and impact.',
            mitigation_plan_hint: 'Steps planned or taken to address and close the gap.',
            linked_requirement_ids_hint: 'Comma-separated requirement codes this gap affects.',
            linked_system_ids_hint: 'Comma-separated system IDs associated with this gap.',
            gap_types: {
                coverage: 'Coverage',
                capability: 'Capability',
                integration: 'Integration',
                compliance: 'Compliance',
            },
        },
        regulatory: {
            system_inventory_governance_info: 'System inventory aligns with Data Law enterprise governance. System types map to regulatory categories, hosting classification determines jurisdiction-specific controls. Use framework linkage to connect systems to applicable regulatory frameworks.',
            automation_planning_workflow_info: 'Automation programs align with compliance workflow obligations defined by applicable regulatory frameworks. Framework scope determines which requirements the program addresses.',
            traceability_regulatory_source_info: 'Each traceability entry connects a BRD requirement to its regulatory source. Verification status tracks whether implementation satisfies the regulatory obligation.',
            security_reviews_control_mapping_info: 'Security reviews evaluate framework-specific controls applicable to each connector. Risk level captures assessed exposure, findings document deviations from control requirements.',
            gap_register_framework_info: 'Gap Register captures compliance gaps per regulatory framework. Use framework filter to view gaps for a specific framework. Severity levels align with framework risk classification.',
            poc_scorecards_criteria_info: 'POC scorecards evaluate connectors against regulatory criteria. Criteria structure supports weighted scoring with evidence notes. Vendor linkage connects to vendor record.',
            evidence_trail_info: 'All connector module actions generate audit events for cross-module evidence trail integrity. CSV exports preserve referential integrity.',
        },
        system_inventory_extra: {
            framework_linkage: 'Kehyslinkitys',
            framework_linkage_placeholder: 'esim. GDPR, ISO 27001, NIS2',
        },
        automation_planning_extra: {
            framework_scope: 'Kehyksen laajuus',
            framework_scope_placeholder: 'esim. GDPR, PCI-DSS',
            procedure_linkage: 'Menettelylinkitys',
            procedure_linkage_placeholder: 'esim. SOP-001, PROC-DATA-003',
        },
        traceability_matrix_extra: {
            regulatory_source: 'Sääntelylähde',
            regulatory_source_placeholder: 'esim. GDPR Art. 30, ISO 27001 A.8',
        },
        security_reviews_extra: {
            control_mapping_col: 'Kontrollimappaus',
            control_mappings_section: 'Ohjauskartoitukset',
            no_control_mappings: 'Ei vielä ohjauskartoituksia. Lisää yksi napsauttamalla "Luo ohjauskartoitus".',
            automation_type_col: 'Automaatio',
        },
        gap_register_extra: {
            framework_filter: 'Kehys',
            framework_id: 'Kehystunnus',
            framework_id_placeholder: 'esim. GDPR, ISO 27001',
            all_frameworks: 'Kaikki kehykset',
        },
        poc_scorecards_extra: {
            criteria_count: 'Kriteerit',
        },
        export_labels: {
            export_brds: 'Vie BRD:t',
            export_decision_records: 'Vie päätösrekisterit',
            export_security_reviews: 'Vie tietoturvakatsaukset',
            export_poc_scorecards: 'Vie POC-tuloskortit',
            export_instances: 'Vie esiintymiä',
            export_definitions: 'Vientimääritelmät',
            export_credentials: 'Vie valtuustiedot',
            export_events: 'Vie tapahtumat',
            exporting: 'Viedään...',
            export_success: 'Vienti valmis',
            export_error: 'Vienti epäonnistui',
        },
    },
    vendor_risk: {
        risk_acceptance_reasoning: {
            draft_label: 'Perusteluluonnos',
            drafting: 'Perustelua laaditaan…',
            results_heading: '[[TOK_2]]-muotoiltu perustelu ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            narrative_label: 'Perustelujen selostus',
            controls_heading: 'Kompensoivat säätimet',
            no_controls: 'Kompensoivia säätöjä ei ehdotettu.',
            citations_label: 'Lainaukset',
            accept_label: 'Hyväksy perustelut',
            reject_label: 'Hylkää luonnos',
            accept_hint: 'Hyväksy tallentaa perustelut IAT-perinteen säilyneen luonnoksen perusteella. Selostus + -säätimet eivät päivitä hyväksyntietuetta automaattisesti – operaattorin liittäminen takaisin vaaditaan.',
            resolve_summary: 'Päätöslauselma: [[TOK_1]]',
            error_generic: 'Perustelua ei voitu laatia. Yritä uudelleen tai tarkista riskin hyväksymistila.',
        },
        redline_assistant: {
            run_label: 'Redline kirjastolla',
            running: 'Käynnissä punalinjaa…',
            results_heading: 'Redline-ehdotukset ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            no_suggestions: 'Standardilausekkeissa ei havaittu aukkoja.',
            jurisdiction_label: 'Toimivalta',
            col_kind: 'Ystävällinen',
            col_severity: 'Vakavuus',
            col_title: 'Ehdotus',
            col_excerpt: 'Osuva ote',
            col_apply: 'Käytä',
            kind_missing: 'Puuttuu standardi',
            kind_weaker: 'Normaalia heikompi',
            kind_jurisdiction: 'Toimivallan peittokuva',
            proposed_label: 'Ehdotettu teksti',
            citations_label: 'Lainaukset',
            accept_label: 'Hyväksy valitut',
            reject_label: 'Hylkää raportti',
            partial_label: 'Käytä valintaa',
            accept_hint: 'Käytä valintatietueita IAT-perinteen luonnoksessa valitut ehdotukset. Sopimustekstiin ei sovelleta automaattista muokkausta – operaattori ajaa punaisen linjan.',
            resolve_summary: 'Päätöslauselma: [[TOK_2]] · [[TOK_3]] ehdotuksia otettu käyttöön',
            error_generic: 'Punaviivaa ei voitu luoda. Yritä uudelleen tai tarkista sopimuksen tila.',
            clause_library_link: 'Hallinnoi lausekirjastoa',
        },
        clause_library: {
            page_title: 'Lausekirjasto',
            add_label: 'Lisää lauseke',
            edit_label: 'Muokkaa',
            delete_label: 'Poista',
            slug_label: 'Slug',
            title_label: 'Otsikko',
            body_label: 'Runko',
            jurisdiction_label: 'Toimivalta',
            tags_label: 'Tunnisteet (pilkuilla erotettuna)',
            must_contain_label: 'Pakolliset merkit (pilkuilla erotettuna)',
            severity_label: 'Vakavuus puuttuessa',
            no_clauses: 'Ei lausekkeita vielä. Lisää yksi punaviiva-avustajan siementämiseksi.',
            save_label: 'Tallenna',
            cancel_label: 'Peruuta',
            load_error: 'Lausekirjastoa ei voitu ladata.',
            save_error: 'Lauseketta ei voitu tallentaa.',
            delete_error: 'Lauseketta ei voitu poistaa.',
            delete_confirm: 'Poistetaanko lause "[[TOK_1]]"? Tätä ei voi kumota.',
        },
        obligation_extraction: {
            extract_label: 'Pura velvoitteet',
            extracting: 'Puretaan…',
            results_heading: 'Poimitut velvoitteet ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            no_obligations: 'Tässä sopimustekstissä ei havaittu velvoitteita.',
            col_class: 'Luokka',
            col_summary: 'Yhteenveto (muokattava)',
            col_excerpt: 'Lauseen ote',
            col_due_date: 'Eräpäivä (muokattava)',
            col_priority: 'Prioriteetti',
            due_date_placeholder: 'YYYY-MM-DD',
            class_notice: 'Irtisanomisaika',
            class_audit: 'Tarkastus oikein',
            class_insurance: 'Vakuutus',
            class_sla: 'Vastaus [[TOK_0]]',
            class_breach: 'Rikkomusilmoitus',
            class_renewal: 'Uusintaikkuna',
            citations_label: 'Lainaukset',
            accept_hint: 'Hyväksy luo yhden tehtävän jokaista velvoitetta kohden (Cap 8) prioriteetin + eräpäivän ollessa näkyvissä.',
            accept_label: 'Hyväksy velvoitteet',
            reject_label: 'Hylkää raportti',
            resolve_summary: 'Ratkaisu: [[TOK_2]] · [[TOK_3]] tehtävä(t) luotu',
            error_generic: 'Velvoitteita ei voitu poimia. Yritä uudelleen tai tarkista sopimusteksti.',
        },
        subprocessor_impact: {
            assess_label: 'Arvioi vaikutus',
            assessing: 'Vaikutusten arviointi…',
            results_heading: 'Vaikutus aliprosessoriin ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            risk_delta_label: 'Riskin delta',
            notification_heading: 'Asiakasilmoitus',
            subject_label: 'Aihe',
            deadline_label: 'Ilmoituksen määräaika',
            body_label: 'Ilmoituselin',
            required_fields_label: 'Pakolliset Art.28(4) kentät',
            mitigation_heading: 'Lieventämisvaiheet',
            citations_label: 'Lainaukset',
            accept_label: 'Hyväksy arviointi',
            reject_label: 'Hylkää arviointi',
            accept_hint: 'Hyväksy luo asiakasilmoitustehtävän, jonka eräpäivänä on [[TOK_0]].',
            resolve_summary: 'Päätöslauselma: [[TOK_2]][[TOK_3]]',
            error_generic: 'Tätä aliprosessorin muutosta ei voitu arvioida. Yritä uudelleen tai tarkista muutostietue.',
        },
        onboarding_evidence: {
            collect_label: 'Suorita [[TOK_0]] todisteiden kerääminen',
            collecting: 'Todisteiden kerääminen…',
            results_heading: 'Todisteiden kerääminen ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            findings_heading: 'Olemassa olevat todisteet',
            missing_heading: 'Puuttuvat esineet',
            no_findings: 'Olemassa olevaa näyttöä ei havaittu.',
            no_missing: 'Tästä riskitasosta ei puutu vaadittuja esineitä.',
            next_step_label: 'Seuraava askel',
            class_dpa: 'Tietojenkäsittelysopimus',
            class_soc2: 'SOC 2 -raportti',
            class_iso27001: 'ISO 27001 sertifikaatti',
            class_insurance: 'Kybervakuutus',
            class_incident_history: 'Aikaisempi tapaus',
            accept_hint: 'Hyväksy luo tehtäviä jokaiselle puuttuvalle esineelle (raja on 5). Havainnot pysyvät luonnoksina, kunnes liität ne todisteeksi.',
            accept_label: 'Hyväksy raportti',
            reject_label: 'Hylkää raportti',
            resolve_summary: 'Ratkaisu: [[TOK_2]] · [[TOK_3]] tehtävä(t) luotu',
            error_generic: '[[TOK_0]] todisteiden keräämistä ei voitu suorittaa. Yritä uudelleen tai tarkista aloitustapauksen tila.',
        },
        no_permission_title: 'Riittämättömät käyttöoikeudet',
        no_permission_message: 'Sinulla ei ole lupaa käyttää toimittajan riskienhallintaa.',
        unknown_vendor: 'Tuntematon myyjä',
        nav: {
            dashboard: 'Riskikojelauta',
            scoring: 'Riskipisteytys',
            questionnaires: 'Kyselylomakkeet',
            contracts: 'Sopimukset',
            gates: 'Hyväksyntäportit',
            reviews: 'Toimittaja-arvioinnit',
            signals: 'Riskisignaalit',
            reassessments: 'Uudelleenarvioinnit',
            portfolio: 'Riskiportfolio',
            acceptances: 'Riskien hyväksyntä',
            review_routing: 'Tarkistuksen reititys',
            onboarding_cases: 'Käyttöönottotapaukset',
            sub_processor_register: 'Alikäsittelijärekisteri',
        },
        dashboard: {
            title: 'Toimittajariskikojelauta',
            page_title: 'Myyjän riskien hallintapaneeli',
            loading: 'Ladataan kojelauta tiedot...',
            risk_tier_header: 'Riskitaso',
            count_header: 'Count',
            percentage_header: 'Prosenttiosuus',
            sections_nav: 'Myyjän riskiosat',
            urgent_expiry: 'Kiireellinen: vanhenee 14 päivän kuluessa',
            no_previous_tier: 'Ei aiempaa tasoa',
            view_as_chart: 'Näytä kaaviona',
            view_as_table: 'Näytä taulukkona',
            showing_chart: 'Näytetään kaavionäkymä',
            showing_table: 'Näytetään taulukonäkymä',
            load_error: 'Epäonnistui: load toimittaja riski kojelauta. Yritä uudelleen.',
            risk_distribution: 'Riski Distribution Yleiskatsaus',
            recent_tier_changes: 'Viimeaikainen Taso Changes',
            no_tier_changes: 'Ei viimeaikaisia tason muutoksia.',
            review_kpis: 'Katselmointia KPI',
            total_vendors_reviewed: 'Tarkastetut toimittajat yhteensä',
            reviews_by_outcome: 'Katselmoinnit by Outcome',
            contract_coverage: 'Sopimus Kattavuus',
            total_vendors: 'Toimittajat yhteensä',
            with_active_dpa: 'Aktiivisella DPA:lla',
            without_dpa: 'Ilman DPA:ta',
            dpa_coverage: 'DPA Kattavuus',
            active_contracts_by_type: 'Aktiiviset sopimukset tyypeittäin',
            expiring_contracts: 'Expiring Sopimukset (Seuraava 90 päivää)',
            no_expiring_contracts: 'No contracts expiring within the next 90 päivää.',
            vendor: 'Toimittaja',
            previous_tier: 'Edellinen Taso',
            current_tier: 'Nykyinen Taso',
            changed_at: 'Muutettu',
            expires_at: 'Vanhenee',
            days_remaining: 'päivää jäljellä',
            days: 'päivää',
            vendors_label: 'toimittajat',
            no_data: 'No tiedot',
            critical: 'Kriittinen',
            high: 'Korkea',
            medium: 'Keskitaso',
            low: 'Matala',
            expiring_acceptances_heading: 'Vanhenevat riskihyväksynnät',
            expiring_30d_label: 'Vanhenee 30 päivässä',
            expiring_60d_label: 'Vanhenee 60 päivässä',
            expiring_90d_label: 'Vanhenee 90 päivässä',
        },
        scoring: {
            title: 'Riskipisteytys',
            page_title: 'Myyjän riskipisteytys',
            filter_scores: 'Suodata riskipisteet',
            filter_by_tier: 'Suodata riskitason mukaan',
            scores_pagination: 'Riskipisteiden sivutus',
            config_dimensions: 'Scoring dimensions configuration',
            scores_loaded: '[[TOK_1]] risk scores loaded',
            weight_must_equal_100: 'Kokonaispainon on oltava 100 (nykyinen: [[TOK_1]])',
            out_of_10: 'out of 10, rated [[TOK_1]]',
            dimension_name: 'Dimension [[TOK_1]] name',
            dimension_weight: '[[TOK_1]] weight (percentage)',
            must_equal_100: 'pitää olla 100',
            config_title: 'Scoring Konfiguraatio',
            scores_title: 'Toimittajien riskipistemäärät',
            new_score_title: 'Pistemäärä a Toimittaja',
            new: 'Uusi Pistemäärä',
            vendor_id: 'Toimittajatunnus',
            risk_tier: 'Riski Taso',
            score: 'Pistemäärä',
            scored_at: 'Pisteytetty',
            no_scores: 'Ei riski pistemäärä found. löytynyt',
            all_tiers: 'Kaikki tasot',
            load_config_error: 'Epäonnistui: load riski scoring konfiguraatio. Yritä uudelleen.',
            update_config: 'Päivitä pisteytyskonfiguraatio',
            update_config_error: 'Epäonnistui: update riski scoring konfiguraatio. Yritä uudelleen.',
            load_scores_error: 'Epäonnistui: load toimittaja riski pistemäärä. Yritä uudelleen.',
            calculate_error: 'Epäonnistui: calculate toimittaja riski pistemäärä. Yritä uudelleen.',
            weight: 'weight',
            score_range: 'Pistemäärä (1-5)',
            method: 'Menetelmä',
        },
        questionnaires: {
            title: 'Kyselylomakkeet',
            page_title: 'Myyjän kyselylomakkeet',
            filter_questionnaires: 'Kyselylomakkeen suodattimet',
            questionnaire_views: 'Kyselylomakkeen näkymät',
            templates_list: 'Kyselypohjien luettelo',
            instances_list: 'Kyselyn esiintymien luettelo',
            filter_by_status: 'Suodata kyselylomakkeen tilan mukaan',
            templates_per_page: 'Malleja per sivu',
            instances_per_page: 'Tapauksia sivua kohden',
            select_template: 'Valitse kyselylomake',
            template_category: 'Mallin luokka',
            templates_tab: 'Mallit',
            instances_tab: 'Esiintymät',
            new: 'Uusi Kysely',
            new_template: 'Uusi malli',
            new_instance: 'Uusi ilmentymä',
            vendor_id: 'Toimittajatunnus',
            template_id: 'Malli Tunniste',
            assigned_to: 'Määritetty To',
            due_date: 'Due Päivämäärä',
            responses: 'Vastaukset',
            risk_score: 'Valmistuminen',
            no_questionnaires: 'Ei questionnaires found. löytynyt',
            load_templates_error: 'Epäonnistui: load questionnaire mallit. Yritä uudelleen.',
            load_instances_error: 'Epäonnistui: load questionnaires. Yritä uudelleen.',
            create_template_error: 'Epäonnistui: create questionnaire malli. Yritä uudelleen.',
            initiate_error: 'Epäonnistui: initiate questionnaire. Yritä uudelleen.',
            submit_error: 'Epäonnistui: submit questionnaire. Yritä uudelleen.',
            review_error: 'Epäonnistui: katselmointi questionnaire. Yritä uudelleen.',
            resubmit: 'Lähetä uudelleen',
            approve_error: 'Kyselylomakkeen hyväksyminen epäonnistui',
            reject_error: 'Kyselylomakkeen hylkääminen epäonnistui',
            resubmit_error: 'Kyselylomakkeen uudelleenlähetys epäonnistui',
            templates_loaded: '[[TOK_1]] kyselylomakemallia ladattu',
            instances_loaded: '[[TOK_1]] kyselylomaketta ladattu',
            fill_responses_cta: 'Täytä vastaukset',
            fill_responses_title: 'Täytä kyselyn vastaukset',
            template_missing: 'Mallia ei löydy.',
            responses_saved: 'Vastaukset tallennettu.',
            load_template_error: 'Mallin lataus epäonnistui.',
            version_history: 'Versiohistoria',
            download_previous_version: 'Lataa aiempi versio',
            trigger: 'Liipaisin',
            template_label: 'Malli',
            reviewer: 'Arvostelija',
            reviewer_required: '[TOK_1]]-kyselylomakkeille on määrättävä arvioija (tehtävien erottaminen).',
            select_option: 'Valitse vaihtoehto',
            multi_choice_hint: 'Valitse kaikki sopivat',
            category_initial_onboarding: 'Alkuperäinen käyttöönotto',
            category_annual_review: 'Vuosikatsaus',
            category_incident_triggered: 'Tapahtuman aiheuttama',
            category_contract_renewal: 'Sopimuksen uusiminen',
            template_editor: {
                page_title: 'Muokkaa kyselylomakemallia',
                preview_page_title: 'Esikatsele kyselylomakemallia',
                edit_structure: 'Muokkaa rakennetta',
                preview: 'Esikatselu',
                actions: 'Toiminnot',
                back_to_list: 'Takaisin malleihin',
                load_error: 'Mallin lataaminen epäonnistui',
                save_error: 'Mallin rakenteen tallentaminen epäonnistui',
                saved: 'Mallin rakenne tallennettu.',
                sections_heading: 'Osat',
                questions_heading: 'Kysymyksiä',
                add_section: 'Lisää osio',
                edit_section: 'Muokkaa osiota',
                delete_section: 'Poista osio',
                move_section_up: 'Siirrä osio ylöspäin',
                move_section_down: 'Siirrä osio alas',
                confirm_delete_section: 'Poistetaanko osio "[[TOK_1]]"? Kaikki sen kysymykset poistetaan.',
                section_title: 'Osion otsikko',
                section_description: 'Osion kuvaus',
                section_id: 'Osion tunnus',
                section_id_hint: 'Luodaan automaattisesti, ellet määritä sitä erikseen.',
                no_sections: 'Ei osioita vielä. Aloita lisäämällä osio.',
                no_questions: 'Tässä osiossa ei ole vielä kysymyksiä.',
                add_question: 'Lisää kysymys',
                edit_question: 'Muokkaa kysymystä',
                delete_question: 'Poista kysymys',
                move_question_up: 'Siirrä kysymys ylös',
                move_question_down: 'Siirrä kysymys alas',
                confirm_delete_question: 'Poistetaanko kysymys "[[TOK_1]]"?',
                question_text: 'Kysymysteksti',
                question_type: 'Kysymystyyppi',
                question_id: 'Kysymystunnus',
                evidence_required: 'Todisteet vaaditaan',
                risk_weight: 'Riskipaino',
                scoring_map: 'Pisteytyskartta',
                scoring_map_json_hint: '[[TOK_0]] oliokartoituksen vastausarvot numeerisiksi arvoiksi.',
                scoring_map_invalid_json: 'Pisteytyskartan on oltava voimassa [[TOK_0]].',
                options_heading: 'Vastausvaihtoehdot',
                add_option: 'Lisää vaihtoehto',
                remove_option: 'Poista vaihtoehto',
                option_label: 'Label',
                option_value: 'Arvo',
                option_risk_weight: 'Riskipaino',
                min_options_error: 'Valintakysymyksissä on oltava vähintään 2 vaihtoehtoa.',
                option_label_required: 'Jokainen vaihtoehto tarvitsee etiketin.',
                option_value_required: 'Jokainen vaihtoehto tarvitsee arvon.',
                option_value_unique: 'Vaihtoehtojen arvojen on oltava yksilöllisiä.',
                branching_rules_heading: 'Haaroittamisen säännöt',
                branching_rules_hint: 'Näytä tai piilota tämä kysymys aikaisemman kysymyksen vastauksen perusteella.',
                add_branching_rule: 'Lisää haarautumissääntö',
                remove_branching_rule: 'Poista haarautumissääntö',
                branching_condition_question: 'Jos kysymys',
                branching_condition_value: 'on arvoa',
                branching_action: 'sitten',
                branching_action_show: 'näytä tämä kysymys',
                branching_action_hide: 'piilota tämä kysymys',
                branching_select_condition_question: 'Valitse aikaisempi kysymys',
                branching_select_condition_value: 'Valitse arvo',
                save: 'Tallenna rakenne',
                saving: 'Tallennetaan...',
                cancel: 'Peruuta',
                close: 'Sulje',
                question_text_required: 'Kysymysteksti on pakollinen.',
                section_title_required: 'Osion otsikko vaaditaan.',
                type_single_choice: 'Yksittäinen valinta',
                type_multi_choice: 'Monivalinta',
                type_free_text: 'Vapaa teksti',
                type_numeric: 'Numeerinen',
                type_date: 'Päivämäärä',
                type_file_upload: 'Tiedoston lataus',
                type_yes_no: 'Kyllä / Ei',
                preview_heading: 'Mallin esikatselu',
                preview_subtitle: 'Vain luku -esikatselu siitä, miltä kyselylomake näyttää toimittajalle.',
                preview_no_content: 'Tässä mallissa ei ole vielä osioita tai kysymyksiä.',
                preview_branching_notice: 'Haaroittumissäännöt arvioidaan täytön aikana; esikatselu näyttää jokaisen kysymyksen.',
            },
            review_modal: {
                title: 'Tarkista kyselylomakkeen vastaukset',
                open_cta: 'Tarkista',
                loading: 'Ladataan kyselylomaketta...',
                template_missing: 'Mallia ei löydy.',
                load_error: 'Kyselylomakkeen lataaminen tarkistettavaksi epäonnistui.',
                annotation_heading: 'Huomautukset',
                annotation_placeholder: 'Lisää tähän kysymykseen arvioijan huomautus...',
                annotation_status_label: 'Huomautuksen tila',
                annotation_status_acceptable: 'Hyväksyttävä',
                annotation_status_concern: 'Huoli',
                annotation_status_requires_action: 'Vaatii toimia',
                review_comments_label: 'Yleisarvostelun kommentit',
                review_comments_placeholder: 'Tee yhteenveto arvosteluhavainnoistasi...',
                justification_label: 'Päätöksen perustelut',
                justification_placeholder: 'Perustele päätöksesi perustelut...',
                reject_requires_comments: 'Kyselylomakkeen hylkääminen edellyttää tarkistuskommentteja.',
                decision_heading: 'Päätös',
                decision: {
                    approved: 'Hyväksy',
                    rejected: 'Hylkää',
                    additional_info_requested: 'Pyydä lisätietoja',
                },
                submit: 'Lähetä arvostelu',
                submitting: 'Lähetetään arvostelua...',
                cancel: 'Peruuta',
                submit_success: 'Arvostelu lähetetty.',
                submit_error: 'Arvostelun lähettäminen epäonnistui.',
                separation_of_duties_error: 'Et voi tarkistaa kyselyä, joka sinulle on määrätty täyttämään. Tehtävien erottaminen edellyttää eri arvioijaa.',
                decision_required: 'Valitse tarkistuspäätös.',
                announce_opened: 'Tarkistusmodaali avattu.',
                announce_submitted: 'Arvostelu lähetetty.',
            },
            instance_detail: {
                submitted_at: 'Lähetetty',
                reviewed_at: 'Arvosteltu',
                reviewer: 'Arvostelija',
                review_decision: 'Päätös',
                review_comments: 'Tarkista kommentit',
                decision_approved: 'Hyväksytty',
                decision_rejected: 'Hylätty',
                decision_additional_info_requested: 'Lisätietoja pyydetään',
                decision_pending: 'Odottaa tarkistusta',
                expand_comments: 'Näytä täydelliset kommentit',
                collapse_comments: 'Piilota täydelliset kommentit',
                no_reviewer: 'Arvostelijaa ei ole määrätty',
            },
            export: {
                portfolio_label: 'Vie portfolio',
                instance_label: 'Vie',
                portfolio_success: 'Portfolion vienti valmis.',
                instance_success: 'Kyselylomakkeen vienti valmis.',
                portfolio_error: 'Kyselylomakesalkun vienti epäonnistui.',
                instance_error: 'Kyselylomakkeen vienti epäonnistui.',
            },
            branching: {
                hidden_notice: 'Osa kysymyksistä on piilotettu haarautumissäännöillä.',
                cycle_warning: 'Haaroitussäännöissä havaittiin sykli. Vaikuttavat kysymykset ovat oletuksena näkyvissä.',
            },
        },
        contracts: {
            title: 'Sopimukset',
            page_title: 'Myyjäsopimukset',
            new: 'Uusi Sopimus',
            vendor_id: 'Toimittajatunnus',
            filter_contracts: 'Suodata sopimukset',
            filter_by_document_type: 'Suodata asiakirjatyypin mukaan',
            filter_by_status: 'Suodata sopimuksen tilan mukaan',
            per_page: 'Sopimukset per sivu',
            expired_notice: 'Tämä sopimus on päättynyt',
            document_type: 'Asiakirjatyyppi',
            expiry_date: 'Expiry Päivämäärä',
            no_contracts: 'Ei contracts found. löytynyt',
            all_document_types: 'Kaikki asiakirjatyypit',
            load_error: 'Epäonnistui: load contracts. Yritä uudelleen.',
            create_error: 'Epäonnistui: create contract. Yritä uudelleen.',
            delete_error: 'Epäonnistui: delete contract. Yritä uudelleen.',
            update_error: 'Epäonnistui: update tila. Yritä uudelleen.',
            confirm_delete: 'Poista contract "{title}"?',
            renewal_date: 'Uusiminen Päivämäärä',
            effective_date: 'Effective Päivämäärä',
            parties: 'Osapuolet',
            summary: 'Yhteenveto',
            n_contracts: '{count} sopimusta',
            n_contract: '{count} sopimus',
            contracts_loaded: '{count} sopimusta ladattu',
            doc_type_dpa: 'DPA',
            doc_type_security_addendum: 'Turvallisuusliite',
            doc_type_scc_annex: 'SCC-liite',
            doc_type_sub_processor_list: 'Alikäsittelijäluettelo',
            doc_type_bcr: 'BCR',
            doc_type_nda: 'NDA',
            doc_type_msa: 'MSA',
            doc_type_sla: 'SLA',
            doc_type_other: 'Muu',
            status_draft: 'Luonnos',
            status_under_negotiation: 'Neuvottelussa',
            status_pending_signature: 'Odottaa allekirjoitusta',
            status_active: 'Aktiivinen',
            status_expired: 'Vanhentunut',
            status_terminated: 'Lopetettu',
            status_superseded: 'Korvattu',
        },
        gates: {
            title: 'Hyväksyntäportit',
            page_title: 'Portin arvioinnit',
            new: 'Uusi Portti Evaluation',
            vendor_id: 'Toimittajatunnus',
            gate_name: 'Portti Nimi',
            outcome: 'Tulos',
            evaluator: 'Arvioija',
            no_gates: 'Ei gate evaluations found. löytynyt',
            load_error: 'Epäonnistui: load gate evaluations. Yritä uudelleen.',
            evaluate_error: 'Epäonnistui: evaluate toimittaja gate. Yritä uudelleen.',
            detail_error: 'Epäonnistui: fetch evaluation detail. Yritä uudelleen.',
            override_error: 'Epäonnistui: override gate evaluation. Yritä uudelleen.',
            criteria_results: 'Kriteerit Tulokset',
            evaluate_form: 'Arvioi myyjäportti',
            per_page: 'Arviot per sivu',
            passed: 'Hyväksytty',
            failed: 'Epäonnistunut',
            override: 'Ohita',
            override_justification: 'Ohita Perustelu',
            override_placeholder: 'Syötä perustelu for overriding this gate evaluation',
            approval_id: 'Hyväksyntätunnus',
            overall_passed: 'Hyväksytty',
            overall_failed: 'Hylätty',
            overall_overridden: 'Ohitettu',
            evaluations_loaded: '{count} porttiarviointia ladattu',
            create_approval_cta: 'Luo hyväksyntä',
        },
        reviews: {
            title: 'Toimittaja-arvioinnit',
            page_title: 'Myyjien arvostelut',
            new: 'Uusi Katselmointia',
            vendor_id: 'Toimittajatunnus',
            filter_by_outcome: 'Suodata arvostelun tuloksen mukaan',
            per_page: 'Arvostelut per sivu',
            kpi_summary: 'Tarkista [[TOK_0]] yhteenveto',
            review_outcome_label: 'Tarkista tulos',
            edit_outcome: 'Muokkaa arvostelun tulosta',
            reviews_loaded: '[[TOK_1]] toimittajaarvostelut ladattu',
            reviewer: 'Arvioija',
            review_type: 'Katselmointia Tyyppi',
            outcome: 'Tulos',
            findings: 'Havainnot',
            no_reviews: 'Ei toimittaja katselmointi found. löytynyt',
            load_kpis_error: 'Epäonnistui: fetch toimittaja katselmointi KPI. Yritä uudelleen.',
            load_error: 'Epäonnistui: fetch toimittaja katselmointi. Yritä uudelleen.',
            update_error: 'Toimittaja-arvion päivittäminen epäonnistui',
            create_error: 'Epäonnistui: create toimittaja katselmointi. Yritä uudelleen.',
            total_reviewed: 'Tarkastetut toimittajat yhteensä',
            total_reviews: 'Katselmoinnit yhteensä',
            satisfactory: 'Tyydyttävä',
            concerns_identified: 'Havaitut huolenaiheet',
            remediation_required: 'Korjaus Pakollinen',
            escalated: 'Eskaloitu',
            program_id: 'Ohjelma Tunniste',
            period_id: 'Kausi Tunniste',
            task_id: 'Tehtävä Tunniste',
            recommendations: 'Suositukset',
        },
        risk_signals: {
            title: 'Riskisignaalit',
            page_title: 'Riskisignaalit',
            new_signal: 'Uusi riskisignaali',
            signal_type: 'Signaalityyppi',
            severity: 'Vakavuus',
            description: 'Kuvaus',
            source: 'Lähde',
            vendor_id: 'Toimittajan tunnus',
            certification_expiry: 'Sertifioinnin päättyminen',
            breach_notification: 'Tietoturvaloukkauilmoitus',
            financial_instability: 'Taloudellinen epävakaus',
            compliance_change: 'Vaatimustenmukaisuuden muutos',
            custom: 'Mukautettu',
            active: 'Aktiivinen',
            acknowledged: 'Kuitattu',
            resolved: 'Ratkaistu',
            no_signals: 'Riskisignaaleja ei löytynyt',
            source_external_feed: 'Ulkoinen syöte',
            source_manual: 'Manuaalinen',
            source_integration: 'Integraatio',
            source_regulatory: 'Sääntelyyn liittyvä',
            source_media: 'Media',
            trigger_reassessment_prompt: 'Tämä signaali on vakavuudeltaan korkea. Käynnistä toimittajan uudelleenarviointi nyt?',
            reassessment_triggered: 'Uudelleenarviointi käynnistetty.',
            reassessment_trigger_error: 'Uudelleenarvioinnin käynnistys epäonnistui.',
        },
        reassessments: {
            title: 'Uudelleenarvioinnit',
            page_title: 'Uudelleenarviointitehtävät',
            trigger: 'Käynnistä uudelleenarviointi',
            trigger_success: 'Uudelleenarviointi käynnistetty onnistuneesti',
            reason: 'Syy',
            deadline: 'Määräaika',
            assigned_to: 'Vastuuhenkilö',
            vendor_id: 'Toimittajan tunnus',
            outcome: 'Tulos',
            new_risk_level: 'Uusi riskitaso',
            complete: 'Suorita uudelleenarviointi',
            complete_success: 'Uudelleenarviointi suoritettu onnistuneesti',
            pending: 'Odottaa',
            in_progress: 'Käynnissä',
            completed: 'Valmis',
            cancelled: 'Peruutettu',
            no_tasks: 'Uudelleenarviointitehtäviä ei löytynyt',
            risk_trend: 'Riskitrendi',
            notes: 'Muistiinpanot',
        },
        portfolio: {
            title: 'Riskiportfolio',
            page_title: 'Riskiportfolio',
            dashboard: 'Portfolion yhteenveto',
            vendor_id: 'Toimittajan tunnus',
            total_vendors: 'Toimittajia yhteensä',
            average_score: 'Keskimääräinen riskipistemäärä',
            high_risk_count: 'Korkean riskin toimittajat',
            trend_direction: 'Trendin suunta',
            improved: 'Parantunut',
            stable: 'Vakaa',
            degraded: 'Heikentynyt',
            vendor_trend: 'Toimittajatrendi',
            outstanding_questionnaires: 'Avoimet kyselylomakkeet',
            overdue_assessments: 'Myöhässä olevat arvioinnit',
            no_outstanding: 'Ei avoimia kyselylomakkeita',
            no_overdue: 'Ei myöhässä olevia arviointeja',
            due_date: 'Eräpäivä',
        },
        risk_acceptance: {
            title: 'Riskien hyväksyntärekisteri',
            page_title: 'Riskien hyväksymisrekisteri',
            new_acceptance: 'Uusi riskien hyväksyntä',
            vendor_id: 'Toimittajan tunnus',
            risk_level: 'Riskitaso',
            conditions: 'Ehdot',
            justification: 'Perustelu',
            expiry_date: 'Päättymispäivä',
            create_success: 'Riskien hyväksyntä luotu onnistuneesti',
            review_condition: 'Tarkista ehto',
            condition_met: 'Ehto täytetty',
            condition_not_met: 'Ehto ei täytetty',
            review_success: 'Ehto tarkistettu onnistuneesti',
            export_register: 'Vie rekisteri',
            active: 'Aktiivinen',
            expired: 'Vanhentunut',
            revoked: 'Peruutettu',
            no_acceptances: 'Riskien hyväksyntöjä ei löytynyt',
            met_count: '[[TOK_2]]/[[TOK_3]] tapasi',
        },
        review_routing: {
            title: 'Tarkistuksen reititys',
            page_title: 'Tarkista reititys',
            route_to_reviewers: 'Lähetä tarkistajille',
            route_success: 'Lähetetty tarkistajille onnistuneesti',
            vendor_id: 'Toimittajan tunnus',
            reviewer_id: 'Tarkistajan tunniste',
            reviewer_role: 'Tarkistajan rooli',
            questionnaire_id: 'Kyselylomakkeen tunniste',
            review_status: 'Tarkistuksen tila',
            reviewers_label: 'Arvostelijat (user_id, rooli riviä kohden)',
            pending: 'Odottaa',
            in_review: 'Tarkistuksessa',
            completed: 'Valmis',
            no_routing: 'Tarkistuksen reititystä ei löytynyt',
            primary_reviewer: 'Ensisijainen tarkistaja',
            secondary_reviewer: 'Toissijainen tarkistaja',
            approver: 'Hyväksyjä',
        },
        onboarding: {
            title: 'Toimittajien käyttöönottotapaukset',
            page_title: 'Toimittajien käyttöönottotapaukset',
            new_case: 'Uusi käyttöönottotapaus',
            case_detail: 'Käyttöönottotapaus',
            open_mps_dossier_filing: 'Avaa MPS-ilmoitus',
            dossier_filing_description: 'Luo uusi MPS-ilmoitus, esitäytetty tästä onboarding-tapauksesta. Ilmoitus linkitetään tapaukseen.',
            dossier_filing_dpia_id: 'DPIA-tunnus',
            dossier_filing_dpia_id_placeholder: 'esim. dpia_01TEST000000000000000001',
            dossier_filing_title: 'Ilmoituksen otsikko',
            dossier_filing_form_type: 'Lomaketyyppi',
            dossier_filing_submit: 'Luo ilmoitus',
            dossier_filing_validation_error: 'DPIA-tunnus ja otsikko vaaditaan.',
            dossier_filing_created: 'MPS-ilmoitus luotu',
            dossier_filing_error: 'MPS-ilmoitusta ei voitu luoda.',
            linked_questionnaire_due_date: 'Eräpäivä',
            linked_questionnaire_assignee: 'Vastuuhenkilö',
            linked_questionnaire_submitted_at: 'Lähetetty',
            score_last_scored: 'Viimeksi pisteytetty',
            score_dimensions: 'Ulottuvuudet',
            linked_contract_document_type: 'Asiakirjatyyppi',
            linked_contract_effective_date: 'Voimaantulopäivä',
            linked_contract_expiry_date: 'Päättymispäivä',
            linked_sub_processor_countries: 'Käsittelymaat',
            linked_sub_processor_last_assessment: 'Viimeisin arviointi',
            linked_sub_processor_next_assessment: 'Seuraava arviointi',
            case_id: 'Tapaus-ID',
            vendor: 'Toimittaja',
            case_type: 'Tapaustyyppi',
            service_description: 'Palvelun kuvaus',
            data_categories: 'Tietokategoriat',
            systems_accessed: 'Käytetyt järjestelmät',
            jurisdiction: 'Lainkäyttöalue',
            hosting_model: 'Hosting-malli',
            controller_role: 'Rekisterinpitäjän/käsittelijän rooli',
            status_pipeline: 'Tilaputki',
            tabs_label: 'Käyttöönottotapauksen osiot',
            per_page: 'Tapauksia sivulla',
            filter_cases: 'Suodata käyttöönottotapauksia',
            cases_count: 'tapausta',
            cases_loaded: 'käyttöönottotapausta ladattu',
            no_cases: 'Käyttöönottotapauksia ei löytynyt.',
            vendor_lookup_placeholder: 'Syötä toimittajan ID',
            data_categories_placeholder: 'esim. henkilötiedot, talous, terveys',
            systems_placeholder: 'esim. CRM, ERP, HR-järjestelmä',
            status_open: 'Avoin',
            status_in_progress: 'Käynnissä',
            status_awaiting_approval: 'Odottaa hyväksyntää',
            status_approved: 'Hyväksytty',
            status_remediation_required: 'Korjaus vaaditaan',
            status_closed: 'Suljettu',
            type_new_vendor: 'Uusi toimittaja',
            type_service_change: 'Palvelumuutos',
            type_renewal: 'Uusinta',
            type_reassessment: 'Uudelleenarviointi',
            tab_overview: 'Yleiskatsaus',
            tab_due_diligence: 'Huolellisuus',
            tab_security_assessment: 'Turvallisuusarviointi',
            tab_contractual_controls: 'Sopimusvalvonta',
            tab_sub_processors: 'Alikäsittelijät',
            tab_approval_gates: 'Hyväksyntäportit',
            tab_evidence: 'Todisteet',
            tab_placeholder: 'Tämän osion sisältö täytetään käyttöönottoprosessin aikana.',
            completion_not_started: 'Ei aloitettu',
            completion_in_progress: 'Käynnissä',
            completion_completed: 'Valmis',
            completion_requiring_attention: 'Vaatii huomiota',
            gate_name: 'Portin nimi',
            approver: 'Hyväksyjä',
            decision: 'Päätös',
            comments: 'Kommentit',
            decide: 'Tee päätös',
            decision_approved: 'Hyväksytty',
            decision_rejected: 'Hylätty',
            decision_deferred: 'Lykätty',
            no_approvals: 'Tälle tapaukselle ei ole konfiguroitu hyväksyntäportteja.',
            approval_success: 'Hyväksyntäpäätös kirjattu onnistuneesti',
            approval_error: 'Hyväksyntäpäätöstä ei voitu kirjata',
            transition_status: 'Vaihda tilaa',
            confirm_transition: 'Vaihda tapaus tilasta "{from}" tilaan "{to}"?',
            transition_success: 'Tapauksen tila vaihdettu onnistuneesti',
            transition_error: 'Tapauksen tilaa ei voitu vaihtaa',
            create_success: 'Käyttöönottotapaus luotu onnistuneesti',
            create_error: 'Käyttöönottotapausta ei voitu luoda',
            load_error: 'Käyttöönottotapauksia ei voitu ladata',
            detail_error: 'Tapauksen tietoja ei voitu ladata',
            export: 'Vie',
            export_error: 'Käyttöönottotapausta ei voitu viedä',
            evidence_tab_description: 'Lataa ja vie todisteita perehdytystapaukseen.',
            upload_evidence_label: 'Lähetä todiste',
            attached_evidence_heading: 'Liitetyt todisteet',
            no_evidence_attached: 'Ei vielä liitettyjä todisteita.',
            export_bundle_button: 'Vie todistepaketti',
            load_attachments_error: 'Todisteiden lataus epäonnistui.',
            linked_questionnaires_heading: 'Linkitetyt kyselyt',
            no_linked_questionnaires: 'Ei linkitettyjä kyselyjä.',
            linked_scores_heading: 'Linkitetyt riskipisteet',
            no_linked_scores: 'Ei linkitettyjä pisteitä.',
            latest_score_label: 'Viimeisin pistemäärä',
            linked_contracts_heading: 'Linkitetyt sopimukset',
            no_linked_contracts: 'Ei linkitettyjä sopimuksia.',
            linked_sub_processors_heading: 'Linkitetyt alikäsittelijät',
            no_linked_sub_processors: 'Ei linkitettyjä alikäsittelijöitä.',
        },
        sub_processors: {
            title: 'Alikäsittelijärekisteri',
            page_title: 'Alikäsittelijärekisteri',
            new_record: 'Uusi alikäsittelijä',
            edit_record: 'Muokkaa alikäsittelijää',
            onboarding_case: 'Käyttöönottotapaus',
            services: 'Tarjotut palvelut',
            data_categories: 'Tietokategoriat',
            processing_countries: 'Käsittelymaat',
            dpa_chain_status: 'DPA-ketjun tila',
            certifications: 'Sertifioinnit',
            last_assessment: 'Viimeisin arviointi',
            next_assessment: 'Seuraava arviointi',
            change_history: 'Muutoshistoria',
            history: 'Historia',
            changed_by: 'Muuttanut',
            comma_separated: 'Pilkuilla erotetut arvot',
            filter_records: 'Suodata tietueita',
            filter_by_dpa: 'Suodata DPA-ketjun tilan mukaan',
            all_dpa_statuses: 'Kaikki DPA-tilat',
            per_page: 'Tietueita sivulla',
            records_count: 'alikäsittelijää',
            records_loaded: 'tietuetta ladattu',
            no_records: 'Alikäsittelijöitä ei löytynyt.',
            no_history: 'Muutoshistoriaa ei ole saatavilla.',
            dpa_active: 'Aktiivinen',
            dpa_pending: 'Odottaa',
            dpa_expired: 'Vanhentunut',
            dpa_not_required: 'Ei vaadittu',
            create_success: 'Alikäsittelijä luotu onnistuneesti',
            create_error: 'Alikäsittelijää ei voitu luoda',
            update_success: 'Alikäsittelijä päivitetty onnistuneesti',
            update_error: 'Alikäsittelijää ei voitu päivittää',
            load_error: 'Rekisteriä ei voitu ladata',
            history_error: 'Muutoshistoriaa ei voitu ladata',
            export_csv: 'Vie CSV',
            export_json: 'Vie JSON',
            export_error: 'Tietoja ei voitu viedä',
        },
    },
    deletion_orchestration: {
        nav: {
            dashboard: 'Orkestroinnin kojelauta',
            runs: 'Orkestroinnin ajot',
            tasks: 'Suoritustehtävät',
            templates: 'Tarkistuslistamallipohjat',
            vendor_requests: 'Toimittajapyynnöt',
            proof_chain: 'Todistusketju',
            dsr_integration: 'DSR-integraatio',
            vendor_verification: 'Toimittajavahvistus',
            completeness: 'Kattavuusnäkymä',
        },
        dashboard: {
            title: 'Orkestroinnin kojelauta',
            loading: 'Ladataan kojelauta tiedot...',
            active_runs: 'Aktiiviset ajot',
            completion_rate: 'Completion Taso',
            avg_completion_time: 'Avg Completion Aika',
            overdue_tasks: 'Myöhässä Tehtävät',
            vendor_compliance: 'Toimittajan vaatimustenmukaisuus',
            recent_runs: 'Viimeaikainen Suorita',
            no_recent_runs: 'Ei viimeaikaisia orkestroinnin ajoja.',
            run_id: 'Suorita Tunniste',
            ticket_id: 'Tiketti Tunniste',
            progress: 'Edistyminen',
            systems: 'Järjestelmät',
            vendors: 'Toimittajat',
            load_error: 'Orkestroinnin hallintapaneelin lataaminen epäonnistui. Yritä uudelleen.',
            aria_table: 'Viimeaikaiset orkestraatiot',
        },
        runs: {
            title: 'Orkestroinnin ajot',
            new: 'Uusi Suorita',
            run_id: 'Suorita Tunniste',
            ticket_id: 'Tiketti Tunniste',
            progress: 'Edistyminen',
            systems: 'Järjestelmät',
            vendors: 'Toimittajat',
            data_subject_ref: 'Tiedot Subject Ref',
            data_categories: 'Tiedot Kategoriat',
            enable_proof_chain: 'Ota käyttöön Todiste Ketju',
            start: 'Aloita',
            started: 'Juoksu alkoi',
            mark_ready: 'Merkitse valmiiksi',
            marked_ready: 'Ajo merkitty valmiiksi',
            complete: 'Täydellinen',
            complete_exceptions: 'Täydellinen ilman poikkeuksia',
            pause: 'Tauko',
            resume: 'Jatka',
            cancel: 'Peruuta',
            no_runs: 'Ei orchestration runs found. löytynyt',
            load_error: 'Orkestrointiajojen lataaminen epäonnistui. Yritä uudelleen.',
            create_error: 'Orkesteriajon luominen epäonnistui',
            aria_filter_status: 'Suodata ajon tilan mukaan',
            aria_table: 'Orkestrointi toimii',
            placeholder_ticket_id: 'esim. TKT-000123',
            placeholder_data_subject_ref: 'esim. DS-REF-001',
            placeholder_data_categories: 'esim. personal_data, talous, terveys',
            title_label: 'Title',
            run_type: 'Run Type',
            run_type_labels: {
                data_subject_request: 'Data Subject Request',
                retention_expiry: 'Retention Expiry',
                manual: 'Manual',
                scheduled: 'Scheduled',
            },
            field_guidelines: {
                title: 'A descriptive name for this orchestration run.',
                run_type: 'The origin or trigger for the deletion process.',
                ticket_id: 'The associated ticket ID from your DSR or support system.',
                data_subject_ref: 'A unique identifier for the data subject (e.g., internal ID, email hash).',
                data_categories: 'Specific categories of personal data to be deleted (comma-separated).',
                proof_enabled: 'Maintains an immutable cryptographic chain of evidence for this run.',
            },
            actions: 'Actions',
            progress_guideline: 'Calculated based on completed system tasks and vendor requests.',
            placeholder_title: 'e.g., Q2 2026 Customer Deletion Batch',
        },
        tasks: {
            title: 'Suoritustehtävät',
            task_id: 'Tehtävä Tunniste',
            run_id: 'Suorita Tunniste',
            system_name: 'Järjestelmä Nimi',
            assigned_to: 'Määritetty To',
            sla_deadline: 'SLA-määräaika',
            progress: 'Edistyminen',
            enter_run_id: 'Syötä suorita tunniste to filter...',
            select_run: 'Valitse juoksu nähdäksesi tehtävät',
            unassigned: 'Määrittämätön',
            overdue: 'Myöhässä',
            assign_task: 'Määritä Tehtävä',
            assignee_id: 'Vastuuhenkilö Tunniste',
            update_status: 'Päivitä tila',
            new_status: 'Uusi Tila',
            no_transitions: 'Tämä tehtävä on lopullisessa tilassa eikä sen tilaa voi muuttaa.',
            select_status_placeholder: 'Valitse uusi tila',
            skip_justification: 'Ohituksen perustelu',
            failure_reason: 'Epäonnistumisen syy',
            no_tasks: 'Ei execution tehtävä found. löytynyt',
            new_task: 'Uusi tehtävä',
            system_id: 'Järjestelmän tunnus',
            data_classification: 'Tietojen luokitus',
            load_error: 'Kohteen execution tasks lataaminen epäonnistui. Yritä uudelleen.',
            assign_error: 'assign task epäonnistui',
            status_error: 'Tehtävän tilan päivittäminen epäonnistui',
            no_tasks_for_run: 'Tällä poistoajolla ei ole vielä suoritustehtäviä.',
            aria_filter_run_id: 'Suodata suoritustunnuksen mukaan',
            aria_filter_status: 'Suodata tehtävän tilan mukaan',
            aria_table: 'Toteutustehtävät',
            view_steps: 'Näytä vaiheet',
            steps_modal_title: 'Suoritusvaiheet',
            step_title: 'Vaihe',
            step_status: 'Vaiheen tila',
            step_notes: 'Muistiinpanot',
            step_evidence: 'Todistetiedostot',
            step_evidence_required: 'Tälle vaiheelle vaaditaan todiste',
            step_evidence_missing: 'Todisteita ei ole vielä ladattu',
            step_save: 'Tallenna vaihe',
            step_saved: 'Vaihe päivitetty',
            step_save_error: 'Vaiheen päivitys epäonnistui',
            create_success: 'Suoritustehtävä luotu',
            create_error: 'Suoritustehtävän luonti epäonnistui',
            step_upload_label: 'Liitä todiste',
        },
        templates: {
            title: 'Tarkistuslistamallipohjat',
            new: 'Uusi Malli',
            template_id: 'Malli Tunniste',
            system_type: 'Järjestelmätyyppi',
            est_duration: 'Est. Kesto',
            steps: 'Vaiheet',
            action_type: 'Toimintotyyppi',
            instructions: 'Ohjeet',
            mandatory: 'Pakollinen',
            add_step: 'Lisää vaihe',
            step_n: 'Vaihe',
            no_templates: 'Ei checklist mallit found. löytynyt',
            all_system_types: 'Kaikki järjestelmätyypit',
            load_error: 'Tarkistuslistamallien lataaminen epäonnistui. Yritä uudelleen.',
            create_error: 'Tarkistuslistamallin luominen epäonnistui',
            aria_filter_system_type: 'Suodata järjestelmätyypin mukaan',
            aria_filter_status: 'Suodata mallin tilan mukaan',
            aria_table: 'Tarkistuslistamallit',
            placeholder_name: 'esim. tietokannan poistamisen tarkistuslista',
            guideline_name: 'Use a clear operating name, for example “Database Deletion Checklist”.',
            guideline_system_type: 'Choose the system category this checklist will usually run against.',
            guideline_status: 'Draft templates can be reviewed before activation; active templates can be reused in runs.',
            guideline_description: 'Summarise scope, retention context, and when teams should select this template.',
            update_success: 'Mallipohja päivitetty onnistuneesti',
            create_success_msg: 'Mallipohja luotu onnistuneesti',
            update_error: 'Mallipohjan päivittäminen epäonnistui',
            activate_success: 'Mallipohja aktivoitu onnistuneesti',
            activate_error: 'Mallipohjan aktivointi epäonnistui',
            archive_success: 'Mallipohja arkistoitu onnistuneesti',
            archive_error: 'Mallipohjan arkistointi epäonnistui',
            clone_success: 'Mallipohja kloonattu onnistuneesti',
            clone_error: 'Mallipohjan kloonaus epäonnistui',
        },
        vendor_requests: {
            title: 'Toimittaja Deletion Pyynnöt',
            new: 'Uusi Pyyntö',
            request_id: 'Pyyntö Tunniste',
            vendor_name: 'Toimittajan nimi',
            vendor_id: 'Toimittajatunnus',
            data_subject_ref: 'Tiedot Subject Ref',
            data_categories: 'Tiedot Kategoriat',
            legal_basis: 'Oikeusperuste',
            sla_days: 'SLA päivää',
            requested_completion: 'Pyydetty valmistuminen',
            communications: 'Viestinnät',
            total_requests: 'Pyynnöt yhteensä',
            no_requests: 'Ei toimittaja deletion requests found. löytynyt',
            filter_vendor_id: 'Suodata by Toimittaja Tunniste...',
            change_status: 'Vaihda Tila',
            new_status: 'Uusi Tila',
            actions: 'Toiminnot',
            load_error: 'Toimittajan poistopyyntöjen lataaminen epäonnistui. Yritä uudelleen.',
            create_error: 'Toimittajan poistopyynnön luominen epäonnistui',
            dashboard_error: 'Toimittajan poiston hallintapaneelin lataaminen epäonnistui. Yritä uudelleen.',
            aria_filter_status: 'Suodata pyynnön tilan mukaan',
            aria_filter_vendor_id: 'Suodata toimittajan tunnuksen mukaan',
            aria_table: 'Toimittajan poistopyynnöt',
            placeholder_vendor_id: 'esim. VND-001',
            placeholder_vendor_name: 'esim. Acme Analytics',
            placeholder_data_subject_ref: 'esim. DS-REF-001',
            placeholder_data_categories: 'esim. personal_data, analytiikka',
            placeholder_legal_basis: 'esim. [[TOK_0]] 19 artikla',
        },
        proof_chain: {
            title: 'Todiste Ketju Katsoja',
            enter_run_id: 'Syötä suorita tunniste...',
            load_chain: 'Lataa Ketju',
            verify_chain: 'Vahvista ketju',
            verifying: 'Vahvistetaan...',
            chain_valid: 'Ketju is valid',
            chain_invalid: 'Ketju is broken',
            chain_length: 'Ketju Pituus',
            broken_at_index: 'Rikkoutunut indeksissä',
            no_proof_records: 'Ei todiste tietueet found for this run. löytynyt',
            proof_id: 'Todiste Tunniste',
            entity_type: 'Entity Tyyppi',
            entity_id: 'Entity Tunniste',
            event_hash: 'Tapahtuma Tiiviste',
            previous_hash: 'Edellinen Tiiviste',
            attestation: 'Todistus',
            attestation_actor: 'Suorittaja',
            attestation_signed_at: 'Allekirjoitettu',
            attestation_signature: 'Allekirjoitus',
            attestation_evidence_refs: 'Todisteviittaukset',
            run_field_label: 'Poistoajo',
            select_run: 'Valitse poistoajo…',
            aria_select_run: 'Poistoajo todisteketjun hakua varten',
            chain_broken_here: 'Ketju broken here',
            load_error: 'Vetoketjun lataaminen epäonnistui. Yritä uudelleen.',
            verify_error: 'Todistusketjun vahvistaminen epäonnistui. Yritä uudelleen.',
            aria_run_id: 'Suorita tunnus todisteketjun hakuun',
        },
        dsr_integration: {
            change_status: 'Muuta tilaa',
            request_type: 'Pyyntötyyppi',
            data_subject_hint: 'Sen rekisteröidyn tunniste, jonka tiedot poistetaan (esim. sähköposti tai asiakastunnus). Vastaa yleensä valitun DSR-tapauksen pyytäjää.',
            title: 'DSR-poistointegraatio',
            create_run: 'Luo DSR-poistoajo',
            dsr_case_id: 'DSR-tapauksen tunnus',
            data_subject_id: 'Rekisteröidyn tunnus',
            systems: 'Kohdejärjestelmät',
            route_to_department: 'Ohjaa osastolle',
            confirm_deletion: 'Vahvista poisto',
            no_runs: 'DSR-poistoajoja ei löytynyt',
            status: 'Poiston tila',
            deadline: 'Määräaika',
        },
        vendor_verification: {
            title: 'Toimittajan poistovahvistus',
            create_followup: 'Luo seuranta',
            deadline: 'Vahvistuksen määräaika',
            escalation_contact: 'Eskalointiyhteys',
            record_confirmation: 'Tallenna vahvistus',
            overdue: 'Myöhässä olevat poistot',
            escalate: 'Eskaloi',
            confirm_escalation: 'Haluatko varmasti eskaloida tämän toimittajan poistopyynnön?',
            no_followups: 'Toimittajaseurantoja ei löytynyt',
            no_overdue: 'Ei myöhässä olevia toimittajapoistoja',
            vendor_request: 'Myyjän pyyntö',
            vendor: 'Toimittaja',
            unknown_vendor: 'Tuntematon toimittaja',
            overdue_badge: 'Myöhässä',
            mark_confirmed: 'Merkitse vahvistetuksi',
            mark_confirmed_for: 'Merkitse poisto vahvistetuksi toimittajalle {vendor}',
            confirm_confirmation: 'Merkitäänkö tämä toimittajan poisto vahvistetuksi?',
            confirmation_success: 'Toimittajan poisto vahvistettu',
            confirmation_failed: 'Toimittajan poiston vahvistaminen epäonnistui',
            select_request: 'Valitse myyjän pyyntö…',
            escalation_contact_placeholder: 'esim. dpo@vendor.example',
            create_success: 'Toimittajan seuranta luotiin onnistuneesti',
            create_failed: 'Toimittajan seurannan luominen epäonnistui',
            deadline_hint: 'Tällä sivulla näytetään vain seurannat, joiden määräaika on jo umpeutunut.',
            deadline_future_warning: 'Tämä määräaika on tulevaisuudessa, joten seuranta ei näy myöhässä olevien luettelossa ennen kuin päivämäärä on ohitettu.',
            escalation_success: 'Toimittajan poistaminen eskaloitui onnistuneesti',
            escalation_failed: 'Toimittajan poistamisen eskalointi epäonnistui',
        },
        completeness: {
            title: 'Poiston kattavuus',
            check_conflicts: 'Tarkista säilytysristiriidat',
            no_conflicts: 'Säilytysristiriitoja ei löytynyt',
            conflict_resolution: 'Ristiriidan ratkaisu',
            extend_retention: 'Pidennä säilytysaikaa',
            proceed_deletion: 'Jatka poistoa',
            escalate_conflict: 'Eskaloi',
            resolve: 'Ratkaise ristiriita',
            data_subject_id: 'Rekisteröidyn tunnus',
            placeholder_data_subject_id: 'Syötä rekisteröidyn tunnus',
            data_subject_hint: 'Sen henkilön tunniste, jonka poistoa tarkistat (esim. sähköposti, asiakastunnus tai DSR-viite). Valitse tunnettu kohde tai kirjoita tunniste.',
            guidance: 'Anna tai valitse rekisteröidyn tunnus, valitse halutessasi järjestelmät ja suorita tarkistus nähdäksesi poiston kattavuuden ja säilytysristiriidat.',
            completion: 'Poiston valmius',
            pending_items: 'Odottavat kohteet',
            system: 'Järjestelmä',
            policy: 'Käytäntö',
            retention_end: 'Säilytys loppu',
            completed_items: 'Valmiit Kohteet',
            last_review_label: 'Viimeisin arvostelu',
            days_ago: 'päivää sitten',
            review_overdue: 'Tarkistusjakso ylitetty. Uudelleentarkistus vaaditaan.',
        },
        run_status_labels: {
            pending: 'Odottaa',
            planning: 'Suunnittelu',
            ready: 'Valmis',
            in_progress: 'Käynnissä',
            paused: 'Keskeytetty',
            completed: 'Valmis',
            completed_with_exceptions: 'Valmis poikkeuksin',
            cancelled: 'Peruutettu',
        },
        task_status_labels: {
            pending: 'Odottaa',
            assigned: 'Osoitettu',
            in_progress: 'Käynnissä',
            awaiting_verification: 'Odottaa vahvistusta',
            verified: 'Vahvistettu',
            failed: 'Epäonnistunut',
            skipped: 'Ohitettu',
        },
        system_type_labels: {
            database: 'Tietokanta',
            saas_application: 'SaaS-sovellus',
            file_storage: 'Tiedostotallennus',
            email_system: 'Sähköpostijärjestelmä',
            analytics_platform: 'Analytiikka-alusta',
            backup_system: 'Varmuuskopiojärjestelmä',
            vendor_managed: 'Toimittajan hallinnoima',
            custom: 'Mukautettu',
        },
        template_status_labels: {
            draft: 'Luonnos',
            active: 'Aktiivinen',
        },
        action_type_labels: {
            manual_check: 'Manuaalinen tarkistus',
            api_call: 'API-kutsu',
            sql_query: 'SQL-kysely',
            script_execution: 'Skriptin suoritus',
            file_deletion: 'Tiedoston poisto',
            verification: 'Vahvistus',
            notification: 'Ilmoitus',
            approval: 'Hyväksyntä',
        },
        request_status_labels: {
            draft: 'Luonnos',
            sent: 'Lähetetty',
            acknowledged: 'Kuitattu',
            in_progress: 'Käynnissä',
            completed: 'Valmis',
            overdue: 'Myöhässä',
            escalated: 'Eskaloitu',
            disputed: 'Kiistetty',
        },
        event_type_labels: {
            initiation: 'Aloitus',
            data_deletion: 'Tietojen poisto',
            completion: 'Valmistuminen',
            verification: 'Vahvistus',
            rollback: 'Peruutus',
        },
        count_labels: {
            one_template: '1 malli',
            n_templates: '{n} mallia',
            one_run: '1 suoritus',
            n_runs: '{n} suoritusta',
            one_task: '1 tehtävä',
            n_tasks: '{n} tehtävää',
            one_request: '1 pyyntö',
            n_requests: '{n} pyyntöä',
        },
        aria: {
            completion_rate: 'Valmistumisaste: {pct}%',
            vendor_compliance: 'Toimittajan vaatimustenmukaisuus: {pct}%',
            run_progress: 'Suorituksen edistyminen: {pct}%',
            run_progress_systems: 'Edistyminen: {completed}/{total} järjestelmää käsitelty',
            chain_broken: 'Ketju katkennut tässä tietueessa',
            chain_valid: 'Ketju kelvollinen tässä tietueessa',
            chain_unknown: 'Ketjun tila tuntematon',
            escalate_vendor: 'Eskaloi {id}',
            resolve_conflict: 'Ratkaise ristiriita kohteelle {system}',
        },
        regulatory: {
            annual_review_cycle_info: 'Poiston täydellisyys on tarkistettava vähintään 365 päivän välein. Tämän kynnyksen ylittävät tietueet merkitään pakolliseen uudelleentarkastukseen säännöstenmukaisuuden säilyttämiseksi.',
            runs_data_d1_lifecycle_info: 'Orkestroinnin ajon tilat liittyvät DATA-D1-elinkaariin: suunnittelu = luettelo, valmis = luokittele, in_progress = käytä sääntöjä, valmis = todisteet luotu, completed_with_exceptions = tarkistus vaaditaan. Jokainen siirtymä kirjataan vedosketjuun.',
            vendor_record_linkage_info: 'Jokainen toimittajan poistopyyntö on linkitetty sen toimittajatietueeseen vendor_id:n kautta. Täytäntöönpanon vahvistus vaatii salaustodisteita todistusketjulta ennen kuin pyyntö voidaan merkitä suoritetuksi.',
            templates_internal_classification_info: 'Kaikki poistojen tarkistuslistamallit luokitellaan organisaation sisäisiksi asiakirjoiksi. They do not carry official regulatory form IDs and should not be submitted as regulatory filings.',
            proof_chain_evidence_info: 'Jokainen todistetietue kaappaa rekisteröidyn/luokan, aikaleiman, toimijan, oikeusperustan ja SHA-256-tiivisteen. Yhdessä nämä kentät tuottavat salauksen poistamisen todisteita, jotka täyttävät säännösten auditointivaatimukset.',
            retention_data_law_info: 'Tämän kojelaudan säilytysaikataulut on johdettu kullekin tietokategorialle määritetystä Data Law -luokituksesta. Kun luokitus muuttuu, linkitetyt säilytyssäännöt päivittyvät automaattisesti säännösten mukautumisen varmistamiseksi.',
            dsr_erasure_route_info: 'DSR erasure runs are linked to the originating Rights Request case. The regulatory deadline (typically 30 days under [[TOK_0]] Art. 17) is tracked automatically. Myöhästyneet tapaukset on merkitty eskaloitaviksi.',
        },
    },
    discovery: {
        nav: {
            dashboard: 'Löytökojelauta',
            scans: 'Löytöskannaukset',
            staging_area: 'Väliaikaisalue',
            dedup_rules: 'Deduplikointisäännöt',
            classification_rules: 'Luokittelusäännöt',
            suggestions: 'Ehdotusjono',
            analytics: 'Ehdotusanalytiikka',
            import_templates: 'Tuontimallipohjat',
            connectors: 'Liitinhallinta',
            discovery_cycles: 'Löytösyklit',
            owner_review: 'Omistajan tarkistus',
            classification_lineage: 'Luokitteluhistoria',
        },
        dashboard: {
            title: 'Löytökojelauta',
            loading: 'Ladataan kojelauta tiedot...',
            total_scans: 'Skannaukset yhteensä',
            active_scans: 'Aktiiviset skannaukset',
            completed_30d: 'Valmis (30d)',
            failed_30d: 'Epäonnistunut (30d)',
            systems_discovered: 'Järjestelmät Discovered',
            pending_staged_records: 'Odottaa Staged Tietueet',
            recent_scans: 'Viimeaikainen Skannaukset',
            no_recent_scans: 'No recent skannaus.',
            scan_id: 'Skannaus Tunniste',
            discovered: 'Löydetty',
            view_all_scans: 'Näytä kaikki skannaukset',
            staging_area: 'Väliaikainen alue',
            suggestion_queue: 'Ehdotus Jono',
            records_reviewed: 'Tarkastetut tietueet',
            records_approved: 'Hyväksytyt tietueet',
            exceptions_pending: 'Odottavat poikkeukset',
            view_as_chart: 'Näytä kaaviona',
            view_as_table: 'Näytä taulukkona',
        },
        scans: {
            title: 'Löytöskannaukset',
            new: 'Uusi Skannaus',
            scan_id: 'Skannaus Tunniste',
            scan_type: 'Skannaustyyppi',
            progress: 'Edistyminen',
            discovered: 'Löydetty',
            no_scans: 'Ei discovery skannaus found. löytynyt',
            all_scan_types: 'Kaikki skannaustvypit',
            source_config: 'Lähde Config (JSON)',
            invalid_json: 'Virheellinen JSON in source config',
            load_error: 'Epäonnistui: load discovery skannaus. Yritä uudelleen.',
            create_error: 'Epäonnistui: create discovery skannaus. Yritä uudelleen.',
            change_status: 'Muuta tilaa',
            new_status: 'Uusi tila',
            actions: 'Toiminnot',
            type_endpoint: 'Päätepiste',
            type_spreadsheet_import: 'Taulukkotuonti',
            type_cmdb_sync: 'CMDB-synkronointi',
            type_cloud_sync: 'Pilvisynkronointi',
            status_pending: 'Odottaa',
            status_running: 'Käynnissä',
            status_completed: 'Valmis',
            status_failed: 'Epäonnistunut',
            status_cancelled: 'Peruutettu',
            source_config_placeholder: '{"isäntä": "...", "portti": 443}',
        },
        staging_area: {
            title: 'Väliaikaisalue',
            record_id: 'Tietuetunnus',
            source_scan: 'Lähde Skannaus',
            entity_type: 'Entity Tyyppi',
            suggested_name: 'Suggested Nimi',
            confidence: 'Luottamus',
            no_records: 'Ei staged tietueet found. löytynyt',
            promote: 'Ylennä',
            discard: 'Hylkää',
            review: 'Katselmointia',
            merge: 'Yhdistä',
            merge_title: 'Yhdistä tietue',
            merge_target_id: 'Yhdistä Tavoite Tunniste',
            reject_reason_placeholder: 'Syy hylkäämiselle...',
            promotion_status: 'Promotion Tila',
            dedup_status: 'Deduplikointi Tila',
            all_source_types: 'Kaikki lähdetyypit',
            all_promotion_statuses: 'Kaikki ylennystilat',
            all_dedup_statuses: 'Kaikki deduplikointitilat',
            load_error: 'Epäonnistui: load staged tietueet. Yritä uudelleen.',
            promote_error: 'Epäonnistui: promote tietue. Yritä uudelleen.',
            reject_error: 'Epäonnistui: reject tietue. Yritä uudelleen.',
            merge_error: 'Epäonnistui: merge tietue. Yritä uudelleen.',
            review_error: 'Epäonnistui: mark tietue for katselmointi. Yritä uudelleen.',
            bulk_promote_error: 'Epäonnistui: bulk promote tietueet. Yritä uudelleen.',
            bulk_reject_error: 'Epäonnistui: bulk reject tietueet. Yritä uudelleen.',
            service_type_web_server: 'Verkkopalvelin',
            service_type_database: 'Tietokanta',
            service_type_api_gateway: 'API-yhdyskäytävä',
            service_type_storage: 'Tallennustila',
            service_type_authentication: 'Todennus',
            service_type_analytics: 'Analytiikka',
            service_type_unknown: 'Tuntematon',
            source_type_endpoint_scan: 'Päätepisteskannaus',
            source_type_spreadsheet: 'Taulukko',
            source_type_cmdb: 'CMDB',
            source_type_cloud_inventory: 'Pilvi-inventaario',
            promotion_status_new: 'Uusi',
            promotion_status_under_review: 'Tarkistettavana',
            promotion_status_promoted: 'Ylennetty',
            promotion_status_rejected: 'Hylätty',
            promotion_status_merged: 'Yhdistetty',
            dedup_status_unmatched: 'Ei vastaavuutta',
            dedup_status_potential_match: 'Mahdollinen vastaavuus',
            dedup_status_exact_match: 'Tarkka vastaavuus',
            dedup_status_resolved: 'Ratkaistu',
            confirm_bulk_reject: 'Haluatko varmasti hylätä valitut tietueet?',
            scan_batch_id: 'Erätunnus',
            promote_to_registry_title: 'Siirry tietorekisteriin',
            promote_modal_instructions: 'Creates a Data Registry item with collection_method: observed and provenance linkage to this discovery record. Kohde alkaa luonnostilassa tarkistettavaksi.',
            promote_label_category: 'Luokka',
            promote_label_name_override: 'Nimi (valinnainen ohitus)',
            placeholder_name_override: 'Oletusarvo on etsintätietueen nimi/isäntänimi',
            promote_label_sensitivity: 'Ehdotettu herkkyys',
            inherit_from_category: 'Peri luokasta',
        },
        dedup_rules: {
            title: 'Deduplikointisäännöt',
            new: 'Uusi Sääntö',
            rule_name: 'Sääntö Nimi',
            match_fields: 'Match Kentät',
            threshold: 'Kynnysarvo',
            no_rules: 'Ei dedup rules found. löytynyt',
            seed_defaults: 'Alusta Oletus',
            match_type: 'Match Tyyppi',
            similarity_threshold: 'Similarity Kynnysarvo',
            field_name: 'Kenttä Nimi',
            load_error: 'Epäonnistui: load dedup rules. Yritä uudelleen.',
            create_error: 'Epäonnistui: create dedup rule. Yritä uudelleen.',
            toggle_error: 'Epäonnistui: toggle dedup rule. Yritä uudelleen.',
            seed_error: 'Epäonnistui: seed defaults. Yritä uudelleen.',
            priority: 'Prioriteetti',
            enabled_status: 'Käytössä',
            disabled_status: 'Ei käytössä',
            default_badge: 'Oletus',
            enable: 'Ota käyttöön',
            disable: 'Poista käytöstä',
            match_type_exact: 'Tarkka',
            match_type_fuzzy: 'Sumea',
            match_type_regex: 'Regex',
            match_type_ip_range: 'IP-alue',
        },
        classification_rules: {
            title: 'Luokittelusäännöt',
            new: 'Uusi Sääntö',
            rule_name: 'Sääntö Nimi',
            pattern: 'Malli',
            classification: 'Luokittelu',
            no_rules: 'Ei classification rules found. löytynyt',
            seed_defaults: 'Alusta Oletus',
            run_rules_now: 'Suorita säännöt nyt',
            run_rules_success: 'Loi [[TOK_1]] uutta luokitusehdotusta',
            run_rules_no_results: 'Uusia ehdotuksia ei luotu – kaikilla vastaavilla säännöillä on jo odottavia ehdotuksia',
            run_rules_error: 'Luokittelusääntöjen suorittaminen epäonnistui. Yritä uudelleen.',
            taxonomy_id: 'Taksonomia Tunniste',
            level_id: 'Taso Tunniste',
            condition_logic: 'Ehtojen logiikka',
            weight: 'Paino',
            conditions: 'Ehdot',
            condition_field: 'Kenttä',
            condition_operator: 'Operaattori',
            condition_value: 'Arvo',
            effectiveness: 'Tehokkuus',
            match_count: 'Vastaavuudet',
            approval_count: 'Hyväksynnät',
            rejection_count: 'Hylkäykset',
            filter_taxonomy: 'Suodata by Taksonomia Tunniste...',
            load_error: 'Epäonnistui: load classification rules. Yritä uudelleen.',
            create_error: 'Epäonnistui: create classification rule. Yritä uudelleen.',
            seed_error: 'Epäonnistui: seed defaults. Yritä uudelleen.',
            toggle_error: 'Epäonnistui: toggle rule. Yritä uudelleen.',
            priority: 'Prioriteetti',
            enabled_status: 'Käytössä',
            disabled_status: 'Ei käytössä',
            enable: 'Ota käyttöön',
            disable: 'Poista käytöstä',
            logic_and: 'JA',
            logic_or: 'TAI',
            operator_equals: 'Yhtä suuri kuin',
            operator_contains: 'Sisältää',
            operator_matches_regex: 'Vastaa Regexia',
            operator_in_list: 'Listalla',
            operator_not_equals: 'Ei yhtä suuri kuin',
            operator_not_contains: 'Ei sisällä',
            enabled_label: 'Käytössä',
            disabled_label: 'Pois käytöstä',
            taxonomy_label: 'Taksonomia',
            operator_label: 'Operaattori',
            value_label: 'Arvo',
        },
        suggestions: {
            title: 'Ehdotusjono',
            entity_type: 'Entity Tyyppi',
            suggested_name: 'Suggested Nimi',
            source: 'Lähde',
            confidence: 'Luottamus',
            accept: 'Hyväksy',
            reject: 'Hylkää',
            no_suggestions: 'Ei ehdotuksia jonossa.',
            modify_approve: 'Modify & Hyväksy',
            delegate: 'Delegoi',
            delegate_user_id: 'Delegoi Käyttäjä Tunniste',
            new_level_id: 'Uusi Taso Tunniste',
            reject_reason_placeholder: 'Syy hylkäämiselle...',
            current_level: 'Nykyinen Taso',
            suggested_level: 'Suggested Taso',
            filter_taxonomy: 'Suodata by Taksonomia Tunniste...',
            all_confidence: 'Kaikki luottamusvälit',
            load_error: 'Epäonnistui: load suggestions. Yritä uudelleen.',
            approve_error: 'Epäonnistui: approve suggestion. Yritä uudelleen.',
            reject_error: 'Epäonnistui: reject suggestion. Yritä uudelleen.',
            modify_error: 'Epäonnistui: modify & approve suggestion. Yritä uudelleen.',
            delegate_error: 'Epäonnistui: delegate suggestion. Yritä uudelleen.',
            bulk_approve_error: 'Epäonnistui: bulk approve suggestions. Yritä uudelleen.',
            bulk_reject_error: 'Epäonnistui: bulk reject suggestions. Yritä uudelleen.',
            suggestion_type_new_label: 'Uusi tunniste',
            suggestion_type_validation: 'Validointi',
            suggestion_type_reclassification: 'Uudelleenluokittelu',
            status_pending: 'Odottaa',
            status_approved: 'Hyväksytty',
            status_rejected: 'Hylätty',
            status_superseded: 'Korvattu',
            confidence_high: 'Korkea',
            confidence_medium: 'Keskitaso',
            confidence_low: 'Matala',
            confirm_bulk_reject: 'Haluatko varmasti hylätä valitut ehdotukset?',
        },
        analytics: {
            title: 'Ehdotusanalytiikka',
            total_suggestions: 'Ehdotukset yhteensä',
            accepted: 'Hyväksytty',
            rejected: 'Hylätty',
            pending: 'Odottaa',
            acceptance_rate: 'Hyväksyntäaste',
            by_entity_type: 'By Entity Tyyppi',
            by_source: 'By Lähde',
            avg_decision_time: 'Avg Päätös Aika',
            rule_effectiveness: 'Sääntö Effectiveness',
            by_status: 'By Tila',
            by_confidence: 'Luottamusvälin mukaan',
            load_error: 'Epäonnistui: load suggestion analytics. Yritä uudelleen.',
            confidence_high: 'Korkea',
            confidence_medium: 'Keskitaso',
            confidence_low: 'Matala',
            by_confidence_band: 'Luottamustason mukaan',
            approval_rate: 'Hyväksyntäaste',
            by_label_state: 'Merkinnän tilan mukaan',
        },
        import_templates: {
            title: 'Tuontimallipohjat',
            new: 'Uusi Malli',
            template_name: 'Malli Nimi',
            file_format: 'Tiedosto Muoto',
            column_mappings: 'Column Kartoitukset',
            no_templates: 'Ei import mallit found. löytynyt',
            source_column: 'Lähde Column',
            target_field: 'Tavoite Kenttä',
            transform: 'Muunna',
            source_column_label: 'Lähde sarake',
            target_field_label: 'Kohdekenttä',
            transform_label: 'Muunna',
            confirm_delete: 'Haluatko varmasti poistaa this import template?',
            load_error: 'Epäonnistui: load import mallit. Yritä uudelleen.',
            save_error: 'Epäonnistui: save import malli. Yritä uudelleen.',
            delete_error: 'Epäonnistui: delete import malli. Yritä uudelleen.',
            file_type_csv: 'CSV',
            file_type_xlsx: 'XLSX',
        },
        connectors: {
            title: 'Liitinhallinta',
            new: 'Uusi Liitin',
            connector_name: 'Liitin Nimi',
            connector_type: 'Tyyppi',
            last_sync: 'Viimeisin synkronointi',
            no_connectors: 'Ei connectors found. löytynyt',
            cmdb_syncs: 'CMDB-synkronoinnit',
            cloud_syncs: 'Pilvisynkronoinnit',
            new_sync: 'Uusi Sync',
            no_syncs: 'Ei syncs found. löytynyt',
            cmdb_error: 'Epäonnistui: load CMDB skannaus. Yritä uudelleen.',
            cloud_error: 'Epäonnistui: load cloud skannaus. Yritä uudelleen.',
            trigger_error: 'Epäonnistui: trigger sync. Yritä uudelleen.',
            trigger_sync_error: 'trigger {type} epäonnistui',
            cmdb_section_title: 'CMDB-synkronoinnit',
            cloud_section_title: 'Pilvisynkronoinnit',
            column_connector: 'Liitin',
            action_start: 'Aloita',
            confirm_cancel_sync: 'Peruuta tämä synkronointi?',
            start_error: 'Synkronoinnin aloitus epäonnistui',
            cancel_error: 'Synkronoinnin peruutus epäonnistui',
            type_endpoint: 'Päätepisteen skannaus',
            type_spreadsheet_import: 'Taulukkotuonti',
            type_cmdb_sync: 'CMDB-synkronointi',
            type_cloud_sync: 'Pilvisynkronointi',
        },
        discovery_cycles: {
            title: 'Löytösyklit',
            new_cycle: 'Uusi löytösykli',
            cycle_name: 'Syklin nimi',
            scope_type: 'Laajuustyyppi',
            scope_ids: 'Laajuustunnukset',
            cadence_days: 'Tiheys (päivää)',
            status: 'Tila',
            no_cycles: 'Löytösyklejä ei löytynyt',
            compare: 'Vertaa syklejä',
            delta_report: 'Muutosraportti',
            new_records: 'Uudet tietueet',
            changed_records: 'Muuttuneet tietueet',
            removed_records: 'Poistetut tietueet',
            schedule: 'Ajasta skannaus',
            scope_organization: 'Organisaatio',
            scope_department: 'osasto',
            scope_system: 'Järjestelmä',
            scope_systems: 'Järjestelmät',
            bulk_actions: 'Joukkotoiminnot',
            selected: '{count} valittu',
            bulk_create: 'Joukkoluo',
            bulk_assign_scope: 'Joukkoosoita laajuus',
            bulk_advance: 'Joukkosiirrä tilaa',
            confirm_bulk_action: 'Vahvista joukkotoiminto',
            bulk_confirm_message: 'Oletko varma, että haluat suorittaa tämän toiminnon?',
            cycles_affected: '{count} sykliä vaikuttaa',
            select_all: 'Valitse kaikki',
            select_cycle: 'Valitse sykli {name}',
            from_template: 'mallista',
            bulk_results: 'Massatulokset',
            failed_label: 'epäonnistui',
            template_id: 'Mallin tunnus',
            count: 'Lukumäärä',
            advance_to: 'Kohdetila',
            bulk_success: 'Massatoiminto suoritettu',
        },
        owner_review: {
            title: 'Omistajan tarkistustehtävät',
            assign_owner: 'Määritä omistajalle',
            owner_id: 'Omistaja',
            decision: 'Päätös',
            approve: 'Hyväksy',
            modify: 'Muokkaa',
            reject: 'Hylkää',
            escalate: 'Eskaloi',
            no_tasks: 'Tarkistustehtäviä ei löytynyt',
            bulk_resolve: 'Massaratkaisu',
            exceptions: 'Poikkeuskohteet',
            no_exceptions: 'Poikkeuskohteita ei löytynyt',
            record_id_label: 'Tietueen tunnus',
            selected: 'valittu',
            notes: 'Muistiinpanot',
            select_all: 'Valitse Kaikki',
            select: 'Valitse',
            confirm_resolve: 'Vahvista',
        },
        classification_lineage: {
            title: 'Luokitteluhistoria',
            link_suggestion: 'Linkitä ehdotettuun tunnisteeseen',
            suggestion_id: 'Ehdotus',
            proposed_label_id: 'Ehdotettu tunniste',
            no_lineage: 'Historiatietoja ei löytynyt',
            full_lineage: 'Täydellinen historia',
            record_id_label: 'Tietueen tunnus',
            staged_record_label: 'Lavastettu levy',
            enter_staged_record_id: 'Anna vaiheittaisen tietueen tunnus',
            scan_id_label: 'Skannaustunnus',
            select_record: 'Valitse tietue',
            select_suggestion: 'Valitse ehdotus',
            select_label: 'Valitse tunniste',
        },
        common_labels: {
            n_rules: '[[TOK_1]] säännöt',
            one_rule: '1 sääntö',
            n_scans: '[[TOK_1]] skannaa',
            one_scan: '1 skannaus',
            n_syncs: '[[TOK_1]] synkronoi',
            one_sync: '1 synkronointi',
            n_records: '[[TOK_1]] tallentaa',
            one_record: '1 ennätys',
            n_templates: '[[TOK_1]]-malleja',
            one_template: '1 malli',
            n_suggestions: '[[TOK_1]] ehdotuksia',
            one_suggestion: '1 ehdotus',
            n_selected: '[[TOK_1]] valittu',
            dashboard_loaded: 'Discovery-hallintapaneeli ladattu',
            n_scans_loaded: '[[TOK_1]] skannausta ladattu',
            n_staged_records_loaded: '[[TOK_1]] lavastettuja tietueita ladattu',
            confirm_delete_import_template: 'Haluatko varmasti poistaa tämän tuontimallin?',
            invalid_json_source_config: 'Virheellinen [[TOK_0]] kohteessa source_config',
            scope_organization: 'Organisaatio',
            scope_department: 'osasto',
            scope_system: 'Järjestelmä',
            aria_filter_scans: 'Suodatinskannaukset',
            aria_filter_staged_records: 'Suodata vaiheittaiset tietueet',
            aria_filter_suggestions: 'Suodattimet',
            aria_filter_by_taxonomy_id: 'Suodata taksonomiatunnuksen mukaan',
            aria_filter_by_enabled_status: 'Suodata käytössä-tilan mukaan',
            aria_filter_by_source_type: 'Suodata lähdetyypin mukaan',
            aria_filter_by_promotion_status: 'Suodata tarjouksen tilan mukaan',
            aria_filter_by_dedup_status: 'Suodata dedup-tilan mukaan',
            aria_filter_by_scan_type: 'Suodata skannaustyypin mukaan',
            aria_filter_by_status: 'Suodata tilan mukaan',
            aria_filter_by_confidence: 'Suodata luottamusalueen mukaan',
            aria_select_all_records: 'Valitse kaikki tietueet',
            aria_select_record: 'Valitse tietue [[TOK_1]]',
            aria_select_all_suggestions: 'Valitse kaikki ehdotukset',
            aria_select_suggestion: 'Valitse ehdotus [[TOK_1]]',
            aria_promote_record: 'Mainosta tietuetta [[TOK_1]]',
            aria_discard_record: 'Hylkää tietue [[TOK_1]]',
            aria_merge_record: 'Yhdistä tietue [[TOK_1]]',
            aria_review_record: 'Tarkista tietue [[TOK_1]]',
            aria_accept_suggestion: 'Hyväksy ehdotus [[TOK_1]]',
            aria_reject_record: 'Hylkää tietue',
            aria_merge_record_dialog: 'Yhdistä tietue',
            aria_create_new_scan: 'Luo uusi skannaus',
            aria_sync_progress: 'Synkronoinnin edistyminen: [[TOK_2]] / [[TOK_3]] kohdetta käsitelty',
            aria_scan_progress: 'Tarkistuksen edistyminen: [[TOK_2]] / [[TOK_3]] kohdetta käsitelty',
            aria_confidence: 'Luottamus: [[TOK_1]] %',
            aria_effectiveness: 'Tehokkuus: [[TOK_1]]',
            aria_promote_n_records: 'Mainosta [[TOK_1]] valittua tietuetta',
            aria_discard_n_records: 'Hylkää [[TOK_1]] valitut tietueet',
            placeholder_pii_detection_rule: 'esim. henkilökohtaisten tunnistetietojen havaitsemissääntö',
            placeholder_tax_id: 'esim. TAX-001',
            placeholder_lvl_id: 'esim. LVL-001',
            placeholder_service_type: 'esim. service_type',
            placeholder_database: 'esim. tietokanta',
            placeholder_hostname_match: 'esim. isäntänimen tarkka vastaavuus',
            placeholder_hostname: 'esim. isäntänimi',
            placeholder_hr_systems_csv: 'esim. HR Systems [[TOK_0]] tuonti',
            placeholder_server_name: 'esim. palvelimen nimi',
            placeholder_hostname_field: 'esim. isäntänimi',
            placeholder_lowercase: 'esim. pienet kirjaimet',
            placeholder_source_config: '{"isäntä": "...", "portti": 443}',
            placeholder_stg_id: 'esim. STG-000123',
            placeholder_lvl_002: 'esim. LVL-002',
            placeholder_usr_id: 'esim. USR-000123',
            decision_for: 'Päätös [[TOK_1]]',
        },
        exports: {
            title: 'Vie',
            inventory: 'Tietoinventaario',
            classification_register: 'Luokitusrekisteri',
            raci: 'RACI-matriisi',
            exceptions: 'Poikkeusraportti',
            evidence_pack: 'Todistepaketti',
            delta_report: 'Muutosraportti',
            executive_summary: 'Johdon yhteenveto',
            export_button: 'Vie',
            downloading: 'Ladataan...',
            download_complete: 'Lataus valmis.',
            download_error: 'Viennin lataus epäonnistui. Yritä uudelleen.',
        },
        flags: {
            title: 'Jatkotoimenpiteiden merkinnät',
            pending: 'Odottavat merkinnät',
            cross_border_review_needed: 'Rajat ylittävä tarkastus tarvitaan',
            sharing_disclosure_needed: 'Jakamisen ilmoitus tarvitaan',
            dpia_review_needed: 'DPIA-tarkastus tarvitaan',
            acknowledge: 'Kuittaa',
            resolve: 'Ratkaise',
            no_flags: 'Ei jatkotoimenpiteiden merkintöjä.',
        },
        delta: {
            title: 'Muutosyhteenveto',
            new_count: '{n} uutta',
            removed_count: '{n} poistettua',
            changed_count: '{n} muutettua',
            re_review_triggered: 'Uudelleentarkastus käynnistetty',
            create_re_review: 'Luo uudelleentarkastus',
            recent_alerts: 'Viimeaikaiset muutoshälytykset',
            no_alerts: 'Ei viimeaikaisia muutoshälytyksiä.',
            threshold_exceeded: 'Muutoskynnys ylitetty (>10 %)',
        },
        regulatory: {
            dashboard_governance_info: 'Tämä kojelauta näyttää syklitason hallinnan tilan: järjestelmät tarkistettu, tietueet vaiheistettu, tietueet tarkistettu, tietueet hyväksytty ja poikkeukset odottavat. Tämä vastaa hallinnointiliidin onnistumiskriteerejä: "suora hallintapaneeli siitä, kuka on päivittänyt varastonsa, luokituksensa ja jakamislokit" (P-VN-05).',
            export_artifacts_info: 'Löytöjen vienti sisältää kaikki vaaditut artefaktityypit kohtia UC-VN-10 ja DATA-EVD-01: hyväksytty tietovarasto, luokitusrekisteri, omistajuus/RACI-kartoitus, poikkeusjono, yhteenveto, todistepaketti ja delta-raportti.',
            scan_inventory_pipeline_info: 'Jokainen valmis skannaus tuottaa vn_data_law_data_inventory_register-mallin kanssa yhteensopivia tietueita (vaatimus 88dd9877). Löydetyt tietovarat täytetään automaattisesti tietovarastorekisteriin täyttääkseen tietolain velvoitteen ylläpitää digitaalista tietovarastoa.',
            connector_linkage_info: 'Jokaisen liitinkokoonpanon on sisällettävä järjestelmätyyppi (esim. [[TOK_0]], pilvialusta), tietovaraston viite (tietokanta, tiedostosäilö, SaaS) ja liiketoimintaprosessien linkitys (UC-VN-10 vaaditut tukitietueet). Nämä kentät varmistavat, että löydetyt resurssit voidaan jäljittää niiden lähdejärjestelmään ja liiketoimintakontekstiin.',
            owner_routing_info: 'Tarkastustehtävät reititetään oikealle osastolle tai sovelluksen omistajalle järjestelmän/tietojen omistajuuden perusteella (UC-VN-10 vaihe 5). Reititys käyttää järjestelmän omistajuusrekisteriä, ei ad hoc -määritystä.',
            owner_actions_audit_info: 'Omistajat voivat hyväksyä, muokata, hylätä tai laajentaa kunkin luokituksen (UC-VN-10 vaihe 6). Jokainen toiminto tallentaa toimijan, aikaleiman ja syyn ja tuottaa hallinnon tarkastuksen todisteita vaatimuksen f12fc090 (vuosittainen hallintotodistus) mukaisesti. Kirjausketju näyttää, kuka on tarkistanut, mitä on muutettu ja milloin.',
            escalation_timers_info: 'Eskalointiajastimet: omistajan tarkastelun määräaika on 5 arkipäivää; poikkeuksen eskalaatio on 48 tuntia (UC-VN-10 ajastimet). Ratkaisemattomat kohteet eskaloituvat automaattisesti, kun määräaika umpeutuu. Ajastimet ovat määritettävissä organisaatiokäytännön mukaan.',
            original_suggestion_preserved_info: 'Alkuperäinen koneen/järjestelmän luokitusehdotus säilytetään jokaisen omistajan ohituksen yhteydessä (UC-VN-10 todistevaatimus). Alkuperäistä ehdotusta ei koskaan kirjoiteta päälle, ja se pysyy näkyvissä tarkastusta varten.',
            dedup_lineage_info: 'Päällekkäisyyden poistamissäännöt estävät päällekkäiset inventaariomerkinnät, kun sama tietoresurssi löydetään useista tarkistuksista tai liittimistä. Viimeisimmät skannauksen metatiedot säilytetään ensisijaisena tietueena, samalla kun säilytetään viittaukset kaikkiin aikaisempiin löytöihin tarkastuksen jäljitettävyyttä varten.',
            label_states_info: 'Analytics erottaa 4 hallinnon tarkistuksen tunnistetilaa: koneen ehdottama (odottaa), omistajan hyväksymä, omistajan muokkaama ja hylätty. Näiden tilojen avulla tilintarkastajat voivat arvioida automaation tarkkuutta ja omistajan sitoutumista.',
            import_pipeline_info: 'Tuontimallien on tuotettava tietueita, jotka ovat yhteensopivia etsintäputken kanssa. Tuoduilla tietueilla on samat metatietovaatimukset kuin skannatut tietueet: lähdejärjestelmän tunniste, erätunnus ja aikaleima. Sarakekartoitusten tulee kohdistaa vn_data_law_data_inventory_register:ssa määritettyihin kenttiin.',
            lineage_full_path_info: 'Luokittelulinja jäljittää koko polun: skannaus/tuonti -> vaiheistus -> omistajan tarkistus -> hyväksytty etiketti -> rekisterimerkintä (UC-VN-10 vaiheet 1-10). Jokainen vaihe näyttää tietueen tunnuksen, toimijan, aikaleiman ja tilasiirtymän täydellisen tarkastuksen jäljitettävyyden varmistamiseksi.',
            staging_workflow_info: 'Vaiheittaiset tietueet erotetaan visuaalisesti hyväksytyistä varastomerkinnöistä niiden ylennyksen tilatunnuksen perusteella (UC-VN-10 vaihe 3). Jokainen tietue säilyttää alkuperän metatiedot: lähdejärjestelmän, skannauserän tunnuksen ja haun aikaleiman täydellisen tarkastuksen jäljitettävyyden varmistamiseksi.',
            suggestion_data_d1_info: 'Ehdotukset vastaavat tietolain luokittelumenettelyä DATA-D1: (1) luettelotietovarat, (2) luokitella herkkyystason mukaan, (3) määrittää käsittelysäännöt. Jokainen ehdotus sisältää herkkyys- ja tärkeysmitat vaatimuksen 18e4bfd1 mukaan.',
            downstream_flags_info: 'Kohteet, jotka on merkitty jaettaviksi, rajat ylittäväksi siirroksi tai suuren riskin käsittelyyn, käynnistävät linkitetyt loppupään työnkulkuja: rajat ylittävän siirron arvioinnin, jakamisen riskinarvioinnin ja [[TOK_0]] tarkistuksen (UC-VN-10 vaihe 8).',
            delta_detection_info: 'Etsintäjaksot tukevat delta-tunnistusta UC-VN-10-vaiheessa 11: jokainen sykli näyttää, mitkä tietueet ovat uusia, muuttuneita tai poistettuja viimeisen hyväksytyn perusviivan jälkeen. Materiaalimuutokset (>10 % delta) käynnistävät automaattisesti uudelleenarvioinnin työnkulkuja.',
        },
    },
    incident_ops: {
        errors: {
            fetch: 'Epäonnistui: load. Yritä uudelleen.',
            save: 'Epäonnistui: save. Yritä uudelleen.',
            fetch_escalation_log_failed: 'Epäonnistui: fetch escalation loki. Yritä uudelleen.',
            fetch_activations_failed: 'Epäonnistui: fetch activations. Yritä uudelleen.',
            deactivate_failed: 'Epäonnistui: deactivate. Yritä uudelleen.',
            complete_activation_failed: 'Epäonnistui: complete activation. Yritä uudelleen.',
            fetch_playbook_templates_failed: 'Epäonnistui: fetch playbook mallit. Yritä uudelleen.',
            create_playbook_template_failed: 'Epäonnistui: create playbook malli. Yritä uudelleen.',
            clone_template_failed: 'Epäonnistui: clone malli. Yritä uudelleen.',
            update_status_failed: 'Epäonnistui: update tila. Yritä uudelleen.',
            deprecate_template_failed: 'Epäonnistui: deprecate malli. Yritä uudelleen.',
            seed_defaults_failed: 'Epäonnistui: seed defaults. Yritä uudelleen.',
            fetch_regulator_exports_failed: 'Epäonnistui: fetch regulator exports. Yritä uudelleen.',
            create_regulator_export_failed: 'Epäonnistui: create regulator export. Yritä uudelleen.',
            update_submission_status_failed: 'Epäonnistui: update submission tila. Yritä uudelleen.',
            fetch_response_metrics_failed: 'Epäonnistui: fetch response metrics. Yritä uudelleen.',
            fetch_sla_dashboard_failed: 'Epäonnistui: fetch SLA kojelauta. Yritä uudelleen.',
            fetch_sla_definitions_failed: 'Epäonnistui: fetch SLA definitions. Yritä uudelleen.',
            create_sla_definition_failed: 'Epäonnistui: create SLA definition. Yritä uudelleen.',
            seed_sla_defaults_failed: 'Epäonnistui: seed SLA defaults. Yritä uudelleen.',
            fetch_vendor_coordination_failed: 'Epäonnistui: fetch toimittaja coordination. Yritä uudelleen.',
            fetch_vendor_detail_failed: 'Epäonnistui: fetch toimittaja detail. Yritä uudelleen.',
            create_vendor_coordination_failed: 'Epäonnistui: create toimittaja coordination. Yritä uudelleen.',
            add_communication_failed: 'Epäonnistui: add communication. Yritä uudelleen.',
            add_info_request_failed: 'Epäonnistui: add info request. Yritä uudelleen.',
            add_action_request_failed: 'Epäonnistui: add toiminto request. Yritä uudelleen.',
        },
        nav: {
            playbooks: 'Toimintaohjeiden mallipohjat',
            sla_definitions: 'SLA-määritelmät',
            sla_dashboard: 'SLA-kojelauta',
            escalation_log: 'Eskalointiloki',
            regulator_exports: 'Viranomaisviennit',
            deadlines: 'Ilmoitus Deadlines',
            vendor_coordination: 'Toimittajakoordinointi',
            metrics: 'Vastemittarit',
            playbook_links: 'Toimintaohjelinkit',
            regulatory_sla: 'Sääntelyllinen SLA',
            coordination_dashboard: 'Koordinointi',
            evidence_chain: 'Todisteketju',
            post_review: 'Jälkiarviointi',
        },
        playbooks: {
            page_title: 'Ohjekirjan mallit',
            activations_page_title: 'Ohjekirjan aktivointi',
            title: 'Toimintaohjeiden mallipohjat',
            new: 'Uusi Malli',
            seed_defaults: 'Alusta Oletus',
            scenario_type: 'Skenaariotyyppi',
            severity_applicability: 'Vakavuus Applicability',
            all_scenario_types: 'Kaikki skenaariotyypit',
            new_playbook: 'Uusi Toimintasuunnitelma Malli',
            clone: 'Kloonaa',
            clone_template: 'Kloonaa Malli',
            template_name: 'Malli nimi',
            deprecate: 'Vanhenna',
            confirm_deprecate: 'Vanhenna malli "{name}"?',
            create_template: 'Luo Malli',
            update_status: 'Päivitä tila',
            no_templates: 'Ei playbook mallit löytynyt',
            deactivation_reason_placeholder: 'Syy käytöstä poistoon...',
            description_placeholder: 'Toimintasuunnitelma kuvaus...',
            name_placeholder: 'Toimintasuunnitelma nimi...',
        },
        sla_definitions: {
            page_title: 'SLA-määrittelyt',
            title: 'SLA-määritelmät',
            new: 'Uusi SLA Määritelmä',
            sla_name: 'SLA Nimi',
            target_hours: 'Tavoite Hours',
            escalation_after: 'Eskalaatio After',
            applies_to: 'Koskee',
            no_definitions: 'Ei sla definitions found. löytynyt',
            target_value_placeholder: 'Tavoite value',
            name_placeholder: 'SLA nimi...',
            threshold_hours_label: 'Kynnystunnit',
            severity_label: 'Vakavuusaste',
            all_types: 'Kaikki tyypit',
            all_severities: 'Kaikki vakavuusasteet',
            default_label: 'Oletus',
        },
        sla_dashboard: {
            compliant: 'Yhteensopiva',
            page_title: 'SLA-näkymä',
            title: 'SLA-kojelauta',
            loading: 'Ladataan sla tiedot...',
            compliance_rate: 'Vaatimustenmukaisuus Taso',
            breached: 'Rikottu',
            at_risk: 'At Riski',
            on_track: 'Aikataulussa',
            by_severity: 'By Vakavuus',
            total_records: 'Tietueiden määrä',
            met: 'Täytetty',
            sla_records: 'SLA-tietueet',
            sla_reference: 'SLA-viite',
            record_id: 'Tietue-ID',
            metric_type: 'Mittarityyppi',
            severity: 'Vakavuus',
            elapsed: 'Kulunut',
            clock_start: 'Kellon aloitus',
        },
        escalation_log: {
            page_title: 'Eskalointiloki',
            title: 'Eskalointiloki',
            incident_id: 'Vaaratilanteita Tunniste',
            escalated_by: 'Eskaloitu By',
            escalated_to: 'Eskaloitu To',
            reason: 'Syy',
            escalated_at: 'Eskaloitu At',
            no_escalations: 'Ei escalations found. löytynyt',
            filter_incident_id: 'Suodata by Vaaratilanteita Tunniste',
            escalation_id: 'Eskalointi-ID',
            level: 'Taso',
            level_range: 'Taso (L1–L4)',
            create_escalation: 'Luo eskalointi',
            incident_id_placeholder: 'esim. INC-001',
            target_role_placeholder: 'esim. dpo, incident_manager',
            select_placeholder: '— valitse —',
        },
        regulator_exports: {
            page_title: 'Viranomaisviennit',
            title: 'Viranomaisviennit',
            new: 'Uusi Vie',
            incident_id: 'Vaaratilanteita Tunniste',
            regulator: 'Valvontaviranomainen',
            export_format: 'Muoto',
            exported_at: 'Viety',
            no_exports: 'Ei regulator exports found. löytynyt',
            enter_incident_id: 'Syötä vaaratilanteita tunniste',
            export_id: 'Vienti-ID',
            watermark: 'Vesileima',
            submission_status: 'Lähetystila',
            all_jurisdictions: 'Kaikki lainkäyttöalueet',
            no_transitions: 'Ei muita siirtymiä saatavilla kohteesta',
            select_new_status: '— valitse uusi tila —',
            sections_included: 'Sisällytetyt osiot',
            form_classification: 'Luokittelu',
            submission_channel: 'kanava',
        },
        deadlines: {
            title: 'Ilmoitus Deadlines',
            incident_id: 'Vaaratilanteita Tunniste',
            deadline: 'Määräaika',
            regulator: 'Valvontaviranomainen',
            remaining: 'jäljellä',
            no_deadlines: 'Ei notification deadlines found. löytynyt',
        },
        vendor_coordination: {
            page_title: 'Toimittajakoordinointi',
            title: 'Toimittajakoordinointi',
            new: 'Uusi Koordinointi',
            incident_id: 'Vaaratilanteita Tunniste',
            vendor_name: 'Toimittajan nimi',
            contact: 'Yhteyshenkilö',
            coordination_status: 'Koordinointi Tila',
            no_items: 'Ei toimittaja coordination items found. löytynyt',
            assessment_placeholder: 'Initial arviointi from toimittaja...',
            coordination_id: 'Koordinointitunnus',
            communications: 'Viestintä',
            info_requests: 'Tietopyynnöt',
            action_requests: 'Toimenpidepyynnöt',
            direction: 'Suunta',
            channel_label: 'Kanava',
            no_transitions: 'Ei lisäsiirtymiä saatavilla.',
            vendor_ref_number: 'Viitenumero',
            report_date: 'Raporttipäivä',
            contact_email: 'Sähköposti',
            contact_phone: 'Puhelin',
            channel_email: 'Sähköposti',
            channel_meeting: 'Kokous',
            channel_phone: 'Puhelin',
            channel_portal: 'Portaali',
            incident_id_placeholder: 'Suodata by Vaaratilanteita Tunniste...',
            priority_critical: 'Kriittinen',
            priority_high: 'Korkea',
            priority_low: 'Low',
            priority_medium: 'Keskitaso',
            vendor_id_placeholder: 'Suodata by Toimittaja Tunniste...',
            description_placeholder: 'Kuvaus...',
            filter_vendor_id: 'Suodata by Toimittaja Tunniste',
            inbound: 'Saapuva',
            outbound: 'Lähtevä',
            summary_placeholder: 'Yhteenveto...',
            priority_label: 'Prioriteetti',
            due_date_label: 'Eräpäivä',
            info_request_desc: 'Tietopyynnön kuvaus',
            action_request_desc: 'Toimintopyynnön kuvaus',
            content_label: 'Sisältö',
            select_incident: 'Valitse tapaus',
            select_vendor: 'Valitse Toimittaja',
            discovery_date: 'Discovery Päivämäärä',
        },
        metrics: {
            page_title: 'Vastausmittarit',
            title: 'Vastemittarit',
            loading: 'Ladataan metrics tiedot...',
            avg_response_time: 'Avg Vastaus Aika',
            avg_resolution_time: 'Avg Resolution Aika',
            total_incidents: 'Vaaratilanteet yhteensä',
            by_severity: 'By Vakavuus',
            by_status: 'By Tila',
            trend: 'Trendi',
            start_sla_clock: 'Käynnistä SLA-kello',
            sla_records: '[[TOK_0]] Records',
            no_sla_records: 'Ei SLA-tietueita vielä.',
            record_id: 'Tietueen tunnus',
            severity: 'Vakavuus',
            progress: 'Edistyminen',
            incident_id_required: 'Häiriö-ID on pakollinen',
            sla_definition_required: 'SLA-määrittely on pakollinen',
            metric_type_required: 'Mittarityyppi on pakollinen',
            threshold_required: 'Kynnystunnit ovat pakollisia',
            sla_clock_started: 'SLA-kello käynnistetty',
            sla_definition: 'SLA-määrittely',
            no_definitions: 'SLA-määrittelyjä ei löytynyt.',
            select_definition: 'Valitse SLA-määrittely...',
            select_metric_type: 'Valitse mittarityyppi...',
            select_severity: 'Valitse vakavuusaste...',
            threshold_hours: 'Kynnys (tunnit)',
            warning_threshold_pct: 'Varoituskynnys (%)',
            start_clock: 'Käynnistä kello',
            starting: 'Käynnistetään...',
            metric_label: 'Mittari',
            value_label: 'Arvo',
            incident_id: 'Häiriö-ID',
            threshold_placeholder: 'esim. 24',
            metric_types: {
                triage_time: 'Lajitteluaika',
                containment_time: 'Rajoittamisaika',
                notification_time: 'Ilmoitusaika',
                resolution_time: 'Ratkaisuaika',
            },
            severities: {
                critical: 'Kriittinen',
                high: 'Korkea',
                medium: 'Keskitaso',
                low: 'Low',
            },
        },
        playbook_links: {
            page_title: 'Playbook-linkit',
            title: 'Toimintaohje-ilmoituslinkit',
            new_link: 'Linkitä toimintaohje ilmoitukseen',
            activation_id: 'Aktivointitunnus',
            notification_id: 'Ilmoitustunnus',
            select_activation: 'Valitse aktivointi...',
            select_notification: 'Valitse ilmoitus...',
            no_links: 'Ei toimintaohjelinkkejä löytynyt',
            seed_pdpl: 'Alusta PDPL-toimintaohjeet',
            created: 'Ohjekirjan linkki luotu',
            seeded: '[[TOK_0]] leikkikirjaa',
            create_failed: 'Pelikirjan linkin luominen epäonnistui',
            seed_failed: '[[TOK_0]] leikkikirjan siemennys epäonnistui',
        },
        regulatory_sla: {
            page_title: 'Sääntelylliset SLA-yhdistämiset',
            title: 'Sääntelylliset SLA-kohdistukset',
            new_mapping: 'Uusi SLA-kohdistus',
            sla_definition: 'SLA-määritelmä',
            select_sla_definition: 'Valitse SLA-määritelmä...',
            framework_code: 'Viitekehyskoodi',
            deadline_type: 'Määräaikatyyppi',
            deadline_hours: 'Määräaika tunteina',
            auto_escalate: 'Automaattinen eskalointi',
            seed_pdpl: 'Alusta PDPL-oletukset',
            no_mappings: 'Ei sääntelyllisiä SLA-kohdistuksia löytynyt',
            dashboard: 'Sääntelyllinen SLA-kojelauta',
            deadline_types: {
                initial_notification: 'Ensimmäinen ilmoitus',
                supplement_response: 'Täydennysvastaus',
                authority_response: 'Viranomaisen vastaus',
                remediation_report: 'Korjausraportti',
            },
            statutory_reference: 'Lakisääteinen viite',
        },
        coordination_dashboard: {
            page_title: 'Koordinointinäkymä',
            title: 'Koordinointikojelauta',
            incident_id: 'Vaaratilanne-tunnus',
            select_incident: 'Valitse häiriö...',
            team_role: 'Tiimirooli',
            members: 'Jäsenet',
            tasks: 'Tehtävät',
            sla_status: 'SLA-tila',
            no_teams: 'Ei koordinointitiimejä löytynyt',
            new_team: 'Uusi koordinointitiimi',
            enter_incident_id: 'Syötä häiriö-ID nähdäksesi koordinointitiimit.',
            member_ids_placeholder: 'käyttäjä1, käyttäjä2',
            edit_team: 'Muokkaa tiimiä',
            task_count: 'Tehtävien määrä',
            tasks_completed: 'Valmis',
            team_roles: {
                security: 'Tietoturva',
                legal: 'Oikeudellinen',
                it: 'IT',
                management: 'Johto',
                department_owner: 'Osaston omistaja',
                external: 'Ulkoinen',
            },
        },
        evidence_chain: {
            page_title: 'Todisteketju',
            title: 'Todisteketju',
            new_entry: 'Uusi todistemerkintä',
            select_incident: 'Valitse häiriö...',
            actor: 'Toimija',
            select_actor: 'Valitse toimija...',
            evidence_id: 'Todistetunnus',
            action: 'Toiminto',
            recipient: 'Vastaanottaja',
            no_entries: 'Ei todisteketjumerkintöjä löytynyt',
            enter_incident_id: 'Syötä häiriö-ID nähdäksesi todisteketju.',
            evidence_id_placeholder: 'esim. EVD-2026-0001',
            evidence_id_help: 'Yksilöllinen viite todistusaineistolle – lokitiedosto, levykuva tai kuvakaappaus. Ehdotus on täytetty valmiiksi; muokkaa se vastaamaan todisteluetteloasi.',
            select_incident_first: 'Valitse yllä oleva häiriö ennen todistemerkinnän lisäämistä.',
            for_incident: 'Häiriölle',
            actions: {
                collected: 'Kerätty',
                shared: 'Jaettu',
                exported: 'Vietiin',
                archived: 'Arkistoitu',
            },
        },
        post_review: {
            page_title: 'Jälkihäiriötarkastus',
            title: 'Jälkiarviointi',
            new_review: 'Uusi arviointi',
            select_incident: 'Valitse häiriö...',
            lessons_learned: 'Opitut asiat',
            recommendations: 'Suositukset',
            improvement_actions: 'Parannustoimenpiteet',
            submit_for_review: 'Lähetä arvioitavaksi',
            aria_submit_review: 'Lähetä arviointi {name} arvioitavaksi',
            aria_sign_off: 'Hyväksy arviointi {name}',
            sign_off: 'Hyväksyntä',
            no_reviews: 'Ei jälkiarviointeja löytynyt',
            enter_incident_id: 'Syötä häiriö-ID nähdäksesi jälkihäiriötarkastus.',
            one_per_line: 'Yksi per rivi',
            statuses: {
                draft: 'Luonnos',
                in_review: 'Arvioitavana',
                signed_off: 'Hyväksytty',
                closed: 'Suljettu',
            },
        },
        activations: {
            title: 'Ohjekirjan aktivointi',
            activation_id: 'Aktivointitunnus',
            phases: 'Vaiheet',
            activated_at: 'Aktivoitu klo',
            activated_by: 'Aktivoi',
            deactivate: 'Poista käytöstä',
            complete: 'Valmis',
            deactivation_reason: 'Deaktivoinnin syy',
            evidence_button: 'Todisteet',
            evidence_modal_title: 'Aktivointitodistus',
            no_evidence: 'Tälle aktivoinnille ei ole liitetty todisteita.',
            upload_evidence_label: 'Lataa aktivointitodistus',
        },
    },
    program_governance: {
        maturity_walkthrough: {
            run_label: 'Kävele minua aukkojen läpi',
            running: 'Kävelyvälit…',
            results_heading: 'Parannussuunnitelma ([[TOK_2]] aukko[[TOK_3]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            no_gaps: 'Aukkoja ei havaittu – kaikki verkkotunnukset tavoitteessa tai sen yläpuolella.',
            col_priority: 'Prioriteetti',
            col_domain: 'Verkkotunnus',
            col_levels: 'Nykyinen → Kohde',
            col_severity: 'Vakavuus',
            col_actions: 'Korjaustoimenpiteet',
            citations_label: 'Lainaukset',
            accept_label: 'Hyväksy tiekartta',
            reject_label: 'Hylkää luonnos',
            export_label: 'Vie [[TOK_0]]',
            exported_label: 'Tiekartta viety',
            accept_hint: 'Hyväksy tallentaa etenemissuunnitelman säilytetylle luonnokselle. Käytä Export [[TOK_0]] luodaksesi tulos. operaattori liittää takaisin improvement_actions arviointiin.',
            resolve_summary: 'Päätöslauselma: [[TOK_1]]',
            error_generic: 'Aukon läpikulkua ei voitu suorittaa. Yritä uudelleen tai tarkista arvioinnin tila.',
        },
        policy_gap: {
            run_label: 'Havaitse politiikan aukot',
            running: 'Havaitaan aukkoja…',
            results_heading: 'Käytäntöaukot ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            no_gaps: 'Kattavuusaukkoja ei havaittu.',
            col_severity: 'Vakavuus',
            col_kind: 'Ystävällinen',
            col_clause: 'Lause / vaatimus',
            kind_missing: 'Lause puuttuu',
            kind_weak: 'Heikko peitto',
            kind_stale: 'Vanhentunut (arvostelu myöhässä)',
            remediation_label: 'Ehdotettu korjaus',
            citations_label: 'Lainaukset',
            accept_label: 'Hyväksy aukkoraportti',
            reject_label: 'Hylkää raportti',
            export_label: 'Vie [[TOK_0]]',
            accept_hint: 'Hyväksy tallentaa säilytetyn luonnoksen aukkoraportin. Käytä Export [[TOK_0]] käytäntöjen tarkastusraportin luomiseen. operaattori tekee varsinaisen käytäntömuokkauksen.',
            resolve_summary: 'Päätöslauselma: [[TOK_1]]',
            error_generic: 'Käytäntöaukkoja ei voitu havaita. Yritä uudelleen tai tarkista asiakirjan tila.',
        },
        remediation_plan_generator: {
            run_label: 'Luo suunnitelma aukoista',
            running: 'Luodaan suunnitelmaa…',
            results_heading: 'Korjaussuunnitelma ([[TOK_2]] vaihe[[TOK_3]]',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            phase_label: 'Vaihe [[TOK_1]]',
            window_label: 'Ikkuna',
            owner_label: 'Omistajan rooli',
            evidence_label: 'Vaaditut todistetyypit',
            tasks_label: 'Tehtävät',
            no_phases: 'Vaiheita ei synny – tulovälisarja voi olla tyhjä.',
            citations_label: 'Lainaukset',
            accept_label: 'Hyväksy suunnitelma',
            reject_label: 'Hylkää suunnitelma',
            export_label: 'Vie [[TOK_0]]',
            accept_hint: 'Hyväksy luo suunnitelmatietueeseen linkitetyt vaihetehtävät. Käytä Export [[TOK_0]] saadaksesi koko toimituksen. Omistajaroolin paikkamerkit tarvitsevat operaattorin seurantaa.',
            resolve_summary: 'Ratkaisu: [[TOK_2]] · [[TOK_3]] tehtävä(t) luotu',
            error_generic: 'Korjaussuunnitelmaa ei voitu luoda. Yritä uudelleen tai tarkista aukko-asetettu tulo.',
            source_picker_label: 'lähde',
            source_all: 'Kaikki',
            source_consent: 'Suostumuksen erojen analyysi',
            source_policy: 'Käytäntöaukon havaitseminen',
            source_vendor: 'Toimittajan perehdytys',
            load_upstream_label: 'Kuorma ylävirrasta',
            loading_upstream: 'Ladataan…',
            upstream_count: '[[TOK_1]] aukko(t) ladattu',
        },
        nav: {
            maturity_models: 'Kypsyysmallit',
            maturity_assessments: 'Kypsyysarvioinnit',
            trend_dashboard: 'Trendikojelauta',
            reporting_periods: 'Raportointikaudet',
            executive_summaries: 'Johdon yhteenvedot',
            audit_readiness: 'Tarkastusvalmius',
            evidence_gaps: 'Todistusaukot',
            program_health: 'Ohjelman tila',
            obligation_mappings: 'Velvoitekartoitukset',
            governance_documents: 'Hallintodokumentit',
            remediation_plans: 'Korjaussuunnitelmat',
            governance_model: 'Hallintomalli',
            document_drafting: 'Asiakirjan luonnostelu',
            document_issuance: 'Asiakirjan julkaisu',
            acknowledgment_tracking: 'Kuittausseuranta',
            change_log: 'Muutosloki',
            review_cadence: 'Tarkistuskadenssi',
        },
        maturity_models: {
            title: 'Kypsyysmallit',
            new: 'Uusi Model',
            seed_defaults: 'Alusta Oletus',
            domains: 'Verkkotunnukset',
            activate: 'Aktivoi',
            no_models: 'Ei maturity models löytynyt',
            new_maturity_model: 'Uusi Kypsyys Model',
            create_model: 'Luo Model',
            load_error: 'Kypsyysmallien lataus epäonnistui. Yritä uudelleen.',
            create_error: 'Kypsyysmallin luonti epäonnistui',
            status_error: 'Mallin tilan päivitys epäonnistui',
            seed_error: 'Oletusarvojen luonti epäonnistui',
            aria_seed_defaults: 'Luo oletuskypsyysmallit',
            aria_create_new: 'Luo uusi kypsyysmalli',
            loading_sr: 'Ladataan kypsyysmalleja',
            model_name_placeholder: 'esim., Tietosuojan kypsyysmalli',
            status_changed: 'Mallin tila muutettu tilaan {status}',
        },
        maturity_assessments: {
            title: 'Kypsyysarvioinnit',
            new: 'Uusi Arviointi',
            model: 'Malli',
            assessor: 'Arvioija',
            overall_score: 'Kokonaispistemäärä',
            overall_score_help: 'Painotettu kypsyysarvio välillä 0–5, joka lasketaan automaattisesti, kun arviointi viimeistellään. Kasvata sitä pisteyttämällä kukin osa-alue korkeammalle arvioinnin aikana ja viemällä arviointi sitten vaiheiden Lähetä tarkistettavaksi → Viimeistele läpi.',
            assessed_at: 'Arvioitu',
            no_assessments: 'Ei maturity arviointi found. löytynyt',
            load_error: 'Kypsyysarviointien lataus epäonnistui. Yritä uudelleen.',
            create_error: 'Arvioinnin luonti epäonnistui',
            start_error: 'Arvioinnin aloitus epäonnistui',
            archive_error: 'Arvioinnin arkistointi epäonnistui',
            eval_error: 'Arvioinnin lataus arviointia varten epäonnistui',
            eval_min_score: 'Arvioi vähintään yksi toimialue',
            eval_save_error: 'Toimialuearviointien tallennus epäonnistui',
            review_error: 'Lähetys tarkistettavaksi epäonnistui',
            finalize_error: 'Arvioinnin viimeistely epäonnistui',
            start: 'Aloita',
            start_confirm_title: 'Aloita arviointi',
            start_confirm_message: 'Haluatko varmasti aloittaa tämän arvioinnin?',
            archive_confirm_title: 'Arkistoi arviointi',
            archive_confirm_message: 'Haluatko varmasti arkistoida tämän arvioinnin?',
            evaluate_domains: 'Arvioi',
            evaluate_domains_title: 'Arvioi toimialueet',
            submit_for_review: 'Lähetä tarkistettavaksi',
            finalize: 'Viimeistele',
            archive: 'Arkistoi',
            all_reviewers: 'Kaikkien tarkastajien on hyväksyttävä',
            any_reviewer: 'Kuka tahansa tarkastaja voi hyväksyä',
            select_level: 'Valitse kypsyystaso...',
            findings_placeholder: 'Havainnot, muistiinpanot, todistusviitteet...',
            no_domains: 'Tälle mallille ei löytynyt toimialueita.',
        },
        trend_dashboard: {
            title: 'Trendikojelauta',
            loading: 'Ladataan trend tiedot...',
            score_trend: 'Pistemäärä Trendi',
            domain_comparison: 'Verkkotunnus Comparison',
            period: 'Kausi',
            load_error: 'Trendiyhteenvedon lataus epäonnistui. Yritä uudelleen.',
            metrics_load_error: 'Trendimittareiden lataus epäonnistui. Yritä uudelleen.',
            module: 'Moduuli',
            metric: 'Mittari',
            value: 'Arvo',
            trend: 'Trendi',
            aria_filters: 'Trendimittareiden suodattimet',
            showing_chart: 'Näytetään kaavionäkymä',
            showing_table: 'Näytetään taulukonäkymä',
        },
        reporting_periods: {
            title: 'Raportointikaudet',
            new: 'Uusi Kausi',
            period_name: 'Kausi Nimi',
            start_date: 'Aloituspäivä',
            end_date: 'Päättymispäivä',
            no_periods: 'Ei reporting periods found. löytynyt',
            load_error: 'Raportointijaksojen lataus epäonnistui. Yritä uudelleen.',
            create_error: 'Raportointijakson luonti epäonnistui',
            auto_generate_error: 'Raportointijaksojen automaattinen luonti epäonnistui',
            status_error: 'Jakson tilan päivitys epäonnistui',
            start_collecting: 'Aloita keräys',
            mark_as_draft: 'Merkitse luonnokseksi',
            submit_for_review: 'Lähetä tarkistettavaksi',
            publish: 'Julkaise',
            auto_generate: 'Luo raportointijaksot automaattisesti',
            period_label_placeholder: 'esim., Q1 2026',
            status_updated: 'Jakson tila päivitetty',
        },
        executive_summaries: {
            title: 'Johdon yhteenvedot',
            new: 'Uusi Yhteenveto',
            period: 'Kausi',
            generated_at: 'Luotu',
            generated_by: 'Luonut',
            no_summaries: 'Ei executive summaries found. löytynyt',
            generate: 'Luo',
            load_error: 'Johdon yhteenvetojen lataus epäonnistui. Yritä uudelleen.',
            generate_error: 'Johdon yhteenvedon luonti epäonnistui',
            save_error: 'Johdon yhteenvedon tallennus epäonnistui',
        },
        audit_readiness: {
            title: 'Tarkastusvalmius',
            loading: 'Ladataan tarkastus readiness tiedot...',
            overall_readiness: 'Kokonaisvalmius',
            by_domain: 'By Verkkotunnus',
            evidence_coverage: 'Todistusaineisto Kattavuus',
            gaps: 'Puutteet',
            load_error: 'Viimeisimmän valmiuden lataus epäonnistui. Yritä uudelleen.',
            history_error: 'Valmiushistorian lataus epäonnistui. Yritä uudelleen.',
            calculate_error: 'Auditoinnin valmiuden laskenta epäonnistui',
            aria_recalculate: 'Laske auditoinnin valmiuspisteet uudelleen',
            aria_current_readiness: 'Nykyinen auditoinnin valmius',
            aria_history: 'Valmiuspisteiden historia',
            recalculated: 'Auditoinnin valmius laskettu uudelleen',
            loading_sr: 'Ladataan auditoinnin valmiustietoja',
        },
        evidence_gaps: {
            title: 'Todistusaukot',
            domain: 'Verkkotunnus',
            control: 'Hallinta',
            gap_type: 'Puutetyyppi',
            severity: 'Vakavuus',
            no_gaps: 'Ei todistusaineisto puute found. löytynyt',
            load_error: 'Todistusaukkojen lataus epäonnistui. Yritä uudelleen.',
            stats_error: 'Aukkotilastojen lataus epäonnistui. Yritä uudelleen.',
            create_error: 'Todistusaukon luonti epäonnistui',
            update_error: 'Todistusaukon päivitys epäonnistui',
            status_error: 'Tilan päivitys epäonnistui',
            aria_create_new: 'Luo uusi todistusaukko',
            aria_statistics: 'Todistusaukkotilastot',
            loading_sr: 'Ladataan todistusaukkoja',
            status_updated: 'Aukon tila päivitetty',
            entity_type_placeholder: 'esim., toimittaja, järjestelmä',
            all_modules: 'Kaikki alueet',
            all_severities: 'Kaikki vakavuudet',
        },
        program_health: {
            title: 'Ohjelman tila',
            loading: 'Ladataan program health tiedot...',
            overall_health: 'Overall Terveys',
            by_module: 'By Moduuli',
            risk_areas: 'Riski Areas',
            recommendations: 'Suositukset',
            load_error: 'Ohjelman terveystietojen lataus epäonnistui. Yritä uudelleen.',
            aria_key_metrics: 'Ohjelman terveyden avainmittarit',
            aria_module_scorecard: 'Moduulin tuloskortin erittely',
            loading_sr: 'Ladataan ohjelman terveystietoja',
            trending_up: 'Nouseva trendi',
            trending_down: 'Laskeva trendi',
            trending_stable: 'Vakaa',
            data_loaded: 'Ohjelman terveystiedot ladattu',
        },
        obligation_mappings: {
            title: 'Velvoitekartoitukset',
            create_mapping: 'Luo velvoitekartoitus',
            framework: 'Viitekehys',
            select_framework: 'Valitse viitekehys...',
            obligation: 'Velvoite',
            obligation_ref: 'Velvoiteviite',
            obligation_description: 'Velvoitteen kuvaus',
            role: 'Rooli',
            assigned_role: 'Määrätty rooli',
            assigned_department: 'Määrätty osasto',
            select_department: 'Valitse osasto...',
            control_ids: 'Kontrolli-ID:t',
            raci_assignments: 'RACI-kohdistukset',
            create_raci: 'Luo RACI-kohdistus',
            activity: 'Toiminto',
            activity_name: 'Toiminnon nimi',
            activity_description: 'Toiminnon kuvaus',
            responsible: 'Vastuullinen',
            select_users: 'Valitse käyttäjät...',
            accountable: 'Tilivelvollinen',
            select_user: 'Valitse käyttäjä...',
            consulted: 'Konsultoitu',
            informed: 'Tiedotettu',
            review_frequency: 'Tarkastustiheys',
            frequency_monthly: 'Kuukausittain',
            frequency_quarterly: 'Neljännesvuosittain',
            frequency_semi_annual: 'Puolivuosittain',
            frequency_annual: 'Vuosittain',
            no_mappings_found: 'Velvoitekartoituksia ei löytynyt.',
            no_raci_found: 'RACI-kohdistuksia ei löytynyt.',
            mapping_created: 'Velvoitemääritys luotu',
            mapping_updated: 'Velvoitekartoitus päivitetty',
            mapping_deleted: 'Velvoitekartoitus poistettu',
            raci_created: 'RACI-tehtävä luotu',
            raci_updated: 'RACI-kohdistus päivitetty',
            raci_deleted: 'RACI-kohdistus poistettu',
            aria_edit_mapping: 'Muokkaa kartoitusta {name}',
            aria_delete_mapping: 'Poista kartoitus {name}',
            aria_edit_raci: 'Muokkaa RACI {name}',
            aria_delete_raci: 'Poista RACI {name}',
            confirm_delete_mapping: 'Poista tämä velvoitekartoitus?',
            confirm_delete_raci: 'Poista tämä RACI-kohdistus?',
            table_view: 'Taulukkonäkymä',
            matrix_view: 'Matriisiinäkymä',
            print_export: 'Tulosta / Vie',
            filter_framework: 'Suodata viitekehyksen mukaan',
            no_matrix_data: 'Ei RACI-osoituksia näytettäväksi matriisiinäkymässä.',
            aria_print_export: 'Tulosta tai vie RACI-matriisi',
        },
        governance_documents: {
            title: 'Hallintodokumentit',
            create_document: 'Luo hallintodokumentti',
            document_title: 'Dokumentin otsikko',
            document_type: 'Dokumenttityyppi',
            content_url: 'Sisältö-URL',
            content_url_placeholder: 'https://...',
            framework_codes: 'Viitekehyskoodit',
            select_frameworks: 'Valitse viitekehykset...',
            effective_date: 'Voimaantulopäivä',
            review_date: 'Tarkastuspäivä',
            status: 'Tila',
            version: 'Versio',
            acknowledgments: 'Kuittaukset',
            acknowledge: 'Kuittaa',
            acknowledged_by: 'Kuitannut',
            department: 'Osasto',
            no_documents_found: 'Hallintodokumentteja ei löytynyt.',
            draft: 'Luonnos',
            review: 'Tarkistus',
            approved: 'Hyväksytty',
            issued: 'Julkaistu',
            superseded: 'Korvattu',
            document_created: 'Asiakirja luotu',
            document_acknowledged: 'Asiakirja kuitattu',
            policy: 'Käytäntö',
            procedure: 'Menettely',
            standard: 'Standardi',
            guideline: 'Ohje',
        },
        governance_model: {
            title: 'Hallintomalli',
            create_model: 'Hallintomalli',
            edit_model: 'Hallintomalli',
            model_name: 'Model',
            description: 'Kuvaus',
            governance_type: 'Type',
            type_centralized: 'Keskitetty',
            type_federated: 'Liittynyt',
            type_hybrid: 'Hybridi',
            framework_codes: 'Framework',
            select_frameworks: '...',
            review_frequency: 'Frequency',
            freq_monthly: 'Kuukausittain',
            freq_quarterly: 'Neljännesvuosittain',
            freq_semi_annual: 'Puolivuosittain',
            freq_annual: 'Vuosittainen',
            committees: 'komiteat',
            committee_name: 'Name',
            committee_members: 'Members',
            committee_mandate: 'Mandaatti',
            add_committee: '+',
            no_committees: '—',
            delegation_rules: 'Delegation',
            from_role: 'From',
            to_role: 'To',
            scope: 'Laajuus',
            add_delegation_rule: '+',
            control_owner_summary: 'RACI',
            no_raci_data: '—',
            activity: 'Toiminta',
            responsible: 'R',
            accountable: 'A',
            consulted: 'C',
            informed: 'I',
            no_models_found: '—',
            model_created: 'OK',
            model_updated: 'OK',
            model_deleted: 'OK',
            confirm_delete: '?',
            expand: '+',
            collapse: '-',
            aria_expand: '{name}',
            aria_edit: '{name}',
            aria_delete: '{name}',
            aria_export_csv: '{name} CSV',
            aria_export_json: '{name} JSON',
            framework_read_permission_warning: 'Tarvitset regulatory_framework:lukuoikeuden kehysten valitsemiseen. Pyydä järjestelmänvalvojaa myöntämään se.',
            select_members: 'Valitse toimikunnan jäsenet',
            select_from_role: 'Valitse delegoiva rooli',
            select_to_role: 'Valitse vastaanottava rooli',
            mandate_markdown_hint: 'Tuettu merkintä: **lihavoitu**, luettelot, linkit.',
            scope_tab_obligation: 'Velvollisuus',
            scope_tab_framework: 'viitekehys',
            scope_tab_free_text: 'Vapaa teksti',
            select_obligation: 'Valitse velvoite',
            select_framework: 'Valitse kehys',
            aria_remove_committee: 'Poista komitea {n}',
            aria_remove_delegation_rule: 'Poista delegointisääntö {n}',
            no_frameworks_available: 'Ei kehyksiä saatavilla. Lisää ensin sääntelykehykset.',
        },
        document_drafting: {
            title: 'Asiakirjan luonnostelu',
            document_title: 'Document',
            document_type: 'Type',
            status: 'Tila',
            drafter: 'Luonnostelija',
            deadline: 'Määräaika',
            assign_drafter: 'Assign',
            select_drafter: '...',
            assign: 'Määritä',
            submit_for_review: 'Submit',
            legal_review: 'Review',
            reviewer: 'Arvostelija',
            select_reviewer: '...',
            comments: 'Kommentit',
            review_action: 'Action',
            approve: 'Hyväksy',
            request_changes: 'Pyydä muutoksia',
            submit_review: 'Submit',
            executive_approval: 'Approval',
            no_drafts_found: '—',
            drafter_assigned: 'OK',
            status_updated: 'OK',
            review_approved: 'OK',
            changes_requested: 'OK',
            document_approved: 'OK',
            aria_assign: '{name}',
            aria_submit_review: '{name}',
            aria_review: '{name}',
            aria_approve: '{name}',
        },
        document_issuance: {
            title: 'Asiakirjan julkaisu',
            document_title: 'Document',
            document_type: 'Type',
            status: 'Tila',
            version: 'Versio',
            effective_date: 'Date',
            distribution_scope: 'Distribution',
            distribution_placeholder: '...',
            issuance_number: 'Number',
            issuance_number_placeholder: 'ISS-2026-001',
            supersedes: 'Supersedes',
            none: '—',
            issue_document: 'Issue',
            ready_for_issuance: 'Ready',
            issued_documents: 'Issued',
            no_issued_documents: '—',
            view_lineage: 'Lineage',
            supersession_lineage: 'Supersession',
            document_issued: 'OK',
            document_superseded: 'OK',
            aria_issue: '{name}',
            aria_view_lineage: '{name}',
        },
        acknowledgment_tracking: {
            title: 'Kuittausseuranta',
            document_title: 'Asiakirja',
            acknowledged_count: 'Tunnustettu',
            pending_count: 'Odottaa',
            percentage: '%',
            details: 'Yksityiskohdat',
            send_reminder: 'Remind',
            acknowledgment_details: 'Details',
            user: 'Käyttäjä',
            department: 'osasto',
            acknowledged_at: 'Date',
            status: 'Tila',
            acknowledged: 'OK',
            no_issued_documents: '—',
            no_acknowledgments: '—',
            reminder_sent: 'OK',
            aria_expand: '{name}',
            aria_send_reminder: '{name}',
        },
        change_log: {
            title: 'Muutosloki',
            date: 'Päivämäärä',
            document: 'Asiakirja',
            change_type: 'Type',
            actor: 'näyttelijä',
            summary: 'Yhteenveto',
            export_csv: 'Vie [[TOK_0]]',
            filters: 'Filters',
            filter_document: 'Document',
            all_documents: 'All',
            filter_change_type: 'Type',
            all_types: 'All',
            date_from: 'From',
            date_to: 'To',
            version_history: 'History',
            version_archive: 'Archive',
            no_entries: '—',
            no_history: '—',
            exported: 'OK',
            aria_export: 'CSV',
            aria_view_history: '{name}',
        },
        review_cadence: {
            title: 'Tarkistuskadenssi',
            configure_cadence: 'Tarkistuskadenssi',
            edit_cadence: 'Tarkistuskadenssi',
            document: 'Asiakirja',
            select_document: '...',
            review_frequency: 'Frequency',
            freq_30: '30',
            freq_60: '60',
            freq_90: '90',
            freq_180: '180',
            freq_365: '365',
            last_reviewed: 'Last',
            next_review: 'Next',
            status: 'Tila',
            overdue: 'Myöhässä',
            on_track: 'OK',
            days: 'days',
            horizon: 'Horizon',
            overdue_warning: 'Overdue',
            overdue_count: '{count}',
            no_cadences: '—',
            cadence_created: 'OK',
            cadence_updated: 'OK',
            aria_edit: '{name}',
        },
        remediation_plans: {
            title: 'Korjaussuunnitelmat',
            create_plan: 'Luo korjaussuunnitelma',
            gap_id: 'Puuteviite',
            select_gap: 'Valitse puute...',
            plan_title: 'Otsikko',
            description: 'Kuvaus',
            priority: 'Prioriteetti',
            priority_critical: 'Kriittinen',
            priority_high: 'Korkea',
            priority_medium: 'Keskitaso',
            priority_low: 'Matala',
            assigned_to: 'Vastuuhenkilö',
            select_user: 'Valitse käyttäjä...',
            target_date: 'Tavoitepäivä',
            framework_code: 'Viitekehys',
            select_framework: 'Valitse viitekehys...',
            gap_finding: 'Puutehavainto',
            action_items: 'Toimenpiteet',
            owner: 'Omistaja',
            deadline: 'Määräaika',
            planned: 'Suunniteltu',
            in_progress: 'Käynnissä',
            completed: 'Valmis',
            verified: 'Vahvistettu',
            no_plans_found: 'Korjaussuunnitelmia ei löytynyt.',
            evidence: 'Todistusaineisto',
            plan_created: 'Korjaussuunnitelma luotu',
            action_items_hint: 'Toimenpiteet (yksi per rivi)',
        },
        statuses: {
            identified: 'Tunnistettu',
            assigned: 'Määrätty',
            in_remediation: 'Kohdassa Remediation',
            resolved: 'Ratkaistu',
            accepted_risk: 'Hyväksytty riski',
            planned: 'Suunniteltu',
            in_progress: 'Meneillään',
            under_review: 'Tarkistuksessa',
            finalized: 'Viimeistelty',
            archived: 'Arkistoitu',
            draft: 'Luonnos',
            active: 'Aktiivinen',
            upcoming: 'Tuleva',
            collecting: 'Keräily',
            published: 'Julkaistu',
            review: 'Tarkista',
            approved: 'Hyväksytty',
            issued: 'Myönnetty',
            superseded: 'Korvattu',
            completed: 'Valmis',
            verified: 'Vahvistettu',
        },
        severities: {
            critical: 'Kriittinen',
            high: 'Korkea',
            medium: 'Keskikokoinen',
            low: 'Low',
        },
        priorities: {
            critical: 'Kriittinen',
            high: 'Korkea',
            medium: 'Keskikokoinen',
            low: 'Low',
        },
        gap_types: {
            missing: 'Puuttuu',
            expired: 'Vanhentunut',
            insufficient: 'Riittämätön',
        },
        document_types: {
            policy: 'politiikka',
            procedure: 'Menettely',
            standard: 'Vakio',
            guideline: 'Ohje',
            template: 'Malli (sisäinen)',
        },
        maturity_levels: {
            level_1: 'Taso 1 – Alkuperäinen',
            level_2: 'Taso 2 – Kehittyvät',
            level_3: 'Taso 3 — määritelty',
            level_4: 'Taso 4 – Hallittu',
            level_5: 'Taso 5 – Optimointi',
        },
        grades: {
            excellent: 'Erinomainen',
            good: 'Hyvä',
            fair: 'Reilu',
            poor: 'Köyhä',
            critical: 'Kriittinen',
            needs_improvement: 'Tarvitsee parannusta',
            not_assessed: 'Ei arvioitu',
        },
        modules: {
            data_mapping: 'Tietojen kartoitus',
            consent: 'Suostumus',
            governance: 'Hallinto',
            incidents: 'Tapahtumat',
            monitoring: 'Valvonta',
            classification: 'Luokittelu',
            vendor_risk: 'Toimittajariski',
            discovery: 'Löytö',
            deletion: 'Poistaminen',
        },
        cadences: {
            monthly: 'Kuukausittain',
            quarterly: 'Neljännesvuosittain',
            semi_annual: 'Puolivuosittain',
            annual: 'Vuosittainen',
        },
        section_labels: {
            opening: 'Avaaminen',
            key_metrics: 'Keskeiset mittarit',
            highlights: 'Kohokohdat',
            concerns: 'Huoli',
            recommendations: 'Suositukset',
            outlook: 'Outlook',
        },
        out_of_100: '/ 100',
        count_gaps: '[[TOK_1]] ero',
        count_gaps_plural: '[[TOK_1]] aukkoja',
        count_summaries: '[[TOK_1]] yhteenveto',
        count_summaries_plural: '[[TOK_1]] yhteenvedot',
        count_assessments: '[[TOK_1]] arviointi',
        count_assessments_plural: '[[TOK_1]] arvioita',
        count_models: '[[TOK_1]] malli',
        count_models_plural: '[[TOK_1]] mallia',
        count_periods: '[[TOK_1]] ajanjaksolla',
        count_periods_plural: '[[TOK_1]] jaksoa',
        count_metrics: '[[TOK_1]] mittari',
        count_metrics_plural: '[[TOK_1]] mittareita',
        unknown_user: 'Tuntematon käyttäjä',
        unknown_gap: 'Tuntematon väli',
        no_permission_title: 'Riittämättömät käyttöoikeudet',
        no_permission_message: 'Sinulla ei ole lupaa käyttää tätä sivua.',
        ac_vn_frameworks_title: 'VN-kehyksen kattavuus',
        ac_vn_frameworks_body: 'Kypsyysarvioinnit kattavat kaikki kuusi Vietnamin sääntelykehystä: [[TOK_0]], tietolaki, televiestintälaki, kyberturvallisuuslaki, [[TOK_1]]-laki ja sähköisen kaupankäynnin laki – jokaisella on puitekohtaiset arviointikriteerit.',
        ac_controller_processor_title: 'Ohjain vs. prosessori',
        ac_controller_processor_body: 'Velvoitekartoitukset erottavat rekisterinpitäjän ja tietojen käsittelijän vastuut. Määritä roolit RACI-matriisin avulla varmistaaksesi, että jokaisella velvoitteella on selkeä omistaja riippumatta siitä, toimiiko organisaatio rekisterinpitäjänä vai käsittelijänä.',
        ac_versioned_evidence_title: 'Versioitu todisteet',
        ac_versioned_evidence_body: 'Jokainen tilasiirtymä (Luonnos, Tarkista, Hyväksytty, Myönnetty) luo aikaleimatun, versioidun tietueen, joka toimii tarkastettavissa olevana todisteena. Muutosloki tallentaa asiakirjan koko elinkaaren historian.',
        ac_remediation_gap_link_title: 'Liittyy arviointipuutteisiin',
        ac_remediation_gap_link_body: 'Jokainen kunnostussuunnitelma liittyy suoraan tunnistettuun arviointivajeeseen. Määritä omistaja ja aseta tavoitemääräaika seurataksesi ratkaisun etenemistä aukosta sulkemiseen.',
        ac_annual_attestation_title: 'Vuotuinen todistussykli',
        ac_annual_attestation_body: 'Raportointijaksot vastaavat Vietnamin tietolain vuotuista todistusvaatimusta. Käytä "Vuosittaista"-poljinta (365 päivän jakso) luodaksesi todistuksen mukaiset jaksot automaattisesti.',
        ac_evidence_per_obligation_title: 'Todistus puitevelvoitetta kohti',
        ac_evidence_per_obligation_body: 'Todisteiden puutteet osoittavat puuttuvat, vanhentuneet tai riittämättömät todisteet kustakin puitevelvollisuudesta. Suodata verkkotunnuksen mukaan nähdäksesi, mistä sääntelyvaatimuksista puuttuu todisteita.',
        ac_cross_framework_title: 'Kehysten välinen täydellisyys',
        ac_cross_framework_body: 'Tarkastusvalmius tarjoaa kehysten välisen täydellisyyden näkymän. Komponenttien pisteet heijastavat kattavuutta kaikissa kartoitetuissa viitekehyksessä ja korostavat alueita, jotka vaativat huomiota ennen auditointia.',
        ac_cadence_default_title: 'Oletusarvostelun poljinnopeus',
        ac_cadence_default_body: 'Oletusarvoinen tarkistustahti on 180 päivää. Myöhästyneet arvostelut merkitään automaattisesti. Säädä tiheyttä asiakirjaa kohden tarpeen mukaan – vaihtoehdot vaihtelevat 30–365 päivää.',
        ac_templates_internal_title: 'Mallin luokitus',
        ac_templates_internal_body: 'Mallit luokitellaan sisäisiksi asiakirjoiksi. Käytä "Malli" -dokumenttityyppiä uudelleenkäytettävien hallinta-artefaktien merkitsemiseen vain sisäiseen jakeluun.',
    },
    mcp_pending: {
        title: 'MCP — Odottavat kirjoitukset',
        subtitle: 'Ulkoiset Claude-asiakkaat ehdottavat kirjoituksia tässä. Hyväksy tai hylkää jokainen merkintä — Forseti suorittaa vasta järjestelmänvalvojan hyväksynnän jälkeen.',
        no_pending: 'Ei odottavia kirjoituksia.',
        col_tool: 'Työkalu',
        col_preview: 'Esikatselu',
        col_key: '[[TOK_0]]-näppäintä',
        col_requested: 'Pyydetty',
        col_expires: 'Vanhenee',
        col_status: 'Tila',
        status_pending: 'Odottaa',
        status_approved: 'Hyväksytty',
        status_declined: 'Hylätty',
        status_expired: 'Vanhentunut',
        status_executed: 'Suoritettu',
        approve_label: 'Hyväksy',
        decline_label: 'Hylkää',
        refresh_label: 'Päivitä',
        error_generic: 'Odottavia kirjoituksia ei voitu ladata.',
        confirm_approve: 'Hyväksyminen suorittaa työkalun organisaatiossasi API key -haltijan oikeuksilla. Jatketaanko?',
        confirm_decline: 'Hylätäänkö tämä odottava kirjoitus? Tätä ei voi peruuttaa.',
        advisory_banner: 'Odottavat kirjoitukset vanhenevat 24 tunnin kuluttua luonnista. Tunnin välein suoritettava GC-pyyhkäisy hylkää vanhentuneet merkinnät automaattisesti.',
    },
    audit_walkthrough: {
        title: 'Forseti — Auditointiläpikäynnin generaattori',
        subtitle: 'Luo jäsennelty läpikäynti auditoinnin aloitukseen: avauskysymys per kontrolli, odotettu näyttö, jatkokysymykset, mahdolliset puutteet.',
        audit_picker_label: 'Auditointi',
        audit_picker_hint: 'Valitse suunniteltu auditointi läpikäynnin luomiseksi.',
        run_label: 'Luo läpikäynti',
        running: 'Luodaan…',
        results_heading: 'Läpikäynti — {count} kontrolli(a)',
        tokens_label: '≈ {count} tokenia',
        no_controls: 'Ei kontrolleja laajuudessa. Lisää kontrollit auditointitietueeseen.',
        col_control: 'Kontrolli',
        col_question: 'Avauskysymys',
        col_evidence: 'Näyttö',
        col_gaps: 'Mahdolliset puutteet',
        expected_evidence_label: 'Odotettu näyttö',
        followup_probes_label: 'Jatkokysymykset',
        accept_label: 'Hyväksy läpikäynti',
        reject_label: 'Hylkää',
        export_label: 'Vie DOCX-muotoon',
        resolve_summary: 'Tulos: {status}',
        error_generic: 'Läpikäyntiä ei voitu luoda. Yritä uudelleen tai tarkista auditoinnin tila.',
    },
    privilege_creep: {
        title: 'Forseti — Oikeuksien karttumisen havaitseminen',
        subtitle: 'Roolimääritysten määräaikainen tarkistus. Havainnot ovat ohjeellisia — Forseti ei koskaan peruuta oikeuksia automaattisesti.',
        run_label: 'Skannaa nyt',
        running: 'Skannataan…',
        findings_heading: '{count} havainto(a)',
        no_findings: 'Ei havaittua oikeuksien karttumista.',
        col_user: 'Käyttäjä',
        col_job_function: 'Työtehtävä',
        col_severity: 'Vakavuus',
        col_unexpected: 'Odottamattomat oikeudet',
        col_remediation: 'Ehdotettu korjaus',
        col_status: 'Tila',
        severity_critical: 'Kriittinen',
        severity_high: 'Korkea',
        severity_medium: 'Keskitaso',
        severity_low: 'Matala',
        status_open: 'Avoin',
        status_dismissed: 'Hylätty',
        status_remediated: 'Korjattu',
        dismiss_label: 'Hylkää',
        remediate_label: 'Merkitse korjatuksi',
        note_label: 'Muistiinpano (valinnainen)',
        error_generic: 'Oikeuksien karttumista ei voitu skannata. Yritä myöhemmin uudelleen.',
        advisory_banner: 'Nämä havainnot ovat ohjeellisia. Forseti ei koskaan peruuta oikeuksia automaattisesti — käy ne läpi roolin omistajan kanssa ennen toimenpiteitä.',
    },
    compliance_rules: {
        rule_mapping: {
            title: 'Automaattinen vaatimustenmukaisuussäännön kartoitus',
            subtitle: 'Forseti käy läpi asennettua säädöspakettia ja ehdottaa uusia tai päivitettyjä vaatimustenmukaisuussääntöjä, jotka perustuvat lähdeartikkeleihin.',
            pack_picker_label: 'Sääntelypaketti',
            pack_picker_hint: 'Valitse kartoitettava asennettu paketti.',
            run_label: 'Kartta paketista',
            running: 'Kartoitus…',
            results_heading: '[[TOK_1]] ehdotuksia',
            tokens_label: '≈ [[TOK_1]] tokeneita kuukausittain',
            no_suggestions: 'Ei ehdotuksia – pakkauksen sisältö saattaa jo olla täysin nykyisten sääntöjen mukainen.',
            kind_new: 'Uusi sääntö',
            kind_refresh: 'Päivitä olemassa oleva',
            kind_no_change: 'Muutosta ei vaadita',
            col_kind: 'Ystävällinen',
            col_title: 'Ehdotettu otsikko',
            col_existing: 'Olemassa oleva sääntö',
            col_source: 'lähde',
            proposed_body_label: 'Ehdotettu runko',
            source_quote_label: 'Lähdelainaus',
            accept_selected: 'Hyväksy valitut',
            reject_all: 'Hylkää kaikki',
            accept_all: 'Hyväksy kaikki',
            resolve_summary: 'Ratkaisu: [[TOK_2]] · [[TOK_3]] sääntö(t) luotu',
            error_generic: 'Sääntökartoitusta ei voitu suorittaa. Yritä uudelleen tai tarkista pakkauskoodi.',
        },
    },
    access_accountability: {
        nav: {
            session_dashboard: 'Istunnon kojelauta',
            access_log: 'Pääsyloki',
            justification_review: 'Perustelutarkistus',
            investigations: 'Tutkimukset',
            pattern_analysis: 'Kuvioanalyysi',
            anchoring_status: 'Ankkurointitila',
            configuration: 'Asetukset',
            access_policies: 'Käyttöoikeuskäytännöt',
            review_campaigns: 'Tarkistuskampanjat',
            evidence_packages: 'Todistuspaketit',
        },
        session_dashboard: {
            title: 'Istunnon kojelauta',
            loading: 'Ladataan kojelauta tiedot...',
            total_sessions: 'Istunnot yhteensä',
            active_sessions: 'Aktiiviset istunnot',
            avg_duration: 'Avg Kesto',
            concurrent_peak: 'Samanaikainen huippu',
            auth_method_breakdown: 'Auth Menetelmä Breakdown',
            geo_country_breakdown: 'Geo Maa Breakdown',
            recent_session_events: 'Viimeaikainen Istunto Tapahtumat',
            user_id: 'Käyttäjätunnus',
            session_id: 'Istunto Tunniste',
            ip_address: 'IP Osoite',
            auth_method: 'Auth Menetelmä',
            started_at: 'Aloitettu',
            event_type: 'Tapahtumatyyppi',
            all_event_types: 'Kaikki tapahtumatyypit',
            filter_by_user: 'Suodata by Käyttäjä Tunniste...',
            no_active_sessions: 'No active istunto',
            no_session_events: 'Ei istunto tapahtuma löytynyt',
            revoke: 'Peruuta',
            revoke_session: 'Peruuta Istunto',
            revoke_reason: 'Syy',
            revoke_placeholder: 'Provide a reason for revoking this istunto...',
            session_label: 'Istunto:',
            load_failed: 'Epäonnistui: load istunto kojelauta. Yritä uudelleen.',
            events_load_failed: 'Epäonnistui: load istunto tapahtuma. Yritä uudelleen.',
            revoke_failed: 'Epäonnistui: revoke istunto. Yritä uudelleen.',
            session_events_loaded: '{n} session events ladattu',
            event_types: {
                session_created: 'Istunto luotu',
                session_refreshed: 'Istunto päivitetty',
                session_expired: 'Istunto vanhentunut',
                session_revoked: 'Istunto peruutettu',
                session_terminated: 'Istunto lopetettu',
                login_success: 'Kirjautuminen onnistui',
                login_failure: 'Kirjautumisvirhe',
                logout: 'Kirjaudu ulos',
                token_refresh: 'Token Refresh',
                mfa_challenge: 'MFA-haaste',
            },
        },
        access_log: {
            title: 'Pääsyloki',
            user_id: 'Käyttäjätunnus',
            resource: 'Resurssi',
            action: 'Toiminto',
            ip_address: 'IP Osoite',
            timestamp: 'Aikaleima',
            no_logs: 'Ei pääsy loki entries found. löytynyt',
            filter_by_user: 'Suodata by Käyttäjä Tunniste...',
            load_failed: 'Epäonnistui: load pääsy loki. Yritä uudelleen.',
            export_success: 'Vie initiated successfully',
            export_failed: 'Epäonnistui: export pääsy loki. Yritä uudelleen.',
            record_count: 'tietue',
            record_count_plural: 'tietueet',
            unclassified: 'Luokittelematon',
            classification_missing: 'Luokitus puuttuu',
            response_code: 'Vastauskoodi',
            classification_levels: {
                public: 'Julkinen',
                internal: 'Sisäinen',
                confidential: 'Luottamuksellinen',
                restricted: 'Rajoitettu',
                unclassified: 'Luokittelematon',
            },
        },
        justification_review: {
            title: 'Perustelutarkistus',
            user_id: 'Käyttäjätunnus',
            resource: 'Resurssi',
            justification: 'Perustelu',
            submitted_at: 'Lähetetty',
            reviewer: 'Arvioija',
            no_reviews: 'Ei perustelu katselmointi found. löytynyt',
            load_failed: 'Epäonnistui: load perustelut. Yritä uudelleen.',
            review_failed: 'Epäonnistui: katselmointi perustelu. Yritä uudelleen.',
            decline_failed: 'Epäonnistui: decline pääsy. Yritä uudelleen.',
            justification_count: 'perustelu',
            justification_count_plural: 'perustelut',
            reviewed: 'Katselmoitu',
            concerning: 'Huolestuttava',
            escalated: 'Eskaloitu',
            link_investigation_placeholder: 'Linkitä to an tutkimus (optional)',
            review_queue: 'Katselmointia Jono',
            access_id_label: 'Käyttötunnus',
            access_id_placeholder: 'Käyttölokin merkinnän tunnus',
            select_user_placeholder: 'Valitse käyttäjä (valinnainen)',
            resource_type_label: 'Resurssityyppi',
            resource_type_placeholder: 'esim. document, database',
            resource_id_label: 'Resurssin tunnus',
            resource_id_placeholder: 'Resurssin tunniste',
            reason_placeholder: 'Syy tämän resurssin käyttämiseen...',
            create_failed: 'create justification epäonnistui',
            unclassified: 'Luokittelematon',
            review_statuses: {
                pending: 'Odottaa',
                reviewed: 'Arvosteltu',
                concerning: 'Mitä tulee',
                escalated: 'Eskaloitunut',
            },
            reason_codes: {
                business_need: 'Liiketoiminnan tarve',
                legal_obligation: 'Laillinen velvoite',
                data_subject_request: 'Rekisteröidyn pyyntö',
                audit_requirement: 'Tarkastusvaatimus',
                incident_response: 'Tapahtumavastaus',
                research: 'Tutkimus',
                administrative: 'Hallinnollinen',
                other: 'muu',
            },
        },
        investigations: {
            title: 'Tutkimus Workspace',
            new: 'Uusi Tutkimus',
            subject: 'Kohde',
            investigator: 'Tutkija',
            opened_at: 'Avattu At',
            findings: 'Havainnot',
            no_investigations: 'Ei tutkimukset found. löytynyt',
            load_failed: 'Epäonnistui: load tutkimukset. Yritä uudelleen.',
            create_failed: 'Epäonnistui: create tutkimus. Yritä uudelleen.',
            timeline_add_failed: 'Epäonnistui: add timeline merkintä. Yritä uudelleen.',
            link_access_failed: 'Epäonnistui: link pääsy Tunniste. Yritä uudelleen.',
            link_justification_failed: 'Epäonnistui: link perustelu Tunniste. Yritä uudelleen.',
            close_failed: 'Epäonnistui: close tutkimus. Yritä uudelleen.',
            export_success: 'Vie initiated successfully',
            export_failed: 'Epäonnistui: export tutkimus. Yritä uudelleen.',
            refresh_failed: 'Epäonnistui: refresh tutkimus detail. Yritä uudelleen.',
            update_failed: 'Tutkinnan päivittäminen epäonnistui',
            investigation_count: 'tutkimus',
            investigation_count_plural: 'tutkimukset',
            title_placeholder: 'Tutkimus otsikko',
            description_placeholder: 'Detailed kuvaus of the tutkimus...',
            assignee_placeholder: 'Vastuuhenkilön käyttäjätunnus (valinnainen)',
            timeline_action_placeholder: 'esim. Tarkistetut pääsylokit',
            timeline_note_placeholder: 'Valinnainen note',
            access_ids_placeholder: 'pääsytunnus-1, pääsytunnus-2',
            justification_ids_placeholder: 'perustelutunnus-1, perustelutunnus-2',
            findings_placeholder: 'Summarize the tutkimus findings...',
            by_actor: 'by',
            close_investigation: 'Sulje Tutkimus',
            add_timeline_failed: 'Epäonnistui: add timeline merkintä. Yritä uudelleen.',
            fetch_failed: 'Epäonnistui: fetch tutkimukset. Yritä uudelleen.',
            change_status: 'Muuta tutkimuksen tilaa',
            details: 'Tutkimuksen tiedot',
            link_evidence: 'Linkitä todiste',
            link_justifications: 'Linkitä perustelut',
            access_ids_label: 'Käyttötunnukset',
            justification_ids_label: 'Perustelutunnukset',
            access_ids_link_placeholder: 'pääsytunnus-1, pääsytunnus-2',
            justification_ids_link_placeholder: 'perustelutunnus-1, perustelutunnus-2',
            investigations_loaded: '{n} investigations ladattu',
            status_changed_to: 'Tila muutettu: {status}',
            add_timeline_entry: 'Lisää aikajanan merkintä',
            add_access_ids: 'Lisää käyttötunnukset',
            add_justification_ids: 'Lisää perustelutunnukset',
            investigation_types: {
                anomaly_review: 'Anomaly Review',
                complaint_driven: 'Valitus ajettu',
                scheduled_review: 'Aikataulutettu tarkistus',
                whistleblower_report: 'Whistleblower-raportti',
            },
            severity_labels: {
                low: 'Matala',
                medium: 'Keskikokoinen',
                high: 'Korkea',
                critical: 'Kriittinen',
            },
            status_labels: {
                open: 'Avaa',
                in_progress: 'Meneillään',
                pending_review: 'Odottaa tarkistusta',
                closed_substantiated: 'Suljettu (perusteltu)',
                closed_unsubstantiated: 'Suljettu (ei perusteltu)',
                closed_inconclusive: 'Suljettu (epäselvä)',
            },
            disposition_labels: {
                substantiated: 'Perusteltu',
                unsubstantiated: 'Perusteeton',
                inconclusive: 'Epäselvä',
            },
        },
        pattern_analysis: {
            title: 'Kuvioanalyysi',
            loading: 'Ladataan pattern tiedot...',
            anomalies_detected: 'Havaitut poikkeamat',
            patterns: 'Mallit',
            by_user: 'By Käyttäjä',
            by_resource: 'Resurssin mukaan',
            time_range: 'Aika Alue',
            load_failed: 'Epäonnistui: analyze patterns. Yritä uudelleen.',
            top_resources: 'Top 10',
            access_by_hour: 'Pääsy vuorokaudenajan mukaan',
            access_by_day: 'Pääsy viikonpäivän mukaan',
            fetch_failed: 'Epäonnistui: fetch pattern analysis. Yritä uudelleen.',
            analysis_loaded: 'Kuvioanalyysi ladattu käyttäjälle {user}, {n} istuntoa löytyi',
            date_format_placeholder: 'PP/KK/VVVV',
            access_by_hour_heading: 'Käyttö vuorokaudenajoin',
            access_by_day_heading: 'Käyttö viikonpäivittäin',
            by_classification: 'Luokitustason mukaan',
            top_accessed_resources: 'Eniten käytetyt resurssit',
            user_access_summary: 'Käyttöoikeuksien yhteenveto',
            days: {
                sunday: 'Sunnuntai',
                monday: 'Maanantai',
                tuesday: 'Tiistai',
                wednesday: 'Keskiviikko',
                thursday: 'Torstai',
                friday: 'Perjantai',
                saturday: 'Lauantai',
            },
            linked_access_logs: 'Linkitetyt käyttölokit',
            linked_access_logs_desc: 'Käytä tämän käyttäjän havaittuihin malleihin liittyviä lokimerkintöjä.',
        },
        anchoring_status: {
            title: 'Ankkurointitila',
            loading: 'Ladataan anchoring tiedot...',
            anchored: 'Ankkuroitu',
            pending: 'Odottaa',
            failed: 'Epäonnistunut',
            last_anchor: 'Last Ankkuri',
            no_records: 'Ei anchoring tietueet found. löytynyt',
            status_load_failed: 'Epäonnistui: load anchoring tila. Yritä uudelleen.',
            proofs_load_failed: 'Epäonnistui: load pääsy todisteet. Yritä uudelleen.',
            verify_failed: 'Epäonnistui: verify todiste chain. Yritä uudelleen.',
            anchor_failed: 'Epäonnistui: anchor pääsy todiste. Yritä uudelleen.',
            batch_anchor_failed: 'Epäonnistui: batch anchor pääsy todisteet. Yritä uudelleen.',
            proof_count: 'todiste',
            proof_count_plural: 'todisteet',
            anchor_single: 'Ankkuroi yksittäinen',
            anchor_batch: 'Ankkurierä',
            access_id_placeholder: 'Syötä pääsy tunniste to anchor',
            batch_ids_placeholder: 'pääsytunnus-1, pääsytunnus-2, pääsytunnus-3',
            verify_chain: 'Vahvista ketju',
            chain_breaks: 'Ketju Breaks',
            total_checked: 'Checked yhteensä',
            anchor_placeholder: 'Syötä pääsy tunniste to anchor',
            fetch_failed: 'Epäonnistui: fetch anchoring tila. Yritä uudelleen.',
            fetch_proofs_failed: 'Epäonnistui: fetch todisteet. Yritä uudelleen.',
            access_id: 'Käyttötunnus',
            chain_sequence: 'Ketjujärjestys',
            proof_hash_label: 'Todisteen tiiviste',
            batch_id: 'Erätunnus',
            proofs_loaded: '{n} access proofs ladattu',
            anchor_statuses: {
                pending: 'Odottaa',
                submitted: 'Lähetetty',
                confirmed: 'Vahvistettu',
                failed: 'Epäonnistui',
            },
            anchor_types: {
                sha256_chain: 'SHA-256 Ketju',
                blockchain_anchor: 'Blockchain-ankkuri',
                zkp_stub: 'ZKP Stub',
            },
        },
        configuration: {
            title: 'Asetukset',
            session_settings: 'Istunto Asetukset',
            log_retention: 'Loki Säilytys (päivää)',
            anomaly_threshold: 'Poikkeamakynnys',
            anchoring_enabled: 'Ankkurointi käytössä',
            save_config: 'Tallenna Konfiguraatio',
            load_failed: 'Epäonnistui: load konfiguraatio. Yritä uudelleen.',
            save_success: 'Konfiguraatio saved successfully',
            save_failed: 'Epäonnistui: save konfiguraatio. Yritä uudelleen.',
            justification_rules: 'Perustelu Säännöt',
            reason_codes: 'Reason Koodi',
            anchoring_settings: 'Ankkurointiasetukset',
            anchoring_method: 'Ankkurointimenetelmä',
            anchoring_frequency: 'Ankkurointitiheys',
            batch_interval: 'Erä Aikaväli (minutes)',
            eligibility_criteria: 'Kelpoisuus Kriteerit',
            add_criterion_placeholder: 'Lisää kelpoisuuskriteeri...',
            retention_settings: 'Säilytys Asetukset',
            standard_retention: 'Standardi Säilytys (päivää)',
            sensitive_retention: 'Sensitive Säilytys (päivää)',
            working_hours: 'Työtunnit',
            work_start: 'Aloita Aika',
            work_end: 'End Aika',
            timezone: 'Aikavyöhyke',
            timezone_placeholder: 'esim. Asia/Ho_Chi_Minh',
            working_days: 'Työpäivät',
            concurrent_sessions: 'Concurrent Istunto Raja',
            concurrent_threshold: 'Concurrent Istunto Kynnysarvo',
            classification_level: 'Luokittelu Taso',
            prompt_mode: 'Kehote-tila',
            grace_period: 'Grace Kausi (s)',
            code_placeholder: 'koodi',
            is_custom: 'Mukautettu',
            label_placeholder: 'Tunniste',
            description_placeholder: 'Kuvaus',
            custom: 'Mukautettu',
            fetch_failed: 'Epäonnistui: fetch konfiguraatio. Yritä uudelleen.',
            classification_levels: {
                public: 'Julkinen',
                internal: 'Sisäinen',
                confidential: 'Luottamuksellinen',
                restricted: 'Rajoitettu',
                unclassified: 'Luokittelematon',
            },
            prompt_modes: {
                reason_only: 'Vain syy',
                reason_text: 'Syy + teksti',
                reason_text_supervisor: 'Syy + teksti + valvoja',
            },
            anchoring_methods: {
                sha256_chain: 'SHA-256 Ketju',
                blockchain_anchor: 'Blockchain-ankkuri',
                zkp_stub: 'ZKP Stub',
            },
            anchoring_frequencies: {
                realtime: 'Reaaliaikainen',
                batched: 'Erässä',
                on_demand: 'On Demand',
            },
        },
        access_policies: {
            title: 'Käyttöoikeuskäytännöt',
            create_policy: 'Luo käyttöoikeuskäytäntö',
            policy_name: 'Käytännön nimi',
            framework_code: 'Viitekehys',
            select_framework: 'Valitse viitekehys...',
            review_frequency: 'Tarkistustiheys',
            scope: 'Laajuus',
            no_policies_found: 'Käyttöoikeuskäytäntöjä ei löytynyt.',
            policy_created: 'Käyttöoikeuskäytäntö luotu',
            frequency_labels: {
                monthly: 'Kuukausittainen',
                quarterly: 'Neljännesvuosittainen',
                semi_annual: 'Puolivuosittainen',
                annual: 'Vuosittainen',
            },
        },
        review_campaigns: {
            title: 'Käyttöoikeustarkistuskampanjat',
            create_campaign: 'Luo tarkistuskampanja',
            reviewer: 'Tarkistaja',
            due_date: 'Eräpäivä',
            certify: 'Vahvista',
            no_campaigns_found: 'Käyttöoikeustarkistuskampanjoita ei löytynyt.',
            status_open: 'Avoin',
            status_in_review: 'Tarkistuksessa',
            status_completed: 'Valmis',
            campaign_created: 'Tarkistuskampanja luotu',
            review_certified: 'Käyttöoikeuskatsaus sertifioitu',
            certify_campaign: 'Sertifioi kampanja {id}',
            policy_id: 'Käytännön tunnus',
            select_policy: 'Valitse käytäntö...',
            reviewer_ids_label: 'Tarkastajat',
            select_reviewers: 'Valitse tarkastajat...',
            status_labels: {
                open: 'Avoin',
                in_review: 'Tarkistettavana',
                completed: 'Valmis',
            },
            evidence_package_id: 'Todistuspaketin tunnus',
        },
        evidence_packages: {
            title: 'Todistuspaketit',
            generate_package: 'Luo todistuspaketti',
            export_type: 'Vientityyppi',
            package_type: 'Paketin tyyppi',
            framework_scope: 'Viitekehyksen laajuus',
            period: 'Ajanjakso',
            generated_by: 'Luonut',
            generated_at: 'Luotu',
            no_packages_found: 'Todistuspaketteja ei löytynyt.',
            package_generated: 'Todistepaketti luotu',
            export_type_full: 'Täysi vienti',
            export_type_summary: 'Yhteenveto',
            export_type_certification_only: 'Vain sertifiointi',
            package_type_access_review: 'Käyttöoikeuskatsaus',
            package_type_investigation: 'Tutkimus',
            package_type_certification: 'Sertifiointi',
            package_type_authority_request: 'Viranomaispyyntö',
            period_start: 'Jakson alku',
            period_end: 'Jakson loppu',
            select_frameworks: 'Valitse kehykset...',
            completeness_col: 'Kattavuus',
            status_col: 'Tila',
            generated_by_col: 'Luonut',
        },
        evidence_package_detail: {
            title: 'Todistepaketin tiedot',
            not_found: 'Todistepakettia ei löytynyt.',
            package_metadata: 'Paketin metatiedot',
            status: 'Tila',
            item_count: 'Kohteiden määrä',
            disposition: 'Ratkaisu',
            closed_at: 'Suljettu',
            completeness_dashboard: 'Kattavuusnäkymä',
            no_completeness_data: 'Kattavuustietoja ei saatavilla.',
            controls_covered: 'kontrollia katettu',
            missing: 'Puuttuu',
            sign_off_tracker: 'Hyväksynnän seuranta',
            stage_framework_owner: 'Kehyksen omistaja',
            stage_legal_compliance: 'Laki ja vaatimustenmukaisuus',
            stage_internal_audit: 'Sisäinen tarkastus',
            approved: 'Hyväksytty',
            returned: 'Palautettu',
            pending: 'Odottaa',
            approve: 'Hyväksy',
            return_btn: 'Palauta',
            sign_off_submitted: 'Hyväksyntä lähetetty',
            artifacts: 'Artefaktit',
            no_artifacts: 'Artefakteja ei löytynyt.',
            template_id: 'Mallin tunnus',
            description: 'Kuvaus',
            classification: 'Luokitus',
            evidence_type: 'Todistetyyppi',
            framework_section: 'Kehysosio',
            history: 'Hyväksyntähistoria',
            expand: 'Laajenna',
            collapse: 'Tiivistä',
            action: 'Toiminto',
            actor: 'Tekijä',
            timestamp: 'Aikaleima',
            comment: 'Kommentti',
            close_case: 'Sulje tapaus',
            confirm_close: 'Vahvista sulkeminen',
            closure_notes: 'Sulkemismuistiinpanot',
            disposition_compliant: 'Vaatimustenmukainen',
            disposition_non_compliant: 'Vaatimustenvastainen',
            disposition_partial: 'Osittainen',
            case_closed: 'Todistepaketti suljettu',
            export_package: 'Vie paketti',
            export_complete: 'Todistepaketti viety',
        },
    },
    consent_properties: {
        nav: {
            dashboard: 'Kojelauta',
            properties: 'Ominaisuudet',
            groups: 'Ryhmät',
            bindings: 'Sidokset',
            change_requests: 'Muutospyynnöt',
            comparison: 'Vertailu',
            inconsistencies: 'Epäjohdonmukaisuudet',
            snapshot_schedules: 'Tilannevedosaikataulut',
            golden_templates: 'Kultaiset mallipohjat',
            evidence_packs: 'Todistuspaketit',
            audit: 'Tarkastus',
        },
        select_property: 'Valitse ominaisuus…',
        select_policy: 'Valitse käytäntö…',
        select_properties: 'Valitse ominaisuudet…',
        select_target_properties: 'Valitse kohdeominaisuudet…',
        select_owner: 'Valitse omistaja…',
        select_technical_contact: 'Valitse tekninen yhteyshenkilö…',
        property_statuses: {
            active: 'Aktiivinen',
            inactive: 'Ei aktiivinen',
            pending: 'Odottaa',
            decommissioned: 'Käytöstä poistettu',
        },
        dashboard: {
            title: 'Ominaisuuksien yhteiskojelauta',
            loading: 'Ladataan kojelauta tiedot...',
            total_properties: 'Ominaisuudet yhteensä',
            active_properties: 'Aktiiviset ominaisuudet',
            snapshot_coverage: 'Tilannevedoksen kattavuus',
            properties_covered: 'ominaisuutta katettu',
            total_bindings: 'Sidoksia yhteensä',
            deployed_bindings: 'Käyttöönotettu',
            pending_bindings: 'Odottaa käyttöönottoa',
            deployment_progress: 'Käyttöönoton edistyminen',
            on_target: 'Tavoitteessa',
            below_target: 'Alle tavoitteen',
            target_label: 'Tavoite',
            total_groups: 'Ryhmät yhteensä',
            pending_changes: 'Odottaa Changes',
            inconsistencies: 'Epäjohdonmukaisuudet',
            recent_activity: 'Viimeaikainen Aktiviteetti',
            no_recent_activity: 'Ei viimeaikaista toimintaa.',
            fetch_error: 'Epäonnistui: load kojelauta. Yritä uudelleen.',
        },
        properties: {
            title: 'Ominaisuusrekisteri',
            new: 'Uusi Ominaisuus',
            edit: 'Muokkaa Ominaisuus',
            property_name: 'Nimi',
            property_type: 'Tyyppi',
            identifier: 'Tunniste',
            environment: 'Ympäristö',
            owner_id: 'Omistaja Tunniste',
            technical_contact_id: 'Technical Contact Tunniste',
            decommission: 'Poista käytöstä',
            confirm_decommission: 'Haluatko varmasti decommission this property?',
            no_properties: 'Ei properties found. löytynyt',
            all_environments: 'Kaikki ympäristöt',
            all_types: 'Kaikki tyypit',
            cmp_instance_id: '[[TOK_0]] Instanssitunnus',
            deployment_date: 'Käyttöönottopäivämäärä',
            identifier_placeholder: 'esim. www.example.com tai com.example.app',
            owner_name: 'Omistaja',
            technical_contact_name: 'Tekninen yhteyshenkilö',
            sensitive_data_categories: 'Arkaluonteiset tietokategoriat',
            sensitive_data_categories_placeholder: 'Valitse arkaluontoisten tietojen luokat',
            requires_enhanced_review: 'Edellyttää tehostettua tarkistusta',
            sensitive_review_status: 'Arkaluonteisten tietojen tarkistus',
            sensitive_review_pending: 'Odottaa tarkistusta',
            sensitive_review_approved: 'Hyväksytty',
            sensitive_review_rejected: 'Hylätty',
            sensitive_review_submit: 'Lähetä arvostelu',
            sensitive_review_approve: 'Hyväksy',
            sensitive_review_reject: 'Hylkää',
            sensitive_review_notes: 'Tarkista muistiinpanot',
            sensitive_review_notes_placeholder: 'Kirjoita arvosteluhuomautukset...',
            record_withdrawal: 'Record Nosto',
            withdrawal_subject_id: 'Aiheen tunnus',
            withdrawal_consent_id: 'Suostumustunnus',
            withdrawal_reason: 'Syy',
            withdrawal_downstream_systems: 'Downstream Systems',
            withdrawal_downstream_placeholder: 'järjestelmä-1, järjestelmä-2',
            withdrawal_success: 'Kotiuttaminen onnistui.',
            withdrawal_error: 'Peruuttamisen levittäminen epäonnistui.',
            withdrawal_data_subject_id: 'Rekisteröidyn tunnus',
            withdrawal_data_subject_id_placeholder: 'esim. usr_abc123',
            withdrawal_consent_record_id: 'Suostumustietueen tunnus',
            withdrawal_consent_record_id_placeholder: 'esim. consent_xyz789',
            withdrawal_purposes: 'Peruutetut tarkoitukset',
            withdrawal_purposes_placeholder: 'Valitse suostumuksen peruuttamisen syyt...',
            withdrawal_withdrawn_at: 'Nostopäivä',
            withdrawal_tasks_created: 'Tehtävät luotu',
            withdrawal_affected_bindings: 'Vaikuttavat sidokset',
            withdrawal_affected_activities: 'Käsittelytoiminnot, joita tämä koskee',
            withdrawal_history: 'Kotiutushistoria',
        },
        groups: {
            title: 'Ominaisuusryhmät',
            new: 'Uusi Ryhmä',
            group_name: 'Ryhmä Nimi',
            member_count: 'Jäsenet',
            no_groups: 'Ei property groups found. löytynyt',
            policies: 'Käytännöt',
            confirm_delete: 'Haluatko varmasti poistaa tämän ryhmän?',
        },
        bindings: {
            title: 'Sidosmatriisi',
            property: 'Ominaisuus',
            purpose: 'Tarkoitus',
            legal_basis: 'Oikeusperuste',
            bound: 'Sidottu',
            no_bindings: 'Ei bindings found. löytynyt',
            bind_policy: 'Sidontakäytäntö',
            bulk_bind: 'Bulk Bind',
            bind_policy_to_property: 'Sido käytäntö omaisuuteen',
            bulk_bind_policy: 'Joukkosidontakäytäntö',
            unbound: 'Ei sitoumuksia',
            policy_id: 'Käytäntötunnus',
            version_placeholder: 'esim. 1.0.0',
            property_ids_placeholder: 'prop-id-1, prop-id-2, prop-id-3',
            binding_name: 'Sidonta',
            property_name: 'Ominaisuuden nimi',
            policy_name: 'Käytännön nimi',
            bindings_list: 'Sidontalistaus',
            binding_actions: {
                start_deploy: 'Käynnistä käyttöönotto',
                mark_deployed: 'Merkitse käyttöönotetuksi',
                rollback: 'Peruuta',
            },
        },
        change_requests: {
            title: 'Muutospyyntöprosessi',
            new: 'Uusi Change Pyyntö',
            requester: 'Pyytäjä',
            change_type: 'Change Tyyppi',
            property: 'Ominaisuus',
            submitted_at: 'Lähetetty',
            no_requests: 'Ei change requests found. löytynyt',
            fetch_pipeline_error: 'Epäonnistui: fetch pipeline. Yritä uudelleen.',
            fetch_list_error: 'Epäonnistui: fetch change requests. Yritä uudelleen.',
            create_error: 'Epäonnistui: create change request. Yritä uudelleen.',
            action_error: 'Epäonnistui: perform toiminto. Yritä uudelleen.',
            approver_name: 'Hyväksyjä',
            placeholder_target_props: 'prop-id-1, prop-id-2',
            view_all: 'Kaikki',
            view_my_properties: 'Omat Ominaisuudet',
            stage_requests: '{stage}-pyynnöt',
        },
        comparison: {
            title: 'Vertailutyötila',
            select_properties: 'Valitse ominaisuudet to compare',
            compare: 'Vertaa',
            no_comparison: 'Valitse at least two properties to compare.',
            fetch_error: 'Epäonnistui: fetch comparison raportti. Yritä uudelleen.',
            run_error: 'Epäonnistui: run comparison. Yritä uudelleen.',
            save_notes_error: 'Epäonnistui: save notes. Yritä uudelleen.',
            scan_complete: 'Inconsistency skannaus valmis successfully.',
            scan_error: 'Epäonnistui: run inconsistency skannaus. Yritä uudelleen.',
            min_two_properties: 'Please provide at least 2 property Tunniste for comparison.',
            view_inconsistencies: 'Näytä epäjohdonmukaisuudet',
            click_to_select: 'Valitse kaksi tai useampia ominaisuuksia napsauttamalla',
            no_properties_available: 'Ei ominaisuuksia saatavilla',
            no_matching_properties: 'Ei vastaavia ominaisuuksia',
            select_at_least_two_props: 'Valitse vähintään kaksi ominaisuutta ylläolevasta pudotusvalikosta.',
            no_differences_found: 'Ei eroja löydetty valittujen ominaisuuksien välillä.',
            found_inconsistencies: 'Löydettiin {count} epäjohdonmukaisuutta {properties} ominaisuuden ja {bindings} sidoksen välillä.',
        },
        inconsistencies: {
            title: 'Epäjohdonmukaisuuslista',
            property: 'Ominaisuus',
            field: 'Kenttä',
            expected: 'Odotettu',
            actual: 'Todellinen',
            severity: 'Vakavuus',
            no_inconsistencies: 'Ei inconsistencies found. löytynyt',
            trend: 'Epäjohdonmukaisuustrendi',
            trend_chart_label: 'Epäjohdonmukaisuustrendikaavio, joka näyttää laskut ajan mittaan',
            acknowledge: 'Kuittaa',
            resolve: 'Ratkaise',
            suppress: 'Piilota',
            cr_id_placeholder: 'CR Tunniste',
            view_all: 'Kaikki',
            view_my_properties: 'Omat Ominaisuudet',
            view_dpo_review: '[[TOK_0]] Tarkistusjono',
            change_request_id_required: 'Tämän epäjohdonmukaisuuden ratkaisemiseksi vaaditaan muutospyyntötunnus.',
        },
        snapshot_schedules: {
            title: 'Tilannevedosaikataulut',
            new: 'Uusi Aikataulu',
            schedule_name: 'Aikataulu Nimi',
            frequency: 'Tiheys',
            next_run: 'Seuraava Suorita',
            last_run: 'Last Suorita',
            no_schedules: 'Ei snapshot schedules found. löytynyt',
            target_type: 'Kohdetyyppi',
            target_id: 'Kohteen tunnus',
            custom_frequency_days: 'Muokattu tiheys (päiviä)',
            time_of_day: 'Kellonaika',
            time: 'Aika',
            retention_days: 'Säilytys (päiviä)',
            execute_now: 'Suorita nyt',
            placeholder_days: 'esim. 10',
            target_name: 'Kohteen nimi',
        },
        golden_templates: {
            title: 'Kultaiset mallipohjat',
            new: 'Uusi Malli',
            template_name: 'Malli Nimi',
            property_type: 'Ominaisuus Tyyppi',
            no_templates: 'Ei golden mallit found. löytynyt',
            applicable_group_ids: 'Sovellettavat ryhmätunnukset (pilkuilla erotettuna)',
            applicable_groups: 'Sovellettavat ryhmät',
            purposes: 'Tarkoitukset',
            legal_bases: 'Oikeusperustat',
            banner_config: 'Bannerin määritys',
            consent_settings: 'Suostumusasetukset',
            group_ids_placeholder: 'ryhmätunnus-1, ryhmätunnus-2',
            apply_to_property: 'Käytä Ominaisuuteen',
            apply_to_group: 'Käytä Ryhmään',
            apply_success: 'Malli käytetty onnistuneesti.',
            applications: 'Käyttöhistoria',
            no_applications: 'Ei mallin käyttökertoja vielä.',
            no_configuration_details: 'Mallissa ei ole konfigurointitietoja. Muokkaa mallia lisätäksesi tarkoituksia, oikeusperusteita, banner-asetuksia tai suostumusasetuksia.',
        },
        rollouts: {
            title: 'Mallien käyttöönotot',
            rollout_status: 'Käyttöönoton tila',
            confirmed: 'Vahvistettu',
            pending: 'Odottaa',
            failed: 'Epäonnistunut',
            confirm: 'Vahvista Ominaisuus',
            confirm_success: 'Ominaisuus vahvistettu käyttöönotossa.',
            can_close: 'Kaikki ominaisuudet vahvistettu — käyttöönotto valmis',
            cannot_close: 'Odotetaan ominaisuusvahvistuksia',
            no_rollouts: 'Ei käyttöönottoja löytynyt.',
            in_progress: 'Käynnissä',
            completed: 'Valmis',
            cancelled: 'Peruutettu',
            reject: 'Hylkää Ominaisuus',
            reject_success: 'Ominaisuus hylätty käyttöönotosta.',
            confirm_all: 'Vahvista Kaikki',
            reject_all: 'Hylkää Kaikki',
            confirm_label: 'Vahvista käyttöönotto kohteelle',
            reject_label: 'Hylkää käyttöönotto kohteelle',
            confirm_all_label: 'Vahvista Kaikki Odottavat Käyttöönotot',
            reject_all_label: 'Hylkää Kaikki Odottavat Käyttöönotot',
            no_properties_in_rollout: 'Tällä käyttöönotolla ei ole ominaisuuksia.',
        },
        analytics: {
            title: 'Ominaisuusanalytiikka',
            opt_in_rate: 'Opt-in-prosentti',
            opt_out_rate: 'Opt-out-prosentti',
            withdrawal_rate: 'Peruutusprosentti',
            total_consents: 'Suostumukset yhteensä',
            total_withdrawals: 'Peruutukset yhteensä',
            compliance_score: 'Vaatimustenmukaisuuspisteet',
            non_compliant: 'Vaatimustenvastaiset ominaisuudet',
            no_non_compliant: 'Kaikki ominaisuudet ovat vaatimustenmukaisia.',
            threshold: 'Vaatimustenmukaisuuskynnys',
            property_id: 'Kiinteistön tunnus',
            compliant: 'Yhteensopiva',
            non_compliant_status: 'Ei yhteensopiva',
            compliance_help_summary: 'Miten vaatimustenmukaisuuspisteet lasketaan ja kuinka korjaan sen?',
            compliance_help_intro: 'Kiinteistö merkitään vaatimustenvastaiseksi, kun sen pistemäärä on alle 80 %. Pisteet lasketaan seuraavasti:',
            compliance_help_with_template_label: 'Jos käytetään kultaista mallia:',
            compliance_help_with_template_text: '% määritysavaimista (tarkoitukset, legal_bases, banner_config, consent_settings), jotka vastaavat mallia tarkasti.',
            compliance_help_no_template_label: 'Jos kultaista mallia ei käytetä:',
            compliance_help_no_template_text: '% sidoksista (omaisuudelle määrätyt suostumustyypit) deployment_status = otettu käyttöön. Ominaisuus, jolla ei ole sidoksia, on oletuksena 100 %.',
            compliance_help_fix_intro: 'Jos haluat poistaa omaisuuden tästä luettelosta, tee jokin seuraavista:',
            compliance_help_fix_deploy_label: 'Ota sen siteet käyttöön',
            compliance_help_fix_deploy_text: 'avaa Binding Matrix -sivu ja aseta kunkin sidoksen käyttöönottotilaksi käytössä.',
            compliance_help_fix_template_label: 'Käytä kultaista mallia',
            compliance_help_fix_template_text: 'Käytä mallissa Käytä ryhmään ja vahvista sitten tämän omaisuuden käyttöönotto. Varmista, että omaisuuden määritykset vastaavat mallia.',
            compliance_help_fix_decommission_label: 'Poistaa kiinteistön käytöstä',
            compliance_help_fix_decommission_text: 'käytä käytöstäpoistopainiketta kiinteistötietojen modaalissa, jos se ei ole enää käytössä.',
            compliance_help_fix_no_bindings_label: 'Poista kaikki sidokset',
            compliance_help_fix_no_bindings_text: 'jos ominaisuudella ei ole mallia eikä sidoksia, se saa oletusarvoisesti 100 %.',
        },
        evidence_packs: {
            title: 'Todistuspaketit',
            new: 'Uusi Pack',
            pack_name: 'Pack Nimi',
            properties: 'Ominaisuudet',
            generated_at: 'Luotu',
            no_packs: 'Ei todistusaineisto packs found. löytynyt',
            generate: 'Luo',
            content_type_consent_records: 'Suostumus Tietueet',
            content_type_policy_versions: 'Käytäntö Versiot',
            content_type_binding_history: 'Binding Historia',
            content_type_change_requests: 'Muutospyynnöt',
            content_type_inconsistency_reports: 'Inconsistency Raportit',
            content_type_snapshot_data: 'Tilannekuva Tiedot',
            content_type_audit_trail: 'Tarkastus Trail',
        },
        audit: {
            title: 'Suostumusominaisuustarkastus',
            event_type: 'Tapahtumatyyppi',
            entity_type: 'Entity Tyyppi',
            entity_id: 'Entity Tunniste',
            actor: 'Toimija',
            timestamp: 'Aikaleima',
            no_events: 'Ei tarkastus tapahtuma found. löytynyt',
            entity_type_property: 'Ominaisuus',
            entity_type_group: 'Ryhmä',
            entity_type_binding: 'Sidonta',
            entity_type_change_request: 'Muutospyyntö',
            entity_type_golden_template: 'Kultainen malli',
            entity_type_snapshot_schedule: 'Tilannevedosaikataulu',
            entity_type_inconsistency: 'Epäjohdonmukaisuus',
            entity_type_evidence_pack: 'Todistepaketti',
            action_created: 'Luotu',
            action_updated: 'Päivitetty',
            action_deleted: 'Poistettu',
            action_decommissioned: 'Poistettu käytöstä',
            action_status_changed: 'Tila muutettu',
            action_submitted: 'Lähetetty',
            action_approved: 'Hyväksytty',
            action_rejected: 'Hylätty',
            action_deployed: 'Otettu käyttöön',
            action_rolled_back: 'Palautettu',
            action_paused: 'Keskeytetty',
            action_resumed: 'Jatkettu',
            action_cancelled: 'Peruutettu',
            action_acknowledged: 'Kuitattu',
            action_resolved: 'Ratkaistu',
            action_suppressed: 'Piilotettu',
            action_executed: 'Suoritettu',
        },
        property_types: {
            website: 'Verkkosivusto',
            mobile_app: 'Mobiilisovellus',
            ott: 'OTT',
            iot_device: 'IoT-laite',
            kiosk: 'Kioski',
            api_service: 'API-palvelu',
            sdk: 'SDK',
        },
        environments: {
            production: 'Tuotanto',
            staging: 'Vaiheistus',
            development: 'Kehitys',
            testing: 'Testaus',
        },
        group_types: {
            brand: 'Brändi',
            region: 'Alue',
            product_line: 'Tuotelinja',
            business_unit: 'Liiketoimintayksikkö',
            custom: 'Mukautettu',
        },
        target_types: {
            property: 'Ominaisuus',
            group: 'Ryhmä',
            all: 'Kaikki',
        },
        frequencies: {
            hourly: 'Tunneittain',
            daily: 'Päivittäin',
            weekly: 'Viikoittain',
            monthly: 'Kuukausittain',
            custom: 'Mukautettu',
        },
        binding_statuses: {
            current: 'Nykyinen',
            outdated: 'Vanhentunut',
            pending: 'Odottava',
            deploying: 'Käyttöönotto',
            rolled_back: 'Palautettu',
        },
        sensitive_categories: {
            health: 'Terveystiedot',
            biometric: 'Biometriset tiedot',
            genetic: 'Geneettinen data',
            racial_ethnic: 'Rotu/etninen alkuperä',
            political_opinions: 'Poliittiset mielipiteet',
            religious_beliefs: 'Uskonnolliset uskomukset',
            trade_union: 'Ammattiliiton jäsenyys',
            sexual_orientation: 'Seksuaalinen suuntautuminen',
            criminal_records: 'Rikosrekisterit',
            financial: 'Taloustiedot',
            children: 'Lasten tiedot',
            geolocation: 'Tarkka Geolocation',
        },
        export_csv: 'Vie CSV',
        exporting: 'Viedaan...',
        page_x_of_y: 'Sivu {page} / {total}',
        regulatory: {
            capture_method_guidance: '[[TOK_0]] vaatii suostumustodistuksen, jotta se vastaa keräyskanavaa. Kiinteistötyypit liittyvät suostumuksen talteenottomenetelmiin: verkkosivusto/OTT = banneripohjainen suostumus, mobiilisovellus/SDK = sovelluksen sisäinen suostumuskulku, kioski = fyysinen/näytöllä näkyvä suostumuksen kaappaus, [[TOK_1]] palvelu = ohjelmallinen suostumus, IoT-laite = laitetason suostumusmekanismi.',
            dashboard_metrics_info: 'Tämä hallintapaneeli tarjoaa [[TOK_0]]:lle yhden näkymän suostumusasennosta kaikissa digitaalisissa omaisuuksissa. Keskeisiä mittareita ovat: sitomisen kattavuuden prosenttiosuus (käyttöön otettujen sidosten kokonaismäärä), mallien noudattaminen epäjohdonmukaisuuswidgetin kautta, tarkistusta vaativat odottavat muutospyynnöt ja omaisuuden tilan erittely, joka näyttää kiinteistöjen aktiivisen, ei-aktiivisen tai käytöstä poistetun tilan. Kiinteistöjä, joissa on arkaluontoisia tietoluokkia, seurataan kiinteistörekisterin kautta.',
            change_request_impact_info: 'Suostumusominaisuuksia koskevissa muutospyynnöissä on dokumentoitava sääntelyn vaikutus: mitä [TOK_0]] vaatimuksia tämä koskee, vaikuttaako muutos arkaluontoisten tietojen käsittelyyn (Art. 2.4) ja vaatiiko muutos rekisteröityjen uudelleensuostumusta. Kunkin muutospyynnön vaikutusten yhteenvedossa on yksityiskohtaiset tiedot [[TOK_1]]-viittauksista tarkastuksen todisteisiin.',
            outdated_binding_warning: 'Sidotukset, joiden tila on "vanhentunut", osoittavat, että omaisuus käyttää käytäntöversiota, joka ei ole ajan tasalla. Nämä ominaisuudet eivät välttämättä vastaa viimeisimpiä [[TOK_0]] vaatimuksia tai organisaatiokäytäntöjen päivityksiä. Tarkista ja päivitä vanhentuneet sidokset viipymättä säilyttääksesi [[TOK_1]] vaatimustenmukaisuuden kaikissa suostumusomaisuuksissa.',
            template_pdpl_alignment: '[[TOK_0]] Art. 11, kultaisten mallien on linkitettävä tarkoitukset oikeusperustoihin. Bannerikokoonpanoissa on pakotettava osallistuminen (ei opt-out) Art. 11.3 nimenomainen suostumus. Malleissa on määritettävä peruutusmekanismi Art. 12. Arkaluonteisten tietojen (2.4 artikla) ​​mallien on pakotettava nimenomainen kirjallinen tai vastaava suostumus – napsautussuhde ei riitä.',
        },
    },
    localization: {
        nav: {
            dashboard: 'Kojelauta',
            market_packs: 'Markkinapaketit',
            language_packs: 'Kielipaketit',
            frameworks: 'Sääntelykehykset',
            mappings: 'Moduulimääritykset',
            submissions: 'Pakettilähetykset',
            translations: 'Käännöksen esikatselu',
            audit: 'Tarkastusjälki',
        },
        dashboard: {
            title: 'Lokalisointikojelauta',
            loading: 'Ladataan kojelauta tiedot...',
            active_market_packs: 'Aktiiviset markkinapaketit',
            published_packs_available: 'Julkaistu market packs available',
            language_packs: 'Kieli Packs',
            total_language_packs: 'Rekisteröityjä kielipaketteja yhteensä',
            active_regulatory_frameworks: 'Aktiiviset sääntelykehykset',
            frameworks_active: 'Kehykset with active tila',
            pending_pack_submissions: 'Odottaa Pack Submissions',
            submissions_awaiting_review: 'Submissions awaiting katselmointi',
            recent_audit_events: 'Viimeaikainen Tarkastus Tapahtumat',
            no_recent_audit: 'No recent tarkastus tapahtuma.',
            event_type: 'Tapahtumatyyppi',
            entity_type: 'Entity Tyyppi',
            entity_id: 'Entity Tunniste',
            actor: 'Toimija',
            timestamp: 'Aikaleima',
        },
        market_packs: {
            title: 'Markkinapakettikatalogi',
            new: 'Uusi Markkina Pack',
            pack_name: 'Pack Nimi',
            market: 'Markkina',
            locale: 'Maa-asetus',
            no_packs: 'Ei market packs found. löytynyt',
        },
        language_packs: {
            title: 'Kielipaketit',
            new: 'Uusi Kieli Pack',
            language: 'Kieli',
            locale_code: 'Maa-asetus Koodi',
            completeness: 'Täydellisyys',
            completeness_detail: 'Täydellisyyden yksityiskohta',
            overall_completeness: 'Yleinen täydellisyys',
            total_keys: 'Avaimet yhteensä',
            translated_keys: 'Käännetyt avaimet',
            missing_keys: 'Avaimet puuttuvat',
            namespace_breakdown: 'Nimitilan erittely',
            namespace: 'Nimiavaruus',
            translated: 'Käännetty',
            no_packs: 'Ei language packs found. löytynyt',
            install_language_pack: 'Asenna kielipaketti',
            available_packs: 'Saatavilla olevat kielipaketit',
            install: 'Asenna',
            all_installed: 'Kaikki kielipaketit on jo asennettu.',
            install_success: 'Kielipaketti asennettu onnistuneesti.',
            market: 'Markkina',
            featured: 'Esitelty',
        },
        frameworks: {
            title: 'Sääntelykehykset',
            new: 'Uusi Kehys',
            framework_name: 'Kehys Nimi',
            jurisdiction: 'Toimivalta',
            effective_date: 'Effective Päivämäärä',
            no_frameworks: 'Ei regulatory kehys found. löytynyt',
            view_requirements: 'Näytä vaatimukset',
            hide_requirements: 'Piilota vaatimukset',
            show_legacy: 'Näytä vanhat kehykset',
            effective_until: 'Voimassa asti',
            effective_on: 'Voimassa alkaen',
            replaced_by: 'Korvattu',
            replaces_label: 'Korvaa',
            status_legacy: 'Vanha',
            status_upcoming: 'Tuleva',
            watchlist: 'Tarkkailulista',
            watchlist_empty: 'Ei luonnosta tai tulevia puitteita',
            watchlist_empty_desc: 'Kehykset, joiden tila on "luonnos" tai "tuleva", näkyvät täällä seurantaa varten.',
            expected_effective: 'Odotettu tehokas',
            effective_date_tbd: 'Voimaantulopäivä: TBD',
            activate: 'Aktivoi',
            ai_law_title: 'Vietnamin [[TOK_0]] laki',
            ai_risk_classification: '[[TOK_0]] Riskiluokitus',
            ai_system_dossier: '[[TOK_0]] Järjestelmän asiakirjat',
            ai_labeling_checklist: '[[TOK_0]] Merkinnät ja tiedot',
            ai_incident_report: '[[TOK_0]] Tapahtumaraportti',
            ai_impact_assessment: '[[TOK_0]] Vaikutusten arviointi',
            ai_sandbox_application: 'Hiekkalaatikkosovellus',
            ai_sandbox_monitoring: 'Hiekkalaatikon valvonta',
            ai_sandbox_completion: 'Hiekkalaatikon valmistuminen',
            ai_submission_tracker: 'Lähetyksen seuranta',
            ai_evidence_capture: 'Todisteiden talteenotto',
            risk_level_minimal: 'Minimaalinen riski',
            risk_level_limited: 'Rajoitettu riski',
            risk_level_high: 'Korkea riski',
            risk_level_unacceptable: 'Hyväksymätön riski',
            submission_status_draft: 'Luonnos',
            submission_status_submitted: 'Lähetetty',
            submission_status_returned: 'Palautettu muutosta varten',
            submission_status_accepted: 'Hyväksytty',
            submission_status_rejected: 'Hylätty',
            submission_status_closed: 'Suljettu',
            ecommerce_law_title: 'Vietnamin sähköisen kaupan laki',
            ecommerce_platform_classification: 'Alustan luokitus',
            ecommerce_seller_register: 'Myyjärekisteri',
            ecommerce_complaint_register: 'Valitusrekisteri',
            ecommerce_takedown_register: 'Poistorekisteri',
            ecommerce_submission_tracking: 'Lähetyksen seuranta',
            ecommerce_dossier_checklist: 'Asiakirjojen tarkistuslista',
            ecommerce_cross_border: 'Rajat ylittävä noudattaminen',
            ecommerce_trustmark: 'Trustmark-ohjelma',
            ecommerce_notification: 'Ilmoitus',
            ecommerce_registration: 'Rekisteröityminen',
            ecommerce_termination: 'Irtisanominen',
            ecommerce_reporting_readiness: 'Raportointivalmius',
            ecommerce_evidence_capture: 'Todisteiden talteenotto',
            submission_status_approved: 'Hyväksytty',
            cybersec_law_2025_title: 'Vietnamin kyberturvallisuuslaki (2025)',
            cybersec_system_classification: 'Järjestelmän luokitus',
            cybersec_risk_assessment: 'Riskinarviointi',
            cybersec_incident_report: 'Tapahtumaraportti',
            cybersec_authority_cooperation: 'Viranomaisten yhteistyö',
            cybersec_data_localization: 'Tietojen lokalisointi',
            cybersec_vendor_security: 'Myyjän turvallisuus',
            cybersec_submission_tracker: 'Lähetyksen seuranta',
            cybersec_evidence_capture: 'Todisteiden talteenotto',
            cybersec_dossier_checklist: 'Asiakirjojen tarkistuslista',
            cybersec_classification_general: 'Kenraali',
            cybersec_classification_important: 'Tärkeää',
            cybersec_classification_critical: 'Kriittinen',
            data_law_title: 'Vietnamin tietolaki',
            data_inventory: 'Tietovarasto',
            data_classification: 'Tietojen luokitus',
            data_sharing: 'Tietojen jakaminen',
            data_governance: 'Tietojen hallinta',
            data_submission_tracker: 'Lähetyksen seuranta',
            data_evidence_capture: 'Todisteiden talteenotto',
            data_dossier_checklist: 'Asiakirjojen tarkistuslista',
            telecom_law_title: 'Vietnamin televiestintälaki',
            telecom_authority_request: 'Viranomaisten pyyntö',
            telecom_disclosure: 'Tietojen paljastaminen',
            telecom_confidentiality: 'Luottamuksellisuus',
            telecom_submission_tracker: 'Lähetyksen seuranta',
            telecom_evidence_capture: 'Todisteiden talteenotto',
            telecom_dossier_checklist: 'Asiakirjojen tarkistuslista',
            pdpl_law_title: 'Vietnamin henkilötietojen suojalaki',
            pdpl_breach_notification: 'Rikkomusilmoitus',
            pdpl_dpo_notification: '[[TOK_0]] Tapaamisilmoitus',
            pdpl_data_subject_notification: 'Rekisteröidyn ilmoitus',
            pdpl_submission_tracker: 'Lähetyksen seuranta',
            pdpl_evidence_capture: 'Todisteiden talteenotto',
            pdpl_dossier_checklist: 'Asiakirjojen tarkistuslista',
            pdpl_authority_filing: 'Viranomaisten arkistointi',
            pdpl_mops_filing: 'MoPS-arkistointi',
        },
        mappings: {
            title: 'Moduulimääritykset',
            new: 'Uusi Kartoitus',
            module: 'Moduuli',
            market_pack: 'Markkinapaketti',
            mapping_status: 'Kartoitus Tila',
            no_mappings: 'Ei module mappings found. löytynyt',
            incomplete_entries_warning: '{count} kartoitus(ta) piilotettu puuttuvan kehys-ID:n, vaatimus-ID:n tai moduulin vuoksi.',
        },
        submissions: {
            title: 'Pakettilähetykset',
            new: 'Uusi Submission',
            submitter: 'Lähettäjä',
            pack: 'Paketti',
            submitted_at: 'Lähetetty',
            no_submissions: 'Ei pack submissions found. löytynyt',
            installed_sector_overlays_title: 'Toimialalisäosat ({count})',
            installed_sector_overlays_aria: 'Asennetut toimialalisäosat',
            installed_col_name: 'Nimi',
            installed_col_code: 'Koodi',
            installed_col_sector: 'Toimiala',
            installed_col_mode: 'Tila',
            installed_col_status: 'Status',
            installed_refresh: 'Päivitä',
        },
        translations: {
            title: 'Käännöksen esikatselu',
            select_locale: 'Valitse maa-asetus',
            select_module: 'Valitse moduuli',
            key: 'Key',
            value: 'Arvo',
            no_translations: 'Ei translations found. löytynyt',
        },
        audit: {
            title: 'Localization Tarkastus Trail',
            event_type: 'Tapahtumatyyppi',
            entity_type: 'Entity Tyyppi',
            entity_id: 'Entity Tunniste',
            entity_name: 'Entiteetin nimi',
            actor: 'Toimija',
            timestamp: 'Aikaleima',
            payload: 'Hyötykuorma',
            collapse_payload: 'Supista hyötykuorman tiedot',
            expand_payload: 'Laajenna hyötykuorman tiedot',
            collapse: 'Supista',
            expand: 'Laajenna',
            all_entity_types: 'Kaikki entiteettityypit',
            no_events: 'Ei tarkastus tapahtuma found. löytynyt',
        },
        market_packs_detail: {
            installed_at: 'Asennettu',
            pack_details_label: 'Paketin tiedot',
            market_code: 'Markkinakoodi',
            supported_locales: 'Tuetut kielet',
            min_platform_version: 'Minimialustanversio',
            pack_information: 'Paketin tiedot',
            pack_contents: 'Pakkauksen sisältö',
            included_frameworks: 'Sisältyvät sääntelykehykset',
            pack_artifacts: 'Paketin artefaktit',
            no_artifacts: 'Ei artefakteja tälle paketille',
            pack_not_found: 'Pakettia ei löytynyt',
        },
        mappings_form: {
            framework_id: 'Kehystunnus',
            requirement_id: 'Vaatimuksen tunnus',
            module_label: 'Moduuli',
            mapping_type: 'Kartoitustyyppi',
            configuration_json: 'Määritys (JSON)',
            conflict_resolution: 'Ristiriidan ratkaisu',
            is_override: 'On ohitus',
            all_modules: 'Kaikki moduulit',
            all_mapping_types: 'Kaikki kartoitustyypit',
        },
        submissions_detail: {
            submission_id: 'Lähetyksen tunnus',
            validation: 'Validointi',
            reviewers: 'Tarkastajat',
            start_review: 'Aloita tarkistus',
            hide_comments: 'Piilota kommentit',
            review_comments: 'Tarkistuskommentit',
            loading_comments: 'Ladataan kommentteja...',
            no_comments: 'Ei vielä kommentteja.',
            add_comment: 'Lisää kommentti',
            reject_submission: 'Hylkää lähetys',
            reason_for_rejection: 'Hylkäyksen syy',
            reviewer_ids: 'Tarkastajien tunnukset (pilkuilla erotetut)',
            submit_new_pack: 'Lähetä uusi paketti',
            pack_type: 'Pakettityyppi',
            market_code: 'Markkinakoodi',
            target_locales: 'Kohdekielet',
            pack_file: 'Pakettitiedosto',
            pack_format_info: 'Paketin muoto: Market-pakettien tulee sisältää kielikohtaiset [[TOK_0]]-tiedostot nimiavaruus-/avainkäännöksineen. Kielipakettien tulee tarjota käännökset määritetyille kohdealueille. Katso yksityiskohtaiset kaaviot dokumentaatiosta.',
            accepted_formats: 'Hyväksytyt muodot: .json tai .zip. [[TOK_0]]-tiedostojen tulee sisältää käännösavain-arvoparien tasainen tai nimiavaruusobjekti. ZIP-tiedostojen tulee sisältää vähintään yksi [[TOK_1]] aluetiedosto.',
            comma_separated_locales: 'Pilkuilla erotetut kielikoodit tälle kielipaketille',
            confirm_approval: 'Vahvista hyväksyntä',
            approve_message: 'Hyväksy tämä pakettiehdotus?',
            submission_label: 'Lähetys',
            all_pack_types: 'Kaikki pakettityypit',
            passed: 'hyväksytty',
            failed_label: 'epäonnistui',
            market_code_required: 'Markkinakoodi on pakollinen',
            version_required: 'Versio on pakollinen',
            pack_type_regulatory: 'Sääntelyyn liittyvä',
            framework_code: 'Viitekehyskoodi',
            jurisdiction_code: 'Lainkäyttöaluekoodi',
            pack_source: 'Lähde',
            pack_source_manual: 'Manuaalinen',
            pack_version: 'Paketin versio',
            install_regulatory_pack: 'Asenna sääntelypaketti',
            regulatory_pack_desc: 'Lataa sääntelykehyspaketti (.zip)',
            framework_required: 'Sääntelykehyksen koodi vaaditaan',
            jurisdiction_required: 'Lainkäyttöalueen koodi vaaditaan',
        },
        catalog_detail: {
            packs_installed_of: '{total} paketista asennettu',
            install_all: 'Asenna kaikki',
            installing: 'Asennetaan...',
            removing: 'Poistetaan...',
            requires: 'Vaatii',
            tab_catalog: 'Luettelo',
            tab_installed: 'Asennettu',
            details: 'Tiedot',
        },
        translations_detail: {
            source_locale: 'Lähdekieli',
            target_locale: 'Kohdekieli',
            locales_must_differ: 'Lähde- ja kohdekielen on oltava erilaisia.',
            all_keys_translated: 'Kaikki avaimet käännetty',
            keys_missing: '[[TOK_1]] avaimet puuttuvat',
            show_missing_only: 'Näytä vain puuttuvat',
            namespace: 'Nimiavaruus',
            source: 'Lähde',
            target: 'Kohde',
        },
        frameworks_detail: {
            tab_frameworks: 'Kehykset',
            tab_watchlist: 'Seurantalista',
            authority: 'Viranomainen',
            requirements_count: 'Vaatimukset',
            all_types: 'Kaikki tyypit',
            collapse_all: 'Supista kaikki',
            expand_all: 'Laajenna kaikki',
            filtered_to: 'Suodatettu',
            clear_filter: 'Tyhjennä suodatin',
            no_requirements: 'Ei vaatimuksia tälle kehykselle.',
            requirements_label: 'Vaatimukset',
            status_updated: 'Tila päivitetty onnistuneesti',
            overview_tab: 'Yleiskatsaus',
            forms_tab: 'Lomakkeet',
            procedures_tab: 'Menettelyt',
            fines_risks_tab: 'Sakot ja riskit',
            deadlines_tab: 'Määräajat',
            guidance_tab: 'Ohjaus',
            guidance_empty: 'Tälle kehykselle ei ole ohjesisältöä.',
            guidance_loading: 'Ladataan ohjetta…',
            guidance_section: 'Ohjausosio',
            guidance_view: 'Näytä opastus',
            guidance_map_to_workflow: 'Kartta työnkulkuun',
            guidance_link_evidence: 'Linkitä todisteet',
            guidance_filter_type: 'Kirjoita',
            guidance_filter_category: 'Luokka',
            guidance_filter_module: 'Moduuli',
            guidance_filter_status: 'Tila',
            guidance_filter_search: 'Hakuohjeet',
            guidance_filter_all: 'Kaikki',
            guidance_table_reference: 'Viite',
            guidance_table_name: 'Ohjeen nimi',
            guidance_table_type: 'Kirjoita',
            guidance_table_category: 'Luokka',
            guidance_table_effective_date: 'Voimaantulopäivä',
            guidance_table_modules: 'Liittyvät moduulit',
            guidance_table_actions: 'Toiminnot',
            guidance_reference_only_banner: 'Vain viite – koskee {[[TOK_1]]}-sektoria, mutta ei organisaatiotasi.',
            guidance_related_link: 'Aiheeseen liittyvät ohjeet',
            deadlines_empty: 'Tälle sääntelykehykselle ei löytynyt sääntelymääräaikoja.',
            deadlines_sla_type: 'SLA-tyyppi',
            deadlines_value: 'Määräaika',
            deadlines_unit: 'Yksikkö',
            deadlines_extension: 'Jatkoaika',
            deadlines_reference: 'Oikeudellinen viite',
            framework_stack: 'Kehysrakenne',
            layer_parent_law: 'Peruslaki',
            layer_implementing_decree: 'Täytäntöönpanoasetus',
            layer_enforcement_decree: 'Rangaistusasetus',
            layer_admin_procedures: 'Hallintomenettelyt',
            status_active: 'Aktiivinen',
            status_draft: 'Luonnos',
            draft_enforcement_badge: 'Luonnos — ei vielä säädetty',
            effective_date: 'Voimaantulopäivä',
            forms_table_id: 'Lomake-ID',
            forms_table_name: 'Lomakkeen nimi',
            forms_table_source: 'Lähde',
            forms_table_category: 'Kategoria',
            forms_table_type: 'Tyyppi',
            fill_form: 'Täytä lomake',
            view_reference: 'Näytä viite',
            forms_official: 'Virallinen',
            forms_internal: 'Sisäinen',
            forms_empty: 'Lomakkeita ei löytynyt tälle kehykselle.',
            forms_loading: 'Ladataan lomakkeita...',
            filter_by_source_layer: 'Suodata lähdekerroksen mukaan',
            all_layers: 'Kaikki kerrokset',
            procedures_id: 'Menettely-ID',
            procedures_name: 'Menettely',
            procedures_trigger: 'Laukaisija',
            procedures_steps: 'Vaiheet',
            procedures_outputs: 'Tulokset',
            procedures_related_forms: 'Liittyvät lomakkeet',
            procedures_submission_channels: 'Lähetyskanavat',
            procedures_empty: 'Menettelyjä ei löytynyt tälle kehykselle.',
            fines_area: 'Rikkomusalue',
            fines_articles: 'Luonnosartiklat',
            fines_individual: 'Sakko (yksityishenkilö)',
            fines_organization: 'Sakko (organisaatio)',
            fines_revenue: 'Liikevaihtoeskalaatio',
            fines_deadlines: 'Määräajat',
            fines_remediation: 'Korjaustoimenpiteet',
            fines_related: 'Liittyvät menettelyt',
            fines_empty: 'Tälle kehykselle ei ole saatavilla täytäntöönpanotietoja.',
            fines_enforcement_pending: 'Täytäntöönpanokehystä ei ole vielä julkaistu. Seuraamustiedot lisätään, kun täytäntöönpanosäädös on annettu.',
            view_details: 'Näytä tiedot',
            back_to_list: 'Takaisin luetteloon',
            description: 'Kuvaus',
            jurisdiction: 'Toimivalta',
            lineage: 'Alkuperä',
            replaces: 'Korvaa',
            replaced_by: 'Korvattu',
            requirements: 'Vaatimukset',
            tab_navigation: 'Kehyksen yksityiskohdat -välilehdet',
            forms_table_actions: 'Toiminnot',
            create_form: 'Luo lomake',
            mark_promulgated: 'Merkitse julkaistuksi',
            status_promulgated: 'Julkaistu',
            promulgated_success: 'Kerroksen tila päivitetty julkaistuksi',
            transition_review: 'Siirtymäkatselmus',
            transition_review_desc: 'Tällä sääntelykehyksellä on odottava siirtymäkatselmus seuraajalain käyttöönottoa varten.',
            transition_review_by: 'Katselmuksen määräaika',
            transition_review_status: 'Katselmuksen tila',
            transition_review_notes: 'Huomautukset',
            transition_review_pending: 'Odottaa',
            transition_review_in_progress: 'Käynnissä',
            transition_review_completed: 'Valmis',
            transition_review_successor: 'Seuraava kehys',
            transition_review_lead_time: 'Valmisteluaika',
            transition_review_lead_time_days: '{days} päivää ennen voimaantulopäivää',
            transition_review_forms_heading: 'Lomakkeiden siirtymäkatselmukset',
            transition_review_forms_desc: 'Tarkista kunkin operatiivisen mallin tarpeellisuus seuraavan kehyksen alla.',
            transition_review_outcome: 'Lopputulos',
            transition_review_outcome_carry_forward: 'Säilytetään',
            transition_review_outcome_carry_forward_revised: 'Säilytetään (muokattuna)',
            transition_review_outcome_retire: 'Poistetaan',
            transition_review_outcome_split: 'Jaetaan',
            transition_review_outcome_awaiting_decree: 'Odottaa asetusta',
            transition_review_no_forms: 'Lomakkeiden siirtymäkatselmuksia ei ole määritetty.',
            transition_review_update_success: 'Siirtymäkatselmus päivitetty onnistuneesti',
            transition_review_operational_note: 'Nämä ovat prosessia tukevia operatiivisia malleja, eivät lakisääteisiä lomakemääriä. Oikeudellinen luokitus pysyy vanhassa kehyksessä seuraajalain voimaantuloon asti.',
            rights_tab: 'Oikeudet',
            rights_empty: 'Tälle kehykselle ei ole määritelty rekisteröidyn oikeuksia.',
            rights_code: 'Koodi',
            rights_name: 'Oikein',
            rights_legal_basis: 'Oikeusperusta',
            rights_elaborating_articles: 'Artikkelien laatiminen',
            rights_description: 'Kuvaus',
            requirements_reference: 'Viite',
            requirements_mandatory: 'Pakollinen',
            requirements_yes: 'Yes',
            requirements_no: 'No',
            requirements_source: 'lähde',
            category_legal_basis: 'Oikeusperusta',
            category_data_subject_rights: 'Rekisteröidyn oikeudet',
            category_notification: 'Ilmoitus',
            category_assessment: 'Arviointi',
            category_governance: 'Hallinto',
            category_record_keeping: 'Kirjanpito',
            category_cross_border: 'Rajat ylittävä',
            category_technical_measures: 'Tekniset toimenpiteet',
            category_incident_reporting: 'Tapahtumaraportointi',
            category_risk_management: 'Riskienhallinta',
            category_supply_chain: 'Toimitusketju',
            category_certification: 'Sertifiointi',
            child_frameworks: '[[TOK_1]] alikehys',
            child_frameworks_plural: '[[TOK_1]] alikehykset',
            replaces_prefix: 'Korvaa:',
            replaced_by_prefix: 'Korvattu:',
            responsible_prefix: 'Vastuuhenkilö:',
            watchlist_empty_hint: 'Kehykset, joiden tila on "luonnos" tai "tuleva", näkyvät täällä seurantaa varten.',
            framework_count: '[[TOK_1]]',
            framework_count_plural: '[[TOK_1]] kehyksiä',
            hiding_legacy: '(piilotetaan [[TOK_1]]:n perintö)',
            label_VN_PDPL: '[[TOK_0]] (asetus 13/2023)',
            label_VN_PDPD_DECREE_13: 'PDPD-asetus 13/2023',
            label_VN_PDPL_LAW_2025: '[[TOK_0]] Laki 91/2025',
            label_VN_PDPL_DECREE_356_2025: 'Asetus [[TOK_0]]',
            label_VN_PDPL_ADMIN_PROCEDURES_778_2026: 'QĐ 778/QĐ-BCA-A05',
            label_VN_PDPL_ENFORCEMENT_DRAFT_2026: '[[TOK_0]] Täytäntöönpanoehdotus 2026',
            label_VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: 'NQ22 Temporary Overlay 2026',
            label_VN_DATA_LAW: 'Tietolaki',
            label_VN_DATA_LAW_DECREE_165_2025: 'Tietolakiasetus 165/2025',
            label_VN_DATA_EXCHANGES_DRAFT_2026: 'Datapörssiluonnos 2026',
            label_VN_TELECOM_LAW_2023: 'Televiestintälaki 2023',
            label_VN_TELECOM_DECREE_163_2024: 'Televiestintäasetus 163/2024',
            label_VN_CYBERSEC_LAW: 'Kyberturvalaki (24/2018)',
            label_VN_CYBERSEC_DECREE_53: 'Cybersec-asetus 53/2022',
            label_VN_CYBERSEC_LAW_2025: 'Kyberturvallisuuslaki 116/2025',
            label_VN_ECOMMERCE_LAW_2025: 'Sähköistä kaupankäyntiä koskeva laki 122/2025',
            label_VN_AI_LAW_2026: '[[TOK_0]] Laki 2026',
            label_VN_AI_DECREE_142_2026: '[[TOK_0]] Decree 142/2026/NĐ-CP',
            issuer_company: 'Yritys',
            issuer_authority_a05_mps: 'MPS/A05',
            issuer_authority_mic: 'MIC',
            issuer_authority_mps_ndc: 'MPS/NDC',
            issuer_other_authority: 'Viranomainen',
            sla_type_rights_request_ack: 'Oikeuspyynnön vahvistus',
            'sla_type_Access control review': 'Kulunvalvonnan tarkistus',
            'sla_type_Annual governance attestation': 'Vuosittainen hallintotodistus',
            'sla_type_Audit review cycle': 'Tarkastuskierros',
            'sla_type_Authority request response': 'Viranomaisten vastauspyyntö',
            'sla_type_Change notification processing': 'Muuta ilmoitusten käsittelyä',
            'sla_type_Complaint acknowledgment': 'Valituksen kuittaus',
            'sla_type_Complaint resolution': 'Valituksen ratkaisu',
            'sla_type_Confidentiality policy review': 'Luottamuksellisuuskäytännön tarkistus',
            'sla_type_Cybersecurity incident full report': 'Kyberturvallisuushäiriön täydellinen raportti',
            'sla_type_Cybersecurity incident initial report': 'Kyberturvallisuushäiriön alustava raportti',
            'sla_type_Data inventory review': 'Tietojen inventaarion tarkistus',
            'sla_type_Disclosure log review cycle': 'Ilmoituslokin tarkistusjakso',
            'sla_type_Incident classification decision': 'Tapahtuman luokittelupäätös',
            'sla_type_Information system classification review': 'Tietojärjestelmän luokituksen tarkistus',
            'sla_type_Notification processing (sales website/app)': 'Ilmoitusten käsittely (myyntisivusto/sovellus)',
            'sla_type_Pen test cycle': 'Kynän testisykli',
            'sla_type_Registration processing (service platform)': 'Rekisteröinnin käsittely (palvelualusta)',
            'sla_type_Risk assessment cycle': 'Riskinarviointisykli',
            'sla_type_Takedown decision (after review)': 'Poistopäätös (tarkistuksen jälkeen)',
            'sla_type_Termination notice (public)': 'Irtisanominen (julkinen)',
            sla_type_ai_impact_assessment_completion: '[[TOK_0]] vaikutustenarvioinnin päätökseen',
            sla_type_ai_sandbox_application_review: '[[TOK_0]] hiekkalaatikkohakemuksen tarkistus',
            sla_type_ai_serious_incident_report: '[[TOK_0]] raportti vakavasta tapauksesta',
            sla_type_ai_system_registration: '[[TOK_0]] järjestelmän rekisteröinti',
            sla_type_authority_request_response: 'Viranomaisten vastauspyyntö',
            sla_type_certificate_issuance_review: 'Varmenteen myöntämisen tarkistus',
            sla_type_complaint_handling_approach_notice: 'Huomio valituksen käsittelystä',
            sla_type_complaint_incomplete_info_request: 'Valitus epätäydellinen tietopyyntö',
            sla_type_data_governance_attestation: 'Tietojen hallinnoinnin todistus',
            sla_type_dsr_acknowledgment: 'DSR-tunnustus',
            sla_type_dsr_cl2_withdraw_restrict_object: 'DSR (Cl.2) — Poista / rajoita / objekti',
            sla_type_dsr_cl2_withdraw_restrict_object_third_party: 'DSR (Cl.2) — Kolmas osapuoli',
            sla_type_dsr_cl3_access_correct_provide: 'DSR (Cl.3) — Käytä / korjaa / tarjoa',
            sla_type_dsr_cl3_access_correct_provide_third_party: 'DSR (Cl.3) — Kolmas osapuoli',
            sla_type_dsr_cl4_deletion: 'DSR (Cl.4) — Poisto',
            sla_type_dsr_cl4_deletion_third_party: 'DSR (Cl.4) — Poisto, kolmas osapuoli',
            sla_type_dsr_cl5_protective_measures: 'DSR (Cl.5) — Suojatoimenpiteet',
            sla_type_telecom_authority_request_response: 'Televiestintäviranomaisen vastauspyyntö',
            sla_type_rights_request_completion: 'Oikeuspyynnön täyttö',
            sla_type_incident_authority_notification: 'Viranomaisilmoitus tapahtumasta',
            sla_type_incident_subject_notification: 'Tapahtuman aiheilmoitus',
            sla_type_dpia_completion: '[[TOK_0]] suoritettu',
            sla_type_data_retention_review: 'Tietojen säilyttämisen tarkistus',
            sla_type_authority_filing_review: 'Viranomaisen hakemuksen tarkistus',
            sla_type_authority_supplement_response: 'Viranomaisen täydennysvastaus',
            sla_type_authority_resubmission: 'Viranomaisen uudelleenlähetys',
            sla_type_authority_filing_supplement_response: 'Viranomaisen täydennysvastaus',
            sla_type_authority_filing_resubmission: 'Viranomaisen hakemuksen uudelleenlähetys',
            unit_working_days: 'työpäiviä',
            unit_calendar_days: 'kalenteripäiviä',
            unit_hours: 'tuntia',
            form_category_dpa: 'DPA',
            form_category_dsr: 'DSR',
            form_category_consent: 'Suostumus',
            form_category_privacy: 'Yksityisyys',
            form_category_breach: 'Rikkominen',
            form_category_dpia: '[[TOK_0]]',
            form_category_register: 'Rekisteröidy',
            form_category_monitoring: 'Valvonta',
            form_category_vendor: 'Myyjä',
            form_category_org: 'Organisatorinen',
            form_category_sector: 'sektori',
            form_category_data_mapping: 'Tietojen kartoitus',
            form_category_governance: 'Hallinto',
            form_category_incident: 'Tapahtuma',
            form_category_authority_submission: 'Viranomaisen esitys',
            form_category_notice: 'Huomaa',
            form_category_assessment_report: 'Arviointiraportti',
            form_category_request: 'Pyyntö',
            form_category_dossier: 'Asiakirja',
            form_category_filing: 'Arkistointi',
            module_consent: 'Suostumus',
            module_rights_request: 'Oikeuspyyntö',
            module_classification: 'Luokittelu',
            module_dpia: '[[TOK_0]]',
            module_governance: 'Hallinto',
            module_monitoring: 'Valvonta',
            module_register: 'Rekisteröidy',
            module_risk: 'Riski',
            module_data_mapping: 'Tietojen kartoitus',
            module_incident: 'Tapahtuma',
            module_assessment: 'Arviointi',
            module_vendor: 'Myyjä',
            module_policy: 'politiikka',
            module_audit: 'Tarkastus',
            module_training: 'Koulutus',
            module_discovery: 'Löytö',
            enum_guidance_type_calculation_guidance: 'Laskentaopas',
            enum_guidance_type_implementation_guidance: 'Käyttöönotto-opas',
            enum_guidance_type_interpretive_note: 'tulkitseva huomautus',
            enum_guidance_type_legal_guidance: 'Oikeudelliset ohjeet',
            enum_guidance_type_procedural_guidance: 'Menettelyohjeet',
            enum_guidance_type_sector_guidance: 'Alakohtaiset ohjeet',
            enum_guidance_type_technical_methodology: 'Tekniset menetelmät',
            enum_guidance_category_annual_reporting: 'Vuosiraportointi',
            enum_guidance_category_authority_cooperation: 'Viranomaisten yhteistyö',
            enum_guidance_category_authority_coordination: 'Viranomaisten koordinointi',
            enum_guidance_category_business_continuity: 'Liiketoiminnan jatkuvuus',
            enum_guidance_category_capital_adequacy: 'Vakavaraisuus',
            enum_guidance_category_complaint_handling: 'Valituksen käsittely',
            enum_guidance_category_consent: 'Suostumus',
            enum_guidance_category_consent_management: 'Suostumuksen hallinta',
            enum_guidance_category_consumer_protection: 'Kuluttajansuoja',
            enum_guidance_category_control_environment: 'Ohjausympäristö',
            enum_guidance_category_cross_border: 'Rajat ylittävä',
            enum_guidance_category_cross_border_transfers: 'Rajat ylittävät siirrot',
            enum_guidance_category_data_classification: 'Tietojen luokitus',
            enum_guidance_category_data_localization: 'Tietojen lokalisointi',
            enum_guidance_category_data_protection_impact_assessment: 'Tietosuojavaikutusten arviointi',
            enum_guidance_category_direct_marketing: 'Suoramarkkinointi',
            enum_guidance_category_dpia: 'DPIA',
            enum_guidance_category_governance: 'Hallinto',
            enum_guidance_category_ict_risk_management: 'ICT-riskinhallinta',
            enum_guidance_category_incident_management: 'Tapahtumanhallinta',
            enum_guidance_category_internal_audit: 'Sisäinen tarkastus',
            enum_guidance_category_isms_documentation: 'ISMS-dokumentaatio',
            enum_guidance_category_lawful_basis: 'Laillinen perusta',
            enum_guidance_category_licensing: 'Lisensointi',
            enum_guidance_category_local_presence: 'Paikallinen läsnäolo',
            enum_guidance_category_logging_and_retention: 'Kirjaaminen ja säilyttäminen',
            enum_guidance_category_logical_and_physical_access: 'Looginen ja fyysinen pääsy',
            enum_guidance_category_operational_resilience_testing: 'Käyttökestävyystestaus',
            enum_guidance_category_outsourcing: 'Ulkoistaminen',
            enum_guidance_category_platform_registration: 'Alustan rekisteröinti',
            enum_guidance_category_quality_of_service: 'Palvelun laatu',
            enum_guidance_category_risk_classification: 'Riskiluokitus',
            enum_guidance_category_risk_management: 'Riskienhallinta',
            enum_guidance_category_scope_definition: 'Soveltamisalan määritelmä',
            enum_guidance_category_sectoral_localisation: 'Sektoraalinen lokalisointi',
            enum_guidance_category_subscriber_protection: 'Tilaajan suojaus',
            enum_guidance_category_supply_chain: 'Toimitusketju',
            enum_guidance_category_system_classification: 'Järjestelmän luokitus',
            enum_guidance_category_system_operations: 'Järjestelmän toiminnot',
            enum_guidance_category_telecommunications_data: 'Tietoliikennetiedot',
            enum_guidance_category_third_party_risk: 'Kolmannen osapuolen riski',
            enum_guidance_category_transitional_provisions: 'Siirtymäsäännökset',
            enum_guidance_category_vulnerability_management: 'Haavoittuvuuden hallinta',
            enum_guidance_status_active: 'Aktiivinen',
            enum_guidance_status_draft: 'Luonnos',
            enum_module_access_management: 'Käyttöoikeuksien hallinta',
            enum_module_ai_governance: '[[TOK_0]] Hallinto',
            enum_module_asset_management: 'Omaisuudenhoito',
            enum_module_audit_trail: 'Audit Trail',
            enum_module_breach_notification: 'Rikkomusilmoitus',
            enum_module_capital_adequacy: 'Vakavaraisuus',
            enum_module_classification: 'Luokittelu',
            enum_module_consent: 'Suostumus',
            enum_module_consent_management: 'Suostumuksen hallinta',
            enum_module_cross_border_transfers: 'Rajat ylittävät siirrot',
            enum_module_data_localization: 'Tietojen lokalisointi',
            enum_module_data_mapping: 'Tietojen kartoitus',
            enum_module_data_protection: 'Tietosuoja',
            enum_module_data_subject_rights: 'Rekisteröidyn oikeudet',
            enum_module_dpia: 'DPIA',
            enum_module_encryption: 'Salaus',
            enum_module_governance: 'Hallinto',
            enum_module_incident: 'Tapahtuma',
            enum_module_incident_management: 'Tapahtumanhallinta',
            enum_module_internal_audit: 'Sisäinen tarkastus',
            enum_module_isms_documentation: 'ISMS-dokumentaatio',
            enum_module_isms_governance: 'ISMS:n hallinto',
            enum_module_logging_and_monitoring: 'Kirjaaminen ja seuranta',
            enum_module_monitoring: 'Valvonta',
            enum_module_policy_management: 'Politiikan hallinta',
            enum_module_risk: 'Riski',
            enum_module_risk_management: 'Riskienhallinta',
            enum_module_training: 'Koulutus',
            enum_module_vendor: 'Myyjä',
            enum_module_vendor_management: 'Myyjän hallinta',
            enum_module_vendor_risk: 'Myyjän riski',
            enum_module_vulnerability_management: 'Haavoittuvuuden hallinta',
            category_access: 'Pääsy',
            category_availability: 'Saatavuus',
            category_change_management: 'Muutosten hallinta',
            category_classification: 'Luokittelu',
            category_communication_and_information: 'Viestintä ja tiedotus',
            category_compliance: 'Vaatimustenmukaisuus',
            category_confidentiality: 'Luottamuksellisuus',
            category_control_activities: 'Ohjaustoiminnot',
            category_control_environment: 'Ohjausympäristö',
            category_incident: 'Tapahtuma',
            category_internal_audit: 'Sisäinen tarkastus',
            category_internal_control: 'Sisäinen valvonta',
            category_logical_and_physical_access: 'Looginen ja fyysinen pääsy',
            category_mis_data: 'Hallintotietojärjestelmän tiedot',
            category_monitoring: 'Valvonta',
            category_monitoring_activities: 'Seurantatoiminnot',
            category_outsourcing: 'Ulkoistaminen',
            category_privacy: 'Yksityisyys',
            category_processing_integrity: 'Käsittelyn eheys',
            category_reporting: 'Raportointi',
            category_risk_assessment: 'Riskinarviointi',
            category_risk_mitigation: 'Riskien vähentäminen',
            category_sector_applicability: 'Toimialan soveltuvuus',
            category_system_operations: 'Järjestelmän toiminnot',
            category_training: 'Koulutus',
            category_vendor: 'Myyjä',
            guidance_related_forms_advisory: 'Joillakin lomakkeilla on asiaan liittyviä ohjeita – katso',
            guidance_related_procedures_advisory: 'Joihinkin toimenpiteisiin liittyy ohjeita – katso kohdasta',
            guidance_related_requirements_advisory: 'Joihinkin vaatimuksiin liittyy ohjeita – katso kohdasta',
        },
        channels: {
            title: 'Lähetyskanavat ja määräajat',
            channels: 'Lähetyskanavat',
            add_channel: 'Lisää kanava',
            channel_type: 'Tyyppi',
            name: 'Nimi',
            instructions: 'Ohjeet',
            active: 'Aktiivinen',
            no_channels: 'Ei lähetyskanavia määritetty',
            portal: 'Portaali',
            in_person: 'Henkilökohtaisesti',
            postal: 'Posti',
            email: 'Sähköposti',
            add: 'Lisää',
            deadlines: 'Sääntelymääräajat',
            add_deadline: 'Lisää määräaika',
            label: 'Tunniste',
            days: 'Päivät',
            day_type: 'Päivätyyppi',
            calendar_days: 'Kalenteripäivät',
            working_days: 'Työpäivät',
            no_deadlines: 'Ei määräaikoja määritetty',
            description: 'Kuvaus',
            failed_load: 'load channel data epäonnistui',
            channel_added: 'Kanava lisätty',
            channel_added_announce: 'Lähetyskanava lisätty',
            failed_add_channel: 'add channel epäonnistui',
            deadline_added: 'Määräaika lisätty',
            deadline_added_announce: 'Sääntelymääräaika lisätty',
            failed_add_deadline: 'add deadline epäonnistui',
        },
        module_links: {
            title: 'Kehyslinkitys',
            modules: 'Linkitetyt moduulit',
            add_module: 'Lisää moduuli',
            module_code: 'Moduulikoodi',
            required: 'Pakollinen',
            link: 'Linkitä',
            no_modules: 'Ei linkitettyjä moduuleita',
            notes: 'Muistiinpanot',
            personas: 'Linkitetyt persoonat',
            add_persona: 'Lisää persoona',
            persona_id: 'Persoonan tunnus',
            role_description: 'Roolin kuvaus',
            no_personas: 'Ei linkitettyjä persoonia',
            failed_load: 'load framework links epäonnistui',
            module_linked: 'Moduuli linkitetty',
            module_linked_announce: 'Moduuli linkitetty onnistuneesti',
            failed_link_module: 'link module epäonnistui',
            persona_linked: 'Persoona linkitetty',
            persona_linked_announce: 'Persoona linkitetty onnistuneesti',
            failed_link_persona: 'link persona epäonnistui',
        },
        regulatory_updates: {
            statuses: {
                pending: 'Odottaa',
                assessed: 'Arvioitu',
                applied: 'Käytetty',
                dismissed: 'Hylätty',
            },
            title: 'Sääntelypäivitykset ja kehysten kojelauta',
            page_description: 'Yhdell? silm?yksell? n?kyv? kattavuus kaikille asennetuille s??ntelyviitekehyksille sek? tuotteen sis?inen muutosloki s??ntelyp?ivityksist?: muutoksista, voimaantulop?ivist? ja vaikutusarvioista.',
            coverage_dashboard: 'Kehyskattavuuden kojelauta',
            no_frameworks: 'Ei kehyksiä löytynyt',
            framework: 'Kehys',
            modules: 'Moduulit',
            templates: 'Mallit',
            forms: 'Lomakkeet',
            channels: 'Kanavat',
            deadlines: 'Määräajat',
            pending: 'Odottavat päivitykset',
            updates: 'Sääntelypäivitykset',
            create_update: 'Luo päivitys',
            framework_id: 'Kehystunnus',
            update_title: 'Otsikko',
            description: 'Kuvaus',
            effective_date: 'Voimaantulopäivä',
            amendment_ref: 'Muutoksen viite',
            create: 'Luo',
            no_updates: 'Ei sääntelypäivityksiä',
            status: 'Tila',
            impact: 'Vaikutus',
            change_summary: 'Muutosyhteenveto',
            assess: 'Arvioi',
            failed_load: 'load data epäonnistui',
            update_created: 'Päivitys luotu',
            update_created_announce: 'Sääntelypäivitys luotu',
            failed_create: 'create update epäonnistui',
            update_assessed: 'Päivitys arvioitu',
            failed_assess: 'assess update epäonnistui',
        },
        sector_overlay: {
            sector_labels: {
                banking: 'Pankkiala',
                insurance: 'Vakuutusala',
                healthcare: 'Terveydenhuolto',
                ict_critical: 'Kriittinen ICT',
                telecom: 'Teleala',
                energy: 'Energia',
                transport: 'Liikenne',
                digital_services: 'Digitaaliset palvelut',
                digital_technology_industry: 'Digitaaliteknologian toimiala',
                public_administration: 'Julkishallinto',
                payments: 'Maksupalvelut',
                other: 'Muu',
            },
            sector_label: 'Toimiala',
            direct_scope_label: 'Suora lakis??teinen soveltuvuus',
            chip_direct: 'Soveltuu suoraan',
            chip_reference: 'Vain viitteeksi',
            banner_direct_copy: 'Soveltuu suoraan organisaatioonne. Toimialaraportit ja m??r?ajat ovat k?yt?ss?.',
            banner_reference_copy: 'Vain viitteeksi ? organisaatiotanne ei ole luokiteltu t?h?n toimialaan.',
            edit_mode_button: 'Muokkaa tilaa',
            edit_form_title: 'Vaihda asennustila',
            mode_direct_label: 'Suora ? lakis??teisesti soveltuva',
            mode_direct_help: 'Ottaa k?ytt??n toimialan m??r?ajat ja koontin?yt?n pienoisohjelmat.',
            mode_reference_label: 'Vain viitteeksi',
            mode_reference_help: 'Selattavissa, mutta ilman m??r?aikoja tai pienoisohjelmia.',
            reason_note_label: 'Syy (valinnainen)',
            reason_note_placeholder: 'esim. Hankittiin pankkialan tyt?ryhti?',
            cancel: 'Peruuta',
            confirm: 'Vahvista',
            confirming: 'Tallennetaan?',
            save: 'Tallenna',
            saving: 'Tallennetaan?',
            toast_mode_changed: 'Toimialalis?osan tila p?ivitettiin.',
            toast_installed: 'Toimialalis?osa asennettiin.',
            toast_sectors_saved: 'Toimialaomam??ritys tallennettiin.',
            install_modal_title: 'Asenna toimialalis?osa',
            install_modal_intro: 'Toimialalis?osat ovat valinnaisia s??ntelypaketteja, jotka koskevat yht? toimialaa.',
            install_modal_footer: 'Voit vaihtaa asennustilaa my?hemmin viitekehyksen tietosivulta.',
            install_button: 'Asenna',
            installed_label: 'Asennettu',
            uninstall_button: 'Poista asennus',
            uninstall_confirm: 'Vahvista asennuksen poistaminen',
            uninstall_cancel: 'Peruuta',
            suggested_label: 'Suositeltu',
            catalog_page_title: 'Toimialalis?osat',
            catalog_page_intro: 'Valinnaiset s??ntelypaketit, jotka on rajattu yhteen toimialaan.',
            catalog_empty_title: 'Toimialalis?osia ei ole saatavilla',
            catalog_empty_description: 'Alustallasi julkaistut toimialalis?osapaketit n?kyv?t t??ll?.',
            authority_label: 'Viranomainen',
            org_sectors_title: 'Toimialat',
            org_sectors_intro: 'Valitse toimialat, joilla organisaatiosi toimii.',
            widget_title: 'Er??ntyv?t toimialalis?osan raportit',
            widget_aria_label: 'Er??ntyv?t toimialalis?osan raportit',
            widget_empty: 'Tulevia toimialalis?osan m??r?aikoja ei ole.',
            audit_event_mode_changed: 'Toimialalis?osan asennustila muuttui',
            audit_event_installed: 'Toimialalis?osa asennettiin',
            view_details_button: 'N?yt? tiedot ?',
            banner_aria_label: 'Toimialalis?osan tila',
            toast_load_failed: 'Toimialalis?osien lataaminen ep?onnistui',
            toast_install_failed: 'Toimialalis?osan asennus ep?onnistui',
            toast_uninstall_confirm_required: 'Vahvista asennuksen poisto kirjoittamalla "{packCode}".',
            toast_uninstalled: 'Poistettiin {packCode}.',
            toast_uninstall_failed: 'Toimialalis?osan poistaminen ep?onnistui',
            uninstall_warning_destructive_label: 'Tuhoava toimenpide.',
            uninstall_warning_body: 'Poistaminen poistaa viitekehystietueen sekä kaikki {frameworkCode}-viitekehykseen liittyvät tallennetut sääntelymääräajat tästä organisaatiosta.',
            uninstall_warning_type_to_confirm: 'Vahvista kirjoittamalla {packCode}.',
            uninstall_in_progress: 'Poistetaan asennusta?',
            widget_view_all: 'N?yt? kaikki toimialalis?osat ?',
            widget_due_in_days: 'Er??ntyy {days} pv kuluttua',
            widget_overdue_days: 'My?h?ss? {days} pv',
            widget_due_today: 'Er??ntyy t?n??n',
            widget_due_unknown: '?',
        },
        phased_obligations: {
            panel_title: 'Vaiheistetut velvoitteet',
            panel_aria_label: 'Vaiheistetut velvoitteet',
            panel_intro: 'Jotkin t?m?n viitekehyksen lausekkeet tulevat voimaan my?hemmin kuin viitekehys itse.',
            phased_effective_date_label: 'Vaiheistettu voimaantulo:',
            status_pending: 'Odottaa',
            status_active: 'Aktiivinen',
            status_early: 'Aktiivinen (ennenaikaisesti k?ytt??notettu)',
            notice_window_label: 'Viranomaisen ilmoitusaika:',
            days_label: 'p?iv??',
            recipient_label: 'Vastaanottaja:',
            early_implement_button: 'Merkitse ennenaikaisesti k?ytt??n otetuksi',
            early_implement_modal_title: 'Merkitse vaiheistettu velvoite ennenaikaisesti k?ytt??n otetuksi',
            early_implement_modal_intro: 'Kun ennenaikainen k?ytt??notto kirjataan, velvoite aktivoituu heti ja viranomaisilmoituksen ajastus k?ynnistyy.',
            effective_at_label: 'Voimassa alkaen',
            reason_label: 'Syy (valinnainen)',
            reason_placeholder: 'esim. Hallitus hyv?ksyi varhaisen k?ytt??noton 2026-09-01',
            confirm: 'Vahvista',
            toast_early_implemented: 'Ennenaikainen k?ytt??notto kirjattiin.',
            audit_event_early_implemented: 'Vaiheistettu velvoite merkittiin ennenaikaisesti k?ytt??n otetuksi',
            widget_rolling_window_label: 'Vaiheistetut aktivoitumiset 90 p?iv?n sis?ll?',
        },
    },
    partner_marketplace: {
        nav: {
            dashboard: 'Kojelauta',
            partner_orgs: 'Kumppaniorganisaatiot',
            service_tiers: 'Palvelutasot',
            deliverable_templates: 'Tuotosmallipohjat',
            deliverables: 'Tuotokset',
            brand_profiles: 'Brändiprofiilit',
            support_tickets: 'Tukipyynnöt',
            workflow_templates: 'Työnkulkumallipohjat',
            workflows: 'Työnkulut',
            escalation: 'Eskalointi',
            reports: 'Raportit',
            audit: 'Tarkastusjälki',
        },
        dashboard: {
            title: 'Kumppanikojelauta',
            loading: 'Ladataan kojelauta tiedot...',
            total_managed_tenants: 'Managed Tenants yhteensä',
            avg_health_score: 'Avg Terveys Pistemäärä',
            open_tickets: 'Avaa Tiketit',
            upcoming_deliverables: 'Tulevat toimitukset',
            escalated_tickets: 'Eskaloitu Tiketit',
            managed_tenants: 'Hallinnoidut vuokralaiset',
            partner_tier: 'Partner Taso',
            managed_tenants_count: 'Managed Tenants Lukumäärä',
            onboarding_date: 'Onboarding Päivämäärä',
            view_details: 'Näytä yksityiskohdat',
            no_partner_orgs: 'Ei partner organizations found. löytynyt',
        },
        partner_orgs: {
            title: 'Kumppaniorganisaatiot',
            new: 'Uusi Partner Org',
            contact_name: 'Contact Nimi',
            contact_email: 'Yhteyssähköposti',
            partner_tier: 'Partner Taso',
            managed_orgs: 'Hallinnoidut organisaatiot',
            onboarding_date: 'Onboarding Päivämäärä',
            no_orgs: 'Ei partner organizations found. löytynyt',
            contact_phone: 'Contact Puhelin',
            metadata_json: 'Metatiedot (JSON)',
            change_status: 'Change Tila',
            new_status: 'Uusi Tila',
            invalid_json_metadata: 'Virheellinen JSON in metadata field',
            suspended: 'Jäädytetty',
            offboarded: 'Poistettu käytöstä',
            all_tiers: 'Kaikki tasot',
            silver: 'Hopea',
            gold: 'Kulta',
            platinum: 'Platina',
            status_offboarded: 'Poistettu käytöstä',
            status_suspended: 'Jäädytetty',
            tier_gold: 'Kulta',
            tier_platinum: 'Platina',
            tier_silver: 'Hopea',
        },
        service_tiers: {
            title: 'Palvelutasot',
            new: 'Uusi Taso',
            tier_name: 'Taso Nimi',
            monthly_fee: 'Kuukausittain Fee',
            features: 'Ominaisuudet',
            no_tiers: 'Ei service tiers found. löytynyt',
            tier_code: 'Taso Koodi',
            user_seats: 'Käyttäjäpaikat',
            user_seat_limit: 'Käyttäjäpaikkoja enintään',
            storage_gb: 'Tallennustila (GB)',
            storage_limit_gb: 'Storage Raja (GB)',
            response_time_hrs: 'Vastaus Aika (hrs)',
            resolution_time_hrs: 'Resolution Aika (hrs)',
            review_frequency: 'Katselmointia Tiheys',
            sla_response_time: 'SLA Vastaus Aika (hours)',
            sla_resolution_time: 'SLA Resolution Aika (hours)',
            module_profile_json: 'Moduuli Profiili (JSON)',
            comparing: 'Verrataan...',
            compare: 'Vertaa',
            comparison: 'Palvelu Taso Comparison',
            attribute: 'Attribuutti',
            deprecate: 'Vanhenna',
            deprecated: 'Vanhentunut',
            invalid_json_module: 'Virheellinen JSON in module profile field',
            select_compare: 'Valitse at least 2 tiers to compare',
            comparison_title: 'Palvelu Taso Comparison',
            status_deprecated: 'Vanhentunut',
            activate: 'Aktivoi',
            invalid_json_module_profile: 'Virheellinen JSON in module profile',
            resolution_time: 'Resolution Aika',
            response_time: 'Vastaus Aika',
            select_at_least_two: 'Valitse at least 2 tiers',
        },
        deliverable_templates: {
            title: 'Tuotosmallipohjat',
            new: 'Uusi Malli',
            template_name: 'Malli Nimi',
            deliverable_type: 'Toimitus Tyyppi',
            no_templates: 'Ei deliverable mallit found. löytynyt',
            frequency: 'Tiheys',
            est_effort_hrs: 'Arvioitu työmäärä (t)',
            estimated_effort: 'Arvioitu työmäärä (tuntia)',
            associated_module: 'Associated Moduuli',
            linked_tiers_count: 'Linked Tasot Lukumäärä',
            evidence_requirements: 'Todistusaineisto Vaatimukset (comma-separated)',
            tier_ids: 'Taso Tunniste (comma-separated)',
            frequency_one_time: 'One Aika',
            frequency_monthly: 'Kuukausittain',
            frequency_quarterly: 'Neljännesvuosittain',
            frequency_annually: 'Vuosittain',
            type_report: 'Raportti',
            type_review: 'Katselmointia',
            type_assessment: 'Arviointi',
            type_meeting: 'Kokous',
            type_configuration: 'Konfiguraatio',
            freq_one_time: 'One Aika',
            freq_monthly: 'Kuukausittain',
            freq_quarterly: 'Neljännesvuosittain',
            freq_annually: 'Vuosittain',
            status_deprecated: 'Vanhentunut',
        },
        deliverables: {
            title: 'Tuotokset',
            new: 'Uusi Toimitus',
            partner: 'Kumppani',
            deliverable_type: 'Toimitus Tyyppi',
            due_date: 'Due Päivämäärä',
            no_deliverables: 'Ei deliverables found. löytynyt',
            assigned_to: 'Määritetty To',
            completion_date: 'Completion Päivämäärä',
            update_status: 'Päivitä tila',
            hide_details: 'Piilota Yksityiskohdat',
            view_details: 'Näytä yksityiskohdat',
            evidence_ids: 'Todistusaineisto Tunniste',
            client_approval: 'Asiakas Hyväksyntä',
            bulk_update: 'Bulk Päivitä',
            bulk_update_status: 'Bulk Päivitä Tila',
            generate_schedule: 'Luo Aikataulu',
            generate_deliverable_schedule: 'Luo Toimitus Aikataulu',
            organization_id: 'Organisaatiotunnus',
            service_tier_id: 'Palvelu Taso Tunniste',
            filter_assigned_to: 'Suodata by Määritetty To',
            select_status: 'Valitse tila...',
            new_status: 'Uusi Tila',
            upcoming: 'Tuleva',
            overdue: 'Myöhässä',
            status_deferred: 'Lykätty',
            status_overdue: 'Myöhässä',
            status_upcoming: 'Tuleva',
        },
        brand_profiles: {
            title: 'Brändiprofiilit',
            new: 'Uusi Brand Profiili',
            partner: 'Kumppani',
            brand_name: 'Brand Nimi',
            primary_color: 'Ensisijainen Väri',
            logo_url: 'Logon URL',
            no_profiles: 'Ei brand profiles found. löytynyt',
            secondary_color: 'Toissijainen Väri',
            header_text: 'Otsikko Text',
            footer_text: 'Alatunnisteen teksti',
            contact_email: 'Yhteyssähköposti',
            contact_phone: 'Contact Puhelin',
            contact_website: 'Contact Verkkosivusto',
            contact_address: 'Contact Osoite',
            is_default: 'Is Oletus',
            set_default: 'Set Oletus',
            preview: 'Esikatselu',
            report_header_preview: 'Raportti Otsikko Preview',
            report_footer_preview: 'Raportti Footer Preview',
            preview_description: 'This is a preview of the raportti header with the valittu brand colors.',
            contact_website_short: 'Verkkosivusto',
            logo_preview: 'Logon esikatselu',
        },
        support_tickets: {
            title: 'Tukipyynnöt',
            new: 'Uusi Tiketti',
            partner: 'Kumppani',
            subject: 'Kohde',
            assigned_to: 'Määritetty To',
            no_tickets: 'Ei support tickets found. löytynyt',
            category: 'Kategoria',
            priority: 'Prioriteetti',
            escalation_tier: 'Eskalaatio Taso',
            sla_status: 'SLA Tila',
            update_status: 'Päivitä tila',
            escalate: 'Eskaloidu',
            add_note: 'Lisää huomautus',
            escalate_ticket: 'Eskaloidu Tiketti',
            escalate_to_tier: 'Eskaloidu To Taso',
            notes_timeline: 'Huomautukset Timeline',
            no_notes: 'Ei vielä huomautuksia.',
            attachments: 'Liitteet',
            no_attachments: 'Ei liitteitä.',
            client_org_id: 'Asiakas Org Tunniste',
            content: 'Sisältö',
            note_type: 'Tyyppi',
            view_detail: 'Näytä yksityiskohta',
            hide: 'Piilota',
            new_status: 'Uusi Tila',
            all_categories: 'Kaikki kategoriat',
            all_priorities: 'Kaikki prioriteetit',
            all_tiers: 'Kaikki tasot',
            ticket_not_found: 'Tiketti not found',
            ticket_id: 'Tiketti Tunniste',
            client_org: 'Asiakas Org',
            deescalate: 'Purkaa eskalointi',
            deescalate_ticket: 'De-escalate Tiketti',
            deescalate_to_tier: 'De-escalate To Taso',
            add_attachment: 'Lisää liite',
            file: 'Tiedosto',
            linked_entity: 'Linkitetty entiteetti',
            sla_target: 'Tavoite',
            breached: 'Rikottu',
            remaining_hours: 'jäljellä',
            na: 'N/A',
            tickets_found: 'tikettiä löytyi',
            reason: 'Syy',
            target: 'Tavoite',
            upload: 'Lataa',
        },
        workflow_templates: {
            title: 'Työnkulkumallipohjat',
            new: 'Uusi Malli',
            template_name: 'Malli Nimi',
            steps: 'Vaiheet',
            no_templates: 'Ei workflow mallit found. löytynyt',
            category: 'Kategoria',
            view_steps: 'Näytä vaiheet',
            hide_steps: 'Piilota Vaiheet',
            step: 'Vaihe',
            step_title: 'Otsikko',
            step_description: 'Kuvaus',
            assignee_role: 'Vastuuhenkilö Rooli',
            sla_hours: 'SLA-tunnit',
            evidence_required: 'Todistusaineisto Pakollinen',
            guidance_notes: 'Opastus Huomautukset',
            add_step: 'Lisää vaihe',
            no_steps: 'Ei määriteltyjä vaiheita.',
            no_steps_defined: 'Ei määriteltyjä vaiheita.',
            templates_found: 'mallia löytyi',
            all_categories: 'Kaikki kategoriat',
        },
        workflows: {
            title: 'Työnkulku Instances',
            new: 'Uusi Työnkulku',
            template: 'Malli',
            partner: 'Kumppani',
            current_step: 'Nykyinen Vaihe',
            progress: 'Edistyminen',
            no_workflows: 'Ei workflow instances found. löytynyt',
            instances_found: 'esiintymää löytyi',
        },
        escalation: {
            title: 'Eskalaatio Kojelauta',
            ticket: 'Tiketti',
            partner: 'Kumppani',
            escalated_at: 'Eskaloitu At',
            reason: 'Syy',
            no_escalations: 'Ei escalations found. löytynyt',
            time_in_tier: 'Aika in Taso',
            auto_evaluate: 'Automaattinen arviointi',
            priority_critical: 'Kriittinen',
            priority_high: 'Korkea',
            priority_medium: 'Keskitaso',
            priority_low: 'Low',
            deescalated_from_dashboard: 'De-escalated from kojelauta',
            sla_breached: 'SLA rikottu',
            sla_remaining: 'SLA jäljellä',
        },
        reports: {
            title: 'Raportit',
            partner: 'Kumppani',
            report_type: 'Raportti Tyyppi',
            generated_at: 'Luotu',
            no_reports: 'Ei raportti found. löytynyt',
            generate: 'Luo Raportti',
        },
        audit: {
            title: 'Partner Tarkastus Trail',
            event_type: 'Tapahtumatyyppi',
            entity_type: 'Entity Tyyppi',
            entity_id: 'Entity Tunniste',
            actor: 'Toimija',
            timestamp: 'Aikaleima',
            no_events: 'Ei tarkastus tapahtuma found. löytynyt',
            events_found: 'tapahtumaa löytyi',
            event_type_created: 'Luotu',
            event_type_updated: 'Päivitetty',
            event_type_deleted: 'Poistettu',
            event_type_status_change: 'Tilan muutos',
            event_type_escalation: 'Eskaloituminen',
            event_type_assignment: 'Tehtävä',
            entity_type_partner_org: 'Partner Org',
            entity_type_service_tier: 'Palvelutaso',
            entity_type_deliverable_template: 'Toimitettava malli',
            entity_type_deliverable_instance: 'Toimitettava esimerkki',
            entity_type_brand_profile: 'Tuotemerkkiprofiili',
            entity_type_support_ticket: 'Tukilippu',
            entity_type_workflow_template: 'Työnkulkumalli',
            entity_type_workflow_instance: 'Työnkulun ilmentymä',
            entity_type_generated_report: 'Luotu raportti',
            entity_type_escalation_rule: 'Eskalointisääntö',
        },
        no_permission_title: 'Riittämättömät käyttöoikeudet',
        no_permission_message: 'Sinulla ei ole lupaa käyttää kumppanin työtilaa.',
        status_active: 'Aktiivinen',
        status_suspended: 'Keskeytetty',
        status_offboarded: 'Offboard',
        status_completed: 'Valmis',
        status_cancelled: 'Peruutettu',
        status_deprecated: 'Käytöstä poistettu',
        status_new: 'Uusi',
        status_triaged: 'Triaged',
        status_in_progress: 'Meneillään',
        status_waiting_on_client: 'Asiakasta odotellessa',
        status_waiting_on_vendor: 'Myyjää odotellessa',
        status_escalated: 'Eskaloitunut',
        status_resolved: 'Ratkaistu',
        status_closed: 'Suljettu',
        status_pending: 'Odottaa',
        status_skipped: 'Ohitettu',
        category_onboarding: 'Käyttöönotto',
        category_incident_escalation: 'Tapahtuman eskaloituminen',
        category_config_change: 'Konfiguroinnin muutos',
        category_periodic_review: 'Säännöllinen tarkistus',
        category_offboarding: 'Offboarding',
        category_custom: 'Mukautettu',
        category_configuration: 'Kokoonpano',
        category_incident: 'Tapahtuma',
        category_compliance_question: 'Vaatimustenmukaisuuskysymys',
        category_feature_request: 'Ominaisuuspyyntö',
        category_bug_report: 'Virheraportti',
        priority_critical: 'Kriittinen',
        priority_high: 'Korkea',
        priority_medium: 'Keskikokoinen',
        priority_low: 'Matala',
        tier_silver: 'Hopeaa',
        tier_gold: 'Kulta',
        tier_platinum: 'Platina',
        report_type_compliance_summary: 'Yhteenveto vaatimustenmukaisuudesta',
        report_type_risk_overview: 'Riskien yleiskatsaus',
        report_type_incident_report: 'Tapahtumaraportti',
        report_type_consent_status: 'Suostumuksen tila',
        report_type_program_maturity: 'Ohjelman kypsyys',
        report_type_executive_pack: 'Executive Pack',
        note_type_internal: 'Sisäinen',
        note_type_client_visible: 'Asiakas näkyvissä',
        status_updated: 'Tilan päivitys onnistui',
        deliverable_status_updated: 'Toimitettavan tilan päivitys onnistui',
        ticket_status_updated: 'Lipun tilan päivitys onnistui',
        ticket_escalated: 'Lippu eskaloitui onnistuneesti',
        note_added: 'Huomautus lisätty onnistuneesti',
        attachment_uploaded: 'Liite lähetetty onnistuneesti',
        ticket_deescalated: 'Lippujen eskaloituminen onnistui',
        auto_evaluation_completed: 'Automaattinen arviointi suoritettu',
        template_created: 'Työnkulkumallin luominen onnistui',
        template_updated: 'Työnkulkumallin päivitys onnistui',
        brand_set_default: 'Brändiprofiilin asettaminen oletukseksi onnistui',
        brand_created: 'Brändiprofiilin luominen onnistui',
        brand_updated: 'Brändiprofiilin päivitys onnistui',
        tier_created: 'Palvelutaso luotiin onnistuneesti',
        tier_updated: 'Palvelutason päivitys onnistui',
        tier_deprecated: 'Palvelutaso poistettu käytöstä',
        tier_activated: 'Palvelutaso aktivoitu onnistuneesti',
        period: 'Kausi',
        format: 'Muoto',
        period_start: 'Jakson alku',
        period_end: 'Jakson loppu',
        reports_count: '[[TOK_1]] raportoi',
        reports_count_one: '[[TOK_1]] raportti',
        metric: 'Metrinen',
        value: 'Arvo',
        showing_chart_view: 'Näytetään karttanäkymä',
        showing_table_view: 'Näytetään tietotaulukkonäkymä',
        evidence_ids_placeholder: 'esim. ev-001, ev-002',
        confirm_cancel_workflow: 'Haluatko varmasti peruuttaa tämän työnkulun? Tätä toimintoa ei voi kumota.',
        export_csv: 'Vie [[TOK_0]]',
        compliance_qualifications_title: 'Vaatimustenmukaisuuspalvelun pätevyys',
        compliance_qualifications_desc: 'Kumppanitaso (hopea/kulta/platina) määrittää vaatimustenmukaisuuspalvelun laajuuden. Gold- ja Platinum-kumppanit ovat päteviä säänneltyjen toimialojen sitoumuksiin. Käytä Metadata-kenttää tallentaaksesi kunkin kumppanin sertifikaatit (ISO 27001, SOC 2), erikoisalat ja lainkäyttöalueet.',
        regulatory_output_title: 'Sääntelyn tuotosten kohdistus',
        regulatory_output_desc: 'Jokainen mallityyppi liittyy sääntelyn tulosluokkaan: Raportit tuottavat vaatimustenmukaisuusdokumentaatiota, Katsaukset vahvistavat valvonnan tehokkuuden, Arvioinnit kattavat riskiarvioinnit ([[TOK_0]], aukkojen analyysi), Kokoukset dokumentoivat hallintoistunnot. Todistusvaatimukset määrittelevät artefaktit, joihin kunkin toimituksen on viitattava tarkastusvalmiutta varten.',
        sla_compliance_title: '[[TOK_0]] Seuranta vaatimustenmukaisuuden toimittamiseksi',
        sla_compliance_desc: 'Vastaus- ja ratkaisuaika SLA-sopimukset ovat sopimusvelvollisia vaatimustenmukaisuuspalvelun toimittamisessa. Tarkistustiheys määrittää, kuinka usein kumppanien vaatimustenmukaisuuden tuotoksia arvioidaan. [[TOK_0]] rikkomukset vaatimustenmukaisuuden kannalta kriittisissä lipuissa laukaisevat automaattisen eskaloinnin, ja ne kirjataan kumppanin seurantaketjuun säännöstenmukaista näyttöä varten.',
        regulatory_engagement_title: 'Sääntelyn sitoutumismallit',
        regulatory_engagement_desc: 'Työnkulun luokat kohdistetaan säännösten mukaisiin sitouttamistyyppeihin: Onboarding kattaa alkuperäisen vaatimustenmukaisuuden määrityksen ja puutteiden analyysin, Periodic Review käsittelee toistuvat vaatimustenmukaisuusarvioinnit, Incident Escalation hallitsee säännösten rikkomiseen reagointia, Offboarding varmistaa tietojen säilyttämisvelvoitteiden täyttymisen. Jokainen vaihe voi edellyttää todisteiden keräämistä kirjausketjun täydellisyydestä.',
        compliance_escalation_title: 'Vaatimustenmukaisuuskriittiset eskalointimenettelyt',
        compliance_escalation_desc: 'L1 käsittelee normaalit toimintaongelmat. L2 kattaa vaatimustenmukaisuuteen vaikuttavat viat (säännösten noudattamatta jättäminen, valvontapuutteet). L3 on varattu säännösten rikkomisskenaarioihin, jotka vaativat välitöntä johdon huomiota. [[TOK_0]] rikkomus L2/L3-lipuissa luo kirjausketjun automaattisesti. Kaikki eskalointi- ja eskalointitoimenpiteet kirjataan pysyvästi lokiin.',
        audit_regulatory_title: 'Sääntelyn todisteiden polku',
        audit_regulatory_desc: 'Tämä kirjausketju tarjoaa peukaloituja tietueita säännösten noudattamisesta. Jokainen kumppanitoiminto (luo, päivitä, poista, eskalointi, tilanmuutos) kirjataan lokiin toimijan identiteetillä, aikaleimalla ja täyden hyötykuorman erolla. Käytä Entity Type -suodattimia todisteiden eristämiseen vaatimustenmukaisuusalueen mukaan. Vie suodatetut tulokset tuottaaksesi auditointivalmiita asiakirjoja viranomaistarkastuksia varten.',
        evidence_trail_title: 'Cross-Module Evidence Trail',
        evidence_trail_desc: 'Jokainen työnkulun vaihe voi kerätä todistetunnuksia, jotka linkittävät suoritteisiin, tarkastustapahtumiin ja vaatimustenmukaisuusartefakteihin moduulien välillä. Edistyminen todisteiden tunnuksilla luo todennettavissa olevan ketjun, joka yhdistää kumppanien työnkulut viranomaisdokumentaatioihin. Täydelliset työnkulut täydellisillä todisteketjuilla toimivat todisteena vaatimustenmukaisuuden sitouttamisesta.',
        evidence_ids_label: 'Todistustodistukset',
    },
    org_groups: {
        title: 'Organisaatioryhmät',
        new: 'Luo Ryhmä',
        group_name: 'Ryhmä Nimi',
        member_count: 'Member Lukumäärä',
        root_org: 'Juuriorganisaatio',
        no_groups: 'Ei org groups found. löytynyt',
        add_organization: 'Lisää Organisaatio',
        select_organization: 'Valitse organisaatio...',
        no_available_orgs: 'Ei lisättäviä organisaatioita saatavilla.',
        no_members: 'Ei jäsenorganisaatioita tässä ryhmässä.',
        member_added: 'Organisaatio lisätty ryhmään.',
        member_removed: 'Organisaatio poistettu ryhmästä.',
        already_in_group: 'Tämä organisaatio on jo ryhmässä.',
        org_not_found: 'Organisaatiota ei löytynyt.',
        add_member_error: 'Organisaation lisääminen ryhmään epäonnistui.',
        remove_member_error: 'Organisaation poistaminen ryhmästä epäonnistui.',
        confirm_remove_member: 'Haluatko varmasti poistaa "{name}" tästä ryhmästä?',
        load_error: 'Organisaatioryhmän tietojen lataaminen epäonnistui.',
        page_title_list: 'Organisaatioryhmät',
        page_title_detail: 'Organisaatioryhmän tiedot',
        page_title_create: 'Luo organisaatioryhmä',
        page_title_settings: 'Organisaatioryhmän asetukset',
        page_title_users: 'Ryhmän käyttäjät',
        page_title_reports: 'Ryhmäraportit',
        page_title_dashboard: 'Ryhmän hallintapaneeli',
        page_title_audit: 'Ryhmän tarkastus',
        page_title_org_audit: 'Organisaatioryhmän tarkastus',
        page_title_shared_vendors: 'Jaetut myyjät',
        page_title_shared_frameworks: 'Jaetut puitteet',
        page_title_shared_forms: 'Jaetut lomakemallit',
        page_title_merged_vendors: 'Yhdistetyt myyjät',
        page_title_settings_inheritance: 'Asetukset Periytys',
        announce_loaded_groups: 'Ladattu [[TOK_1]] organisaatioryhmää',
        announce_loaded_group: 'Ladattu ryhmä [[TOK_1]]',
        announce_loaded_users: 'Ladattu [[TOK_1]] ryhmän käyttäjää',
        announce_loaded_reports: 'Ladattu [[TOK_1]] raportteja',
        announce_loaded_vendors: 'Ladattu [[TOK_1]] jaettua toimittajaa',
        announce_loaded_frameworks: 'Ladattu [[TOK_1]] jaettua kehystä',
        announce_loaded_templates: 'Ladattu [[TOK_1]] jaetut lomakemallit',
        announce_loaded_audit: 'Ladattu [[TOK_1]] tarkastustapahtumaa',
        announce_loaded_merged: 'Ladattu [[TOK_2]] jaettua ja [[TOK_3]] paikallista toimittajaa',
        announce_dashboard_loaded: 'Kojelauta ladattu.',
        announce_dashboard_refreshed: 'Kojelauta päivitetty.',
        announce_dashboard_refresh_failed: 'Hallintapaneelin päivittäminen epäonnistui.',
        announce_refreshing: 'Päivitetään kojelautaa...',
        announce_settings_loaded: 'Asetusten perintö ladattu.',
        announce_settings_saved: 'Asetukset tallennettu onnistuneesti.',
        announce_saving_settings: 'Tallennetaan asetuksia...',
        announce_error_saving: 'Virhe asetusten tallentamisessa.',
        announce_group_dissolved: 'Ryhmä purettu.',
        announce_creating_group: 'Luodaan organisaatioryhmää...',
        announce_group_created: 'Organisaatioryhmän luominen onnistui.',
        announce_error_creating: 'Virhe luotaessa organisaatioryhmää.',
        announce_vendor_published: 'Toimittaja julkaistu onnistuneesti.',
        announce_vendor_retired: 'Myyjä jäi eläkkeelle.',
        announce_framework_published: 'Framework julkaistu onnistuneesti.',
        announce_framework_retired: 'Framework eläkkeelle.',
        announce_template_published: 'Lomakemallin julkaisu onnistui.',
        announce_template_retired: 'Lomakemalli poistettu käytöstä.',
        announce_role_assigned: 'Roolin määrittäminen onnistui.',
        announce_error_assign_role: 'Virhe määritettäessä roolia.',
        announce_role_revoked: 'Rooli peruutettu onnistuneesti.',
        announce_report_generating: 'Raporttia luodaan...',
        announce_report_requested: 'Raportin luonti pyydetty.',
        announce_error_report: 'Virhe raporttia pyydettäessä.',
        announce_report_deleted: 'Raportti poistettu.',
        announce_search_applied: 'Haku käytössä.',
        announce_search_cleared: 'Haku tyhjennetty.',
        announce_tab_selected: '[[TOK_1]]-välilehti valittu',
        announce_error_add_member: 'Virhe lisättäessä jäsentä ryhmään.',
        announce_category_reverted: '[[TOK_1]] palautettiin vanhemmalta perityksi.',
        announce_category_overridden: '[[TOK_1]] asetettu paikalliseen ohitukseen.',
        announce_override_saved: '[[TOK_1]] ohitus tallennettu.',
        announce_export_started: 'Viedään tarkastus nimellä [[TOK_1]]...',
        announce_export_completed: 'Vienti [[TOK_1]] valmis.',
        announce_export_failed: 'Vienti epäonnistui.',
        announce_filter_org: 'Suodatettu organisaation mukaan [[TOK_1]]',
        announce_filter_org_cleared: 'Organisaation suodatin tyhjennetty',
        announce_filter_event: 'Suodatettu tapahtumatyypin [[TOK_1]]',
        announce_filter_cleared: 'Suodatin tyhjennetty',
        announce_download: 'Ladataan [TOK_2]] nimellä [[TOK_3]]',
        error_load_groups: 'Organisaatioryhmien lataaminen epäonnistui. Yritä uudelleen.',
        error_load_users: 'Ryhmän käyttäjien lataaminen epäonnistui.',
        error_load_reports: 'Ryhmäraporttien lataaminen epäonnistui.',
        error_load_dashboard: 'Ryhmän hallintapaneelin lataaminen epäonnistui.',
        error_load_settings: 'Ryhmäasetusten lataaminen epäonnistui.',
        error_load_vendors: 'Yhdistettyjen toimittajien lataaminen epäonnistui.',
        error_save_settings: 'Asetusten tallentaminen epäonnistui.',
        error_dissolve_group: 'Ryhmän purkaminen epäonnistui.',
        error_assign_role: 'Roolin määrittäminen epäonnistui.',
        error_create_group: 'Organisaatioryhmän luominen epäonnistui. Yritä uudelleen.',
        error_request_report: 'Raportin pyytäminen epäonnistui.',
        error_group_name_required: 'Ryhmän nimi vaaditaan.',
        success_settings_saved: 'Asetukset tallennettu onnistuneesti.',
        confirm_retire_vendor: 'Haluatko varmasti lopettaa toimittajan [[TOK_1]]?',
        confirm_retire_framework: 'Haluatko varmasti poistaa puitteet [[TOK_1]]?',
        confirm_retire_template: 'Haluatko varmasti poistaa lomakemallin [[TOK_1]]?',
        confirm_dissolve_group: 'Haluatko varmasti purkaa kohteen [[TOK_1]]? Tätä toimintoa ei voi kumota.',
        confirm_revoke_role: 'Haluatko varmasti peruuttaa roolin [[TOK_2]] asemalta [[TOK_3]]?',
        confirm_delete_report: 'Haluatko varmasti poistaa raportin "[[TOK_1]]"?',
        dissolve_group: 'Pura ryhmä',
        dissolve_warning: 'Tämä purkaa organisaatioryhmän pysyvästi. Kaikki jäsenjärjestöt poistetaan.',
        count_groups: '[[TOK_1]] ryhmä',
        count_groups_plural: '[[TOK_1]] ryhmää',
        count_users: '[[TOK_1]] käyttäjä',
        count_users_plural: '[[TOK_1]] käyttäjää, joilla on ryhmärooleja',
        count_events: '[[TOK_1]] tapahtuma',
        count_events_plural: '[[TOK_1]] tapahtumia',
        count_reports: '[[TOK_1]] raportti',
        count_reports_plural: '[[TOK_1]] raportoi',
        count_vendors: '[[TOK_1]] toimittaja jaettu ryhmässä',
        count_vendors_plural: '[[TOK_1]] toimittajaa jaettu ryhmässä',
        count_frameworks: '[[TOK_1]] puitteet jaetaan koko ryhmälle',
        count_frameworks_plural: '[[TOK_1]] puitteet jaetaan koko ryhmälle',
        count_templates: '[[TOK_1]] malli jaettu koko ryhmälle',
        count_templates_plural: '[[TOK_1]] mallia jaetaan koko ryhmälle',
        count_shared_vendors: '[[TOK_1]] jaettua toimittajaa',
        count_local_vendors: '[[TOK_1]] paikallisia myyjiä',
        merged_combined_view: 'Yhdistetty näkymä [[TOK_2]] jaetuista ja [[TOK_3]] paikallisista toimittajista',
        dashboard: {
            title: 'Ryhmän kojelauta',
            loading: 'Ladataan kojelauta tiedot...',
            total_groups: 'Ryhmät yhteensä',
            total_members: 'Members yhteensä',
            active_groups: 'Aktiiviset ryhmät',
            overall_compliance_score: 'Yleinen vaatimustenmukaisuuspisteet',
            group_risk_level: 'Ryhmän riskitaso',
            sla_compliance: '[[TOK_0]] Vaatimustenmukaisuus',
            compliance_posture: 'Vaatimustenmukaisuusasento',
            risk_heatmap: 'Riskien lämpökartta',
            sla_performance: '[[TOK_0]] Suorituskyky',
            recent_incidents: 'Viimeaikaiset tapahtumat',
            recent_activity: 'Viimeaikainen toiminta',
            refresh_label: 'Päivitä kojelaudan tiedot',
            score_good: 'Hyvä',
            score_needs_attention: 'Vaatii huomiota',
            score_critical: 'Kriittinen',
            trend_up: 'Nousussa',
            trend_down: 'Trendikäs alaspäin',
            trend_stable: 'Vakaa',
            risk_low: 'Low',
            risk_medium: 'Keskikokoinen',
            risk_high: 'Korkea',
            risk_critical: 'Kriittinen',
            risk_unknown: 'Tuntematon',
            col_organization: 'Organisaatio',
            col_score: 'Pisteet',
            col_trend: 'Trendi',
            col_open_issues: 'Avoimet ongelmat',
            col_critical_issues: 'Kriittiset kysymykset',
            col_health: 'Terveys',
            col_vendor_risk: 'Myyjän riski',
            col_data_risk: 'Tietojen riski',
            col_compliance_risk: 'Vaatimustenmukaisuusriski',
            col_total_cases: 'Tapauksia yhteensä',
            col_on_time: 'Ajoissa',
            col_breached: 'Rikkoutunut',
            col_sla_percent: '[[TOK_0]] %',
            col_avg_days: 'Päivien keskiarvo',
            sr_vendor_risk: 'Toimittajan riskipisteet: [[TOK_1]]',
            sr_data_risk: 'Tietojen riskipisteet: [[TOK_1]]',
            sr_compliance_risk: 'Vaatimustenmukaisuuden riskipisteet: [[TOK_1]]',
            sr_sla_breaches: 'Varoitus: [[TOK_1]] [[TOK_2]] rikkoo',
            sr_severity: 'Vakavuus: [[TOK_1]]',
        },
        detail: {
            title: 'Ryhmän tiedot',
            members: 'Jäsenet',
            settings: 'Asetukset',
            audit: 'Tarkastus',
            sr_loading: 'Ladataan organisaatioryhmän tietoja',
            sr_loading_hierarchy: 'Ladataan hierarkiaa',
            member_org: 'jäsenjärjestö',
            root_org_label: 'juuriorganisaatio',
        },
        users: {
            title: 'Ryhmän käyttäjät',
            add_user: 'Lisää käyttäjä',
            no_users: 'No käyttäjä in this group.',
            role_group_admin: 'Ryhmän ylläpitäjä',
            role_group_reader: 'Ryhmälukija',
            sr_loading: 'Ladataan ryhmän käyttäjiä',
        },
        reports: {
            title: 'Ryhmän raportit',
            no_reports: 'Ei raportti found. löytynyt',
            generate_report: 'Luo uusi raportti',
            report_type_compliance: 'Yhteenveto vaatimustenmukaisuudesta',
            report_type_risk: 'Riskien yleiskatsaus',
            report_type_sla: '[[TOK_0]] Suorituskyky',
            report_type_incident: 'Tapahtumaraportti',
            report_type_executive: 'Executive Lyhyt',
            report_type_board: 'Hallituksen raportti',
            status_queued: 'Jonossa',
            status_generating: 'Luodaan',
            status_completed: 'Valmis',
            status_failed: 'Epäonnistui',
            period_start: 'Jakson alku',
            period_end: 'Jakson loppu',
            sr_loading: 'Ladataan ryhmäraportteja',
        },
        shared_vendors: {
            title: 'Jaetut toimittajat',
            no_vendors: 'Ei shared toimittajat found. löytynyt',
            merged_vendors: 'Merged Toimittajat',
            publish_form_label: 'Julkaise jaettu toimittaja',
            sr_loading: 'Ladataan jaettuja toimittajia',
            sr_loading_merged: 'Ladataan yhdistettyjä toimittajia',
            local_vendors: 'Paikalliset myyjät',
            source_shared: 'Jaettu ryhmästä',
            source_local: 'Paikallinen myyjä',
            category_technology: 'Tekniikka',
            category_consulting: 'Konsultointi',
            category_outsourcing: 'Ulkoistaminen',
            category_cloud: 'Pilvi',
            category_data_processing: 'Tietojen käsittely',
            category_other: 'muu',
            risk_tier_low: 'Low',
            risk_tier_medium: 'Keskikokoinen',
            risk_tier_high: 'Korkea',
            risk_tier_critical: 'Kriittinen',
            compliance_compliant: 'Yhteensopiva',
            compliance_non_compliant: 'Ei yhteensopiva',
            compliance_pending: 'Odottaa',
            compliance_under_review: 'Tarkistuksessa',
            status_active: 'Aktiivinen',
            status_retired: 'Eläkkeellä',
        },
        shared_frameworks: {
            title: 'Jaetut kehykset',
            no_frameworks: 'Ei shared kehys found. löytynyt',
            publish_form_label: 'Julkaise jaettu kehys',
            sr_loading: 'Ladataan jaettuja kehyksiä',
            status_active: 'Aktiivinen',
            status_retired: 'Eläkkeellä',
        },
        shared_forms: {
            title: 'Jaetut lomakemallipohjat',
            no_forms: 'Ei shared form mallit found. löytynyt',
            publish_form_label: 'Julkaise jaettu lomakemalli',
            sr_loading: 'Ladataan jaettuja lomakemalleja',
            status_active: 'Aktiivinen',
            status_retired: 'Eläkkeellä',
        },
        audit: {
            title: 'Ryhmän tarkastus',
            consolidated_title: 'Consolidated Tarkastus Trail',
            consolidated_subtitle: 'Cross-organization tarkastus tapahtuma for this group',
            audit_log_title: 'Ryhmä Tarkastus Loki',
            event_type: 'Tapahtumatyyppi',
            actor: 'Toimija',
            timestamp: 'Aikaleima',
            source_org: 'Lähde Org',
            org: 'Org',
            summary: 'Yhteenveto',
            details: 'Yksityiskohdat',
            no_events: 'Ei tarkastus tapahtuma found. löytynyt',
            all_events: 'Kaikki tapahtumat',
            all_orgs: 'Kaikki organisaatiot',
            organization: 'Organisaatio',
            from: 'Lähettäjä',
            to: 'To',
            search_events: 'Hae tapahtuma...',
            clear: 'Tyhjennä',
            events_24h: 'Tapahtumat (24h)',
            events_7d: 'Tapahtumat (7d)',
            active_orgs: 'Aktiiviset organisaatiot',
            exporting: 'Viedään...',
            export_csv: 'Vie CSV',
            export_json: 'Vie JSON',
            back_to_group: 'Takaisin to Ryhmä',
            back_to_detail: 'Takaisin to Yksityiskohta',
            sr_loading: 'Ladataan tarkastustapahtumia',
            sr_loading_summary: 'Ladataan tarkastuksen yhteenvetoa',
        },
        settings: {
            title: 'Ryhmä Asetukset',
            inheritance: 'Asetukset Inheritance',
            inheritance_subtitle: 'Määritä, mitkä asetusluokat perivät ryhmältä vai käyttävät paikallisia ohituksia',
            sla_settings: 'SLA Asetukset',
            calendar_settings: 'Calendar Asetukset',
            notification_settings: 'Ilmoitusasetukset',
            intake_settings: 'Intake Asetukset',
            cmp_integration: 'CMP Integraatio',
            overridden: 'Ohitettu',
            inheriting: 'Periytyvä',
            hide_defaults: 'Piilota Oletus',
            show_group_defaults: 'Näytä Ryhmä Oletus',
            group_defaults: 'Ryhmä Oletus',
            inherit_from_group: 'Inherit from Ryhmä',
            use_local_override: 'Käytä paikallista ohitusta',
            local_override_json: 'Paikallinen Ohita (JSON)',
            save_override: 'Tallenna Ohita',
            saving: 'Tallennetaan...',
            sr_loading: 'Ladataan asetusten perintöä',
            sr_loading_settings: 'Ladataan ryhmän asetuksia',
            sr_enabled: 'Käytössä',
            sr_disabled: 'Ei käytössä',
            sr_override_active: 'Paikallinen ohitus aktiivinen',
            sr_inherited: 'Peritty vanhemmalta',
            danger_zone: 'Vaaravyöhyke',
            sharing_options: 'Jakamisasetukset',
            advanced_options: 'Lisäasetukset',
        },
        status_active: 'Aktiivinen',
        status_dissolved: 'Liuennut',
        status_pending: 'Odottaa',
        status_suspended: 'Keskeytetty',
    },
    integrations: {
        nav: {
            webhooks: 'Webhookit',
            domains: 'Verkkotunnukset',
            export_schedules: 'Vientiaikataulut',
            email_log: 'Sähköpostiloki',
        },
    },
    platform: {
        nav: {
            users: 'Käyttäjät',
            roles: 'Roolit',
            profile: 'Oma profiili',
        },
        security: {
            mfa: 'MFA-asetukset',
            sso: 'SSO-asetukset',
            api_keys: 'API-avaimet',
            service_accounts: 'Palvelutilit',
            ip_allowlist: 'IP-sallittujen lista',
            delegations: 'Delegoinnit',
            break_glass: 'Hätäpääsy',
            session_settings: 'Istuntoasetukset',
            active_sessions: 'Aktiiviset istunnot',
            access_reviews: 'Pääsyn tarkistukset',
            my_reviews: 'Omat tarkistukset',
            role_analytics: 'Roolianalytiikka',
            attestation_schedules: 'Vahvistusaikataulut',
            sod_rules: 'SoD-säännöt',
            sod_violations: 'SoD-rikkomukset',
        },
        module_config: {
            title: 'Moduulien asetukset',
            subtitle: 'Ota käyttöön tai poista käytöstä ominaisuusmoduuleja organisaatiollesi. Käytöstä poistetut moduulit piilotetaan navigaatiosta.',
            enabled: 'Käytössä',
            disabled: 'Ei käytössä',
            save: 'Tallenna asetukset',
            saving: 'Tallennetaan...',
            saved: 'Asetukset tallennettu onnistuneesti',
            nav_label: 'Moduulien asetukset',
            settings: 'Asetukset',
            webhooks: 'Webhookit',
            domains: 'Verkkotunnukset',
            export_schedules: 'Vientiaikataulut',
            email_log: 'Sähköpostiloki',
        },
        files_nav: {
            section: 'Tiedostot',
            configuration: 'Kokoonpano',
            browser: 'Tiedostoselain',
            dashboard: 'Tiedostojen hallintapaneeli',
        },
        immutable_audit_trails: {
            nav_group_label: 'Tarkastus ja todiste',
            nav_settings: 'Asetukset',
            nav_status: 'Todistuksen tila',
            nav_integrity_center: 'Integrity Center',
            nav_usage: 'Käyttö ja hyvitykset',
            settings_title: 'Muuttumattomat seurantapolut — Asetukset',
            settings_subtitle: 'Organisaatiokohtaiset asetukset Immutable Audit Trails -lisäosalle.',
            settings_banner: 'Muuttumaton seurantapolku -lisäosa ei ole käytössä organisaatiossasi. Ota se käyttöön tässä aloittaaksesi tason A- ja B-tarkastustapahtumien todisteiden ankkuroimisen.',
            status_title: 'Muuttumattomat kirjauspolut — todisteen tila',
            status_subtitle: 'Tapahtumakohtaiset todisteet moduulien välillä.',
            status_banner: 'Muuttumaton seurantapolku -lisäosa ei ole käytössä organisaatiossasi. Ota se käyttöön siirtymällä Asetuksiin.',
            integrity_center_title: 'Muuttumattomat seurantapolut — Integrity Center',
            integrity_center_subtitle: 'Tarkista todisteet ja vie Integrity Packs.',
            integrity_center_banner: 'Muuttumaton seurantapolku -lisäosa ei ole käytössä organisaatiossasi. Ota se käyttöön asetuksissa ennen vahvistuksen suorittamista tai Integrity Packs -pakettien vientiä.',
            usage_title: 'Muuttumattomat seurantapolut — käyttö ja hyvitykset',
            usage_subtitle: 'Luottosaldo, pakettiostot ja käyttöhistoria.',
            usage_banner: 'Ota muuttumattomat seurantapolut käyttöön asetuksissa, jotta voit alkaa kuluttaa todisteita.',
            module_tips_placeholder: 'Vinkkejä ja ohjeita tälle pinnalle on saatavilla ohjekeskuksessa.',
            column_label: 'Todistus',
            no_proof_aria: 'Todisteita ei tallennettu',
            proof_status_receipt_label: 'kuitti {id}',
            in_progress_hint: 'Käynnissä — päivittyy automaattisesti',
            status_pills: {
                pending: 'Odottaa',
                submitted: 'Lähetetty',
                anchored: 'Ankkuroitu',
                confirmed: 'Vahvistettu',
                retrying: 'Yritetään uudelleen',
                paused_cap: 'Keskeytetty (Cap)',
                failed: 'Epäonnistui',
                failed_auth: 'Todennus epäonnistui',
            },
            status_tooltips: {
                pending: 'Odottaa — jonossa vedospalveluun. Siirtyy pian kohtaan Lähetetty; toimenpiteitä ei tarvita.',
                submitted: 'Lähetetty – tapahtumasi lähetettiin todistepalveluun. Erätilassa se odottaa sulkemista ja ankkuroimista ketjuun. Päivittyy automaattisesti; toimenpiteitä ei tarvita.',
                anchored: 'Ankkuroitu — erä on kirjoitettu ketjuun ja odottaa lopullista vahvistusta. Päivittyy automaattisesti; toimenpiteitä ei tarvita.',
                confirmed: 'Vahvistettu — todiste on ankkuroitu ketjuun ja tarkistettavissa.',
                retrying: 'Yritetään uudelleen – tapahtui ohimenevä virhe. Täsmäytysohjelma yrittää uudelleen automaattisesti; toimenpiteitä ei tarvita.',
                paused_cap: 'Keskeytetty – kuukausittainen luottorajasi on saavutettu. Lunasta lisää luottoja tai odota seuraavaan laskutuskuukauteen.',
                failed: 'Epäonnistui – ankkurointi ei onnistunut. Täsmäytysohjelma yrittää uudelleen automaattisesti; ota yhteyttä tukeen, jos se jatkuu.',
                failed_auth: 'Todennus epäonnistui – todistuspalvelu hylkäsi valtuustietomme. Tarkista muuttumattomien seurantapolkujen asetukset -sivu.',
            },
            mode_pills: {
                direct: 'Suora',
                batch: 'Erä',
            },
            drawer: {
                title: 'Todistuksen yksityiskohdat',
                close: 'Sulje',
                section_proof: 'Todistus',
                section_batch: 'Eräjäsenyys',
                status: 'Tila',
                proof_reference: 'Todistusviittaus',
                receipt_id: 'Kuitin tunnus',
                taxonomy_class: 'Taksonomian luokka',
                units_consumed: 'Kulutetut yksiköt',
                created_at: 'Luotu',
                verification_ref: 'Ketjun vahvistusviite',
                chain: 'Ketju',
                tx_hash: 'Tx hash',
                block_ref: 'Block ref',
                batch_reference: 'Eräviite',
                leaf_index: 'Lehtiindeksi',
                local_event_hash: 'Paikallinen tapahtuma hash',
                show_inclusion: 'Näytä sisällyttämispolku',
                hide_inclusion: 'Piilota sisällyttämispolku',
                privacy_note: 'Hyötykuorma on hajautettu; ComplianceOne ei jättänyt henkilötietoja tälle tapahtumalle.',
                verify_now: 'Vahvista nyt',
                verify_pending: 'Vahvistus käynnissä…',
                verify_verified: 'Vahvistettu – paikalliset + ketjupuolen tarkastukset läpäisty.',
                verify_issue_prefix: 'Vahvistusongelma: ',
                verify_failed: 'Vahvistuspuhelu epäonnistui.',
                verify_result_prefix: 'Vahvistuspäätös:',
                verify_pending_note: 'Varmistus odottaa: tämä todistus odottaa edelleen ketjun ankkuroimista. Yritä uudelleen, kun erä on suljettu.',
                awaiting_anchor_note: 'Tämä todiste on osa avointa erää. Vahvistus tulee saataville, kun erä on sinetöity ja ankkuroitu ketjuun – yleensä organisaation määritetyn eräikkunan sisällä. Tilamerkki päivittyy automaattisesti.',
                terminal_error_note: 'Tämä todiste ei onnistunut ankkuroitumaan. Todistuksen tilan täsmäytysohjelma yrittää uudelleen automaattisesti; manuaalisessa vahvistuksessa ei ole vielä mitään tarkistettavaa.',
            },
            integrity_center: {
                section_run: 'Suorita vahvistus',
                section_progress: 'Suorita edistyminen',
                section_issues: 'Ongelmat',
                period_start: 'Jakson alku',
                period_end: 'Kauden loppu',
                module_filter: 'Moduulit (pilkuilla erotettu, valinnainen)',
                modules_placeholder: 'rights_requests, tapahtumat',
                run_button: 'Suorita vahvistus',
                export_button: 'Vie Integrity Pack',
                export_success: 'Integrity Pack vietiin.',
                export_failed: 'Vienti epäonnistui.',
                empty_disabled: 'Ota muuttumattomat seurantareitit käyttöön asetuksissa suorittaaksesi vahvistuspassit.',
                error_period_required: 'Valitse aloitus- ja lopetuspäivä.',
                error_start_run: 'Juoksun aloittaminen epäonnistui.',
                processed: 'Käsitelty: [[TOK_2]] / [[TOK_3]]',
                col_verdict: 'Tuomio',
                col_count: 'Count',
                col_proof_link: 'Todistuslinkki',
                col_module: 'Moduuli',
                col_event_type: 'Tapahtuman tyyppi',
                col_expected: 'Odotettu hash',
                col_recomputed: 'Uudelleen laskettu hash',
                col_raised_at: 'Nostettu klo',
                any_verdict: 'Mikä tahansa tuomio',
                no_issues: 'Ei ongelmia.',
            },
            settings_page: {
                load_error: 'Asetusten lataaminen epäonnistui.',
                save: 'Tallenna',
                save_success: 'Asetukset tallennettu.',
                save_error: 'Tallennus epäonnistui.',
                discard: 'Hylkää muutokset',
                read_only_banner: 'Sinulla on vain luku -oikeus. Ota yhteyttä alustan järjestelmänvalvojaan muutosten tekemiseksi.',
                section_status: 'Tila ja käyttöönotto',
                enabled_label: 'Lisäosa käytössä',
                enabled_help: 'Kun tämä on käytössä, jokainen tason A ja tason B tarkastustapahtuma tiivistetään ja ankkuroidaan.',
                section_scope: 'Laajuus',
                scope_self: 'Vain itse',
                scope_self_and_children: 'Itse- ja lapsiorganisaatiot',
                scope_children_only: 'Vain lapset (vanhempi ei todista omia tapahtumiaan)',
                section_mode: 'Oletustodistustila',
                mode_direct: 'Suora (yksi ankkuri tapahtumaa kohden)',
                mode_batch: 'Erä (Merkle-juuren ankkuri ryhmää kohti)',
                mode_hybrid: 'Hybridi (luokkakohtainen rekisterioletus)',
                batch_window_label: 'Eräikkuna (minuutit, 1–60)',
                section_taxonomy: 'Suojattu tapahtumataksonomia',
                taxonomy_help: 'Tapahtuma-luokan ohitukset. Taso A → suora tila, taso B → erätila, pois päältä → ei varmennettu.',
                taxonomy_search: 'Haku ohittaa',
                taxonomy_reset: 'Palauta oletusasetukset',
                taxonomy_event_class: 'Tapahtumaluokka',
                taxonomy_override: 'Ohita',
                taxonomy_actions: 'Toiminnot',
                taxonomy_clear: 'Selkeä',
                taxonomy_no_overrides: 'Ei ohituksia — käytetään rekisterin oletusasetuksia.',
                taxonomy_add_class: 'event_class.koodi',
                taxonomy_add: 'Lisää ohitus',
                section_privacy: 'Yksityisyyden hallinta',
                privacy_log_actor_ip: 'Loki näyttelijän IP',
                privacy_log_user_agent: 'Kirjaa käyttäjäagentti',
                privacy_privileged_access_proofing: 'Todista etuoikeutetut lukemat (Tier A)',
                privacy_note: 'Muutokset koskevat vain tulevaisuutta.',
                section_caps: 'Rajat ja rajat',
                cap_label: 'Kuukausikatto (yksikköä; tyhjä = rajoittamaton)',
                warn_label: 'Varoituskynnys (yksiköt; on oltava pienempi kuin yläraja)',
                auto_pause_label: 'Keskeytä uudet vedokset automaattisesti, kun enimmäismäärä on saavutettu',
                section_export: 'Vie käyttöoikeus',
                export_help: 'Roolitunnukset saavat viedä Integrity Packs -paketteja. Pilkuilla erotettu; tyhjä = käytä IMMUTABLE_AUDIT_TRAILS_EXPORT-oletuslupaa.',
                section_group: 'Ryhmään osallistuminen',
                group_view_intro: 'Sinut on määritetty ryhmän vanhemmiksi. Jokainen lapsiorganisaatio hallitsee omaa käyttöönottoaan/poistamistaan; heidän päätöksensä koostuvat laskutuksestasi ryhmälaskutussääntöjen mukaisesti.',
                group_view_rule_enabled: 'Lapsi, jolla on enabled=false, näytetään "Ei osallistu". Näet poissaolon; lapsi hallitsee kytkintä.',
                group_view_rule_billing: 'Lastenkulutus kertyy kuukausikattoon. Katso käyttösivua seurataksesi yhdistettyä palamisnopeutta.',
                group_view_rule_edit: 'Et voi muokata lapsen asetuksia tällä sivulla. Avaa alatason organisaatio suoraan muokataksesi.',
                group_view_open_groups: 'Avaa Organisaatioryhmät',
                section_credentials: 'Valtuustiedot',
                credential_id: 'Valtuustietotunnus',
                credential_rotated_at: 'Viimeksi käännetty',
                rotate_button: 'Kierrä tunnistetietoja',
                rotate_success: 'Tunnuksia kierretty. Vanhat kirjautumistiedot ovat voimassa vielä [[TOK_1]] minuuttia.',
                rotate_failed: 'Tunnistetietojen kierto epäonnistui.',
                rotate_modal_title: 'Kierretäänkö [[TOK_0]]-kirjautumistietoja?',
                rotate_modal_body: 'Rotaatio antaa uuden valtuustodistuksen. [[TOK_0]] hyväksyy vanhat valtuustiedot 60 minuutin lisäajan ajaksi, jotta lennolla olevat työntekijät voivat lopettaa nykyisen työnsä. 60 minuutin kuluttua vanha valtuutus peruutetaan.',
                rotate_modal_confirm: 'Pyöritä nyt',
                tier_a_off_modal_title: 'Poistetaanko tapahtumaluokan tarkistus käytöstä?',
                tier_a_off_modal_body: 'Tapahtumaluokan asettaminen tilaan "Pois" estää todistusta ankkuroimasta näitä tapahtumia. Arkkitehtuuri §6 selittää sääntelyn vaikutuksen: A-tason tapahtumat ovat sääntelyn kannalta tärkeitä; niiden poistaminen käytöstä voi rikkoa kirjausketjun puolustettavuuden.',
                tier_a_off_modal_confirm: 'Ymmärrän – käytä ohitusta',
                error_warn_lt_cap: 'Varoitusrajan on oltava pienempi kuin kuukausiraja.',
                error_window_range: 'Eräikkunan on oltava 1–60 minuuttia.',
                error_run_in_progress: 'Varmistusajo on käynnissä; lisäosaa ei voi poistaa käytöstä juuri nyt.',
            },
            status_page: {
                filter_status: 'Tila',
                filter_mode: 'Todistustila',
                filter_module: 'Moduuli',
                filter_source_collection: 'Lähdekokoelma',
                filter_from_date: 'From',
                filter_to_date: 'Vastaanottaja',
                filter_search: 'Etsi',
                any_status: 'Mikä tahansa tila',
                any_mode: 'Mikä tahansa tila',
                col_module: 'Moduuli',
                col_event_type: 'Tapahtuman tyyppi',
                col_proof_status: 'Tila',
                col_proof_mode: 'tila',
                col_created_at: 'Luotu',
                col_units: 'Yksiköt',
                empty_disabled: 'Muuttumaton seurantapolku -lisäosa ei ole käytössä organisaatiossasi. Ota se käyttöön siirtymällä Asetuksiin.',
                empty_enabled_no_rows: 'Mikään todistelinkki ei vastaa nykyisiä suodattimia.',
                export_csv: 'Vie [[TOK_0]]',
                export_xlsx: 'Vie [[TOK_0]]',
                export_success: 'Vienti valmis',
                export_failed: 'Vienti epäonnistui',
            },
            usage_page: {
                section_alerts: 'Hälytykset',
                alert_dismiss: 'Hylkää',
                alert_dismiss_aria: 'Hylkää ilmoitus [[TOK_1]]',
                alert_dismissed: 'Hälytys hylätty',
                alert_dismiss_failed: 'Hälytyksen hylkääminen epäonnistui',
                section_balance: 'Luottosaldo',
                balance_label: 'Saatavilla olevat krediitit',
                balance_hint: 'Yksiköt jäljellä (1 yksikkö = 1 suojattu tapahtumavarma).',
                section_current_month: 'Nykyinen kuukausi',
                consumed_label: 'Kulutettu',
                granted_label: 'Myönnetty',
                refunded_label: 'Hyvitetty',
                net_label: 'Net',
                section_history: 'Käyttöhistoria',
                history_kind: 'Ystävällinen',
                history_units: 'Yksiköt',
                history_balance_after: 'Saldo jälkeen',
                history_notes: 'Huomautuksia',
                history_at: 'Milloin',
                cap_warning_banner: 'Olet ylittänyt tämän laskutuskuukauden varoitusrajan. Harkitse lisäkrediittien lunastamista.',
                cap_paused_banner: 'Kuukausikatto saavutettu. Todisteiden toimittaminen keskeytetään seuraavaan kuukauteen tai kunnes enimmäismäärää nostetaan.',
                section_redeem: 'Lunasta luottopaketti',
                redeem_purchase_id: 'Laskun numero',
                redeem_package: 'Paketti',
                redeem_button: 'Lunasta',
                redeem_pending: 'Lunastetaan…',
                redeem_success: 'Krediitit lunastettu',
                redeem_failed: 'Lunastus epäonnistui',
                redeem_option_template: '[[TOK_4]] — [[TOK_5]] [[TOK_6]] — [[TOK_7]]',
                redeem_option_units: 'yksiköitä',
                alert_dismissing: 'Hylätään…',
                alert_kind: {
                    cap_reached: 'Kuukausikatto saavutettu',
                    low_balance: 'Matala tasapaino',
                    auth_failure: 'Todennus epäonnistui',
                    merkle_mismatch: 'Merklen yhteensopimattomuus',
                    batch_terminal_failure: 'Eräpäätteen vika',
                    direct_terminal_failure: 'Suoran lähetyksen päätevirhe',
                },
                usage_kind: {
                    consume: 'Kuluttaa',
                    refund: 'Hyvitys',
                    grant: 'Grant',
                    adjustment: 'Säätö',
                    reservation: 'Varaus',
                },
                package_starter: 'Aloittaja',
                package_growth: 'Kasvu',
                package_enterprise: 'Yritys',
                // Sprint 48.5.x — self-service "Buy More" billing (Flow A + B).
                buy_more: {
                    buy_button: 'Osta lisää krediittejä',
                    purchase_title: 'Osta lisää krediittejä',
                    purchase_subtitle: 'Valitse paketti. Sinut ohjataan turvalliseen Stripe-maksuun, ja laskusi saapuu sähköpostitse.',
                    checkout_button: 'Jatka maksamaan',
                    checkout_pending: 'Avataan maksua…',
                    cancel_button: 'Peruuta',
                    purchase_error: 'Maksua ei voitu aloittaa. Yritä pian uudelleen.',
                    redeem_subtitle: 'Jo maksettu? Valitse ostamasi paketti ja syötä laskun tunnus sähköpostistasi lisätäksesi krediitit.',
                    error_not_found: 'Kyseisellä numerolla ei löytynyt laskua. Tarkista laskun numero ja yritä uudelleen.',
                    error_not_paid: 'Tätä laskua ei ole vielä merkitty maksetuksi.',
                    error_org_mismatch: 'Tätä laskua ei ole myönnetty organisaatiollesi.',
                    error_package_mismatch: 'Tämä lasku ei vastaa valittua pakettia.',
                    error_billing_unavailable: 'Laskutuspalveluun ei saatu yhteyttä. Yritä pian uudelleen.',
                },
            },
        },
        files_config: {
            title: 'Tiedostojen asetukset',
            subtitle: 'Määritä tiedostojen latausrajat, säilytyskäytännöt ja omistajakohtaiset ohitukset alustan liitepinnalle.',
            section_global: 'Globaalit oletusasetukset',
            section_global_help: 'Nämä rajoitukset koskevat kaikkia organisaatiosi käyttäjien lataamia tiedostoja, ellei alla oleva omistajakohtainen ohitus muuta niitä.',
            section_overrides: 'Omistajakohtaiset ohitukset',
            section_overrides_help: 'Ohita tietyn omistajatyypin yleiset rajoitukset. Omistajakohtaiset arvot voittaa aina globaalin asetuksen.',
            max_file_size_label: 'Tiedoston enimmäiskoko',
            max_file_size_hint: 'Yksittäinen lataus (MiB)',
            max_total_attachments_label: 'Liitteiden enimmäismäärä',
            max_total_attachments_hint: 'Koko organisaatiossa',
            max_total_size_label: 'Tallennustilan enimmäismäärä yhteensä',
            max_total_size_hint: 'Koko organisaatiossa (MiB)',
            allowed_mime_types_label: 'Sallitut tiedostotyypit',
            allowed_mime_types_placeholder: 'Valitse MIME-tyypit',
            retention_days_label: 'Säilytysaika (päiviä)',
            retention_days_hint: 'Kuinka kauan tiedostoja on säilytettävä, ennen kuin ne voidaan poistaa. Jätä tyhjäksi, jos et halua säilyttää säilytyskäytäntöä.',
            legal_hold_label: 'Laillinen pito',
            legal_hold_hint: 'Kun tämä on käytössä, tämän omistajatyypin tiedoston poistaminen vaatii laillisen säilytyksen ohitusoikeuden ja operaattorin nimenomaisen valinnan.',
            save: 'Tallenna muutokset',
            saving: 'Tallennetaan…',
            reset: 'Nollaa',
            save_success: 'Asetukset tallennettu',
            save_version_conflict: 'Toinen operaattori päivitti nämä asetukset muokkauksen aikana. Päivitä nähdäksesi uusimmat arvot.',
            empty_state_title: 'Käytä alustan oletusasetuksia',
            empty_state_body: 'Organisaatiosi käyttää tällä hetkellä alustan oletustiedostokäytäntöä. Luo organisaatiotason ohitus muokkaamalla mitä tahansa alla olevaa arvoa.',
            read_only_banner: 'Sinulla on vain luku -oikeus tiedostokokoonpanoon. Ota yhteyttä alustan järjestelmänvalvojaan muutosten tekemiseksi.',
            owner_type_default_badge: 'Oletus',
            owner_type_overridden_badge: 'Ohitettu',
            owner_type_label: 'Omistajan tyyppi',
            owner_type_collapse: 'Kutista',
            owner_type_expand: 'Laajenna',
            override_save: 'Tallenna ohitus',
            override_remove: 'Poista ohitus',
            mime_labels: {
                'application/pdf': '[[TOK_0]] asiakirja',
                'image/png': 'PNG-kuva',
                'image/jpeg': 'JPEG-kuva',
                'image/jpg': 'JPG-kuva',
                'application/msword': 'Word-asiakirja (vanha)',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word-asiakirja',
                'application/vnd.ms-excel': 'Excel-laskentataulukko (vanha)',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel-laskentataulukko',
                'text/csv': '[[TOK_0]] tiedosto',
                'text/plain': 'Pelkkää tekstiä',
                'message/rfc822': 'Sähköpostiviesti',
            },
        },
        files_browser: {
            title: 'Tiedostoselain',
            subtitle: 'Hae, suodata ja hallitse kaikkia organisaatioon ladattuja liitteitä.',
            filter_owner_type: 'Omistajan tyyppi',
            filter_uploader: 'Lähettäjä',
            filter_from: 'Ladattu jälkeen',
            filter_to: 'Ladattu aiemmin',
            filter_size_min: 'Minimikoko (MiB)',
            filter_size_max: 'Suurin koko (MiB)',
            filter_mime: 'Tiedostotyyppi',
            filter_deleted_state: 'Poistotila',
            filter_deleted_any: 'Kaikki tiedostot',
            filter_deleted_only: 'Vain poistettu',
            filter_deleted_exclude: 'Sulje pois poistettu',
            filter_orphaned: 'Vain orvot',
            filter_search_placeholder: 'Etsi tiedostonimi…',
            filter_apply: 'Käytä suodattimia',
            filter_clear: 'Selkeät suodattimet',
            col_filename: 'Tiedostonimi',
            col_owner_type: 'Omistajan tyyppi',
            col_owner_entity: 'Omistaja',
            col_uploader: 'Lähettäjä',
            col_uploaded_at: 'Ladattu',
            col_size: 'Koko',
            col_mime: 'Kirjoita',
            col_state: 'Tila',
            col_actions: 'Toiminnot',
            state_active: 'Aktiivinen',
            state_deleted: 'Poistettu',
            state_orphaned: 'Orvoksi jäänyt',
            action_view_detail: 'Näytä tiedot',
            action_download: 'Lataa',
            action_ai_edits: '[[TOK_0]] Muokkaukset',
            action_soft_delete: 'Pehmeä poisto',
            action_restore: 'Palauta',
            action_hard_delete: 'Pysyv? poisto',
            bulk_soft_delete: 'Pehmeä poisto valittu',
            bulk_export_csv: 'Vie [[TOK_0]]',
            bulk_select_all: 'Valitse kaikki',
            reason_label: 'Syy',
            reason_min_10_chars: 'Syy vaaditaan (vähintään 10 merkkiä)',
            reason_min_20_chars: 'Syy vaaditaan (vähintään 20 merkkiä)',
            legal_hold_override_label: 'Ohita laillinen säilytysvaatimus',
            legal_hold_override_warning: 'Tämä tiedosto on säilytysvaatimuksen alainen. Kova poistaminen kirjataan kirjausketjuun syyn ja ohituslipun kanssa.',
            empty_state_title: 'Yksikään tiedosto ei vastaa suodattimiasi',
            empty_state_body: 'Säädä suodattimiasi nähdäksesi tulokset tai tyhjennä ne nähdäksesi kaikki tiedostot.',
            pagination_prev: 'Edellinen',
            pagination_next: 'Seuraavaksi',
            pagination_page: 'Sivu [[TOK_2]]/[TOK_3]]',
            pagination_size_label: 'per sivu',
            pagination_total: 'Yhteensä: [[TOK_1]]',
            toast_soft_deleted: 'Tiedosto poistettu pehmeästi',
            toast_restored: 'Tiedosto palautettu',
            toast_hard_deleted: 'Tiedosto poistettu pysyvästi',
            toast_bulk_deleted: '[[TOK_1]] tiedosto(t) poistettu',
            toast_error: 'Toiminto epäonnistui',
            confirm_soft_delete_title: 'Pehmeä poista tiedosto',
            confirm_restore_title: 'Palauta tiedosto',
            confirm_hard_delete_title: 'Poista tiedosto pysyvästi',
            confirm_bulk_soft_delete_title: 'Valittujen tiedostojen pehmeä poistaminen',
            confirm_submit: 'Vahvista',
            confirm_cancel: 'Peruuta',
        },
        files_detail: {
            modal_title: 'Tiedoston tiedot',
            close: 'Sulje',
            meta_filename: 'Tiedostonimi',
            meta_size: 'Koko',
            meta_mime: 'Kirjoita',
            meta_owner_type: 'Omistajan tyyppi',
            meta_owner_entity: 'Omistajakokonaisuus',
            meta_uploader: 'Lähettäjä',
            meta_uploaded_at: 'Ladattu',
            meta_storage_path: 'Tallennuspolku',
            meta_deleted_state: 'Poistotila',
            audit_section_title: 'Kirjausketju',
            audit_load_more: 'Lataa lisää tapahtumia',
            audit_empty: 'Tälle tiedostolle ei ole tallennettu tarkastustapahtumia.',
            audit_config_changed: 'Kokoonpano muutettu',
            audit_soft_deleted: 'Pehmeä-poistettu',
            audit_restored: 'Palautettu',
            audit_hard_deleted: 'Poistettu pysyvästi',
            audit_downloaded: 'Ladattu',
            audit_quota_breached: 'Kiintiön rikkomista yritettiin',
            action_download: 'Lataa',
            action_soft_delete: 'Pehmeä poisto',
            action_restore: 'Palauta',
            action_hard_delete: 'Pysyv? poisto',
            effective_settings_title: 'Tehokas politiikka',
            effective_max_file_size: 'Tiedoston enimmäiskoko',
            effective_retention_days: 'Säilytys',
            effective_legal_hold: 'Laillinen pito',
            effective_legal_hold_yes: 'Aktiivinen',
            effective_legal_hold_no: 'Ei mitään',
        },
        files_dashboard: {
            title: 'Tiedostojen hallintapaneeli',
            subtitle: 'Tallennustilan käyttö, kasvu ja orvot tiedostot koko organisaatiossa.',
            kpi_total_files: 'Tiedostot yhteensä',
            kpi_total_size: 'Tallennustila yhteensä',
            kpi_near_quota: 'Kiintiön käyttö',
            kpi_orphaned: 'Orvot tiedostot',
            chart_by_owner_type: 'Tiedostot omistajatyypin mukaan',
            chart_growth_30d: '30 päivän kasvu',
            toggle_count: 'Laskun mukaan',
            toggle_size: 'Koon mukaan',
            orphaned_panel_title: 'Orvot tiedostot (20 parasta)',
            orphaned_view_all: 'Näytä kaikki orvot tiedostot',
            orphaned_empty: 'Orpotiedostoja ei löytynyt.',
            growth_empty: 'Ei lataustoimintaa viimeisen 30 päivän aikana.',
            retention_n_days: '[[TOK_1]] päivää',
            retention_none: 'Ei politiikkaa',
        },
    },
    category_labels: {
        'user-guide': 'Käyttöopas',
        'admin-guide': 'Järjestelmänvalvojan opas',
        'getting-started': 'Aloitus',
        faq: 'FAQ',
    },
    tag_labels: {
        faq: 'FAQ',
        dsar: 'DSAR',
        dsr: 'DSR',
        cmp: 'CMP',
        hmac: 'HMAC',
        sso: 'SSO',
        mfa: 'MFA',
        rbac: 'RBAC',
        api: 'API',
        'api-keys': '[[TOK_0]] Näppäimet',
        webhook: 'Webhook',
        webhooks: 'Webhooks',
        admin: 'Admin',
        aesirx: 'AesirX',
        purposes: 'Tarkoitukset',
        preferences: 'Asetukset',
        onboarding: 'Käyttöönotto',
        'first-steps': 'Ensimmäiset askeleet',
        login: 'Kirjaudu sisään',
        navigation: 'Navigointi',
        users: 'Käyttäjät',
        user: 'Käyttäjä',
        roles: 'Roolit',
        role: 'Rooli',
        'access-control': 'Kulunvalvonta',
        'access-management': 'Käyttöoikeuksien hallinta',
        permissions: 'Käyttöoikeudet',
        permission: 'Lupa',
        consent: 'Suostumus',
        'consent-management': 'Suostumuksen hallinta',
        privacy: 'Yksityisyys',
        pdpl: 'PDPL',
        gdpr: 'GDPR',
        iso27001: 'ISO 27001',
        audit: 'Audit',
        auditing: 'Tilintarkastus',
        breach: 'Rikkominen',
        incident: 'Tapahtuma',
        incidents: 'Tapahtumat',
        notification: 'Ilmoitus',
        notifications: 'Ilmoitukset',
        reporting: 'Raportointi',
        risk: 'Riski',
        vendor: 'Myyjä',
        vendors: 'Myyjät',
        'vendor-risk': 'Myyjän riski',
        assessment: 'Arviointi',
        assessments: 'Arvioinnit',
        dpia: 'DPIA',
        'cross-border': 'Rajat ylittävä',
        transfer: 'Siirto',
        transfers: 'Siirrot',
        deletion: 'Poistaminen',
        retention: 'Säilytys',
        'data-mapping': 'Tietojen kartoitus',
        discovery: 'Löytö',
        classification: 'Luokittelu',
        workflow: 'Työnkulku',
        workflows: 'Työnkulut',
        template: 'Malli',
        templates: 'Mallit',
        catalog: 'Katalogi',
        monitoring: 'Valvonta',
        tasks: 'Tehtävät',
        task: 'Tehtävä',
        'task-management': 'Tehtävien hallinta',
        organizations: 'Organisaatiot',
        org: 'Organisaatio',
        governance: 'Hallinto',
        compliance: 'Vaatimustenmukaisuus',
        forms: 'Lomakkeet',
        form: 'Lomake',
        connectors: 'Liittimet',
        connector: 'Liitin',
        integration: 'Integrointi',
        integrations: 'Integraatiot',
        security: 'Turvallisuus',
        encryption: 'Salaus',
        backup: 'Varmuuskopio',
        recovery: 'Toipuminen',
        maintenance: 'Huolto',
        settings: 'Asetukset',
        configuration: 'Kokoonpano',
        sla: 'SLA',
        escalation: 'Eskaloituminen',
        remediation: 'Korjaus',
        evidence: 'Todisteet',
        'case-management': 'Tapausten hallinta',
        profile: 'Profiili',
        delegation: 'valtuuskunta',
        'service-accounts': 'Palvelutilit',
        license: 'Lisenssi',
        'license-management': 'Lisenssien hallinta',
        plan: 'Suunnittele',
        plans: 'Suunnitelmat',
        dashboard: 'Kojelauta',
        'web-consent': 'Verkkosuostumus',
        'partner-marketplace': 'Kumppanimarkkinapaikka',
        partner: 'Kumppani',
        partners: 'Yhteistyökumppanit',
        deliverables: 'Toimitettavat tuotteet',
        'service-tiers': 'Palvelutasot',
        'support-tickets': 'Tukiliput',
        'audit-trail': 'Audit Trail',
        'first-time-setup': 'Ensiasennus',
        setup: 'Asennus',
        quickstart: 'Pika-aloitus',
        tour: 'Tour',
        tours: 'Matkat',
        'sample-data': 'Esimerkkitiedot',
        'data-subject': 'Rekisteröity',
        'data-subjects': 'Rekisteröidyt',
        pseudonymous: 'Pseudonyymi',
        identified: 'Tunnistettu',
        'help-center': 'Ohjekeskus',
        article: 'Artikkeli',
        articles: 'Artikkelit',
        search: 'Etsi',
        'platform-settings': 'Alustan asetukset',
        'platform-config': 'Alustan asetukset',
        'module-config': 'Moduulin konfigurointi',
        'module-configuration': 'Moduulin konfigurointi',
        'rights-requests': 'Oikeuspyynnöt',
        'access-accountability': 'Käytä vastuullisuutta',
        'data-discovery': 'Data Discovery',
        'incident-ops': 'Tapahtumaoperaatiot',
        'deletion-orchestration': 'Poiston orkestrointi',
        'compliance-forms': 'Vaatimustenmukaisuuslomakkeet',
        'program-governance': 'Ohjelman hallinto',
        localization: 'Lokalisointi',
        'privacy-scanner': 'Yksityisyysskanneri',
        'consent-properties': 'Suostumuksen ominaisuudet',
        acceptances: 'Hyväksynnät',
        access: 'Pääsy',
        'access-review': 'Access Review',
        'access-reviews': 'Pääsy arvosteluihin',
        accountability: 'Vastuullisuus',
        acknowledgment: 'Tunnustus',
        'action-plans': 'Toimintasuunnitelmat',
        activation: 'Aktivointi',
        activations: 'Aktivoinnit',
        'active-response': 'Aktiivinen vastaus',
        activity: 'Toiminta',
        adequacy: 'Riittävyys',
        'admin-guide': 'Järjestelmänvalvojan opas',
        aggregation: 'Aggregointi',
        agreements: 'sopimukset',
        ai: 'AI',
        alerts: 'Hälytykset',
        analytics: 'Analytics',
        anchoring: 'Ankkurointi',
        approval: 'Hyväksyntä',
        approvals: 'Hyväksynnät',
        apps: 'Sovellukset',
        assets: 'Omaisuus',
        assignments: 'Tehtävät',
        attestation: 'Todistus',
        'audit-log': 'Tarkastusloki',
        'audit-pack': 'Tarkastuspaketti',
        authentication: 'Todennus',
        authority: 'Viranomainen',
        'auto-play': 'Automaattinen toisto',
        automated: 'Automatisoitu',
        automation: 'Automaatio',
        baseline: 'Perustaso',
        batches: 'Erät',
        bidirectional: 'Kaksisuuntainen',
        bilingual: 'Kaksikielinen',
        bindings: 'Sidokset',
        blockchain: 'Blockchain',
        board: 'taulu',
        brand: 'Tuotemerkki',
        brds: 'BRD:t',
        'break-glass': 'Break-Glass',
        builder: 'Rakentaja',
        bulk: 'Bulkki',
        'bulk-sync': 'Joukkosynkronointi',
        bundles: 'Kimput',
        calendar: 'Kalenteri',
        campaigns: 'Kampanjat',
        cases: 'Tapaukset',
        categories: 'Luokat',
        category: 'Luokka',
        certification: 'Sertifiointi',
        chain: 'Ketju',
        change: 'Muuta',
        'change-awareness': 'Muutostietoisuus',
        'change-log': 'Muutosloki',
        'change-management': 'Muutosten hallinta',
        'change-requests': 'Muutospyynnöt',
        'cmp-validation': '[[TOK_0]] Vahvistus',
        collection: 'Kokoelma',
        comparison: 'Vertailu',
        completeness: 'Täydellisyys',
        completion: 'Valmistuminen',
        'compliance-posture': 'Vaatimustenmukaisuusasento',
        'compliance-proof': 'Todiste vaatimustenmukaisuudesta',
        'compliance-reviews': 'Vaatimustenmukaisuusarvostelut',
        config: 'Konfig',
        confirmation: 'Vahvistus',
        conflicts: 'Konfliktit',
        consolidation: 'Konsolidointi',
        continuous: 'Jatkuva',
        contracts: 'Sopimukset',
        controls: 'Säätimet',
        cookies: 'Evästeet',
        cooperation: 'Yhteistyö',
        coordination: 'Koordinointi',
        'corporate-governance': 'Yrityshallinto',
        'corrective-actions': 'Korjaavat toimet',
        coverage: 'Kattavuus',
        'credential-vault': 'Valtuustietoholvi',
        credentials: 'Valtuustiedot',
        cycles: 'Pyörät',
        dashboards: 'Kojelaudat',
        'data-assets': 'Tietovarat',
        'data-flows': 'Tietovirrat',
        'data-sensitivity': 'Tietojen herkkyys',
        'data-steward': 'Tietojen valvoja',
        deadlines: 'Määräajat',
        'decree-356': 'Asetus 356',
        dedup: 'Dedup',
        definitions: 'Määritelmät',
        deliverable: 'Toimitettava',
        departments: 'Osastot',
        'dependency-order': 'Riippuvuusjärjestys',
        deployment: 'Käyttöönotto',
        detection: 'Havaitseminen',
        diff: 'Diff',
        'digital-properties': 'Digitaaliset ominaisuudet',
        dimensions: 'Mitat',
        disable: 'Poista käytöstä',
        'disaster-recovery': 'Katastrofipalautus',
        disclosure: 'Tietojen paljastaminen',
        documentation: 'Dokumentaatio',
        documents: 'Asiakirjat',
        domains: 'Verkkotunnukset',
        dossier: 'Asiakirja',
        dpa: 'DPA',
        drift: 'Drift',
        'drift-detection': 'Poikkeaman tunnistus',
        'due-diligence': 'Due Diligence',
        email: 'S?hk?posti',
        emergency: 'Hätä',
        enable: 'Ota käyttöön',
        'enterprise-map': 'Yrityskartta',
        erasure: 'Poista',
        evaluation: 'Arviointi',
        'event-bus': 'Tapahtuman bussi',
        exceptions: 'Poikkeukset',
        execution: 'Toteutus',
        executive: 'Executive',
        exercises: 'Harjoitukset',
        export: 'Vie',
        exports: 'Vienti',
        filing: 'Arkistointi',
        filter: 'Suodata',
        filtering: 'Suodatus',
        findings: 'Havainnot',
        flows: 'Virtaukset',
        'follow-up': 'Seuranta',
        forensic: 'Oikeuslääketieteen',
        forensics: 'Forensics',
        'form-filler': 'Lomakkeen täyttö',
        framework: 'viitekehys',
        frameworks: 'Kehykset',
        'gap-analysis': 'Aukon analyysi',
        'gap-report': 'Aukkoraportti',
        gaps: 'aukkoja',
        gates: 'Portit',
        'getting-started': 'Aloitus',
        'golden-templates': 'Kultaiset mallit',
        grc: 'GRC',
        'group-management': 'Ryhmän hallinta',
        groups: 'ryhmät',
        'guided-tours': 'Opastetut kierrokset',
        guides: 'Oppaat',
        handling: 'Käsittely',
        'hands-on': 'Hands-On',
        health: 'Terveys',
        help: 'Apua',
        hierarchy: 'Hierarkia',
        history: 'Historia',
        i18n: 'i18n',
        iam: 'IAM',
        'identity-provider': 'Henkilöllisyyden tarjoaja',
        implementation: 'Toteutus',
        import: 'Tuo',
        improvement: 'Parantaminen',
        'incident-response': 'Tapahtumavastaus',
        inconsistencies: 'Epäjohdonmukaisuudet',
        instances: 'Esineet',
        intake: 'Saanti',
        'intake-key': 'Imuavain',
        interactive: 'Interaktiivinen',
        international: 'Kansainvälinen',
        inventory: 'Varasto',
        investigation: 'Tutkinta',
        investigations: 'Tutkimukset',
        'ip-allowlist': 'IP-sallitut lista',
        issues: 'Ongelmat',
        justification: 'Perustelut',
        justifications: 'Perustelut',
        kanban: 'Kanban',
        keyboard: 'Näppäimistö',
        keys: 'Avaimet',
        'knowledge-base': 'Tietokanta',
        koncernstyring: 'Corporate Governance',
        kpi: 'KPI',
        labeling: 'Merkinnät',
        language: 'Kieli',
        'language-packs': 'Kielipaketit',
        languages: 'Kielet',
        lawfulness: 'Laillisuus',
        layout: 'Asettelu',
        'legal-basis': 'Oikeusperusta',
        'lessons-learned': 'Oppitunnit',
        levels: 'Tasot',
        library: 'Kirjasto',
        lifecycle: 'Elinkaari',
        lineage: 'Sukuperä',
        links: 'Linkit',
        listings: 'Listaukset',
        live: 'Livenä',
        locale: 'Alue',
        log: 'Log',
        logging: 'Kirjaaminen',
        'managed-service': 'Hallittu palvelu',
        mapping: 'Kartoitus',
        mappings: 'Kartoitukset',
        'market-packs': 'Markkinapaketit',
        marketplace: 'Markkinapaikka',
        maturity: 'Kypsyys',
        metrics: 'Mittarit',
        models: 'Mallit',
        module: 'Moduuli',
        modules: 'Moduulit',
        mps: 'MPS',
        'multi-factor': 'Monitekijä',
        'multi-market': 'Multi-Market',
        'multi-org': 'Multi-Org',
        'multi-property': 'Monikiinteistö',
        'my-tasks': 'Omat tehtäväni',
        obligations: 'Velvollisuudet',
        offboarding: 'Offboarding',
        oidc: 'OIDC',
        orchestration: 'Orkestrointi',
        'org-groups': 'Organisaatioryhmät',
        organization: 'Organisaatio',
        overdue: 'Myöhässä',
        overview: 'Yleiskatsaus',
        'owner-review': 'Omistajan arvostelu',
        package: 'Paketti',
        packages: 'Paketit',
        packs: 'Pakkaukset',
        pagination: 'Sivutus',
        'parent-child': 'Vanhempi-lapsi',
        patterns: 'kuvioita',
        performance: 'Suorituskyky',
        periodic: 'Jaksottainen',
        periods: 'Jaksot',
        personal: 'Henkilökohtainen',
        'personal-data': 'Henkilötiedot',
        personas: 'Henkilöt',
        planning: 'Suunnittelu',
        platform: 'Alusta',
        playbooks: 'Toimintakirjat',
        poc: 'PoC',
        'point-in-time': 'Point-in-Time',
        policies: 'Käytännöt',
        portfolio: 'Portfolio',
        'post-incident': 'Tapahtuman jälkeinen',
        'power-user': 'Tehokäyttäjä',
        practice: 'Harjoittele',
        pricing: 'Hinnoittelu',
        'privacy-impact': 'Tietosuojavaikutus',
        procedures: 'Menettelyt',
        processes: 'Prosessit',
        processing: 'Käsittely',
        'processing-activities': 'Käsittelytoiminnot',
        procurement: 'Hankinta',
        productivity: 'Tuottavuus',
        profiles: 'Profiilit',
        programs: 'Ohjelmat',
        progress: 'Edistyminen',
        proof: 'Todistus',
        propagation: 'Lisääntyminen',
        properties: 'Ominaisuudet',
        'pub-sub': 'Pub-Sub',
        'public-form': 'Julkinen lomake',
        quality: 'Laatu',
        questionnaires: 'Kyselylomakkeet',
        'quick-links': 'Pikalinkit',
        'quick-start': 'Pika-aloitus',
        'quick-starts': 'Pikakäynnistykset',
        raci: 'RACI',
        readiness: 'Valmius',
        'real-time': 'Reaaliaikainen',
        reassessments: 'Uudelleenarvioinnit',
        reconciliation: 'Sovittelu',
        record: 'Record',
        records: 'Records',
        recurring: 'Toistuva',
        register: 'Rekisteröidy',
        registry: 'Rekisteri',
        regulations: 'määräyksiä',
        regulator: 'Säädin',
        regulatory: 'Sääntely',
        'regulatory-frameworks': 'Sääntelykehykset',
        remap: 'Reap',
        reminders: 'Muistutukset',
        reports: 'Raportit',
        requests: 'Pyynnöt',
        requirements: 'Vaatimukset',
        response: 'Vastaus',
        'response-plans': 'Vastaussuunnitelmat',
        'response-team': 'Vastausryhmä',
        'response-templates': 'Vastausmallit',
        'response-time': 'Vastausaika',
        responses: 'Vastaukset',
        responsibility: 'Vastuullisuus',
        results: 'Tulokset',
        review: 'Tarkista',
        reviews: 'Arvostelut',
        'right-to-delete': 'Oikeus poistaa',
        rights: 'Oikeudet',
        'risk-tiers': 'Riskitasot',
        rollouts: 'Käyttöönotto',
        rollup: 'Rollup',
        ropa: 'ROPA',
        routing: 'Reititys',
        rpo: 'RPO',
        rto: 'RTO',
        rules: 'säännöt',
        runs: 'Juoksee',
        saml: 'SAML',
        scan: 'Skannaa',
        scanning: 'Skannaus',
        scc: 'SCC',
        schedule: 'Aikataulu',
        scheduled: 'Aikataulutettu',
        schedules: 'Aikataulut',
        scheduling: 'Ajoitus',
        scores: 'Pisteet',
        scoring: 'Pisteytys',
        scripts: 'Käsikirjoitukset',
        'security-reviews': 'Turvallisuusarvostelut',
        'sensitive-data': 'Arkaluonteiset tiedot',
        sensitivity: 'Herkkyys',
        'separation-of-duties': 'Tehtävien erottaminen',
        service: 'Palvelu',
        sessions: 'Istunnot',
        'setup-wizard': 'Ohjattu asennustoiminto',
        severity: 'Vakavuus',
        'shared-governance': 'Jaettu hallinto',
        'shared-settings': 'Jaetut asetukset',
        shortcuts: 'Pikanäppäimet',
        sidebar: 'Sivupalkki',
        signals: 'Signaalit',
        'single-sign-on': 'Kertakirjautuminen',
        snapshots: 'Tilannekuvat',
        sod: 'SoD',
        sorting: 'Lajittelu',
        sources: 'Lähteet',
        staging: 'Lavastus',
        standards: 'Standardit',
        status: 'Tila',
        structure: 'Rakenne',
        'sub-processor': 'Aliprosessori',
        'sub-processors': 'Aliprosessorit',
        submissions: 'Lähetykset',
        subprocessors: 'Aliprosessorit',
        subscription: 'Tilaus',
        suggestions: 'ehdotuksia',
        summaries: 'Yhteenvedot',
        supplements: 'Lisäravinteet',
        support: 'Tuki',
        sync: 'Synkronoi',
        system: 'Järjestelmä',
        systems: 'Järjestelmät',
        tables: 'Taulukot',
        tagging: 'Merkintä',
        'tamper-proof': 'Peukaloinnin kestävä',
        taxonomies: 'Taksonomiat',
        taxonomy: 'Taksonomia',
        tenants: 'Vuokralaiset',
        termination: 'Irtisanominen',
        'third-party': 'Kolmas osapuoli',
        'ticket-sync': 'Lippujen synkronointi',
        tickets: 'Liput',
        tiers: 'Tasot',
        tokens: 'Tokenit',
        totp: 'TOTP',
        traceability: 'Jäljitettävyys',
        tracking: 'Seuranta',
        trail: 'Polku',
        training: 'Koulutus',
        translation: 'Käännös',
        translations: 'Käännökset',
        transparency: 'Läpinäkyvyys',
        trends: 'Trendit',
        unified: 'Yhtenäinen',
        updates: 'Päivitykset',
        validation: 'Validointi',
        vault: 'Holvi',
        'vendor-requests': 'Myyjän pyynnöt',
        verification: 'Vahvistus',
        versioning: 'Versiointi',
        versions: 'Versiot',
        vietnam: 'Vietnam',
        violations: 'Rikkomukset',
        visualization: 'Visualisointi',
        waivers: 'Poikkeukset',
        'web-records': 'Web Records',
        website: 'Verkkosivusto',
        websites: 'Verkkosivustot',
        weights: 'Painot',
        'white-label': 'Valkoinen etiketti',
        withdrawal: 'Nosto',
    },
    module_labels: {
        rights_requests: 'Tietopyynnöt',
        data_mapping: 'Tietokartoitus',
        governance: 'Toimittajahallinto',
        consent: 'Suostumushallinto',
        consent_properties: 'Suostumuksen ominaisuudet',
        assessments: 'Vaikutustenarvioinnit',
        classification: 'Tietojen luokitus',
        monitoring: 'Valvontaohjelmat',
        program: 'Valvontaohjelma',
        incidents: 'Tapausten hallinta',
        connectors: 'Liittimet',
        vendor_risk: 'Myyjän riski',
        deletion_orchestration: 'Poisto-orkestrointi',
        discovery: 'Tietojen löytäminen',
        incident_ops: 'Poikkeamatoiminnot',
        program_governance: 'Ohjelmahallinto',
        access_accountability: 'Pääsyvastuu',
        localization: 'Lokalisointi',
        partner_workspace: 'Kumppanityötila',
        privacy_scanner: 'Tietosuojaskanneri',
        onboarding: 'Käyttöönotto',
        compliance_forms: 'Vaatimustenmukaisuuslomakkeet',
        audit_trail: 'Tarkastuspolku',
        data_subjects: 'Rekisteröidyt',
        organizations: 'Organisaatiot',
        task_management: 'Tehtävien hallinta',
        deletion_orch: 'Poisto-orkestrointi',
        forms: 'Vaatimustenmukaisuuslomakkeet',
        partner_marketplace: 'Kumppanimarkkinapaikka',
        dashboard: 'Kojelauta',
        platform_settings: 'Alustan asetukset',
        help_center: 'Ohjekeskus',
    },
    module_descriptions: {
        rights_requests: 'Hallinnoi rekisteröityjen oikeuspyyntöjä, mukaan lukien pääsy, poistaminen ja siirrettävyys. Seuraa pyyntöjen elinkaarta, osoita käsittelijät ja täytä lakisääteiset määräajat.',
        data_mapping: 'Kartoita tietovirrat organisaatiossasi. Seuraa käsittelytoimia, tietokategorioita, tarkoituksia, säilytyskäytäntöjä ja järjestelmäintegraatioita.',
        governance: 'Hallinnoi toimittajien vaatimustenmukaisuutta ja hallintoa. Seuraa toimittaja-arviointeja, sopimuksia, SLA-suorituskykyä ja sääntelyvelvoitteita.',
        consent: 'Hallinnoi suostumuksen keräämistä, tallentamista ja peruuttamista. Seuraa suostumustietueita, tarkoituksia ja integrointia suostumuksenhallinnan alustoihin.',
        consent_properties: 'Määritä suostumusominaisuudet, ryhmät ja kultaiset mallit. Luo uudelleenkäytettäviä suostumuskonfiguraatioita yhtenäiseen käyttöönottoon.',
        assessments: 'Suorita tietosuojan vaikutustenarviointeja (DPIA) ja yksityisyysriskien arviointeja. Arvioi käsittelytoimien vaatimustenmukaisuusriskejä.',
        classification: 'Luokittele tietovarat herkkyystason mukaan. Käytä taksonomiatunnisteita, seuraa elinkaaren tietueita ja tunnista luokittelupuutteet.',
        monitoring: 'Perusta valvontaohjelmia vaatimustenmukaisuusmittareiden, keskeisten riski-indikaattorien ja valvonnan tehokkuuden seuraamiseen ajan kuluessa.',
        incidents: 'Raportoi ja hallinnoi yksityisyystapauksia ja tietomurtoja. Seuraa tutkinta-, ilmoitus- ja korjausprosesseja.',
        connectors: 'Määritä tietolähdekonnektorit ja integraatiot. Yhdistä ulkoiset järjestelmät automaattiseen tietojen löytämiseen ja valvontaan.',
        vendor_risk: 'Arvioi ja valvo kolmannen osapuolen toimittajariskejä. Pisteytä toimittajat, seuraa riskien vähentämistä ja hallinnoi toimittajariskikonfiguraatioita.',
        deletion_orchestration: 'Orkestroi tietojen poisto järjestelmien välillä. Seuraa poistopyyntöjä, todenna todistusketjut ja varmista tietojen täydellinen poistaminen.',
        discovery: 'Löydä henkilötiedot yhdistetyissä järjestelmissä. Skannaa tietolähteet kattavan tietoinventaarion rakentamiseksi.',
        incident_ops: 'Operatiivinen tapaustenhallinta pelikirjoilla, eskalointityönkuluilla ja SLA-seurannalla tapausten ratkaisemiseksi.',
        program_governance: 'Seuraa tietosuojaohjelman yleistä kypsyyttä, vaatimustenmukaisuuspisteitä, todistusaukkoja ja johdon raportointia koko organisaatiossasi.',
        access_accountability: 'Tutki ja tarkasta käyttäjien pääsymalleja. Seuraa pääsykonfiguraatioita, valvo epäilyttävää toimintaa ja varmista vastuullisuus.',
        localization: 'Asenna ja hallinnoi markkinoiden lokalisointipaketteja. Lisää sääntelykehyksiä, kielipaketteja ja aluekohtaista vaatimustenmukaisuussisältöä.',
        partner_workspace: 'Tee yhteistyötä ulkoisten kumppanien kanssa. Jaa vaatimustenmukaisuustietoja, seuraa kumppanivelvoitteita ja hallinnoi kumppanisuhteita.',
        privacy_scanner: 'Skannaa verkkosivustoja yksityisyyden vaatimustenmukaisuusongelmien varalta. Valvo evästeiden käyttöä, seurantaskriptejä ja tietosuojakäytännön läsnäoloa reaaliaikaisesti.',
        onboarding: 'Opasta uusia organisaatioita alustan käyttöönotossa. Vaiheittainen käyttöönotto-opas alkumääritykseen ja tietojen tuontiin.',
        compliance_forms: 'Luo ja hallinnoi vaatimustenmukaisuuslomakkeita mallikatalogista. Täytä sääntelylomakkeet, seuraa lähetyksiä ja luo raportteja.',
        audit_trail: 'Näytä täydellinen tarkastuspolku kaikista järjestelmätoiminnoista. Seuraa kuka teki mitä, milloin ja missä kaikissa moduuleissa.',
        organizations: 'Hallinnoi organisaatioita ja monen vuokralaisen asetuksia. Määritä organisaatioprofiilit, hierarkiat ja organisaatioiden väliset suhteet.',
    },
    privacy_scanner: {
        anomaly_explain: {
            explain_label: 'Selitä epämuodostumat',
            explaining: 'Selitetään…',
            results_heading: 'Poikkeamien selitykset ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            items_label: '[[TOK_1]] kohdetta',
            remediation_label: 'Korjausvaiheet',
            items_detail_label: 'Kohteet, joita asia koskee',
            accept_label: 'Hyväksy selitys',
            reject_label: 'Hylkää selitys',
            error_generic: 'Ei voinut selittää poikkeavuuksia. Yritä uudelleen tai tarkista, että skannaus on suoritettu onnistuneesti.',
        },
        cookie_insight: {
            insight_label: 'Eväste- ja seurantatieto [[TOK_0]]',
            producing: 'Tuotetaan oivalluksia…',
            results_heading: 'Eväste- ja seurantatiedot ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]]-merkkejä',
            items_label: '[[TOK_1]] kohdetta',
            classification_label: 'Luokittelu',
            severity_label: 'Vakavuus',
            banner_copy_label: 'Suositeltu bannerikopio',
            retention_label: 'Säilytysohjeet',
            citations_label: 'Lainaukset',
            kind_cookie: 'Eväste',
            kind_tracker: 'Tracker',
            class_necessary: 'Välttämätön',
            class_analytics: 'Analytics',
            class_marketing: 'Markkinointi',
            class_social: 'Sosiaalinen',
            accept_label: 'Hyväksy oivallus',
            reject_label: 'Hylkää oivallus',
            no_items: 'Tässä skannauksessa ei havaittu evästeitä tai seurantalaitteita.',
            error_generic: 'Evästetietoja ei voitu tuottaa. Yritä uudelleen tai tarkista, että skannaus on suoritettu onnistuneesti.',
        },
        monitoring: {
            title: 'Tietosuojavalvonta',
            new_scan: 'Uusi skannaus',
            scan_url: 'Skannattava URL',
            scan_frequency: 'Skannaustaajuus',
            last_scan: 'Viimeisin skannaus',
            score: 'Tietosuojapisteet',
            issues: 'Löydetyt ongelmat',
            history: 'Skannaushistoria',
            settings: 'Valvonta-asetukset',
        },
        real_time: {
            title: 'Reaaliaikaskanneri',
            scan_now: 'Skannaa nyt',
            scanning: 'Skannataan...',
            results: 'Skannauksen tulokset',
            no_results: 'Ei skannaustuloksia vielä.',
            cookies: 'Evästeet',
            trackers: 'Seurantakomentosarjat',
            consent_banners: 'Suostumusbannerit',
            third_party: 'Kolmannen osapuolen komentosarjat',
            archive: 'Tulosarkisto',
            settings: 'Skannerin asetukset',
        },
        dashboard: {
            page_title: 'Yksityisyyden valvonnan hallintapaneeli',
            privacy_monitoring: 'Yksityisyyden valvonta',
            plan_label: '[[TOK_1]] suunnitelma',
            expires_label: 'vanhenee [[TOK_1]]',
            settings: 'Asetukset',
            refresh: 'Päivitä',
            refreshing_dashboard: 'Virkistävä valvontakojelauta',
            refresh_aria: 'Päivitä valvontamittaristo',
            not_configured_title: 'Yksityisyyden valvontaa ei ole määritetty',
            not_configured_desc: 'Yhdistä [[TOK_0]] Privacy Monitoring -palvelusi, jotta voit alkaa seurata verkkosivuston noudattamista.',
            configure_monitoring: 'Määritä valvonta',
            license_expired_title: 'Lisenssi vanhentunut',
            license_expired_desc: '[[TOK_0]] Privacy Monitoring -lisenssisi on vanhentunut. Uusi se palvelun keskeytymisen välttämiseksi.',
            compliance_score: 'Vaatimustenmukaisuuspisteet',
            cookies_detected: 'Evästeet havaittu',
            trackers_label: 'Jäljittäjät',
            open_issues: 'Avoimet ongelmat',
            score_good: 'Hyvä',
            score_needs_improvement: 'Tarvitsee parannusta',
            score_critical: 'Kriittinen',
            action_required: 'Toimenpide vaaditaan',
            cookies_sr: 'evästeitä havaittu',
            trackers_sr: 'jäljittäjä löytyy',
            open_issues_sr: 'avoimia kysymyksiä',
            action_required_sr: 'tarvitaan toimenpiteitä',
            metric_label: 'Metrinen',
            value_label: 'Arvo',
            status_label: 'Tila',
            aria_metrics: 'Yksityisyyden valvontamittarit',
            plan_limit_warning: 'Skannataan [[TOK_4]]: [[TOK_2]]/[[TOK_3]] — olet saavuttanut suunnitelmasi rajan.',
            manage_domains: 'Hallinnoi verkkotunnuksia tai päivitä suunnitelmasi.',
            monitored_domains: 'Valvotut verkkotunnukset',
            domain_added: 'Verkkotunnus [[TOK_1]] lisätty',
            domain_removed: 'Verkkotunnus [[TOK_1]] poistettu',
            failed_add_domain: 'Verkkotunnuksen lisääminen epäonnistui',
            failed_remove_domain: 'Verkkotunnuksen poistaminen epäonnistui',
            failed_load: 'Valvonnan hallintapaneelin lataaminen epäonnistui',
            new_domain_aria: 'Uusi verkkotunnus [[TOK_0]]',
            add_domain: 'Lisää verkkotunnus',
            adding_domain: 'Lisätään…',
            no_domains: 'Valvottuja verkkotunnuksia ei ole vielä määritetty.',
            aria_domains_table: 'Valvotut verkkotunnukset',
            col_domain: 'Verkkotunnus',
            col_compliance_score: 'Vaatimustenmukaisuuspisteet',
            col_status: 'Tila',
            col_cookies: 'Evästeet',
            col_trackers: 'Jäljittäjät',
            col_issues: 'Ongelmat',
            col_last_scan: 'Viimeinen skannaus',
            col_action: 'Toiminta',
            compliance_status_sr: 'vaatimustenmukaisuuden tila',
            showing_chart: 'Näytetään karttanäkymä',
            showing_table: 'Näytetään tietotaulukkonäkymä',
            loading_sr: 'Valvonnan kojelautaa ladataan',
            col_framework_tags: 'Framework Tagit',
            col_last_monitored: 'Viimeksi tarkkailtu',
            framework_tags_sr: 'sovellettavia sääntelypuitteita',
            last_monitored_sr: 'jatkuvan seurannan aikaleima',
            audit_trail_heading: 'Audit Trail',
            audit_trail_info: 'Jokainen valvontaskannaus on aikaleimattu ja kirjattu lokiin. Verkkotunnustason vaatimustenmukaisuusmuutokset tuottavat muuttumattoman tarkastustietueen, joka voidaan viedä viranomaistarkastuksia varten.',
            cybersecurity_law_info_heading: 'Kyberturvallisuuslain havaitseminen',
            cybersecurity_law_info: 'Valvotut verkkotunnukset tarkistetaan automaattisesti kyberturvallisuuslain vaatimusten (esim. Vietnamin kyberturvallisuuslain, [[TOK_0]] direktiivin) suhteen. Framework tagit osoittavat, mitkä määräykset ovat voimassa. Ongelmat luokitellaan kohdennetun korjaamisen sääntelykehyksen mukaan.',
        },
        scan: {
            page_title: 'Reaaliaikainen skannaus',
            title: 'Reaaliaikainen yksityisyysskanneri',
            settings: 'Asetukset',
            results_archive: 'Tulosarkisto',
            launch_scan: 'Käynnistä Scan',
            target_url: 'Kohde [[TOK_0]]',
            protocol_aria: 'pöytäkirja',
            url_required: '[[TOK_0]] vaaditaan',
            url_whitespace: 'Poista välilyönnit kohteesta [[TOK_0]]',
            url_invalid: 'Anna kelvollinen verkkotunnus (esim. esimerkki.fi)',
            add_subpages: 'Lisää alasivuja',
            add_subpages_aria: 'Lisää alasivuja, [[TOK_1]] lisätty',
            start_scan: 'Aloita skannaus',
            launching: 'Käynnistetään…',
            scan_launched: 'Skannaus käynnistyi onnistuneesti',
            scan_failed: 'Skannauksen käynnistäminen epäonnistui',
            scan_progress: 'Skannauksen edistyminen',
            scanning_in_progress: 'Skannaus käynnissä…',
            scan_id: 'Skannaustunnus',
            status_label: 'Tila',
            status_unknown: 'unknown',
            progress_label: 'Edistyminen',
            pages_label: 'Sivut',
            refresh_status: 'Päivitä tila',
            new_scan: 'Uusi skannaus',
            scan_completed: 'Skannaus valmis, tulokset saatavilla',
            failed_check_status: 'Skannauksen tilan tarkistaminen epäonnistui',
            scan_results: 'Skannaustulokset',
            main_page: 'Pääsivu',
            page_n: 'Sivu [[TOK_1]]',
            result_pages_nav: 'Tulossivut',
            page_url: 'Sivu [[TOK_0]]',
            risk_score: 'Riskipisteet',
            risk_score_sr: 'riskipisteet',
            cookies_label: 'Evästeet',
            cookies_sr: 'evästeitä havaittu',
            scripts_label: 'Käsikirjoitukset',
            scripts_sr: 'skriptejä havaittu',
            issues_label: 'Ongelmat',
            issues_sr: 'ongelmia löydetty',
            issues_found: 'Ongelmia löydetty',
            aria_issues_table: 'Skannauksen aikana löytyi ongelmia',
            col_severity: 'Vakavuus',
            col_category: 'Luokka',
            col_title: 'Otsikko',
            col_remediation: 'Korjaus',
            severity_sr: 'severity',
            scan_result_metrics: 'Tarkista tulosmittarit',
            view_full_detail: 'Näytä täydelliset tiedot',
            col_consent_category: 'Suostumusluokka',
            consent_category_sr: 'suostumuksen luokittelu',
            compliance_evidence_heading: 'Todisteet vaatimustenmukaisuudesta',
            compliance_evidence_info: 'Skannaustulokset linkitetään vaatimustenmukaisuustapauksiin automaattisesti. Jokainen ongelma voidaan jäljittää suostumusluokkaan (olennainen, toiminnallinen, analytiikka, markkinointi), ja se tuottaa auditointivalmiita todisteita viranomaistarkastuksia varten.',
            rule_config_heading: 'Säännön määritys',
            rule_config_info: 'Skannaussäännöt ovat määritettävissä sääntelykehyksen mukaan. Evästeiden tarkistukset, komentosarjan tunnistus ja toimittaja-analyysi voidaan ottaa käyttöön tai poistaa käytöstä asetuksista. Mukautetut säännöt voidaan määrittää vastaamaan organisaatiosi vaatimustenmukaisuusvaatimuksia.',
            case_linkage_heading: 'Compliance Case Linkage',
            case_linkage_info: 'Reaaliaikaisten tarkistusten aikana löydetyt ongelmat voidaan linkittää vaatimustenmukaisuustapauksiin seurantaa ja korjaamista varten. Siirry Skannaustuloksen tiedot -sivulle nähdäksesi tapausyhteydet.',
            subpages_modal_title: 'Lisää alasivuja',
            subpages_modal_desc: 'Lisää enintään viisi alasivun URL-osoitetta skannattavaksi pääverkkotunnuksen rinnalla.',
            subpage_n: 'Alasivu [[TOK_1]]',
        },
        result_detail: {
            page_title: 'Skannaustuloksen tiedot',
            title: 'Skannauksen tulos',
            back_to_archive: 'Takaisin arkistoon',
            failed_load: 'Skannaustuloksen lataaminen epäonnistui',
            loading_sr: 'Ladataan skannaustulosta…',
            scan_id: 'Skannaustunnus',
            target_url: 'Kohde [[TOK_0]]',
            status_label: 'Tila',
            status_sr: 'status',
            started: 'Aloitettu',
            completed: 'Valmis',
            pages_scanned: 'Sivut skannatut',
            https_label: 'HTTPS',
            highest_risk_score: 'Korkein riskipiste',
            most_cookies: 'Useimmat evästeet',
            most_vendors: 'Useimmat kolmannen osapuolen toimittajat',
            most_issues: 'Useimmat ongelmat',
            across_pages: 'sivujen yli',
            highest_values_aria: 'Korkeimmat arvot kaikilla sivuilla',
            scanned_pages_nav: 'Skannatut sivut',
            main_page: 'Pääsivu',
            page_n: 'Sivu [[TOK_1]]',
            page_url: 'Sivu [[TOK_0]]',
            risk_score: 'Riskipisteet',
            overall_risk_sr: 'kokonaisriskipisteet',
            cookies_label: 'Evästeet',
            cookies_sr: 'evästeitä havaittu',
            vendors_label: 'Kolmannen osapuolen toimittajat',
            vendors_sr: 'kolmannen osapuolen toimittajat havaittu',
            issues_label: 'Ongelmat',
            issues_sr: 'ongelmia löydetty',
            risk_breakdown_aria: 'Riskipisteiden erittely',
            issues_found: 'Ongelmia löydetty',
            aria_issues_table: 'Skannauksen aikana löytyi ongelmia',
            col_severity: 'Vakavuus',
            col_category: 'Luokka',
            col_title: 'Otsikko',
            col_remediation: 'Korjaus',
            severity_sr: 'severity',
            cookies_heading: 'Evästeet ([[TOK_1]])',
            aria_cookies_table: 'Evästeet havaittu',
            col_name: 'Nimi',
            col_domain: 'Verkkotunnus',
            col_path: 'Polku',
            col_secure: 'Turvallinen',
            col_httponly: 'HttpOnly',
            col_samesite: 'Samasivusto',
            vendors_heading: 'Kolmannen osapuolen toimittajat ([[TOK_1]])',
            aria_vendors_table: 'Kolmannen osapuolen toimittajat havaittu',
            col_hostname: 'Isäntänimi',
            scripts_heading: 'Skriptit/majakat ([[TOK_1]])',
            aria_scripts_table: 'Skriptit ja majakat havaittu',
            col_url: 'URL',
            col_type: 'Kirjoita',
            links_heading: 'Linkit',
            first_party: 'Ensimmäinen osapuoli',
            third_party: 'Kolmannen osapuolen',
            col_risk_category: 'Riskiluokka',
            col_regulatory_framework: 'Sääntelykehys',
            col_actionable_detail: 'Toimiva yksityiskohta',
            risk_category_sr: 'sääntelyn riskiluokka',
            risk_category_mapping_heading: 'Riskikategorian kartoitus',
            risk_category_mapping_info: 'Jokainen skannauslöydös on kartoitettu lakisääteiseen riskiluokkaan (tiedonkeruu, rajat ylittävä siirto, suostumuksen hallinta, tietojen säilyttäminen, turvatarkastukset). Tämä kartoitus mahdollistaa kohdennetun kunnostuksen, joka priorisoidaan sääntelyvaikutusten mukaan.',
            compliance_case_heading: 'Compliance Case Association',
            compliance_case_info: 'Skannaustulokset linkitetään vaatimustenmukaisuustapauksiin päästä päähän -seurantaa varten. Ongelmat voidaan siirtää suoraan tarkistustuloksista vaatimustenmukaisuustapausten työnkulkuun.',
        },
        results_archive: {
            page_title: 'Skannaustulosarkisto',
            title: 'Skannaustulosarkisto',
            back_to_scanner: 'Takaisin skanneriin',
            failed_load: 'Skannaustulosten lataaminen epäonnistui',
            results_loaded: 'Skannaustulokset ladattu, [[TOK_1]] tietueita',
            total_label: 'Yhteensä: [[TOK_1]]',
            aria_table: 'Tarkista tulosarkisto',
            col_scan_date: 'Skannauspäivämäärä',
            col_target_url: 'Kohde [[TOK_0]]',
            col_duration: 'Kesto',
            col_issues_found: 'Ongelmia löydetty',
            col_risk_score: 'Riskipisteet',
            col_status: 'Tila',
            col_actions: 'Toiminnot',
            scan_status_sr: 'skannauksen tila',
            view_result: 'Näytä',
            no_results: 'Skannaustuloksia ei löytynyt.',
            loading_sr: 'Ladataan skannaustuloksia',
            pagination_aria: 'Skannaa tulosten sivutus',
            col_risk_category: 'Riskiluokka',
            risk_category_sr: 'sääntelyn riskiluokka',
            archive_retention_heading: 'Arkiston säilyttäminen',
            archive_retention_info: 'Skannaustuloksia säilytetään organisaatiosi tietojen säilytyskäytännössä määritellyn ajan. Arkistoidut tulokset sisältävät koko skannauskontekstin (kehystunnisteet, riskiluokat, korjausohjeet), ja ne voidaan viedä muodossa [[TOK_0]] säännösten mukaiseksi todisteeksi.',
            export_context_info: 'Viedyt [[TOK_0]]-tiedostot sisältävät säädöskontekstin: riskiluokan, sovellettavat puitteet ja kunkin havainnon korjaustoimenpiteitä koskevat tiedot.',
        },
        scanner_settings: {
            page_title: 'Skannerin asetukset',
            title: 'Skannerin asetukset',
            back_to_scanner: 'Takaisin skanneriin',
            failed_load: 'Skannerin määrityksen lataaminen epäonnistui',
            endpoint_url: 'Päätepiste [[TOK_0]]',
            save_success: 'Skannerin määritykset tallennettu onnistuneesti.',
            save_failed: 'Skannerin asetusten tallentaminen epäonnistui',
            test_connection: 'Testaa yhteys',
            testing: 'Testataan...',
            save_configuration: 'Tallenna asetukset',
            saving: 'Tallennetaan...',
            loading_sr: 'Ladataan skannerin asetuksia',
        },
        monitoring_settings: {
            page_title: 'Yksityisyyden valvonta-asetukset',
            title: 'Valvonta-asetukset',
            back_to_dashboard: 'Takaisin hallintapaneeliin',
            failed_load: 'Valvontamäärityksen lataaminen epäonnistui',
            credentials_heading: '[[TOK_0]] Valtuustiedot',
            connected_as: 'Yhdistetty nimellä [[TOK_1]]',
            credentials_desc: 'Anna [[TOK_0]]-tilisi kirjautumistiedot yhdistääksesi Privacy Monitoringin. Etsi jäsentunnuksesi [[TOK_1]]-tilisi profiilisivulta.',
            client_id: 'Asiakastunnus',
            client_secret: 'Asiakkaan salaisuus',
            username: '[[TOK_0]] Käyttäjätunnus (sähköposti)',
            password: '[[TOK_0]] Salasana',
            placeholder_keep: '(jätä tyhjäksi säilyttääksesi olemassa)',
            credential_form_aria: '[[TOK_0]] valtakirjalomake',
            test_connection: 'Testaa yhteys',
            testing: 'Testataan…',
            test_aria: 'Testaa [[TOK_0]]-yhteyttä',
            testing_aria: 'Testaa yhteyttä',
            save_configuration: 'Tallenna asetukset',
            saving: 'Tallennetaan…',
            save_aria: 'Tallenna tunnistetiedot',
            saving_aria: 'Tallennetaan kirjautumistietoja',
            credentials_saved: '[[TOK_0]] tunnistetiedot tallennettu onnistuneesti.',
            credentials_saving: '[[TOK_0]] kirjautumistiedot tallennettu. Ladataan määritystä uudelleen…',
            credentials_save_failed: 'Tunnistetietojen tallentaminen epäonnistui',
            client_id_required: 'Asiakastunnus ja käyttäjätunnus vaaditaan.',
            all_fields_required: 'Kaikki tunnistetiedot ovat pakollisia.',
            email_heading: 'Sähköposti-ilmoitukset',
            receive_emails: 'Vastaanota skannausraporttisähköposteja',
            email_toggle_aria: 'Vaihda skannausraporttisähköpostit',
            only_on_change: 'Lähetä sähköpostia vain, kun riskitilanne muuttuu',
            only_on_change_aria: 'Vaihda sähköposti vain riskitilan muutoksen yhteydessä',
            emails_enabled: 'Tarkista raporttisähköpostit käytössä',
            emails_disabled: 'Tarkista raporttisähköpostit pois käytöstä',
            only_change_on: 'Sähköposti vain riskien muutoksista',
            only_change_off: 'Sähköposti jokaisella skannauksella',
            email_failed: 'Sähköpostiasetusten päivittäminen epäonnistui',
            email_settings_aria: 'Sähköposti-ilmoitusasetukset',
            loading_sr: 'Ladataan valvontaasetuksia',
        },
        entity_types: {
            user: 'Käyttäjä',
            case: 'Asia',
            incident: 'Tapahtuma',
            assessment: 'Arviointi',
            vendor: 'Myyjä',
            consent: 'Suostumus',
            policy: 'politiikka',
            data_map: 'Tietokartta',
        },
        actions: {
            create: 'Luo',
            update: 'Päivitä',
            delete: 'Poista',
            view: 'Näytä',
            export: 'Vie',
            status_change: 'Tilan muutos',
        },
    },
    forms: {
        dashboard: {
            title: 'Lomakkeiden yhteenveto',
            total_templates: 'Mallipohjia yhteensä',
            installed: 'Asennettu',
            available: 'Saatavilla',
            by_market: 'Markkina-alueittain',
            back_dashboard: 'Takaisin to Kojelauta',
            browse_templates: 'Browse Mallit',
            catalog_coverage: 'Catalog Kattavuus',
            quick_start: 'Quick Aloita',
            recent_instances: 'Viimeaikainen Instances',
            total_instances: 'Instances yhteensä',
            fetch_failed: 'Epäonnistui: fetch kojelauta tiedot. Yritä uudelleen.',
            no_instances: 'Ei instances found. löytynyt',
            form_metrics: 'Lomakemittareiden yleiskatsaus',
            templates_total: 'mallia yhteensä',
            instances_total: 'instanssia yhteensä',
            installed_of_available: '[[TOK_2]] / [TOK_3]] asennettu',
            templates_in_category: 'mallia luokassa {category}',
        },
        templates: {
            title: 'Lomakemallipohjat',
            new: 'Uusi mallipohja',
            edit: 'Muokkaa mallipohjaa',
            name: 'Mallipohjan nimi',
            form_type: 'Lomaketyyppi',
            market: 'Markkina-alue',
            language: 'Kieli',
            schema: 'Lomakeskeema',
            preview: 'Esikatselu',
            duplicate: 'Monista mallipohja',
            grid_view: 'Ruudukko Näytä',
            list_view: 'Lista Näytä',
            fetch_failed: 'Epäonnistui: fetch mallit. Yritä uudelleen.',
            filter_templates: 'Suodata mallit',
            version_history: 'Versiohistoria',
            no_version_history: 'Ei versiohistoriaa — tämä on alkuperäinen versio.',
            form_id: 'Lomakkeen tunnus',
            source_instrument: 'Lähdeinstrumentti',
            issuer: 'Myöntäjä',
            all_frameworks: 'Kaikki kehykset',
            view_mode: 'Näkymätila',
        },
        catalog: {
            title: 'Lomakekatalogi',
            install: 'Asenna',
            uninstall: 'Poista asennus',
            install_all: 'Asenna kaikki',
            installed_tab: 'Asennetut',
            catalog_tab: 'Katalogi',
            search_placeholder: 'Hae mallipohjia...',
            no_templates: 'Mallipohjia ei löytynyt.',
            template_count: '{count} mallipohjaa',
            all_markets: 'Kaikki markkinat',
            sections: 'Osiot',
            all_categories: 'Kaikki kategoriat',
            category: 'Kategoria',
            category_install_failed: 'Epäonnistui: install kategoria mallit. Yritä uudelleen.',
            category_install_success: 'Kategoria mallit installed.',
            fetch_failed: 'Epäonnistui: fetch mallit. Yritä uudelleen.',
            fetch_installed_failed: 'Epäonnistui: fetch installed mallit. Yritä uudelleen.',
            fields: 'Kentät',
            install_failed: 'Epäonnistui: install malli. Yritä uudelleen.',
            install_success: 'Malli installed successfully.',
            installing: 'Asennetaan...',
            removing: 'Poistetaan...',
            uninstall_confirm: 'Haluatko varmasti uninstall this template?',
            uninstall_failed: 'Epäonnistui: uninstall malli. Yritä uudelleen.',
            uninstall_success: 'Malli uninstalled successfully.',
            installation_summary: 'Asennuksen yhteenveto',
            filter_catalog: 'Suodata luettelo',
            all_frameworks: 'Kaikki kehykset',
            templates_installed_count: '[[TOK_1]] malli(t) asennettu onnistuneesti',
            all_already_installed: 'Kaikki tämän luokan mallit on jo asennettu',
            form_id: 'Lomakkeen tunnus',
            issuer: 'Myöntäjä',
            catalog_tabs: 'Lomakeluettelon välilehdet',
        },
        filler: {
            back_templates: 'Takaisin to Mallit',
            no_sections: 'Ei sections found. löytynyt',
            draft_created: 'Luonnos created.',
            draft_saved: 'Luonnos saved.',
            fetch_template_failed: 'Epäonnistui: fetch malli. Yritä uudelleen.',
            save_draft: 'Tallenna Luonnos',
            save_draft_failed: 'Epäonnistui: save draft. Yritä uudelleen.',
            saving: 'Tallennetaan...',
            select_option: 'Valitse an option',
            submit: 'Lähetä',
            submit_failed: 'Epäonnistui: submit. Yritä uudelleen.',
            submitting: 'Lähetetään...',
            title: 'Lomakeopas',
            form_id_label: 'Lomakkeen tunnus',
            schema_label: 'Skeema',
            framework_label: 'Kehys',
            issuer_label: 'Myöntäjä',
            source_label: 'Lähde',
            market_label: 'Markkina',
            section_of: 'Osio {current}/{total}',
            form_navigation: 'Lomakenavigaatio',
            form_progress: 'Lomakkeen eteneminen: Osio {current}/{total}',
            removed_item: 'Kohde {index} poistettu kentästä {field}',
            added_item: 'Uusi kohde lisätty kenttään {field}',
            go_to_previous: 'Siirry edelliseen osioon, osio {current}/{total}',
            go_to_next: 'Siirry seuraavaan osioon, osio {current}/{total}',
            risk_matrix_placeholder: '1–5',
        },
        filing: {
            title: 'Hakemuksen tila',
            advance: 'Päivitä hakemuksen tila...',
            not_started: 'Ei aloitettu',
            drafting: 'Luonnostelu',
            internal_review: 'Sisäinen tarkistus',
            approved_for_submission: 'Hyväksytty jätettäväksi',
            submitted_to_authority: 'Jätetty viranomaiselle',
            supplement_requested: 'Täydennys pyydetty',
            supplement_in_progress: 'Täydennys käynnissä',
            resubmitted: 'Jätetty uudelleen',
            accepted: 'Hyväksytty',
            rejected: 'Hylätty',
            closed: 'Suljettu',
        },
        instances: {
            approved_by: 'Hyväksynyt',
            form_answers: 'Lomake Answers',
            no_answers: 'Ei answers found. löytynyt',
            view_outputs: 'Näytä tulosteet',
            approve: 'Hyväksy',
            approve_failed: 'Epäonnistui: approve. Yritä uudelleen.',
            approving: 'Hyväksytään...',
            detail_title: 'Instance Yksityiskohta',
            fetch_failed: 'Epäonnistui: fetch instances. Yritä uudelleen.',
            generate_failed: 'Epäonnistui: generate output. Yritä uudelleen.',
            generate_output: 'Luo Tuloste',
            generating: 'Luodaan...',
            submitted_at: 'Lähetetty',
            instance_metadata: 'Lomakeinstanssin metatiedot',
            filing_status_steps: 'Arkistointitilan vaiheet',
            current_status: 'nykyinen tila',
            filing_status_update_failed: 'Hakemuksen tilan päivittäminen epäonnistui',
        },
        outputs: {
            back_instance: 'Takaisin to Instance',
            no_outputs_msg: 'Tulosteita ei ole vielä luotu.',
            no_outputs_title: 'No Tulosteet',
            output_name: 'Tuloste Nimi',
            download: 'Lataa',
            download_failed: 'Epäonnistui: download. Yritä uudelleen.',
            fetch_failed: 'Epäonnistui: fetch outputs. Yritä uudelleen.',
            format: 'Muoto',
            generated_at: 'Luotu',
            generated_by: 'Luonut',
            size: 'Koko',
            title: 'Lomake Tulosteet',
            print: 'Tulosta',
            print_outputs: 'Tulosta lomakkeen tulosteet',
            printing: 'Tulostetaan lomakkeen tulosteet',
            pdf_preview: 'PDF-esikatselu',
            downloading: 'Ladataan {name}',
            preview_in_new_window: 'Esikatsele {name} ({format}) uudessa ikkunassa',
        },
        cybersec_domains: {
            scope: 'Laajuus ja soveltuvuus',
            risk: 'Riskinarviointi ja kontrollikartoitus',
            policy: 'Organisaation turvallisuuspolitiikat',
            localization: 'Datan lokalisointi ja paikallinen läsnäolo',
            vendor: 'Kolmannet osapuolet ja toimitusketju',
            authority: 'Viranomaispyyntöjen käsittely',
            incident: 'Poikkeamien hallinta ja todisteet',
            training: 'Koulutus ja valmius',
        },
        market_finalization_domains: {
            data_law: 'Tietolaki — Hallinto ja Operatiiviset Kontrollit',
            pdpl_2025: 'PDPL 2025 — Yksityisyyden Hallinta ja Rekisteröityjen Oikeudet',
            decree_356: 'Asetus 356/2025 — Toimittaja- ja Rajat Ylittävät Kontrollit',
            telecom: 'Viestintälaki — Luottamuksellisuus ja Viranomaisvaatimukset',
        },
        nav: {
            filing_case_links: 'Arkistointitapauslinkit',
            section_routing: 'Osion reititys',
            submission_packages: 'Lähetyspaketit',
        },
        filing_case_links: {
            title: 'Arkistointitapauslinkit',
            link_form: 'Linkitä lomake arkistointitapaukseen',
            filing_case_type: 'Arkistointitapaustyyppi',
            form_instance: 'Lomakeinstanssi',
            select_form_instance: 'Valitse lomakeinstanssi...',
            select_filing_case: 'Valitse arkistointitapaus...',
            no_links_found: 'Arkistointitapauslinkkejä ei löytynyt.',
            linked: 'Linkitetty',
            filing_case_id: 'Arkistointitapauksen tunnus',
            link_created: 'Arkistointitapauksen linkki luotu',
            link_deleted: 'Arkistointitapauslinkki poistettu',
            aria_delete_link: 'Poista linkki {name}',
            case_type_dpia_dossier: 'DPIA-asiakirjakansio',
            case_type_cross_border_filing: 'Rajat ylittävä arkistointi',
            case_type_breach_notification: 'Tietoturvaloukkausilmoitus',
            no_instances_guidance: 'Ei vielä lomakeinstansseja. Luo yksi Lomakemalleista.',
            no_filings_guidance: 'Ei vielä arkistointitapauksia. Luo yksi Arvioinneista.',
        },
        section_routing: {
            title: 'Osion reititys',
            assign_section: 'Määritä osio',
            department: 'Osasto',
            select_department: 'Valitse osasto...',
            assignee: 'Vastuuhenkilö',
            select_assignee: 'Valitse vastuuhenkilö...',
            section: 'Osio',
            select_section: 'Valitse osio...',
            select_form_instance: 'Valitse lomakeinstanssi...',
            no_assignments_found: 'Osion määrityksiä ei löytynyt.',
            select_instance_prompt: 'Valitse lomakeinstanssi nähdäksesi osion kohdistukset.',
            complete_section: 'Viimeistele osio',
            status_pending: 'Odottaa',
            status_in_progress: 'Käynnissä',
            status_completed: 'Valmis',
            status_reviewed: 'Tarkistettu',
            form_instance_id: 'Lomakeinstanssin tunnus',
            assignment_created: 'Osiokohdistus luotu',
            assignment_deleted: 'Osiokohdistus poistettu',
            status_updated: 'Osion tila päivitetty',
            aria_delete_assignment: 'Poista kohdistus {name}',
            deadline: 'Määräaika',
            deadline_help: 'Valinnainen. Tämän päivämäärän jälkeiset kohdistukset näytetään myöhässä olevina.',
            overdue: 'Myöhässä',
            days_remaining: 'päivää jäljellä',
            approval_requested: 'Lähetetty tarkistettavaksi',
            form_approved: 'Lomake hyväksytty',
            form_rejected: 'Lomake hylätty',
            no_departments_guidance: 'Osastoja ei ole määritetty. Määritä ne Organisaation asetuksissa.',
            no_sections_guidance: 'Mallissa ei ole osioita. Varmista, että lomakemallissa on osioita.',
            select_instance_first: 'Valitse ensin lomakeinstanssi ladataksesi käytettävissä olevat osiot.',
        },
        submission_packages: {
            title: 'Lähetyspaketit',
            assemble_package: 'Kokoa lähetyspaketti',
            dossier: 'Asiakirjakansio',
            select_dossier: 'Valitse asiakirjakansio...',
            package_label: 'Paketin nimi',
            cover_letter: 'Saatekirje',
            checklist: 'Tarkistuslista',
            evidence_index: 'Todistusaineistoluettelo',
            completeness: 'Kattavuus',
            incomplete_warning: 'Kokoaminen ei onnistu: lomakkeessa on keskeneräisiä osioita.',
            no_packages_found: 'Lähetyspaketteja ei löytynyt.',
            version: 'Versio',
            package_assembled: 'Lähetyspaketti koottu',
            package_deleted: 'Lähetyspaketti poistettu',
            aria_delete_package: 'Poista paketti {name}',
            status_draft: 'Luonnos',
            status_complete: 'Valmis',
            status_submitted: 'Lähetetty',
            status_accepted: 'Hyväksytty',
            status_rejected: 'Hylätty',
            package_updated: 'Lähetyspaketti päivitetty',
            document_generated: 'Asiakirja luotu',
            documents: 'Asiakirjat',
            generate: 'Luo',
            preview: 'Esikatselu',
            download: 'Lataa',
            download_all: 'Lataa kaikki',
            no_dossiers_guidance: 'Ei vielä asiakirja-aineistoja. Luo yksi Arvioinneista.',
            package_plan_help: 'Sisällytä pakettiin (automaattinen asiakirjojen luonti käytettävissä):',
            cover_letter_help: 'Virallinen saatekirje vastaanottavalle viranomaiselle',
            checklist_help: 'Vaatimustenmukaisuuden tarkistuslista, joka varmistaa kaikkien lähetysvaatimusten täyttymisen',
            evidence_index_help: 'Lähetyksessä viitattujen todistusasiakirjojen hakemisto',
            completeness_skipped: 'Kattavuustarkistus ohitettu — tähän asiakirja-aineistoon ei ole linkitetty lomakeinstanssia.',
            completeness_unavailable: 'Kattavuustarkistus ei käytettävissä — jatketaan paketin kokoamista.',
            duplicate_package_error: 'Tälle asiakirja-aineistolle on jo olemassa lähetyspaketti.',
            doc_cover_letter: 'Saatekirje',
            doc_checklist: 'Tarkistuslista',
            doc_evidence_index: 'Todistusaineiston hakemisto',
            export_csv: 'Vie CSV',
            export_success: 'Arkistointitapausten linkit viety onnistuneesti',
            no_assignments_guidance: 'Ei vielä osiotoimeksiantoja. Määritä osiot osastoille ja tiimin jäsenille aloittaaksesi reitityksen.',
        },
        template_picker: {
            title: 'Valitse malli',
            hint: 'Valitse sääntelylomakepohja tai aloita tyhjällä lomakkeella.',
            market_filter: 'Suodata markkinan mukaan',
            framework_filter: 'Suodata kehyksen mukaan',
            all_markets: 'Kaikki markkinat',
            all_frameworks: 'Kaikki kehykset',
            search_placeholder: 'Hae malleja...',
            blank_form: 'Tyhjä / yleinen lomake',
            blank_form_desc: 'Luo ilman mallia — täytä kentät manuaalisesti.',
            no_templates: 'Malleja ei löytynyt tällä suodattimella.',
            select: 'Valitse',
            link_error: 'Mallin linkitys epäonnistui — voit linkittää mallin myöhemmin Muokkausnäkymästä.',
            internal_badge: 'Sisäinen malli',
            legacy_badge: 'Vanhentunut',
            draft_badge: 'Luonnos',
            upcoming_badge: 'Tuleva',
            hidden_badge: 'Piilotettu',
            show_hidden_toggle: 'Näytä piilotetut / vanhentuneet mallit',
            show_hidden_toggle_hint: 'Järjestelmänvalvojan näkymä: sisältää internal_only, hidden, legacy tai draft merkityt mallit.',
        },
        cover_letter_modal: {
            title: 'Saatekirje: esikatselu ja muokkaus',
            iframe_title: 'Saatekirjeen esikatselu',
            stage_label: 'Vaihe',
            stage_initial: 'Ensimmäinen toimitus',
            stage_supplement: 'Täydennysvastaus',
            stage_resubmission: 'Uudelleentoimitus',
            subject_label: 'Aihe',
            body_label: 'Runkokappale',
            notes_label: 'Lisämuistiinpanot',
            refresh_preview: 'Päivitä esikatselu',
            confirm: 'Vahvista ja tallenna',
            regenerate: 'Luo uudelleen',
            snapshot_saved: 'Saatekirje tallennettu',
        },
        related_panel: {
            title: 'Liittyvät sääntelylomakkeet',
            open_form: 'Täytä lomake',
            no_forms: 'Liittyviä lomakkeita ei löytynyt.',
            hint_vn: 'VN-kohtaiset sääntelylomakkeet saatavilla — valitse lomake avataksesi vaatimustenmukaisuusavustajan.',
            internal_badge: 'Sisäinen',
            official_badge: 'Virallinen',
            loading: 'Ladataan liittyviä lomakkeita...',
            error: 'Liittyvien lomakkeiden lataaminen epäonnistui.',
            form_id: 'Lomakkeen tunnus',
            form_name: 'Lomakkeen nimi',
            framework: 'Sääntelykehys',
        },
        view_form: 'Näytä lomake',
        edit_form: 'Muokkaa lomaketta',
        save_draft: 'Tallenna luonnos',
        module_settings: 'Moduuliasetukset',
        validation_errors: 'Korjaa validointivirheet',
        custom_name_help: 'Valinnainen — oletuksena mallin nimi, jos jätetään tyhjäksi',
        select_placeholder: 'Valitse...',
        previous_section: 'Edellinen',
        next_section: 'Seuraava',
        loading: 'Ladataan...',
        array_add: 'Lisää',
        array_remove: 'Poista',
        array_item_label: '{label} kohde {index}',
        array_add_item: 'Lisää kohde kohteeseen {label}',
        array_remove_item: 'Poista kohde {index} kohteesta {label}',
        legacy_banner: 'Tämä tietue luotiin ennen yhtenäisiä lomakkeita. Jotkin tiedot voivat erota entiteetin ja lomakeinstanssin välillä.',
        field_required: '{label} on pakollinen',
        section_announcement: 'Osio [[TOK_3]] [[TOK_4]]: [[TOK_5]]',
        sections_nav_label: 'Lomakeosat',
        no_sections: 'Malliosioita ei ole saatavilla.',
        section_label_tpl: 'Osio [[TOK_2]]: [[TOK_3]]',
        module_settings_auto_applied: 'Moduulikohtaiset asetukset otetaan käyttöön automaattisesti.',
        operation_failed: 'Toiminto epäonnistui',
        failed_to_load_form: 'Lomakkeen lataaminen epäonnistui',
        failed_to_save_form: 'Lomakkeen tallentaminen epäonnistui',
        failed_to_submit_form: 'Lomakkeen lähettäminen epäonnistui',
        failed_to_load_template: 'Mallin lataaminen epäonnistui',
        failed_to_save_draft: 'Luonnoksen tallentaminen epäonnistui',
        failed_to_create: 'Luominen epäonnistui',
    },
    pack_catalog: {
        title: 'Pakettikatalogi',
        install: 'Asenna paketti',
        uninstall: 'Poista paketin asennus',
        install_batch: 'Asenna pakettiryhmä',
        installed_tab: 'Asennetut',
        catalog_tab: 'Katalogi',
        pack_details: 'Paketin tiedot',
        frameworks: 'Sääntelykehykset',
        requirements: 'Vaatimukset',
        artifacts: 'Artefaktit',
        language_pack: 'Kielipaketti',
        dependencies: 'Riippuvuudet',
        no_packs: 'Paketteja ei löytynyt.',
    },
    platform_pages: {
        users: {
            title: 'Käyttäjät',
            new: 'Uusi käyttäjä',
            invite: 'Kutsu käyttäjä',
            edit: 'Muokkaa käyttäjää',
            name: 'Nimi',
            email: 'Sähköposti',
            role: 'Rooli',
            status: 'Tila',
            identity_type: 'Identiteettityyppi',
            last_login: 'Viimeisin kirjautuminen',
            deactivate: 'Poista käytöstä',
            reactivate: 'Palauta käyttöön',
            unlock: 'Avaa lukitus',
            reset_password: 'Nollaa salasana',
            remove: 'Poista',
            remove_confirm: 'Poistetaanko "{name}"? Tämä toiminto on pysyvä ja käyttäjä menettää kaiken käyttöoikeuden. Tietue säilytetään tarkastustarkoituksia varten.',
        },
        roles: {
            title: 'Roolit',
            new: 'Uusi rooli',
            edit: 'Muokkaa roolia',
            name: 'Roolin nimi',
            description: 'Kuvaus',
            permissions: 'Käyttöoikeudet',
            users_count: 'Käyttäjät',
            detail: 'Roolin tiedot',
            all_tiers: 'Kaikki tasot',
            role_name_placeholder: 'esim. alueellinen vaatimustenmukaisuusjohtaja',
        },
        profile: {
            title: 'Oma profiili',
            name: 'Nimi',
            display_name: 'Näyttönimi',
            email: 'Sähköposti',
            phone: 'Puhelin',
            department: 'Osasto',
            job_title: 'Tehtävänimike',
            language: 'Kieli',
            role: 'Rooli',
            persona: 'Tunnistettu persoona',
            last_login: 'Viimeisin kirjautuminen',
            save: 'Tallenna muutokset',
            save_success: 'Profiili päivitetty onnistuneesti',
            module_tips_section: 'Moduulivinkit',
            tips_toggle: 'Näytä sääntelyvinkit moduuleissa',
            dismissed_tips: 'Ohitetut vinkit',
            reset_dismissed: 'Nollaa kaikki ohitetut vinkit',
            notification_prefs: 'Ilmoitusasetukset',
            notification_prefs_link: 'Hallitse ilmoitusasetuksia →',
            change_password: 'Vaihda salasana',
            current_password: 'Nykyinen salasana',
            new_password: 'Uusi salasana',
            confirm_password: 'Vahvista salasana',
            accessibility: 'Esteettomyys',
            high_contrast: 'Suuren kontrastin tila',
            high_contrast_desc: 'Lisaa kontrastia luettavuuden parantamiseksi. Tayttaa WCAG 2.1 AAA -vaatimukset.',
            passwords_no_match: 'Salasanat eivät täsmää',
            password_changed_logout: 'Salasana vaihdettu. Sinut kirjataan ulos.',
            failed_update: 'Profiilin päivitys epäonnistui',
            failed_change_password: 'Salasanan vaihto epäonnistui',
            none: 'Ei mitään',
            never: 'Ei koskaan',
            password_requirements: 'Vähintään 12 merkkiä, iso kirjain, pieni kirjain, numero, erikoismerkki',
        },
        security: {
            mfa_title: 'MFA-asetukset',
            mfa_enable: 'Ota MFA käyttöön',
            mfa_disable: 'Poista MFA käytöstä',
            mfa_setup: 'Skannaa tämä QR-koodi todennussovelluksellasi',
            sso_title: 'SSO-asetukset',
            sso_provider: 'Palveluntarjoaja',
            sso_client_id: 'Asiakastunnus',
            sso_redirect: 'Uudelleenohjauksen URI',
            api_keys_title: 'API-avaimet',
            api_keys_new: 'Uusi API-avain',
            api_keys_name: 'Avaimen nimi',
            api_keys_last_used: 'Viimeksi käytetty',
            api_keys_expires: 'Vanhenee',
            api_keys_revoke: 'Peruuta',
            service_accounts_title: 'Palvelutilit',
            ip_allowlist_title: 'IP-sallittujen lista',
            ip_add: 'Lisää IP-osoite',
            ip_address: 'IP-osoite',
            ip_description: 'Kuvaus',
            delegations_title: 'Delegoinnit',
            delegations_new: 'Uusi delegointi',
            delegations_from: 'Käyttäjältä',
            delegations_to: 'Käyttäjälle',
            delegations_expires: 'Vanhenee',
            break_glass_title: 'Hätäpääsy',
            break_glass_request: 'Pyydä pääsy',
            break_glass_reason: 'Pääsyn syy',
            break_glass_duration: 'Kesto',
            session_settings_title: 'Istuntoasetukset',
            session_timeout: 'Istunnon aikakatkaisu (minuuttia)',
            session_max_concurrent: 'Samanaikaisten istuntojen enimmäismäärä',
            active_sessions_title: 'Aktiiviset istunnot',
            active_sessions_device: 'Laite',
            active_sessions_ip: 'IP-osoite',
            active_sessions_started: 'Aloitettu',
            active_sessions_revoke: 'Peruuta istunto',
            active_sessions_confirm_terminate: 'Haluatko varmasti lopettaa tämän istunnon?',
            active_sessions_confirm_terminate_current: 'Tämä on nykyinen istuntosi. Sen lopettaminen kirjaa sinut ulos välittömästi. Jatkaa?',
            active_sessions_confirm_terminate_all: 'Haluatko varmasti lopettaa kaikki muut istunnot? Vain nykyinen istuntosi pysyy aktiivisena.',
            active_sessions_terminated: 'Istunto lopetettu onnistuneesti.',
            active_sessions_all_terminated: 'Kaikki muut istunnot on lopetettu.',
            active_sessions_terminate_all: 'Lopeta kaikki muut istunnot',
            active_sessions_last_activity: 'Viimeinen toiminta',
            active_sessions_current: 'Nykyinen istunto',
            active_sessions_revoke_selected: 'Peruuta valitut',
            active_sessions_confirm_terminate_selected: 'Haluatko varmasti lopettaa valitut istunnot?',
            active_sessions_selected_terminated: 'Valitut istunnot lopetettu.',
            ip_allowlist_desc: 'Hallinnoi sallittuja IP-osoitteita [[TOK_0]]:lle.',
            ip_no_entries: 'IP-osoitteita ei ole määritetty.',
            session_settings_desc: 'Määritä istunnon aikakatkaisu ja samanaikaisten istuntojen rajoitukset.',
            session_settings_save_policy: 'Tallenna istuntokäytäntö',
            session_settings_saved: 'Istuntoasetusten päivitys onnistui.',
            session_settings_idle_timeout: 'Idle Timeout (minuutit)',
            session_settings_absolute_timeout: 'Absoluuttinen aikakatkaisu (minuutteja)',
            session_settings_help_idle: 'Istunto vanhenee tämän epäaktiivisuuden jälkeen.',
            session_settings_help_absolute: 'Istunto vanhenee tämän kokonaiskeston jälkeen aktiviteetista riippumatta.',
            session_settings_help_max: 'Samanaikaisten istuntojen enimmäismäärä käyttäjää kohti.',
            sso_note: 'SSO-määrityksen muutokset voivat edellyttää käyttäjien todentamista uudelleen.',
            service_accounts_warning: 'Tämä [[TOK_0]]-näppäin näytetään vain kerran. Kopioi se nyt ja säilytä se turvallisesti.',
            service_accounts_new: 'Uusi palvelutili',
            service_accounts_name: 'Tilin nimi',
            service_accounts_role: 'Rooli',
            service_accounts_created: 'Luotu',
            service_accounts_desc: 'Hallinnoi koneiden välisiä palvelutilejä [[TOK_0]]-integraatioille.',
            break_glass_warning: 'Rikkoutuvien lasien käyttö auditoidaan ja kirjataan. Käytä vain aidoissa hätätilanteissa.',
            break_glass_min_chars: '[[TOK_2]] / [[TOK_3]] vähintään merkkiä',
            break_glass_permission_count: '[[TOK_1]] lupa(t) valittu',
            break_glass_submitted: 'Lasin rikkomista koskeva pyyntö lähetetty. Odottaa hyväksyntää.',
            break_glass_approved: 'Lasin rikkoutumispyyntö hyväksytty.',
            break_glass_denied: 'Lasin rikkomista koskeva pyyntö evätty.',
            break_glass_confirm_activate: 'Hyväksytäänkö tämä lasinmurtopyyntö? Tämä antaa hätäpääsyn välittömästi.',
            break_glass_confirm_title: 'Vahvista aktivointi',
            break_glass_pending: 'Odottavat pyynnöt',
            break_glass_active_sessions: 'Active Break-Glass -istunnot',
            break_glass_time_remaining: 'Aikaa jäljellä',
            break_glass_expired: 'Vanhentunut',
            break_glass_approved_denied_by: 'Hyväksytty/hylätty',
            delegations_desc: 'Hallinnoi väliaikaisia käyttöoikeuksien delegointeja käyttäjien välillä.',
            delegations_my: 'Minun valtuuskuntani',
            delegations_to_me: 'Delegoitu minulle',
            delegations_scope_all: 'Kaikki käyttöoikeudet',
            delegations_scope_specific: 'Erityiset käyttöoikeudet',
            delegations_created: 'Delegaatio luotiin onnistuneesti.',
            delegations_revoked: 'Valtuutus peruutettu.',
            delegations_confirm_revoke: 'Haluatko varmasti peruuttaa tämän valtuutuksen?',
            delegations_confirm_revoke_title: 'Vahvista peruutus',
            delegations_permission_count: '[[TOK_1]] lupa(t)',
            api_keys_status: 'Tila',
            api_keys_prefix: 'Avaimen etuliite',
            api_keys_permissions_count: 'Käyttöoikeudet',
            api_keys_ip_count: 'IP-rajoitukset',
            api_keys_created: 'Luotu',
            api_keys_confirm_revoke_title: 'Vahvista peruutus',
            api_keys_confirm_revoke_message: 'Haluatko varmasti peruuttaa [[TOK_2]]-avaimen "[[TOK_1]]"? Tätä toimintoa ei voi kumota.',
            api_keys_confirm_rotate_title: 'Vahvista kierto',
            api_keys_confirm_rotate_message: 'Haluatko varmasti kiertää [[TOK_2]]-näppäintä "[[TOK_1]]"? Nykyinen avain lakkaa toimimasta välittömästi.',
            api_keys_created_success: '[[TOK_0]]-avain luotiin onnistuneesti.',
            api_keys_revoked_success: '[[TOK_2]] avain "[[TOK_1]]" on peruutettu.',
            api_keys_rotated_success: '[[TOK_2]]-näppäintä "[[TOK_1]]" on käännetty. Kopioi uusi avain alla.',
            api_keys_load_error: '[[TOK_0]]-avainten lataaminen epäonnistui.',
            api_keys_create_error: 'Avaimen [[TOK_0]] luominen epäonnistui.',
            api_keys_revoke_error: '[[TOK_0]]-avaimen peruuttaminen epäonnistui.',
            api_keys_rotate_error: '[[TOK_0]]-näppäimen kiertäminen epäonnistui.',
            break_glass_duration_15: '15 minuuttia',
            break_glass_duration_30: '30 minuuttia',
            break_glass_duration_60: '60 minuuttia (1h)',
            break_glass_duration_120: '120 minuuttia (2h)',
            break_glass_duration_240: '240 minuuttia (4h)',
            sod_rules_title: 'Tehtävien erottelusäännöt',
            sod_violations_report: 'Rikkomusraportti',
            sod_create_rule: 'Luo sääntö',
            sod_col_name: 'Nimi',
            sod_col_description: 'Kuvaus',
            sod_col_conflict_count: 'Konfliktien määrä',
            sod_col_severity: 'Vakavuus',
            sod_col_status: 'Tila',
            sod_col_actions: 'Toiminnot',
            sod_no_rules: 'SoD-sääntöjä ei löytynyt',
            sod_severity_warning: 'Varoitus',
            sod_severity_blocking: 'Estäminen',
            sod_active: 'Aktiivinen',
            sod_inactive: 'Ei-aktiivinen',
            sod_edit: 'Muokkaa',
            sod_exceptions: 'Poikkeukset',
            sod_deactivate: 'Poista käytöstä',
            sod_confirm_deactivate_title: 'Vahvista deaktivointi',
            sod_confirm_deactivate_message: 'Poistetaanko sääntö [[TOK_1]]? Se ei enää merkitse rikkomuksia.',
            sod_deactivate_error: 'Säännön poistaminen käytöstä epäonnistui',
            sod_rule_count: '{count} rules',
        },
        access_reviews: {
            title: 'Pääsyn tarkistukset',
            campaigns: 'Tarkistuskampanjat',
            new_campaign: 'Uusi kampanja',
            campaign_name: 'Kampanjan nimi',
            scope: 'Laajuus',
            reviewers: 'Tarkastajat',
            due_date: 'Määräaika',
            progress: 'Edistyminen',
            my_reviews: 'Omat tarkistukset',
            approve: 'Hyväksy',
            revoke: 'Peruuta',
            analytics: 'Roolianalytiikka',
            analytics_title: 'Roolianalytiikka',
            permission_usage: 'Käyttöoikeuksien käyttö',
            role_coverage: 'Roolien kattavuus',
            campaign_detail: 'Kampanjan tiedot',
            campaign_description: 'Kuvaus',
            campaign_status: 'Tila',
            campaign_deadline: 'Määräaika',
            campaign_scope_type: 'Laajuustyyppi',
            campaign_completion: 'Valmistuminen',
            campaign_total_items: 'Tuotteita yhteensä',
            campaign_pending_items: 'Odottaa',
            campaign_confirmed_items: 'Vahvistettu',
            campaign_revoked_items: 'Peruutettu',
            campaign_escalated_items: 'Eskaloitunut',
            campaign_launch: 'Käynnistä kampanja',
            campaign_cancel: 'Peruuta kampanja',
            campaign_confirm_launch: 'Haluatko varmasti käynnistää tämän kampanjan?',
            campaign_confirm_cancel: 'Haluatko varmasti peruuttaa tämän kampanjan?',
            campaign_launched: 'Kampanja käynnistetty onnistuneesti.',
            campaign_cancelled: 'Kampanja peruttu.',
            review_items: 'Tarkista kohteet',
            review_item_user: 'Käyttäjä',
            review_item_role: 'Rooli',
            review_item_reviewer: 'Arvostelija',
            review_item_decision: 'Päätös',
            review_item_justify: 'Perustelut',
            review_item_confirm: 'Vahvista',
            review_item_revoke: 'Peruuta',
            review_item_escalate: 'Eskaloida',
            all_decisions: 'Kaikki päätökset',
            bulk_action: 'Joukkotoiminta',
            bulk_confirm: 'Joukkovahvista',
            bulk_revoke: 'Joukko peruutus',
            selected_count: '[[TOK_1]] valittu',
            justify_required: 'Perustelut vaaditaan',
            scope_all_users: 'Kaikki käyttäjät',
            scope_role_owner: 'Roolin omistaja',
            scope_department: 'osasto',
            back_to_campaigns: 'Takaisin Kampanjoihin',
            recommendations: 'Suositukset',
            refreshing: 'Virkistävää...',
            decide: 'Päätä',
            decision_by: 'Päätös Tekijä',
            loading_items: 'Ladataan kohteita...',
            loading_review_items: 'Ladataan arvostelukohteita...',
            campaign_not_found: 'Kampanjaa ei löydy',
            loading_campaign: 'Ladataan kampanjan tietoja...',
            campaign_completed: 'Kampanja suoritettu onnistuneesti.',
            confirm_cancel_title: 'Vahvista Peruuta',
            justify_bulk_confirm: 'Joukkokäytön perustelu vahvista:',
            justify_bulk_revoke: 'Perusteet joukkoperuuttamiselle:',
            items_selected: '[[TOK_1]] kohde(t) valittu',
            justify_bulk_required: 'Joukkotoimille vaaditaan perustelut',
            create_campaign_title: 'Luo käyttöoikeuksien tarkistuskampanja',
            name_required: 'Nimi vaaditaan',
            scope_type_required: 'Laajuustyyppi vaaditaan',
            reviewer_strategy_required: 'Arvioijastrategia vaaditaan',
            deadline_required: 'Määräaika vaaditaan',
            reviewer_id_required: 'Tarkastajan tunnus vaaditaan tietylle käyttäjästrategialle',
            invalid_json: 'Virheellinen [[TOK_0]]',
            scope_filter_label: 'Laajuussuodatin ([[TOK_0]])',
            reviewer_strategy_label: 'Arvostelijastrategia',
            reviewer_id_label: 'Arvostelijan tunnus',
            deadline_label: 'Määräaika',
            create_campaign_btn: 'Luo kampanja',
            scope_type_label: 'Laajuustyyppi',
            scope_by_role: 'Rolen mukaan',
            scope_by_department: 'Osaston mukaan',
            scope_custom: 'Mukautettu',
            reviewer_manager: 'Manager',
            reviewer_specific_user: 'Tietty käyttäjä',
            enter_json_filter: 'Anna [[TOK_0]]-suodatin',
            hint_label: 'Vihje:',
            role_usage: 'Roolin käyttö',
            over_privileged_users: 'Ylioikeutetut käyttäjät',
            role_name_col: 'Roolin nimi',
            assigned_users: 'Määritetyt käyttäjät',
            active_users_30d: 'Aktiiviset käyttäjät (30 pv)',
            total_perms: 'Permit yhteensä',
            used_perms: 'Käytetyt Permit',
            unused_perms: 'Käyttämättömät Permit',
            no_data_available: 'Tietoja ei ole saatavilla',
            roles_col: 'Roolit',
            total_col: 'Yhteensä',
            used_col: 'Käytetty',
            unused_pct: 'Käyttämätön %',
            current_count: 'Nykyinen määrä',
            recommended_count: 'Suositeltu määrä',
            rationale: 'Perustelut',
            loading_analytics: 'Ladataan analytiikkaa...',
            loading_role_analytics: 'Ladataan roolin analytiikkatietoja...',
            computed_at: 'Laskettu osoitteessa:',
            form_errors: 'Lomakkeessa on [[TOK_1]] virhettä. Korjaa ne.',
            scope_filter_invalid_json: 'Laajuussuodatin sisältää virheellisen [[TOK_0]]',
            scope_hint_all_users: 'Suodatinta ei tarvita – kaikki käyttäjät otetaan mukaan.',
            review_type_label: 'Tarkistustyyppi',
            review_type_required: 'Tarkistustyyppi on pakollinen',
            reviewer_ids_label: 'Tarkastajan tunnukset',
            reviewer_ids_hint: 'Syötä käyttäjätunnukset pilkuilla eroteltuina',
            reviewer_ids_required: 'Vähintään yksi tarkastajan tunnus vaaditaan',
            start_date_label: 'Alkamispäivä',
            start_date_required: 'Alkamispäivä on pakollinen',
            end_date_label: 'Päättymispäivä',
            end_date_required: 'Päättymispäivä on pakollinen',
            review_type_user_access: 'Käyttäjän pääsy',
            review_type_role_permissions: 'Roolin oikeudet',
            review_type_service_accounts: 'Palvelutilit',
            review_type_privileged_access: 'Etuoikeutettu pääsy',
            review_type_application_access: 'Sovelluksen pääsy',
            auto_revoke_label: 'Automaattinen peruutus kieltäytymisellä',
            campaigns_title: 'Tarkastele kampanjoita',
            create_campaign_label: '+ Create Campaign',
            no_campaigns_found: 'No campaigns found',
            loading_campaigns: 'Loading campaigns...',
            no_reviews_assigned: 'Sinulle ei ole määrätty arvosteluja',
            loading_reviews: 'Loading reviews...',
            review_decision_title: 'Review Decision',
            justification_label: 'Perustelut',
            announce_loaded_review_items: 'Ladattu [[TOK_1]] arvostelukohdetta',
            announce_loaded_campaigns: 'Ladattu [[TOK_1]] kampanjaa',
            announce_decision_submitted: 'Päätös "[[TOK_1]] lähetettiin tarkistettavaksi',
            announce_decision_submitted_for: 'Päätös "[[TOK_2]]" lähetetty [[TOK_3]]',
            announce_bulk_decision: 'Joukko [[TOK_2]] käytetty [[TOK_3]] kohteelle',
        },
        attestation: {
            title: 'Vahvistusaikataulut',
            new: 'Uusi aikataulu',
            edit: 'Muokkaa aikataulua',
            create_title: 'Luo vahvistusaikataulu',
            edit_title: 'Muokkaa vahvistusaikataulua',
            schedule_history: 'Aikatauluhistoria',
            next_run_date: 'Seuraava suorituspäivä',
            schedule_name: 'Aikataulun nimi',
            frequency: 'Tiheys',
            next_run: 'Seuraava suoritus',
            last_run: 'Viimeisin suoritus',
            history: 'Vahvistushistoria',
            description: 'Kuvaus',
            scope: 'Laajuus',
            status: 'Tila',
            created_at: 'Luotu',
            updated_at: 'Päivitetty',
            trigger_now: 'Trigger Now',
            back_to_schedules: 'Back to Schedules',
            confirm_trigger: 'Trigger this schedule now?',
            confirm_delete: 'Delete this schedule?',
            triggered: 'Aikataulu käynnistyi onnistuneesti.',
            deleted: 'Aikataulu poistettu.',
            saved: 'Aikataulu tallennettu onnistuneesti.',
            campaigns_generated: 'Luodut kampanjat',
            run_date: 'Suorituspäivämäärä',
            run_status: 'Suorita tila',
            create_schedule: 'Luo aikataulu',
            view_history: 'Näytä historia',
            deactivate: 'Poista käytöstä',
            overdue: 'OVERDUE',
            overdue_sr: 'Aikataulu on myöhässä',
            confirm_trigger_title: 'Vahvista toiminto',
            confirm_trigger_message: 'Are you sure you want to trigger this schedule now?',
            confirm_deactivate_title: 'Vahvista deaktivointi',
            confirm_deactivate_message: 'Haluatko varmasti poistaa tämän aikataulun käytöstä?',
            triggered_success: 'Aikataulu käynnistyi onnistuneesti.',
            deactivated_success: 'Aikataulu poistettu käytöstä.',
            name_label: 'nimi *',
            frequency_label: 'Taajuus *',
            scope_type_label: 'Laajuustyyppi *',
            scope_filter_label: 'Laajuussuodatin ([[TOK_0]])',
            reviewer_strategy_label: 'Arvostelijastrategia *',
            reviewer_id_label: 'Arvostelijan tunnus *',
            frequency_quarterly: 'Neljännesvuosittain',
            frequency_semi_annual: 'Puolivuosittain',
            frequency_annual: 'Vuosittainen',
            scope_all_users: 'Kaikki käyttäjät',
            scope_by_role: 'Rolen mukaan',
            scope_by_department: 'Osaston mukaan',
            scope_framework: 'viitekehys',
            scope_custom: 'Mukautettu',
            reviewer_manager: 'Manager',
            reviewer_role_owner: 'Roolin omistaja',
            reviewer_specific_user: 'Tietty käyttäjä',
            computed_next_run_date: 'Laskettu seuraavan ajon päivämäärä',
            current_scheduled_date: 'Nykyinen suunniteltu päivämäärä',
            recomputed_frequency_changed: '(uudelleen laskettu -- taajuus muutettu)',
            estimated_days_hint: 'Arvioitu [[TOK_1]] päivän perusteella tästä päivästä',
            validation_name_required: 'Nimi vaaditaan',
            validation_frequency_required: 'Taajuus vaaditaan',
            validation_scope_type_required: 'Laajuustyyppi vaaditaan',
            validation_reviewer_strategy_required: 'Arvioijastrategia vaaditaan',
            validation_reviewer_id_required: 'Tarkastajan tunnus vaaditaan tietylle käyttäjästrategialle',
            validation_invalid_json: 'Virheellinen [[TOK_0]]',
            validation_scope_filter_invalid_json: 'Laajuussuodatin sisältää virheellisen [[TOK_0]]',
            form_errors: 'Lomakkeessa on [[TOK_1]] virhettä. Korjaa ne.',
            create_schedule_btn: 'Luo aikataulu',
            schedule_history_title: 'Aikatauluhistoria',
            campaign_name_col: 'Kampanjan nimi',
            items_col: 'Tuotteet',
            no_campaigns_yet: 'Kampanjoita ei ole vielä luotu',
            loading_history: 'Ladataan historiaa...',
            loading_schedule: 'Ladataan aikataulua...',
            total_campaigns: 'Kampanjoita yhteensä: [[TOK_1]]',
            results_per_page: 'Tulokset per sivu',
            page_size_option: '[[TOK_1]] / sivu',
        },
        sod: {
            title: 'Tehtävien eriyttämissäännöt (SoD)',
            new: 'Uusi sääntö',
            edit: 'Muokkaa sääntöä',
            create_title: 'Luo SoD-sääntö',
            edit_title: 'Muokkaa SoD-sääntöä',
            rule_name: 'Säännön nimi',
            conflicting_permissions: 'Ristiriitaiset käyttöoikeudet',
            permission_a: 'Käyttöoikeus A',
            permission_b: 'Käyttöoikeus B',
            violations: 'SoD-rikkomukset',
            violation_user: 'Käyttäjä',
            violation_rule: 'Rikottu sääntö',
            violation_date: 'Havaittu',
            exceptions: 'SoD-poikkeukset',
            exception_reason: 'Poikkeuksen syy',
            exception_approver: 'Hyväksyjä',
            exception_status: 'Poikkeustila',
            has_exception: 'On poikkeus',
            no_exception: 'Ei poikkeusta',
            grant_exception: 'Apuraha poikkeus',
            granting: 'Myönnetään...',
            grant_new_exception: 'Myönnä uusi poikkeus',
            exceptions_for: 'Poikkeukset: [[TOK_1]]',
            back_to_rules: 'Takaisin sääntöihin',
            no_violations: 'Rikkomuksia ei löytynyt',
            no_exceptions_found: 'Tälle säännölle ei löytynyt poikkeuksia',
            all_exception_statuses: 'Kaikki poikkeustilat',
            user_id_label: 'Käyttäjätunnus',
            justification_label: 'Perustelut',
            compensating_controls_label: 'Kompensoivat säätimet',
            expires_at_label: 'Päättyy klo',
            granting_exception_for: 'Poikkeuksen myöntäminen säännölle: [[TOK_1]]',
            severity: 'Vakavuus',
            severity_warning: 'Varoitus',
            severity_blocking: 'Estäminen',
            violation_count: '[[TOK_1]] rikkomukset',
            exception_count: '[[TOK_1]] poikkeusta',
            rule_description: 'Kuvaus',
            confirm_delete: 'Haluatko varmasti poistaa tämän säännön?',
            deleted: 'Sääntö poistettu.',
            framework_code: 'Saantelykehys',
            name_label: 'nimi *',
            severity_label: 'Vakavuus *',
            conflict_pairs_legend: 'Ristiriitalupaparit',
            conflict_pairs_hint: 'Jokainen pari määrittelee kaksi käyttöoikeutta, joita samalla käyttäjällä ei pitäisi olla.',
            placeholder_permission_a: '-- Lupa A --',
            placeholder_permission_b: '-- Lupa B --',
            permission_a_for_pair: 'Lupa A parille [[TOK_1]]',
            permission_b_for_pair: 'Lupa B parille [[TOK_1]]',
            conflict_pair_label: 'Ristiriitapari [[TOK_1]]',
            remove_conflict_pair: 'Poista ristiriitapari [[TOK_1]]',
            add_pair: '+ Lisää pari',
            placeholder_name: 'esim. Maksuhyväksynnän erottaminen',
            create_rule: 'Luo sääntö',
            loading_rule: 'Ladataan SoD-sääntöä...',
            failed_load_rule: 'Säännön lataaminen epäonnistui.',
            failed_create_rule: 'SoD-säännön luominen epäonnistui.',
            failed_update_rule: 'SoD-säännön päivittäminen epäonnistui.',
            validation_name_required: 'Nimi vaaditaan.',
            validation_pair_required: 'Vähintään yksi ristiriitalupapari vaaditaan.',
            validation_pair_both_required: 'Yhdistä [[TOK_1]]: Molemmat käyttöoikeudet on valittava.',
            validation_pair_must_differ: 'Pari [[TOK_1]]: Luvan A ja B:n on oltava eri.',
            added_conflict_pair: 'Lisätty ristiriitapari [[TOK_1]]',
            removed_conflict_pair: 'Poistettu ristiriitapari [[TOK_1]]',
            announce_loaded_violations: 'Ladattu [[TOK_1]] rikkomuksia',
            announce_loaded_exceptions: 'Ladattu [[TOK_1]] poikkeusta',
            announce_loaded_rules: 'Ladattu [[TOK_1]] SoD-säännöt',
            announce_loading_exceptions: 'Ladataan poikkeuksia…',
            regulatory_info: {
                sod_context: 'SoD-saannot toteuttavat PDPL:n vaatiman roolien erottamisen. framework_code-tunnisteeseen liitetyt rikkomukset voidaan sisallyttaa kehyskohtaisiin todistepaketteihin (UC-VN-09).',
                violation_export_context: 'SoD-rikkomusvienti sisaltaa framework_code, ristiriitaiset roolit, vakavuuden, luojan ja havaitsemisajankohdan todistepaketteihin (P-VN-10).',
                exception_context: 'SoD-poikkeukset tuottavat tarkastusnayttoa: hyvaksyja, perustelu, korvaavat kontrollit ja vanhentumispaiva. Vanhentuneet poikkeukset pysyvat nakyvissa (UC-VN-09 Vaihe 5).',
            },
        },
        regulatory_info: {
            attestation_context: 'Attestation schedules support the annual governance attestation cycle required by Data Law (DATA-D4). When scope_type is set to "framework", schedules can be linked to specific regulatory frameworks.',
            api_keys_context: 'API key telemetry constitutes account evidence per VN_CYBERSEC_LAW_2025 Section B.5. Each key record includes last_used_at, ip_allowlist, permissions, status, and expires_at.',
            session_context: 'Session management enforces access controls per Telecom Law confidentiality requirements (Section B.4). Session events produce audit trail entries.',
            break_glass_context: 'Break-glass procedures produce regulatory justification evidence: requestor identity, justification, permissions, duration, approver identity, and approval/denial timestamps.',
            license_context: 'License settings gate modules by tier using PACKAGE_DEFINITIONS. Framework-specific modules require appropriate license tiers. Tier changes produce audit trail entries.',
            module_config_context: 'Module configuration supports framework-driven enablement. Disabling a module required by an active regulatory framework may break evidence completeness.',
            notification_context: 'Compliance-critical notifications (breach deadlines, attestation due dates) are marked with a compliance_critical flag and cannot be fully suppressed.',
            delegation_context: 'Delegation governance produces audit-grade evidence: delegator_id, delegate_id, permission scope, start/end dates, and status. Expired delegations remain visible.',
            access_control_context: 'Access control configuration meets Cybersecurity Law requirements (VN_CYBERSEC_LAW_2025): IP allowlist, MFA, service accounts, and SSO changes are audit-trailed.',
        },
    },
    cmp: {
        integration: {
            title: 'CMP-integraatio',
            status: 'Yhteyden tila',
            endpoint: 'CMP-päätepiste',
            last_sync: 'Viimeisin synkronointi',
            configure: 'Määritä',
        },
        purpose_mapping: {
            title: 'Tarkoitusten kytkentä',
            cmp_purpose: 'CMP-tarkoitus',
            grc_purpose: 'GRC-tarkoitus',
            mapping_status: 'Kytkennän tila',
            auto_map: 'Automaattinen kytkentä',
            new_mapping: 'Uusi kytkentä',
        },
        webhook: {
            title: 'Webhook-asetukset',
            webhook_url: 'Webhook-URL',
            secret: 'Webhook-salaisuus',
            events: 'Tapahtumatyypit',
            test_webhook: 'Testaa webhook',
        },
        bulk_sync: {
            title: 'Joukkosynkronointi',
            sync_now: 'Synkronoi nyt',
            last_run: 'Viimeisin suoritus',
            records_synced: 'Synkronoidut tietueet',
            sync_history: 'Synkronointihistoria',
            syncing: 'Synkronoidaan...',
        },
        sync_settings: {
            sync_failures: 'Sync Epäonnistuminen',
            sync_secret_warning: 'Sync Salaisuus (save this now — it will not be shown again):',
            push_description: 'Määritä the GRC Suite to push case tila updates to AesirX CMP.',
            technical_description: 'Tämä määritys hallitsee sitä, kuinka GRC Suite lähettää tapauksen tilapäivitykset [[TOK_1]]:iin [[TOK_0]].',
            direction_label: 'Suunta',
            direction_value: 'GRC Suite → AesirX CMP (lähtevä)',
            auth_label: 'Todennus',
            auth_value: 'HMAC-SHA256-allekirjoitus X-GRC-Signature-otsikossa',
            retry_label: 'Yritä uudelleen Käytäntö',
            retry_value: '3 yritystä eksponentiaalisella viiveellä (30s, 2min, 10min)',
            inbound_label: 'Saapuva konfiguraatio',
            inbound_value: 'Saapuva webhook (CMP → GRC) on määritetty',
            cmp_webhook_settings: 'CMP Webhook Asetukset',
            page_title: 'CMP Synkronointiasetukset',
            outbound_sync_configured: 'Lähtevä synkronointi määritetty.',
            configure_sync_failed: 'Synkronoinnin määritys epäonnistui',
            configuration_updated: 'Määritys päivitetty.',
            update_configuration_failed: 'Määrityksen päivitys epäonnistui',
            connection_test_failed: 'Yhteystesti epäonnistui',
            test_result_message: 'Testi lähetetty osoitteeseen {endpoint}. Tila: {status}',
            endpoint_placeholder: 'https://your-cmp-domain/api/grc-sync',
            events: {
                new_to_under_review: 'Uusi → Under Katselmointia (assigned)',
                under_review_to_identity_verification: 'Tarkistettavana → Henkilöllisyyden vahvistus',
                under_review_to_in_progress: 'Tarkistettavana → Käynnissä',
                in_progress_to_completed: 'In Progress → Valmis',
                in_progress_to_denied: 'Käynnissä → Hylätty',
                any_to_closed: 'Mikä tahansa → Suljettu',
            },
        },
    },
    settings_pages: {
        webhooks: {
            title: 'Webhookit',
            new: 'Uusi webhook',
            url: 'URL',
            url_placeholder: 'https://example.com/webhook',
            events: 'Tapahtumat',
            secret: 'Salaisuus',
            active: 'Aktiivinen',
            test: 'Testaa',
            create_failed: 'Epäonnistui: create webhook. Yritä uudelleen.',
            create_success: 'Webhook luotiin onnistuneesti.',
            deactivate_failed: 'Epäonnistui: deactivate webhook. Yritä uudelleen.',
            deactivate_success: 'Webhook poistettu käytöstä.',
            fetch_failed: 'Epäonnistui: fetch webhooks. Yritä uudelleen.',
            send_test_failed: 'Epäonnistui: send test. Yritä uudelleen.',
            test_failed: 'Webhook-testi epäonnistui.',
            test_success: 'Webhook-testi onnistui.',
            edit_title: 'Muokkaa webhookia',
            announce_loaded: 'Webhookit ladattu',
            update_success: 'Webhook päivitetty onnistuneesti.',
            update_failed: 'Webhookin päivitys epäonnistui.',
            activate_success: 'Webhook aktivoitu.',
            activate_failed: 'Webhookin aktivointi epäonnistui.',
        },
        domains: {
            title: 'Verkkotunnukset',
            new: 'Uusi verkkotunnus',
            domain_name: 'Verkkotunnuksen nimi',
            verified: 'Vahvistettu',
            verify: 'Vahvista',
            add_failed: 'Epäonnistui: add domain. Yritä uudelleen.',
            add_success: 'Verkkotunnus added successfully.',
            domain_placeholder: 'esim. grc.example.com',
            fetch_failed: 'Epäonnistui: fetch domains. Yritä uudelleen.',
            remove_failed: 'Epäonnistui: remove domain. Yritä uudelleen.',
            remove_success: 'Verkkotunnus removed successfully.',
            txt_record: 'TXT Tietue',
            verify_dns_failed: 'DNS verification epäonnistunut.',
            verify_failed: 'Epäonnistui: verify domain. Yritä uudelleen.',
            verify_success: 'Verkkotunnus verified successfully.',
        },
        export_schedules: {
            title: 'Vientiaikataulut',
            new: 'Uusi aikataulu',
            schedule_name: 'Nimi',
            frequency: 'Tiheys',
            format: 'Muoto',
            last_run: 'Viimeisin suoritus',
            next_run: 'Seuraava suoritus',
            create_failed: 'Epäonnistui: create schedule. Yritä uudelleen.',
            create_success: 'Aikataulu created successfully.',
            day_of_month: 'Kuukauden päivä',
            day_of_week: 'Viikonpäivä',
            deactivate_failed: 'Epäonnistui: deactivate schedule. Yritä uudelleen.',
            deactivate_success: 'Aikataulu deactivated.',
            fetch_failed: 'Epäonnistui: fetch schedules. Yritä uudelleen.',
            freq_daily: 'Päivittäin',
            freq_monthly: 'Kuukausittain',
            freq_weekly: 'Viikoittain',
            recipients: 'Vastaanottajat',
            time_utc: 'Aika (UTC)',
            trigger_failed: 'Epäonnistui: trigger export. Yritä uudelleen.',
            trigger_success: 'Vie triggered successfully.',
            type_audit_trail: 'Tarkastus Trail',
            type_compliance_report: 'Vaatimustenmukaisuus Raportti',
            type_custom: 'Mukautettu',
            type_incident_report: 'Vaaratilanteita Raportti',
            type_ropa: 'ROPA',
        },
        email_log: {
            title: 'Sähköpostiloki',
            recipient: 'Vastaanottaja',
            subject: 'Aihe',
            sent_at: 'Lähetetty',
            status: 'Tila',
            resend: 'Lähetä uudelleen',
            fetch_failed: 'Epäonnistui: fetch sähköposti loki. Yritä uudelleen.',
        },
    },
    organizations: {
        title: 'Organisaatiot',
        create: 'Luo Organisaatio',
        edit: 'Muokkaa Organisaatio',
        name: 'Nimi',
        slug: 'Tunniste',
        timezone: 'Aikavyöhyke',
        locale: 'Oletus Maa-asetus',
        parent: 'Parent Organisaatio',
        group: 'Ryhmä',
        org_group: 'Organisaatioryhmä',
        no_group: '(Ei mitään - ei kuulu ryhmään)',
        created: 'Luotu',
        no_parent: '(Ei mitään - itsenäinen)',
        no_orgs: 'Ei organizations löytynyt',
        load_error: 'Epäonnistui: load organizations. Yritä uudelleen.',
        save_error: 'Epäonnistui: save organization. Yritä uudelleen.',
        created_msg: 'Organisaatio created',
        updated: 'Organisaatio updated',
        deactivate: 'Poista käytöstä',
        deactivated: 'Organisaatio deactivated',
        confirm_deactivate: 'Haluatko varmasti deactivate this organization?',
        loaded_results: 'Organizations ladattu, {count} tulosta',
        form_loaded: 'Organization-lomake ladattu',
        locale_vi_vn: 'Tiếng Việt (vi-VN)',
        locale_en_us: 'englanti (en-US)',
    },
    intake_configs: {
        title: 'Julkiset vastaanottokonfiguraatiot',
        create: 'Luo Config',
        edit: 'Muokkaa Intake Config',
        label_col: 'Tunniste',
        key: 'Intake Avain',
        key_hint: 'Julkinen URL on: /rights-request?key=',
        mapped_org: 'Tavoite Organisaatio',
        status: 'Tila',
        enabled: 'Käytössä',
        disabled: 'Pois käytöstä',
        request_types: 'Käytössä Pyyntö Tyypit',
        language: 'Oletus Kieli',
        public_url: 'Julkinen URL',
        no_configs: 'Ei intake configs found. luo one to enable public rights request forms. löytynyt',
        load_error: 'Epäonnistui: load intake configs. Yritä uudelleen.',
        save_error: 'Epäonnistui: save. Yritä uudelleen.',
        delete_error: 'Epäonnistui: delete. Yritä uudelleen.',
        created_msg: 'Konfiguraatio luotu',
        updated: 'Konfiguraatio päivitetty',
        deleted: 'Vastaanottokonfiguraatio poistettu',
        confirm_delete: 'Poista this intake config?',
        select_types: 'Valitse at least one request tyyppi',
        select_org: 'Valitse a target organization',
        routing_mode: 'Reititystila',
        single_org: 'Yksittäinen Organisaatio',
        org_group_mode: 'Organisaatioryhmä',
        org_group: 'Organisaatioryhmä',
        select_group: 'Valitse organisaatioryhmä...',
        group_root_hint: 'Asetetaan automaattisesti ryhmän juuriorganisaatioksi, kun ryhmä valitaan.',
        loaded_results: 'Intake configurations ladattu, {count} tulosta',
        form_loaded: 'Intake configuration-lomake ladattu',
    },
    frequency: {
        weekly: 'Viikoittain',
        monthly: 'Kuukausittain',
        quarterly: 'Neljännesvuosittain',
        semi_annually: 'Puolivuosittain',
        annually: 'Vuosittain',
        custom: 'Mukautettu',
    },
    task_management: {
        nav: {
            calendar: 'Kalenteri',
            all_tasks: 'Kaikki tehtävät',
            my_tasks: 'Omat tehtävät',
            overdue: 'Myöhässä',
            board: 'Taulu',
            workflows: 'Työnkulut',
        },
        list: {
            title: 'Kaikki tehtävät',
            my_title: 'Omat tehtävät',
            overdue_title: 'Myöhässä olevat tehtävät',
            new_task: 'Luo tehtävä',
            no_tasks: 'Tehtäviä ei löytynyt.',
            empty_state: 'Ei tehtäviä. Tehtävät luodaan moduulien työnkuluista, kuten arvioinneista, poikkeamista ja tarkistuskampanjoista.',
            total: 'Tehtäviä yhteensä',
            search_placeholder: 'Hae tehtäviä...',
            bulk_actions: 'Massatoiminnot',
            change_status: 'Vaihda tila',
            change_priority: 'Vaihda prioriteetti',
            assign: 'Määritä',
            sr_my_tasks_count: '{count} tehtävää sinulle',
            sr_days_overdue: '{count} päivää myöhässä',
            sla_label: 'SLA',
        },
        detail: {
            title: 'Tehtävän tiedot',
            description: 'Kuvaus',
            workflow_progress: 'Työnkulun edistyminen',
            checklist: 'Tarkistuslista',
            dependencies: 'Riippuvuudet',
            comments: 'Kommentit',
            activity_timeline: 'Toiminnan aikajana',
            assignees: 'Vastuuhenkilöt',
            add_assignee: 'Lisää vastuuhenkilö',
            remove_assignee: 'Poista vastuuhenkilö',
            due_date: 'Eräpäivä',
            start_date: 'Aloituspäivä',
            sla_status: 'SLA-tila',
            sla_on_track: 'Aikataulussa',
            sla_at_risk: 'Vaarassa',
            sla_breached: 'Rikottu',
            tags: 'Tunnisteet',
            source_entity: 'Lähde-entiteetti',
            view_source: 'Näytä lähde',
            add_dependency: 'Lisää riippuvuus',
            remove_dependency: 'Poista riippuvuus',
            write_comment: 'Kirjoita kommentti...',
            post_comment: 'Lähetä',
            edit_comment: 'Muokkaa',
            delete_comment: 'Poista',
            add_checklist_item: 'Lisää kohde',
            no_dependencies: 'Ei riippuvuuksia',
            no_comments: 'Ei kommentteja vielä',
            blocks: 'Estää',
            blocked_by: 'Estetty',
            related: 'Liittyvä',
            working_days_remain: 'työpäivää jäljellä',
            created_by: 'Luonut',
            completed_at: 'Valmistunut',
            no_assignees: 'Ei vastuuhenkilöitä',
            add_assignee_placeholder: 'Syötä käyttäjätunnus...',
            edited: 'muokattu',
            timeline: 'Toiminnan aikajana',
            no_timeline: 'Ei toimintaa vielä',
            no_workflow: 'Ei työnkulkua määritettynä',
            add_dependency_placeholder: 'Syötä tehtävätunnus...',
            sr_status_updated: 'Tila päivitetty [[TOK_1]]',
            sr_priority_updated: 'Prioriteetti päivitetty arvoon [[TOK_1]]',
            convert_to_workflow: 'Suorita työnkulkuna',
            convert_modal_title: 'Muunna tehtävä työnkulkuajoksi',
            convert_workflow_label: 'Työnkulku',
            convert_workflow_placeholder: 'Valitse työnkulku…',
            convert_attachments_label: 'Liitteet',
            convert_attachments_empty: 'Ei liitteitä tähän tehtävään.',
            convert_persona_label: 'Personan ohitus (valinnainen)',
            convert_submit: 'Aloita työnkulun ajo',
            convert_starting: 'Aloitetaan työnkulkua…',
            convert_started: 'Työnkulkuajo aloitettu – avausajo…',
            convert_disabled_in_flight: 'Tästä tehtävästä suoritettava työnkulku on jo käynnissä.',
            linked_workflow_chip: 'Lähettäjä [[TOK_1]]',
            linked_chat_chip: 'Chatista [[TOK_0]]',
            linked_more: '+[[TOK_1]] lisää',
        },
        calendar: {
            title: 'Tehtäväkalenteri',
            page_title: 'Kalenteri',
            create_task: 'Luo tehtävä',
            month: 'Kuukausi',
            week: 'Viikko',
            day: 'Päivä',
            today: 'Tänään',
            more_tasks: '+[[TOK_1]] lisää',
            no_tasks_day: 'Ei tehtäviä tänä päivänä',
            all_day: 'Koko päivä',
            quick_create_tooltip: 'Luo tehtävä tälle päivälle',
            view_changed: 'Kalenterinäkymä vaihdettu: {view}',
            tasks_in_view: '{count} tehtävää näkymässä',
            task_in_view: '[[TOK_1]] tehtävä näkyvissä',
        },
        filters: {
            assignee: 'Vastuuhenkilö',
            me: 'Minä',
            role: 'Rooli',
            status: 'Tila',
            priority: 'Prioriteetti',
            task_type: 'Tehtävätyyppi',
            source_module: 'Lähdemoduuli',
            organization: 'Organisaatio',
            sla_breached_only: 'Näytä vain SLA-rikotut',
            clear_filters: 'Tyhjennä suodattimet',
            apply_filters: 'Käytä',
            source_label: 'lähde',
            source_manual: 'Manuaalinen',
            source_module_kind: 'Moduuli luotu',
            source_chat: 'Chatista [[TOK_0]]',
            source_workflow_run: 'Alkaen [[TOK_0]] Workflow Run',
        },
        status: {
            pending: 'Odottava',
            in_progress: 'Käynnissä',
            blocked: 'Estetty',
            completed: 'Valmis',
            overdue: 'Myöhässä',
            escalated: 'Eskaloitu',
            cancelled: 'Peruutettu',
        },
        priority: {
            critical: 'Kriittinen',
            high: 'Korkea',
            medium: 'Keskitaso',
            low: 'Matala',
        },
        task_types: {
            manual_task: 'Manuaalinen tehtävä',
            dsr_case: 'DSR-tapaus',
            dsr_review: 'DSR-tarkistus',
            dsr_escalation: 'DSR-eskalointi',
            dpia_review: 'DPIA-tarkistus',
            dpia_approval: 'DPIA-hyväksyntä',
            transfer_review: 'Siirtotarkistus',
            incident_task: 'Poikkeamatehtävä',
            incident_notification: 'Poikkeamailmoitus',
            playbook_step: 'Ohjekirjan vaihe',
            regulator_deadline: 'Viranomaisaikamäärä',
            monitoring_task: 'Valvontatehtävä',
            kpi_alert: 'KPI-hälytys',
            vendor_review: 'Toimittajatarkistus',
            vendor_questionnaire: 'Toimittajakysely',
            governance_review: 'Hallintotarkistus',
            drift_alert: 'Poikkeamahälytys',
            governance_approval: 'Hallintohyväksyntä',
            deletion_task: 'Poistotehtävä',
            deletion_verification: 'Poistovarmistus',
            access_review: 'Pääsytarkistus',
            sod_alert: 'SoD-hälytys',
            consent_workflow: 'Suostumustyönkulku',
            consent_alert: 'Suostumushälytys',
            property_review: 'Ominaisuustarkistus',
            inconsistency_alert: 'Epäjohdonmukaisuushälytys',
            form_review: 'Lomaketarkistus',
            dossier_deadline: 'Kansioaikamäärä',
            submission_task: 'Lähetystehtävä',
            translation_review: 'Käännöstarkistus',
            governance_task: 'Hallintotehtävä',
            reporting_deadline: 'Raportointiaikamäärä',
            scanner_alert: 'Skannerihälytys',
            classification_review: 'Luokittelutarkistus',
            lifecycle_task: 'Elinkaaritehtävä',
            discovery_review: 'Löytämistarkistus',
        },
        task_type_groups: {
            manual: 'Manuaalinen',
            dsr: 'DSR / Rekisteröidyn oikeudet',
            assessments: 'Arvioinnit',
            incidents: 'Poikkeamat',
            incident_ops: 'Poikkeamatoiminnot',
            monitoring: 'Valvonta',
            vendor_risk: 'Toimittajariski',
            governance: 'Hallinto',
            deletion: 'Poisto',
            access_review: 'Pääsytarkistus',
            consent: 'Suostumus',
            consent_properties: 'Suostumuksen ominaisuudet',
            forms: 'Lomakkeet',
            localization: 'Lokalisointi',
            program_governance: 'Ohjelmahallinto',
            privacy_scanner: 'Tietosuojaskanneri',
            classification: 'Luokittelu',
            discovery: 'Löytäminen',
        },
        create: {
            title: 'Luo tehtävä',
            task_title: 'Otsikko',
            task_description: 'Kuvaus',
            task_type: 'Tehtävätyyppi',
            task_type_label: 'Tehtävätyyppi',
            task_type_placeholder: 'Valitse tehtävätyyppi',
            priority: 'Prioriteetti',
            assignees: 'Vastuuhenkilöt',
            assignee_search_placeholder: 'Hae käyttäjiä...',
            due_date: 'Eräpäivä',
            start_date: 'Aloituspäivä',
            checklist: 'Tarkistuslista',
            tags: 'Tunnisteet',
            add_checklist_item: 'Lisää tarkistuslistakohde',
            validation: {
                title_required: 'Otsikko on pakollinen',
                title_max_length: 'Otsikko saa olla enintään 500 merkkiä',
                description_max_length: 'Kuvaus saa olla enintään 5000 merkkiä',
                due_date_before_start: 'Eräpäivän on oltava aloituspäivän jälkeen',
                max_reminders: 'Enintään 5 muistutusta tehtävää kohti',
            },
            reminders: {
                title: 'Muistutukset',
                add: 'Lisää muistutus',
                at_due_date: 'Eräpäivänä',
                minutes_before: '[[TOK_1]] minuuttia ennen',
                hours_before: '[[TOK_1]] tuntia ennen',
                days_before: '[[TOK_1]] päivää ennen',
                weeks_before: '[[TOK_1]] viikkoa ennen',
                custom: 'Mukautettu',
                channel_platform: 'Alusta',
                channel_email: 'Sähköposti',
                channel_both: 'Molemmat',
            },
            workflow: {
                label: 'Työnkulku',
                none: 'Ei mitään (manuaalinen tilanhallinta)',
                steps_count: '[[TOK_1]] askelta',
                preview_label: 'Työnkulun vaiheet',
            },
        },
        errors: {
            fetch_failed: 'Tehtävien lataaminen epäonnistui.',
            save_failed: 'Tehtävän tallentaminen epäonnistui.',
            delete_failed: 'Tehtävän poistaminen epäonnistui.',
            status_change_failed: 'Tehtävän tilan vaihtaminen epäonnistui.',
            assign_failed: 'Tehtävän määrittäminen epäonnistui.',
            comment_failed: 'Kommentin tallentaminen epäonnistui.',
            checklist_failed: 'Tarkistuslistan päivittäminen epäonnistui.',
            dependency_failed: 'Riippuvuuden päivittäminen epäonnistui.',
            workflow_failed: 'Työnkulun tallentaminen epäonnistui.',
            workflow_activate_failed: 'Työnkulun aktivointi epäonnistui.',
            workflow_delete_failed: 'Työnkulun poistaminen epäonnistui.',
            template_install_failed: 'Mallin asentaminen epäonnistui.',
            search_failed: 'Tehtävien hakeminen epäonnistui.',
            convert_failed: 'Työnkulkua ei voitu käynnistää.',
            convert_quota_exhausted: 'Token bucket alhainen. Täytä ennen uudelleenkäynnistystä.',
        },
        dependency_types: {
            blocks: 'Estää',
            blocked_by: 'Estetty',
            related: 'Liittyvä',
        },
        workflow: {
            current_step: 'Nykyinen vaihe',
            transition: 'Siirtymä',
            history: 'Vaihehistoria',
            no_workflow: 'Ei työnkulkua määritettynä',
            detail_title: 'Työnkulun tiedot',
            list_title: 'Työnkulkumääritykset',
            create_workflow: 'Luo työnkulku',
            browse_templates: 'Selaa malleja',
            template_catalog_title: 'Työnkulkumallikatalogi',
            name: 'Nimi',
            description: 'Kuvaus',
            task_types: 'Tehtävätyypit',
            steps: 'Vaiheet',
            version: 'Versio',
            created: 'Luotu',
            actions: 'Toiminnot',
            status_draft: 'Luonnos',
            status_active: 'Aktiivinen',
            status_archived: 'Arkistoitu',
            activate: 'Aktivoi',
            archive: 'Arkistoi',
            save: 'Tallenna',
            edit: 'Muokkaa',
            delete: 'Poista',
            clone: 'Kopioi',
            install: 'Asenna',
            installed: 'Asennettu',
            system: 'Järjestelmä',
            general_settings: 'Yleiset asetukset',
            default_assignment: 'Oletustoimeksianto',
            default_sla: 'Oletus-SLA',
            workflow_steps: 'Työnkulun vaiheet',
            add_step: 'Lisää vaihe',
            step_name: 'Vaiheen nimi',
            step_status: 'Tila-arvo',
            assignment_strategy: 'Toimeksiantostrategia',
            assignment_role: 'Toimeksiantorooli',
            sla_hours: 'SLA-tunnit',
            sla_calendar_type: 'Kalenterityyppi',
            working_days: 'Työpäivät',
            calendar_days: 'Kalenteripäivät',
            is_terminal: 'Päätösvaihe',
            required_fields: 'Pakolliset kentät',
            checklist_template: 'Tarkistuslistamalli',
            transitions: 'Siirtymät',
            add_transition: 'Lisää siirtymä',
            from_step: 'Mistä',
            to_step: 'Mihin',
            permission: 'Oikeus',
            sla_action: 'SLA-toiminto',
            notify: 'Ilmoita',
            escalation_rules: 'Eskalointisäännöt',
            add_rule: 'Lisää sääntö',
            trigger: 'Laukaisin',
            threshold: 'Kynnysarvo',
            action: 'Toiminto',
            target_role: 'Kohderooli',
            trigger_sla_threshold: 'SLA-kynnysarvo',
            trigger_sla_breach: 'SLA-rikkomus',
            trigger_blocked_duration: 'Estetty kesto',
            trigger_manual: 'Manuaalinen',
            action_notify: 'Ilmoita',
            action_escalate: 'Eskaloi taso',
            action_reassign: 'Uudelleenmääritä',
            sla_start: 'Aloita',
            sla_pause: 'Keskeytä',
            sla_resume: 'Jatka',
            sla_stop: 'Lopeta',
            strategy_manual: 'Manuaalinen',
            strategy_role_based: 'Roolipohjainen',
            strategy_round_robin: 'Round Robin',
            strategy_least_loaded: 'Vähiten kuormitettu',
            strategy_creator: 'Luoja',
            confirm_delete: 'Haluatko varmasti poistaa tämän työnkulun?',
            confirm_archive: 'Haluatko varmasti arkistoida tämän työnkulun?',
            cannot_delete_active: 'Aktiivisia työnkulkuja ei voi poistaa. Arkistoi ensin.',
            validation_errors: 'Työnkulun validointivirheet',
            step_count: '[[TOK_1]] askelta',
            no_workflows: 'Työnkulkuja ei löytynyt.',
            no_templates: 'Malleja ei saatavilla.',
            sr_templates_count: '[[TOK_1]] malleja saatavilla',
            template_installed: 'Malli asennettu onnistuneesti.',
            activate_success: 'Työnkulku aktivoitu onnistuneesti.',
            archive_success: 'Työnkulku arkistoitu onnistuneesti.',
            save_success: 'Työnkulku tallennettu onnistuneesti.',
            delete_success: 'Työnkulku poistettu onnistuneesti.',
        },
        columns: {
            priority: 'Prioriteetti',
            title: 'Otsikko',
            status: 'Tila',
            type: 'Tyyppi',
            assignees: 'Vastuuhenkilö(t)',
            due_date: 'Eräpäivä',
            source: 'Lähde',
            actions: 'Toiminnot',
        },
        groups: {
            overdue: 'Myöhässä',
            due_today: 'Erääntyy tänään',
            due_this_week: 'Erääntyy tällä viikolla',
            due_later: 'Erääntyy myöhemmin',
            no_due_date: 'Ei eräpäivää',
        },
        board: {
            title: 'Tehtävätaulu',
            drag_hint: 'Vedä tehtäviä sarakkeiden välillä tilan vaihtamiseksi',
            empty_column: 'Ei tehtäviä',
            keyboard_hint: 'Näppäimistö: nuolinäppäimet navigointiin, välilyönti poimii tehtävän, vasen/oikea nuoli valitsee sarakkeen, Enter pudottaa, Escape peruuttaa.',
            sr_moving: 'Siirretään {title}. Kohdassa {column}. Paina Enter pudottaaksesi, Escape peruuttaaksesi.',
            sr_tasks_shown: '{count} tehtävää näytetty',
            sr_picked_up: '{title} poimittu',
            sr_returned: '[[TOK_2]] palasi [[TOK_3]]',
            sr_dropped: '{title} pudotettu sarakkeeseen {column}, sijainti {position}/{total}',
            sr_move_cancelled: 'Siirto peruutettu',
            sr_over_column: 'Kohdassa {column}',
            sr_moved_to: '{title} siirretty sarakkeeseen {column}',
            invalid_transition: 'Tehtavaa ei voi siirtaa tilasta {from} tilaan {to}.',
            terminal_status: 'Tama tehtava on paatostilassa eika sita voi siirtaa.',
            invalid_drop_target: 'Virheellinen pudotuskohde',
        },
        team: {
            title: 'Tiimin työkuorma',
            assignee: 'Vastuuhenkilö',
            active: 'Aktiivinen',
            overdue: 'Myöhässä',
            blocked: 'Estetty',
            completed_7d: 'Valmis (7p)',
            load: 'Kuorma',
            load_high: 'Korkea',
            load_medium: 'Keskitaso',
            load_normal: 'Normaali',
        },
        graph: {
            title: 'Riippuvuuskaavio',
            list_view: 'Luettelonäkymä',
            graph_view: 'Kaavionäkymä',
            zoom_in: 'Lähennä',
            zoom_out: 'Loitonna',
            reset_zoom: 'Nollaa',
            blocks_label: 'blocks',
            related_label: 'related',
            no_dependencies: 'Ei visualisoitavia riippuvuuksia.',
        },
        add_dependency_modal: {
            title: 'Lisää riippuvuus',
            search_placeholder: 'Hae tehtäviä otsikon tai tunnuksen perusteella...',
            no_results: 'Tehtäviä ei löytynyt.',
            this_blocks: 'Tämä tehtävä estää valitut',
            this_blocked_by: 'Valittu on estänyt tämän tehtävän',
            related: 'Liittyvä',
            max_dependencies: 'Enintään 10 riippuvuutta tehtävää kohden.',
            circular_error: 'Ei voi lisätä: luo pyöreän riippuvuuden.',
        },
        conflict_detection: {
            title: 'Ristiriitojen tunnistus',
            unresolved: 'ratkaisematon',
            no_conflicts: 'Ei ristiriitoja havaittu',
            section: 'Osio',
            field: 'Kenttä',
            dept_a: 'Osasto A',
            value_a: 'Arvo A',
            dept_b: 'Osasto B',
            value_b: 'Arvo B',
            severity: 'Vakavuus',
            status: 'Tila',
            resolved: 'Ratkaistu',
            open: 'Avoin',
            resolve: 'Ratkaise',
            load_failed: 'load conflicts epäonnistui',
            resolve_success: 'Ristiriita ratkaistu onnistuneesti',
            resolve_failed: 'resolve conflict epäonnistui',
            severity_critical: 'Kriittinen',
            severity_warning: 'Varoitus',
            severity_info: 'Tietoja',
        },
        consolidation: {
            title: 'Konsolidoinnin eteneminen',
            add_child: 'Lisää alatehtävä',
            child_task_id: 'Alatehtävän tunnus',
            department_id: 'Osaston tunnus',
            link: 'Linkitä',
            overall_completion: 'Kokonaisvalmistuminen',
            departments_complete: 'Osastot valmiit',
            overdue: 'Myöhässä',
            ready: 'Valmis',
            not_ready: 'Ei valmis',
            master_status: 'Päätila',
            department_breakdown: 'Osastokohtainen erittely',
            department: 'Osasto',
            status: 'Tila',
            completion: 'Valmistuminen',
            due_date: 'Eräpäivä',
            overdue_flag: 'Myöhässä',
            child_tasks: 'Alatehtävät',
            task: 'Tehtävä',
            load_failed: 'load consolidation data epäonnistui',
            child_linked: 'Alatehtävä linkitetty onnistuneesti',
            link_failed: 'link child task epäonnistui',
            confirm_unlink: 'Haluatko varmasti poistaa tämän lapsitehtävän linkityksen?',
            child_unlinked: 'Lapsitehtävän linkitys poistettu',
            unlink_failed: 'Alatason tehtävän linkityksen poistaminen epäonnistui',
            unlink: 'Poista linkitys',
            status_completed: 'Valmis',
            status_in_progress: 'Käynnissä',
            status_pending: 'Odottaa',
            select_child_task: 'Valitse alitehtävä',
            select_department: 'Valitse osasto',
        },
        section_assignments: {
            title: 'Osiokohdistukset',
            assign_section: 'Kohdista osio',
            section_ref: 'Osion viite',
            section_label: 'Osion tunniste',
            department_id: 'Osaston tunnus',
            department: 'osasto',
            assignee_id: 'Vastaanottajan tunnus',
            assignee: 'Valtuutettu',
            mandatory: 'Pakollinen',
            assign: 'Kohdista',
            no_assignments: 'Ei osiokohdistuksia',
            status: 'Tila',
            completion: 'Valmistuminen',
            mark_complete: 'Valmis',
            load_failed: 'load section assignments epäonnistui',
            assign_success: 'Osio kohdistettu onnistuneesti',
            assign_failed: 'assign section epäonnistui',
            status_updated: 'Tila päivitetty',
            status_update_failed: 'Tilan päivittäminen epäonnistui',
            section_ref_placeholder: 'esim. 3.2',
            status_completed: 'Valmis',
            status_in_progress: 'Meneillään',
            status_pending: 'Odottaa',
            select_department: 'Valitse osasto',
            select_assignee: 'Valitse valtuutettu',
        },
        overdue_columns: {
            days_overdue: 'Paivaa myohassa',
        },
        regulatory_info: {
            deadline_context: 'Luotaessa DPIA-tehtavia eraapaivien tulisi vastata PDPL-jaettoaikoja: osastosyote = 10 tyopaivaa. Kyberturvallisuus- ja televiestintamaeraaajat ovat myos voimassa.',
            overdue_deadline_context: 'Saantelymaeraaajat pakettidatasta: PDPL osastosyote = 10 tyopaivaa, lisavastaus = 15 tyopaivaa, uudelleenlahetys = 10 tyopaivaa. SLA-rikkomukset korostetaan visuaalisesti.',
            section_assignment_context: 'DPIA monen osaston tyonkulku (PDPL-P1): DPO osoittaa asiakirjaosiot osastoille. Osastosyoteen maeraaika: 10 tyopaivaa.',
            template_catalog_context: 'Jarjestelmamallit kattavat kehyskohtaiset prosessit: PDPL DPIA, tietolain todistus, kyberturvallisuusvastaus, televiestintaviranomaispyynnot ja AI-rekisterointi. Jarjestelmamallit eivat ole muokattavissa.',
            workflow_instantiation_context: 'Asennetut mallit voidaan luoda aktiivisiksi tyonkuluiksi. Tehtavat luodaan automaattisesti lasketuilla eraapaivilla.',
        },
    },
    notifications: {
        bell: {
            title: 'Ilmoitukset',
            unread_count: 'unread',
        },
        drawer: {
            title: 'Ilmoitukset',
            mark_all_read: 'Merkitse kaikki luetuiksi',
            no_notifications: 'Ei ilmoituksia',
            filter: {
                all: 'All',
                unread: 'Lukematon',
                tasks: 'Tehtävät',
                approvals: 'Hyväksynnät',
                alerts: 'Hälytykset',
            },
        },
        preferences: {
            title: 'Ilmoitusasetukset',
            description: 'Määritä, miten saat ilmoituksia',
            category: {
                label: 'Luokka',
                task_assigned: 'Tehtävä määrätty',
                task_sla_approaching: '[[TOK_0]] Lähestymme',
                task_overdue: 'Tehtävä myöhässä',
                task_completed: 'Tehtävä suoritettu',
                task_escalated: 'Tehtävä Eskaloitu',
                workflow_transition: 'Työnkulun siirtyminen',
                approval_requested: 'Hyväksyntää pyydetty',
                comment_added: 'Kommentti lisätty',
                weekly_digest: 'Viikoittainen tiivistelmä',
                sla_breach_report: '[[TOK_0]] Rikkomusraportti',
                system_alert: 'Järjestelmän hälytys',
            },
            channel: {
                platform: 'Alusta',
                email: 'S?hk?posti',
            },
            quiet_hours: {
                title: 'Hiljaiset tunnit',
                start: 'Aloita',
                end: 'End',
                timezone: 'Aikavyöhyke',
            },
            digest: {
                title: 'Digest Frequency',
                daily: 'Päivittäin',
                weekly: 'viikoittain',
                none: 'Ei mitään',
            },
            watched: {
                title: 'Katsotut kokonaisuudet',
                empty: 'Ei katsottuja kokonaisuuksia',
            },
            save: 'Tallenna asetukset',
            saving: 'Tallennetaan...',
            saved_success: 'Asetukset tallennettu onnistuneesti',
            load_error: 'Ei voitu ladata tallennettuja asetuksia. Näytetään oletukset – muutokset tallennetaan, kun napsautat Tallenna.',
            enabled: 'Käytössä',
            disabled: 'Ei käytössä',
            unwatch: 'Poista katselu',
        },
        admin_queue: {
            title: 'Ilmoitusten hallintajono',
            description: 'Seuraa sähköpostin toimitustilaa ja yritä epäonnistuneita viestejä uudelleen',
            load_error: 'Sähköpostijonon tietojen lataaminen epäonnistui',
            retry_error: 'Sähköpostin uudelleenyritys epäonnistui',
            filter_status: 'Suodata tilan mukaan',
            all_statuses: 'Kaikki',
            refresh: 'Päivitä',
            status_queued: 'Jonossa',
            status_sent: 'Lähetetty',
            status_failed: 'Epäonnistunut',
            status_bounced: 'Palautunut',
            col_recipient: 'Vastaanottaja',
            col_category: 'Kategoria',
            col_template: 'Malli',
            col_status: 'Tila',
            col_retries: 'Uudelleenyritykset',
            col_created: 'Luotu',
            col_sent: 'Lähetetty',
            col_actions: 'Toiminnot',
            no_items: 'Sähköpostijonossa ei ole kohteita',
            retry: 'Yritä uudelleen',
            retrying: 'Yritetään uudelleen...',
            prev: 'Edellinen',
            next: 'Seuraava',
            access_denied_title: 'Järjestelmänvalvojan käyttöoikeus vaaditaan',
            access_denied: 'Tämä sivu on käytettävissä vain järjestelmänvalvojille. Ota yhteyttä järjestelmänvalvojaasi, jos tarvitset käyttöoikeuden.',
            announce_queue_loaded: 'Sähköpostijono ladattu, [[TOK_1]] kohdetta',
            announce_processed: 'Käsitelty [[TOK_1]] sähköposti(ta)',
            process_now: 'Käsittele nyt',
            processing_ellipsis: 'Käsitellään…',
        },
    },
    ui_assist: {
        toolbar: {
            title: 'UI Assist',
            activate: 'Aktivoi',
            deactivate: 'Poista käytöstä',
            connected: 'Yhdistetty',
            disconnected: 'Yhteys katkaistu',
            disconnected_hint: "Yhteys katkaistu — suorita `npm run relay' muodostaaksesi yhteyden Claude CLI:hen",
            open_panel: 'Avaa UI Assist -paneeli',
            history: 'Historia',
            settings: 'Asetukset',
        },
        prompt: {
            placeholder: 'Kuvaile muutos, jonka haluat tehdä…',
            send: 'Lähetä',
            cancel: 'Peruuta',
            char_count: '[[TOK_2]] / [[TOK_3]]',
        },
        session: {
            streaming: 'Käsitellään…',
            complete: 'Täydellinen',
            error: 'Virhe',
            abort: 'Keskeytä',
            abort_confirm: 'Oletko varma, että haluat keskeyttää?',
            aborted_hint: 'Istunto keskeytettiin — voit jatkaa tästä.',
            undo: 'Kumoa',
            redo: 'Toista',
            retry: 'Yritä uudelleen',
            dismiss: 'Hylkää',
        },
        label: {
            component: 'Komponentti',
            element: 'Elementti',
            file: 'Tiedosto',
        },
        response: {
            you: 'You',
            claude: 'Claude',
            empty: 'Ei viestejä vielä. Valitse elementit ja lähetä kehote aloittaaksesi.',
        },
        panel: {
            tab_conversation: 'Chat',
            tab_tasks: 'Tehtävät',
            tab_sprint: 'Sprintti',
            tab_sessions: 'Istunnot',
            tab_lobby: 'Aula',
            follow_up: 'Seuraa',
            followup_placeholder: 'Esitä jatkokysymys…',
            interrupt_placeholder: 'Kirjoita keskeyttääksesi ja uudelleenohjataksesi…',
            send_interrupt: 'Lähetä & Keskeytä',
            will_interrupt: 'Keskeyttää nykyisen vastauksen ja lähettää tämän sen sijaan',
            expand: 'Laajenna koko näytölle',
            collapse: 'Pienennä sivupaneeliin',
            no_sessions: 'Ei aiempia istuntoja. Valitse elementtejä ja lähetä ohje aloittaaksesi.',
            session_active: 'Aktiivinen',
            session_ended: 'Päättynyt',
            session_messages: '{count} viestiä',
            switch_session: 'Vaihda tähän istuntoon',
            load_session: 'Lataa istuntohistoria',
            session_restored: 'Istunto palautettu historiasta',
            archive_session: 'Arkiston istunto',
            archive_confirm: 'Arkistoidaanko tämä istunto? Istuntotiedosto poistetaan.',
            new_session: 'Uusi istunto',
            new_session_desc: 'Käytä Aktivoi valitaksesi käyttöliittymäelementin ja aloittaaksesi uuden istunnon',
            start_new_session: 'Aloita uusi istunto',
            no_active_session_chat: 'Aloita uusi istunto tai valitse sivulta käyttöliittymäelementti Aktivoi-painikkeella.',
            no_active_session_tasks: 'Aloita uusi istunto tai luo tehtäviä valitsemalla olemassa oleva istunto.',
            no_active_session_sprint: 'Aloita uusi istunto tai valitse olemassa oleva istunto suunnitellaksesi sprintin.',
            previous_sessions: 'Edelliset istunnot',
        },
        tasks: {
            none_found: 'Vastauksesta ei löytynyt tehtäviä. Pyydä Claudea ehdottamaan tehtäviä.',
            selected: 'selected',
            create_selected: 'Luo tehtäviä',
            execute_tasks: 'Suorita tehtävät',
            creating: 'Luodaan…',
            created: 'luotuja tehtäviä',
            create_error: 'Tehtävän luominen epäonnistui',
            plan_sprint: 'Suunnittele Sprint',
            priority_critical_desc: 'Estävä — korjaa heti',
            priority_high_desc: 'Tärkeä — käsittele tässä sprintissä',
            priority_medium_desc: 'Normaali — suunnittele tulevaan sprinttiin',
            priority_low_desc: 'Mukava — backlog-ehdokas',
            add_custom: 'Lisää tehtävä',
            add_title_placeholder: 'Tehtävän otsikko…',
            add_desc_placeholder: 'Kuvaus (valinnainen)',
            add_save: 'Lisää',
            add_cancel: 'Peruuta',
        },
        sprint: {
            title: 'Sprintin suunnittelija',
            assigned: 'assigned',
            new_placeholder: 'Sprintin nimi (esim. Sprint 18.1.0)',
            add: 'Add',
            backlog: 'Ruuhka',
            move_to: 'Siirrä kohteeseen…',
            empty: 'Luo sprinttiryhmä ja määritä sille tehtäviä.',
            create_all: 'Luo kaikki tehtävät',
            remove: 'Poista',
            drop_here: 'Anna tehtäviä alla olevasta ruuhkasta',
            add_task: 'Lisää tehtävä ruuhkasta…',
        },
        feature_disabled: 'UI Assist ei ole käytössä',
        permission_denied: 'Sinulla ei ole lupaa käyttää UI Assist -sovellusta',
    },
    license: {
        title: 'Lisenssi & Paketti',
        current_license: 'Nykyinen lisenssi',
        license_key: 'Lisenssiavain',
        activate: 'Aktivoi Lisenssi',
        deactivate: 'Poista lisenssi käytöstä',
        validate_now: 'Vahvista nyt',
        status: 'Lisenssin tila',
        active: 'Aktiivinen',
        expired: 'Vanhentunut',
        suspended: 'Keskeytetty',
        invalid: 'Virheellinen',
        pending: 'Odottaa',
        no_license: 'Ei lisenssiä',
        expires_at: 'Vanhenee',
        last_validated: 'Viimeksi vahvistettu',
        domain: 'Lisensoitu verkkotunnus',
        activation_success: 'Lisenssi aktivoitu onnistuneesti.',
        activation_failed: 'Lisenssin aktivointi epäonnistui.',
        domain_mismatch: 'Lisenssiverkkotunnus ei vastaa nykyistä verkkotunnusta.',
        deactivation_success: 'Lisenssi deaktivoitu.',
        validation_success: 'Lisenssi validoitu onnistuneesti.',
        validation_failed: 'Lisenssin vahvistus epäonnistui.',
        enter_key: 'Anna lisenssiavaimesi',
        confirm_deactivate: 'Haluatko varmasti poistaa tämän lisenssin käytöstä? Moduulirajoituksia sovelletaan oletustason mukaan.',
    },
    package_mgmt: {
        title: 'Paketti',
        module_column: 'Moduuli',
        current_tier: 'Nykyinen paketti',
        light: 'Kevyt',
        standard: 'Standardi',
        enterprise_unlimited: 'Enterprise Unlimited',
        change_package: 'Vaihda paketti',
        upgrade: 'Päivitä',
        downgrade: 'Vähennä',
        target_tier: 'Kohdepaketti',
        new_license_key: 'Kohdepaketin lisenssiavain',
        confirm_change: 'Vahvista paketin muutos',
        change_success: 'Paketti vaihdettu onnistuneesti.',
        change_failed: 'Paketin vaihto epäonnistui.',
        modules_included: 'Mukana moduulit',
        modules_restricted: 'Ei saatavilla nykyisessä paketissa',
        upgrade_to_enable: 'Päivitä ottaaksesi tämän moduulin käyttöön.',
        module_availability: 'Moduulien saatavuus',
        comparison: 'Pakettien vertailu',
        power_users: 'Tehokäyttäjät',
        unlimited: 'Rajoittamaton',
        impact_warning: 'Vanhempaan versioon poistaminen poistaa käytöstä seuraavat moduulit:',
        invalid_license: 'Annettu lisenssiavain ei kelpaa tälle paketille.',
        tier_mismatch: 'Lisenssiavain on eri pakettitasolle.',
    },
    board_report: {
        title: 'Hallituksen vaatimustenmukaisuusraportti',
        subtitle: 'Yhteenveto vaatimustenmukaisuudesta kaikissa moduuleissa',
        date_from: 'Alkaen',
        date_to: 'Päättyen',
        language: 'Raportin kieli',
        generate: 'Luo raportti',
        generating: 'Luodaan raporttia...',
        download_pdf: 'Lataa PDF',
        close: 'Sulje raportti',
        open_board_report: 'Luo hallitusraportti',
        close_board_report: 'Sulje hallitusraportti',
        report_period: 'Raporttikausi',
        generated_at: 'Luotu',
        generated_by: 'Luonut',
        organization: 'Organisaatio',
        section_rights_requests: 'Oikeuspyynnöt',
        section_vendors: 'Toimittajat',
        section_dpias: 'DPIA:t',
        section_consent: 'Suostumuskäytännöt',
        section_data_mapping: 'Tietokartoitus',
        section_incidents: 'Tapahtumat',
        section_classification: 'Tietojen luokittelu',
        section_governance: 'Hallinto',
        open: 'Avoin',
        closed: 'Suljettu',
        sla_compliance: 'SLA-vaatimustenmukaisuus',
        total: 'Yhteensä',
        expired_dpa: 'Vanhentunut DPA',
        high_risk: 'Korkea riski',
        completed: 'Valmis',
        overdue: 'Myöhässä',
        policies_active: 'Aktiiviset käytännöt',
        coverage: 'Kattavuus',
        systems: 'Järjestelmät',
        completeness: 'Täydellisyys',
        avg_resolution_days: 'Keskim. ratkaisuaika (päivää)',
        labeled: 'Merkitty',
        unlabeled_systems: 'Merkitsemättömät järjestelmät',
        compliance_score: 'Vaatimustenmukaisuuspisteet',
        drift_events_open: 'Avoimet poikkeamat',
        no_data: 'Ei tietoja valitulle ajanjaksolle.',
        error_date_range: 'Valitse sekä alku- että loppupäivä.',
        table_category: 'Kategoria',
        table_metric: 'Mittari',
        table_value: 'Arvo',
        showing_chart_view: 'Näytetään kaavionäkymä',
        showing_table_view: 'Näytetään taulukonäkymä',
        error_generate: 'Hallitusraportin luominen epäonnistui.',
        playbook_evidence_title: 'Playbook-suoritusten todistusaineisto',
        playbook_evidence_description: 'Playbook-kohtainen suoritusaktiivisuus ja liitetyt todistustiedostot raportointijaksolta.',
        playbook_name: 'Pelikirja',
        playbook_execution_count: 'Suoritukset',
        playbook_steps_total: 'Vaiheet',
        playbook_steps_required: 'Todistusaineistoa vaaditaan',
        playbook_steps_attached: 'Todistusaineisto liitetty',
        playbook_coverage_pct: 'Kattavuus',
        playbook_evidence_files: 'Todistustiedostot',
        playbook_no_evidence: 'Tältä ajanjaksolta ei ole playbook-suorituksia.',
        playbook_download_file: 'Lataa tiedosto',
    },
    framework_module_links: {
        title: 'Kehyslinkitys',
        modules: 'Linkitetyt moduulit',
        add_module: 'Lisää moduuli',
        module_code: 'Moduulikoodi',
        required: 'Pakollinen',
        notes: 'Muistiinpanot',
        link: 'Linkki',
        no_modules: 'Ei linkitettyjä moduuleja',
        personas: 'Linkitetyt henkilöt',
        add_persona: 'Lisää henkilö',
        persona_id: 'Henkilötunnus',
        role_description: 'Roolin kuvaus',
        no_personas: 'Ei linkitettyjä henkilöitä',
    },
    framework_channels: {
        title: 'Lähetyskanavat & Määräajat',
        channels: 'Lähetyskanavat',
        add_channel: 'Lisää kanava',
        channel_type: 'Tyyppi',
        name: 'Nimi',
        instructions: 'Ohjeet',
        active: 'Aktiivinen',
        no_channels: 'Ei lähetyskanavia määritelty',
        portal: 'Portaali',
        in_person: 'Henkilökohtaisesti',
        postal: 'Posti',
        email: 'Sähköposti',
        add: 'Lisää',
        deadlines: 'Sääntelymääräajat',
        add_deadline: 'Lisää määräaika',
        label: 'Tunniste',
        days: 'Päivät',
        day_type: 'Päivätyyppi',
        calendar_days: 'Kalenteripäivät',
        working_days: 'Työpäivät',
        description: 'Kuvaus',
        no_deadlines: 'Ei määräaikoja määritelty',
    },
    regulatory_updates: {
        title: 'Sääntelypäivitykset & Kehysdashboard',
        coverage_dashboard: 'Kehyksen kattavuusdashboard',
        no_frameworks: 'Kehyksiä ei löydy',
        framework: 'Kehys',
        status: 'Tila',
        modules: 'Moduulit',
        templates: 'Mallipohjat',
        forms: 'Lomakkeet',
        channels: 'Kanavat',
        deadlines: 'Määräajat',
        pending: 'Odottavat päivitykset',
        updates: 'Sääntelypäivitykset',
        create_update: 'Luo päivitys',
        framework_id: 'Kehystunnus',
        update_title: 'Otsikko',
        description: 'Kuvaus',
        effective_date: 'Voimaantulopäivä',
        create: 'Luo',
        no_updates: 'Ei sääntelypäivityksiä',
        impact: 'Vaikutus',
        assess: 'Arvioi',
    },
    module_tips: {
        show_guide: 'Näytä opas',
        hide_guide: 'Piilota opas',
        title: 'Moduulin opas',
        title_prefix: 'Moduulivinkki:',
        loading_aria: 'Ladataan moduulivinkkiä',
        related_frameworks: 'Liittyvät viitekehykset',
        quick_start_label: 'Pikastartti',
        related_forms_note: 'Liittyvät vaatimustenmukaisuuslomakkeet ovat saatavilla alla — etsi Mẫu số-tunnistetta virallisten vietnamilaisten sääntelylomakkeiden tunnistamiseksi.',
        read_full_guide: 'Lue koko opas',
        view_full_requirements: 'Näytä kaikki vaatimukset',
        relevant_for: 'Sopiva',
        key_procedure: 'Avainmenettely',
        deletion_orchestration: 'Tietojen poistopyyntöjen koordinointi järjestelmien ja toimittajien välillä varmennustyönkuluilla ja tarkastusjäljillä.',
        rights_requests: 'Hallitse rekisteröityjen oikeuspyyntöjä mukaan lukien pääsy, poisto, oikaisu ja siirrettävyys. Vaaditaan PDPL-lain 91/2025 ja GDPR:n nojalla.',
        consent: 'Hallitse suostumuskäytäntöjä ja työnkulkuja. Vaaditaan PDPL:n, verkkokauppalain ja GDPR:n noudattamiseksi.',
        consent_properties: 'Määritä suostumuskeruupisteet ja CMP-integraation ominaisuudet verkko- ja sovellussuostumuksen seurantaan.',
        data_mapping: 'Kartoita tietovirrat organisaatiossasi — käsittelytoimet, järjestelmät ja rajat ylittävät siirrot.',
        data_mapping_registry: 'Maintain a per-field inventory of every personal-data element your organization holds. Liitä jokainen elementti tietoluokkaan, ohita herkkyys tai säilytys tarvittaessa ja tuo viranomaisrekistereistä ([[TOK_0]] henkilötietojen luettelo) menettämättä operaattorin muokkauksia.',
        data_mapping_ropa_completeness: 'Per-field hygiene audit of every Processing Activity against the framework’s required ROPA fields ([[TOK_1]], [[TOK_0]], Decree 165). Identify critical / high / conditional misses before regulatory submission and jump straight into the activity editor to fix each one.',
        assessments: 'Luo ja hallitse tietosuojan vaikutustenarviointeja (DPIA) ja tekoälyjärjestelmien riskiarviointeja. Vaaditaan PDPL-lain 91/2025 artiklan 24 nojalla.',
        classification: 'Luokittele ja merkitse tietovarat herkkyyden, kategorian ja sääntelyvaatimusten mukaan.',
        incidents: 'Kirjaa ja hallitse tietoturvatapahtumia ja tietomurtoja. Vaaditaan tietomurtoilmoituksiin PDPL:n ja kyberturvallisuuslain nojalla.',
        incident_ops: 'Koordinoi häiriönhallintatoimintoja playbook-aktivoinneilla, eskalointipoluilla ja reaaliaikaisilla koordinointinäkymillä.',
        monitoring: 'Seuraa vaatimustenmukaisuuden KPI-mittareita, ohjelman tilaa ja tehtävien valmistumisasteita koko organisaatiossa.',
        vendor_risk: 'Arvioi ja hallitse toimittajariskejä kyselylomakkeilla, riskisalkuilla ja vaatimustenmukaisuuspisteillä.',
        governance: 'Hallitse toimittajahallintoa, playbookeja ja kolmannen osapuolen vaatimustenmukaisuusvaatimuksia.',
        program_governance: 'Määritä ohjelmahallinnan kypsyysarvioinnit, koontinäyttömittarit ja vaatimustenmukaisuuden pisteytyskehykset.',
        discovery: 'Löydä ja inventoi tietovarat organisaatiossasi automatisoidulla skannauksella ja luokitteluprosesseilla.',
        discovery_cycles: 'Aikatauluta ja suorita toistuvia löytösyklejä, jotka skannaavat järjestelmät uudelleen, paljastavat delta-muutokset ja ohjaavat löydökset tarkistuksen, hyväksynnän ja julkaisun läpi.',
        connectors: 'Määritä integraatiot ja tietokonnektorit automaattiseen vaatimustenmukaisuustietojen keruuseen.',
        task_management: 'Hallitse vaatimustenmukaisuustehtäviä, tehtäväksiantoja ja määräaikoja tiimien ja moduulien välillä.',
        audit_trail: 'Tarkastele ja etsi yhdistettyä tarkastusjälkeä kaikille vaatimustenmukaisuustoimille ja todisteiden keruulle.',
        evidence_packs: 'Assemble, verify, and submit audit evidence packs for regulatory compliance. Todistuspakkaukset keräävät tarkastustapahtumat viitekehyksen, kokonaisuuden tyypin ja ajanjakson mukaan vientikelpoisiin nippuihin sisäistä tarkastusta tai viranomaistoimia varten.',
        audit_periods: 'Määritä ja hallitse tarkastusraportointijaksot sääntelykehyksen mukaisesti. Tarkastusjaksot asettavat aikarajat ja säilytyskäytännöt todisteiden keräämiselle ja vaatimustenmukaisuuden raportointijaksoille.',
        qs_evidence_pack: 'Kokoa ensimmäinen todistepakettisi',
        qs_audit_period: 'Luo tarkastusraportointijakso',
        compliance_forms: 'Selaa vaatimustenmukaisuuslomakeluetteloa ja luo lomakeinstansseja sääntelyilmoituksiin.',
        partner_workspace: 'Kumppani- ja jälleenmyyjätyötilojen hallinta rajoitetuilla käyttöoikeuksilla, vaatimustenmukaisuustarkistustyönkuluilla ja yhteistyötyökaluilla.',
        localization: 'Hallitse sääntelykehyksiä, kielipaketteja ja lokalisointiasetuksia.',
        onboarding: 'Seuraa perehdytyksen etenemistä, suorita pikastartit ja seuraa personapohjaisia vaatimustenmukaisuuspolkuja.',
        organizations: 'Hallitse organisaatiorakennetta, osastoja ja moniorganisaatiomäärityksiä.',
        privacy_scanner: 'Seuraa verkkosivuston tietosuojavaatimustenmukaisuutta automatisoidulla skannauksella ja ongelmien havaitsemisella.',
        access_accountability: 'Määritä pääsykatselkampanjat ja vastuullisuuspolitiikat tietojen pääsynhallintaan.',
        dashboard: 'Tarkastele vaatimustenmukaisuuden hallintapaneelin yleiskatsausta, jossa on reaaliaikaiset tilayhteenvedot, kehyksen kattavuus ja tärkeimmät vaatimustenmukaisuusmittarit.',
        platform: 'Hallinnoi alustan suojausasetuksia, mukaan lukien [[TOK_0]]-avaimet, lasin rikkoutumisen hätäkäyttö ja SSO-määritykset.',
        framework_vn_pdpl: 'VN Henkilötietojen suojalaki (PDPL)',
        framework_vn_cybersecurity: 'VN Kyberturvallisuuslaki',
        framework_vn_ecommerce: 'VN Verkkokauppalaki',
        framework_vn_ai_law: 'VN Tekoälylaki',
        framework_vn_telecom: 'VN Tietoliikennelainsäädäntö',
        framework_vn_banking_circular_83: 'VN Banking Circular [[TOK_0]] — Sisäinen valvontajärjestelmä',
        framework_gdpr: 'EU GDPR',
        cross_framework: 'Viitekehysrajat ylittävä — tukee kaikkia sääntelynmukaisuustoimia',
        qs_dpia_filing: 'Suorita ensimmäinen DPIA-ilmoitus',
        qs_dept_compliance: 'Lähetä ensimmäinen osastovaatimustenmukaisuusosio',
        qs_ecommerce_consent: 'Määritä verkkokaupan suostumuskeruu',
        qs_telecom_data: 'Määritä tietoliikenteen tilaajaatietojen käsittely',
        qs_data_flow: 'Kartoita ensimmäinen tietovirtasi',
        qs_incident_response: 'Määritä häiriönhallinnan työnkulku',
        qs_ai_risk: 'Suorita tekoälyjärjestelmän riskinarviointi',
        qs_cross_border: 'Arvioi rajat ylittävä tiedonsiirto',
        qs_breach_notification: 'Simuloi tietomurtoilmoitusprosessi',
        qs_audit_trail: 'Tarkasta vaatimustenmukaisuuden tarkastusjälki',
        procedure_data_deletion_fulfillment: 'Tietojen poistamisen toteuttaminen',
        procedure_cross_system_deletion: 'Järjestelmien välinen poistaminen',
        procedure_dsar_intake: 'Rekisteröidyn oikeuspyynnön vastaanotto',
        procedure_cmp_property_config: 'CMP-ominaisuuksien määritys',
        procedure_consent_collection: 'Suostumuksen keräyspolitiikka',
        procedure_ropa_filing: 'Käsittelytoimien selosteen täyttö',
        procedure_cross_border_assessment: 'Rajat ylittävän tiedonsiirron arviointi',
        procedure_data_classification: 'Tietojen luokittelu',
        procedure_breach_notification: 'Tietoturvaloukkausilmoitus',
        procedure_incident_timeline: 'Tapahtumaaikajanaseuranta',
        procedure_playbook_escalation: 'Toimintaohjeen eskalointi',
        procedure_compliance_kpi_monitoring: 'Vaatimustenmukaisuus-KPI-seuranta',
        procedure_vendor_risk_assessment: 'Toimittajariskien arviointi',
        procedure_transfer_mechanism_review: 'Siirtomekanismin tarkistus',
        procedure_program_maturity: 'Ohjelman kypsyysarviointi',
        procedure_data_discovery: 'Tietovarantojen löytäminen',
        procedure_connector_setup: 'Liittimien asennus ja määritys',
        procedure_task_assignment: 'Tehtävien osoittaminen ja delegointi',
        procedure_audit_evidence: 'Tarkastusnäytön kerääminen',
        procedure_form_submission: 'Vaatimustenmukaisuuslomakkeen lähetys',
        procedure_partner_onboarding: 'Kumppanin käyttöönottotyönkulku',
        procedure_partner_access: 'Kumppanin pääsy ja käyttöoikeudet',
        procedure_framework_pack_install: 'Viitekehyspaketin asennus',
        procedure_language_pack_deploy: 'Kielipaketin käyttöönotto',
        procedure_org_onboarding: 'Organisaation käyttöönoton määritys',
        procedure_multi_org_config: 'Moniorganisaatiomääritys',
        procedure_privacy_scan: 'Tietosuojan vaatimustenmukaisuusskannaus',
        procedure_access_review: 'Pääsyntarkistuskampanja',
        procedure_dpia_filing: 'DPIA-hakemusprosessi',
        security: 'Alustan suojausmääritykset: [[TOK_0]] avainten hallinta, istuntokäytännöt, MFA-valvonta, SSO-integrointi, IP-sallitut luettelot ja rikkoutuvan lasin hätäkäytön hallinta.',
        settings: 'Koko alustan kattava määritys: ilmoitusasetukset, verkkotunnuksen hallinta, vientiaikataulut ja organisaatiosi moduulimääritykset.',
        users: 'Käyttäjätilien hallinta: luo ja hallitse käyttäjätilejä, määritä rooleja, määritä osastojäsenyys ja seuraa kirjautumistoimintaa.',
        roles: 'Rooli- ja käyttöoikeuksien hallinta: määritä mukautettuja rooleja, määritä moduulikohtaiset käyttöoikeudet ja pakota tehtävien erottelukäytäntöjä.',
        profile: 'Henkilökohtaisen profiilisi asetukset: näyttönimi, yhteystiedot, kieliasetukset, moduulioppaan asetukset, esteettömyysasetukset ja salasanan hallinta.',
        consent_properties_bindings: 'Hallinnoi digitaalisten omaisuuksien suostumuskäytäntöjen sidoksia. Seuraa, mikä käytäntöversio on otettu käyttöön kussakin omaisuudessa, tunnista vanhentuneet sidokset ja koordinoi käytäntöjen käyttöönottoa.',
        consent_properties_templates: 'Kultaisen mallin hallinta: määritä normaalit suostumusmääritykset, vertaa ominaisuuksia malleihin ja ota mallien muutokset käyttöön eri kiinteistöryhmissä.',
        consent_properties_compliance: 'Suostumuksen noudattamisen valvonta: havaitse ominaisuuksien ja kultaisten mallien väliset kokoonpanon epäjohdonmukaisuudet, hallitse muutospyyntöjä hyväksyntätyönkulkujen kautta ja luo todisteita tarkastusvalmiutta varten.',
        consent_properties_operations: 'Suostumusomaisuuksien toiminnan hallinta: määritä automaattiset tilannevedosaikataulut, järjestä omaisuudet ryhmiin ja tarkista suostumusomaisuuden kirjausketju.',
        consent_properties_audit: 'Hyväksy kiinteistöjen auditointi ja analytiikka: tarkastele konfiguraatiomuutoshistoriaa, analysoi kiinteistöjen vaatimustenmukaisuustrendejä ja luo vaatimustenmukaisuusraportteja säännöstenmukaista tarkastusta varten.',
        classification_taxonomies: 'Määritä ja hallitse datan luokittelutaksonomioita herkkyys- ja tärkeysulottuvuuksilla. Määritä luokitustasot, käsittelyvaatimukset ja [[TOK_0]] riskitasot.',
        classification_labeling: 'Käytä luokitustunnisteita tietoresursseihin. Lähetä tunnisteet tarkistettavaksi, hallitse joukkoluokitusta ja seuraa tunnisteiden tilaa koko tietovarastossasi.',
        classification_lifecycle: 'Seuraa luokiteltujen tietoresurssien elinkaarta eri vaiheissa: luonnos, aktiivinen käyttö, tarkistus käynnissä, arkistointi ja odottava poistaminen. Valvo säilytysaikoja ja käynnistä poistotyönkulkuja.',
        classification_gaps: 'Tunnista ja hallitse luokitusaukot koko tietovarastossasi. Suorita aukkojen tunnistus tunnistaaksesi merkitsemättömät omaisuudet ja puuttuvat elinkaarimääritykset ja seuraa sitten korjauksia.',
        classification_reviews: 'Hallitse luokituksen tarkistustehtäviä eskalointiajastinten avulla. Tarkista ehdotetut etiketit, käsittele poikkeukset ja varmista oikea-aikaiset luokituspäätökset.',
        incidents_breach: 'Hallitse tietomurtoilmoituksia ja viranomaisraportteja. Luo ilmoituspaketteja, seuraa säännösten mukaisia ​​määräaikoja ja dokumentoi täydellinen rikkomusvastausaikajana.',
        incidents_authority: 'Käsittele sääntelyelinten muodollisia pyyntöjä. Seuraa saapuvia tiedusteluja, kokoa todistepaketteja, hallitse tarkistuslistoja ja noudata vastausten määräaikoja.',
        incidents_disclosure: 'Ylläpidä keskitettyä tiedonantorekisteriä kaikesta yhteydenpidosta valvontaviranomaisten kanssa. Kirjaa ilmoituspäivämäärät, kanavat, vastaanottajat ja sisältötiivistelmät kirjausketjun noudattamista varten.',
        incidents_reports: 'Luo ja hallitse tapahtumaraportteja sisäistä tarkastusta ja viranomaistoimia varten. Luo yksityiskohtaisia ​​tapausyhteenvetoja, seuraa raportin tilaa ja vie asiakirjoja viranomaisilmoituksia varten.',
        incidents_tasks: 'Koordinoi tapahtumien reagointitehtäviä ryhmien välillä. Luo tehtävien tarkistuslistoja, määritä omistajia, seuraa prioriteetteja ja riippuvuuksia, eskaloi eskaloituja kohteita ja seuraa valmistumisen edistymistä.',
        incidents_supplements: 'Hallinnoi lisäasiakirjoja, joita sääntelyviranomaiset ovat pyytäneet ensimmäisen rikkomusilmoituksen jälkeen. Seuraa täydennyspyyntöjä, valmistele vastauspaketteja ja seuraa lähetysten määräaikoja.',
        incidents_remediation: 'Seuraa osastoille ja käyttäjille määrättyjä korjaavia toimenpiteitä tapahtumien perimmäisen syyn ja vaikutuksen korjaamiseksi. Valvo täytäntöönpanon määräaikoja, tarkista valmistuminen ja dokumentoi korjaustodisteet.',
        incident_ops_playbooks: 'Luo ja hallitse tapausvastausten pelikirjoja. Määritä eskalaatiopolut, määritä vastaustiimejä ja aktivoi pelikirjoja live-tapahtumien aikana.',
        incident_ops_sla: 'Seuraa häiriötilanteiden SLA-sopimuksia ja määräaikoja. Valvo lakisääteisten ilmoitusaikataulujen noudattamista ja mittaa vastausten suorituskykymittareita.',
        incident_ops_evidence: 'Ylläpidä tapausten todisteketjuja ja suorita tapahtumien jälkeisiä tarkastuksia. Luo viranomaisvalmiita vientipaketteja, joissa on täydellinen tapahtumadokumentaatio.',
        data_mapping_systems: 'Rekisteröi ja hallinnoi henkilötietoja käsitteleviä järjestelmiä. Asiakirjajärjestelmän omistajuus, tietoluokat, käsittelytarkoitukset ja vaatimustenmukaisuuspisteet.',
        data_mapping_flows: 'Kartoittaa järjestelmien väliset tietovirrat, mukaan lukien rajat ylittävät siirrot. Dokumentoi tietojen siirtoreitit, siirtomekanismit ja vastaanottajan lainkäyttöalueet.',
        data_mapping_activities: 'Asiakirjojen käsittelytoiminnot ja käsittelytoimintojen tietueiden luominen (RoPA). Yhdistä toiminnot oikeusperustoihin, tarkoituksiin ja tietoluokkiin.',
        data_mapping_governance: 'Hallitse tiedonhallintatehtäviä, todistusjaksoja ja riskinarviointeja. Seuraa hallinnoinnin omistajuutta ja tarkista aikataulut koko tietovarastossasi.',
        data_mapping_reference: 'Hallinnoi datakartoituksen viitetietoja: tietoluokat, käsittelytarkoitukset, säilytyskäytännöt ja vientimääritykset.',
        data_mapping_categories: 'Hallitse tietoluokkaluetteloa: nimiä, herkkyystasoja, esimerkkejä ja tunnisteita. Perusteet jokaiselle luokittelu- ja kartoitustoiminnalle.',
        data_mapping_purposes: 'Luettelon käsittelytarkoituksiin niiden laillinen perusta. Käyttää ROPA:ta, [[TOK_0]]:ta ja laillisuustarkastuksia.',
        data_mapping_retention: 'Määritä säilytyskäytännöt, hävitystavat ja tarkistamisnopeus. On yhdenmukainen asetuksen 13/2023 ja asetuksen 356/2025 vaatimusten kanssa.',
        data_mapping_exports: 'Vie ROPA, järjestelmät, tarkoitukset ja luokat kohteisiin [[TOK_0]], [[TOK_3]], [[TOK_2]] tai [[TOK_1]]. Kaikki viennit saapuvat alustan tiedostoselaimeen.',
        data_mapping_attestation: 'Suunnittele ja seuraa tietojen todennusjaksoja. Seuraa todistuksen valmistumista koko tietovarastossasi.',
        data_mapping_review: 'Luokituksen tarkistusjono: tarkastelutehtävät, laatusignaalit ja hyväksyntätila.',
        data_mapping_risk: 'Käsittelytoimintojen riskinarviointi: pisteytyskehykset, lieventämissuunnitelmat ja tehokkuuden seuranta.',
        data_mapping_evidence: 'Käsittelytoimintoihin liittyvät todisteet: turvatodistukset, DPA-sopimukset, [[TOK_0]]-raportit.',
        data_mapping_inventory: 'Luokitteluvaraston yleiskatsaus: tunnisteet, herkkyystasot ja organisaation laajuinen jakelu.',
        data_mapping_exceptions: 'Luokittelujen poikkeusrekisteri: perustelut, hyväksyjä, kelpoisuusikkuna ja korjauspolku.',
        data_mapping_history: 'Luokituksen muutoshistoria: kuka muutti mitä, milloin ja miksi.',
        access_accountability_logs: 'Reaaliaikainen virta etuoikeutetuista tapahtumista. Yhdistä käytäntösivun kanssa määrittääksesi, kuka voi saavuttaa kunkin tietovyöhykkeen. Yhdistä tutkimuksiin poikkeavuuksien seuraamiseksi.',
        access_accountability_policies: 'Käyttöoikeusvyöhykkeen käytäntöjen luonti: määritä, mitkä roolit ja käyttäjät voivat saavuttaa kunkin tietovyöhykkeen aikarajaisin poikkeuksin. Ajaa valvontaa tarkistaa, että pinta lokeissa.',
        access_accountability_anchoring: 'Käyttölokin peukaloitu ankkurointi hash-ketjuun. Vaaditaan VN:n kyberturvallisuuslain kirjausketjun eheydelle.',
        access_accountability_investigations: 'Case-työtila epäilyttävien käyttötapahtumien tutkimiseen. Aikajana, linkitetyt lokit, todistepaketit ja tapauksen sulkemisen työnkulku yhdessä näkymässä.',
        assessment_triggers: 'Säännöt, jotka avaavat automaattisesti [[TOK_0]]- tai aineiston arkistoinnin, kun alkuvaiheessa tapahtuu muutoksia (uusi käsittelytoiminto, uusi toimittaja, uusi rajat ylittävä kulku), täyttävät käynnistysehdon.',
        connectors_gap_register: 'Toteuttamattomien tai osittaisten liittimien luettelo. Luokittele kohteet, määritä omistajat, seuraa aukkojen kaventamista tiekartan yli.',
        connectors_system_inventory: 'Jokaisen liittimen kautta tavoitettavissa olevan järjestelmän luettelo. Yksittäinen totuuden lähde tietokartalle.',
        connectors_traceability: 'Tietoelementin päästä päähän -linja järjestelmien välillä, jotka on linkitetty liittimien kautta. Olennainen ROPA-tarkkuuden ja aihepyyntöjen täyttämisen kannalta.',
        consent_properties_change_requests: 'Suostumusomaisuuteen ehdotetut muutokset (lisätty tarkoitus, uusi kieli, päivitetty käytäntölinkki). Hallinto-arviointi ennen tuotannon käyttöönottoa.',
        consent_properties_comparison: 'Suostumusomaisuuden muodon rinnakkainen vertailu verkkotunnusten tai käyttöönottojen välillä. Liput ajautuvat, mikä heikentäisi täytäntöönpanokelpoisuutta.',
        governance_playbooks: 'Ohjekirjamallit, jotka ohjaavat toistettavia hallintotyönkulkuja (toimittajan käyttöönotto, DPA-tarkistus, siirron arviointi).',
        incident_ops_coordination: 'Tiimien välinen koordinointikojelauta aktiiviselle tapahtumalle. Yksi paikka, josta näet, kuka on siinä, mitä he tekevät ja mikä on estetty.',
        incident_ops_escalation: 'Eskalaatioloki aktiivisille tapahtumille. Vakavuusasteen siirtymät, sidosryhmien ilmoitukset ja johdon tiedotteet tallennetaan tähän.',
        incident_ops_post_review: 'Tapahtuman jälkeinen tarkastelu: perussyyanalyysi, aikajana, korjaustoimenpiteet ja opit. Syöttyy harjoituksiin ja pelikirjan päivityksiin.',
        incident_ops_regulator_exports: 'Luo viranomaisten toimituspaketteja ilmoitettaville tapauksille. Mẫu số 08 (rikkomus) + todistusaineisto.',
        incident_ops_vendor_coordination: 'Koordinoi vastaus sen toimittajan kanssa, jonka järjestelmä on rikottu. Sopimusvelvoitteet, vastaustasosopimukset ja jaettu todisteketju.',
        monitoring_authority_readiness: 'Valmiuden tarkistuslista ja todistepaketti tulevia sääntelyviranomaisten käyntejä varten. Yhdistetty näkymä jäljellä olevista aukoista ja valmiista ohjaimista.',
        monitoring_change_review: 'Ohjausmuutosten säännöllinen tarkastelu valvontaohjelmassa. Havaitsee ajautumisen ennen kuin siitä tulee vaatimustenmukaisuusvaje.',
        monitoring_framework_link: 'Linkitä valvontasäädöt tiettyihin sääntelykehyksen artikloihin. Luo sääntelijöiden odottaman näyttökartan.',
        monitoring_ric: 'Viranomaiskysely- ja kirjeenvaihtotapaukset. Seuraa sääntelyviranomaisen kysymyksiä ja vastauksia ajan mittaan.',
        forms: 'Sääntelylomakeluettelo, lomakkeen täyttö, lomakkeiden esiintymät ja arkistointitapausten linkit. Mẫu số 02a/02b:n ja siihen liittyvien lähetysten runko.',
        monitoring_tasks: 'Valvontatehtäväjono: ajoitetut ohjaustarkastukset, todistukset ja todisteet päivittyvät.',
        partner_workspace_reports: 'Kumppaniverkostossa jaetut raportit: vaatimustenmukaisuus, kuukausittaiset yhteenvedot, organisaatioiden väliset tiedot.',
        partner_workspace_tickets: 'Tue kumppanien kesken kerättyjä lippuja jaetuissa työnkuluissa ja eskalaatioissa.',
        program_governance_audit_readiness: 'Tarkastusvalmiuden pisteytys puuttuvien todisteiden, puutteiden rekisterin ja korjaustoimien omistajien tarkastelulla.',
        program_governance_drafting: 'Asiakirjan luonnostyötila, jossa on versiointi, tarkistusreititys ja hyväksyntätyönkulku.',
        program_governance_evidence_gaps: 'Evidence-gap -rekisteri: mistä ohjauksista puuttuu ajantasainen näyttö ja milloin päivitys on suoritettava.',
        program_governance_executive_summaries: 'Johdon yhteenvetomallit, joissa on automaattisesti täytetyt KPI:t hallituksen ja johtajien tiedotustilaisuuksia varten.',
        program_governance_health: 'Ohjelman yleinen kuntomittari: maturiteetti-, kattavuus- ja trendi-indikaattorit.',
        program_governance_issuance: 'Asiakirjojen myöntämisen työnkulku: hyväksyminen, julkaiseminen, sidosryhmien ilmoitus.',
        program_governance_model: 'Hallintotoimintamalli: roolit, vastuut, komiteat ja päätösoikeudet.',
        program_governance_remediation: 'Korjaussuunnitelmat sidottu havaittuihin puutteisiin. Omistaja, määräaika, tila ja vahvistustodistus.',
        program_governance_review_cadence: 'Hallintoartefaktien ajoitettu tarkistus: käytännöt, menettelyt, kontrollit, todisteet.',
        program_governance_trends: 'Trendimittaristo: kypsyys ajan myötä, todisteiden tuoreus, aukon sulkemisnopeus.',
        task_management_conflicts: 'Tunnista ristiriitaiset tehtävämääräykset (kaksinkertaiset omistajat, päällekkäiset määräajat) ja ratkaise ne uudelleenjakamalla.',
        task_management_consolidation: 'Yhdistä useiden moduulien automaattisesti luomat tehtävät yhdeksi toimeksisaajan työnkulkuun.',
        localization_dashboard: 'Lokalisointimoduulin yleiskatsaus: kehysluettelon kunto, paketin tila, käännösten kattavuus ja vireillä olevat säädöspäivitykset yhdessä kojelaudassa.',
        localization_frameworks: 'Sääntelykehysluettelo: [[TOK_1]], asetus 13/2023, asetus 356/2025, kyberturvallisuuslaki ja [[TOK_0]]. Jokainen kehys linkittää artikkelit alustan ohjaimiin.',
        localization_framework_channels: 'Kuhunkin viitekehykseen linkitetyt sääntelyviranomaisten lähetyskanavat ([[TOK_1]]-portaali, [[TOK_0]]-päätepiste, viranomaisen sähköposti). Ohjaa Mẫu số -tiedostojen reititystä.',
        localization_framework_detail: 'Yhden kehyksen yksityiskohtainen näkymä: artikkelit, menettelyt, persoonat, linkitetyt lomakkeet ja toteutuksen syvyys koko alustalla.',
        localization_framework_module_links: 'Framework → moduulin kattavuuskartta. Mitä säädösartikkeleita mikä alustamoduuli valvoo.',
        localization_language_packs: 'Kielipakettien luettelo 16 kielellä: asennuksen tila, käännösten valmius ja paketin lähetyshistoria.',
        localization_audit: 'Lokalisointimuutosten seurantaketju: kehysmuokkaukset, pakkauspäivitykset, lähetystapahtumat.',
        localization_market_packs: 'Markkinapakettien luettelon niputuskehys + kieli + lomakkeet markkinakohtaisesti (VN, EU-maat jne.).',
        localization_module_mappings: 'Moduulikartoitusrekisteri: mikä kehysartikkeli koskee mitäkin moduulia ominaisuustasolla.',
        localization_pack_detail: 'Yksittäisen paketin yksityiskohtainen näkymä: versio, mukana olevat puitteet, käännöstila, asennushistoria.',
        localization_pack_submissions: 'Pakkauksen toimitusputki: kumppanien lähetykset, tarkistustilat, julkaisujen hyväksynnät.',
        localization_regulatory_updates: 'Säännösten päivityssyöte: puiteluetteloon vaikuttavat uudet asetukset, muutokset ja ohjeet.',
        localization_sector_overlays: 'Alakohtainen peittokuvaluettelo: valinnaiset toimialakohtaiset säädöspaketit (esim. pankkitoiminta, terveydenhuolto). Asenna suorassa tilassa toimialaan kuuluville organisaatioille tai viitetilassa eri alojen näkyvyyttä varten.',
        localization_help_content_packs: 'Help-Content Pack Manager: asenna, versio ja käännä järjestelmänvalvojan käyttöliittymässä näkyvät sovelluksen sisäiset ohjeartikkelit, moduulioppaat ja pika-aloitusohjeet.',
        localization_translation_preview: 'Käyttöliittymämerkkijonojen live esikatselu eri kielillä. Käännösten laadunvarmistuksen rinnakkainen vertailu.',
        organizations_groups_create: 'Luo uusi organisaatioryhmä (koncern): valitse juuriorganisaatio, valitse jäsenet, määritä periytymistila kategorioittain.',
        organizations_groups_detail: 'Yksittäisen organisaation ryhmän tiedot: jäsenet, perintömatriisi, jaetut resurssit ja tarkastuksen yhteenveto.',
        organizations_groups_settings: 'Organisaatioryhmän asetukset: [[TOK_0]], kalenteri, ilmoitukset, vastaanotto, [[TOK_1]] integraatio. Luokkakohtainen peri/ohita kytkin.',
        organizations_groups_audit: 'Ryhmäkohtainen tarkastusloki: jäsenyyden muutokset, periytymiskytkimet, jaetun resurssin lisääminen/poistaminen.',
        organizations_groups_consolidated_audit: 'Yhdistetty tarkastusnäkymä kaikista ryhmän jäsenorganisaatioista. Suodata entiteetin, näyttelijän ja aikaikkunan mukaan.',
        organizations_groups_dashboard: 'Jäsenten välinen hallintapaneeli: vaatimustenmukaisuus, avoimet kohteet, [[TOK_0]] rikkomukset kerätty koko ryhmälle.',
        organizations_groups_reports: 'Ryhmätason raportit: yhteenveto, sääntelijöille suunnattu yhteenveto, [[TOK_0]]-vertailu.',
        organizations_groups_users: 'Koko ryhmässä näkyvät käyttäjät: organisaatioiden väliset roolitehtävät, jaetut järjestelmänvalvojat, esiintymisketju.',
        organizations_groups_merged_vendors: 'Jäsenorganisaatioiden toimittajanäkymä on poistettu – yksi toimittaja näkyy kerran, vaikka se olisi otettu käyttöön erikseen.',
        organizations_groups_shared_templates: 'Ryhmätasolla julkaistut lomakepohjat. Jäsenet haluavat periä mallin; opt-out on organisaatiokohtainen.',
        organizations_groups_shared_frameworks: 'Sääntelykehykset jaetaan koko ryhmälle. Keskitetty päivitys virtaa jokaiselle jäsenelle, jossa on mode=inherit.',
        organizations_groups_shared_vendors: 'Ryhmätason toimittajarekisteri. Sopimus, DPA-tila ja riskipisteet näkyvät jokaiselle jäsenelle.',
        onboarding_help_center: 'Ohjekeskus: selaa kaikkia yli 309 artikkelia moduulin, luokan ja persoonan mukaan. Koko tekstihaku EN + VI -sisällöstä.',
        onboarding_progress: 'Käyttöönoton edistymisen seuranta: mitkä käyttöönottovaiheet ovat suoritettuja, mitkä odottavat, kuka omistaa estäjät.',
        onboarding_personas: 'Henkilökohtaiset perehdytysmatkat 10 VN-rooliin (P-VN-01 - P-VN-10). Jokainen matka on kuratoitu luettelo ensimmäisistä toimista.',
        onboarding_quick_starts: 'Pika-aloitusskenaariot: Suorita täydellinen vaatimustenmukaisuuden työnkulku päästä päähän hiekkalaatikossa. Ihanteellinen harjoitteluun.',
        onboarding_sample_data: 'Esimerkkitietojen generaattori: lataa realistisia esittelyrivejä mihin tahansa moduuliin. Hyödyllinen myyntidemoille ja koulutukselle.',
        onboarding_tours: 'Interaktiivisia opastettuja kierroksia. Käynnistä moduulikohtainen esittely, joka kertoo jokaisen sivun navigoinnin aikana.',
        security_sessions: 'Todennettujen istuntojen reaaliaikainen näkymä: laite, IP, viimeinen toiminta, käytetty MFA-tekijä. Lopeta yhdellä napsautuksella.',
        security_api_keys: 'Palvelutilin [[TOK_0]] avaimet: laajuus, kierto, viimeksi käytetty ja avainkohtainen kirjausketju.',
        security_break_glass: 'Hätäkäyttöinen lasinmurto: aikarajoitettu superjärjestelmänvalvojan lupa, jossa on pakollinen kirjausketju ja tapahtuman jälkeinen tarkistus.',
        security_delegations: 'Väliaikaiset roolien delegoinnit: toimiston ulkopuolinen kattavuus, hyväksyntäketjut, automaattinen päättyminen.',
        security_ip_allowlist: 'IP-sallitut asetukset: Rajoita järjestelmänvalvojan kirjautuminen tiettyihin yritysverkkoihin tai VPN-alueisiin.',
        security_mfa: 'Monivaiheinen todennuskäytäntö: pakottaminen roolia kohti, sallittujen tekijöiden luettelo (TOTP/SMS/WebAuthn), nollauskulku.',
        security_service_accounts: 'Palvelut kattavat järjestelmien välisen integroinnin. Rajataan, tarkastetaan ja vaihdetaan erillään ihmiskäyttäjistä.',
        security_session_settings: 'Istuntokäytäntö: joutokäynnin aikakatkaisu, istunnon enimmäisikä, samanaikaisen istunnon raja, uudelleentodennuksen laukaisimet.',
        security_sso: 'Kertakirjautumisen määritykset: SAML-/OIDC-palveluntarjoajat, attribuuttien kartoitus, automaattisen käyttäjien hallinnan säännöt.',
        rights_requests_create: 'Luo uusi rekisteröidyn oikeuksia koskeva pyyntötapaus. Tallentaa pyytäjän identiteetin, pyynnön tyypin, kanavan ja [[TOK_0]] kellon alun.',
        rights_requests_list: 'Kaikki oikeuspyyntötapaukset, joissa on [[TOK_0]] lähtölaskenta, siirronsaaja, tila ja suodatinsirut kanava + pyyntötyypille.',
        rights_requests_detail: 'Yksittäisen tapauksen työtila: kirjeenvaihto, toteutustoimenpiteet, todisteet, vastausten laatiminen, [[TOK_0]] siirtymät.',
        rights_requests_cmp_sync: '[[TOK_0]] integroinnin synkronointiasetukset: webhook-päätepiste, automaattisen tapauksen luontisäännöt, uudelleenyrityskäytäntö.',
        rights_requests_extensions: '[[TOK_0]] laajennuspyynnöt: perustelut, hyväksyjän reititys ja kirjausketjun kirjaus myöntämisen/hylkäämisen yhteydessä.',
        rights_requests_fulfillment: 'Pyydä toteutustyötilaa: kerää tietopaketit, tee muokkaukset, pakkaa toimitettavaksi.',
        rights_requests_responses: 'Vastauksen luonnos mallin lisäyksellä, yhdistämiskentillä ja vierekkäin EN/VI-esikatselulla.',
        rights_requests_response_templates: 'Vastausmalliluettelo: hyväksytyt mallit pyyntötyypin + lainkäyttöalueen mukaan, versiohistorialla.',
        compliance_forms_consolidation_create: 'Luo uusi konsolidointitapaus: ryhmittele liittyvät lomakelähetykset yhteen arkistointipakettiin, joka on tarkoitettu yhdelle sääntelijälle.',
        compliance_forms_consolidation_detail: 'Yksittäisen konsolidointitapauksen työtila: osien syötteet, tarkastajien hyväksynnät, täydellisen asiakirjan vienti sääntelijälle.',
        compliance_forms_consolidation_cases: 'Kaikki konsolidointitapaukset, joissa on arkistointitila, tarkastajien tehtävät ja määräaikojen seuranta.',
        compliance_forms_consolidation_review: 'Tarkista konsolidointitapausten työtila: hyväksy osien syötteet, pyydä muutoksia, kirjaudu ulos ennen vientiä.',
        compliance_forms_dossier_export: 'Vie konsolidoitu asiakirja-aineisto sääntelyvalmiina [[TOK_0]]-nippuna saatekirjeen, liitteiden ja allekirjoitusten kanssa.',
        compliance_forms_section_input: 'Osaston omistajan työtila konsolidointitapauksen yksittäisen osan suorittamiseen.',
        compliance_forms_filing_case_links: 'Linkit lomakeesiintymien ja arkistointitapausten välillä. Varmistaa, että jokaisen tiedoston taustalla on oikeat lomaketiedot.',
        compliance_forms_section_routing: 'Osion reitityssäännöt: mikä osasto omistaa kunkin lomakemallin minkä osan.',
        assessments_dashboard: 'Arviointien hallintapaneeli: [[TOK_0]]-määrä, siirtoarviot, aukkojen yhteenveto, tulevat tarkistusten määräajat.',
        assessments_dossier_filing_detail: 'Yksittäisen aineiston arkistointi: lomaketyyppi (Mẫu số 02a/02b), osien tehtävät, osion tila, lähetyksen tiedot, [[TOK_0]] ajastimet.',
        assessments_dossier_filing_list: 'Kaikki aineiston arkistointi lomakkeen tyypin, tilan ja osien määrittämisen edistymisestä. Suodata tilan ja kehyksen mukaan.',
        assessments_dpia_list: '[[TOK_0]] rekisteri: kaikki keskeneräiset, hyväksytyt ja arkistoidut tietosuojavaikutusten arvioinnit.',
        assessments_gap_report: 'Puuteraportti: [[TOK_0]] kattavuus, luokittelematon [[TOK_1]] vaatimus, rajoittamattomat riskit, puuttuvat ilmoitukset. Ensisijainen auditointivalmiuspinta.',
        assessments_transfer_list: 'Siirtojen arvioinnit rajat ylittäville tietovirroille. Jokainen arviointi dokumentoi mekanismin, suojatoimenpiteet ja riskiluokituksen.',
        deletion_orchestration_templates: 'Poistoajojen tarkistuslistamallit. Jokainen malli on komentosarjottu tehtävien sarja, joka on sidottu tiettyihin järjestelmiin ja säilytyssääntöihin.',
        deletion_orchestration_dsr_integration: 'DSR-poisto-integrointi: käynnistää automaattisesti poistoajon hyväksytystä poistopyynnöstä.',
        deletion_orchestration_tasks: 'Aktiivisten poistoajojen suoritustehtävät. Jokainen tehtävä seuraa järjestelmää, toimintaa, omistajaa ja vahvistusta.',
        deletion_orchestration_dashboard: 'Poiston ohjauksen hallintapaneeli: aktiiviset ajot, valmistumisaste, odottavat vahvistukset, tarkistusketjun tuoreus.',
        deletion_orchestration_proof_chain: 'Peukaloinnin ilmeinen varmistusketju jokaiselle poistotoiminnolle. Vaaditaan, jotta [[TOK_0]] noudattaisi poistamista.',
        organizations_compliance_rollup: 'Vaatimusten yhteensopivuus kokonaisuuksien välillä: [[TOK_0]] yhteisöittäin, kehystason kattavuus, jäljellä olevat velvoitteet.',
        organizations_departments_admin: 'Järjestelmänvalvojan työtila osastoille: luo, määritä omistajat uudelleen, hallitse tiimijäsenyyttä, aseta reitityssääntöjä.',
        organizations_departments: 'Osastot luettelo kokonaisuuksista. Ohjaa osien reititystä, hyväksyntävirtoja ja todisteiden antamista.',
        organizations_entity_frameworks: 'Määritä sääntelykehykset kullekin kokonaisuudelle. Asemat, joita Mẫu số -lomakkeet käyttävät ja jotka tarkastukset ovat pakollisia.',
        organizations_entity_form: 'Luo tai muokkaa yksittäistä organisaatiokokonaisuutta: virallinen nimi, yrityksen rekisteröinti, osoite, edustaja.',
        organizations_list: 'Kaikki vuokralaisen organisaatioyksiköt. Ensisijainen luettelonäkymä tilasuodattimilla ja pikatoiminnoilla.',
        organizations_retention_policies_admin: 'Säilytyskäytännön hallinta, joka koskee organisaatiota: oletussäännöt, entiteettikohtaiset ohitukset.',
        task_management_calendar: 'Kalenterinäkymä tehtävistä ja määräajoista. Värikoodattu moduulin ja [[TOK_0]]-tilan mukaan.',
        task_management_my_tasks: 'Henkilökohtainen tehtäväjono: määrätty minulle, eräpäivä pian, myöhässä. Ensisijainen päivittäinen työtila.',
        task_management_overdue: 'Myöhästyneitä tehtäviä koko organisaatiossa. Suodattimet omistajan, moduulin ja päivien erääntymisen mukaan.',
        task_management_section_assignments: 'Osion tehtävän yleiskatsaus: mikä osasto omistaa minkä osan kustakin aktiivisesta lomaketiedostosta.',
        task_management_board: 'Kanban-taulun näkymä tehtävistä. Päivitä tila vetämällä sarakkeiden välillä (To-Do / In-Progress / Review / Done).',
        task_management_detail: 'Yhden tehtävän työtila: kuvaus, kommentit, liitteet, osatehtävät, kirjausketju, tilasiirtymät.',
        task_management_list: 'Litteä luettelo kaikista tehtävistä suodattimilla: omistaja, moduuli, tila, prioriteetti, eräpäivä.',
        consent_cmp_sync: '[[TOK_0]] synkronointityötila: käynnistä synkronoinnit, tarkista synkronointihistoria, tarkista epäonnistumiset. Pitää [[TOK_1]] tilan linjassa alustan kanssa.',
        consent_cmp_bulk_sync: '[[TOK_0]]-synkronointi: synkronoi kaikki suostumustietueet uudelleen kaikissa omaisuuksissa. Käytetään vuokralaisten siirtoihin ja suuriin [[TOK_1]] muutoksiin.',
        consent_cmp_integration: '[[TOK_0]] integrointiasetukset: päätepiste, todennus, synkronointikäytäntö ja yhteyden kunto.',
        consent_cmp_purpose_mapping: 'Yhdistä [[TOK_0]] käyttöympäristöön. Varmistaa, että suostumussignaalit kulkevat oikein kahden järjestelmän välillä.',
        consent_cmp_webhook: '[[TOK_0]] webhook-määritys: saapuvien tapahtumien reititys, allekirjoitussalaisuudet, uudelleenyrityskäytäntö.',
        partner_workspace_brand_profiles: 'Kumppanien brändiprofiilit: logo, tunnuslause, yhteystiedot, palvelutarjonta. Ohjaa kumppanimarkkinapaikkalistausta.',
        partner_workspace_deliverable_templates: 'Toimitettava malliluettelo: standardoidut palvelupaketit, joita kumppanit voivat tarjota ([[TOK_0]] arvostelu, toimittajan tarkastus, koulutus).',
        partner_workspace_deliverables: 'Aktiiviset tuotokset kumppanien sitoumuksissa. Raidan laajuus, eräpäivät, hyväksymiskriteerit.',
        partner_workspace_service_tiers: 'Palvelutasojen määritelmät: Pronssi / Hopea / Kulta laajuudella, [[TOK_0]] ja hintaluokat.',
        partner_workspace_workflow_instances: 'Aktiiviset työnkulkuesiintymät kumppanien kesken: käyttöönotto, tarkistus, eskalointi, offboard-ajot.',
        partner_workspace_workflow_templates: 'Työnkulkumalliluettelo kumppanien sitouttamiseen. Jokainen malli määrittää vaiheet, omistajat, SLA:t ja tulosteet.',
        access_accountability_justification_reviews: 'Tarkista käyttäjien lähettämät käyttöoikeusperusteet. Hyväksy, haasta tai esikaloi vyöhykekohtainen käytäntö.',
        access_accountability_review_campaigns: 'Ajoitetut käyttöoikeus-tarkistuskampanjat: toistuvuus, laajuus, arvioijan tehtävä, valmistumisen seuranta.',
        access_reviews_list: 'Kaikki pääsy-tarkistuskampanjat suodattimilla: jakso, tila, tarkistaja, kohdejärjestelmä.',
        access_reviews_campaign_detail: 'Yhden kampanjan työtila: laajuus, tarkistajat, nimikejono, sertifioinnin tila, kirjausketju.',
        access_reviews_my_reviews: 'Minulle määrätyt arvostelut: odottavat päätökset kontekstineen, varmentaa tai peruuttaa kohdetta kohti.',
        attestation_schedules_list: 'Todistusaikataulurekisteri: toistuvuus, laajuus, seuraava eräpäivä, valmistumisaste aikataulua kohden.',
        attestation_schedules_create: 'Luo uusi todistusaikataulu: valitse taajuus, laajuus, todistajat ja todisteet.',
        attestation_schedules_edit: 'Muokkaa olemassa olevaa todistusaikataulua. Muutokset koskevat seuraavaa jaksoa; menneet syklit pysyvät ennallaan.',
        attestation_schedules_history: 'Todistusaikataulun historiallinen valmistumisaikajana. Todistusesineitä linkitetty per sykli.',
        governance_board_report: 'Hallituksen valmis noudattamisraportti: yhteenveto, tulostrendit, jäljellä olevat riskit, korjaamisen tila.',
        governance_compliance_score: 'Vaatimustenmukaisuuspisteiden laskenta eri kehysten välillä. Tarkastellaan ohjauskohtaista panosta.',
        governance_drift_monitor: 'Havaitse ohjauksen ajautuminen: asetusmuutokset, luvat, käytäntöpoikkeukset, jotka heikentävät asentoa.',
        governance_audit: 'Hallintokohtainen auditointiloki: työnkulkutapahtumat, hyväksymispäätökset, poikkeamissignaalit.',
        governance_evidence: 'Todistusluettelo hallinnon valvonnasta. Todistavat asiakirjat, kuvakaappaukset, todistuskuitit.',
        partner_workspace_escalation: 'Kumppanien välisen eskaloinnin hallintapaneeli: avoimet eskalaatiot, vakavuus, [[TOK_0]] kellot ja seuraavan toiminnon omistajat.',
        partner_workspace_audit: 'Kumppanien työtilan tarkastusloki: sitouttamismuutokset, suoritepäivitykset, eskalaatiosiirtymät.',
        partner_workspace_partner_detail: 'Yhden kumppanin organisaatioprofiili: sitoutumishistoria, aktiiviset suoritukset, kontaktit, suorituskykypisteet.',
        partner_workspace_partner_list: 'Kumppaniorganisaatiorekisteri: aktiiviset, aloittavat ja ulkopuoliset kumppanit, joilla on palvelutaso + suoritusmerkit.',
        platform_license: 'Lisenssiasetukset: taso, paikkamäärät, uusimistila, asennetun lisenssin ohjaama toimintojen vaihto.',
        platform_notifications_admin_queue: 'Järjestelmänvalvojan ilmoitusjono: ilmoitukset lennon aikana, toimitushäiriöt, uudelleenyritysten tila sähköposti-/tekstiviesti-/sovelluksen sisäisissä kanavissa.',
        platform_notifications_prefs: 'Käyttäjäkohtaiset ilmoitusasetukset: kanavan valinta, tiivistelmäaikataulu, mykistetut aiheet.',
        settings_overview: 'Vuokralaisen asetusten yleiskatsaus: pikalinkit verkkotunnuksiin, sähköpostiin, vientiin, webhookeihin ja muihin alustan laajuisiin määrityksiin.',
        settings_domains: 'Sallitut verkkotunnukset rekisteröitymistä ja kertakirjautumista varten. Rajoittaa tilin luomisen vahvistettuihin yritysverkkotunnuksiin.',
        settings_email: 'Lähtevän sähköpostin määritykset: SMTP-palveluntarjoaja, lähettäjän identiteetti, DKIM/SPF-tila, testisähköpostityökalu.',
        settings_export_schedules: 'Ajoitettu vienti: toistuva [[TOK_0]]/[[TOK_2]]/[[TOK_1]]-sukupolvi toimitetaan tiedostoselaimeen cron-aikataulun mukaisesti.',
        settings_webhooks: 'Lähtevät webhook-päätepisteet: tilaa ulkoiset järjestelmät alustatapahtumiin. Jokaisen toimituksen allekirjoitus, uudelleenyritys, tarkastus.',
        sod_rules_create: 'Luo velvollisuuksien erottelusääntö: valitse ristiriitaiset rooliparit, laajuus ja täytäntöönpanotapa (esto/varoita).',
        sod_rules_edit: 'Muokkaa olemassa olevaa SoD-sääntöä. Muutokset astuvat voimaan välittömästi; olemassa olevat rikkomukset arvioidaan uudelleen seuraavan käyttökerran yhteydessä.',
        sod_rules_list: 'Kaikki vuokralaisen SoD-säännöt: täytäntöönpanotila, rooliparit, poikkeusten määrä, rikkomusten määrä.',
        connectors_definitions: 'Liitintyyppirekisteri: kunkin integroinnin määritelmä (päätepisteen muoto, todennus, tuetut toiminnot).',
        connectors_list: 'Kaikki liitininstanssit on kytketty vuokralaiseen. Tila, viimeisin synkronointi, virheloki, synkronointi pyynnöstä.',
        connectors_credentials: 'Liittimen kirjautumistietovarasto: [[TOK_1]]-tunnukset, [[TOK_0]]-avaimet, palvelutilin salasanat. Kiertoaikataulu + auditointi.',
        connectors_event_bus: 'Liitintapahtumaväylä: saapuvat tapahtumat integroinneista, reitityssäännöt, toista kuolleiden kirjainten jono.',
        consent_change_awareness: 'Havaitse merkitykselliset suostumuksen muutokset: tarkoitus lisätty, käytäntö päivitetty, soveltamisalaa laajennettu. Edistää uudelleensuostumuskampanjoita.',
        consent_audit: 'Suostumusten kirjausketju: jokainen apuraha, päivitys, peruutus työnkulkujen välillä. Ensisijainen pinta säätimen läpikulkua varten.',
        consent_reconciliation: 'Täsmennä suostumustila [[TOK_0]]-, alusta- ja myöhempien järjestelmien välillä. Lippujen erot.',
        consent_withdrawal_propagation: 'Peruuttamisen leviämisputki: kun kohde peruuttaa suostumuksensa, varmista, että se virtaa kaikkiin linkitettyihin järjestelmiin.',
        consent_policies: 'Suostumuskäytäntöluettelo: tietosuojakäytäntöjen versiot, kieliversiot, aktivointiikkunat.',
        consent_purpose_catalog: 'Suostumustyönkulkujen käyttötarkoitusluettelo. Jokainen tarkoitus liittyy oikeusperustaan ​​ja säilytyssääntöön.',
        consent_snapshots: 'Suostumuksen tilannekuvat: kaikkien aktiivisten suostumusten ajankohtainen kaappaus. Vaaditaan auditointeja ja laillisia säilytysvaatimuksia varten.',
        consent_workflows: 'Suostumustyönkulkuluettelo. Jokainen työnkulku määrittelee triggerit, keräämisvirrat ja loppupään toiminnot.',
        discovery_classification_lineage: 'Luokittelulinja: seuraa, kuinka tietoelementti luokiteltiin skannausten ja manuaalisen tarkistuksen aikana.',
        discovery_classification_rules: 'Luokittelusääntöjen rekisteri: säännöllinen lauseke, sanasto, ML-mallit, joita käytetään löydettyjen kenttien automaattiseen luokitteluun.',
        discovery_dedup_rules: 'Deduplikaatiosäännöt löydetyille tietueille. Estää saman kentän näkymisen useita kertoja.',
        discovery_import_templates: 'Tuo malleja olemassa olevien tietoluetteloiden tuomiseksi Discovery-moduuliin [[TOK_0]]:n tai ulkoisten työkalujen avulla.',
        discovery_owner_review: 'Omistajan tarkistusjono: ehdotetut luokitukset odottavat tietojen omistajan hyväksyntää tai hylkäämistä.',
        discovery_staging: 'Kohdealue äskettäin löydetyille pelloille. Triage ennen siirtymistä Data Mapping -luetteloon.',
        discovery_suggestion_analytics: 'Analyysi ehdotusmoottorille: tarkkuus, kattavuus, ohitetuimmat luokitukset.',
        discovery_suggestion_queue: 'Tarkista ehdotettujen luokittelujen jono ennen niiden käyttöönottoa. Hyväksy, muokkaa tai hylkää kohdetta kohden.',
        compliance_forms_filler: 'Vuorovaikutteinen lomakkeiden täyttö: käy läpi säädöslomake, jossa on vahvistus, automaattinen tallennus ja yhteistyökumppanit.',
        compliance_forms_instance_detail: 'Yksittäinen ilmentymä: nykyinen tila, historia, linkitetty arkistointitapaus, vienti.',
        compliance_forms_outputs: 'Luodut tulosteet lomakeesiintymää kohti: [[TOK_2]], [[TOK_1]], [[TOK_0]] paketit saatekirjeellä ja allekirjoituksilla.',
        compliance_forms_submission_packages: 'Lähetyspakettien luettelo: viranomaisvalmiit paketit, joissa on luettelo, allekirjoitukset ja toimituskuitti.',
        incident_ops_regulatory_sla: 'Virheilmoitusten [[TOK_2]]-määritykset (VN:n kyberturvallisuuslain 72 tunnin ikkuna, [[TOK_1]] 72 tuntia, [[TOK_0]] 72 tuntia).',
        incident_ops_response_metrics: 'Tapahtumareaktiomittarit: MTTD, MTTR, [[TOK_0]] vaatimustenmukaisuusaste, eskalaatiomäärät.',
        incident_ops_sla_dashboard: '[[TOK_0]] hallintapaneeli: aktiiviset tapahtumat heidän [[TOK_1]] kellossaan, vaaravaroitukset, rikkomushistoria.',
        incident_ops_sla_definitions: '[[TOK_0]] määritelmät: vakavuustasot, tasokohtaiset vaste- ja resoluutioikkunat, viittaukset puitteisiin.',
        monitoring_governance_raci: 'RACI-matriisi hallinnon valvonnalle: vastuullinen, vastuullinen, kuultu, tietoinen ohjauskohtaisesti koko ohjelmassa.',
        monitoring_periods: 'Valvontajaksot: vuosi-/neljännesvuosittain/kuukausittaiset tarkastelujaksot, jotka on yhdenmukaistettu säännösten mukaisten arkistointiikkunoiden kanssa.',
        monitoring_programs_list: 'Valvontaohjelmaluettelo: puitteisiin kohdistetut ohjelmat laajuudella, omistajalla, poljinnopeudella.',
        monitoring_task_templates: 'Tehtävämallit seurantajaksoille. Jokainen malli määrittelee laajuuden, siirrettävän roolin ja näyttövaatimukset.',
        access_accountability_evidence_detail: 'Yksittäisen todistepaketin yksityiskohdat: valvontaketju, allekirjoitukset, vientivaihtoehdot sääntelyviranomaisen toimittamista varten.',
        access_accountability_evidence_packages: 'Todistuspakettien luettelo pääsyvastuuta varten: allekirjoitetut, peukaloinnin havaitsevat paketit valmiina tarkastettavaksi.',
        access_reviews_role_analytics: 'Roolianalytiikka: roolien käyttötiheys, oikeuksien hiipuminen, sertifiointi-päätöstrendit.',
        access_accountability_pattern_analysis: 'Käyttölokien mallianalyysi: epätavalliset käyttöajat, maantieteelliset poikkeamat, etuoikeuksien eskalaatiosignaalit.',
        access_accountability_session_dashboard: 'Istunnon hallintapaneeli: reaaliaikaiset todennettuja istuntoja, istunnon lämpökartta tunnin/päivän mukaan, ei-aktiivisten istuntojen hälytykset.',
        classification_exports: 'Luokitteluvientit: Vie luokitusvarasto muodossa [[TOK_0]]/[[TOK_1]] ulkoisia tarkastustyökaluja varten.',
        classification_discovery_cycles: 'Luokituksen etsintäjaksot: ajoitetut tarkistukset, jotka tuovat esiin äskettäin lisätyt tai muuttuneet tietoelementit.',
        classification_enterprise_data_map: 'Yritystietokartta: yhdistetty luokitusnäkymä järjestelmien, osastojen ja herkkyystasojen välillä.',
        connectors_automation_planning: 'Automaatiosuunnittelu: määritä liipaisin → liitin → toimintaketjut tapahtumapohjaisille dataoperaatioille.',
        connectors_brd_capture: 'Liiketoiminnan vaatimukset Asiakirjojen taltiointi uusia liittimiä varten.',
        connectors_poc_scorecards: 'Proof-of-konseptin tuloskortit uusien liitinintegraatioiden arvioimiseen hyväksymiskriteerien perusteella.',
        discovery_connector_management: 'Etsintäliittimien hallinta: mitkä skannerit on asennettu, niiden kunto ja mihin järjestelmiin ne kohdistuvat.',
        discovery_scans_list: 'Kaikki löytöskannaukset, joissa on tila, kattavuus ja löydöt. Perehdy skannauskohtaisiin löydöksiin.',
        governance_approvals: 'Hallinto-hyväksyntäjono: vireillä olevat päätökset toimittajan käyttöönotosta, DPA-tarkastukset, siirtoarvioinnit.',
        governance_offboarding: 'Myyjän offboarding työnkulku: sopimuksen irtisanominen, tietojen palauttaminen/poistaminen, pääsyn peruuttaminen, lopullinen tarkastus.',
        governance_periodic_review: 'Säännöllinen toimittajan tarkistus: ajoitettu riskin uudelleenarviointi, DPA-valuutta, alikäsittelijöiden luettelo.',
        incident_ops_playbook_activations: 'Aktiiviset pelikirjan esiintymät: mikä pelikirja on käynnissä missäkin tapahtumassa, edistyminen, jäljellä olevat tehtävät.',
        incident_ops_playbook_links: 'Ohjekirja → tapahtumalinkitysrekisteri. Linkkejä myös sääntelijän ilmoitusmalleihin pelikirjakohtaisesti.',
        incident_ops_playbook_templates: 'Ohjekirjan malliluettelo: uudelleenkäytettävät tapausvastausskriptit tapaustyypin ja vakavuuden mukaan.',
        organizations_groups_settings_inheritance: 'Ryhmän jäsenten välinen perintömatriisi. Luokkakohtainen perintä/ohita kytkin ja kirjausketju.',
        organizations_intake_config_form: 'Luo tai muokkaa sisäänottomäärityksiä: julkisen lomakkeen [[TOK_0]] polku, nopeusrajoitukset, captcha, ilmoitusreitit.',
        organizations_intake_configs_list: 'Intake-konfiguraatioluettelo: yleisölle päin olevat oikeudet-pyyntöjen sisääntulokohdat markkinoita/brändejä kohti.',
        privacy_scanner_monitoring_dashboard: 'Tietosuojaskannerin valvontakojelauta: omaisuuden kattavuus, skannauspoljinnopeus, kiinteistökohtaisesti merkityt signaalit.',
        privacy_scanner_monitoring_settings: 'Valvonta-asetukset: tarkistustaajuus, kynnyssäännöt, hälytysreititys, skannaustulosten säilyttäminen.',
        privacy_scanner_settings: 'Skannerin asetukset: käytössä olevat tarkistusluokat, allekirjoituspäivitykset, [[TOK_0]] skannerin päätepisteen tunnistetiedot.',
        privacy_scanner_real_time_scan: 'Reaaliaikainen skannaus: käynnistä ad-hoc-skannaus ja katso tulokset. Ihanteellinen nopeaan todentamiseen.',
        privacy_scanner_scan_result_detail: 'Yksityiskohtainen näkymä yksittäisestä skannaustuloksesta: evästeet, majakat, löydetyt jäljittäjät, luokitus, korjaustoimenpiteet.',
        privacy_scanner_results_archive: 'Historiallisten skannaustulosten arkisto. Suodata ominaisuuden, ajanjakson ja signaalityypin mukaan.',
        task_management_workflow_detail: 'Yksi työnkulun ilmentymä: kaikki vaiheet, omistajat, SLA-sopimukset, haarautumislogiikka, valmistumistodistus.',
        task_management_workflow_list: 'Kaikki työnkulun ilmentymät moduulien välillä: tila, omistaja, määräaika, alkuperämoduuli.',
        task_management_workflow_templates: 'Työnkulkumalliluettelo: uudelleenkäytettävät monivaiheiset työnkulut, jotka voidaan luoda mistä tahansa lähdemoduulista.',
        audit_trail_classic: 'Klassinen kirjausketjunäkymä (vanha). Poistetaan käytöstä yhtenäisen tarkastusmoduulin hyväksi.',
        audit_trail_unified: 'Yhtenäinen kirjausketju jokaisessa moduulissa. Ensisijainen auditointipinta.',
        iat_settings: 'Määritä Immutable Audit Trails -lisäosa: käyttöönotto, laajuus, oletustodistustila, taksonomian ohitukset, ylärajat ja [[TOK_0]] tunnistetietojen kierto. Lue ensin kanonisen moduulin opas; syvä kumppani on "Enabling and Configuring".',
        iat_status: 'Selaa jokaista proof_link tila-, tila-, moduuli- ja päivämääräsuodattimilla. Napsauta mitä tahansa merkkiä avataksesi vedoslaatikon. Syvä kumppani: "Todisteen tilan ymmärtäminen".',
        iat_integrity_center: 'Suorita poikkeaman havaitsemisen vahvistuskierrokset ajanjaksolla; viedä Integrity Packin kaikkiin tarkastusalueisiin. Syvä kumppani: "Eheellisyyskeskuksen käyttäminen".',
        iat_usage: 'Seuraa nykyistä saldoa, kuukausittaista kulutusta, ylärajan tilaa ja lunasta luottopaketteja. Deep companion: "Kreditit ja Caps".',
        classification_exceptions: 'Luokittelupoikkeusjono: tietueet, jotka on merkitty reunatapauksiksi, odottavat manuaalista tarkistusta.',
        classification_review_tasks: 'Luokituksen tarkistustehtäväjono: automaattisesti ehdotetut luokitukset odottavat omistajan vahvistusta.',
        consent_properties_audit_log: 'Suostumusominaisuuden muutosten seurantaketju: kuka päivitti mitä, milloin, vanhat/uudet arvot.',
        consent_properties_analytics: 'Suostumusomaisuuden analytiikka: suostumuksen keräämisprosentti, peruutusprosentti, käyttötarkoituksen yhdistelmätrendit.',
        consent_properties_evidence_packs: 'Todistuspaketit suostumusominaisuuksille: viranomaisvalmiit paketit, jotka todistavat suostumuksen noudattamisen.',
        consent_properties_inconsistencies: 'Suostumusominaisuuksien epäjohdonmukaisuudet: ominaisuudet, joiden tila ja [TOK_0]] ovat eri mieltä.',
        consent_properties_golden_templates: 'Kultaiset suostumusbannerimallit: hyväksyttyjä, tarkistettuja, hallintovalmiita bannerimuotoja, jotka on otettu käyttöön eri kiinteistöissä.',
        consent_properties_template_rollouts: 'Mallin käyttöönottoputki: vaihe, pilotti, tuotantoaallot kultaisten mallien työntämiseen kiinteistöihin.',
        consent_properties_property_groups: 'Kiinteistöryhmät: klusteriin liittyvät omaisuudet hallinta- ja raportointikokoelmia varten.',
        consent_properties_snapshot_schedules: 'Snapshot-aikataulut: automatisoi säännölliset suostumustilan kaappaukset tarkastusta ja laillista säilytystä varten.',
        deletion_orchestration_completeness: 'Täydellisyyden seuranta: varmistaa jokaisen säilytysalueen järjestelmän vahvistetun poiston.',
        deletion_orchestration_runs_list: 'Kaikki poistoajot: tila, kesto, katetut järjestelmät, valmistumisaste.',
        deletion_orchestration_vendor_requests: 'Lähtevät poistopyynnöt toimittajille: seuranta, [[TOK_0]], vahvistuksen artefaktit.',
        deletion_orchestration_vendor_verification: 'Toimittajan varmennustyönkulku: varmista, että toimittajajärjestelmät ovat suorittaneet poiston pyyntömme mukaisesti.',
        compliance_forms_catalog: 'Vaatimustenmukaisuuslomakeluettelo: kaikki säädöslomakkeet (Mẫu số, [[TOK_0]] Art 30, ISO 27701) arkistoitavissa.',
        compliance_forms_template_browser: 'Malliselain: löydä hyväksyttyjä lomakemalleja eri kehyksistä.',
        governance_cross_border: 'Rajat ylittävien siirtojen rekisteri hallintotasolla: mekanismit, suojatoimet, maariskin arviointi.',
        governance_subprocessors: 'Alikäsittelijän rekisteri: ketä toimittajamme käyttävät, DPA-sarja, muutoksista ilmoittaminen.',
        incidents_detail: 'Yksittäisen tapahtuman työtila: aikajana, omistaja, vakavuus, korjaus, viranomaisen ilmoituksen tila.',
        incidents_list: 'Tapahtumarekisteri: kaikki aktiiviset + historialliset tapahtumat vakavuuden, kanavan, kehyksen suodattimilla.',
        partner_workspace_partner_dashboard: 'Kumppanien hallintapaneeli: huipputason KPI:t kaikille kumppanien sitoumuksille, eskalaatiomäärät, terveystrendit.',
        partner_workspace_support_tickets: 'Kumppanituen lippuluettelo. Jaettu kumppani- ja vuokraajatiimien välillä [[TOK_0]]-seurannan avulla.',
        program_governance_acknowledgment_tracking: 'Asiakirjan kuittauksen seuranta: kuka on lukenut ja hyväksynyt kunkin käytännön tai menettelyn.',
        program_governance_change_log: 'Asiakirjan muutosloki: jokainen muokkaus hallintoasiakirjaan, jossa on erotus- ja hyväksyntäketju.',
        roles_detail: 'Yksittäisen roolin tiedot: tähän rooliin sidotut käyttöoikeudet, määrätyt käyttäjät, jäsenmuutosten tarkastus.',
        roles_list: 'Rooliluettelo: jokainen sisäänrakennettu ja mukautettu rooli, jossa on jäsenmäärä ja käyttöoikeus.',
        consent_properties_cross_property_dashboard: 'Kiinteistöjen välinen hallintapaneeli: suostumuksen tila jokaisessa omaisuudessa. Aggregaatit kaappausnopeus, poistonopeus, ryömintäindikaattorit.',
        consent_properties_property_registry: 'Kiinteistörekisteri: jokainen vuokralaisen hallinnoima kiinteistö, jolla on suostumusbanneritila, linkitetty [[TOK_0]], käytäntöversio.',
        forseti_projects_overview: 'Forseti-työtilat: projekti ryhmittelee asiakirjat, keskustelut, työnkulkuajot ja taulukkoarvostelut yhteen säiliöön, joten [[TOK_0]]-neuvoja säilyttää kontekstin koko toimeksiannon ajan.',
        forseti_workflows_list: 'Tallennettu [[TOK_0]] kehotemalleja, jotka tuottavat tehtäviä ja luonnostelevat todisteita pyynnöstä. Käytä sisäänrakennettuja pakettityönkulkuja tai luo omia; juoksut veloitetaan kuukausittaisesta token-ämpäristäsi.',
        forseti_tabular_reviews_list: 'Toistettavissa oleva sarake sarakkeelta katsaus asiakirjakorpukseen. Määrittele kysymykset kerran, suorita sama tarkistus useissa liitteissä ja saat vierekkäisen vastausruudukon, jossa on lainauksia.',
        forseti_document_review_index: 'Triage-postilaatikko asiakirjoille, joissa on [[TOK_0]]-ehdotuksia tai Forsetista peräisin olevia versioita. Asiakirjat saapuvat jonoon keskusteluista, työnkulkuajoista tai tämän sivun "Lähetä asiakirja tarkistettavaksi" -toimintakehotuksesta.',
        forseti_audit_lineage: 'Seuraa jokaista [[TOK_0]]:n luomaa artefaktia, joka on liitetty mihin tahansa tietueeseen: keskustelut, työkalukutsut, tehtävät, todisteluonnokset ja asiakirjaversiot. Vaaditaan todisteiden puolustettavuutta ja toiminnan jälkeisiä tarkastuksia varten.',
        forseti_draft_evidence: '[[TOK_0]]-luokitellut todisteet odottavat ihmisen tarkistusta. Valtuutetun arvioijan on hyväksyttävä jokainen luonnos ennen kuin siitä tulee virallinen todiste – Forseti ei koskaan arkistoi automaattisesti.',
        forseti_usage: 'Tämän organisaation tunnuksen kulutus ja kauhan tila. Seuraa kuukausittain laskutettavia yksiköitä, jäljellä olevaa ryhmää ja viimeaikaista toimintaa käyttäjän / ominaisuuden / työkalun mukaan.',
        forseti_overview: 'Sisäänkäynti Forsetin [[TOK_0]] lakimiehelle: valitse henkilö, selaa viimeisimpiä keskusteluja ja aloita uusi keskustelu. Henkilövalinta tässä määrittää oletusäänen uusille keskusteluille.',
        forseti_chat_detail: 'Yksi Forseti-keskustelu: tarkastele viestihistoriaa, vaihda henkilöitä keskustelun aikana, lähetä uusia viestejä ja vie transkriptio muodossa [[TOK_0]] todisteena.',
        forseti_cross_framework_conflicts: 'Kuroitu luettelo ristiriidoista organisaatiosi asentamien säädöspakettien välillä. Suodata kehyksen / aiheen / vakavuuden / kuittauksen tilan mukaan, napsauta riviä nähdäksesi vierekkäiset kehyksen sijainnit ja kuitata / määritä / ratkaise. Forseti paljastaa konfliktit; ihmiset päättävät.',
        users_detail: 'Yhden käyttäjän profiili: identiteetti, rooli, MFA, istuntohistoria, kirjausketju.',
        users_list: 'Käyttäjähakemisto: kaikki aktiiviset, kutsutut ja deaktivoidut käyttäjät pikasuodattimilla ja joukkotoiminnoilla.',
        governance_vendors: 'Hallinnoi toimittajan hallinnan elinkaarta: käyttöönottoprosessi, säännölliset tarkistukset, hyväksynnät ja offboarding. Seuraa toimittajan vaatimustenmukaisuuden tilaa ja ohjekirjan noudattamista.',
        governance_compliance: 'Seuraa organisaation noudattamista pisteytyksen, poikkeaman havaitsemisen ja taulun raportoinnin avulla. Seuraa vaatimustenmukaisuustrendejä ja luo johtajille valmiita raportteja.',
        governance_transfers: 'Hallitse rajat ylittäviä tiedonsiirtoja, DPA-tarkastuksia ja alikäsittelijän hallintoa. Asiakirjojen siirtomekanismit ja kansainvälisten tietovirtojen säännöstenmukaisuuden varmistaminen.',
        vendor_risk_assessment: 'Arvioi ja pisteytä toimittajariskiä koko portfoliossasi. Seuraa riskisignaaleja, seuraa uudelleenarviointeja ja ylläpidä kattavaa riskisalkkunäkymää.',
        vendor_risk_contracts: 'Hallitse myyjäsopimuksia, due diligence -kyselylomakkeita ja porttiarviointeja. Seuraa sopimusehtoja, uusimispäiviä ja vaatimustenmukaisuusvaatimuksia.',
        vendor_risk_onboarding: 'Hallinnoi toimittajan käyttöönoton elinkaarta: vastaanoton arviointi, tarkistusreititys, hyväksyntätyönkulku ja riskien hyväksymispäätökset.',
        vendor_risk_dashboard: 'Keskeinen yleiskatsaus toimittajan riskiasetelmaan: portfolion jakautuminen tasoittain, viimeaikaiset tason muutokset, 90 päivän sisällä päättyvät sopimukset, KPI-arvojen tarkistaminen ja riskien hyväksyntä. Aloita tästä, niin saat yhdellä silmäyksellä lukemisen ennen kuin alat perehtyä pisteisiin, signaaleihin tai portteihin.',
        vendor_risk_scoring: 'Määritä pisteytysmitat ja arvioi toimittajat painotettujen riskikriteerien perusteella. Seuraa yhdistelmäpisteitä, määritettyjä tasoja ja tuloshistoriaa ajan mittaan.',
        vendor_risk_signals: 'Seuraa epäsuotuisia tapahtumia, jotka saattavat edellyttää toimittajan uudelleenarviointia: sertifioinnin vanheneminen, rikkomusilmoitukset, taloudellinen epävakaus ja vaatimustenmukaisuuden muutokset. Signaalit ohjaavat loppupään uudelleenarviointitehtäviä.',
        vendor_risk_reviews: 'Suorita ajoittain toimittajien tarkastuksia sopimustilan tilannekuvien, havaintojen ja suositusten avulla. Seuraa tarkastelutuloksia (tyydyttävä, huolenaiheita havaittu, korjaustoimenpiteitä vaaditaan, eskaloitunut) ohjelmien ja ajanjaksojen välillä.',
        vendor_risk_reassessments: 'Käynnistä ja hallitse uudelleenarviointitehtäviä, kun signaalit tai säännölliset aikataulut osoittavat muuttuneen riskiasennon. Tallenna tulokset ja päivitetyt riskitasot; valmistuneet uudelleenarvioinnit siirtyvät takaisin pisteytykseen.',
        vendor_risk_acceptance: 'Hyväksy muodollisesti toimittajan jäännösriski nimenomaisilla ehdoilla, viimeisillä päivämäärillä ja perusteluilla. Ylläpidä riskien hyväksymisrekisteriä — aktiivisten, vanhentuneiden ja peruttujen hyväksymispäätösten tarkastettavaa rekisteriä.',
        vendor_risk_onboarding_cases: 'Hallinnoi toimittajan käyttöönottotapauksen elinkaarta: uusi käyttöönotto, materiaalimuutostarkistukset ja säännölliset tarkistukset. Työskentele vaiheittaisten välilehtien läpi valmistumisosoittimilla ja käynnistä hyväksyntäportit, kun olet valmis.',
        vendor_risk_review_routing: 'Ohjaa toimittajan tarkistustehtävät tietyille arvioijille käyttäjän ja roolin mukaan. Määritä kyselylomakkeita, seuraa arvioijien tehtäviä ja tallenna reititystulokset täydellä kirjausketjulla.',
        vendor_risk_gates: 'Arvioi hankintojen hyväksymisportit ennen kuin toimittajat alkavat julkaista. Määritä porttikriteerit (sertifioinnit, DPA-allekirjoitettu, kyselylomake täytetty, riski kynnyksen sisällä), tallenna ohituksen perustelut ja linkitä todisteet.',
        vendor_risk_questionnaires: 'Rakenna due diligence -kyselylomakemalleja ja määritä ne toimittajille. Seuraa vastausten valmistumista, tarkista huomautuksia ja havaintoja, jotka syötetään riskipisteytys- ja hyväksymisportteihin.',
        monitoring_programs: 'Luo ja hallitse säännöstenmukaisuuteen liittyviä valvontaohjelmia. Määritä tehtäviä RACI-hallinnan kautta ja seuraa ohjelman suoritusta.',
        monitoring_kpi: 'Seuraa vaatimustenmukaisuuden KPI:itä, viranomaisvalmiuspisteitä ja muuta tarkistuksen tilaa. Kojelautanäkymä ohjelman suorituskyvyn seurantaan kaikissa aktiivisissa kehyksissä.',
        discovery_scans: 'Suorita tiedonhakutarkistuksia yhdistetyissä järjestelmissä. Hallitse etsintäjaksoja delta-tunnistuksen avulla, määritä liittimet ja seuraa skannaustuloksia.',
        discovery_classification: 'Tarkista löytöehdotukset, hallinnoi äskettäin löydettyjen tietojen esitysaluetta ja suorita omistajan tarkistus luokitussuositusten avulla.',
        discovery_management: 'Määritä päällekkäisyyden poistamissäännöt, hallitse tuontimalleja ja jäljitä luokittelulinja etsinnästä hyväksyttyihin luokitustarroihin.',
        connectors_integration: 'Määritä järjestelmäliittimet, hallitse tunnistetietoja ja tarkkaile tapahtumaväylää reaaliaikaista tietojen synkronointia varten integroitujen järjestelmien välillä.',
        connectors_automation: 'Suunnittele automaatiostrategioita, ota huomioon liiketoiminnan vaatimukset ja arvioi konseptin näyttökortteja järjestelmäintegraatioprojekteihin.',
        connectors_governance: 'Hallitse järjestelmävarastoa, suorita tietoturvatarkastuksia, ylläpidä jäljitettävyysmatriiseja ja seuraa integraatiovajausrekistereitä.',
        task_management_tasks: 'Tarkastele ja hallitse vaatimustenmukaisuustehtäviä: tehtäväluettelo, henkilökohtainen tehtäväjono, myöhässä olevat tehtävät, tehtävätaulu ja kalenterinäkymät kaikkien moduulien työn seurantaa varten.',
        task_management_workflows: 'Suunnittele ja hallitse vaatimustenmukaisuustyönkulkuja: luo työnkulkumalleja, määritä osien tehtävät ja seuraa työnkulun toteutusta.',
        compliance_forms_templates: 'Selaa ja hallinnoi vaatimustenmukaisuuslomakemalleja. Käytä malliluetteloa, luo mukautettuja malleja ja määritä lomakeasetteluja säädöstenmukaisia ​​lähetyksiä varten.',
        compliance_forms_submissions: 'Täytä ja lähetä vaatimustenmukaisuuslomakkeet. Seuraa lomakkeen esiintymiä, tarkastele tulosteita ja hallitse lähetyspaketteja säännösten mukaista arkistointia varten.',
        compliance_forms_filing: 'Hallinnoi arkistointilinkkejä, osien reititystä ja useiden osastojen yhdistämistä säädösaineiston valmistelua ja lähettämistä varten.',
        organizations_entities: 'Hallitse organisaatiokokonaisuuksia, määritä sääntelykehykset entiteettiä kohti ja määritä osastohierarkiat useiden entiteettien noudattamista varten.',
        organizations_groups: 'Hallitse monien yritysten organisaatioryhmiä. Jaa toimittajat, puitteet ja lomakemallit ryhmän jäsenten kesken yhdistetyn raportoinnin avulla.',
        organizations_intake: 'Määritä vastaanottoasetukset ja hallitse asetusten periytymistä organisaatiohierarkioissa.',
        access_accountability_sessions: 'Tarkkaile käyttäjien istuntoja, tarkastele käyttölokeja ja analysoi käyttömalleja. Seuraa istunnon toimintaa ankkurointitilalla vastuullisuuden todisteiden saamiseksi.',
        access_accountability_reviews: 'Suorita käyttöoikeuksien tarkistuskampanjoita, hallinnoi perustelutarkastuksia ja seuraa arvioijan edistymistä. Koordinoi säännöllisiä käyttöoikeuksia koko organisaatiossa.',
        access_accountability_sod: 'Määritä tehtävien erottelusäännöt, havaitse rikkomukset ja hallitse poikkeuksia. Ota käyttöön eturistiriitojen hallinta rooleissa ja käyttöoikeuksissa.',
        access_accountability_evidence: 'Luo todistepaketteja käyttöoikeustarkastuksia varten, suorita tutkimuksia ja analysoi roolien käyttötapoja pääsyvastuuraportointia varten.',
        program_governance_maturity: 'Arvioi ja seuraa vaatimustenmukaisuusohjelman kypsyyttä eri kehysten välillä. Määritä kypsyysmalleja, suorita arviointeja ja seuraa parannustrendejä ajan mittaan.',
        program_governance_obligations: 'Kartoita sääntelyvelvoitteet organisaatioyksiköille, joilla on RACI-hallinto. Määritä hallintomalli ja seuraa havaittujen puutteiden korjaamissuunnitelmia.',
        program_governance_documents: 'Hallinnoi hallintoasiakirjarekisteriä: luonnostele, tarkista, anna ja seuraa vaatimustenmukaisuusperiaatteiden ja toiminta-asiakirjojen kuittauksia.',
        program_governance_reporting: 'Luo yhteenvetoja, tarkastusvalmiusraportteja ja todisteiden puutteiden analyyseja. Seuraa raportointijaksoja ja seuraa ohjelman terveysmittareita.',
        deletion_orchestration_runs: 'Suorita ja seuraa poistojen orkestrointiajoja. Seuraa suoritustehtäviä, tarkista täydellisyys ja hallitse poistojen hallintapaneelia.',
        deletion_orchestration_vendors: 'Koordinoi toimittajan poistopyyntöjä, varmista, että toimittaja noudattaa poistovelvoitteita, ja ylläpidä todistusketjun dokumentaatiota.',
        consent_management: 'Hallinnoi suostumuskäytäntöjä, käyttötarkoitusluetteloita ja suostumustyönkulkuja. Määritä suostumuksen keräämissäännöt ja seuraa suostumuksen tilannekuvia ajan mittaan.',
        consent_cmp: 'Integroi Consent Management Platforms (CMP:t) kanssa: määritä webhookeja, yhdistä [[TOK_0]] tarkoitukset GRC-luettelotarkoituksiin ja synkronoi suostumustietueet.',
        consent_compliance: 'Valvo suostumuksen noudattamista: havaitse konfiguraatiomuutokset, sovita yhteensopimattomuudet, seuraa peruuttamisen leviämistä ja tarkista suostumuksen kirjausketju.',
        partner_workspace_partners: 'Hallitse kumppaniorganisaatioita, tee kumppanitarkastuksia ja käsittele eskalaatioita. Seuraa kumppanin aloitustilaa ja vaatimustenmukaisuusvaatimuksia.',
        partner_workspace_operations: 'Hallitse kumppanien toimituksia, työnkulkumalleja, palvelutasoja ja brändiprofiileja. Määritä toiminnalliset työnkulut kumppaniyhteistyötä varten.',
        privacy_scanner_scanning: 'Suorita reaaliaikaisia ​​tietosuojatarkistuksia verkkosivustoissa ja sovelluksissa. Tarkastele skannaustuloksia, seuraa ennakkosuostumuksen seurantatodisteita ja hallitse skannausarkistoa.',
        privacy_scanner_monitoring: 'Määritä tietosuojaskannerin hallintapaneelit ja -asetukset. Määritä automaattiset skannausaikataulut ja hallitse skannerin asetuksia.',
        consent_import: 'Joukkotuonti suostumustietueet [[TOK_0]]-tiedostoista. Ihanteellinen paperipohjaisen suostumuksen rekisteröintiin (työsopimukset, vanhemman/koulun suostumuslomakkeet) mittakaavassa. Tukee myöntämisen, peruutuksen, rajoituksen ja vastalauseen työnkulkutyyppejä.',
        cases_import: 'Tuoda joukkotuonti rekisteröidyn oikeuksia koskevat tapaukset [[TOK_0]]-tiedostoista. Tukee monikanavaisia ​​vastaanottolähteitä, mukaan lukien puhelin-, posti-, sähköposti- ja henkilökohtaiset lähetykset organisaatioille, jotka vastaanottavat suuria määriä DSAR-ilmoituksia.',
        data_subjects: 'Tarkastele yhdistettyjä rekisteröityjen profiileja, joihin on koottu kaikki kunkin henkilön oikeuspyyntötapaukset ja suostumustietueet. Seuraa yksityisyyden koko elinkaarta henkilöä kohti – suostumushistoriaa, DSR-tapauksia ja vuorovaikutuksen aikajanaa.',
        files_config: 'Aseta koko alustan laajuinen tiedostojen lähetyskäytäntö – kokorajoitukset, tyypin sallitut luettelot, säilytysoletukset ja lailliset säilytyssäännöt. Omistajakohtaisten ohitusten avulla voit tiukentaa arkaluontoisten moduulien käytäntöjä (esim. käyttöoikeustodistuksia) ja pitää muun organisaation oletusarvoisena. Säilytysoletukset tukevat [[TOK_0]] lain 91/2025 3 artiklan mukaisia ​​tietojen minimointiodotuksia; oikeudellinen säilytys keskeyttää poistamisen avoimien tutkimusten tai riitojen aikana.',
        files_browser: 'Selaa, hae ja hallitse kaikkia organisaatioon ladattuja liitteitä. Suodata omistajamoduulin, lataajan, päivämäärän ja MIME-tyypin mukaan; avaa liitetietojen vetolaatikko nähdäksesi tarkastushistorian, linkitetyn kokonaisuuden ja säilytystilan. Toiminnallinen näkymä – ei kehyskohtainen – jota järjestelmänvalvojat ja tarkastajat käyttävät tiedostojen etsimiseen ja lajitteluun.',
        files_dashboard: 'Operatiivinen yleiskuvaus tiedostopinnasta: tallennustilan kokonaismäärä, kasvu ajan myötä, orvot liitteet (ei emokokonaisuutta) ja säilytyskäytännön noudattaminen omistajatyypin mukaan. Käytä sitä havaitaksesi käytäntöjen ajautuminen (esim. moduuli, joka säilyttää tiedostot maailmanlaajuisen säilytysikkunan jälkeen) ja budjettitallennustilaan. Toiminnalliset työkalut – ei ole sidottu tiettyyn sääntelykehykseen.',
    },
    framework_rights: {
        be_informed: 'Oikeus saada tietoa',
        consent: 'Oikeus suostumukseen',
        refuse_consent: 'Oikeus kieltäytyä suostumuksesta',
        withdraw_consent: 'Oikeus peruuttaa suostumus',
        access: 'Oikeus saada pääsy tietoihin',
        rectification: 'Oikeus oikaisuun',
        data_provision: 'Oikeus tietojen toimittamiseen',
        deletion: 'Oikeus poistamiseen',
        restriction_of_processing: 'Oikeus käsittelyn rajoittamiseen',
        object_to_processing: 'Oikeus vastustaa käsittelyä',
        complaint: 'Oikeus tehdä valitus',
        denunciation: 'Oikeus ilmiantoon',
        lawsuit: 'Oikeus nostaa kanne',
        claim_damages: 'Oikeus vaatia vahingonkorvausta',
        request_protection_measures: 'Oikeus pyytää suojatoimenpiteitä',
    },
    framework_content: {
        EU_EPRIVACY_DIRECTIVE: {
            display_name: 'Direktiivi 2002/58/EY (sähköisen viestinnän tietosuojadirektiivi)',
            description: 'Päädirektiivi sähköisen viestinnän tietosuojan kansallisesta täytäntöönpanosta. Kattaa evästeet, sähköisen viestinnän tietosuojan ja suoramarkkinoinnin. Jokaisen jäsenvaltion on saatettava osa kansallista lainsäädäntöään.',
        },
        EU_GDPR: {
            display_name: 'Yleinen tietosuoja-asetus (EU) 2016/679',
            description: 'Yleinen tietosuoja-asetus ([[TOK_0]]) on EU:n tietosuoja- ja yksityisyysasetus. Sitä sovelletaan suoraan kaikissa EU/ETA-maissa.',
        },
        EU_NIS2_DIRECTIVE: {
            display_name: 'Direktiivi (EU) 2022/2555 ([[TOK_0]])',
            description: 'Päädirektiivi kansallisille täytäntöönpanotoimille [[TOK_0]]. Kattaa kyberturvallisuusriskien hallinnan, vaaratilanteiden raportoinnin, toimitusketjun turvallisuuden olennaisille ja tärkeille kokonaisuuksille.',
        },
        VN_AI_LAW_2026: {
            display_name: 'Vietnamin [[TOK_0]] laki ([[TOK_1]]) – voimaan 1.3.2026',
            description: 'Vietnamin [[TOK_0]] laki (Luật Trí tuệ nhân tạo [[TOK_2]]), joka säätelee tekoälyjärjestelmien kehitystä, käyttöönottoa ja käyttöä. Perustaa riskiluokitus-, avoimuus- ja merkintävelvollisuudet, vaaratilanteiden raportointivaatimukset, vaikutustenarviointivelvoitteet ja valvotun testausmekanismin (hiekkalaatikko) [[TOK_1]]:n toiminnalle Vietnamissa.',
        },
        VN_AI_DECREE_142_2026: {
            display_name: 'Decree 142/2026/NĐ-CP — [[TOK_0]] Law Implementation',
            description: 'Decree 142/2026/NĐ-CP (Nghị định số 142/2026/NĐ-CP) detailing certain articles and implementing measures of the Vietnam [[TOK_0]] Law (Law 134/2025/QH15). Issued 2026-04-30, effective 2026-05-01. Lead authority: Ministry of Science and Technology. Operationalises [[TOK_0]] risk classification, classification dossier, reclassification review, high-risk conformity assessment, high-risk risk-management system, transparency / explanation / technical marking / visible labeling, serious [[TOK_0]] incident reporting (72h / 5wd / 15d), state-agency [[TOK_0]] impact assessment (Mẫu AI02), and the controlled testing / [[TOK_0]] sandbox lifecycle (Mẫu AI03a-AI09b). Submission via the [[TOK_0]] one-stop e-portal or MoST transitional channel. No statutory fines.',
        },
        VN_CYBERSEC_LAW: {
            display_name: 'Vietnamin kyberturvallisuuslaki (24/2018 aikakausi)',
            description: 'Vietnamin kyberturvallisuuslaki (laki nro [[TOK_0]]), jossa vahvistetaan kyberturvallisuutta, tietojen lokalisointia ja tapahtumaraportointia koskevat vaatimukset. Voimassa, kunnes se korvataan lailla [[TOK_1]] voimassa 2026-07-01.',
        },
        VN_CYBERSEC_DECREE_53: {
            display_name: 'Asetus 53 – Kyberturvallisuuslain täytäntöönpano',
            description: 'Asetus [[TOK_0]] kyberturvallisuuslain täytäntöönpanosta, joka kattaa soveltamisalan määrittämisen, tietojen lokalisoinnin liipaisimet, paikallisen läsnäolon vaatimukset ja viranomaisten yhteistyön työnkulkuja.',
        },
        VN_CYBERSEC_LAW_2025: {
            display_name: 'Kyberturvallisuuslaki ([[TOK_0]])',
            description: 'Vietnamin konsolidoitu kyberturvallisuuslaki (laki [[TOK_0]]), joka korvaa lain [[TOK_1]], voimaan 1.7.2026. Konsolidoidaan asetuksen [[TOK_2]]Đ-CP (katso VN_CYBERSEC_DECREE_53).',
        },
        VN_DATA_LAW: {
            display_name: 'Vietnamin tietolaki',
            description: 'Vietnamin tietolaki (laki [[TOK_0]]), jossa vahvistetaan kattavat tiedonhallintavaatimukset, mukaan lukien tietojen kartoitus, luokittelu, jakamisen hallinta ja rajat ylittävän tiedonsiirron hallinto. Päällekkäinen VN_PDPL_LAW_2025 (henkilötietonäkökohdat) ja VN_CYBERSEC_LAW_2025 (tietojen lokalisointi/luokitus).',
        },
        VN_DATA_LAW_DECREE_165_2025: {
            display_name: 'Asetus [[TOK_0]]Đ-CP (tietolain täytäntöönpano)',
            description: 'Asetus [[TOK_0]]Đ-CP Vietnamin tietolain täytäntöönpanosta (laki [[TOK_1]]). Tarjoaa viralliset lomakkeet rajat ylittävän tiedonsiirron vaikutustenarviointiin, vuotuiseen riskinarviointiraportointiin ja kansalliseen tietokantaan. Määrittää 11 virallista Mẫu số -lomaketta.',
        },
        VN_DATA_EXCHANGES_DRAFT_2026: {
            display_name: 'Datapörssejä koskeva asetusluonnos 2026',
            description: 'Asetusluonnos tiedonvaihtoalustojen toiminnasta (Dự thảo Nghị định quy định về hoạt động của sàn dữ liệu). Säätelee alustan luokittelua, osallistujien kelpoisuutta, datatuotteiden ja palveluiden listauksen hallintaa, hiekkalaatikkotestausta, transaktioiden työnkulkua, sähköistä sopimusta, tietoihin liittyviä omistusoikeuksia koskevia varmenteita ja valitusten/riitojen käsittelyä. Parhaillaan julkisessa kuulemisessa; ei ole vielä julkaistu. Viittaa tietosuojalakiin [[TOK_0]], henkilötietojen suojaa koskevaan lakiin [[TOK_1]], kyberturvalakiin [[TOK_2]] ja lakiin sähköisistä liiketoimista [[TOK_3]].',
        },
        VN_ECOMMERCE_LAW_2025: {
            display_name: 'Sähköistä kaupankäyntiä koskeva laki ([[TOK_0]])',
            description: 'Vietnamin sähköistä kaupankäyntiä koskeva laki (Luật Thương mại điện tử [[TOK_0]]), jolla perustetaan yhtenäinen kansallinen sähköistä kaupankäyntiä koskeva järjestelmä, joka kattaa kotimaiset ja rajat ylittävät alustatoiminnot, alustan hallinnan ja vastuuvelvollisuuden, kuluttajansuojan, myyjien ja sidosryhmien hallinnolliset menettelyt, sisällönkäsittelyn ja sidosyritysten käsittelyn, modeemin ja sidosyritysten käsittelyn valvonnan. valtion sähköisen kaupankäynnin hallintajärjestelmä.',
        },
        VN_PDPL: {
            display_name: 'Vietnam [[TOK_0]] (asetuksen 13/2023 aikakausi)',
            description: 'Vietnamin henkilötietosuojaasetus (asetus [[TOK_0]]), jossa vahvistetaan kattavat tietosuojavaatimukset. Vanhat puitteet – korvataan lailla [[TOK_1]] ja asetuksella [[TOK_2]], voimaan 1.1.2026.',
        },
        VN_PDPD_DECREE_13: {
            display_name: 'Asetus 13 – [[TOK_0]] Toiminnan perusta',
            description: 'Asetus [[TOK_1]], operatiivinen väline [[TOK_0]]:n tehtäviin, mukaan lukien asiakirja-aineiston arkistointi, hallintoartefaktit, rajat ylittävä mekaniikka ja MoPS-hallinnolliset menettelyt. Korvattu asetuksella [[TOK_2]], voimaan 1.1.2026.',
        },
        VN_PDPL_LAW_2025: {
            display_name: 'Henkilötietojen suojalaki ([[TOK_0]])',
            description: 'Vietnamin henkilötietosuojalaki (laki [[TOK_2]]), jolla luodaan kattavat henkilötietojen suojapuitteet, voimaan 1. tammikuuta 2026. Kattaa noudattamisteemat A–J: lailliset käsittelyperusteet, arkaluonteisten tietojen suostumus, rekisteröidyn oikeudet (pääsy/oikaisu/poisto/rajoitus/vastuu/siirrettävyys), rikkomuksen kohteiden ilmoitus viranomaisille ja []-[]kTO]4. käsittely, rajat ylittävän siirron hallinnointi, [[TOK_1]] nimeäminen, tiedot käsittelytoimista, käsittelijän sopimusvelvoitteet. Viranomaisten ilmoitusvelvollisuudet MoPS:n kautta (VN_PDPL_ADMIN_PROCEDURES_778_2026). Ristiviitteet: VN_PDPL_DECREE_356_2025 (täytäntöönpanoasetus), VN_CYBERSEC_LAW_2025 (kyberturvallisuuden päällekkäisyydet), VN_DATA_LAW (tietojen hallinta).',
        },
        VN_PDPL_DECREE_356_2025: {
            display_name: 'Asetus [[TOK_1]] ([[TOK_0]] täytäntöönpano)',
            description: 'Asetus [[TOK_0]] henkilötietojen suojalain täytäntöönpanosta, joka korvaa asetuksen [[TOK_1]]. Kattaa asiakirja-aineiston arkistoinnin, hallintoartefaktit, rajat ylittävän mekaniikan ja palveluntarjoajan sertifioinnin. Liitelomakeluettelo: Phụ lục I–VIII (vaikutusten arviointi, rajat ylittävä siirto, sertifiointi). MoPS-hallinnolliset menettelyt VN_PDPL_ADMIN_PROCEDURES_778_2026:n kautta (päätös 778/QĐ-BCA-A05). Sertifikaatin työnkulku: hakemus → myöntäminen → muutospyyntö → uudelleen myöntäminen → peruutus. Ristiviitteet: VN_PDPL_LAW_2025 (ylälaki), VN_CYBERSEC_LAW_2025 (tietojen lokalisointi), VN_DATA_LAW (tietojen hallinnan päällekkäisyydet).',
        },
        VN_PDPL_ADMIN_PROCEDURES_778_2026: {
            display_name: '[[TOK_0]] A05 hallintomenettelyt (päätös 778/QĐ-BCA-A05)',
            description: 'Päätös 778/QĐ-BCA-A05 (helmikuu 2026) – Henkilötietojen suojaa koskevat hallinnolliset menettelyt kohdassa A05 ([[TOK_0]]). Määrittää asiakirja-aineiston toimittamisen, käsittelyn ja tulosten myöntämismenettelyt, mukaan lukien DLCN-HC-lomakkeet ja Mẫu số lakisääteiset lomakkeet.',
        },
        VN_PDPL_ENFORCEMENT_DRAFT_2026: {
            display_name: 'Täytäntöönpanoasetusluonnos 2026',
            description: 'Luonnos täytäntöönpano- ja seuraamusasetukseksi henkilötietosuojalain (laki [[TOK_0]] rikkomisesta). Määrittää rangaistusalueet, raskauttavat/lieventävät tekijät ja täytäntöönpanomenettelyt. Tällä hetkellä luonnostilassa odottaa julkaisemista.',
        },
        VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: {
            display_name: 'Government Resolution NQ22/2026 — MoPS Administrative Simplification (Temporary Overlay)',
            description: 'Temporary procedural overlay (effective 2026-04-29, expiring 2027-03-01) introducing three official channels (National Public Service Portal, direct submission to MoPS, postal submission to MoPS) for [[TOK_0]] Decree 356/2025 and Decision 778/2026 dossier submissions. Email is NOT a NQ22 official channel — a separate unofficial email-ZIP submission guidance ([[TOK_0]]_GUIDANCE_EMAIL_ZIP_DOSSIER_SUBMISSION_2026) is shipped with requires_legal_review: true. Procedural overlay only — does NOT alter substantive obligations, fine ranges, or the binding force of underlying frameworks. Review task scheduled 2027-02-01.',
        },
        VN_TELECOM_LAW_2023: {
            display_name: 'Vietnamin televiestintälaki 2023',
            description: 'Vietnamin televiestintälaki 2023 (Luật Viễn thông), televiestintä-, Internet-palveluntarjoaja- tai alustayritysten alakohtainen peitto, joka koskee luottamuksellisuutta, tietojen luovuttamista ja viranomaispyyntöjen käsittelyä. Ristiviitteet: VN_CYBERSEC_LAW_2025 (tietojärjestelmän turvallisuus), VN_PDPL_LAW_2025 (käyttäjätietojen käsittely), VN_DATA_LAW (tietojen hallinta).',
        },
        VN_TELECOM_DECREE_163_2024: {
            display_name: 'Asetus [[TOK_0]]Đ-CP (televiestintälain täytäntöönpano)',
            description: 'Asetus [[TOK_0]]Đ-CP televiestintälain täytäntöönpanosta (laki [[TOK_1]]). Tarjoaa viralliset lomakkeet telepalveluilmoitus-, lisensointi-, rekisteröinti- ja datakeskusten kehityssuunnitelmia varten. Määrittää 7 virallista Mẫu số -lomaketta.',
        },
    },
    framework_requirements: {
        d163_r4: {
            title: 'Palvelinkeskuksen kehityssuunnitelman jättäminen',
            description: 'Palvelinkeskusten kehittämissuunnitelmat on toimitettava toimivaltaiselle viranomaiselle asetuksen [[TOK_0]]Đ-CP mukaisesti.',
        },
        d163_r3: {
            title: 'Televiestintäpalvelun rekisteröinti',
            description: 'Telepalvelujen rekisteröinti on tehtävä toimivaltaiselle viranomaiselle määrättyä lomaketta käyttäen.',
        },
        d163_r2: {
            title: 'Telecom-lisenssihakemus',
            description: 'Televiestintätoimilupahakemukset on jätettävä määrätyllä lomakkeella asetuksen [[TOK_0]]Đ-CP mukaisesti.',
        },
        d163_r1: {
            title: 'Ilmoitus tietoliikennepalvelujen tarjoamisesta',
            description: 'Telepalvelujen tarjoajien on ennen palvelun aloittamista ilmoitettava asiasta toimivaltaiselle viranomaiselle määrätyllä lomakkeella.',
        },
        vn_dp_draft_f: {
            title: 'Valitukset, riidat ja riskienhallinta',
            description: 'Alustan operaattoreiden on tarjottava valitusten käsittely, riitojen käsittelyn työnkulku todisteiden säilyttämisellä, riskien tunnistaminen ja varhaisvaroitushallinta sekä yksityisyyden, kyberturvallisuuden ja pääsyn hallinnan riskien säännöllinen tarkastelu.',
        },
        vn_dp_draft_e: {
            title: 'Transaktion työnkulku ja todistus omistusoikeuksista tiedoille',
            description: 'Tapahtumat edellyttävät tilin rekisteröintiä, listauksen hyväksymistä, sähköistä sopimusta, maksuvahvistusta, toimitustietuetta ja tarvittaessa tietojen omistusoikeustodistuksen myöntämistä. Tapahtumahistoria ja jäljitettävyys on säilytettävä tapahtumarekisterissä.',
        },
        vn_dp_draft_d: {
            title: 'Hiekkalaatikon ja testausympäristön hallintalaitteet',
            description: 'Testiympäristöt on eristettävä, niihin on pääsy rajoitettu, niitä on valvottava ja tarkastettava ennen tulosteen purkamista. Testiympäristöstä ei saa poimia lähdetietoja, ja testiistuntojen sulkeminen/siivoaminen on tallennettava.',
        },
        vn_dp_draft_c: {
            title: 'Tietojen tuote- ja palveluluettelon hallinta',
            description: 'Tietojen tueksi on esitettävä todisteet laillisista lähteistä ja omistus-/käyttöoikeuksista, tekniset validointitietueet, laatutiedot ja alustan puolen listauksen tarkistus- ja hyväksyntitietueet. Kielletyt tiedot on suodatettava ennen listaamista.',
        },
        vn_dp_draft_b: {
            title: 'Osallistumiskelpoisuus ja osallistuminen',
            description: 'Alustan ylläpitäjien on tarkistettava myyjien ja ostajien oikeudellinen asema, oikeuskelpoisuus ja ehdolliset liiketoimintavaatimukset, rekisteröitävä tapahtuma- ja maksutilit ja ylläpidettävä osallistujarekisteriä.',
        },
        vn_dp_draft_a: {
            title: 'Tietoalustan luokitus ja toimintamalli',
            description: 'Alustan operaattoreiden on luotava alustatyypin luokitus (kansallinen tietoalusta vs. muut tietoalustat), määriteltävä operaattorin kelpoisuus ja vastuut sekä dokumentoitava hinnoittelu, maksut, toimintasäännöt ja tekninen hallinto.',
        },
        d165_r5: {
            title: 'Pääsy kansallisiin tietokantoihin',
            description: 'Valtakunnallisen digitaalisen tietokannan tietojen poimia/käyttöä koskevat pyynnöt käyttävät määrättyjä lomakkeita (Mẫu số 07a/07b).',
        },
        d165_r4: {
            title: 'Vuotuinen riskinarviointiraportti',
            description: 'Vuotuiset riskinarviointiraportit on laadittava määrätyillä lomakkeilla (Mẫu số 05a/05b, 06).',
        },
        d165_r3: {
            title: 'Ilmoitus rajat ylittävän siirron irtisanomisesta',
            description: 'Rajat ylittävän siirron päättymisestä on ilmoitettava määrätyillä lomakkeilla (Mẫu số 04a/04b).',
        },
        d165_r2: {
            title: 'Ilmoitus arvioinnin tuloksista',
            description: 'Viranomaiset antavat arvioinnin tulosilmoitukset määrätyllä lomakkeella (Mẫu số 03).',
        },
        d165_r1: {
            title: 'Rajat ylittävän tiedonsiirron vaikutustenarvioinnin arkistointi',
            description: 'Organisaatioiden on toimitettava rajat ylittävän tiedonsiirron/käsittelyn vaikutustenarviointiasiakirjat määrätyillä lomakkeilla (Mẫu số 01a/01b, 02).',
        },
        a964190d_8d1d_4284_bc7d_4023e2866751: {
            title: 'Suostumus evästeille ja vastaaville teknologioille',
            description: 'Tietojen tallentaminen tai niihin pääsy päätelaitteessa on sallittu vain ennakkoon ilmoitettuun suostumukseen, lukuun ottamatta teknisesti tarpeellista tallennusta.',
        },
        '8437d96d_cf01_4f87_89f6_4faaf8eefdf6': {
            title: 'Viestinnän luottamuksellisuus',
            description: 'Jäsenvaltioiden on varmistettava yleisen viestintäverkon ja yleisesti saatavilla olevien sähköisten viestintäpalvelujen avulla tapahtuvan viestinnän ja siihen liittyvien liikennetietojen luottamuksellisuus.',
        },
        c5420073_50c6_4981_816a_398460e5f546: {
            title: 'Suostumus suoramarkkinointiin (opt-in)',
            description: 'Sähköisten viestintäjärjestelmien käyttö suoramarkkinointiin edellyttää tilaajan ennakkosuostumusta.',
        },
        c8bf67d2_874b_4647_92d7_39aaa3230819: {
            title: 'Pehmeä opt-in olemassa oleville asiakkaille',
            description: 'Samankaltaisten tuotteiden/palveluiden suoramarkkinointi olemassa oleville asiakkaille on sallittua ilman suostumusta, jos kieltäydytään.',
        },
        b546df40_9217_4204_b71c_5af5022a0ff9: {
            title: 'Rikkomusilmoitus teleoperaattoreille',
            description: 'Yleisesti saatavilla olevien sähköisten viestintäpalvelujen tarjoajien on ilmoitettava toimivaltaiselle kansalliselle viranomaiselle henkilötietojen tietoturvaloukkauksista.',
        },
        '5bd66ae4_dee3_4611_9104_71742df55484': {
            title: 'Oikeus vastustaa suoramarkkinointia',
            description: 'Tilaajille on annettava mahdollisuus milloin tahansa ja maksutta vastustaa suoramarkkinointiviestien vastaanottamista.',
        },
        a10af31f_ba28_494e_ab50_f8679e86a0b0: {
            title: 'Liikennetietojen säilyttäminen ja poistaminen',
            description: 'Tilaajia ja käyttäjiä koskevat liikennetiedot on poistettava tai tehtävä anonyymeiksi, kun niitä ei enää tarvita siirtoon, lukuun ottamatta laskutusta tai yhteenliittämismaksuja.',
        },
        '8577e60f_66a8_4651_8336_d561db9929ad': {
            title: 'Sijaintitietojen käsittelyehdot',
            description: 'Muita sijaintitietoja kuin liikennetietoja voidaan käsitellä vain anonyymeiksi tehtyinä tai käyttäjän suostumuksella, siinä laajuudessa ja niin kauan kuin se on tarpeellista.',
        },
        '7f3abb41_8713_4276_93b5_6902f419a016': {
            title: 'Käsittelyn laillisuus – suostumus',
            description: 'Käsittely on laillista vain, jos rekisteröity on antanut suostumuksensa henkilötietojensa käsittelyyn yhtä tai useampaa erityistä tarkoitusta varten.',
        },
        '1c2a945a_8eac_428d_8105_e80e95288ea4': {
            title: 'Käsittelyn laillisuus – sopimus',
            description: 'Käsittely on tarpeen sellaisen sopimuksen täyttämiseksi, jonka osapuoli rekisteröity on.',
        },
        '2b50c0fb_ee96_412e_a092_c3c1f3f817e8': {
            title: 'Käsittelyn laillisuus — lakisääteinen velvoite',
            description: 'Käsittely on välttämätöntä rekisterinpitäjän lakisääteisen velvoitteen noudattamiseksi.',
        },
        '702ea760_9e5c_4c32_babc_0b5094ca9735': {
            title: 'Käsittelyn laillisuus – elintärkeät edut',
            description: 'Käsittely on tarpeen rekisteröidyn tai muun luonnollisen henkilön elintärkeiden etujen suojaamiseksi.',
        },
        '8b55ce88_2d5e_467b_a55c_8c5b0efab67e': {
            title: 'Käsittelyn laillisuus – yleinen etu',
            description: 'Käsittely on tarpeen yleisen edun mukaisen tehtävän suorittamiseksi tai julkista valtaa käytettäessä.',
        },
        '8a72dd16_ee3c_4947_b5cd_9484719adad8': {
            title: 'Käsittelyn laillisuus – oikeutetut edut',
            description: 'Käsittely on tarpeen rekisterinpitäjän tai kolmannen osapuolen oikeutettujen etujen toteuttamiseksi.',
        },
        afefc965_8f83_4d75_a9fc_92d4d4f549d6: {
            title: 'Erityisluokkien käsittely (arkaluonteiset tiedot)',
            description: 'Erityisten henkilötietojen (rotuperä, poliittiset mielipiteet, terveys jne.) käsittely on kiellettyä, ellei Art. 9(2) täyttyvät.',
        },
        '10a2d63f_744d_4222_91f6_86a5a4cdaefd': {
            title: 'Suostumuksen edellytykset',
            description: 'Rekisterinpitäjän on osoitettava, että suostumus on annettu. Suostumus on annettava vapaasti, täsmällinen, tietoinen ja yksiselitteinen. Peruuttamisen tulee olla yhtä helppoa kuin suostumuksen antaminen.',
        },
        '27697f99_efef_49e6_b8e7_c2dc550d1791': {
            title: 'Lapsen suostumus – digitaaliset palvelut',
            description: 'Alle 16-vuotiaan (tai jäsenvaltion asettaman alemman iän, ei alle 13-vuotiaan) lapsen henkilötietojen käsittely edellyttää vanhemman suostumusta tietoyhteiskunnan palveluihin.',
        },
        '53883480_508e_4f8e_984f_9354c18de285': {
            title: 'Läpinäkyvä tiedotus ja viestintä',
            description: 'Rekisterinpitäjän on annettava käsittelyyn liittyvät tiedot tiiviissä, läpinäkyvässä, ymmärrettävässä ja helposti saatavilla olevassa muodossa.',
        },
        b5eb22b7_78f2_4c55_b342_827d5f8ac90c: {
            title: 'Tiedot suoraa keräystä varten',
            description: 'Jos rekisteröidyltä kerätään henkilötietoja, rekisterinpitäjän on annettava tietyt tiedot keräyksen yhteydessä.',
        },
        e55f7dbf_cd2a_4713_887e_8c64744e2d95: {
            title: 'Tietoja epäsuoraan keräämiseen',
            description: 'Jos henkilötietoja ei ole saatu rekisteröidyltä, rekisterinpitäjän on annettava tietyt tiedot kohtuullisessa ajassa.',
        },
        '6bc5ec07_0589_4593_882a_13f41c31e1f6': {
            title: 'Käyttöoikeus',
            description: 'Rekisteröidyllä on oikeus saada vahvistus käsittelystä sekä pääsy henkilötietoihin ja lisätietoihin.',
        },
        '0e011e25_dcea_4a1e_ae55_583e683cea44': {
            title: 'Oikeus oikaisuun',
            description: 'Rekisteröidyllä on oikeus saada virheelliset henkilötiedot oikaistaan ilman aiheetonta viivytystä.',
        },
        e8ec5a55_f657_4a99_9b92_3e9861067d28: {
            title: 'Oikeus poistaa (oikeus tulla unohdetuksi)',
            description: 'Rekisteröidyllä on oikeus vaatia henkilötietojensa poistamista ilman aiheetonta viivytystä, jos siihen on erityisiä syitä.',
        },
        '5b0c92fd_cd08_47be_bfd2_0540ad73f84f': {
            title: 'Oikeus käsittelyn rajoittamiseen',
            description: 'Rekisteröidyllä on oikeus saada käsittelyn rajoitus tietyin edellytyksin.',
        },
        '3b829862_39f4_41be_8f2b_d469469a801b': {
            title: 'Ilmoitusvelvollisuus – oikaisu/poistaminen/rajoitus',
            description: 'Rekisterinpitäjä ilmoittaa kaikista oikaisuista, poistoista tai rajoituksista jokaiselle vastaanottajalle, jolle tietoja on luovutettu.',
        },
        '9cf34be6_121b_4fdf_ad7c_c4773696522e': {
            title: 'Oikeus tietojen siirrettävyyteen',
            description: 'Rekisteröidyllä on oikeus saada henkilötietonsa jäsennellyssä, yleisesti käytetyssä, koneellisesti luettavassa muodossa.',
        },
        becae433_90b9_4cc0_bd33_df50976c1561: {
            title: 'Oikeus vastustaa',
            description: 'Rekisteröidyllä on oikeus vastustaa yleiseen etuun tai oikeutettuihin etuihin perustuvaa käsittelyä, mukaan lukien profilointi.',
        },
        '4ef387f1_439c_4579_82a3_01565e6dc05d': {
            title: 'Automatisoitu yksilöllinen päätöksenteko, mukaan lukien profilointi',
            description: 'Rekisteröidyllä on oikeus olla joutumatta sellaisen päätöksen kohteeksi, joka perustuu yksinomaan automaattiseen käsittelyyn ja jolla on oikeudellisia tai vastaavia merkittäviä vaikutuksia.',
        },
        '667ae5eb_a39a_4809_a032_923cc804eaed': {
            title: 'Rikkomusilmoitus valvontaviranomaiselle (72h)',
            description: 'Tietoturvaloukkauksesta rekisterinpitäjän on ilmoitettava siitä valvontaviranomaiselle 72 tunnin kuluessa tietoonsa saamisesta, ellei siitä todennäköisesti aiheudu riskiä.',
        },
        '40e4c2ad_bc85_436c_814f_265f02c8c3b1': {
            title: 'Rikkomusilmoitus rekisteröidyille (suuri riski)',
            description: 'Jos loukkaus todennäköisesti aiheuttaa suuren riskin oikeuksille ja vapauksille, rekisterinpitäjän on ilmoitettava loukkauksesta rekisteröidylle ilman aiheetonta viivytystä.',
        },
        '9dbb47bd_172f_4335_b7f3_4558476c4192': {
            title: 'Rekisteröityjen pyyntöihin vastaaminen (30 päivää)',
            description: 'Rekisterinpitäjä vastaa rekisteröityjen pyyntöihin ilman aiheetonta viivytystä ja kuukauden kuluessa vastaanottamisesta, jota voidaan jatkaa kahdella kuukaudella monimutkaisissa pyynnöissä.',
        },
        '175d16b7_a0fc_44ff_bb9e_5ccb5d3de5a9': {
            title: 'Tietosuojavaikutusten arviointi',
            description: 'Jos käsittely todennäköisesti johtaa suureen riskiin oikeuksille ja vapauksille, rekisterinpitäjän on suoritettava [[TOK_0]] ennen käsittelyä.',
        },
        e54a7b09_33dd_4cda_8e21_d10a51e5e925: {
            title: 'Ennakkoneuvottelut valvontaviranomaisen kanssa',
            description: 'Rekisterinpitäjän on kuultava valvontaviranomaista, jos [[TOK_0]] osoittaa, että käsittely johtaisi suureen riskiin ilman lieventäviä toimenpiteitä.',
        },
        '047b7838_bae5_4861_9c38_c99fedec9c96': {
            title: '[[TOK_0]] pakollinen käsittelyluettelo',
            description: '[TOK_0]] tarvitaan systemaattiseen arviointiin/profilointiin, erityisluokkien laajamittaiseen käsittelyyn ja yleisten alueiden järjestelmälliseen seurantaan.',
        },
        aa08dc83_7c1a_441d_a8e7_960f65c8de87: {
            title: 'Käsittelytoimia koskevat tiedot (rekisterinpitäjä)',
            description: 'Jokaisen rekisterinpitäjän on pidettävä kirjaa vastuullaan olevista käsittelytoimista, mukaan lukien tarkoitukset, luokat, vastaanottajat, siirrot ja säilyttäminen.',
        },
        b7eb6296_5962_449c_b267_d322d7919122: {
            title: 'Käsittelytoimia koskevat tiedot (käsittelijä)',
            description: 'Jokaisen käsittelijän on pidettävä kirjaa kaikista rekisterinpitäjän puolesta suoritetuista käsittelytoimista.',
        },
        '0d57e6d5_bbf5_4ea6_9a89_0f57bed61b5b': {
            title: 'Käsittelyn turvallisuus',
            description: 'Rekisterinpitäjän ja käsittelijän on toteutettava asianmukaiset tekniset ja organisatoriset toimenpiteet riskiin sopivan turvallisuuden varmistamiseksi.',
        },
        ad85edfc_3c92_4ce4_a414_3ba6186cae98: {
            title: 'Tietosuoja on suunniteltu ja oletusarvoisesti',
            description: 'Rekisterinpitäjä toteuttaa asianmukaiset toimenpiteet sen varmistamiseksi, että vain kuhunkin tiettyyn tarkoitukseen tarpeellisia henkilötietoja käsitellään (tietojen minimointi).',
        },
        '933b438d_53b8_4b6a_b1db_8e7f1b429ede': {
            title: 'Tietosuojavastaavan nimitys',
            description: 'Rekisterinpitäjän ja henkilötietojen käsittelijän on nimettävä [[TOK_0]], jos käsittely on viranomaisen suorittamaa, säännöllistä ja järjestelmällistä seurantaa tai erityisluokkien laajamittaista käsittelyä.',
        },
        '28810a5d_d818_411a_9e8c_792d1b2c9b2f': {
            title: 'Siirtojen yleinen periaate',
            description: 'Henkilötietojen siirto kolmanteen maahan saa tapahtua vain, jos V luvun ehtoja noudatetaan.',
        },
        '60add64b_bb0c_44e7_baaf_666af65b2d0f': {
            title: 'Siirrot riittävyyspäätöksen perusteella',
            description: 'Siirto voi tapahtua, jos komissio on päättänyt, että kolmas maa takaa riittävän suojelun tason.',
        },
        cde8c7cd_3727_40ce_a321_e6b72b335179: {
            title: 'Siirrot asianmukaisin suojatoimin',
            description: 'Jos riittävyyttä koskevaa päätöstä ei ole tehty, siirrot voivat tapahtua, jos asianmukaisia suojatoimia tarjotaan, mukaan lukien SCC:t tai BCR:t.',
        },
        '0e8edaa1_2156_44d9_95f2_1b284f581658': {
            title: 'Vakiosopimuslausekkeet',
            description: 'Komission tai valvontaviranomaisen hyväksymät vakiosopimuslausekkeet tarjoavat asianmukaiset takeet kansainvälisille siirroille.',
        },
        '608a8de7_6c75_4f88_bd4c_1cc308780ab9': {
            title: 'Yrityksen sitovat säännöt',
            description: 'Toimivaltaisen valvontaviranomaisen hyväksymät sitovat yrityssäännöt tarjoavat asianmukaiset suojat konsernin sisäisille kansainvälisille siirroille.',
        },
        '420ced80_0d3b_4a28_adad_14ba54df3e40': {
            title: 'Poikkeukset erityistilanteita varten',
            description: 'Riittävyyden tai takeiden puuttuessa siirrot voivat tapahtua nimenomaisen suostumuksen, sopimuksen välttämättömyyden, yleisen edun, oikeudellisten vaatimusten, elintärkeiden etujen tai julkisen rekisterin perusteella.',
        },
        c86fbc0d_7188_486c_8ea5_96b3fe957c6f: {
            title: 'Hallintoelimen vastuu ja koulutus',
            description: 'Olennaisten ja tärkeiden yksiköiden johtoelinten tulee hyväksyä kyberturvallisuuden riskienhallintatoimenpiteet ja käydä säännöllisesti koulutusta.',
        },
        ffb95a09_993c_4db0_a4bb_c48000e43b33: {
            title: 'Kyberturvallisuuden riskienhallintatoimenpiteet',
            description: 'Olennaisten ja tärkeiden tahojen on toteutettava asianmukaiset ja oikeasuhteiset tekniset, toiminnalliset ja organisatoriset toimenpiteet kyberturvallisuusriskien hallitsemiseksi.',
        },
        '6a7c8c8f_4b81_4b47_adb7_c6abd12acd4b': {
            title: 'Tapahtumankäsittelykäytännöt ja -menettelyt',
            description: 'Yhteisöjen on otettava käyttöön vaaratilanteiden käsittelyä koskevat käytännöt, mukaan lukien havaitsemis-, analysointi-, eristys- ja reagointimenettelyt.',
        },
        de019eab_9992_4361_be7c_3e592f209d76: {
            title: 'Liiketoiminnan jatkuvuus ja kriisinhallinta',
            description: 'Yhteisöjen tulee toteuttaa toiminnan jatkuvuustoimenpiteitä, mukaan lukien varmuuskopiointi, katastrofipalautus ja kriisinhallinta.',
        },
        '6b5f482f_301c_4f69_bd91_f9ae1b21de6c': {
            title: 'Toimitusketjun turvallisuus',
            description: 'Yhteisöjen on käsiteltävä turvallisuuteen liittyviä näkökohtia suhteissa suorien toimittajien ja palveluntarjoajien kanssa, mukaan lukien toimitusketjun riskinarvioinnit.',
        },
        c8e7738b_358c_4c79_9fc2_a564f15a6e37: {
            title: 'Tietoturva verkko- ja tietojärjestelmissä',
            description: 'Yhteisöjen tulee toteuttaa tietoturva verkko- ja tietojärjestelmien hankinnassa, kehittämisessä ja ylläpidossa, mukaan lukien haavoittuvuuksien käsittely.',
        },
        '72520ed1_51ff_4983_a785_9be1f72cf7dd': {
            title: 'Haavoittuvuuden käsittely ja paljastaminen',
            description: 'Yhteisöjen on otettava käyttöön politiikkaa ja menettelyjä haavoittuvuuden koordinoitua paljastamista ja käsittelyä varten.',
        },
        f009e65d_d55e_4c98_9532_63c150694698: {
            title: 'Kyberturvallisuusriskien arvioinnin tehokkuus',
            description: 'Yhteisöjen on otettava käyttöön politiikkaa ja menettelyjä kyberturvallisuuden riskienhallintatoimenpiteiden tehokkuuden arvioimiseksi.',
        },
        '00e88824_675d_4b37_960c_757b3176c079': {
            title: 'Salaus- ja salauskäytännöt',
            description: 'Yhteisöjen on otettava käyttöön kryptografian ja tarvittaessa salauksen käyttöä koskevat periaatteet ja menettelyt.',
        },
        de29d287_81f1_46b1_b327_9cbf06ddad3d: {
            title: 'HR turvallisuus, kulunvalvonta, omaisuudenhallinta',
            description: 'Yksiköt toteuttavat henkilöstöturvallisuutta, kulunvalvontakäytäntöjä ja omaisuudenhallintaa.',
        },
        '750f4459_9ba4_415e_bc47_5b0ec27d35a2': {
            title: 'Monivaiheinen todennus',
            description: 'Yksiköiden on käytettävä monitekijätodennus- tai jatkuvatodennusratkaisuja, suojattua ääni-/video-/tekstiviestintää ja suojattuja hätäviestintäjärjestelmiä.',
        },
        '359474f9_1820_4e3e_9031_a593b66ccde4': {
            title: 'Varhainen varoitus CSIRT:lle (24h)',
            description: 'Yhteisöjen on annettava toimivaltaiselle CSIRT:lle ennakkovaroitus 24 tunnin kuluessa siitä, kun ne ovat havainneet merkittävän tapahtuman.',
        },
        '66acd92c_3091_4148_b935_68b0d24308e7': {
            title: 'Tapahtumailmoitus CSIRT:lle (72h)',
            description: 'Yhteisöjen on toimitettava vaaratilanteesta ilmoitus toimivaltaiselle CSIRT:lle 72 tunnin kuluessa siitä, kun ne ovat havainneet merkittävän vaaratilanteen.',
        },
        '68269688_06b2_43ea_8e3e_a84532086557': {
            title: 'Loppuraportti CSIRT:lle (1 kuukausi)',
            description: 'Yhteisöjen on toimitettava loppuraportti toimivaltaiselle CSIRT:lle viimeistään kuukauden kuluttua tapahtumailmoituksesta.',
        },
        c8512bde_b064_4926_b333_06b9c95cecd7: {
            title: 'Soveltuvuuden määrittäminen [[TOK_0]]:n toimiin',
            description: 'Selvitä, harjoittaako organisaatio [[TOK_0]] Vietnamin [[TOK_1]] lain alaista toimintaa ja dokumentoi sovellettavuuspäätös.',
        },
        '3a87ad63_179a_45ba_8743_98d865df80ab': {
            title: '[[TOK_0]] järjestelmän riskiluokitus riskitason mukaan',
            description: 'Luokittele jokainen [[TOK_0]]-järjestelmä riskitason mukaan (minimaalinen, rajoitettu, korkea, ei-hyväksyttävä) käyttämällä ohjattua luokitusmenetelmää.',
        },
        '0f4475d3_77a6_4b41_bfe2_d4b299b1bd45': {
            title: '[[TOK_0]] Järjestelmärekisterin merkintöjen ylläpito',
            description: 'Ylläpidä [[TOK_0]]-järjestelmien rekisteriä, jossa on järjestelmän nimi, omistaja, tarkoitus, käyttöönottokonteksti, riskitaso ja toimittajan osallistuminen.',
        },
        '2a73ce94_906a_4c95_8a45_a5bdf2a8118c': {
            title: '[[TOK_0]] Järjestelmäaineisto, jossa on esineiden tarkistuslista ja todisteita',
            description: 'Rakenna ja ylläpidä järjestelmäaineistoa, joka sisältää vaaditun artefaktien tarkistuslistan, todistekirjaston ja versiohistorian.',
        },
        e92cfb42_d91b_444f_adbc_c03903844eac: {
            title: 'Avoimuusvelvoitteet [[TOK_0]] verkonhaltijoille',
            description: 'Toteuta avoimuustoimenpiteitä [[TOK_0]]-järjestelmille, mukaan lukien käyttäjäilmoitukset, [TOK_1]] osallistumisen paljastaminen ja järjestelmädokumentaatio.',
        },
        '45eb43d7_9b63_4166_aa0d_fa6aeeaa70ba': {
            title: '[[TOK_0]] tulosten merkitseminen, vesileima ja metatietojen allekirjoitus',
            description: 'Ota [[TOK_0]]:n luomalle sisällölle merkitseminen ja vesileima, mukaan lukien metatietojen allekirjoitus tarvittaessa.',
        },
        '9566c94d_0dd3_419c_869f_6707d2a972f9': {
            title: '[[TOK_0]]:n luoman sisällön paljastamisvaatimukset',
            description: 'Ilmoita käyttäjille, kun sisältö on [[TOK_0]] luomaa, ja tarjoa käyttäjille mekanismeja [[TOK_1]]in osallistumisen tunnistamiseen.',
        },
        '21d39ea5_df78_45c6_8710_b203db229e25': {
            title: 'Selittävyys ja käyttäjäkohtaiset läpinäkyvyystehtävät',
            description: 'Tarjoa selitettäviä tuloksia [[TOK_0]] päätöksille, jotka vaikuttavat yksilöihin, ja ylläpidä käyttäjille suunnattua avoimuusdokumentaatiota.',
        },
        f523fbc2_156d_466d_ad50_6a0c51b3ac9d: {
            title: 'Ihmisten valvontavelvollisuudet korkean riskin [[TOK_0]] järjestelmissä',
            description: 'Varmista, että riskialttiille [[TOK_0]]-järjestelmille on olemassa ihmisen valvontamekanismit, mukaan lukien eskalointi- ja ohitusominaisuudet.',
        },
        bd180a89_4976_4790_9e50_f1c5c97dc576: {
            title: '[[TOK_0]] tapahtumien valvonta ja havaitseminen',
            description: 'Ota käyttöön valvontaominaisuudet havaitaksesi [[TOK_0]] järjestelmähäiriöt, toimintahäiriöt ja haitalliset seuraukset.',
        },
        e7c1c60b_856c_4d3d_b6c9_092cde9b56bd: {
            title: 'Vakavan [[TOK_0]] tapauksen ilmoittaminen viranomaisille',
            description: 'Ilmoita vakavista [[TOK_0]] vaaratilanteista toimivaltaiselle viranomaiselle säädetyn ajan (72 tunnin) kuluessa.',
        },
        '97f15adc_558a_49f2_bb06_86597cb9579b': {
            title: '[[TOK_0]] tapausilmoitusten aikataulun noudattaminen',
            description: 'Noudata [[TOK_0]]-tapahtumien ilmoitusaikatauluja, mukaan lukien alustavat ilmoitukset, päivitykset ja sulkemisraportit.',
        },
        '96c33d7e_fe52_4730_adac_70c8c477c88e': {
            title: '[[TOK_0]] vaikutustenarviointi korkean riskin järjestelmistä',
            description: 'Tee vaikutustenarviointeja suuririskisille [[TOK_0]]-järjestelmille, jotka kattavat riskit, lieventämiset, inhimillisen valvonnan ja seurantasuunnitelmat.',
        },
        '0f3b72c0_1030_44ff_ba53_596f45601cd7': {
            title: 'Kontrolloitu testaus / hiekkalaatikkokelpoisuuden määrittäminen',
            description: 'Selvitä kelpoisuus kontrolloituun testaukseen (hiekkalaatikkoon) ja dokumentoi kelpoisuusarviointi.',
        },
        '4a6aed20_f655_4182_a760_aef1f329d5df': {
            title: 'Sandbox-hakemusten jättämisen ja hyväksynnän seuranta',
            description: 'Lähetä hiekkalaatikkohakemukset toimivaltaiselle viranomaiselle ja seuraa hyväksynnän tilaa toimituksen elinkaaren ajan.',
        },
        '8376988d_cd32_491e_a5b8_3340d3973358': {
            title: 'Hiekkalaatikon valvontapisteet ja valmistuminen/poistuminen',
            description: 'Suorita säännöllisiä seurantatarkastuksia hiekkalaatikkoon osallistumisen aikana ja valmistele valmistumis-/poistumisraportit.',
        },
        '7cb2b544_0512_4702_a092_9f1c10872376': {
            title: 'Poikkeus-/poikkeusasiakirjojen merkitseminen perusteluineen',
            description: 'Dokumentoi kaikki merkintöjä koskevat poikkeukset ja perustelut ja todisteet.',
        },
        dccd7fbf_872a_4716_87a4_b9c5ce8e2387: {
            title: 'Tietojen lokalisointi vietnamilaisille käyttäjille',
            description: 'Vietnamilaisten käyttäjien tiedot Vietnamissa tarjotuista palveluista on säilytettävä Vietnamin alueella.',
        },
        '9eb86a03_e165_4963_8813_2272b638d529': {
            title: 'Kyberturvallisuustapahtumien raportointi',
            description: 'Kyberturvallisuushäiriöistä on ilmoitettava toimivaltaisille viranomaisille hyvissä ajoin.',
        },
        '736ac7de_7a6a_4bfd_b2be_c594e290038a': {
            title: 'Tietojärjestelmän luokitus',
            description: 'Tietojärjestelmät on luokiteltava tärkeysasteen mukaan ja sovellettava asianmukaisia ​​turvatoimia.',
        },
        ffb807cf_f121_4b52_8e50_e091c33180c9: {
            title: 'Kyberturvallisuusriskien arviointi',
            description: 'Tietojärjestelmille on tehtävä säännöllisiä kyberturvallisuusriskien arviointeja.',
        },
        a4de518b_a5f1_481f_9b08_f8d2bc9db7e5: {
            title: 'Soveltamisalan määritys (päätöspuu)',
            description: 'Organisaatioiden on määritettävä määrätyn päätöspuun avulla, kuuluvatko ne asetuksen 53 soveltamisalaan.',
        },
        '01f99e9a_5e30_4d14_aae5_a2ce322a700b': {
            title: 'Tietojen lokalisoinnin arviointi ja valmius',
            description: 'Organisaatioiden on arvioitava tietojen lokalisointivaatimukset ja osoitettava valmius.',
        },
        cf24f011_dc23_4d84_aef5_994dde440571: {
            title: 'Varastointi- ja säilytysvalmiuden tarkistuslista',
            description: 'Tallennus- ja säilytysvalmiuden tarkistuslista on täytettävä tietojen lokalisoinnin vaatimustenmukaisuuden varmistamiseksi.',
        },
        b3884cb8_c785_4258_9517_9e393be4f4e1: {
            title: 'Paikallinen läsnäolovaatimuksen arviointi',
            description: 'Organisaatioiden on arvioitava, sovelletaanko paikallisia läsnäolovaatimuksia, ja suunnitella niiden mukaisesti.',
        },
        c1dc645b_cb1a_42a6_8ca5_9b15cfa84156: {
            title: 'Viranomaiset pyytävät vastaanottoa ja vahvistusta',
            description: 'Viranomaisten pyynnöt on vastaanotettava, tarkistettava ja käsiteltävä määrättyjen menettelyjen mukaisesti.',
        },
        d4571651_f39d_4c51_8f2d_7248c37f7b14: {
            title: 'Viranomainen pyytää vastausta määräajassa',
            description: 'Viranomaisten pyyntöihin on vastattava säädetyssä määräajassa.',
        },
        '66c1df70_3456_40e9_b645_6c6bd3be702e': {
            title: 'Viranomaisten pyyntöjen käsittelyloki',
            description: 'Kaikista viranomaispyyntöjen käsittelytoimista on pidettävä lokia.',
        },
        '04bbba2a_9804_4199_a517_054b6f4689fb': {
            title: 'Soveltuvuus ja soveltamisalan määrittäminen (konsolidoitu)',
            description: 'Organisaatioiden on selvitettävä, kuuluvatko ne konsolidoidun kyberturvallisuuslain soveltamisalaan, joka kattaa sekä vanhan lain 24/2018 että asetuksen 53/2022.',
        },
        '89a21eaf_cf09_4fec_bbb4_a1dadd652f6e': {
            title: 'Tietojärjestelmän luokittelu tärkeystason mukaan',
            description: 'Tietojärjestelmät on luokiteltava tärkeysasteen mukaan (yleinen, tärkeä, kriittinen) ja vastaavat turvallisuusvelvoitteet.',
        },
        '83ad981e_23ff_4a92_bebd_cd24487e912f': {
            title: 'Kyberturvallisuuden hallintorakenne ja vastuullinen henkilöstö',
            description: 'Organisaatioiden on perustettava kyberturvallisuuden hallintorakenteet ja nimettävä vastuuhenkilöt.',
        },
        '98d9a523_fefb_400b_bb7f_ebaf609a6ed4': {
            title: 'Säännöllinen kyberturvallisuusriskien arviointi',
            description: 'Kaikille turvaluokiteltuille tietojärjestelmille on tehtävä säännöllisiä kyberturvallisuusriskien arviointeja.',
        },
        '5236539f_4c1a_4eff_b2eb_fc11eb4eab23': {
            title: 'Turvatoimenpiteet tietojärjestelmän luokituksen mukaan',
            description: 'Teknisiä turvatoimenpiteitä tulee soveltaa kunkin tietojärjestelmän luokitustason mukaisesti.',
        },
        b69a8be2_ae0c_408c_b8f1_73b573eca876: {
            title: 'Kulunvalvonta ja identiteetin hallinta',
            description: 'Tietojärjestelmiin tulee ottaa käyttöön kulunvalvonta- ja identiteetinhallintatoimenpiteet.',
        },
        ac774c26_feb7_4123_b799_c54f77bd87b5: {
            title: 'Kirjaaminen, seuranta ja kirjausketju',
            description: 'Tietojärjestelmien on ylläpidettävä kirjaus-, seuranta- ja kirjausketjuominaisuudet.',
        },
        a86cb01d_239b_44e2_9e09_e6973bcf9658: {
            title: 'Haavoittuvuuksien hallinta ja korjaus',
            description: 'Haavoittuvuuksien hallinta- ja korjausprosessit on perustettava ja ylläpidettävä.',
        },
        '826a789f_0c03_4918_81a1_6aa1cc2c205c': {
            title: 'Vietnamilaisten käyttäjien tietojen lokalisointi',
            description: 'Vietnamilaisten käyttäjien tiedot Vietnamissa tarjotuista palveluista on säilytettävä Vietnamin alueella.',
        },
        '8bee2b51_ace8_4118_89c8_010b96640016': {
            title: 'Paikallinen läsnäolovaatimukset ulkomaisille palveluntarjoajille',
            description: 'Vietnamissa toimivien ulkomaisten palveluntarjoajien on ylläpidettävä paikallista läsnäoloa määräysten mukaisesti.',
        },
        '74d89250_b45f_41b6_bfe3_f915071580de': {
            title: 'Paikallinen tallennusarkkitehtuuri ja rajat ylittävän virtauksen dokumentaatio',
            description: 'Paikallinen tallennusarkkitehtuuri on dokumentoitava ja rajat ylittävät tietovirrat on kartoitettava ja ohjattava.',
        },
        '04dec6f8_3280_494c_8506_292804b16d4d': {
            title: 'Kyberturvallisuushäiriöiden havaitseminen ja reagointi',
            description: 'Organisaatioilla on oltava valmiudet havaita kyberturvallisuushäiriöitä ja reagoida niihin.',
        },
        faeda71b_5050_497d_b08b_e3f3f5313ad4: {
            title: 'Pakollinen vaaratilanteesta ilmoittaminen toimivaltaiselle viranomaiselle',
            description: 'Hyväksytyt kyberturvallisuushäiriöt on ilmoitettava osoitteeseen [[TOK_1]]/[[TOK_0]] määrätyissä aikatauluissa.',
        },
        d732b5a2_2b2c_48a0_955d_97a39daf132d: {
            title: 'Tapahtumailmoitusten aikataulun noudattaminen',
            description: 'Tapahtumailmoitusten tulee noudattaa määrättyjä aikatauluvaatimuksia (alkuraportti 24 tunnin sisällä, täydellinen raportti 72 tunnin sisällä).',
        },
        '8e2dffb0_3481_44f0_baf2_130ddd8cfe12': {
            title: 'Viranomaisten pyyntöjen käsittely ja yhteistyö',
            description: 'Viranomaisten pyynnöt on käsiteltävä ripeästi ja yhteistyö on tehtävä määrättyjen menettelyjen mukaisesti.',
        },
        e4c5b870_1d61_48fe_a6c2_1b9f5a458ea3: {
            title: 'Viranomaisten pyyntöjen tapausrekisteri ja tiedonantoloki',
            description: 'Kaikki viranomaisten pyynnöt ja ilmoitukset on kirjattava tapausrekisteriin, jossa on täydellinen kirjausketju.',
        },
        '8eff8b17_65bc_4f94_8ece_c509a9fd9abb': {
            title: 'Toimittajan ja kolmannen osapuolen turvallisuusarviointi',
            description: 'Kolmannen osapuolen toimittajien, joilla on pääsy tietojärjestelmiin, on suoritettava turvallisuusarviointi.',
        },
        '69891e1b_97f6_464c_9cce_b1276794fe4a': {
            title: 'Toimittajan tietojen käyttö- ja tapahtumailmoitusten hallinta',
            description: 'Toimittajan tietojen käyttö on dokumentoitava ja sopimuskohtaiset tapahtumat ilmoittavat velvoitteet.',
        },
        d89b6bc0_7a9e_4816_b31e_7c0abc02e90c: {
            title: 'Turvallisuustietoisuuden koulutus ja harjoitukset',
            description: 'Säännöllisiä kyberturvallisuustietoisuuskoulutuksia ja pöytäharjoituksia on suoritettava.',
        },
        f9c5d3cc_5bb2_4b30_a5fb_ada34e407981: {
            title: 'Säännöllinen kynätesti ja turvatarkastus',
            description: 'Turvaluokiteltuille tietojärjestelmille on suoritettava määräajoin tunkeutumistestejä ja turvatarkastuksia.',
        },
        '88dd9877_d2e2_4e41_a248_ae39b1ff478f': {
            title: 'Ylläpidä digitaalista tietovarastoa',
            description: 'Organisaatioiden on ylläpidettävä kattavaa digitaalista tietovarastoa, joka luetteloi kaikki tietovarat.',
        },
        '18e4bfd1_42cf_4d87_870f_5a34242962ef': {
            title: 'Tietojen luokitus herkkyyden ja tärkeyden mukaan',
            description: 'Tiedot on luokiteltava tietolain määrittelemien herkkyys- ja tärkeystasojen mukaan.',
        },
        b89981ac_7559_46f9_a74c_a143976dde4e: {
            title: 'Määritä käsittelysäännöt luokitustason mukaan',
            description: 'Käsittelysäännöt on vahvistettava kullekin tiedon luokitustasolle.',
        },
        '3bf8019d_b72c_41d7_82cf_fc367efd9526': {
            title: 'Seuraa tietojen jakamista ja luovuttamista hyväksynnöillä',
            description: 'Kaikkea tietojen jakamista ja luovuttamista on seurattava asianmukaisilla hyväksynnöillä.',
        },
        '8623eca2_4cf9_41bd_bfbd_2300c06ca1f3': {
            title: 'Rajat ylittävän tiedonsiirron hallinto',
            description: 'Rajat ylittävän tiedonsiirron on täytettävä tietolain mukaiset hallintovaatimukset.',
        },
        '006b8aa6_9379_4eff_b8ab_935f9a087601': {
            title: 'Säilytä hallintoperiaatteet ja vastuut',
            description: 'Organisaatioiden on ylläpidettävä tiedonhallintakäytäntöjä ja jaettava hallinnointivastuita.',
        },
        f12fc090_5c3e_4fa8_9813_74bea0359c5c: {
            title: 'Vuosittainen hallintotodistus',
            description: 'Jatkuvan vaatimustenmukaisuuden vahvistamiseksi on täytettävä vuosittainen hallintotodistus.',
        },
        f6c3060a_5e52_4f97_b1af_c6a5f00bfaee: {
            title: 'Tietojen riskinarviointi',
            description: 'Tietoriskien arviointi on suoritettava tietojen hallinnointiin liittyvien riskien tunnistamiseksi ja vähentämiseksi.',
        },
        '6f228998_1c61_49cf_a585_3d3e9baff55a': {
            title: 'Alustan operaattorin vastuuvelvollisuus ja hallintovelvollisuudet',
            description: 'Perustetaan alustan ylläpitäjien vastuullisuusrakenteet, mukaan lukien hallintokäytännöt, valvontavastuut ja täytäntöönpanovelvoitteet.',
        },
        eee1d423_3783_4530_bc64_eef6fd9d02dc: {
            title: 'Alustasääntöjen julkaiseminen ja tiedon avoimuus',
            description: 'Julkaise alustan säännöt, kaupankäynnin ehdot ja toiminnalliset tiedot avoimesti ja helposti saatavilla olevalla tavalla.',
        },
        '50b57433_7a51_4e92_9c84_c748d6865b70': {
            title: 'Verkkokaupan myyntisivusto/sovellusilmoitus MOITille',
            description: 'Lähetä MOITille ilmoitus verkkokaupan myyntisivustoista ja sovelluksista Online.gov.vn-osoitteen tai tiettyjen kanavien kautta.',
        },
        '92854abe_6654_4155_8495_f3419a8a8da0': {
            title: 'Verkkokaupan palvelualustan/markkinapaikan rekisteröinti MOIT:iin',
            description: 'Rekisteröi sähköisen kaupankäynnin palvelualustoja ja markkinapaikkoja MOIT-palveluun mukaan lukien aineistojen toimittamisen ja hyväksynnän seuranta.',
        },
        b8bff437_805e_4a4a_a62e_89cb90b89d3f: {
            title: 'Myyjärekisterin ylläpito (kotimainen ja ulkomainen)',
            description: 'Ylläpidä rekisteriä kaikista alustalla olevista myyjistä, mukaan lukien kotimaiset ja ulkomaiset myyjät sisäänkäynnin, todentamisen ja elinkaaren seurannan avulla.',
        },
        '75778639_5235_4d13_a728_fa772c27fc0c': {
            title: 'Suoratoiston myyjärekisteri ja vaatimustenmukaisuuden valvonta',
            description: 'Ylläpidä livestream-myyjien rekisteriä henkilöllisyyden vahvistamisen, toiminnan seurannan ja vaatimustenmukaisuuden valvonnan avulla.',
        },
        '405f2932_742a_4bcb_9784_1a3d81f2e714': {
            title: 'Affiliate- ja markkinointikumppanirekisteri',
            description: 'Ylläpidä kumppanimarkkinoijien ja suosituskumppaneiden rekisteriä, jolla on sopimuksen tila, sisältöohjeet ja vaatimustenmukaisuusvahvistukset.',
        },
        cce5a4eb_a576_459c_95b5_bdd0e8ed30a8: {
            title: 'Tuoteluettelo ja kiellettyjen/ehdollisten tuotteiden valvonta',
            description: 'Ota käyttöön tuotelistauksen valvontaa, mukaan lukien kiellettyjen ja ehdollisten tavaroiden seulonta-, valvonta- ja täytäntöönpanotoimet.',
        },
        '9fc01e19_18dd_4d60_b95a_c1f4bcdbb6ae': {
            title: 'Kuluttajavalitukset kirjataan sisääntuloon, toimenpiteisiin ja kirjausketjuun',
            description: 'Ylläpidä valitusrekisteriä vastaanottorekistereistä, tutkintatoimista, ratkaisutuloksista ja täydellisestä kirjausketjusta.',
        },
        '8a21764e_e5f4_4934_9913_c235f4c462ca': {
            title: 'Valituksen käsittelymenettely ja ratkaisuaikataulut',
            description: 'Luo valitusten käsittelymenettelyt määritellyillä kuittaus-, tutkinta- ja ratkaisuaikatauluilla.',
        },
        '8406373c_ec31_4bf8_810f_72d9d73b3de8': {
            title: 'Sisällön valvonta, seuranta ja poistamisen valvonta',
            description: 'Ota käyttöön sisällön valvonta-, valvonta- ja poistomenettelyjä laittoman, kielletyn tai loukkaavan sisällön osalta.',
        },
        '6f32c315_323b_4ce6_a4bb_3262a5b56afe': {
            title: 'Poisto- ja täytäntöönpanotoimet rekisteröidään todisteiden säilyttämisessä',
            description: 'Pidä rekisteriä poisto- ja täytäntöönpanotoimista päätösrekistereillä, todisteiden säilyttämisellä ja myyjäilmoituksilla.',
        },
        c0bbbfbf_29bd_4813_89f1_956eab9f1a23: {
            title: 'Alustapolitiikka ja tiedonantorekisteri (versiot, julkaisupäivät, hyväksyntä)',
            description: 'Pidä rekisteriä alustan käytännöistä ja ilmoituksista versiohistorian, julkaisupäivämäärien ja hyväksymistodistusten kanssa.',
        },
        c9fcbe90_622d_43ca_9ec6_db26c0eda490: {
            title: 'Kuluttajatiedotusvelvollisuudet - tarkat tuotetiedot ja petoksen esto',
            description: 'Varmista tarkat, selkeät tuote- ja palvelutiedot ja toteuta toimenpiteitä petollisten käytäntöjen estämiseksi alustalla.',
        },
        '8f49603b_454c_4470_ab07_2f845a447595': {
            title: 'Ulkomaisen alustan toimintaehdot ja rekisteröinti/ilmoitus',
            description: 'Noudata vietnamilaisia käyttäjiä palvelevien ulkomaisten alustojen käyttöehtoja, mukaan lukien rekisteröinti- tai ilmoitusvaatimukset.',
        },
        e0dc85cc_5d2a_4142_b1a6_cc2fde891f7b: {
            title: 'Paikallinen edustus tai valtuutus ulkomaisille alustoille',
            description: 'Nimeä paikallinen edustaja tai valtuutettu taho Vietnamissa ulkomaisille alustoille lain edellyttämällä tavalla.',
        },
        '5719f47c_f298_429e_90c3_df6ceed856e1': {
            title: 'Rajatylittävän myyjän ja valitusten käsittelyn koordinointi',
            description: 'Koordinoi rajat ylittävää myyjien käsittelyä ja valitusten ratkaisua, mukaan lukien eskalointi ja todisteiden hallinta.',
        },
        c0b3db29_9161_4cef_a889_94e3b85d78fe: {
            title: 'Valtion verkkokaupan hallintajärjestelmän vuorovaikutus ja raportointivalmius',
            description: 'Valmistaudu vuorovaikutukseen valtion sähköisen kaupan hallintajärjestelmän kanssa, mukaan lukien tietokenttien kartoitus ja raportointiominaisuus.',
        },
        '145a7016_720a_4a06_badd_00145842821e': {
            title: 'Hyväksynnän jälkeinen materiaalimuutosilmoitus',
            description: 'Lähetä ilmoitukset alustan tietojen, käytäntöjen tai toimintojen olennaisista muutoksista ensimmäisen hyväksynnän jälkeen.',
        },
        '4bc0ee2a_610d_490d_8122_d6d1afadaa22': {
            title: 'Ilmoitus irtisanomisesta ja deaktivoinnista',
            description: 'Lähetä irtisanomis- tai deaktivointiilmoitukset, kun lopetat sähköisen kaupankäynnin, mukaan lukien julkiset ilmoitukset ja kuluttajansuojakäsittely.',
        },
        be95bc85_2b25_4de7_a3e7_154b780289e4: {
            title: 'Luottamusmerkki- ja uskottavuusluokitusohjelman kelpoisuus ja ylläpito',
            description: 'Arvioi kelpoisuus luottamusmerkki- ja uskottavuusluokitusohjelmiin ja säilytä vaatimustenmukaisuustodistus jatkuvasta osallistumisesta.',
        },
        f639afe2_18f2_4c0a_82d9_626308994267: {
            title: 'Suostumus henkilötietojen käsittelyyn',
            description: 'Henkilötietojen käsittely edellyttää rekisteröidyn suostumusta, ellei poikkeusta sovelleta.',
        },
        '5dd8e1b9_ac2d_48af_8c62_538937f0a4f7': {
            title: 'Suostumus arkaluonteisten tietojen käsittelyyn',
            description: 'Arkaluonteisten henkilötietojen käsittely vaatii nimenomaisen suostumuksen ja erillisen selkeän ilmoituksen rekisteröidylle.',
        },
        '5a958c76_6943_4449_a15c_ddb503ce526f': {
            title: 'Käyttöoikeus',
            description: 'Rekisteröidyillä on oikeus tutustua rekisterinpitäjän hallussa oleviin henkilötietoihinsa.',
        },
        '1ae0a58b_65a5_4a32_9b2c_0baed7799a32': {
            title: 'Oikeus oikaisuun',
            description: 'Rekisteröidyillä on oikeus pyytää virheellisten henkilötietojen oikaisua.',
        },
        '25c61e57_273f_48cb_a318_d6315ad744f1': {
            title: 'Oikeus poistaa',
            description: 'Rekisteröidyillä on oikeus pyytää henkilötietojensa poistamista.',
        },
        '0eafe047_ed8b_4a9a_bda9_b4ef2ae353c2': {
            title: 'Oikeus rajoittaa käsittelyä',
            description: 'Rekisteröidyillä on oikeus pyytää henkilötietojensa käsittelyn rajoittamista.',
        },
        '77f9677a_f436_43ec_a947_3bdc44fc192a': {
            title: 'Oikeus vastustaa',
            description: 'Rekisteröidyillä on oikeus vastustaa henkilötietojensa käsittelyä.',
        },
        c8b19e70_782c_49c9_8a71_14bef4147d6b: {
            title: 'Oikeus peruuttaa suostumus',
            description: 'Rekisteröidyillä on oikeus peruuttaa aiemmin antamansa suostumus milloin tahansa.',
        },
        '7f472a1c_b37f_498d_adc7_df8d8eafbae9': {
            title: 'Rikkomusilmoitus viranomaiselle (72h)',
            description: 'Rekisterinpitäjän tulee ilmoittaa tietosuojaministeriölle 72 tunnin kuluessa henkilötietojen tietoturvaloukkauksen havaitsemisesta.',
        },
        '98bed7ab_e814_43f5_8e70_e95c413266a1': {
            title: 'Rikkomusilmoitus rekisteröidyille',
            description: 'Rekisterinpitäjän tulee ilman aiheetonta viivytystä ilmoittaa rekisteröidyille henkilötietojen tietoturvaloukkauksesta.',
        },
        '404a3576_dd84_4bac_acf4_29719615c45e': {
            title: '[[TOK_0]] suuren riskin käsittelyyn',
            description: 'Tietosuojavaikutusten arviointi on suoritettava käsittelytoimista, jotka todennäköisesti johtavat suureen riskiin.',
        },
        '29d9ed94_9360_457c_9aca_37aefac66969': {
            title: 'Rajat ylittävien siirtojen arviointi',
            description: 'Vaikutustenarviointi on tehtävä ennen henkilötietojen siirtämistä Vietnamin ulkopuolelle.',
        },
        '9620ff08_b83c_4e1f_9350_eba835b145fe': {
            title: 'Kirjaa käsittelytoimista',
            description: 'Rekisterinpitäjien on ylläpidettävä käsittelytoimien rekisteriä (RoPA), joka dokumentoi kaikki käsittelytoimet.',
        },
        '96ee0ff3_3ead_431e_aa57_08ccff4821fc': {
            title: 'Tietojenkäsittelysopimustietueet',
            description: 'Käsittelijöiden ja alikäsittelijöiden kanssa tehdyistä tietojenkäsittelysopimuksista on pidettävä kirjaa.',
        },
        '434dc319_1922_49e4_b757_37622135c4b2': {
            title: 'Rajat ylittävien siirtojen suojatoimet',
            description: 'Henkilötietojen siirto Vietnamin ulkopuolelle edellyttää asianmukaisia suojatoimia ja dokumentoituja arvioita.',
        },
        '3372c651_d5a8_4cae_ae57_2fc684ad0768': {
            title: 'Kuittaus 2 työpäivän sisällä',
            description: 'Rekisteröidyn pyyntö on kuitattava 2 työpäivän kuluessa vastaanottamisesta.',
        },
        b15fa62d_3f52_4e42_8442_f4969e08883a: {
            title: 'Valmistuminen 15 työpäivän kuluessa',
            description: 'Rekisteröityjen pyynnöt on täytettävä 15 työpäivän kuluessa, ja sitä voidaan jatkaa 5 työpäivällä.',
        },
        '5d81233c_f671_4827_b874_827762edfc20': {
            title: 'MoPS vaikutustenarviointiaineiston arkistointi',
            description: 'Korkean riskin käsittelyä suorittavien organisaatioiden on toimitettava vaikutustenarviointiasiakirja yleisen turvallisuuden ministeriölle määrättyä hallintomenettelyä noudattaen.',
        },
        '83bf5bf8_edbd_4f0a_9f8e_5f47db01324d': {
            title: 'MoPS rajat ylittävää siirtoa koskevien asiakirjojen arkistointi',
            description: 'Organisaatioiden, jotka siirtävät henkilötietoja Vietnamin ulkopuolelle, on toimitettava rajat ylittävän siirron vaikutustenarviointiasiakirja yleisen turvallisuuden ministeriölle.',
        },
        '9454e465_e618_4b6f_80b3_d79fdd9cc5cb': {
            title: 'Palveluntarjoajan sertifiointia käsitellään',
            description: 'Henkilötietojen käsittelyä palveluna tarjoavien organisaatioiden on hankittava palvelun käsittelytodistus yleisen turvallisuuden ministeriöltä.',
        },
        b88aec34_046a_4e0a_9c77_ddad27ea4bc4: {
            title: 'Vaikutustenarviointiaineiston käsittely, kun laukaisut täyttyvät',
            description: 'Käsittelyvaikutusten arviointiasiakirjat on toimitettava, kun säädetyt triggerit täyttyvät.',
        },
        '9d34a206_b85e_4649_a23b_e2c6f1398402': {
            title: 'Rajat ylittävien siirtojen vaikutusasiakirja',
            description: 'Kansainvälistä tiedonsiirtoa varten on laadittava ja arkistoitava rajat ylittävän tiedonsiirron vaikutusasiakirja.',
        },
        '210d3ec3_e6f2_424b_ae25_cad76bc13320': {
            title: 'Tietosuojavastaavan nimitys',
            description: 'Tietosuojavastaava on nimettävä asetuksen 13 mukaisesti.',
        },
        '776183b2_2797_40e8_8d81_c4f512c566d2': {
            title: 'Hallintoartefaktit (käytännöt, roolit, menettelyt)',
            description: 'Hallintoartefaktit, mukaan lukien politiikat, roolit ja menettelyt, on säilytettävä.',
        },
        '4f1385f1_6dfc_4368_b4af_1040cd3f77b7': {
            title: 'Todistuspaketin täydellisyys ja muuttumaton kirjausketju',
            description: 'Todistuspakettien on oltava täydellisiä, ja muuttumaton kirjausketju on säilytettävä.',
        },
        f6826e26_8991_4a0f_9117_481490230bdd: {
            title: 'Arkistoinnin työnkulun tuki',
            description: 'Tapausten arkistointityönkulkua on tuettava vaikutusten arvioinnissa ja rajat ylittävissä asiakirjoissa.',
        },
        '8a28ee33_305a_491f_a93f_90e59f8da91b': {
            title: 'Prosessorin sopimusvaatimukset',
            description: 'Tietojen käsittelijöille on asetettava sopimusvaatimukset ja niitä on valvottava.',
        },
        '4fd36e83_8286_40e0_b9b2_a4bc5e8377b3': {
            title: 'Vuotuinen vaatimustenmukaisuustarkastus',
            description: 'Vuosittainen vaatimustenmukaisuustarkastus on suoritettava jatkuvan noudattamisen varmistamiseksi.',
        },
        '8b6b6c13_0d32_4439_819f_4bd8cff02217': {
            title: 'Viranomaisten hakemusten tietueet',
            description: 'Kaikista viranomaisilmoituksista on säilytettävä kirjaa.',
        },
        e7ce6c23_03dc_42dd_bccd_fa571c3afee3: {
            title: 'Henkilötietojen käsittelyn lailliset perusteet',
            description: 'Henkilötietojen käsittelyn tulee perustua [[TOK_0]]:n määrittelemiin laillisiin perusteisiin.',
        },
        c919c66c_6a74_4403_bb97_04b773d270bf: {
            title: 'Arkaluontoisten tietojen suostumusvaatimukset',
            description: 'Arkaluonteisten henkilötietojen käsittely edellyttää nimenomaista suostumusta erityisillä vaatimuksilla.',
        },
        '419cc7c3_a257_4293_a054_304dc2fcb8df': {
            title: 'Rekisteröidyn oikeudet (pääsy, oikaisu, poistaminen, rajoittaminen, kohde, siirrettävyys)',
            description: 'Rekisteröidyillä on kattavat oikeudet, mukaan lukien pääsy, oikaisu, poistaminen, rajoittaminen, vastustaminen ja siirrettävyys.',
        },
        '638e6e25_3a74_4864_8bff_8e21ab82860b': {
            title: 'Rikkomusilmoitus viranomaiselle',
            description: 'Rekisterinpitäjien on ilmoitettava toimivaltaiselle viranomaiselle henkilötietojen tietoturvaloukkauksista säädetyssä määräajassa.',
        },
        '6e75c111_66b1_4726_8c27_6537846edb30': {
            title: 'Rikkomusilmoitus rekisteröidyille',
            description: 'Rekisterinpitäjien on ilmoitettava henkilötietojen loukkauksista niille rekisteröidyille, joita asia koskee.',
        },
        f686123d_3bdd_4a61_a53c_efe5b52d9058: {
            title: 'Tietosuojavaikutusten arviointi',
            description: 'Korkean riskin käsittelytoimista on tehtävä tietosuojavaikutusten arviointi.',
        },
        '554ea5b6_092d_4295_a57a_1bd9b2eef291': {
            title: 'Rajat ylittävien siirtojen hallinto',
            description: 'Henkilötietojen rajat ylittävän siirron on noudatettava hallintovaatimuksia.',
        },
        cf9a5b29_46fd_4072_b877_13b8a69df82c: {
            title: 'Tietosuojavastaavan nimitys',
            description: 'Organisaatioiden on tarvittaessa nimettävä tietosuojavastaava.',
        },
        f5a4965d_eb0c_47df_9933_f185ae46463b: {
            title: 'Käsittelytoimien tiedot',
            description: 'Organisaatioiden on pidettävä kirjaa kaikista käsittelytoimista.',
        },
        ce8986ff_684d_41ec_8147_b3f2a1c5206c: {
            title: 'Käsittelijän sopimusvelvoitteet',
            description: 'Tietojen käsittelijöiden kanssa on sovittava sopimusvelvoitteista.',
        },
        '7a3d7554_7b6f_49d7_8864_4a5cd71fd6bd': {
            title: 'Vaikutustenarviointiaineiston arkistointi',
            description: 'Vaikutustenarviointiasiakirjat on toimitettava toimivaltaiselle viranomaiselle määräysten mukaisesti.',
        },
        '65dba62f_0788_44c1_89e3_09d802e28eb9': {
            title: 'Rajat ylittävien siirtojen vaikutusasiakirja',
            description: 'Kansainvälistä tiedonsiirtoa varten on laadittava ja arkistoitava rajat ylittävän tiedonsiirron vaikutusasiakirja.',
        },
        '0eccb520_b1fa_4fa3_a3ab_2d30823dd00e': {
            title: '[[TOK_0]] tapaaminen ja ilmoitus',
            description: 'Tietosuojavastaava on nimettävä ja viranomaiselle on ilmoitettava asiasta.',
        },
        '43ead19e_982a_4615_bafd_e6a3a4e80b3a': {
            title: 'Hallintoperiaatteet ja -menettelyt',
            description: 'Hallintopolitiikat ja -menettelyt on laadittava ja niitä on ylläpidettävä.',
        },
        '9ebc7a42_e1f1_49c4_ac90_22a691fd2219': {
            title: 'Todistuspaketti ja muuttumaton kirjausketju',
            description: 'Todistuspakettien on oltava täydellisiä, ja muuttumaton kirjausketju on säilytettävä.',
        },
        '5b0ba1c0_7b86_4c80_b9f9_26e4ff9652c2': {
            title: 'Arkistoinnin elinkaari',
            description: 'Arkistointiasioiden elinkaari on hallittava määrättyjen vaiheiden kautta.',
        },
        '83f2f346_47bb_4377_a711_3cef26742f39': {
            title: 'Prosessorin sopimusvaatimukset',
            description: 'Tietojen käsittelijöille on asetettava sopimusvaatimukset ja niitä on valvottava.',
        },
        cb972e06_f773_492e_8ad5_f65d1e999b79: {
            title: 'Palvelunkäsittelyn tarjoajan sertifiointi',
            description: 'Tietojenkäsittelypalveluita tarjoavien organisaatioiden on hankittava sertifiointi.',
        },
        '4ba36ab5_39f0_4d79_927e_c39587bed226': {
            title: 'Viranomaisten hakemusten tietueet',
            description: 'Kaikista viranomaisilmoituksista on säilytettävä kirjaa.',
        },
        f7a62c88_3cda_4031_bc52_1598661a5128: {
            title: 'Vuotuinen vaatimustenmukaisuustarkastus',
            description: 'Vuosittainen vaatimustenmukaisuustarkastus on suoritettava jatkuvan noudattamisen varmistamiseksi.',
        },
        '3e97f4d4_60ad_46a8_ad2b_615d4ca04aee': {
            title: 'Tekniset tietoturvatoimenpiteet',
            description: 'Tietoturvan tekniset toimenpiteet on toteutettava ja ylläpidettävä.',
        },
        '45f4e745_a923_4879_94ce_5a2b41b7e886': {
            title: 'Asetuksen 356 viralliset Mẫu số -lomakevaatimukset',
            description: 'Asetuksella [[TOK_0]]Đ-CP säädettyjä 13 virallista Mẫu số hallintomenettelylomaketta (Mẫu số 01a–10) on käytettävä vastaaviin ilmoituksiin yleisen turvallisuuden ministeriölle. Phụ lục I–VIII kohteet ovat sisäisiä tietorakennekartoituksia, eivät virallisia säädöslomakkeita.',
        },
        ff452604_7461_4c12_aeab_cb7dd1fb5ba3: {
            title: '[[TOK_0]] asiakirjan lähettäminen kohtaan A05',
            description: 'Organisaatioiden on toimitettava [TOK_0]] asiakirjat osoitteeseen A05/[[TOK_1]] käsitelläkseen toimia, joihin liittyy arkaluonteisia henkilötietoja tai laajamittaista käsittelyä.',
        },
        '003600ae_7a0f_4034_b206_72f59409b8f3': {
            title: 'Rajat ylittävää siirtoa koskevien asiakirjojen toimittaminen',
            description: 'Organisaatioiden on toimitettava rajat ylittävää tiedonsiirtoa koskevat asiakirjat A05/[[TOK_0]] tarkastettavaksi ja hyväksyttäväksi.',
        },
        '4632b20c_293a_4c7e_968e_4ce178c3b7d8': {
            title: 'Palveluvarmennehakemusta käsitellään',
            description: 'Tietojenkäsittelypalvelun tarjoajien on haettava varmenteita alkaen A05/[[TOK_0]].',
        },
        be96add4_ebdb_4b6c_9426_4dc87b7cd2ce: {
            title: 'Ilmoitus henkilötietojen käsittelystä',
            description: 'Rekisterinpitäjien on ilmoitettava A05/[[TOK_0]] henkilötietojen käsittelystä määrätyillä lomakkeilla (Mẫu số 01a/01b).',
        },
        '39f50471_27cc_46bd_acff_9aa2211d43ab': {
            title: 'Vuosittainen tilanneraportti',
            description: 'Rekisterinpitäjien on toimitettava vuosittain henkilötietojen käsittelyn tilanneraportti (Mẫu số 09).',
        },
        '3b45c6fa_d66a_448a_9ff1_597caa055e09': {
            title: 'Käyttäjätietojen luottamuksellisuus oletuksena',
            description: 'Käyttäjätietoja on käsiteltävä oletusarvoisesti luottamuksellisina.',
        },
        '2994510e_b1f8_4cdd_947c_d9542746433b': {
            title: 'Organisaation ja teknisen suojauksen vähimmäisvalvonta',
            description: 'Organisaation ja teknisen suojan vähimmäisvalvonta on toteutettava.',
        },
        '8643160f_9a10_4d93_baf5_082c6a7c768a': {
            title: 'Ilmoittaminen vain asianmukaisin perustein',
            description: 'Käyttäjätietojen luovuttaminen on sallittua vain asianmukaisen laillisen perustan perusteella.',
        },
        c1fb7d85_fdc0_402e_ab0c_ff134bd72dfa: {
            title: 'Pakollinen tiedonkeruu ja auditoitavuus',
            description: 'Kaikki tiedot on kirjattava ja tarkastettavissa.',
        },
        efa36bc0_abae_417a_b676_9509af37f89d: {
            title: 'Sisäinen hyväksynnän työnkulku ilmoituksia varten',
            description: 'Kaikille ilmoituksille on luotava sisäinen hyväksynnän työnkulku.',
        },
        d086fdcd_9a23_4500_893c_db8ac62bd787: {
            title: 'Viranomaisten pyyntöjen vastausten käsittely',
            description: 'Viranomaisten pyynnöt on käsiteltävä ja niihin on vastattava määrättyjen menettelyjen mukaisesti.',
        },
    },
    framework_rights_descriptions: {
        be_informed: 'Rekisteröidyllä on oikeus saada tietoa henkilötietojen käsittelystä.',
        consent: 'Rekisteröidyllä on oikeus suostua henkilötietojensa käsittelyyn.',
        refuse_consent: 'Rekisteröidyllä on oikeus olla suostumatta henkilötietojensa käsittelyyn.',
        withdraw_consent: 'Rekisteröidyllä on oikeus pyytää aiemmin antamansa suostumuksen peruuttamista.',
        access: 'Rekisteröidyllä on oikeus nähdä ja päästä käsiksi rekisterinpitäjän hallussa oleviin henkilötietoihinsa.',
        rectification: 'Rekisteröidyllä on oikeus oikaista tai pyytää oikaisemaan virheelliset henkilötiedot.',
        data_provision: 'Rekisteröidyllä on oikeus pyytää henkilötietojensa toimittamista (yêu cầu cung cấp dữ liệu cá nhân).',
        deletion: 'Rekisteröidyllä on oikeus vaatia henkilötietojensa poistamista tai tuhoamista lain poikkeuksin.',
        restriction_of_processing: 'Rekisteröidyllä on oikeus pyytää henkilötietojensa käsittelyn rajoittamista.',
        object_to_processing: 'Rekisteröidyllä on oikeus lähettää pyyntö vastustaa henkilötietojensa käsittelyä.',
        complaint: 'Rekisteröidyllä on oikeus tehdä valitus (khiếu nại) henkilötietojen käsittelystä.',
        denunciation: 'Rekisteröidyllä on oikeus irtisanoa (tố cáo) henkilötietojen suojan loukkauksista.',
        lawsuit: 'Rekisteröidyllä on oikeus nostaa kanne (khởi kiện) tietosuojaoikeuksien loukkaamisesta.',
        claim_damages: 'Rekisteröidyllä on oikeus vaatia korvausta henkilötietojen suojan loukkauksista aiheutuneista vahingoista.',
        request_protection_measures: 'Rekisteröidyllä on oikeus pyytää toimivaltaisia viranomaisia tai asianomaisia organisaatioita/henkilöitä toteuttamaan toimenpiteitä henkilötietojensa suojaamiseksi.',
    },
    framework_procedures: {
        VN_DP_DRAFT_P7: {
            name: 'Riskienhallinta ja seuranta (luonnos)',
            steps: {
                '1': 'Tunnista riskiluokat',
                '2': 'Säilytä varhaisvaroitussäätimet',
                '3': 'Tarkista keräys-, tallennus-, käsittely-, jakamis- ja tapahtumariskit',
                '4': 'Tallenna tietosuoja-, kyberturvallisuus- ja pääsynhallintariskit',
                '5': 'Käynnistä korjaustoimenpiteet',
                '6': 'Säilytä arvosteluhistoria',
            },
        },
        VN_DP_DRAFT_P6: {
            name: 'Valitukset ja kiistat (luonnos)',
            steps: {
                '1': 'Vastaanota valitus/riita',
                '2': 'Tarkista vaadittujen tietojen täydellisyys; pyydä lisäystä 24 tunnin kuluessa, jos se on puutteellinen',
                '3': 'Ilmoita osapuolille käsittelytavasta ja odotetusta aikataulusta kolmen työpäivän kuluessa täydellisen pyynnön vastaanottamisesta',
                '4': 'Pyydä vastauksia ja asiakirjoja',
                '5': 'Arvioi kiistan tosiasiat ja alustan vastuu',
                '6': 'Ennätysresoluutiotulos',
                '7': 'Säilytä todisteet ja sulje tapaus',
            },
        },
        VN_DP_DRAFT_P5: {
            name: 'Tietojen omistusoikeuden toimitus ja todistus (luonnos)',
            steps: {
                '1': 'Toimita tuote/palvelu sopimustavan mukaisesti',
                '2': 'Tallenna toimitustapahtuma ja aika',
                '3': 'Luo tietojen omistusoikeustodistus',
                '4': 'Rekisteröi tapahtuman suorittaminen',
                '5': 'Ota myöhempi haku/vahvistus käyttöön tarvittaessa',
            },
        },
        VN_DP_DRAFT_P4: {
            name: 'Kaupan aloittaminen ja sopimus (luonnos)',
            steps: {
                '1': 'Tarkista listaus ja arvioinnin tulos',
                '2': 'Aloita osto-, neuvottelu- tai huutokauppatyönkulku',
                '3': 'Luo sähköinen sopimus',
                '4': 'Varmista molempien osapuolten hyväksyntä',
                '5': 'Kirjaa maksun suorittaminen',
                '6': 'Valtuuta toimitus',
            },
        },
        VN_DP_DRAFT_P3: {
            name: 'Hiekkalaatikon/testiympäristön käyttöoikeus (luonnos)',
            steps: {
                '1': 'Lähetä hiekkalaatikkopyyntö',
                '2': 'Määritä laajuus, sallitut tiedot, ajanjakso ja käsittelyoikeudet',
                '3': 'Tarjoa eristetty tekninen ympäristö',
                '4': 'Tarkkaile turvallisuutta ja pääsyä testauksen aikana',
                '5': 'Tarkista tulos ennen poistamista',
                '6': 'Hyväksy louhinta vain, jos se on sallittua',
                '7': 'Sulje testiistunto ja puhdista ympäristö',
            },
        },
        VN_DP_DRAFT_P2: {
            name: 'Tuote-/palvelutiedot (luonnos)',
            steps: {
                '1': 'Luo listaussovellus',
                '2': 'Tallenna lähde- ja omistus-/käyttöoikeustodisteet',
                '3': 'Tallenna tekniset ominaisuudet, muoto, [[TOK_0]] tiedot ja rajoitukset',
                '4': 'Ennätykselliset tiedot',
                '5': 'Lähetä listausaineisto alustan tarkastettavaksi',
                '6': 'Alusta suorittaa täydellisyys-, laillisuus- ja tekniset tarkastukset',
                '7': 'Hyväksy tai hylkää luettelo',
                '8': 'Jos hyväksytään, julkaise luettelo ja liitteenä arviointitulos',
            },
        },
        VN_DP_DRAFT_P1: {
            name: 'Osallistujan käyttöönotto (luonnos)',
            steps: {
                '1': 'Määritä osallistujan tyyppi: myyjä tai ostaja',
                '2': 'Tarkista oikeusasema ja oikeuskelpoisuus',
                '3': 'Tarkista lisäehdot, jos ehdollisia liiketoimintalinjoja sovelletaan',
                '4': 'Rekisteröi tapahtumatili',
                '5': 'Linkitä maksutili',
                '6': 'Hyväksy alustan osallistuminen',
                '7': 'Tallenna osallistujatietue ja kirjausketju',
            },
        },
        AI_A1: {
            name: '[[TOK_0]] Järjestelmän rekisteröinti/ilmoitus',
            steps: {
                '1': 'Soveltuvuuden tarkistus ja [[TOK_0]] järjestelmäluokitus',
                '2': 'Luo rekisteröinti-/ilmoitusaineisto',
                '3': 'Sisäinen hyväksyntä',
                '4': 'Lähetä kanavan kautta',
                '5': 'Muutossilmukka – jos palautetaan, päivitä ja lähetä uudelleen',
                '6': 'Sulje ja tallenna vahvistus',
            },
        },
        AI_A2: {
            name: '[[TOK_0]] Riskiluokituksen työnkulku',
            steps: {
                '1': 'Luo [[TOK_0]] järjestelmärekisterimerkintä',
                '2': 'Suorita ohjattu luokittelutoiminto',
                '3': 'Liitä todisteet',
                '4': 'Hyväksy luokitus',
                '5': 'Linkitä tulosteet järjestelmän aineistoon',
            },
        },
        AI_A3: {
            name: 'Merkintöjen ja paljastamisen vaatimustenmukaisuus',
            steps: {
                '1': 'Tunnista merkintävelvollisuudet järjestelmän ja käyttötapauksen mukaan',
                '2': 'Ota käyttöön merkintäilmoitukset',
                '3': 'Kaappaa todisteita – kuvakaappauksia, käyttöliittymäkopioita, teknisiä metatietoja',
                '4': 'Käsittele poikkeukset ja kirjaa perustelut',
                '5': 'Hyväksy ja versio',
            },
        },
        AI_A4: {
            name: 'Raportointi vakavista tapauksista',
            steps: {
                '1': 'Luo [[TOK_0]] tapahtumatietue',
                '2': 'Luokittele vakavuus',
                '3': 'Suorita eristämistoimia ja todisteiden talteenotto',
                '4': 'Luo vakavan tapauksen raporttimallin vienti',
                '5': 'Lähetä viranomaiselle kanavan kautta',
                '6': 'Seuraa viranomaisten vastauksia ja sulkemista',
            },
        },
        AI_A5: {
            name: '[[TOK_0]] Vaikutusten arviointi',
            steps: {
                '1': 'Luo arviointitietue',
                '2': 'Täytä vaaditut osat',
                '3': 'Liitä todisteet – tietovirrat, mallidokumentaatiot, kontrollit',
                '4': 'Sisäinen hyväksyntä',
                '5': 'Vie raportti ja säilytä asiakirjassa',
            },
        },
        AI_A6: {
            name: 'Kontrolloitu testaus / hiekkalaatikkoon osallistuminen',
            steps: {
                '1': 'Täydellinen kelpoisuus- ja valmiustodistus',
                '2': 'Valmistele hakemus ja vie',
                '3': 'Lähetä kanavan kautta',
                '4': 'Raidan hyväksyntä',
                '5': 'Suorita valvontatarkastuspisteet ja lokit',
                '6': 'Täydellinen valmistumisraportti ja sulkemispaketti',
            },
        },
        CYBERSEC_C1: {
            name: 'Kriittisen tietojärjestelmän turvallisuusarviointi',
            steps: {
                '1': 'Luokittele tietojärjestelmät kansallisten kyberturvallisuusvaatimusten mukaan',
                '2': 'Suorita turvaluokiteltujen järjestelmien turvallisuusarviointi ja riskiarviointi',
                '3': 'Ota käyttöön tarvittavat turvatoimenpiteet ja perussäädöt',
                '4': 'Dokumentoi todisteet vaatimustenmukaisuudesta ja ajoita säännölliset tarkistukset',
            },
        },
        CYBERSEC_C2: {
            name: 'Ilmoitus kyberturvallisuustapahtumasta',
            steps: {
                '1': 'Havaitse, luokittele ja arvioi kyberturvallisuushäiriö',
                '2': 'Suorita välittömät reagointitoimet ja todisteiden säilyttäminen',
                '3': 'Raportoi viranomaisille ja osallistu valtakunnalliseen vaaratilanteiden hallintaan',
                '4': 'Suorita tapahtuman jälkeinen tarkistus ja dokumentoi saadut opetukset',
            },
        },
        CYBERSEC_C3: {
            name: 'Tietojen lokalisoinnin vaatimustenmukaisuuden tarkistus',
            steps: {
                '1': 'Arvioi, ovatko datan lokalisointikäynnistimet käytössä palvelutyypin ja tietoluokkien perusteella',
                '2': 'Varmista, että paikallinen tallennusarkkitehtuuri ja rajat ylittävät virtauksen säädöt ovat käytössä',
                '3': 'Arvioi paikalliset läsnäolovaatimukset (sivukonttori / edustusto) tarvittaessa',
                '4': 'Dokumentoi vaatimustenmukaisuustodistus ja säilytä viranomaisen tarkastelua varten',
            },
        },
        CYBERSEC_C4: {
            name: 'Vastaus viranomaisen yhteistyöpyyntöön',
            steps: {
                '1': 'Vastaanota ja tarkista viranomaispyynnön laillisuus ja laajuus',
                '2': 'Kerää ja valmistele pyydetyt tiedot tai suorita vaaditut toimenpiteet',
                '3': 'Lähetä vastaus viranomaiselle vaaditussa määräajassa',
                '4': 'Kirjaa ilmoitus ja sulje tapaus',
            },
        },
        CYBERSEC_C5: {
            name: 'Kyberturvallisuushenkilöstön pätevyyden tarkistus',
            steps: {
                '1': 'Arvioi toimittajan turvallisuusasenne kyberturvallisuuden arviointikehyksen avulla',
                '2': 'Tarkista toimittajan tietojen käyttöoikeus ja rekisteröidy toimittajan tietojen käyttölokiin',
                '3': 'Tarkista toimittajan tapausten ilmoituslauseke ja sopimuskohtaiset kyberturvallisuusvaatimukset',
                '4': 'Suunnittele säännölliset toimittajan tietoturvatarkastukset ja seuraa vaatimustenmukaisuutta',
            },
        },
        DATA_D1: {
            name: 'Tietovaraston ja luokittelun asetukset',
            steps: {
                '1': 'Luetteloi kaikki tietovarat tyypeineen ja lähteineen tietovarastorekisteriin',
                '2': 'Luokittele jokainen omaisuus herkkyystason mukaan',
                '3': 'Määritä käsittelysäännöt luokitustasoittain',
                '4': 'Tallenna todisteet – kuvakaappaukset, arkkitehtuurikaaviot, kulunvalvonta',
                '5': 'Suunnittele säännölliset tarkastukset',
            },
        },
        DATA_D2: {
            name: 'Tietojen jakamisen hallinta',
            steps: {
                '1': 'Arvioi uusia jakamisjärjestelyjä tiedonjaon riskiarvioinnin avulla',
                '2': 'Suorita sisäinen hyväksyntätyönkulku',
                '3': 'Tallenna jakamistapahtuma tietojen jakamis-/paljastuslokissa',
                '4': 'Taltioi todisteet – hyväksymisasiakirjat, sopimusasiakirjat',
                '5': 'Jakamisjärjestelyjen säännöllinen tarkistus',
            },
        },
        DATA_D3: {
            name: 'Rajat ylittävän tiedonsiirron arviointi',
            steps: {
                '1': 'Tunnista rajat ylittävät siirrot tietovarastosta',
                '2': 'Suorita siirtoriskin arviointi',
                '3': 'Käytä suojatoimia ja hallintotoimenpiteitä',
                '4': 'Asiakirja valtioiden rajat ylittävässä hallintotodistuksessa',
                '5': 'Viennin arviointipaketti auditointiin',
            },
        },
        DATA_D4: {
            name: 'Vuosittainen hallintotodistus',
            steps: {
                '1': 'Tarkista hallinto-RACI-matriisi',
                '2': 'Vahvista käytännön tila (hallinto, luokittelu, jakaminen, säilyttäminen)',
                '3': 'Täydellinen todistuspaketti',
                '4': 'Hanki sisäinen hyväksyntä',
                '5': 'Vienti- ja arkistointitodistus',
            },
        },
        DATA_D5: {
            name: 'Tietotapahtumien käsittely',
            steps: {
                '1': 'Luokittele tapahtuma päätöstietueen avulla',
                '2': 'Suorita tapausvastaus pelikirjan mukaan',
                '3': 'Kaappaa todisteita – lokeja, kuvakaappauksia, viestintää',
                '4': 'Suorita tapahtuman jälkeinen tarkistus',
                '5': 'Jos vaaditaan viranomaisen ilmoitus: luo lähetystapaus ja lähetä osoitteeseen [[TOK_0]]',
                '6': 'Sulje ja arkistoi',
            },
        },
        ECOM_P1: {
            name: 'Ilmoitus (myyntisivusto/sovellus)',
            steps: {
                '1': 'Määritä luokitus: myyntisivusto/sovellus vs. markkinapaikka/palvelualusta',
                '2': 'Luo sisäinen asiakirjatietue, joka sisältää yrityksen identiteetin, verkkosivuston/sovelluksen tiedot ja vaaditut tiedot',
                '3': 'Luo todistepaketti – kuvakaappauksia ilmoituksista, käytäntöjen URL-osoitteista, versiohistoriasta',
                '4': 'Lähetä osoitteessa Online.gov.vn – lataa asiakirjat, tallenna aikaleima ja vahvistus',
                '5': 'Seuraa käsittelyä – jos palautetaan korjattavaksi, tallenna syyt ja lähetä uudelleen',
                '6': 'Sulje — tallenna vahvistus, linkitä todisteet ja kirjausketju',
            },
        },
        ECOM_P2: {
            name: 'Rekisteröityminen (palvelualustat / markkinapaikat)',
            steps: {
                '1': 'Määritä alustamalli ja velvoitteet – markkinapaikka vs. sekakauppa vs. sosiaalinen kaupankäynti',
                '2': 'Rakenna rekisteröintiaineisto — hakemuslomake, palveluntarjoamisjärjestelmä, käyttöehdot, alustasäännöt',
                '3': 'Sisäiset hyväksynnät — määritä laillinen/vaatimustenmukaisuusomistaja, hyväksy lähetys',
                '4': 'Lähetä osoitteessa Online.gov.vn — lataa aineisto, tallenna aikaleima',
                '5': 'Käsittelysilmukka – jos palautetaan korjattavaksi, päivitä ja lähetä uudelleen',
                '6': 'Hyväksyminen ja käyttöönotto — säilytä vahvistus, ylläpidä jatkuvaa vaatimustenmukaisuusrekisteriä',
            },
        },
        ECOM_P3: {
            name: 'Päivitys/muutosilmoitus',
            steps: {
                '1': 'Tunnista muutoksen laukaiseva tekijä – materiaalin muutos asiakirja-aineistoon',
                '2': 'Luo muutospaketti — muutosyhteenveto, päivitetyt asiakirjat, todisteiden päivitykset',
                '3': 'Lähetä päivitys ja tallenna lähetyksen tila',
                '4': 'Seuraa käsittelyä ja sulje',
            },
        },
        ECOM_P4: {
            name: 'Päättäminen / deaktivointi',
            steps: {
                '1': 'Valmistele irtisanomispaketti – lopetuspäivämäärä, syy, kuluttajansuojakäsittelysuunnitelma, todiste julkisesta ilmoituksesta',
                '2': 'Lähetä irtisanominen — tallenna aikaleima ja vahvistus',
                '3': 'Sulje — tallenna lopullinen tila ja todisteet',
            },
        },
        ECOM_P5: {
            name: 'Trustmark / uskottavuusluokitusohjelma',
            steps: {
                '1': 'Kelpoisuus- ja valmiustarkastus',
                '2': 'Valmistele asiakirja virallisella lomakkeella',
                '3': 'Lähetä ja seuraa',
                '4': 'Säilytä jatkuva näyttö vaatimustenmukaisuudesta',
            },
        },
        PDPL_P1: {
            name: '[[TOK_0]] Lähetyksen arkistointi osoitteeseen [[TOK_1]]',
            steps: {
                '1': 'Täytä [[TOK_0]] käyttämällä Decree 356 -lomakepolkua (Mẫu số 02a/02b)',
                '2': 'Kokoa kansiasiakirjat ja niitä tukevat todisteet',
                '3': 'Lähetä yksi alkuperäinen asiakirja yleisen turvallisuuden ministeriölle ([[TOK_0]])',
                '4': 'Tarkkaile täydennyspyyntöjä lähettäjältä [[TOK_0]] ja vastaa määräajan kuluessa',
                '5': 'Säilytä asiakirjat ja todisteet toimittamisesta kirjausketjua varten',
            },
        },
        PDPL_P2: {
            name: 'Rajat ylittävä siirtohakemus',
            steps: {
                '1': 'Täytä rajat ylittävää siirtoa koskeva asiakirja-aineisto Decree 356 -lomakkeilla (Mẫu số 01a/01b, Mẫu số 09)',
                '2': 'Lähetä yksi alkuperäinen asiakirja [[TOK_0]]:lle 60 päivän kuluessa käsittelyn aloittamisesta',
                '3': 'Ilmoita [[TOK_0]] onnistuneesta siirtämisestä ja lähetä vastaanottavan osapuolen yhteystiedot',
                '4': 'Vastaa [[TOK_0]]:n täydennys-/korjaus-/tarkastuspyyntöihin määräajan kuluessa',
            },
        },
        PDPL_P3: {
            name: 'Tietojenkäsittelypalvelun varmennehakemus',
            steps: {
                '1': 'Valmistele sertifiointihakemusasiakirjat asetuksen 356 vaatimusten mukaisesti',
                '2': 'Lähetä hakemus osoitteeseen [[TOK_0]] ja vaadi tarvittavat asiakirjat',
                '3': 'Vastaa [[TOK_0]]:n tarkistuskommentteihin ja täydennyspyyntöihin',
                '4': 'Pidä yllä sertifikaattia ja uusimisaikataulua',
            },
        },
        PDPL_P4: {
            name: 'Rekisteröidyn oikeuksia koskevan pyynnön käsittely',
            steps: {
                '1': 'Vastaanota ja kirjaa pyyntö; tarkistaa rekisteröidyn henkilöllisyyden 2 työpäivän kuluessa',
                '2': 'Arvioi pyyntötyyppi ja määritä sovellettava määräaika (10/15/20 päivää tyypin mukaan)',
                '3': 'Suorita toteutustoimia asianmukaisissa järjestelmissä ja osastoissa',
                '4': 'Valmistele ja lähetä rekisteröidylle vastaus tuloksen ja perusteluineen',
                '5': 'Sulje tapaus ja säilytä todisteet tarkastusta varten; dokumentoi mahdolliset kieltäytymisen perusteet',
            },
        },
        PDPL_P5: {
            name: 'Rikkomusilmoitus henkilölle [[TOK_0]]',
            steps: {
                '1': 'Havaitse ja arvioi rikkomus; määrittää ilmoitusvelvollisuuden 2 työpäivän kuluessa',
                '2': 'Valmistele ilmoituspaketti [[TOK_0]] vaatimusten mukaisesti',
                '3': 'Lähetä ilmoitus osoitteeseen [[TOK_0]] kahden työpäivän kuluessa havaitsemisesta',
                '4': 'Vastaa [[TOK_0]]-seurantapyyntöihin; toimittaa täydennyksiä ja koordinointitodisteita',
            },
        },
        TELECOM_T1: {
            name: 'Viranomaisten pyyntöjen käsittely',
            steps: {
                '1': 'Vastaanota ja kirjaa viranomaispyyntö ottotietueen kautta',
                '2': 'Tarkista viranomaisen henkilöllisyys, oikeusperusta ja pyynnön laajuus',
                '3': 'Suorita sisäinen oikeudellinen tarkastus ja hanki johdon hyväksyntä',
                '4': 'Valmistele vastauspaketti kootuilla todisteilla',
                '5': 'Laadi ja hyväksy vastauskirje',
                '6': 'Luo lähetystapaus ja lähetä vastaus kanavan kautta',
                '7': 'Lokin paljastaminen ja seurantavaltuutuksen vahvistus',
                '8': 'Sulje tapaus ja säilytä todisteet kirjausketjua varten',
            },
        },
        TELECOM_T2: {
            name: 'Tietojen hallinta',
            steps: {
                '1': 'Vastaanota luovutuspyyntö (käyttäjän suostumus, lakisääteinen velvoite tai viranomainenpyyntö)',
                '2': 'Suorita tietojen hyväksymisen työnkulku loppuun',
                '3': 'Suorita julkistaminen ja kirjaa lokirekisteriin',
                '4': 'Taltioi todisteet – hyväksymisasiakirjat, viestintätietueet',
                '5': 'Ilmoituslokin määräaikainen tarkistus',
            },
        },
        TELECOM_T3: {
            name: 'Luottamuksellisuuskäytäntö ja kulunvalvontaasetukset',
            steps: {
                '1': 'Luonnostele ja hyväksy salassapitopolitiikka',
                '2': 'Laadi ja hyväksy kulunvalvonta- ja lokikäytäntö',
                '3': 'Asiakirjojen käsittelytoiminta käyttäjätietojen käsittelyrekisterissä',
                '4': 'Kerää todisteita – politiikka-asiakirjat, täytäntöönpanon todisteet',
                '5': 'Suunnittele säännölliset tarkastukset',
            },
        },
        TELECOM_T4: {
            name: 'Televiestintätapahtuman arviointi',
            steps: {
                '1': 'Luokittele ja arvioi tapahtuma',
                '2': 'Määritä ilmoitusvaatimukset',
                '3': 'Jos viranomaisen ilmoitus vaaditaan: luo lähetystapaus',
                '4': 'Ota ja säilytä todisteita',
                '5': 'Päätös ja sulkeminen',
            },
        },
        TELECOM_T5: {
            name: 'Säilytyksen ja poistamisen hallinta',
            steps: {
                '1': 'Määritä säilytys- ja poistoaikataulu tietokategorioittain',
                '2': 'Ota poistomenettelyt käyttöön',
                '3': 'Kaappaa todisteet - poista tietueet',
                '4': 'Aikataulujen säännöllinen tarkistus',
            },
        },
    },
    framework_fines: {
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-A': 'Tapahtuman käsittelyn ja raportoinnin epäonnistumiset',
            'CYBERSEC-FINE-B': 'Järjestelmän turvallisuuden valvonta ja perustilan hallinnan epäonnistumiset',
            'CYBERSEC-FINE-C': 'Viranomaisten yhteistyöpyyntöjen epäonnistumiset',
            'CYBERSEC-FINE-D': 'Tietojen lokalisoinnin ja paikallisen läsnäolon rikkomukset',
            'CYBERSEC-FINE-E': 'Haittaohjelmien eston ja järjestelmän suojausvirheet',
            'CYBERSEC-FINE-F': 'Alustan/palveluntarjoajan vastausvirheet',
            'CYBERSEC-FINE-G': 'Toimittajan/kolmannen osapuolen tietoturvavirheet',
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-A': 'Rekisteröinti / Ilmoitus / Hallinnollinen valmius',
            'ECOM-FINE-B': 'Valitukset ja kuluttajansuoja',
            'ECOM-FINE-C': 'Valvonta ja poistamisen täytäntöönpano',
            'ECOM-FINE-D': 'Rajat ylittävät toiminnot',
            'ECOM-FINE-E': 'Alustan säännöt ja avoimuus',
        },
        VN_PDPL: {
            'PDPL-FINE-A': 'Toiminnan laiminlyönti [[TOK_0]]',
            'PDPL-FINE-B': 'Luvaton rajat ylittävä siirto',
            'PDPL-FINE-C': 'Käsittely ilman laillista perustetta',
            'PDPL-FINE-D': 'Epäonnistuminen DSR:lle',
            'PDPL-FINE-E': 'Tietoturvaloukkauksesta ilmoittamatta jättäminen',
            'PDPL-FINE-F': 'Ei-yhteensopiva käsittelysopimus',
            'PDPL-FINE-G': 'Arkaluonteisten tietojen käsittelyn rikkomukset',
            'PDPL-FINE-H': 'Lasten tietojenkäsittelyn rikkomukset',
            'PDPL-FINE-I': 'Automatisoidut päätöksentekorikkomukset',
            'PDPL-FINE-J': 'Viranomaisten määräysten noudattamatta jättäminen',
        },
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-A': 'Viranomaisten pyyntöjen käsittelyvirheet',
            'TELECOM-FINE-B': 'Luottamuksellisuus ja luvaton paljastaminen',
            'TELECOM-FINE-C': 'Kulunvalvonta- ja kirjausvirheet',
            'TELECOM-FINE-D': 'Säilytys- ja poistamisrikkomukset',
            'TELECOM-FINE-E': 'Televiestintätapahtumien arvioinnin epäonnistumiset',
        },
    },
    framework_fines_detail: {
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-E': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Välittömästi havaitsemisen jälkeen',
            },
            'TELECOM-FINE-D': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Jatkuva velvoite',
            },
            'TELECOM-FINE-C': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Jatkuva velvoite',
            },
            'TELECOM-FINE-B': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Jatkuva velvoite',
            },
            'TELECOM-FINE-A': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Kuten viranomaispyynnössä on ilmoitettu',
            },
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-E': {
                fine_individual: 'Jopa 80 miljoonaa VND',
                fine_org: 'Jopa 160 miljoonaa VND',
                deadlines: 'Jatkuva velvoite',
            },
            'ECOM-FINE-D': {
                fine_individual: 'Jopa 80 miljoonaa VND',
                fine_org: 'Jopa 160 miljoonaa VND',
                deadlines: 'Jatkuva velvoite',
            },
            'ECOM-FINE-C': {
                fine_individual: 'Jopa 80 miljoonaa VND',
                fine_org: 'Jopa 160 miljoonaa VND',
                deadlines: 'Jatkuva velvoite',
            },
            'ECOM-FINE-B': {
                fine_individual: 'Jopa 80 miljoonaa VND',
                fine_org: 'Jopa 160 miljoonaa VND',
                deadlines: 'Valituksen käsittelyvelvollisuuksien mukaisesti',
            },
            'ECOM-FINE-A': {
                fine_individual: 'Jopa 80 miljoonaa VND',
                fine_org: 'Jopa 160 miljoonaa VND',
                deadlines: 'Ennen sähköisen kaupankäynnin aloittamista',
            },
        },
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-G': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Jatkuva velvoite',
            },
            'CYBERSEC-FINE-F': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Kuten viranomaisen pyynnöstä on ilmoitettu',
            },
            'CYBERSEC-FINE-E': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Jatkuva velvoite',
            },
            'CYBERSEC-FINE-D': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Kuten viranomaisen päätöksessä on määritelty; jatkuva velvoite, jos se on käynnistetty',
            },
            'CYBERSEC-FINE-C': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Kuten viranomaispyynnössä on ilmoitettu',
            },
            'CYBERSEC-FINE-B': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Jatkuva velvoite; hallintalaitteiden on oltava paikoillaan ennen järjestelmän käyttöä',
            },
            'CYBERSEC-FINE-A': {
                fine_individual: 'Jopa 100 miljoonaa VND',
                fine_org: 'Jopa 200 miljoonaa VND',
                deadlines: 'Välitön vastaus vaaditaan; raportoida määrätyssä aikataulussa',
            },
        },
        VN_PDPL: {
            'PDPL-FINE-A': {
                fine_individual: 'Jopa 1,5 miljardia VND',
                fine_org: 'Jopa 3 miljardia VND',
                deadlines: '60 päivää käsittelyn aloittamisesta aineiston toimittamiseen [[TOK_0]]',
            },
            'PDPL-FINE-B': {
                fine_individual: 'Jopa 1,5 miljardia VND',
                fine_org: 'Jopa 3 miljardia VND',
                revenue: '3–5 % edellisen vuoden Vietnamin tuloista vaikeissa tapauksissa',
                deadlines: '60 päivää käsittelyn alkamisesta toimittaa asiakirja [[TOK_0]]:lle; vaaditaan siirron jälkeinen ilmoitus',
            },
            'PDPL-FINE-C': {
                fine_individual: 'Jopa 1,5 miljardia VND',
                fine_org: 'Jopa 3 miljardia VND',
                deadlines: 'Jatkuva velvoite; suostumus on hankittava ennen käsittelyä',
            },
            'PDPL-FINE-D': {
                fine_individual: 'Jopa 1,5 miljardia VND',
                fine_org: 'Jopa 3 miljardia VND',
                deadlines: '2 työpäivää menettelyllinen vastaus; 10 päivää pääsy/korjaus; 15 päivää peruutus/rajoitus/vastuu; 20 päivän poisto',
            },
            'PDPL-FINE-E': {
                fine_individual: 'Jopa 1,5 miljardia VND',
                fine_org: 'Jopa 3 miljardia VND',
                deadlines: '2 työpäivää aikaa ilmoittaa [[TOK_0]] rikkomuksen havaitsemisesta',
            },
            'PDPL-FINE-F': {
                fine_individual: 'Jopa 1,5 miljardia VND',
                fine_org: 'Jopa 3 miljardia VND',
                deadlines: 'Jatkuva velvoite',
            },
            'PDPL-FINE-G': {
                fine_individual: 'Jopa 1,5 miljardia VND',
                fine_org: 'Jopa 3 miljardia VND',
                deadlines: 'Jatkuva velvoite; valvonta on oltava käytössä ennen arkaluonteisten tietojen käsittelyä',
            },
            'PDPL-FINE-H': {
                fine_individual: 'Jopa 1,5 miljardia VND',
                fine_org: 'Jopa 3 miljardia VND',
                deadlines: 'Jatkuva velvoite; vanhempien suostumus vaaditaan ennen käsittelyä',
            },
            'PDPL-FINE-I': {
                fine_individual: 'Jopa 1,5 miljardia VND',
                fine_org: 'Jopa 3 miljardia VND',
                deadlines: 'Jatkuva velvoite',
            },
            'PDPL-FINE-J': {
                fine_individual: 'Jopa 1,5 miljardia VND',
                fine_org: 'Jopa 3 miljardia VND',
                revenue: 'Jopa 5 % edellisen vuoden Vietnamin tuloista toistuvista rikkomuksista',
                deadlines: 'Kuten viranomaismääräyksessä on määritelty',
            },
        },
    },
    framework_procedures_detail: {
        VN_DP_DRAFT_P7: {
            trigger: 'Alustan jatkuva toiminta',
            responsible: {
                '1': 'Alustan käyttäjä / riski',
                '2': 'Alustan käyttäjä/turvallisuus',
                '3': 'Alustan käyttäjä / riski',
                '4': 'Alustan käyttäjä/turvallisuus',
                '5': 'Alustan operaattori',
                '6': 'Vaatimustenmukaisuus',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P6: {
            trigger: 'Osallistuja tekee valituksen tai kiistapyynnön',
            responsible: {
                '1': 'Alustan operaattori',
                '2': 'Alustan operaattori',
                '3': 'Alustan operaattori',
                '4': 'Alustan operaattori',
                '5': 'Alustan operaattori / lakimies',
                '6': 'Alustan operaattori',
                '7': 'Vaatimustenmukaisuus',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P5: {
            trigger: 'Toimitus päättyy sopimuksen ja maksuehtojen täyttyessä',
            responsible: {
                '1': 'Myyjä / alustan operaattori',
                '2': 'Alustan operaattori',
                '3': 'Alustan operaattori',
                '4': 'Alustan operaattori',
                '5': 'Alustan operaattori',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P4: {
            trigger: 'Ostaja aloittaa tiedon, tuotteen tai palvelun tapahtuman',
            responsible: {
                '1': 'Ostaja',
                '2': 'Ostaja / alustan operaattori',
                '3': 'Alustan operaattori',
                '4': 'Ostaja / Myyjä',
                '5': 'Alustan operaattori / maksu',
                '6': 'Alustan operaattori',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P3: {
            trigger: 'Osallistuja haluaa arvioida datatuotteita/palveluita eristetyssä ympäristössä',
            responsible: {
                '1': 'Osallistuja',
                '2': 'Alustan operaattori / osallistuja',
                '3': 'Alustan operaattori / IT',
                '4': 'Alustan käyttäjä/turvallisuus',
                '5': 'Alustan operaattori',
                '6': 'Alustan operaattori',
                '7': 'Alustan operaattori / IT',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P2: {
            trigger: 'Myyjä pyrkii listaamaan dataa, tuotetta tai datapalvelua kaupankäyntiä varten',
            responsible: {
                '1': 'Myyjä',
                '2': 'Myyjä/lakimies',
                '3': 'Myyjä / IT',
                '4': 'Myyjä',
                '5': 'Myyjä',
                '6': 'Alustan operaattori',
                '7': 'Alustan operaattori',
                '8': 'Alustan operaattori',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P1: {
            trigger: 'Myyjä tai ostaja liittyy tietoalustaan',
            responsible: {
                '1': 'Alustan operaattori',
                '2': 'Alustan operaattori / lakimies',
                '3': 'Alustan operaattori / lakimies',
                '4': 'Alustan operaattori',
                '5': 'Alustan operaattori',
                '6': 'Alustan operaattori',
                '7': 'Vaatimustenmukaisuus',
            },
            step_outputs: {},
        },
        PDPL_P1: {
            trigger: 'Vaikutustenarviointia vaativan henkilötietojen käsittelyn aloittaminen',
            responsible: {
                '1': '[[TOK_0]] / Tietosuojatiimi',
                '2': 'Tietosuojatiimi',
                '3': 'Laki / vaatimustenmukaisuus',
                '4': '[[TOK_0]] / Tietosuojatiimi',
                '5': 'Compliance Team',
            },
            step_outputs: {},
        },
        PDPL_P2: {
            trigger: 'Aikomus siirtää henkilötietoja Vietnamin ulkopuolelle',
            responsible: {
                '1': '[[TOK_0]] / Tietosuojatiimi',
                '2': 'Laki / vaatimustenmukaisuus',
                '3': 'Laki / vaatimustenmukaisuus',
                '4': '[[TOK_0]] / Tietosuojatiimi',
            },
            step_outputs: {},
        },
        PDPL_P3: {
            trigger: 'Sertifiointia vaativia tietojenkäsittelypalveluita tarjoava organisaatio',
            responsible: {
                '1': 'Laki / vaatimustenmukaisuus',
                '2': 'Laki / vaatimustenmukaisuus',
                '3': '[[TOK_0]] / Tietosuojatiimi',
                '4': 'Compliance Team',
            },
            step_outputs: {},
        },
        PDPL_P4: {
            trigger: 'Rekisteröidyn oikeuksia koskevan pyynnön vastaanotto',
            responsible: {
                '1': 'Tietosuojatiimi / Asiakaspalvelu',
                '2': '[[TOK_0]] / Tietosuojatiimi',
                '3': 'Osastonjohtajat / IT',
                '4': '[[TOK_0]] / Tietosuojatiimi',
                '5': 'Compliance Team',
            },
            step_outputs: {},
        },
        PDPL_P5: {
            trigger: 'Henkilötietosuojarikkomuksen tai -loukkauksen havaitseminen',
            responsible: {
                '1': 'Tapahtumavalvontatiimi / [[TOK_0]]',
                '2': '[[TOK_0]] / Tietosuojatiimi',
                '3': 'Laki / vaatimustenmukaisuus',
                '4': '[[TOK_0]] / Välikohtausryhmä',
            },
            step_outputs: {},
        },
    },
    framework_deadline_references: {
        'PDPL Art. 9': '[[TOK_0]] Art. 9',
        'PDPL Art. 17': '[[TOK_0]] Art. 17',
        'PDPL Art. 23': '[[TOK_0]] Art. 23',
        'Decree 13 Art. 24': 'Asetus 13 Art. 24',
        'MoPS Admin Procedures': 'MoPS-järjestelmänvalvojan menettelyt',
        'Annual cycle': 'Vuotuinen sykli',
        'Decree 13/2023/NĐ-CP Art. 24': 'Asetus [[TOK_0]Đ-CP Art. 24',
        'Decree 356/2025/NĐ-CP Art. 25(4)': 'Asetus [[TOK_0]Đ-CP Art. 25(4)',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2': 'Asetus [[TOK_0]Đ-CP Art. 5 Cl. 2',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2–5': 'Asetus [[TOK_0]Đ-CP Art. 5 Cl. 2–5',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 3': 'Asetus [[TOK_0]Đ-CP Art. 5 Cl. 3',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 4': 'Asetus [[TOK_0]Đ-CP Art. 5 Cl. 4',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 5': 'Asetus [[TOK_0]Đ-CP Art. 5 Cl. 5',
        'Decree 356/2025/NĐ-CP Art. 8(3)': 'Asetus [[TOK_0]Đ-CP Art. 8(3)',
        'Draft Decree on Data Platforms 2026': 'Tietoalustoja koskeva asetusluonnos 2026',
        'Law 122/2025/QH15 Ch. III; NĐ 98/2020; NĐ 24/2025': 'Laki [[TOK_0] Ch. III; NĐ 98/2020; NĐ 24/2025',
        'Law 122/2025/QH15 Ch. IV (Consumer Protection)': 'Laki [[TOK_0] Ch. IV (kuluttajansuoja)',
        'Law 122/2025/QH15 — Online.gov.vn operational procedure': 'Laki [[TOK_0]] — Online.gov.vn:n toimintamenettely',
        'Law 134/2025/QH15 Article 12': 'Lain [[TOK_0]] 12 artikla',
        'Law 134/2025/QH15 Article 21': 'Lain [[TOK_0]] 21 artikla',
        'Law 134/2025/QH15 Article 27': 'Lain [[TOK_0]] 27 artikla',
        'Law 134/2025/QH15 Articles 9–10': 'Laki [[TOK_0]] 9–10 artikla',
        'Law 24/2023/QH15 — article mapping pending': 'Laki [[TOK_0]] — artikkelikartoitus vireillä',
        'Law 60/2024/QH15 (internal control target)': 'Laki [[TOK_0]] (sisäisen valvonnan tavoite)',
        'Law 91/2025/QH15 Art. 21': 'Laki [[TOK_0]] Art. 21',
        'Law 91/2025/QH15 Art. 23': 'Laki [[TOK_0]] Art. 23',
        'Policy-defined': 'Käytännön määrittelemä',
        Quarterly: 'Neljännesvuosittain',
        'QĐ 778/QĐ-BCA-A05 administrative procedure': 'QĐ 778/QĐ-BCA-A05 hallinnollinen menettely',
        'internal control target (Law 116/2025/QH15 Art. 24(2)(b), 41(5) — exact timeline pending implementing instrument)': 'sisäisen valvonnan tavoite (laki [[TOK_0]] 24 artiklan 2 kohdan b alakohta, 41 artiklan 5 kohta – tarkka aikataulu odottaa täytäntöönpanosäädöstä)',
        'internal control target (Law 116/2025/QH15 Art. 41(3) — exact timeline pending implementing instrument)': 'sisäisen valvonnan tavoite (laki [[TOK_0]] 41 artiklan 3 kohta – tarkka aikataulu odottaa täytäntöönpanosäädöstä)',
        'source verification pending': 'lähteen vahvistus odottaa',
        'Circular 83/2025/TT-NHNN — Ad-hoc Internal Audit Reporting to SBV (Layer 5)': 'Circular 83/2025/TT-NHNN ? Ad hoc -sis?isen tarkastuksen raportointi SBV:lle (kerros 5)',
        'Circular 83/2025/TT-NHNN — Annual ICAAP Report (Phụ lục III) (Layer 5)': 'Circular 83/2025/TT-NHNN ? Vuotuinen ICAAP-raportti (Ph? l?c III) (kerros 5)',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục I (Layer 5)': 'Circular 83/2025/TT-NHNN ? Vuotuinen Ph? l?c I (kerros 5)',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục IV (Layer 5)': 'Circular 83/2025/TT-NHNN ? Vuotuinen Ph? l?c IV (kerros 5)',
        'Circular 83/2025/TT-NHNN — Annual Risk Management Report (Phụ lục II) (Layer 5)': 'Circular 83/2025/TT-NHNN ? Vuotuinen riskienhallintaraportti (Ph? l?c II) (kerros 5)',
        'Circular 83/2025/TT-NHNN — Asset Management Responsibility (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN ? Vastuu varainhallinnasta (kerros 2, teema C)',
        "Circular 83/2025/TT-NHNN — Board / Members' Council Oversight (Layer 2, theme A)": 'Circular 83/2025/TT-NHNN ? Hallituksen / j?senten neuvoston valvonta (kerros 2, teema A)',
        'Circular 83/2025/TT-NHNN — Board Committees (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN ? Hallituksen valiokunnat (kerros 2, teema A)',
        'Circular 83/2025/TT-NHNN — Board Decisions and Minutes (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN ? Hallituksen p??t?kset ja p?yt?kirjat (kerros 2, teema A)',
        'Circular 83/2025/TT-NHNN — Branch Control Procedures (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN ? Sivukonttorien valvontamenettelyt (kerros 2, teema C)',
        'Circular 83/2025/TT-NHNN — Compliance Assessment of Internal Rules (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN ? Sis?isten s??nt?jen vaatimustenmukaisuuden arviointi (kerros 2, teema D)',
        'Circular 83/2025/TT-NHNN — Compliance Function (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN ? Compliance-toiminto (kerros 2, teema D)',
        'Circular 83/2025/TT-NHNN — Compliance Remediation Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN ? Compliance-korjausten seuranta (kerros 2, teema D)',
        'Circular 83/2025/TT-NHNN — Concentration Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Keskittym?riski (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Conflict of Interest (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN ? Eturistiriita (kerros 2, teema C)',
        'Circular 83/2025/TT-NHNN — Control Culture (Layer 2, theme A/B)': 'Circular 83/2025/TT-NHNN ? Valvontakulttuuri (kerros 2, teema A/B)',
        'Circular 83/2025/TT-NHNN — Credit Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Luottoriski (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Delegated Authority (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN ? Delegoitu toimivalta (kerros 2, teema C)',
        'Circular 83/2025/TT-NHNN — Early Implementation Notification (Layer 5)': 'Circular 83/2025/TT-NHNN ? Ilmoitus ennenaikaisesta k?ytt??notosta (kerros 5)',
        'Circular 83/2025/TT-NHNN — General Director Responsibility (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN ? P??johtajan vastuu (kerros 2, teema A)',
        'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? ICAAP (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Interest-Rate Risk in the Banking Book (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Pankkikirjan korkoriski (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Internal Audit Charter (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN ? Sis?isen tarkastuksen toimintaohje (kerros 2, teema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Engagements (Theme H)': 'Circular 83/2025/TT-NHNN ? Sis?isen tarkastuksen toimeksiannot (teema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings Communication (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN ? Sis?isen tarkastuksen havaintojen viestint? (kerros 2, teema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings and Corrective Actions (Theme H)': 'Circular 83/2025/TT-NHNN ? Sis?isen tarkastuksen havainnot ja korjaavat toimet (teema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Follow-Up (Theme H)': 'Circular 83/2025/TT-NHNN ? Sis?isen tarkastuksen jatkoseuranta (teema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Governance': 'Circular 83/2025/TT-NHNN ? Sis?isen tarkastuksen hallintamalli',
        'Circular 83/2025/TT-NHNN — Internal Audit Independence (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN ? Sis?isen tarkastuksen riippumattomuus (kerros 2, teema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Plan (Layer 2/Theme H)': 'Circular 83/2025/TT-NHNN ? Sis?isen tarkastuksen suunnitelma (kerros 2/teema H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Reporting to SBV (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN ? Sis?isen tarkastuksen raportointi SBV:lle (kerros 2, teema H)',
        'Circular 83/2025/TT-NHNN — Internal Control System Governance (Layer 2)': 'Circular 83/2025/TT-NHNN ? Sis?isen valvontaj?rjestelm?n hallintamalli (kerros 2)',
        'Circular 83/2025/TT-NHNN — Internal Reporting Procedure (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN ? Sis?isen raportoinnin menettely (kerros 2, teema C)',
        'Circular 83/2025/TT-NHNN — Internal Reports Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN ? Sis?isten raporttien rekisteri (kerros 4, teema F)',
        'Circular 83/2025/TT-NHNN — Law-Change Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN ? Lains??d?nt?muutosten seuranta (kerros 2, teema D)',
        'Circular 83/2025/TT-NHNN — Legal and Reputational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Oikeudellinen ja maineeseen liittyv? riski (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Limit Breach Escalation (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Rajaylityksen eskalointi (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Liquidity Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Likviditeettiriski (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — MIS Annual Review (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN ? MIS:n vuosikatselmus (kerros 4, teema F)',
        'Circular 83/2025/TT-NHNN — MIS Backup and Continuity (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN ? MIS:n varmuuskopiointi ja jatkuvuus (kerros 4, teema F)',
        'Circular 83/2025/TT-NHNN — MIS Escalation Mechanisms (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN ? MIS:n eskalointimekanismit (kerros 4, teema F)',
        'Circular 83/2025/TT-NHNN — MIS Reliability and Confidentiality (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN ? MIS:n luotettavuus ja luottamuksellisuus (kerros 4, teema F)',
        'Circular 83/2025/TT-NHNN — MIS Risk Data Sources (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN ? MIS:n riskidatan l?hteet (kerros 4, teema F)',
        'Circular 83/2025/TT-NHNN — Management Information System (Layer 4)': 'Circular 83/2025/TT-NHNN ? Johdon tietoj?rjestelm? (kerros 4)',
        'Circular 83/2025/TT-NHNN — Market Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Markkinariski (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Material Risk Register (Layer 3)': 'Circular 83/2025/TT-NHNN ? Olennaisten riskien rekisteri (kerros 3)',
        'Circular 83/2025/TT-NHNN — Model Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Malliriski (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — New Product Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Uuden tuotteen arviointi (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Operational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Operatiivinen riski (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Outsourcing BCP (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN ? Ulkoistamisen jatkuvuussuunnitelma (kerros 2, teema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Contracts (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN ? Ulkoistamissopimukset (kerros 2, teema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Controls': 'Circular 83/2025/TT-NHNN ? Ulkoistamisen valvontatoimet',
        'Circular 83/2025/TT-NHNN — Outsourcing Due Diligence (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN ? Ulkoistamisen due diligence (kerros 2, teema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Fallback Provider (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN ? Ulkoistamisen varatoimittaja (kerros 2, teema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Materiality (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN ? Ulkoistamisen olennaisuus (kerros 2, teema G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Monitoring (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN ? Ulkoistamisen seuranta (kerros 2, teema G)',
        'Circular 83/2025/TT-NHNN — Phụ lục V/VI Technical References (Layer 5)': 'Circular 83/2025/TT-NHNN ? Ph? l?c V/VI -tekniset viitteet (kerros 5)',
        'Circular 83/2025/TT-NHNN — Policy Register (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN ? K?yt?nt?rekisteri (kerros 2, teema C)',
        'Circular 83/2025/TT-NHNN — Professional Ethics (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN ? Ammattieettiset periaatteet (kerros 2, teema C)',
        'Circular 83/2025/TT-NHNN — Risk Appetite (Layer 3)': 'Circular 83/2025/TT-NHNN ? Riskinottohalukkuus (kerros 3)',
        'Circular 83/2025/TT-NHNN — Risk Committee Coordination (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN ? Riskikomitean koordinointi (kerros 2, teema E)',
        'Circular 83/2025/TT-NHNN — Risk Data Governance (Layer 3, theme E/F) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN ? Riskidatan hallintamalli (kerros 3, teema E/F) ? vaiheistettu 2028-01-01 asti',
        'Circular 83/2025/TT-NHNN — Risk Limit Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Riskirajojen katselmointi (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Risk Limits Framework (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Riskirajojen viitekehys (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Risk Management Function (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN ? Riskienhallintatoiminto (kerros 2, teema E)',
        'Circular 83/2025/TT-NHNN — Risk Methodology and Models (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN ? Riskimenetelm?t ja -mallit (kerros 2, teema E)',
        'Circular 83/2025/TT-NHNN — Risk Reporting (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN ? Riskiraportointi (kerros 2, teema E)',
        'Circular 83/2025/TT-NHNN — Risk Reporting Cadence (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN ? Riskiraportoinnin rytmi (kerros 4, teema F)',
        'Circular 83/2025/TT-NHNN — SBV Remediation Submission (Layer 5)': 'Circular 83/2025/TT-NHNN ? Korjaustoimien toimittaminen SBV:lle (kerros 5)',
        'Circular 83/2025/TT-NHNN — SBV Submission Channels (Layer 5)': 'Circular 83/2025/TT-NHNN ? SBV:n toimituskanavat (kerros 5)',
        'Circular 83/2025/TT-NHNN — Sector Applicability (Layer 1)': 'Circular 83/2025/TT-NHNN ? Toimialakohtainen soveltuvuus (kerros 1)',
        'Circular 83/2025/TT-NHNN — Segregation of Duties (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN ? Teht?vien eriytt?minen (kerros 2, teema C)',
        'Circular 83/2025/TT-NHNN — Senior Management Supervision (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN ? Ylimm?n johdon valvonta (kerros 2, teema A)',
        'Circular 83/2025/TT-NHNN — Strategic Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN ? Strateginen riski (kerros 3, teema E)',
        'Circular 83/2025/TT-NHNN — Stress Testing (Layer 3, theme E) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN ? Stressitestaus (kerros 3, teema E) ? vaiheistettu 2028-01-01 asti',
        'Circular 83/2025/TT-NHNN — Supervisory Board (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN ? Valvontaneuvosto (kerros 2, teema A)',
        'Circular 83/2025/TT-NHNN — Supervisory Findings Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN ? Valvontahavaintojen rekisteri (kerros 4, teema F)',
        'Circular 83/2025/TT-NHNN — Three Lines Roles and Escalation (Layer 2, theme B)': 'Circular 83/2025/TT-NHNN ? Kolmen puolustuslinjan roolit ja eskalointi (kerros 2, teema B)',
        'Circular 83/2025/TT-NHNN — Three Lines of Defence (Layer 2)': 'Circular 83/2025/TT-NHNN ? Kolme puolustuslinjaa (kerros 2)',
        'Circular 83/2025/TT-NHNN — Violation Escalation (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN ? Rikkomuksen eskalointi (kerros 2, teema D)',
    },
    framework_authorities: {
        'Quốc hội (National Assembly)': 'Quốc hội (kansalliskokous)',
        'Ministry of Public Security / A05 Department': 'Yleisen turvallisuuden ministeriö / A05-osasto',
        'Ministry of Public Security': 'Yleisen turvallisuuden ministeriö',
        'Ministry of Information and Communications': 'Tieto- ja viestintäministeriö',
        'Government of Vietnam': 'Vietnamin hallitus',
        'European Data Protection Board (EDPB)': 'Euroopan tietosuojalautakunta (EDPB)',
        'ENISA / National CSIRTs': 'ENISA / kansalliset CSIRT-ryhmät',
        'State Bank of Vietnam': 'Vietnamin valtionpankki',
    },
    tour_titles: {
        access_accountability: 'Pääsy Accountability Tour',
        assessments: 'Arviointikierros',
        audit_trail: 'Audit Trail -esittely',
        classification: 'Luokittelukierros',
        compliance_forms: 'Vaatimustenmukaisuuslomakkeiden esittely',
        connectors: 'Liitinten esittely',
        consent_properties: 'Suostumuksen kiinteistöjen esittely',
        consent: 'Suostumuskierros',
        dashboard: 'Kojelautakierros',
        data_mapping: 'Tietojen kartoituskierros',
        data_subjects: 'Rekisteröityjen kierros',
        deletion_orchestration: 'Poiston orkestraatiokierros',
        discovery: 'Tietojen l?ydett?vyyden esittely',
        governance: 'Hallintokierros',
        help_center: 'Ohjekeskuksen esittely',
        incident_ops: 'Tapahtuma-operaatioiden esittely',
        incidents: 'Tapahtumien esittely',
        localization: 'Lokalisointikierros',
        monitoring: 'Seurantakierros',
        onboarding: 'Aloituskierros',
        organizations: 'Organisaatioiden esittely',
        partner_workspace: 'Kumppanity?tilan esittely',
        platform_settings: 'Alustan asetusten esittely',
        privacy_scanner: 'Tietosuojaskannerin esittely',
        program_governance: 'Ohjelman hallintokierros',
        rights_requests: 'Oikeuspyyntöjen esittely',
        task_management: 'Tehtävienhallintakierros',
        vendor_risk: 'Myyjän riskikierros',
    },
    tour_descriptions: {
        access_accountability: 'Sisäisen tarkastuksen johtajana (P-VN-10) tarkasta käyttötodisteet, tarkastuslupien käyttö ja tutki poikkeavia malleja osoittaaksesi [[TOK_0]] artiklan 5(1) f) eheyden ja luottamuksellisuuden.',
        assessments: 'Yritys [[TOK_1]] (P-VN-01) suorittaa DPIA:n asetuksen 356 Mau so 02a mukaisesti, tunnistaa noudattamispuutteet ja arvioi rajat ylittävän siirron riskit kohdassa [[TOK_0]].',
        audit_trail: 'Sisäisen tarkastuksen päähenkilönä (P-VN-10 voit tiedustella moduulien välistä todistetta, koota tarkastuspaketteja ja viedä peukalointilokeja säädöstenmukaisia lähetyksiä varten.',
        classification: 'Tietojen valvojana (P-VN-05) määritä tietojen luokittelutaksonomiat, määritä herkkyystunnisteet, valvo säilytyskäytäntöjä ja ratkaise [[TOK_0]]:n noudattamisen edellyttämät kattavuusaukot.',
        compliance_forms: 'Yrityksenä [[TOK_0]] (P-VN-01) selaa, täytä ja lähetä virallisia Vietnamin sääntelylomakkeita, mukaan lukien Phu luc I-, Phu luc II- ja Mau so -malleja PDP-komitean hakemuksia varten.',
        connectors: 'IT-järjestelmien johtajana (P-VN-05) ota huomioon integraatioiden liiketoimintavaatimukset, yhdistä liittimet vaatimustenmukaisiin tietovirtoihin ja varmista POC-valmius ennen julkaisemista.',
        consent_properties: 'Yritys [[TOK_1]] (P-VN-01) määritä [[TOK_2]]-käyttöönotto: digitaalinen omaisuuden rekisteröinti, kultaiset mallit johdonmukaisia [[TOK_0]]-suostumusbannereita varten ja sidontamatriisit, jotka linkittävät ominaisuuksia käsittelytoimintoihin.',
        consent: 'Yrityksenä [[TOK_1]] (P-VN-01) hallitse suostumuskäytännön elinkaarta: määritä keräämistarkoitukset, pane [[TOK_0]]-peruuttamisoikeudet täytäntöön ja integroi suostumuksen hallintaalustaan.',
        dashboard: 'Yritys [[TOK_1]] (P-VN-01) suuntaudu vaatimustenmukaisuusasennon komentokeskukseen, joka paljastaa [[TOK_0]]-määräajat, rikkomukset SLA-sopimukset ja auditointivalmiuden KPI:t.',
        data_mapping: 'Tietojen valvojana (P-VN-05) rakenna ROPA-inventaarisi, kartoita rajat ylittäviä tietovirtoja ja ylläpidä [[TOK_0]]:n edellyttämää käsittelytoimintarekisteriä.',
        data_subjects: 'Yrityksen DPO tai Education Compliance Lead -johtajana hallitse yhtenäisiä rekisteröityjen profiileja, jotka linkittävät suostumustietueet, oikeuspyynnöt ja aikajanan toiminnan alustalla.',
        deletion_orchestration: 'Kuten [[TOK_1]] (P-VN-01), varmista päästä päähän tietojen poistaminen sisäisistä järjestelmistä ja kolmansien osapuolien toimittajista salausvarmistusketjuilla [[TOK_0]] artiklan 17 poisto-oikeuden noudattamiseksi.',
        discovery: 'Tietojen valvojana (P-VN-05) suorita automaattisia tarkistuksia löytääksesi henkilökohtaisia tietoja yhdistetyistä järjestelmistä, tarkista vaiheittaiset löydökset ja syötä tulokset [[TOK_0]]-merkintöjä varten luokittelumoduuliin.',
        governance: 'Myyjän riskipäällikkönä (P-VN-08 ylläpitää toimittajarekisteriä, seurata aliprosessorin ketjuja, arvioida rajat ylittävien siirtojen riskejä ja valvoa hallinnointiohjeita [[TOK_0]]:ssa.',
        help_center: 'Kaikille henkilöille – tietosuojavastaaville, tarkastajille, IT-johtajille ja vaatimustenmukaisuuspäälliköille – löydät vastaukset, ohjeet ja moduulikohtaiset asiakirjat päivittäisten vaatimustenmukaisuuden työnkulkujen tueksi.',
        incident_ops: 'Tapahtumakomentajana (P-VN-09 aktivoi vastausleikit, seuraa [[TOK_1]] 72 tunnin [[TOK_0]] ilmoitusikkunan noudattamista, hallitse eskalaatioita ja koordinoi toimittajan vastausta.',
        incidents: 'Incident Commander (P-VN-09) havaitse ja raportoi tietoturvaloukkauksista 72 tunnin [[TOK_0]] ilmoitusvelvollisuudella PDP-komitealle, luokittele vakavuuden mukaan ja rakenna tarkastustason tapausasiakirjat.',
        localization: 'Yritys [[TOK_1]] (P-VN-01) hallitse sääntelykehyksen elinkaarta: asenna vietnamilaiset markkinapaketit, aktivoi [[TOK_0]]- ja Decree 13 -kehykset, yhdistä vaatimukset alustamoduuleihin ja hallitse käännöksiä.',
        monitoring: 'Yritys [[TOK_1]] (P-VN-01) perustaa jatkuvat vaatimustenmukaisuuden seurantaohjelmat, seuraa säädösten muutoksia, mittaa KPI:itä ja hallitse säännösten mukaisia vuorovaikutustapauksia [[TOK_0]]:n mukaisesti.',
        onboarding: 'Compliance Trainer (P-VN-02) anna koulutusta opastetuilla kierroksilla, lataa realistisia näytetietoja käytännön harjoituksia varten ja suorita ohjattu asennustoiminto pika-aloitusskenaarioihin.',
        organizations: '[[TOK_0]] (P-VN-01) määritä usean organisaation vaatimustenmukaisuusrakenteet, määritä osastohierarkiat ja reititä rekisteröidyt pyynnöt koko yritysryhmässäsi.',
        partner_workspace: 'Kumppanitilipäällikkönä osallistu kumppaniorganisaatioihin, määritä palvelutasoja, seuraa vaatimustenmukaisuuden toimituksia ja hallitse kumppanimarkkinoita.',
        platform_settings: 'Alustan järjestelmänvalvojana hallitset kaikkia toiminnallisia määrityksiä – identiteettiä, suojausta, integraatioita ja moduulien käyttöoikeuksia, jotka tukevat vaatimustenmukaisuusohjelmaasi.',
        privacy_scanner: 'Tietosuojaanalyytikona (P-VN-06) suorita jatkuvaa valvontaskannausta evästeiden suostumuksen rikkomusten, luvattomien seurantalaitteiden ja käytäntöjen aukkojen havaitsemiseksi. Näin saat todisteita sähköisen viestinnän tietosuojasta ja [[TOK_0]] noudattamisesta.',
        program_governance: 'Selaa kypsyysmallien, arvioiden, todisteiden aukkojen, yhteenvetojen ja muiden välillä. Jokainen alamoduuli antaa kokonaisvaltaisen näkemyksen sisäisestä ohjelman tilasta.',
        rights_requests: 'Yrityksenä [[TOK_1]] (P-VN-01) hallitse [[TOK_0]]-kohdassa olevia rekisteröidyn oikeuksia koskevia pyyntöjä 15 päivän lakisääteisillä määräajoilla, henkilöllisyyden todentamisella ja tilintarkastustason ratkaisupoluilla.',
        task_management: 'Ohjaa vaatimustenmukaisuustehtävät henkilöiden välillä, seuraa [[TOK_0]] määräaikoja ja automatisoi työnkulkuja, jotka pitävät tiimisi vastuullisena.',
        vendor_risk: 'Toimittajan riskipäällikkönä (P-VN-08) arvioi kolmannen osapuolen riskejä, pakota porttitarkastuksia ja käynnistä uudelleenarviointeja – eri kuin ohjelman hallinta, joka seuraa sisäistä kypsyytesi.',
    },
    consolidation: {
        title: 'Konsolidointitapaukset',
        new_case: 'Luo konsolidointitapaus',
        case_count: 'case',
        created: 'Konsolidointitapaus luotu',
        create: 'Luo tapaus',
        creating: 'Luodaan...',
        cancel: 'Peruuta',
        no_cases: 'Konsolidointitapauksia ei löytynyt.',
        all_statuses: 'Kaikki tilat',
        all_purposes: 'Kaikki käyttötarkoitukset',
        filter_status: 'Suodata tilan mukaan',
        filter_purpose: 'Suodata käyttötarkoituksen mukaan',
        col_title: 'Otsikko',
        col_purpose: 'Tarkoitus',
        col_status: 'Tila',
        col_progress: 'Edistyminen',
        col_deadline: 'Määräaika',
        col_department: 'osasto',
        col_version: 'Versio',
        col_evidence: 'Todisteet',
        sections_accepted: 'accepted',
        prev: 'Edellinen',
        next: 'Seuraavaksi',
        page: 'Sivu',
        prev_page: 'Edellinen sivu',
        next_page: 'Seuraava sivu',
        field_title: 'Otsikko',
        field_purpose: 'Tarkoitus',
        field_framework: 'Puitekoodi',
        field_deadline: 'Määräaika',
        field_reviewer: 'Tarkistajan käyttäjätunnus',
        title_placeholder: 'Anna tapauksen otsikko',
        framework_placeholder: 'esim. PDPD-2023',
        reviewer_placeholder: 'Anna arvioijan käyttäjätunnus',
        purposes: {
            dpia_filing: '[[TOK_0]] Arkistointi',
            cross_border_filing: 'Rajat ylittävä arkistointi',
            annual_governance_attestation: 'Vuosittainen hallintotodistus',
            breach_package: 'Rikkomuspaketti',
            audit_inspection_pack: 'Audit Inspection Pack',
        },
        statuses: {
            draft: 'Luonnos',
            collecting: 'Keräily',
            consolidating: 'Konsolidoituu',
            review: 'Tarkista',
            corrections: 'Korjaukset',
            pending_approval: 'Odottaa hyväksyntää',
            approved: 'Hyväksytty',
            completed: 'Valmis',
            closed: 'Suljettu',
            rejected: 'Hylätty',
        },
        section_statuses: {
            pending: 'Odottaa',
            in_progress: 'Meneillään',
            submitted: 'Lähetetty',
            accepted: 'Hyväksytty',
            needs_correction: 'Vaatii korjausta',
            corrected: 'Korjattu',
        },
        flag_types: {
            missing_section: 'Osa puuttuu',
            conflicting_entry: 'Ristiriitainen sisääntulo',
            stale_entry: 'Vanhentunut sisääntulo',
            missing_evidence: 'Puuttuva todiste',
            incomplete_data: 'Puutteelliset tiedot',
            duplicate_entry: 'Päällekkäinen merkintä',
        },
        flag_severities: {
            critical: 'Kriittinen',
            warning: 'Varoitus',
            info: 'Tietoja',
        },
        sections_title: 'Osat',
        no_sections: 'Osioita ei ole vielä määritetty.',
        flags_title: 'Liput',
        no_flags: 'Lippuja ei havaittu.',
        open: 'open',
        approval_chain: 'Hyväksyntäketju',
        pending: 'Odottaa',
        audit_trail: 'Audit Trail',
        no_audit: 'Ei tarkastustapahtumia.',
        auto_assign: 'Määritä osiot automaattisesti',
        start_collection: 'Aloita kokoelma',
        review_case: 'Tarkista tapaus',
        generate_export: 'Luo vienti',
        review_title: 'Konsolidointikatsaus',
        advance_approval: 'Ennakkohyväksyntä',
        back_to_case: 'Takaisin tapaukseen',
        accept: 'Hyväksy',
        return_section: 'Palaa',
        return_comment: 'Palauta kommentti...',
        resolve: 'Ratkaise',
        dismiss: 'Hylkää',
        resolution_notes: 'Päätösmuistiinpanot...',
        notes: 'Huomautuksia',
        section_accepted: 'Osio hyväksytty',
        section_returned: 'Osa palautettiin korjattavaksi',
        advanced_to_approval: 'Tapaus on edennyt odottavaan hyväksyntään',
        section_data: 'Osion tiedot',
        save_progress: 'Tallenna edistyminen',
        submit_section: 'Lähetä osio',
        submitting: 'Lähetetään...',
        resubmit: 'Lähetä uudelleen',
        progress_saved: 'Edistyminen tallennettu',
        section_submitted: 'Osio lähetetty',
        correction_required: 'Korjaus vaaditaan',
        evidence_title: 'Todisteet',
        no_evidence: 'Ei todisteita liitteenä.',
        add_evidence: 'Lisää todisteita',
        evidence_added: 'Todisteet lisätty',
        evidence_files: 'todisteet tiedostot',
        uploaded_by: 'ladannut',
        comments_title: 'Kommentit',
        no_comments: 'Ei vielä kommentteja.',
        comment_placeholder: 'Lisää kommentti...',
        add_comment: 'Lisää kommentti',
        comment_added: 'Kommentti lisätty',
        view_data: 'Näytä lähetetyt tiedot',
        export_title: 'Asiakirjojen vienti',
        export_generated: 'Vientipaketti luotu',
        regenerate: 'Luo uudelleen',
        regenerating: 'Regeneroidaan...',
        generated_at: 'Luotu klo',
        artifacts_title: 'Vie esineitä',
        artifact_type: 'Artefaktti',
        file_name: 'Tiedoston nimi',
        file_size: 'Koko',
        generated: 'Luotu',
        download: 'Lataa',
        artifacts: {
            master_report: 'Pääraportti',
            evidence_bundle: 'Todistuspaketti (ZIP)',
            contributor_lineage: 'Contributor Lineage',
            conflict_resolution: 'Konfliktinratkaisu',
            approval_history: 'Hyväksyntähistoria',
        },
        official_forms: 'Viralliset lomakkeet',
        forms_description: 'Seuraavat viralliset lomakkeet voidaan muodostaa yhdistetyistä tiedoista. Viralliset lomakkeet ovat erillisiä sisäisistä työpapereista.',
        announce_loaded_cases: 'Ladattu [[TOK_1]] konsolidointitapausta',
        announce_case_detail_loaded: 'Asiakirjan tiedot ladattu',
        announce_case_transitioned: 'Tapaus siirretty [[TOK_1]]',
        announce_flag_resolved: 'Lippu ratkaistu',
        announce_flag_dismissed: 'Lippu hylätty',
        case_detail_loaded: 'Asiakirjan tiedot ladattu',
        sections_auto_assigned: 'Osastohierarkiasta automaattisesti määrätyt osiot',
        errors: {
            load_failed: 'Tietojen lataaminen epäonnistui. Yritä uudelleen.',
            create_failed: 'Tapauksen luominen epäonnistui. Yritä uudelleen.',
            required_fields: 'Täytä kaikki vaaditut kentät.',
            not_found: 'Ei löytynyt.',
            comment_required: 'Kommentti vaaditaan osiota palautettaessa.',
            notes_required: 'Huomautuksia tarvitaan, kun lippua ratkaistaan tai hylätään.',
        },
    },
    rights_requests: {
        import: {
            title: 'Tuo tapauksia',
            nav_title: 'Massatuonti',
            description: 'Lataa CSV-tiedosto oikeuspyyntötapausten massatuontia varten.',
            select_file: 'Valitse CSV-tiedosto',
            file_help: 'CSV otsikoineen, jotka vastaavat tapauskenttiä.',
            file_too_large: 'Tiedosto on liian suuri. Enimmäiskoko on 2 Mt.',
            preview: 'Esikatselu',
            columns_detected: 'Havaitut sarakkeet: {count}',
            column_mapping: 'Sarakemääritys',
            import_button: 'Tuo',
            import_complete: 'Tuonti valmis',
            import_error: 'Tuonti epäonnistui',
            result: 'Tuontitulos',
            total: 'Yhteensä',
            imported: 'Tuotu',
            skipped: 'Ohitettu',
            failed: 'Epäonnistunut',
            errors: 'Virheet',
            error_row: 'Rivi',
            error_field: 'Kenttä',
            error_message: 'Viesti',
            history: 'Tuontihistoria',
            no_history: 'Ei tuontihistoriaa.',
            history_file: 'Tiedostonimi',
            history_date: 'Päivämäärä',
        },
        batch: {
            nav_title: 'Eräprosessi',
            page_title: 'DSR eräprosessi',
            page_subtitle: 'Lataa [[TOK_1]] odottavia DSR-tiedostoja. Forseti laatii pyyntökohtaisen kuittausvastauksen ja asettaa jonoon vahvistustehtävän riviä kohden. [[TOK_0]]-arvostelut + hyväksyy jokaisen ennen lähettämistä.',
            upload_heading: 'Lataa',
            csv_hint: 'Pakolliset sarakkeet: request_id, requester_email, request_type. Valinnainen: määräaika (ISO-8601), huomautukset.',
            rows_heading: '[[TOK_1]] riviä jäsennetty',
            submit_label: 'Suorita erä',
            submitting: 'Luonnostetaan…',
            col_request_id: 'Pyydä tunnus',
            col_email: 'Pyydä sähköposti',
            col_type: 'Kirjoita',
            col_status: 'Tila',
            col_actions: 'Toiminnot',
            status_queued: 'Jonossa',
            status_drafted: 'Laadittu',
            status_failed: 'Epäonnistui',
            status_accepted: 'Hyväksytty',
            status_rejected: 'Hylätty',
            'status_parsing-error': 'Jäsennysvirhe',
            accept: 'Hyväksy',
            reject: 'Hylkää',
            permission_denied: 'Sinulla ei ole oikeutta suorittaa Forseti-työnkulkuja.',
        },
    },
    assessment_triggers: {
        title: 'Arviointikäynnistimet',
        subtitle: 'Määritä automaattisen arvioinnin luominen ja [[TOK_0]] ilmoitukset tietosuojatyönkulkua varten.',
        auto_create_dpia_label: 'Luo [[TOK_0]] automaattisesti, kun vaaditaan [TOK_1]]-merkityn toiminnan käsittely',
        auto_notify_new_purpose_label: 'Ilmoita automaattisesti [[TOK_0]], kun uusi tarkoitus luodaan arkaluontoisten tietoluokkien avulla',
        auto_notify_cross_border_label: 'Ilmoita automaattisesti [[TOK_0]], kun rajat ylittävä siirto lisätään käsittelytoimintaan',
        default_dpo_label: 'Oletus [[TOK_0]]',
        default_dpo_placeholder: 'Valitse oletusarvo [[TOK_0]]...',
        notification_channels_label: 'Ilmoituskanavat',
        channel_in_app: 'Sovelluksen sisäinen',
        channel_email: 'S?hk?posti',
        save_success: 'Arviointikäynnistimen asetukset tallennettu.',
        save_error: 'Arviointikäynnistimen asetusten tallentaminen epäonnistui.',
        fetch_error: 'Arviointikäynnistimen asetusten lataaminen epäonnistui.',
        fetch_users_error: 'Käyttäjien lataaminen epäonnistui.',
        announce_loaded: 'Arviointikäynnistimen asetukset ladattu',
        dpia_status: '[[TOK_0]] Tila',
        dpia_linked: '[[TOK_0]] Linkitetty',
        dpia_required_no_dpia: '[[TOK_0]] Pakollinen – Ei luotu',
        create_dpia: 'Luo [[TOK_0]]',
        create_dpia_success: '[[TOK_0]] luotu ja linkitetty toimintaan.',
        create_dpia_error: '[[TOK_0]]:n luominen toiminnalle epäonnistui.',
        view_dpia: 'Näytä [[TOK_0]]',
    },
    data_subjects: {
        title: 'Rekisteröityjen profiilit',
        nav_title: 'Rekisteröidyt',
        nav: {
            profiles: 'Profiilit',
        },
        create: 'Luo profiili',
        edit: 'Muokkaa profiilia',
        delete: 'Poista profiili',
        delete_confirm: 'Haluatko varmasti poistaa tämän rekisteröidyn profiilin?',
        display_name: 'Näyttönimi',
        email: 'S?hk?posti',
        phone: 'Puhelin',
        employee_id: 'Työntekijän tunnus',
        student_id: 'Opiskelijatunnus',
        notes: 'Huomautuksia',
        external_refs: 'Ulkoiset viittaukset',
        cases_count: 'Tapaukset',
        workflows_count: 'Suostumustiedot',
        last_activity: 'Viimeinen toiminta',
        timeline: 'Aikajana',
        link_case: 'Link Case',
        link_workflow: 'Link Workflow',
        no_profiles: 'Rekisteröidyn profiileja ei löytynyt.',
        search_placeholder: 'Hae nimellä, sähköpostilla, puhelimella tai henkilötunnuksella...',
        create_success: 'Rekisteröidyn profiili luotu.',
        create_error: 'Rekisteröidyn profiilin luominen epäonnistui.',
        update_success: 'Rekisteröidyn profiili päivitetty.',
        update_error: 'Rekisteröidyn profiilin päivitys epäonnistui.',
        delete_success: 'Rekisteröidyn profiili poistettu.',
        delete_error: 'Rekisteröidyn profiilin poistaminen epäonnistui.',
        link_case_success: 'Tapaus linkitetty profiiliin.',
        link_case_error: 'Tapauksen linkittäminen profiiliin epäonnistui.',
        link_workflow_success: 'Työnkulku linkitetty profiiliin.',
        link_workflow_error: 'Työnkulun linkittäminen profiiliin epäonnistui.',
        load_error: 'Rekisteröidyn profiilien lataaminen epäonnistui.',
        detail_load_error: 'Rekisteröidyn profiilin lataaminen epäonnistui.',
        timeline_load_error: 'Aikajanan lataaminen epäonnistui.',
        tab_cases: 'DSR-tapaukset',
        tab_consent: 'Suostumustiedot',
        tab_timeline: 'Aikajana',
        tab_consent_workflows: 'Suostumustyönkulut',
        tab_web_consent: '[[TOK_0]] Suostumus',
        web_consent_empty: 'Tälle aiheelle ei löytynyt [[TOK_0]] suostumustietueita.',
        web_consent_load_error: '[[TOK_0]] suostumustietueiden lataaminen epäonnistui.',
        col_policy_version: 'Käytännön versio',
        col_versions: 'Versiot',
        col_consent_version: 'Suostumus',
        col_cookie_declaration_version: 'Evästeilmoitus',
        col_purposes: 'Tarkoitukset',
        purpose_granted: 'Myönnetty',
        purpose_denied: 'Kielletty',
        granted_domains: 'Myönnetty',
        denied_domains: 'Kielletty',
        col_action: 'Toiminta',
        col_timestamp: 'Aikaleima',
        col_domain: 'Verkkotunnus',
        no_cases: 'Ei yhdistettyjä tapauksia.',
        no_workflows: 'Ei linkitettyjä suostumustyönkulkuja.',
        no_timeline: 'Ei aikajanatapahtumia.',
        case_id: 'Tapaustunnus',
        case_status: 'Tila',
        case_type: 'Pyynnön tyyppi',
        case_created: 'Luotu',
        workflow_id: 'Työnkulun tunnus',
        workflow_type: 'Kirjoita',
        workflow_status: 'Tila',
        workflow_created: 'Luotu',
        timeline_date: 'Päivämäärä',
        timeline_event: 'Tapahtuma',
        timeline_details: 'Yksityiskohdat',
        timeline_time: 'Aika',
        timeline_type: 'Kirjoita',
        timeline_summary: 'Yhteenveto',
        type_case: 'DSR-kotelo',
        type_consent_workflow: 'Suostumustyönkulku',
        profile_info: 'Profiilin tiedot',
        announce_loaded: 'Rekisteröidyn profiilit ladattu',
        announce_detail_loaded: 'Rekisteröidyn profiili ladattu',
        select_case: '— Valitse tapaus —',
        select_workflow: '— Valitse työnkulku —',
        no_cases_hint: 'Linkitä tapauksia nähdäksesi ne täällä.',
        no_workflows_hint: 'Linkitä suostumustyönkulkuja nähdäksesi ne täällä.',
    },
    flows: {
        map: {
            description_prefix: '[[TOK_4]] järjestelmät · [[TOK_5]] virrat · [[TOK_6]] rajat ylittävät · [[TOK_7]] suuri/kriittinen riski',
            switch_to_list: 'Vaihda luettelonäkymään',
            switch_to_list_aria: 'Vaihda taulukkonäkymään',
            svg_aria: 'Tietovirtakartta: [[TOK_3]] järjestelmät, [[TOK_4]] virrat, [[TOK_5]] rajat ylittävät',
            selected_system: 'Valittu järjestelmä',
            drill_hint: 'Avaa luettelo-välilehti muokataksesi tämän järjestelmän linkitettyjä kulkuja, DPIA:ita ja toimittajamäärityksiä.',
        },
    },
    packages: {
        light: {
            name: 'Kevyt',
            description: 'Olennaiset yksityisyyden vaatimustenmukaisuustyökalut pienille tiimeille',
        },
        standard: {
            name: 'Vakio',
            description: 'Täysin varustettu vaatimustenmukaisuusalusta kasvaville organisaatioille',
        },
        enterprise_unlimited: {
            name: 'Enterprise Unlimited',
            description: 'Yritystason vaatimustenmukaisuus monen organisaation tuella ja erityispalveluilla',
        },
    },
    forseti: {
        providerSettings: {
            title: 'Forseti [[TOK_0]] Palveluntarjoajan asetukset',
            subtitle: 'Määritä Claude-palveluntarjoaja Forseti [[TOK_0]] Legal Advisorille.',
            healthHeading: 'Terveyden tarjoaja',
            statusLabel: 'Tila',
            statusOk: 'OK',
            statusFailed: 'Ei saatavilla',
            providerLabel: 'Palveluntarjoaja',
            providerClaudeApi: 'Claude [[TOK_0]]',
            providerCliRelay: 'Claude CLI rele',
            providerAesirManaged: 'Aesirin hallinnoimat rahakkeet',
            lastCheckedLabel: 'Viimeksi tarkistettu',
            reasonLabel: 'Syy',
            refreshButton: 'Päivitä',
            apiKeyHeading: 'Claude [[TOK_0]]-avain',
            apiKeyHint: '[[TOK_0]]-näppäimen asettaminen aktivoi Claude [[TOK_1]]-tilan. Jätä määrittämättä, jos haluat käyttää paikallista CLI-välitystä (kehittäjä / itseisännöity tila).',
            apiKeyLabel: '[[TOK_0]]-näppäintä',
            apiKeyMinLength: 'Vähintään 32 merkkiä. Salattu levossa; ei koskaan näytetty uudelleen.',
            apiKeyTooShort: '[[TOK_0]]-avaimessa on oltava vähintään 32 merkkiä.',
            apiKeySaved: '[[TOK_0]] avain tallennettu. Virkistävää terveyttä…',
            apiKeyCleared: '[[TOK_0]] avain tyhjennetty. Forseti käyttää nyt paikallista CLI-välitystä.',
            setKeyButton: 'Tallenna [[TOK_0]]-avain',
            clearKeyButton: 'Tyhjennä [[TOK_0]] avain (käytä CLI-relettä)',
        },
        usage: {
            title: 'Käyttö',
            subtitle: 'Tämän organisaation tunnuksen kulutus ja ryhmän tila.',
            bucketHeading: 'Kuukausittainen token-ämpäri',
            remainingLabel: 'Jäljellä',
            consumedLabel: 'Kulutettu',
            totalLabel: 'Yhteensä',
            unitsLabel: 'laskutettavat yksiköt',
            lastReconciledLabel: 'Viimeksi sovittu',
            recentHeading: 'Viimeaikainen toiminta',
            historyHeading: 'Viimeiset 12 jaksoa',
            noActivity: 'Ei toimintaa vielä tällä ajanjaksolla.',
            featureLabel: 'Ominaisuus',
            whenLabel: 'Milloin',
            periodLabel: 'Kausi',
            topUpButton: 'Pyydä täydennyspaketti',
            topUpHint: 'Ota yhteyttä tilivastaavaasi ja pyydä täydennyspaketti.',
            buyMore: {
                buyButton: 'Osta lisää yksiköitä',
                purchaseTitle: 'Osta lisää laskutusyksiköitä',
                purchaseSubtitle: 'Valitse paketti. Sinut ohjataan turvalliseen Stripe-kassaan, ja laskusi saapuu sähköpostitse.',
                packageLabel: 'Paketti',
                optionTemplate: '{name} — {units} {units_label} — {price}',
                packageSmall: 'Pieni',
                packageMedium: 'Keskikokoinen',
                packageLarge: 'Suuri',
                checkoutButton: 'Jatka kassalle',
                checkoutPending: 'Avataan kassaa…',
                cancelButton: 'Peruuta',
                purchaseError: 'Kassaa ei voitu avata. Yritä hetken kuluttua uudelleen.',
                redeemTitle: 'Lunasta lasku',
                redeemSubtitle: 'Oletko jo maksanut? Valitse ostamasi paketti ja syötä sähköpostissasi oleva laskun numero lisätäksesi yksiköt.',
                invoiceLabel: 'Laskun numero',
                invoicePlaceholder: 'JJVExxxX-0001',
                redeemButton: 'Lunasta',
                redeemPending: 'Lunastetaan…',
                redeemSuccess: 'Yksiköt lisätty kiintiöösi.',
                redeemAlready: 'Tämä lasku on jo lunastettu.',
                errorNotFound: 'Kyseisellä numerolla ei löytynyt laskua. Tarkista laskun numero ja yritä uudelleen.',
                errorNotPaid: 'Tätä laskua ei ole vielä merkitty maksetuksi.',
                errorOrgMismatch: 'Tätä laskua ei ole myönnetty organisaatiollesi.',
                errorPackageMismatch: 'Tämä lasku ei vastaa valittua pakettia.',
                errorInvalidInvoice: 'Syötä kelvollinen laskun numero.',
                errorGeneric: 'Lunastus epäonnistui. Yritä hetken kuluttua uudelleen.',
            },
            byFeatureHeading: 'Tässä kuussa ominaisuuden mukaan',
            byFeatureEmpty: 'Ei ominaisuustoimintaa vielä tällä ajanjaksolla.',
            featureColumn: 'Ominaisuus',
            featureUnitsColumn: 'Yksiköt',
            featureRunsColumn: 'Juoksee',
            byUserHeading: 'Tämä kuukausi käyttäjän mukaan (järjestelmänvalvojan näkymä)',
            byUserEmpty: 'Ei käyttäjäkohtaista toimintaa vielä tällä ajanjaksolla.',
            userColumn: 'Käyttäjä',
            reconciliationLinkLabel: 'Näytä täsmäytysraportti',
            reconciliationLinkHint: 'Aesir - vain sisäinen järjestelmänvalvoja.',
            featureLabels: {
                chat: 'Chat',
                workflow: 'Työnkulkuajo',
                tabular: 'Taulukkopoisto',
                redline: 'Redline arvostelu',
                title: 'Keskustelun otsikko',
                unknown: 'muu',
            },
        },
        reconciliation: {
            title: 'Forseti-kiintiön täsmäytys',
            subtitle: 'Ajaudu nopean kiintiölaskurin välimuistin ja virallisen laskutuskirjan välillä. Sovitin toimii 5 minuutin välein; tällä sivulla on uusin juoksu ja historia. Aesir - vain sisäinen järjestelmänvalvoja.',
            backLink: 'Takaisin Forsetin käyttöön',
            stubHeading: 'Sovitteluhistoria tulossa pian',
            stubBody: 'Täsmäytystyöntekijän lokit ajautuvat strukturoidun lokikanavan kautta. Taustalukupäätepiste, joka paljastaa viimeiset 30 täsmäytysajoa, on suojattu (siirretty Sprint 47.5.9.6:sta – katso työtiedosto). Kun päätepiste laskeutuu, tällä sivulla näkyy ajohistoriataulukko + P0-ajautumisbanneri.',
            stubBackendOwner: 'Taustajärjestelmän lykkäys: jatkuva täsmäytys suoritetaan uudessa kokoelmassa + lisää "GET /llm-relay/quota/conciliation" -reitti.',
            permissionDenied: 'Tämä sivu on rajoitettu Aesirin sisäisille järjestelmänvalvojille. Jos uskot, että sinulla pitäisi olla pääsy, ota yhteyttä [[TOK_0]] edustajaan.',
        },
        projects: {
            title: 'Projektit',
            subtitle: 'Työtilat asiakirjoja, keskusteluja, työnkulkuja ja arvosteluja varten.',
            modeLabel: 'Näytä',
            tabMine: 'Minun projektini',
            tabShared: 'Jaettu kanssani',
            searchLabel: 'Etsi projekteja',
            searchPlaceholder: 'Hae…',
            newButton: 'Uusi projekti',
            colName: 'Nimi',
            colVisibility: 'Näkyvyys',
            colDocs: 'Asiakirjat',
            colMembers: 'jäsenet',
            colUpdated: 'Päivitetty',
            visibilityOwn: 'Vain oma',
            visibilityShared: 'Jaettu',
            emptyMine: 'Ei vielä projekteja. Aloita luomalla sellainen.',
            emptyShared: 'Sinun kanssasi ei ole jaettu mitään projekteja.',
            pageHint: 'Näytetään [[TOK_2]] / [[TOK_3]].',
            createTitle: 'Uusi projekti',
            createSubmit: 'Luo projekti',
            fieldName: 'Nimi',
            fieldDescription: 'Kuvaus (valinnainen)',
            fieldCmNumber: 'Tapauksen/asian numero (valinnainen)',
            fieldVisibility: 'Näkyvyys',
            errorNameRequired: 'Nimi vaaditaan.',
            errorSelectorRequired: 'Valitse lisättävä käyttäjä tai organisaatioryhmä.',
            renameButton: 'Nimeä uudelleen',
            renamePrompt: 'Nimeä projekti uudelleen',
            deleteButton: 'Poista',
            deleteConfirm: 'Poistetaanko tämä projekti? Sitä säilytetään 30 päivää ennen pysyvää poistamista.',
            deleteFolderConfirm: 'Poistetaanko tämä kansio? Sisällä olevat asiakirjat jäävät projektiin, vain arkistoimatta.',
            removeMemberConfirm: 'Poistetaanko tämä jäsen?',
            foldersHeading: 'Kansiot',
            foldersEmpty: 'Ei kansioita vielä.',
            addFolderButton: 'Uusi kansio',
            addFolderTitle: 'Uusi kansio',
            documentsHeading: 'Asiakirjat',
            documentsEmpty: 'Asiakirjoja ei ole vielä liitetty.',
            colFilename: 'Tiedostonimi',
            colAdded: 'Lisätty',
            unattachButton: 'Irrota',
            membersHeading: 'jäsenet',
            membersEmpty: 'Vain omistaja.',
            addMemberButton: 'Lisää jäsen',
            addMemberTitle: 'Lisää jäsen',
            addMemberSubmit: 'Lisää jäsen',
            colMember: 'jäsen',
            colRole: 'Rooli',
            selectorTypeLabel: 'Lisää',
            selectorUser: 'Käyttäjätunnus',
            selectorGroup: 'Organisaatioryhmän tunnus',
            fieldUserId: 'Käyttäjä',
            fieldGroupId: 'Organisaatioryhmä',
            fieldRole: 'Rooli',
            roleAdmin: 'Admin',
            roleEditor: 'Toimittaja',
            roleViewer: 'Katsoja',
            notFound: 'Projektia ei löydy.',
            selectUserPlaceholder: 'Valitse käyttäjä…',
            selectGroupPlaceholder: 'Valitse organisaatioryhmä…',
            noUsersAvailable: 'Käyttäjiä ei ole saatavilla.',
            noGroupsAvailable: 'Organisaatioryhmiä ei ole saatavilla.',
            loadFailed: 'Vaihtoehtojen lataaminen epäonnistui.',
            deleteProjectTitle: 'Poistetaanko projekti?',
            deleteFolderTitle: 'Poistetaanko kansio?',
            removeMemberTitle: 'Poistetaanko jäsen?',
            removeMemberConfirmGeneric: 'Poistetaanko tämä jäsen projektista?',
            addDocumentButton: 'Lisää asiakirja',
            addDocumentTitle: 'Lisää asiakirja projektiin',
            fieldDocument: 'Valitse asiakirja',
            selectDocPlaceholder: 'Etsi asiakirjaa...',
            ownerLabel: 'Järjestelmän omistaja',
        },
        chat: {
            sidebarLabel: 'Chatit',
            overviewTitle: 'Forseti',
            overviewSubtitle: '[[TOK_0]] Legal & Compliance Advisor – perustuu vuokraajatietoihisi ja asennettuihin säädöspaketteihin.',
            personaSelectorLabel: 'Persoona',
            personaHeading: 'Valitse persoona',
            startChatButton: 'Aloita uusi chat',
            startingChat: 'Aloitetaan chatti…',
            recentHeading: 'Viimeaikaiset keskustelut',
            recentEmpty: 'Ei vielä keskusteluja – aloita yksi ylhäältä.',
            untitledChat: 'Uusi chat',
            messageListLabel: 'Keskustelu',
            detailSubtitle: 'Persoona: [[TOK_1]]',
            composeHeading: 'Lähetä viesti',
            composeLabel: 'Viesti Forsetille',
            composeDisabledPlaceholder: 'Viestin kokoonpano laskeutuu seuraavaan sprinttiin (47.5.4b – SSE-suoratoisto + työkalukutsusilmukka).',
            composeDisabledHint: 'Vain luku -esikatselu toimitettu 47.5.4a. Suoratoisto + työkalukutsut laskeutuvat 47.5.4b:hen.',
            switchPersonaHeading: 'Persoona',
            presetPersona: 'Esiasetettu persoona',
            changePersona: 'Vaihda persoonaa',
            hidePersonaOptions: 'Piilota persoonavaihtoehdot',
            starterHeading: 'Aloita jollakin näistä toiminnoista',
            renameButton: 'Nimeä uudelleen',
            renamePrompt: 'Nimeä chat uudelleen',
            deleteButton: 'Poista',
            deleteConfirm: 'Poistetaanko tämä keskustelu? Sitä säilytetään 30 päivää ennen pysyvää poistamista.',
            notFound: 'Chattia ei löydy.',
            emptyChat: 'Ei vielä viestejä – aloita keskustelu tervehtimällä.',
            roleUser: 'sinä',
            roleAssistant: 'Forseti',
            roleSystem: 'Järjestelmä',
            thinkingLabel: 'Ajatteleminen',
            toolCallPlaceholder: 'Työkalukutsu:',
            toolResultPlaceholder: 'Työkalun tulos piilotettu – täysi käyttöliittymä laskeutuu 47.5.4b:hen.',
            docEditPlaceholder: 'Ehdotetut asiakirjan muokkaukset (V[[TOK_1]]).',
            disclaimer: 'Forseti tukee harkintasi - se ei korvaa lisensoitua asianajajaa.',
            sendButton: 'Lähetä',
            sending: 'Lähetetään…',
            composePlaceholder: 'Kysy Forsetilta…',
            composingPlaceholder: 'Forseti vastaa…',
            streamingPlaceholder: 'Forseti kirjoittaa…',
            promptInjectionTitle: 'Forseti pudotti joitakin ohjausmerkkejä.',
            promptInjectionBody: 'Raidatut kuviot: [[TOK_1]]. Forseti näkee vain viestisi tekstin.',
            promptInjectionInline: 'Forseti poisti viestistäsi ohjaustunnuksia ([[TOK_1]]).',
            rateLimitTitle: 'Lähetät viestejä liian nopeasti.',
            rateLimitRetryAfter: 'Yritä uudelleen [[TOK_1]]s kuluttua.',
            counselReviewTitle: 'Forseti on epävarma tässä.',
            counselReviewBody: 'Vahvista valtuutetulta asianajajalta ennen kuin toimit tämän vastauksen mukaisesti.',
            legalConclusionRefused: 'Forseti kieltäytyi antamasta oikeudellista johtopäätöstä perustelematta. Kokeile ensin search_regulatory tai lähetä neuvoa.',
            toolCallDone: 'Tehty.',
            toolCallArgsLabel: 'Argumentit',
            toolCallResultLabel: 'Tulos',
            toolResultLogged: 'Työkalun tulos tallennettu tarkastuslokiin.',
            toolResultAria: 'työkalun tulos',
            documentEditAria: 'asiakirjan muokkaus',
            createTaskFromMessage: 'Luo tehtävä tästä',
            createTaskHeading: 'Luo tehtävä tästä viestistä',
            createTaskTitleLabel: 'Otsikko',
            createTaskTitleRequired: 'Otsikko vaaditaan.',
            createTaskDescriptionLabel: 'Kuvaus',
            createTaskAssigneeLabel: 'Valtuutettu',
            createTaskAssigneePlaceholder: 'Valitse valtuutettu…',
            createTaskAssigneeNone: '— määräämätön —',
            createTaskDueDateLabel: 'Eräpäivä',
            createTaskWorkflowLabel: 'Linkitetty työnkulku (valinnainen)',
            createTaskWorkflowPlaceholder: 'Valitse työnkulku…',
            createTaskWorkflowNone: '- ei yhtään -',
            renameModalSubmit: 'Nimeä uudelleen',
            renameModalSaving: 'Tallennetaan…',
            deleteConfirmTitle: 'Poistetaanko chat?',
            createTaskSubmit: 'Luo tehtävä',
            createTaskSubmitting: 'Luodaan…',
            cancelButton: 'Peruuta',
            autoRouteHintMessage: 'Tämä kysymys on enemmän [[TOK_1]]:n ohjaushytissä.',
            autoRouteSwitchButton: 'Vaihda palveluun [[TOK_1]]',
            autoRouteSwitching: 'Vaihdetaan…',
            handoffSuggestionMessage: 'Tai avaa uusi chatti [[TOK_1]]:n kanssa ja siirrä tätä kysymystä eteenpäin.',
            handoffSuggestionButton: 'Aloita uusi keskustelu käyttäjän [[TOK_1]] kanssa',
            handoffSuggestionWorking: 'Avataan…',
            handoffSuggestionDismiss: 'Ei nyt',
            persona_display: {
                'forseti-generalist': 'Forseti',
                'forseti-compliance': 'Vaatimustenmukaisuuden asiantuntija',
                'forseti-legal': 'Lakiasiantuntija',
                'forseti-dpo': 'Tietosuojavastaava-neuvonantaja',
                'forseti-risk': 'Riskianalyytikko',
                'forseti-auditor': 'Tilintarkastajan näkemys',
            },
            exportButton: 'Vie PDF',
            exportRunning: 'Viedään…',
            exportSuccess: 'Viety: {filename} (avaa tiedostoselain).',
            citation: {
                verifyBadge: '[VAHVISTA]',
                verifyAria: 'lainausta ei voitu vahvistaa – tarkista ennen luottamista',
                popoverAria: 'Lähde: [[TOK_1]]',
                openSource: 'Avoimen lähdekoodin sivu',
            },
        },
        auditTrail: {
            forsetiBadge: 'Forseti',
            forsetiBadgeTooltip: '[[TOK_0]] luonut tapahtuman Forsetin kirjausketjusta.',
        },
        rowAction: {
            ask: 'Kysy Forsetilta',
            tooltipOpen: 'Kysy Forsetilta tästä [[TOK_1]]',
            tooltipLocked: 'Tämä [[TOK_1]] on lukittu — Forseti voi vastata kysymyksiin, mutta ei voi tehdä muutoksia.',
        },
        advisorRunPanel: {
            title: 'Forseti — tästä levystä',
            heading: 'Forseti — [[TOK_1]]',
            summaryLabel: 'Yhteenveto',
            suggestedPersona: 'Ehdotettu persoona',
            askForseti: 'Kysy Forsetilta',
            runWorkflow: 'Suorita työnkulku',
            viewLineage: 'Näytä Audit Lineage',
            createPdplEvidencePack: 'Luo PDPL-todistepaketti',
            prepareBreachDraft: 'Valmistele ilmoitusluonnos',
            primaryActions: {
                projectSummary: 'Tiivistä projektiasiakirja',
                supplementSummary: 'Tiivistä lisäpyyntö',
                authoritySummary: 'Tiivistä viranomaispyyntö',
                rightsRequestResponse: 'Laadi DSR-vastaus',
                dpiaQuickReview: 'Suorita DPIA-pikatarkistus',
                taskControlWalkthrough: 'Käy läpi kontrollitodisteet',
                vendorRiskNarrative: 'Luo toimittajariskin narratiivi',
                incidentLetter: 'Laadi PDPL-loukkauskirje',
                ropaSufficiency: 'Suorita RoPA-riittävyyden tarkistus',
                vendorDpaReview: 'Suorita toimittajan DPA-tarkistus',
            },
            builtinWorkflowViews: {
                ropaSufficiency: {
                    title: 'RoPA Sufficiency Check',
                    notice: 'Runs the existing RoPA sufficiency workflow for this processing activity. The run may create draft follow-up tasks; operators still review and execute them.',
                },
                vendorDpaReview: {
                    title: 'Vendor DPA Review',
                    notice: 'Runs the existing Vendor DPA Review workflow for this vendor contract. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                vendorRiskNarrative: {
                    title: 'Vendor Risk Narrative',
                    notice: 'Runs the existing vendor risk narrative workflow for this vendor. Output remains draft evidence; the human risk owner reviews and approves it before use.',
                },
                incidentLetter: {
                    title: 'PDPL Breach Notification Letter',
                    notice: 'Runs the existing VN PDPL breach-notification letter workflow for this incident or playbook activation. Output remains draft only; formal regulator filing still requires human sign-off.',
                },
                projectSummary: {
                    title: 'Project Document Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this Forseti project. The workflow is read-only and does not create tasks, evidence, or record updates.',
                },
                supplementSummary: {
                    title: 'Supplement Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this supplement request. The workflow is read-only and does not create tasks, evidence, record updates, or filing decisions.',
                },
                authoritySummary: {
                    title: 'Authority Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this authority request. The workflow is read-only and does not create tasks, evidence, record updates, filing decisions, or authority-response drafts.',
                },
                rightsRequestResponse: {
                    title: 'DSR Response Draft',
                    notice: 'Runs the existing DSR response draft workflow for this rights request. Output remains draft only; sending and case updates still require the existing human-reviewed rights-request flow.',
                },
                dpiaQuickReview: {
                    title: 'DPIA Quick Review',
                    notice: 'Runs the existing DPIA Quick Review workflow for this DPIA. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                taskControlWalkthrough: {
                    title: 'Control Evidence Walkthrough',
                    notice: 'Runs the existing compliance-control walkthrough for this task. The workflow must retrieve regulatory anchors before citing them, does not issue legal conclusions or mark controls/evidence approved, and only creates draft evidence placeholders when the operator explicitly requests them.',
                },
            },
            breachDraftNotice: 'Forseti valmistelee vain linkitetyn Mẫu số 08 -lomakkeen luonnossisällön. Se ei päätä ilmoitusvelvollisuudesta eikä toimita tai lähetä lomaketta.',
            breachDraftReady: 'Mẫu số 08 -luonnos valmis tarkistettavaksi',
            breachDraftReviewBeforeSelecting: 'Tarkista ennen valintaa',
            workflowHeading: 'Olennaiset työnkulut',
            workflowLoading: 'Ladataan olennaisia työnkulkuja…',
            workflowEmpty: 'Sopivaa työnkulkua ei löytynyt. Luo tälle tietueelle ohjattu työnkulku.',
            workflowError: 'Olennaisia työnkulkuja ei voitu ladata.',
            selectWorkflow: 'Valitse {title}',
            workflowSelected: 'Työnkulku on valittu ja valmis suoritettavaksi tälle tietueelle.',
            workflowRunSelected: 'Suorita valittu työnkulku',
            workflowStarting: 'Käynnistetään työnkulkua…',
            workflowRunError: 'Työnkulkua ei voitu käynnistää.',
            workflowQuotaExhausted: 'Forseti-käyttökiintiösi ei riitä tämän työnkulun käynnistämiseen.',
            workflowTopUp: 'Tarkista käyttö ja pyydä lisäkiintiötä',
            workflowCreateGuided: 'Luo tälle tietueelle ohjattu työnkulku',
            lineageHeading: 'Tämän tietueen tarkastusketju',
            lineageLoading: 'Ladataan tarkastusketjua…',
            lineageEmpty: 'Tälle tietueelle ei ole tallennettu Forseti-ketjutapahtumia.',
            lineageError: 'Tarkastusketjua ei voitu ladata.',
            retry: 'Yritä uudelleen',
            chatContextLoading: 'Ladataan tietueen kontekstia…',
            chatGuidance: {
                general: 'Forseti voi tehdä tietueesta yhteenvedon, tunnistaa puuttuvat tiedot ja ehdottaa tarkistusvaiheita.',
                privacy: 'Forseti voi tarkistaa tietosuojatiedot ja asennettujen sääntelykehysten velvoitteet sekä auttaa laatimaan luonnoksen ihmisen tarkistettavaksi.',
                compliance: 'Forseti voi tunnistaa vaatimustenmukaisuuden puutteet, perustaa vaatimukset asennettuihin lähteisiin ja ehdottaa vastuullisia jatkotoimia.',
                legal: 'Forseti voi tehdä tietueesta yhteenvedon, etsiä perusteltua lähdeaineistoa ja auttaa laatimaan luonnoksen oikeudellista tarkistusta varten.',
                risk: 'Forseti voi arvioida kirjattuja riskejä, merkitä puuttuvat tosiseikat ja ehdottaa oikeasuhtaisia tarkistusvaiheita.',
                audit: 'Forseti voi tarkastella todistusaineiston puutteita, yhdistää tietueen asennettuihin kontrolleihin ja ehdottaa auditointivalmiita jatkotoimia.',
            },
            starterPrompts: {
                identifyGaps: 'Mitä tietoja tai todistusaineistoa tästä tietueesta puuttuu?',
                reviewFrameworks: 'Mitkä asennettujen sääntelykehystemme velvoitteet minun tulisi tarkistaa tämän tietueen osalta?',
                prepareDraft: 'Auta minua laatimaan luonnos, joka perustuu vain tähän tietueeseen ja perusteltuihin asennettuihin lähteisiin.',
                nextSteps: 'Mitkä tarkistusvaiheet minun tulisi tehdä seuraavaksi?',
                summarizeRecord: 'Tee tietueesta yhteenveto ja merkitse ihmisen tarkistusta vaativat kohdat.',
                assessRisk: 'Arvioi kirjatut riskit, tunnista puuttuvat tosiseikat ja ehdota tarkistusvaiheita.',
            },
            disclaimer: 'Forseti tukee harkintasi - se ei korvaa lisensoitua asianajajaa.',
            recordType: {
                project: 'Projekti',
                dpia: '[[TOK_0]]',
                dossier_filing: 'Asiakirjojen arkistointi',
                transfer_assessment: 'Rajat ylittävä siirto',
                vendor: 'Myyjä',
                vendor_contract: 'Myyjäsopimus',
                vendor_acceptance: 'Myyjän riskin hyväksyminen',
                incident: 'Tapahtuma',
                incident_op: 'Tapahtumaoperaatio',
                breach_notification: 'Rikkomusilmoitus',
                authority_request: 'Viranomaisten pyyntö',
                supplement_request: 'Täydennyspyyntö',
                rights_request: 'Oikeuspyyntö',
                contract: 'Sopimus',
                task: 'Tehtävä',
                data_mapping_activity: 'RoPA-toiminta',
                compliance_rule: 'Vaatimustenmukaisuussääntö',
                program: 'Ohjelma',
                governance_document: 'Hallinto-asiakirja',
                remediation_plan: 'Kunnostussuunnitelma',
                cross_border_filing: 'Rajat ylittävä arkistointi',
            },
        },
        autocomplete: {
            button_label: 'Pyydä Forsetiä laatimaan tämä',
            drafting: 'Luonnostetaan…',
            hint_pick_activity: 'Valitse linkitetty käsittelytoiminto ottaaksesi Forsetin luonnoksen käyttöön.',
            draft_origin_label: 'Forseti luonnos - tarkastelu kenttäkohtaisesti',
            tokens_label: '≈ [[TOK_1]] tokeneita kuukausittain',
            accept_selected: 'Hyväksy valitut',
            reject_all: 'Hylkää luonnos',
            field_checkbox_label: 'Käytä Forsetin luonnosta [[TOK_1]]',
            field_labels: {
                description: 'Kuvaus',
                purpose: 'Tarkoitus',
                data_subjects: 'Rekisteröidyt',
                data_types: 'Tietotyypit',
                necessity_justification: 'Välttämättömyys ja suhteellisuus',
                consultation_notes: 'Konsultaatiomuistiinpanot',
                dpo_opinion: '[[TOK_0]] mielipide',
                system_ids: 'Linkitetyt järjestelmät',
                vendor_ids: 'Linkitetyt toimittajat',
            },
            error_generic: 'Forseti ei voinut luonnostella tätä [[TOK_0]]. Yritä uudelleen tai tarkenna toimintatietuetta.',
            variant_legend: 'Runkokehys',
            variant_label_gdpr: '[[TOK_0]]',
            variant_label_pdpl: '[[TOK_0]]',
            variant_label_nis2: '[[TOK_0]]',
            variant_label_iso27001: 'ISO 27001',
            variant_label_soc2: 'SOC 2',
            conflict_banner: 'Huomio: [[TOK_1]] kehysten välistä ristiriitaa koskee tätä versiota. Tarkista ennen hyväksymistä.',
        },
        tia: {
            button_label: 'Pyydä Forsetiä laatimaan tämä TIA',
            drafting: 'Laaditaan TIA:ta…',
            hint_pick_destination: 'Aseta kohdemaa siirtotietueeseen ennen kuin Forseti voi luonnostaa.',
            draft_origin_label: 'Forseti TIA luonnos – tarkistus kenttäkohtaisesti',
            tokens_label: '≈ [[TOK_1]] tokeneita kuukausittain',
            accept_selected: 'Hyväksy valitut',
            reject_all: 'Hylkää luonnos',
            field_checkbox_label: 'Käytä Forsetin luonnosta [[TOK_1]]',
            error_generic: 'Forseti ei voinut laatia tätä TIA:ta. Yritä uudelleen tai tarkenna siirtotietuetta.',
            usage_details: 'Tekoälyn käyttötiedot',
            applied_status: 'Luonnos hyväksytty. Tarkista täytetyt kentät ja valitse sitten Päivitä.',
            recommended_updates_title: 'Suositellut tietueen päivitykset',
            mechanism_recommendation: 'Siirtomekanismi: {value}',
            dpo_signoff_recommendation: 'Vaadi tietosuojavastaavan (DPO) hyväksyntä tälle arkaluonteiselle siirrolle.',
            review_date_warning: 'Aseta tarkistuksen määräaika ennen tämän arkaluonteisen siirron päivittämistä.',
            processing_activity_warning: 'Liitä vähintään yksi käsittelytoimi / ROPA-tietue ennen TIA:n valmistumista.',
            go_to_field: 'Siirry kenttään',
            adequacy_label: 'Kohdejärjestelmä',
            adequacy_status_adequacy_decision: 'Päätös riittävyydestä',
            adequacy_status_non_adequacy_with_sccs: 'Puutteellisuus — SCC:t vaaditaan',
            adequacy_status_derogation: '49 artiklan poikkeus',
            adequacy_status_transitional: 'Siirtymäaika/ETA-pikakuvake',
            adequacy_status_unknown: 'Tuntematon — aseta määränpää',
            conflict_banner: 'Huomio: [[TOK_1]] kehysten välistä ristiriitaa koskee tätä siirtojärjestelmää. Tarkista ennen hyväksymistä.',
        },
        // Sprint 48.3.6 — shared draft output-guardrail labels (TIA + DPIA + all draft workflows).
        guardrails: {
            missing_facts_title: 'Puuttuvat pakolliset tiedot',
            missing_facts_hint: 'Forseti merkitsi tietoja, joita ei ole tietueessa. Niistä riippuvia kenttiä ei ole valittu valmiiksi — täytä tiedot tai hyväksy kenttä tietoisesti.',
            risk_label: 'Kalibroitu riski',
            risk_low: 'Matala',
            risk_medium: 'Keskitaso',
            risk_high: 'Korkea',
            jurisdiction_label: 'Lainkäyttöalueen laukaisimet',
            jurisdiction_gdpr: 'GDPR',
            jurisdiction_vn_pdpl: 'PDPL (Vietnam)',
            trigger_applicable: 'Soveltuu',
            trigger_not_applicable: 'Ei laukaistu',
            trigger_unknown: 'Tuntematon — tieto puuttuu',
            recipient_role_label: 'Vastaanottajan rooli',
            recipient_role_controller: 'Rekisterinpitäjä',
            recipient_role_processor: 'Käsittelijä',
            recipient_role_joint_controller: 'Yhteisrekisterinpitäjä',
            recipient_role_unknown: 'Tuntematon — ei ilmoitettu',
            opt_in_hint: 'Oikeudellinen johtopäätös — valitse vain, jos hyväksyt sen käytettävissä olevilla tiedoilla.',
        },
        mcp: {
            pageTitle: 'MCP-liitinavaimet',
            pageSubtitle: 'Anna [[TOK_0]] avaimet, jotta ulkoiset Claude-asiakkaat voivat kutsua vain luku -muotoisia Forseti-työkaluja (säädöstenhaku, asiakirjan luku, moduulihaku). Vaihe 1 – vain luku. Kirjoita työkalut maahan 48.3.0.',
            issueButton: 'Anna uusi avain',
            issueModalTitle: 'Anna MCP [[TOK_0]]-avain',
            labelField: 'Label',
            labelHint: 'Lyhyt kuvaus (esim. "[[TOK_0]] kykylaboratorio – sääntelytutkimus").',
            permittedToolsField: 'Sallitut työkalut',
            expiresAtField: 'Vanhenee (valinnainen)',
            expiresAtHint: 'Jätä tyhjäksi, jos se ei vanhene.',
            submit: 'Ongelman avain',
            cancel: 'Peruuta',
            keyDisplayedOnce: 'Kopioi tämä avain nyt – et näe sitä enää. Tallenna se salaiseen hallintaan (1Password, AWS Secrets Manager, Vault jne.).',
            keyDisplayedOnceClose: 'Kopioin sen - sulje',
            colLabel: 'Label',
            colPrefix: 'Etuliite',
            colStatus: 'Tila',
            colTools: 'Työkalut',
            colCreatedAt: 'Luotu',
            colLastUsed: 'Viimeksi käytetty',
            colCalls: 'Puhelut',
            colActions: 'Toiminnot',
            statusActive: 'Aktiivinen',
            statusRevoked: 'Peruutettu',
            statusExpired: 'Vanhentunut',
            revokeAction: 'Peruuta',
            rotateAction: 'Kierrä',
            confirmRevokeTitle: 'Perutaanko tämä MCP-avain?',
            confirmRevokeBody: 'Tätä avainta käyttävät ulkoiset Claude-asiakkaat menettävät pääsyn välittömästi. Tätä ei voi kumota.',
            confirmRevoke: 'Peruuta avain',
            rotatedTitle: 'Avainta kierretty',
            rotatedBody: 'Uusi selväkieliavain on alla. Vanha avain jatkaa toimintaansa 5 minuuttia, joten kaikki lennon aikana soitetut puhelut päättyvät.',
            emptyState: 'MCP-avaimia ei ole vielä myönnetty.',
            errorIssue: 'MCP-avainta ei voitu antaa.',
            errorList: 'MCP-avaimia ei voitu ladata.',
            errorRevoke: 'Avainta ei voitu peruuttaa.',
            errorRotate: 'Avainta ei voitu kääntää.',
            neverUsed: '—',
            neverExpires: 'Ei koskaan',
        },
        memory: {
            pageTitle: 'Forsetin muisti',
            pageSubtitle: 'Selaa ja kuratoi organisaatiokohtaista kontekstia, jonka Forsetti on kerännyt keskusteluista ja päätöksistä. Kuroidut merkinnät estyvät iltaisin säilymiseltä ja pysyvät jokaisen henkilön saatavilla.',
            filterCategory: 'Luokka',
            filterAllCategories: 'Kaikki luokat',
            totalCount: '[[TOK_1]] merkintää',
            colAnchor: 'Ankkuri',
            colCategory: 'Luokka',
            colSource: 'lähde',
            colContent: 'Sisältö',
            colCreatedAt: 'Luotu',
            colActions: 'Toiminnot',
            editButton: 'Muokkaa',
            deleteButton: 'Poista',
            promoteButton: 'Ylennä kuratoiduksi',
            emptyState: 'Ei vielä muistoja – Forseti kerää kontekstia keskustelun aikana.',
            categories: {
                framework_interpretation: 'Viitekehyksen tulkinta',
                process_preference: 'Prosessiasetus',
                escalation_threshold: 'Eskalaatiokynnys',
                decision_context: 'Päätöksen konteksti',
                glossary_term: 'Sanasto termi',
                auto_inferred: 'Automaattinen päätelmä',
            },
            sources: {
                admin_curated: 'Kuroitu',
                user_explicit: 'Selkeä',
                auto: 'Päätelty',
            },
            deleteConfirmTitle: 'Poistetaanko tämä muisti?',
            deleteConfirmBody: 'Poistaminen poistaa tämän ankkurin kaikista tulevista Forseti-chat-käynnistyksistä. Ankkuri: [[TOK_1]]',
            deleteConfirmLabel: 'Poista',
            deleteCancelLabel: 'Peruuta',
            editModalTitle: 'Muokkaa muistia',
            editAnchorLabel: 'Ankkuri',
            editCategoryLabel: 'Luokka',
            editContentLabel: 'Sisältö',
            editContentCount: '[[TOK_2]]/[[TOK_3]] merkkiä',
            editEmptyError: 'Sisältö ei voi olla tyhjä.',
            editTooLongError: 'Sisällön tulee olla ≤1000 merkkiä.',
            editAutoPromoteHint: 'Tämän automaattisesti päätellyn muistin tallentaminen merkitsee sen käyttäjän vahvistamaksi ja poistaa sen säilytyspyyhkäisystä.',
            editCancelButton: 'Peruuta',
            editSaveButton: 'Tallenna',
            editSaving: 'Tallennetaan…',
        },
        auditLineage: {
            title: 'Tarkastuslinja',
            subtitle: 'Jäljitä jokainen [[TOK_0]]:n luoma artefakti, joka on liitetty tietueeseen. Chatit, työkalukutsut, tehtävät, todisteluonnokset ja asiakirjaversiot.',
            filterForm: 'Suodattimet',
            recordType: 'Tietueen tyyppi',
            recordId: 'Tietueen tunnus',
            dateStart: 'From',
            dateEnd: 'Vastaanottaja',
            search: 'Etsi',
            loading: 'Ladataan…',
            exportPdf: 'Vie [[TOK_0]]',
            exportCsv: 'Vie [[TOK_0]]',
            nodesHeading: 'Sukulinjan solmut',
            colType: 'Kirjoita',
            colLabel: 'Label',
            colOccurredAt: 'Tapahtui klo',
            colActor: 'näyttelijä',
            colId: 'ID',
            noResults: 'Ei neuvonantajatoimintaa tälle tietueelle.',
            draftBadge: '[[TOK_0]] luotu luonnos',
            prev: 'Edellinen',
            next: 'Seuraavaksi',
            viewToggleTable: 'Näytä taulukkona',
            viewToggleGraph: 'Näytä kaaviona',
            graphAriaLabel: 'Linjakuvaaja (visuaalinen). Käytä taulukkonäkymää aputekniikkaan.',
            graphLegendDraft: 'Luonnos [[TOK_0]] todisteista',
            graphEmpty: 'Ei solmuja kaavioita varten.',
            paginationAriaLabel: 'Sivutus',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_3]]',
            exportErrorTemplate: 'Vienti epäonnistui: [[TOK_1]]',
            recordTypes: {
                project: 'Projekti',
                dpia: '[[TOK_0]]',
                vendor: 'Myyjä',
                incident: 'Tapahtuma',
                incident_op: 'Tapahtumatoiminta',
                rights_request: 'Oikeuspyyntö',
                contract: 'Sopimus',
                task: 'Tehtävä',
                data_mapping_activity: 'Tietojen kartoitustoiminta',
                compliance_rule: 'Vaatimustenmukaisuussääntö',
                program: 'Ohjelma',
            },
            nodeTypes: {
                chat: 'Chat',
                tool_call: 'Työkalukutsu',
                workflow_run: 'Työnkulkuajo',
                task: 'Tehtävä',
                evidence: 'Todisteet',
                document_version: 'Asiakirjan versio',
            },
        },
        integrityCenter: {
            verdicts: {
                ok: 'OK',
                drifted: 'Ajautui',
                hash_mismatch: 'Hash-yhteensopivuus',
                merkle_mismatch: 'Merklen yhteensopimattomuus',
                source_missing: 'Lähde puuttuu',
                not_found: 'Ei löytynyt',
                chain_unreachable: 'Ketju tavoittamaton',
                service_unreachable: 'Palvelu tavoittamaton',
                pending: 'Odottaa ankkurointia',
            },
        },
        evidenceDraft: {
            draftBadge: '[[TOK_0]] luonut LUONNOS',
            pendingReviewBadge: 'Odottaa tarkistusta',
            approvedBadge: 'Hyväksytty',
            rejectedBadge: 'Hylätty',
            moveToReviewButton: 'Merkitse valmiiksi tarkastettavaksi',
            approveButton: 'Hyväksy',
            rejectButton: 'Hylkää',
            rejectReasonLabel: 'Hylkäämisen syy',
            humanSignoffBanner: 'Forseti tukee harkintasi - se ei korvaa lisensoitua asianajajaa. [[TOK_0]]:n tuottama todiste vaatii ihmisen hyväksynnän, ennen kuin sitä lasketaan viralliseksi todisteeksi.',
            pageTitle: '[[TOK_0]] todisteluonnokset',
            pageSubtitle: 'Tarkista, hyväksy tai hylkää [[TOK_0]]:n luomat todisteet. Ihmisen on hyväksyttävä luonnokset, ennen kuin niitä voidaan pitää muodollisina todisteina.',
            filterAll: 'Kaikki toimintakelpoisia',
            filterDrafts: 'Vain luonnokset',
            filterPending: 'Odottaa tarkistusta',
            filterApproved: 'Äskettäin hyväksytty',
            filterRejected: 'Äskettäin hylätty',
            colId: 'Todistustunnus',
            colStatus: 'Tila',
            colSource: 'lähde',
            colCreatedAt: 'Luotu',
            colActions: 'Toiminnot',
            empty: 'Ei [[TOK_0]] todisteluonnoksia tässä tilassa.',
            confirmApprove: 'Hyväksytäänkö tämä [[TOK_0]]:n luoma todiste muodolliseksi?',
            confirmReject: 'Hylkää tämä todisteluonnos. Tätä ei voi kumota.',
            reasonRequired: 'Hylkäämisen syy vaaditaan.',
            rejectModalTitle: 'Hylkää todisteluonnos',
            approveModalTitle: 'Hyväksy todisteluonnos',
            operationFailed: 'Toiminto epäonnistui. Yritä uudelleen.',
            moveToReviewSuccess: 'Merkitty valmiiksi tarkastettavaksi.',
            approveSuccess: 'Hyväksytty.',
            rejectSuccess: 'Hylätty.',
            sourceLabelWorkflowRunTitle: 'Työnkulku: [[TOK_1]]',
            sourceLabelWorkflowRunId: 'Työnkulkuajo [[TOK_1]]',
            sourceLabelChatTitle: 'Chat: [[TOK_1]]',
            sourceLabelChatId: 'Forseti-chat [[TOK_1]]',
            sourceLabelEmpty: '—',
            filtersAriaLabel: 'Suodattimen tila',
        },
        workflows: {
            pageTitle: 'AI-työnkulut',
            pageSubtitle: 'Tallennetut AI-promptipohjat, jotka tuottavat tehtäviä ja luonnostodisteita.',
            newWorkflow: 'Uusi työnkulku',
            newWorkflowHeading: 'Uusi AI-työnkulku',
            tabAll: 'Kaikki',
            tabBuiltin: 'Sisäänrakennettu paketti',
            tabMine: 'Omat työnkulut',
            tabDetail: 'Tiedot',
            tabLinkedTasks: 'Linkitetyt tehtävät',
            builtinBadge: 'Sisäänrakennettu',
            builtinSubtitle: 'Sisäänrakennettu työnkulku.',
            userSubtitle: 'Mukautettu työnkulku.',
            emptyHint: 'Ei vielä työnkulkuja.',
            loadTimeoutError: 'Työnkulkuja ei voitu ladata 10 sekunnissa. Yritä uudelleen tai tarkista selaimen Verkko-välilehti jumiutuneesta pyynnöstä.',
            loadError: 'Työnkulkuja ei voitu ladata.',
            hideError: 'Piilotus epäonnistui.',
            unhideError: 'Näyttäminen epäonnistui.',
            retry: 'Yritä uudelleen',
            producesTasks: 'Tuottaa tehtäviä',
            producesEvidence: 'Tuottaa luonnostodisteita',
            hideButton: 'Piilota listaltani',
            unhideButton: 'Näytä',
            runButton: 'Suorita',
            editButton: 'Muokkaa',
            shareButton: 'Jaa',
            backToList: 'Takaisin listaan',
            requireTitleAndPrompt: 'Otsikko ja prompt vaaditaan.',
            fieldTitle: 'Otsikko',
            fieldDescription: 'Kuvaus',
            fieldType: 'Tyyppi',
            fieldPersona: 'Persoonan affiniteetti',
            fieldPractice: 'Käytäntö',
            fieldPrompt: 'Kehote (merkintä)',
            fieldProducesTasks: 'Tuottaa tehtäviä',
            fieldProducesEvidence: 'Tuottaa luonnostodisteita',
            fieldProjectId: 'Projekti (valinnainen)',
            fieldAttachmentIds: 'Liitteet',
            fieldParentRecord: 'Yläsisältö (valinnainen)',
            fieldPersonaOverride: 'Persoonan ohitus (valinnainen)',
            typeAssistant: 'Avustaja',
            typeTabular: 'Taulukkomainen',
            personaNone: '— ei mitään —',
            parentNone: '— ei mitään —',
            parentIdPlaceholder: 'Yläsisällön tunniste',
            selectProjectPlaceholder: 'Valitse projekti…',
            selectProjectFirst: 'Valitse projekti valitaksesi liitteet.',
            selectAttachmentsPlaceholder: 'Valitse asiakirjat…',
            noAttachmentsInProject: 'Tällä projektilla ei ole liitteitä.',
            selectParentRecordPlaceholder: 'Valitse tietue…',
            selectParentRecordFirst: 'Valitse ensin tietuetyyppi.',
            noRecordsForType: 'Tämän tyyppisiä tietueita ei ole saatavilla.',
            shareUserSelectorLabel: 'Vastaanottajat (käyttäjät)',
            shareGroupSelectorLabel: 'Vastaanottajat (organisaatioryhmät)',
            selectUsersPlaceholder: 'Valitse käyttäjät…',
            selectOrgGroupsPlaceholder: 'Valitse organisaatioryhmät…',
            loadingOptions: 'Ladataan…',
            loadFailed: 'Vaihtoehtojen lataus epäonnistui.',
            parentRecordTypes: {
                dpia: 'DPIA',
                vendor: 'Toimittaja',
                incident: 'Tapahtuma',
                rights_request: 'Oikeuspyyntö',
                contract: 'Sopimus',
                data_mapping_activity: 'RoPA-toiminto',
                compliance_rule: 'Vaatimussääntö',
                program: 'Ohjelma',
            },
            cancelButton: 'Peruuta',
            closeButton: 'Sulje',
            createButton: 'Luo',
            creating: 'Luodaan…',
            saveButton: 'Tallenna',
            saving: 'Tallennetaan…',
            shareWorkflowHeading: 'Jaa työnkulku',
            shareIntro: 'Jaetaan: {title}',
            shareUserIds: 'Käyttäjätunnukset (välilyönnillä tai pilkulla erotettuna)',
            shareGroupIds: 'Organisaatioryhmätunnukset (välilyönnillä tai pilkulla erotettuna)',
            shareAllowEdit: 'Salli vastaanottajien muokata',
            shareRequireRecipient: 'Anna vähintään yksi käyttäjä- tai ryhmätunnus.',
            shareSuccess: 'Jaettu.',
            sharing: 'Jaetaan…',
            runWorkflowHeading: 'Suorita: {title}',
            runStarting: 'Käynnistetään…',
            runStatusLabel: 'Tila: {status}',
            runProducedCounts: 'Tehtävät: {tasks} · Todistusaineistoluonnokset: {evidence} · Liitteet: {attachments}',
            runPanelHeading: 'Työnkulun ajo',
            runPanelHeadingWithTitle: 'Työnkulun ajo: {title}',
            runViewTasks: 'Näytä luodut tehtävät',
            runLoadFailed: 'Työnkulun ajoa ei voitu ladata.',
            runStreamFailed: 'Yhteys työnkulun etenemistietoihin katkesi.',
            runStatusValues: {
                pending: 'Odottaa',
                running: 'Käynnissä',
                completed: 'Valmis',
                succeeded: 'Onnistui',
                failed: 'Epäonnistui',
                cancelled: 'Peruttu',
            },
            runProgressStatus: 'Tila: {status}',
            runProgressTaskCreated: 'Tehtävä luotu.',
            runProgressEvidenceDrafted: 'Luonnostodiste luotu.',
            runProgressAttachmentGenerated: 'Liite luotu.',
            guidedWorkflowTitle: 'Ohjattu työnkulku: {recordType}',
            guidedWorkflowDescription: 'Luotu tyypin {recordType} tietueille. Tarkista ja mukauta työnkulkua ennen tallentamista.',
            guidedWorkflowPrompt: 'Tarkista annettu tyypin {recordType} tietue, tunnista puuttuvat tosiseikat ja ehdota perusteltuja jatkotoimia ihmisen tarkistettavaksi.',
            costHint: 'Esikiintiötarkistus laukeaa lähetettäessä; kiintiön ylittävät ajot palauttavat 402 latauspyynnön kanssa.',
            quotaExhausted: 'Token-kiintiö alhainen. Lataa ennen uudelleenajoa.',
            promptHeading: 'Kehote',
            editWorkflowHeading: 'Muokkaa työnkulkua',
            linkedTasksHint: 'Tämän työnkulun luomat tehtävät näkyvät tehtävälistalla suodatettuina tämän työnkulun tunnisteen mukaan. Ristiviittaus saapuu 47.5.8:ssa.',
            notFound: 'Työnkulkua ei löytynyt.',
            schedules: {
                tabTitle: 'Aikataulut',
                sectionHeading: 'Ajastetut ajot',
                empty: 'Ei vielä aikatauluja. Luo aikataulu tämän työnkulun ajamiseksi automaattisesti.',
                addButton: 'Lisää aikataulu',
                addHeading: 'Aikatauluta työnkulku',
                editHeading: 'Muokkaa aikataulua',
                fieldFrequency: 'Toistuvuus',
                fieldDayOfWeek: 'Viikonpäivä',
                fieldDayOfMonth: 'Kuukauden päivä',
                fieldTime: 'Aika (UTC)',
                fieldTimezone: 'Aikavyöhyke',
                fieldProject: 'Projekti (valinnainen)',
                fieldAttachments: 'Oletusliitteet',
                fieldPersonaOverride: 'Persoonan ohitus (valinnainen)',
                frequencyDaily: 'Päivittäin',
                frequencyWeekly: 'Viikoittain',
                frequencyMonthly: 'Kuukausittain',
                weekdaySun: 'Sunnuntai',
                weekdayMon: 'Maanantai',
                weekdayTue: 'Tiistai',
                weekdayWed: 'Keskiviikko',
                weekdayThu: 'Torstai',
                weekdayFri: 'Perjantai',
                weekdaySat: 'Lauantai',
                statusActive: 'Aktiivinen',
                statusPaused: 'Tauotettu',
                nextRunLabel: 'Seuraava ajo',
                lastRunLabel: 'Viimeinen ajo',
                pauseButton: 'Tauko',
                resumeButton: 'Jatka',
                deleteButton: 'Poista',
                triggerButton: 'Suorita nyt',
                savingButton: 'Tallennetaan…',
                saveButton: 'Tallenna',
                triggered: 'Ajo aloitettu — tarkista ajohistoria.',
            },
            branching: {
                helpHeading: 'Ehdollinen prompt-syntaksi',
                helpBody: 'Käytä {% if attachment.framework_code == "vn-pdpl" %}…{% endif %} promptin muuttamiseen kontekstin mukaan. Sallitut muuttujat: attachment.framework_code, attachment.locale, project.name, project.tier, persona.slug, org.country, org.locale. Sisäkkäisiä {% if %} -lohkoja ei tueta.',
            },
        },
        crossFrameworkConflicts: {
            pageTitle: 'Kehysten väliset ristiriidat',
            pageSubtitle: 'Kuroitu luettelo siitä, missä asennetut säädöspaketit ovat vuorovaikutuksessa ristiriitaisilla tavoilla. Forseti pinnat; ihmiset päättävät.',
            noInstalledPacks: 'Tälle organisaatiolle ei ole asennettu sääntelypaketteja – asenna vähintään kaksi pakettia kehysten välisten ristiriitojen ratkaisemiseksi.',
            noConflicts: 'Mikään ristiriita ei vastaa nykyisiä suodattimia.',
            allAcknowledged: 'Jokainen näkyvä ristiriita on tunnustettu. Hienoa työtä.',
            columnSeverity: 'Vakavuus',
            columnTitle: 'Otsikko',
            columnFrameworks: 'Kehykset',
            columnTopic: 'Aihe',
            columnStatus: 'Tila',
            filterFrameworkPlaceholder: 'Kaikki puitteet',
            filterTopicPlaceholder: 'Kaikki aiheet',
            filterSeverityPlaceholder: 'Kaikki vakavuusasteet',
            filterStatusPlaceholder: 'Kaikki tilat',
            filterStatusAcknowledged: 'Tunnustettu',
            filterStatusUnacknowledged: 'Tunnustamaton',
            severityCritical: 'Kriittinen',
            severityHigh: 'Korkea',
            severityMedium: 'Keskikokoinen',
            severityLow: 'Matala',
            statusAcknowledged: 'Tunnustettu',
            statusInReview: 'Tarkastuksessa',
            statusResolved: 'Ratkaistu',
            statusWontFix: 'Ei korjaa',
            statusUnacknowledged: 'Tunnustamaton',
            drawerSummaryHeading: 'Yhteenveto',
            drawerSideAHeading: 'puoli A',
            drawerSideBHeading: 'Sivu B',
            drawerRequirementsLabel: 'Mainitut vaatimukset',
            drawerSuggestedResolutionHeading: 'Ehdotettu ratkaisu',
            drawerLegalCounselBadge: 'Tarvitaan lakimiehen tarkastus',
            drawerAckHeading: 'Tunnustus',
            drawerAckStatusLabel: 'Tila',
            drawerAckAssigneeLabel: 'Määrätty',
            drawerAckDueDateLabel: 'Eräpäivä',
            drawerAckNotesLabel: 'Huomautuksia',
            drawerAckButtonAcknowledge: 'Tunnusta',
            drawerAckButtonUpdate: 'Päivitä',
            drawerAckButtonUnacknowledge: 'Peruuta tunnustaminen',
            searchPlaceholder: 'Hae otsikkoa tai yhteenvetoa…',
            searchButton: 'Etsi',
            searchButtonAriaLabel: 'Suorita ristiriitahaku',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_1]]',
            exportSuccessTemplateXlsx: '[[TOK_2]]: [[TOK_1]]',
            exportErrorTemplate: 'Vienti epäonnistui: [[TOK_1]]',
            exportAriaLabel: 'Vientiristiriidat',
        },
        tabularReviews: {
            pageTitle: 'Tabulaariset arvioinnit',
            pageSubtitle: 'Vertaa N asiakirjaa M attribuutin yli perustellulla viittauksella.',
            newReview: 'Uusi arviointi',
            newReviewHeading: 'Uusi tabulaarinen arviointi',
            emptyHint: 'Ei vielä tabulaarisia arviointeja.',
            docsLabel: '{n} asiakirjaa',
            colsLabel: '{n} saraketta',
            detailSubtitle: '{docs} asiakirjaa · {cols} saraketta',
            addColumn: 'Lisää sarake',
            addColumnHeading: 'Lisää sarake',
            columnInfo: 'Näytä kehote ja muoto',
            columnInfoAria: 'Näytä sarakkeen {name} kehote ja muoto',
            columnInfoPrompt: 'Kehote',
            columnInfoFormat: 'Palautusmuoto',
            columnInfoPresets: 'Sallitut arvot',
            columnInfoCitations: 'Lähdeviitteet',
            columnInfoCitationsRequired: 'Pakollinen',
            removeColumn: 'Poista sarake',
            removeColumnAria: 'Poista sarake {name}',
            removeColumnConfirm: 'Poistetaanko sarake "{name}"? Sen poimitut solut poistetaan.',
            deleteReview: 'Poista',
            deleteReviewAria: 'Poista tarkastelu {title}',
            deleteReviewConfirm: 'Poistetaanko tarkastelu "{title}"? Tämä poistaa pysyvästi sen sarakkeet, solut ja keskustelut.',
            runAll: 'Suorita kaikki',
            running: 'Käynnissä…',
            cancel: 'Peruuta',
            exportXlsx: 'Vie Excel',
            exportCsv: 'Vie CSV',
            exporting: 'Viedään…',
            backToList: 'Takaisin listaan',
            notFound: 'Tabulaarista arviointia ei löytynyt.',
            noDocuments: 'Liitä asiakirjoja aloittaaksesi arvioinnin.',
            noColumns: 'Lisää sarakkeita määritelläksesi mitä poimitaan.',
            tableAriaLabel: 'Poimintaverkko',
            threadsCountAria: '{n} keskusteluviestiä',
            startDiscussionAria: 'Aloita keskustelu',
            docColumn: 'Asiakirja',
            statusPending: 'Odottaa',
            statusRunning: 'Käynnissä…',
            statusFailed: 'Epäonnistui: {msg}',
            statusCancelled: 'Peruttu',
            citationsCount: '{n} viittausta',
            citationsView: 'Näytä lähdekohdat',
            citationPage: 'Sivu {n}',
            titleRequired: 'Otsikko vaaditaan.',
            fieldTitle: 'Otsikko',
            fieldProjectId: 'Projekti (valinnainen)',
            fieldAttachmentIds: 'Liitteet',
            fieldColumnName: 'Sarakkeen nimi',
            fieldColumnNameHelp: 'Lyhyt, kuvaava tunniste tälle sarakkeelle poimintaruudukossa.',
            columnNamePlaceholder: 'esim. Sopimuksen alkupäivä',
            fieldExtractionPrompt: 'Poimintaprompti',
            fieldExtractionPromptHelp: 'Kuvaile poimittavat tiedot. Ole täsmällinen saadaksesi parempia tuloksia.',
            columnPromptPlaceholder: 'Mitä Forsetin tulisi etsiä asiakirjoista?',
            fieldReturnFormat: 'Palautusmuoto',
            fieldReturnFormatHelp: 'Ohjaa, miten tekoäly muotoilee vastauksensa (esim. päivämääränä tai numerona).',
            fieldPresets: 'Sallitut arvot (yksi per rivi)',
            fieldPresetsPlaceholder: 'kyllä\nei\nosittain',
            fieldCitationsRequired: 'Viittaus vaaditaan',
            formatShortText: 'Lyhyt teksti',
            formatLongText: 'Pitkä teksti',
            formatEnum: 'Enum',
            formatNumber: 'Numero',
            formatDate: 'Päivämäärä',
            formatList: 'Lista',
            columnRequireFields: 'Nimi ja prompt vaaditaan.',
            addColumnError: 'Sarakkeen lisääminen epäonnistui.',
            cancelButton: 'Peruuta',
            createButton: 'Luo',
            creating: 'Luodaan…',
            addButton: 'Lisää',
            adding: 'Lisätään…',
            runConfirmHeading: 'Suorita poiminta',
            estimateBody: 'Arvioitu ~{units} laskutettavaa yksikköä ({confidence} luottamus).',
            costHint: 'Esikiintiötarkistus laukeaa vahvistettaessa; kiintiön ylittävät ajot palauttavat 402 latauspyynnön kanssa.',
            quotaExhausted: 'Token-kiintiö alhainen. Lataa ennen uudelleenajoa.',
            starting: 'Käynnistetään…',
            confirmRun: 'Vahvista ajo',
            charts: {
                title: 'Sarakekaaviot',
                tabsAria: 'Kaaviosarakkeet',
                enumAria: 'Enum-arvojen jakauma',
                numberAria: 'Numerojakauman histogrammi',
                dateAria: 'Päivämääräaikajana',
                enumEmpty: 'Ei valmiita soluja.',
                numberEmpty: 'Ei numeerisia arvoja.',
                numberExcluded: '{n} solua poissuljettu (tyhjät / ei-numeeriset / ei valmiit).',
                dateEmpty: 'Ei päivämääräarvoja.',
                dateExcluded: '{n} solua poissuljettu.',
                unsupportedFormat: 'Ei tuettu sarakemuoto.',
            },
            threads: {
                drawerTitle: 'Keskustelu',
                loading: 'Ladataan…',
                empty: 'Ei vielä viestejä. Aloita keskustelu.',
                composerLabel: 'Uusi kommentti',
                composerPlaceholder: 'Lisää kommentti…',
                post: 'Lähetä',
                posting: 'Lähetetään…',
                edit: 'Muokkaa',
                editLabel: 'Muokkaa viestiä',
                delete: 'Poista',
                save: 'Tallenna',
                cancel: 'Peruuta',
                close: 'Sulje',
                editedBadge: 'muokattu',
                loadError: 'Ketjun lataus epäonnistui',
                postError: 'Lähetys epäonnistui',
                editError: 'Muokkaus epäonnistui',
                deleteError: 'Poisto epäonnistui',
            },
            compare: {
                pageTitle: 'Vertaa arviointeja',
                leftReviewLabel: 'Vasen arviointi',
                rightReviewLabel: 'Oikea arviointi',
                pickReview: 'Valitse arviointi vertailtavaksi',
                noSharedDocuments: 'Näillä arvioinneilla ei ole yhteisiä asiakirjoja — vertailu vaatii vähintään yhden yhteisen liitteen.',
                sharedDocumentsHeading: 'Yhteiset asiakirjat',
                leftOnlyHeading: 'Vain vasemmassa arvioinnissa olevat sarakkeet',
                rightOnlyHeading: 'Vain oikeassa arvioinnissa olevat sarakkeet',
                differs: 'Eroaa',
                identical: 'Identtinen',
                emptyValue: '—',
                compareButton: 'Vertaa kohteeseen…',
                documentHeading: 'Asiakirja',
                errorMissingIds: 'Sekä vasemman että oikean arvioinnin tunnisteet vaaditaan.',
                errorComparisonFailed: 'Vertailu epäonnistui.',
                errorLoadFailed: 'Arviointien lataus epäonnistui.',
                pickerLoading: 'Ladataan…',
                pickerNoOtherReviews: 'Ei muita arviointeja saatavilla vertailtavaksi.',
                pickerCancel: 'Peruuta',
            },
        },
        documentReview: {
            pageTitle: 'Asiakirjan tarkistus',
            pageSubtitle: 'Hyväksy tai hylkää [[TOK_0]]:n ehdottamat muutokset tähän asiakirjaan.',
            sidePanelLabel: '[[TOK_0]] punaviivat',
            sidePanelHeading: '[[TOK_0]] punaviivat',
            noPendingEdits: 'Ei odottavia muokkauksia.',
            pendingCount: '[[TOK_1]] odottaa',
            acceptAllButton: 'Hyväksy kaikki',
            rejectAllButton: 'Hylkää kaikki',
            acceptAllTitle: 'Hyväksytäänkö kaikki odottavat muokkaukset?',
            acceptAllConfirm: 'Tämä hyväksyy [[TOK_1]] odottavat muokkaukset ja luo yhden tai useamman uuden version. Jatkaa?',
            editsHeading: 'Muokkaukset',
            editsEmpty: 'Ei tarkistettavia muokkauksia.',
            versionsHeading: 'Versiohistoria',
            versionsEmpty: 'Ei vielä versioita.',
            editLabel: 'Muokkaa',
            editLabelWithId: 'Muokkaa #{id}',
            acceptButton: 'Hyväksy',
            rejectButton: 'Hylkää',
            accepting: 'Hyväksytään…',
            rejecting: 'Hylätään…',
            diffDeletedAria: 'Poistettu',
            diffInsertedAria: 'Lisätty',
            statusPending: 'Odottaa',
            statusAccepted: 'Hyväksytty',
            statusRejected: 'Hylätty',
            versionLabel: 'Versio',
            versionAriaLabel: 'Versio {n}',
            versionAriaLabelCurrent: 'Versio {n} ({current})',
            versionCurrentTag: 'nykyinen',
            versionSourceLabel: 'lähde',
            versionCreatedLabel: 'Luotu',
            versionModelLabel: 'Malli',
            sourceUpload: 'Lataa',
            sourceUserUpload: 'Käyttäjän lataus',
            sourceAssistantEdit: 'Assistant-muokkaus',
            sourceUserAccept: 'Käyttäjä hyväksyi muokkauksen',
            sourceUserReject: 'Käyttäjä hylkäsi muokkauksen',
            sourceGenerated: 'Luotu',
        },
        documentReviewIndex: {
            sidebarLabel: 'Asiakirjojen arviointi',
            pageTitle: 'Asiakirjojen arviointi',
            pageSubtitle: 'Organisaatiosi asiakirjat, joissa on AI:n ehdottamia muokkauksia odottamassa arviointia tai Forseti-pohjaisia versioita.',
            colDocument: 'Asiakirja',
            colLinkedRecord: 'Linkitetty tietue',
            colPendingEdits: 'Odottavat muokkaukset',
            colLastActivity: 'Viimeisin toiminta',
            colOpen: 'Avaa',
            open: 'Avaa',
            empty: 'Ei vielä asiakirjoja Forseti-arvioinnissa. Asiakirjat tulevat tähän jonoon, kun Forseti ehdottaa muokkausta keskustelussa, kun AI-työnkulku tuottaa redlinen, tai kun lähetät asiakirjan arviointiin yllä olevalla painikkeella.',
            loading: 'Ladataan…',
            loadError: 'Arvioinnissa olevien asiakirjojen lataus epäonnistui.',
            retryButton: 'Yritä uudelleen',
            noLinkedRecord: '—',
            pendingZero: 'Ei yhtään',
            sendForReviewButton: 'Lähetä asiakirja arviointiin',
            sendForReviewTitle: 'Lähetä asiakirja arviointiin',
            sendForReviewSubtitle: 'Valitse olemassa oleva liite tästä organisaatiosta, tai lataa uusi tiedosto. Asiakirja lisätään arviointijonoon ja Forseti tekee siihen redline-ajon.',
            sendForReviewTabPick: 'Valitse olemassa oleva',
            sendForReviewTabUpload: 'Lataa uusi',
            sendForReviewPickerLabel: 'Etsi liitteistä',
            sendForReviewPickerPlaceholder: 'Kirjoita hakeaksesi…',
            sendForReviewPickerEmpty: 'Ei vastaavia liitteitä. Yritä toista hakua.',
            sendForReviewSubmit: 'Lähetä arviointiin',
            sendForReviewCancel: 'Peruuta',
            sendForReviewSubmitting: 'Lähetetään…',
            sendForReviewError: 'Asiakirjan lähetys arviointiin epäonnistui. Yritä uudelleen.',
            sendForReviewSuccess: 'Asiakirja lähetetty arviointiin.',
            sendForReviewAcceptedExt: 'Hyväksytyt: {ext}.',
            sendForReviewMaxSize: 'Enimmäiskoko {mb} MB.',
        },
        chats: {
            exportError: 'Vienti epäonnistui.',
        },
    },
    pdplEvidencePacks: {
        title: 'PDPL-todistuspaketit',
        subtitle: 'Asiakkaan hallitsema toimitus MoPS A05 -viranomaiselle',
        nav: { emailProviders: 'Sähköpostipalveluntarjoajat' },
        providers: {
            pageTitle: 'Sähköpostipalveluntarjoajat',
            pageSubtitle: 'Määritä organisaatiosi lähtevän sähköpostin palveluntarjoaja PDPL-todistuspakettien toimittamiseksi MoPS A05 -viranomaiselle.',
            architectureRuleHeading: 'Arkkitehtuurisääntö (lukittu)',
            architectureRuleBody: 'AesirX ei ole todistepakettisähköpostien lähettäjä. Jokainen lähetys käyttää palveluntarjoajaa, joka on sinun omistuksessasi ja hallinnassasi. AesirX ei koskaan lähetä puolestasi.',
            empty: 'Palveluntarjoajia ei ole vielä määritetty.',
            createCta: 'Luo palveluntarjoaja',
            statusPendingConsent: 'Suostumusta odottaa',
            statusPendingConnectionCheck: 'Yhteystestiä odottaa',
            statusActive: 'Aktiivinen',
            statusConnectionCheckFailed: 'Yhteystesti epäonnistui',
            statusDisabled: 'Poistettu käytöstä',
            acceptConsentCta: 'Hyväksy suostumus',
            runConnectionCheckCta: 'Suorita yhteystesti',
            disableCta: 'Poista käytöstä',
            disableConfirm: 'Tämän palveluntarjoajan poistaminen käytöstä pysäyttää suorat lähetykset, kunnes uusi palveluntarjoaja on määritetty ja suostumus vahvistettu uudelleen. Jatketaanko?',
            columnDisplayName: 'Nimi',
            columnFromAddress: 'Lähettäjäosoite',
            columnStatus: 'Tila',
            columnLastCheck: 'Viimeisin testi',
            columnActions: 'Toiminnot',
            createModalTitle: 'Uusi SMTP-palveluntarjoaja',
            createDisplayNameLabel: 'Näyttönimi',
            createFromAddressLabel: 'Lähettäjäosoite',
            createReplyToLabel: 'Vastausosoite (valinnainen)',
            createSmtpHostLabel: 'SMTP-isäntä',
            createSmtpPortLabel: 'SMTP-portti',
            createSmtpUsernameLabel: 'SMTP-käyttäjätunnus',
            createSmtpPasswordLabel: 'SMTP-salasana',
            createSmtpEncryptionLabel: 'Salaus',
            createSmtpEncryptionStarttls: 'STARTTLS',
            createSmtpEncryptionTls: 'TLS (implisiittinen)',
            createSmtpEncryptionNone: 'Ei mitään',
            createOauthM365Tab: 'Microsoft 365',
            createOauthGoogleTab: 'Google Workspace',
            createOauthDisabledBadge: 'Tulossa pian',
            createOauthDisabledHint: 'OAuth-palveluntarjoajia ei ole vielä otettu käyttöön. Käytä toistaiseksi SMTP:tä.',
            createSubmitCta: 'Luo palveluntarjoaja',
            createCancelCta: 'Peruuta',
            createErrorInvalidFromAddress: 'Lähettäjäosoitteen on oltava kelvollinen sähköpostilaatikko.',
            createErrorDuplicateFromAddress: 'Toinen palveluntarjoaja on jo määritetty tälle lähettäjäosoitteelle.',
            createErrorGeneric: 'Palveluntarjoajan luonti epäonnistui. Tarkista lomake ja yritä uudelleen.',
            consentModalTitle: 'Vahvista arkkitehtuurisääntö',
            consentLocaleToggleEn: 'Englanti',
            consentLocaleToggleVi: 'Vietnam',
            consentAcknowledgeCta: 'Vahvistan — hyväksy suostumus',
            consentCancelCta: 'Peruuta',
            consentErrorMismatch: 'Suostumusteksti on muutettu eikä vastaa enää kanonista vastuuvapauslauseketta. Avaa valintaikkuna uudelleen ja lähetä uudelleen.',
            testModalTitle: 'Yhteystesti',
            testRunningCta: 'Testataan yhteyttä…',
            testRunCta: 'Suorita yhteystesti',
            testRetryCta: 'Yritä yhteystestiä uudelleen',
            testSuccessHeading: 'Yhteys onnistui',
            testSuccessBody: 'Todennettu kohteeseen {host}:{port} {latencyMs} ms:ssa. Palveluntarjoaja on valmis suoria lähetyksiä varten.',
            testFailureHeading: 'Yhteys epäonnistui',
            testFailureBody: 'Testiä ei voitu suorittaa loppuun. Tarkista syy alta ja yritä uudelleen korjauksen jälkeen.',
            testFailureReasonLabel: 'Virheen syy',
            testCloseCta: 'Sulje',
            detailDrawerTitle: 'Palveluntarjoajan tiedot',
            detailDrawerHistoryHeading: 'Yhteystestien historia',
            detailDrawerConsentHeading: 'Suostumusvahvistus',
            detailDrawerNoHistory: 'Yhteystestejä ei ole vielä kirjattu.',
            detailDrawerNoConsent: 'Suostumusta ei ole vielä vahvistettu.',
            outcomeSuccess: 'Onnistui',
            outcomeFailure: 'Epäonnistui',
        },
        builder: {
            pageTitle: 'Kokoa todistuspaketti',
            pageSubtitle: 'Lataa 6 osatiedostoa, valitse paketin tyyppi ja kokoa deterministinen 8-osainen ZIP toimitusta varten.',
            packTypeLabel: 'Paketin tyyppi',
            packTypeDpia: 'DPIA (Mẫu số 02a)',
            packTypeOtia: 'OTIA (Mẫu số 02b)',
            part01CoverLetter: 'Osa 01 — Saatekirje (PDF)',
            part02AuthorityForm: 'Osa 02 — Viranomaislomake (PDF)',
            part03Supporting: 'Osa 03 — Tukitodisteet (≥1)',
            part04Safeguards: 'Osa 04 — Suojatoimet',
            part04SafeguardsRequiredOtia: '(pakollinen OTIA:lle)',
            part05PriorCorrespondence: 'Osa 05 — Aiempi kirjeenvaihto (valinnainen)',
            part06Signature: 'Osa 06 — Allekirjoitus- ja leimatodisteet (≥1)',
            uploadPickFile: 'Valitse tiedosto',
            uploadPickFiles: 'Valitse tiedostot',
            uploadRemoveFile: 'Poista',
            requiredMissing: 'Pakollinen osa puuttuu',
            assembleCta: 'Kokoa paketti',
            assembling: 'Kootaan…',
            assembleSuccessHeading: 'Paketti koottu',
            assembleSuccessSummary: '{fileCount} tiedostoa · {bytes} tavua · SHA-256 {shaPrefix}…',
            composeNextCta: 'Laadi sähköpostiluonnos',
            warningsHeading: 'Validointivaroitukset',
            assembleError: 'Pakettia ei voitu koota. Tarkista syötteet ja yritä uudelleen.',
            forsetiAssistHeading: 'Forseti AI-apu (valinnainen)',
            forsetiAssistHint: 'Suorita PDPL Evidence Pack Assembly Advisor tuodaksesi esiin puuttuvat osat, laatiaksesi saatekirjeen tekstin ja merkitäksesi suojausaukkoja. AesirX ei ole lähettäjä — tekoäly vain neuvoo; sinä hyväksyt jokaisen tuotoksen.',
            forsetiAssistCta: 'Avaa Forseti-työnkulkukirjasto',
            forsetiAiRunIdLabel: 'Linkitetty Forseti AI-ajon tunnus (liitä rekisteröidäksesi tekoälyavun)',
        },
        draft: {
            pageTitle: 'Sähköpostiluonnos',
            pageSubtitle: 'Laadi ja muokkaa sähköpostiluonnosta. Suora lähetys tulee myöhemmässä versiossa.',
            composeCta: 'Laadi luonnos',
            composing: 'Laaditaan…',
            noDraftYet: 'Ei vielä luonnosta. Laadi sellainen aloittaaksesi.',
            localeToggleLabel: 'Kieli',
            localeEn: 'Englanti',
            localeVi: 'Vietnam',
            subjectLabel: 'Aihe',
            bodyLabel: 'Sisältö',
            saveCta: 'Tallenna muutokset',
            saving: 'Tallennetaan…',
            saveError: 'Luonnosta ei voitu tallentaa. Yritä uudelleen.',
            manifestSummaryLabel: 'Manifestin yhteenveto',
            coverLetterLabel: 'Saatekirje (PDF)',
            coverLetterDownloadCta: 'Lataa PDF',
            editHistoryHeading: 'Muokkaushistoria',
            editHistoryEmpty: 'Ei vielä muokkauksia.',
            editHistoryEntry: 'v{version} · {fields} · {when} · {who}',
            unofficialChannelHeading: 'NQ22 epävirallinen kanava -ilmoitus',
            uploadSentProofCta: 'Lataa manuaalinen lähetystodiste',
            versionLabel: 'Versio',
            statusDraft: 'Luonnos',
            statusEdited: 'Muokattu',
            statusFinalized: 'Valmis',
        },
        sentProof: {
            modalTitle: 'Lataa manuaalinen lähetystodiste',
            architectureLockNote: 'AesirX ei ole lähettäjä. Tämä todiste tallentaa manuaalisen lähetyksen, jonka teit oman sähköpostiohjelmasi kautta.',
            fileLabel: 'Todistetiedosto (.eml, .png, .jpg)',
            envelopeFromLabel: 'Lähettäjä',
            envelopeToLabel: 'Vastaanottaja',
            envelopeSubjectLabel: 'Aihe (lähetettäessä)',
            envelopeSentAtLabel: 'Lähetetty',
            envelopeAttachmentShaLabel: 'Liite SHA-256 (lähetettäessä)',
            uploadCta: 'Lataa todiste',
            uploading: 'Ladataan…',
            uploadSuccess: 'Lähetystodiste ladattu.',
            uploadErrorInvalidMime: 'Tiedostotyyppi ei sallittu. Käytä .eml, .png, .jpg tai .jpeg.',
            uploadErrorGeneric: 'Todistetta ei voitu ladata. Yritä uudelleen.',
            existingProofsHeading: 'Rekisteröidyt lähetystodisteet',
            existingProofsEmpty: 'Lähetystodisteita ei ole vielä rekisteröity.',
            proofEntry: '{when} · {filename}',
        },
        packDetail: {
            pageTitle: 'Todistuspaketti',
            notFoundMessage: 'Pakettia ei löytynyt – se on saatettu poistaa tai linkki on virheellinen.',
            manifestHeading: 'Manifesti',
            dossierLabel: 'Asia',
            packShaLabel: 'Paketin SHA-256',
            fileCountLabel: 'Tiedostot',
            bytesLabel: 'Koko',
            composeDraftCta: 'Laadi luonnos',
            sendComingSoonCta: 'Suora lähetys: tulossa pian',
            sendComingSoonHint: 'Suoran lähetyksen toiminto on aktiivisessa kehityksessä. Käytä luonnossivulla kohtaa "Lataa manuaalinen lähetystodiste" siihen asti.',
            sendCta: 'Lähetä määritetyn palveluntarjoajan kautta',
            sendDisabledNoProviderHint: 'Määritä ensin asiakkaan hallinnoima sähköpostipalveluntarjoaja. AesirX ei koskaan lähetä puolestasi.',
            timelineHeading: 'Lähetyshistoria',
        },
        // Sprint 58.4.2 (Phase 25 / Sprint E2) — direct-send + timeline + authority response + hard-copy follow-up.
        send: {
            // Send dialog
            dialogTitle: 'Lähetä todistepaketti',
            providerPickerLabel: 'Määritetty sähköpostipalveluntarjoaja',
            providerPickerHint: 'AesirX ei koskaan lähetä puolestasi. Valitse jokin määritetyistä palveluntarjoajistasi alta.',
            providerPickerEmpty: 'Aktiivisia palveluntarjoajia ei ole määritetty. Määritä yksi sähköpostipalveluntarjoajien sivulla ennen lähettämistä.',
            providerPickerEmptyCta: 'Avaa sähköpostipalveluntarjoajat',
            draftPickerLabel: 'Sähköpostiluonnos',
            draftPickerOption: '{locale} · v{version}',
            draftPickerEmpty: 'Tälle paketille ei ole vielä laadittu luonnoksia. Laadi ensin luonnos luonnossivulla.',
            recipientToLabel: 'Vastaanottaja',
            recipientToHint: 'Yksi tai useampi sähköpostiosoite pilkulla erotettuna.',
            recipientCcLabel: 'Kopio (pilkuin eroteltu)',
            recipientCcHint: 'Valinnainen. Pilkulla eroteltu lista sähköpostiosoitteista.',
            recipientBccLabel: 'Piilokopio (pilkuin eroteltu)',
            recipientBccHint: 'Valinnainen. Pilkulla eroteltu lista sähköpostiosoitteista.',
            consentReaffirmHeading: 'Vahvista palveluntarjoajan suostumus uudelleen',
            submitCta: 'Lähetä nyt',
            sending: 'Lähetetään…',
            cancelCta: 'Peruuta',
            sendSuccess: 'Lähetys kirjattu. Paketti on lähetetty määritetyn palveluntarjoajasi kautta.',
            sendErrorGeneric: 'Pakettia ei voitu lähettää. Tarkista alla oleva virhe ja yritä uudelleen.',
            sendErrorAlreadyFinalized: 'Tätä luonnosta on jo käytetty onnistuneeseen lähetykseen. Laadi uusi luonnos ennen kuin lähetät uudelleen.',
            sendErrorInvalidRecipients: 'Yksi tai useampi vastaanottajaosoite ei ole kelvollinen sähköpostilaatikko.',
            // Timeline
            timelineEmpty: 'Lähetyksiä ei ole vielä kirjattu. Käytä yllä olevaa "Lähetä määritetyn palveluntarjoajan kautta" -toimintoa lähettääksesi asiakkaan hallinnoiman SMTP-, Microsoft 365- tai Google Workspace -palveluntarjoajan kautta.',
            timelineProviderLabel: 'Lähetetty määritetyn palveluntarjoajasi kautta',
            timelineSentAtLabel: 'Lähetetty',
            timelineRecipientLabel: 'Vastaanottaja',
            timelineOutcomeSent: 'Lähetetty',
            timelineOutcomeFailed: 'Epäonnistui',
            timelineViewDetailsCta: 'Näytä tiedot',
            // Authority-response chips
            authorityChipNone: 'Odotetaan vastausta',
            authorityChipAcknowledgement: 'Vastaanottoilmoitus',
            authorityChipAcceptance: 'Hyväksyntä',
            authorityChipRejection: 'Hylkäys',
            authorityChipSupplementRequest: 'Täydennyspyyntö',
            authorityChipNoResponse: 'Ei vastausta',
            // Hard-copy chips
            hardCopyChipNone: 'Ei paperista jatkokäsittelyä',
            hardCopyChipPending: 'Postitettu — toimitus kesken',
            hardCopyChipDelivered: 'Toimitettu',
            // Drawer
            drawerTitle: 'Lähetystietue',
            drawerEnvelopeHeading: 'Kirjekuori',
            drawerEnvelopeFromLabel: 'Lähettäjä',
            drawerEnvelopeToLabel: 'Vastaanottaja',
            drawerEnvelopeCcLabel: 'Kopio',
            drawerEnvelopeBccLabel: 'Piilokopio',
            drawerEnvelopeSubjectLabel: 'Aihe',
            drawerEnvelopeMessageIdLabel: 'Viesti-ID',
            drawerOutcomeHeading: 'Tulos',
            drawerSnapshotHeading: 'Säilytysketjun tilannekuva',
            drawerSnapshotPackShaLabel: 'Paketin SHA-256 lähetyshetkellä',
            drawerSnapshotDraftVersionLabel: 'Luonnoksen versio lähetyshetkellä',
            drawerSnapshotAttachmentLabel: 'Lähetetty ZIP',
            drawerSnapshotAttachmentDownloadCta: 'Lataa ZIP',
            drawerAuthorityResponseHeading: 'Viranomaisen vastaus',
            drawerHardCopyHeading: 'Paperinen jatkokäsittely',
            drawerSentByLabel: 'Lähettäjä',
            drawerSendIdLabel: 'Lähetystietueen tunnus',
            drawerSmtpResponseLabel: 'SMTP-vastaus',
            drawerFailureReasonLabel: 'Epäonnistumisen syy',
            drawerLatencyLabel: 'Viive',
            drawerLatencyValue: '{ms} ms',
            drawerAcceptedLabel: 'Hyväksytty',
            drawerRejectedLabel: 'Hylätty',
            drawerCloseCta: 'Sulje',
            // Authority-response panel
            authorityRecordCta: 'Kirjaa vastaus',
            authorityReclassifyCta: 'Luokittele uudelleen',
            authorityClassificationLabel: 'Luokittelu',
            authorityReceivedAtLabel: 'Vastaanotettu',
            authorityFreeTextLabel: 'Huomautukset (valinnainen)',
            authorityEvidenceLabel: 'Todistetiedosto (.eml / .pdf / .png / .jpg — valinnainen)',
            authorityReasonLabel: 'Uudelleenluokittelun syy',
            authorityHistoryHeading: 'Uudelleenluokitteluhistoria',
            authorityHistoryEmpty: 'Uudelleenluokitteluja ei ole kirjattu.',
            authorityHistoryEntry: '{when} · {previous} → {next} · {who}{reason}',
            authoritySubmitCta: 'Tallenna vastaus',
            authoritySubmitting: 'Tallennetaan…',
            authorityErrorInvalidMime: 'Todistetiedoston tyyppi ei ole sallittu. Käytä muotoa .eml, .pdf, .png tai .jpg.',
            authorityErrorGeneric: 'Vastausta ei voitu tallentaa. Yritä uudelleen.',
            authorityRecordedAtLabel: 'Kirjattu',
            authorityRecordedByLabel: 'Kirjaaja',
            authorityEvidenceFilenameLabel: 'Todiste',
            authorityEvidenceDownloadCta: 'Lataa todiste',
            // Hard-copy panel
            hardCopyRecordCta: 'Kirjaa paperinen jatkokäsittely',
            hardCopyConfirmCta: 'Vahvista toimitus',
            hardCopyEditNotesCta: 'Muokkaa toimitushuomautuksia',
            hardCopyPostedAtLabel: 'Postitettu',
            hardCopyCourierLabel: 'Kuriiri',
            hardCopyTrackingLabel: 'Seurantanumero',
            hardCopyRecipientLabel: 'Vastaanottaja etiketissä',
            hardCopyReceiptLabel: 'Kuittitodiste (.pdf / .png / .jpg — valinnainen)',
            hardCopyReceiptDownloadCta: 'Lataa kuitti',
            hardCopyDeliveredAtLabel: 'Toimitettu',
            hardCopyDeliveryNotesLabel: 'Toimitushuomautukset (valinnainen)',
            hardCopySubmitCta: 'Tallenna jatkokäsittely',
            hardCopySubmitting: 'Tallennetaan…',
            hardCopyErrorInvalidMime: 'Kuittitiedoston tyyppi ei ole sallittu. Käytä muotoa .pdf, .png tai .jpg.',
            hardCopyErrorGeneric: 'Jatkokäsittelyä ei voitu tallentaa. Yritä uudelleen.',
        },
    },
};
//# sourceMappingURL=fi.js.map